import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A date in UTC with a format of YYYY-MM-DDThh:mm:ss.000Z. */
  DateTime: { input: string; output: string };
  /**
   * The internationalized email address.<blockquote><strong>Note:</strong> Up to 64
   * characters are allowed before and 255 characters are allowed after the
   * <code>@</code> sign.
   * However, the generally accepted maximum length for an email address is 254 characters.
   * The pattern verifies that an unquoted <code>@</code> sign exists.</blockquote>
   *
   * minLength: 3
   * maxLength: 254
   * pattern: <code>^.+@[^\"\\-].+$</code>.
   */
  Email: { input: string; output: string };
  /** A JSON map of key/value pairs */
  JSON: { input: Record<string, any>; output: Record<string, any> };
  /** An integer that can accept values that are bigger than 2^32 */
  Long: { input: number; output: number };
  /**
   * A single-unit [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601#Durations) duration (e.g. PT20M, P5D,
   * P2M), or the sentinel PAllTime. Used for relative time ranges — both presets and custom relative
   * times. Compound durations (e.g. PT1H30M) are rejected: the relative-time picker produces a single
   * number + unit, and a compound value would not round-trip.
   */
  RelativeTimeDuration: { input: string; output: string };
  /** An [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601#Times) timestamp in UTC. */
  Timestamp: { input: number; output: number };
};

/** Presigned upload URL and the corresponding S3 URL for an AI attachment */
export type AIAttachmentUploadUrl = {
  __typename?: 'AIAttachmentUploadUrl';
  /** The s3:// URI of the uploaded object, to be passed as an attachment reference */
  s3Url: Scalars['String']['output'];
  /** The presigned URL to use for uploading the file via HTTP PUT */
  uploadUrl: Scalars['String']['output'];
};

/** Request AI assistance to author a new detection with iterative testing. */
export type AIAuthorDetectionInput = {
  /** Optional alias of the inference stream, used to retrieve the stream */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** The detection metadata */
  detection?: InputMaybe<AIAuthorDetectionInputDetection>;
  /** Caller context */
  metadata?: InputMaybe<AISummarizeMetadata>;
  /** The requested output length */
  outputLength?: InputMaybe<OutputLength>;
  /** Whether the stream should be private and not visible to other users */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user's detection requirements and specifications */
  prompt: Scalars['String']['input'];
};

export type AIAuthorDetectionInputDetection = {
  analysisType?: InputMaybe<DetectionType>;
  baseDetection?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  createAlert?: InputMaybe<Scalars['Boolean']['input']>;
  dedupPeriodMinutes?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  logTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  outputIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  runbook?: InputMaybe<Scalars['String']['input']>;
  scheduledQueries?: InputMaybe<Array<Scalars['String']['input']>>;
  severity?: InputMaybe<Severity>;
  summaryAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tests?: InputMaybe<Array<DetectionTestDefinitionInput>>;
  threshold?: InputMaybe<Scalars['Int']['input']>;
};

/** Request AI assistance to author or review an organization profile. */
export type AIAuthorOrganizationProfileInput = {
  /** Optional alias of the inference stream, used to retrieve the stream */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** The current organization profile text (may be empty/null) */
  currentProfile?: InputMaybe<Scalars['String']['input']>;
  /** Caller context */
  metadata?: InputMaybe<AISummarizeMetadata>;
  /** The requested output length */
  outputLength?: InputMaybe<OutputLength>;
  /** Whether the stream should be private and not visible to other users */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user's request for profile creation or improvement */
  prompt: Scalars['String']['input'];
};

/** Request AI assistance to author a new AI skill with iterative refinement. */
export type AIAuthorRunbookInput = {
  /** Optional alias of the inference stream, used to retrieve the stream */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** The detection the runbook is being drafted for */
  detection?: InputMaybe<AIAuthorRunbookInputDetection>;
  /** Caller context */
  metadata?: InputMaybe<AISummarizeMetadata>;
  /** The requested output length */
  outputLength?: InputMaybe<OutputLength>;
  /** Whether the stream should be private and not visible to other users */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user's runbook requirements and answers to the co-author's questions */
  prompt: Scalars['String']['input'];
};

export type AIAuthorRunbookInputDetection = {
  /** The detection's analysis type (RULE, POLICY, SCHEDULED_RULE, or CORRELATION_RULE) */
  analysisType?: InputMaybe<AnalysisType>;
  /**
   * The editor form's current detection logic (rule Python or policy SQL), which may include
   * unsaved edits; when present it is authoritative for the detection's logic and the persisted
   * detection is fetched only as best-effort metadata enrichment
   */
  body?: InputMaybe<Scalars['String']['input']>;
  /** The editor form's current description, which may include unsaved edits */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The editor form's current display name, which may include unsaved edits */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** The editor form's current runbook value, which may include unsaved edits */
  existingRunbook?: InputMaybe<Scalars['String']['input']>;
  /** The persisted detection ID; absent when the detection has not been saved yet */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The log types the editor form currently monitors, which may include unsaved edits */
  logTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The editor form's current severity, which may include unsaved edits */
  severity?: InputMaybe<Severity>;
};

export type AIAuthorSkillInput = {
  /** Optional alias of the inference stream, used to retrieve the stream */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Caller context */
  metadata?: InputMaybe<AISummarizeMetadata>;
  /** The requested output length */
  outputLength?: InputMaybe<OutputLength>;
  /** Whether the stream should be private and not visible to other users */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user's skill requirements and specifications */
  prompt: Scalars['String']['input'];
  /** The skill metadata */
  skill?: InputMaybe<AIAuthorSkillInputSkill>;
};

export type AIAuthorSkillInputSkill = {
  dependsOn?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  eagerLoading?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The persisted skill ID. Present when the user opens the Skill Builder on the
   * edit page; absent for a fresh create. Used server-side to discriminate
   * edit-vs-create and surface existing skill context to the author model.
   */
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  requiredTools?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  toolMessage?: InputMaybe<Scalars['String']['input']>;
};

/** An AI conversation containing a series of inference streams */
export type AIConversation = {
  __typename?: 'AIConversation';
  /** The originating context alias (e.g., alertID value) */
  alias?: Maybe<Scalars['String']['output']>;
  /** The raw originating context alias type (e.g., "alert", "detection-author"). Matches the entrypoint identifiers generated from `api/lambda/ai/models/api.go`. */
  aliasType?: Maybe<Scalars['String']['output']>;
  /** Whether the current user can edit or delete this conversation (based on ownership or ManageAIResponses permission) */
  canEdit: Scalars['Boolean']['output'];
  /** When the conversation was created */
  createdAt: Scalars['DateTime']['output'];
  /** Who created the conversation */
  createdBy?: Maybe<Actor>;
  /**
   * The first user prompt in this conversation (immutable, set at creation). Used by
   * the conversation list to render a preview without fanning out to the streams
   * sub-resolver for every row.
   */
  firstUserPrompt?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the conversation */
  id: Scalars['ID']['output'];
  /** Whether the current user is the owner of this conversation */
  isOwner: Scalars['Boolean']['output'];
  /** Whether this conversation was created by a scheduled prompt */
  isScheduled: Scalars['Boolean']['output'];
  /** The kind of conversation (alert, alertList, overview, etc.) */
  kind?: Maybe<AISummarizeKind>;
  /** Whether the conversation is private to the creator */
  private: Scalars['Boolean']['output'];
  /** Whether the conversation is saved (persists forever, no TTL) */
  saved: Scalars['Boolean']['output'];
  /** The ID of the scheduled prompt that created this conversation */
  scheduledPromptId?: Maybe<Scalars['String']['output']>;
  /** The inference streams in this conversation (each stream is one user prompt + AI response) */
  streams: AIInferenceStreamsMetadataList;
  /** User-defined title for the conversation */
  title?: Maybe<Scalars['String']['output']>;
  /** When the conversation was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** An AI conversation containing a series of inference streams */
export type AIConversationStreamsArgs = {
  input?: InputMaybe<AIConversationStreamsInput>;
};

/**
 * Category buckets used by the chat history filter UI. Each value maps to a
 * predicate over the conversation's `aliasType` + `isScheduled` fields:
 * - overview:  aliasType "overview" or unset, not scheduled
 * - alertID:   aliasType "alertID", not scheduled
 * - alertList: aliasType "alertList", not scheduled
 * - scheduled: isScheduled = true (regardless of aliasType)
 * - other:     aliasType not in the known set above, not scheduled
 * A conversation falls into exactly one bucket; multiple categories combine with
 * OR semantics on the filter.
 */
export enum AIConversationCategory {
  AlertId = 'alertID',
  AlertList = 'alertList',
  Other = 'other',
  Overview = 'overview',
  Scheduled = 'scheduled',
}

/** Privacy filter for the AI conversations list. */
export enum AIConversationPrivacy {
  All = 'all',
  Private = 'private',
  Shared = 'shared',
}

/** Input for fetching streams within a conversation */
export type AIConversationStreamsInput = {
  /** Pagination cursor */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Number of streams per page (default 25) */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Only return root-level streams (streams with no parent). Use on the scheduled
   * prompt details page to show the initial prompt response rather than the last reply.
   */
  rootOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for listing AI conversations */
export type AIConversationsInput = {
  /** Filter by originating context aliases (e.g., specific alertIDs) */
  aliases?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Filter to conversations whose category is in the given set. Multiple values
   * combine with OR. Omit (or pass null) to disable category filtering — passing
   * every value is equivalent to omitting.
   */
  categories?: InputMaybe<Array<AIConversationCategory>>;
  /** Pagination cursor */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Restrict the listing to the given conversation IDs. Used by the bookmarks UI
   * to fetch a known set without scanning the full conversation table. When
   * provided, both pagination cursors and pageSize are ignored — all matching IDs
   * are returned in a single response. Capped at 100 IDs per request.
   */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by scheduled status */
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by conversation kinds */
  kinds?: InputMaybe<Array<AISummarizeKind>>;
  /**
   * Restrict results to conversations created by the given user ID. Stacks with
   * the caller's permission-based visibility — a non-admin still cannot see
   * another user's private conversations even when that user is set here. Null
   * or empty string disables the filter.
   */
  ownedBy?: InputMaybe<Scalars['String']['input']>;
  /** Number of conversations per page (default 25) */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Filter by privacy, stacking with your permission-based visibility. all
   * (default) returns every visible conversation; private returns the private
   * conversations you can see — your own, plus (for admins) other users' private
   * conversations, so combine with ownedBy to scope to yourself; shared returns
   * only non-private (shared) conversations.
   */
  privacy?: InputMaybe<AIConversationPrivacy>;
  /**
   * Sort order by last-activity time. recent (default) returns the most recently
   * updated first; oldest reverses it.
   */
  sort?: InputMaybe<AIConversationsSort>;
};

/** Output for listing AI conversations */
export type AIConversationsOutput = {
  __typename?: 'AIConversationsOutput';
  /** The list of conversations */
  edges: Array<AIConversationsOutputEdge>;
  /** Pagination information */
  pageInfo: CursorBasedPaginationPageInfo;
};

/** Edge for AIConversationsOutput */
export type AIConversationsOutputEdge = {
  __typename?: 'AIConversationsOutputEdge';
  /** The conversation */
  node: AIConversation;
};

/** Sort order for the AI conversations list (by last-activity time). */
export enum AIConversationsSort {
  Oldest = 'oldest',
  Recent = 'recent',
}

export type AIGeneratePantherFlowQueryContext = {
  /**
   * The table names (e.g., "panther_logs.public.aws_cloudtrail", "signals.alerts") to include in the query context.
   * The backend will fetch the full schemas for these tables.
   */
  tableNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Request AI assistance to generate a PantherFlow query from natural language. */
export type AIGeneratePantherFlowQueryInput = {
  /** Optional alias of the inference stream, used to retrieve the stream */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Caller context */
  metadata?: InputMaybe<AISummarizeMetadata>;
  /** The requested output length */
  outputLength?: InputMaybe<OutputLength>;
  /** The user's natural language query description */
  prompt: Scalars['String']['input'];
  /** Query context including table and schema information */
  queryContext?: InputMaybe<AIGeneratePantherFlowQueryContext>;
};

export type AIGenerateSqlQueryContext = {
  /** The selected database name (e.g., "panther_logs") */
  databaseName?: InputMaybe<Scalars['String']['input']>;
  /**
   * The selected table name (e.g., "panther_logs.public.aws_cloudtrail").
   * The backend will fetch the full schema for this table.
   */
  tableName?: InputMaybe<Scalars['String']['input']>;
};

/** Request AI assistance to author a SQL query from natural language. */
export type AIGenerateSqlQueryInput = {
  /** Optional alias of the inference stream, used to retrieve the stream */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Caller context */
  metadata?: InputMaybe<AISummarizeMetadata>;
  /** The requested output length */
  outputLength?: InputMaybe<OutputLength>;
  /** The user's natural language query description */
  prompt: Scalars['String']['input'];
  /** Query context including database and table information */
  queryContext?: InputMaybe<AIGenerateSqlQueryContext>;
};

/** Used to poll response stream. */
export type AIInferenceStream = {
  __typename?: 'AIInferenceStream';
  /** The alias of the stream */
  alias?: Maybe<Scalars['String']['output']>;
  /** Whether the current user can edit or delete this stream (based on ownership or ManageAIResponses permission) */
  canEdit: Scalars['Boolean']['output'];
  /** Whether the stream was cancelled by the user. When true, the inference loop stopped on its next chunk write and the stream is finished. */
  cancelled?: Maybe<Scalars['Boolean']['output']>;
  /** When the stream was cancelled (null if not cancelled) */
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who cancelled the stream (null if not cancelled) */
  cancelledBy?: Maybe<Actor>;
  /** When the stream was created */
  createdAt: Scalars['DateTime']['output'];
  /** Who created the stream */
  createdBy?: Maybe<Actor>;
  /** Whether the stream is deleted (soft delete, can be undone and by default is not in listings) */
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** When the stream was deleted */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who deleted the stream */
  deletedBy?: Maybe<Actor>;
  /** This is set on errors with a useful message */
  error?: Maybe<Scalars['String']['output']>;
  /** If true, there is no more data */
  finished: Scalars['Boolean']['output'];
  /** The parent stream id from which this response was derived */
  parentStreamId?: Maybe<Scalars['ID']['output']>;
  /** Whether the stream is pinned (set by the user with editAIInferenceStream) */
  pinned?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the stream is private and not visible to other users (set by the user with editAIInferenceStream) */
  private?: Maybe<Scalars['Boolean']['output']>;
  /**
   * AI analysis response
   * Only set when querying a specific inference stream
   * Will be null when listing inference streams
   */
  responseText?: Maybe<Scalars['String']['output']>;
  /**
   * Risk scoring evidence for this stream (if available)
   * Only set when risk scoring has been performed
   */
  riskScoreEvidence?: Maybe<RiskScoreEvidence>;
  /** Whether the stream is saved (never expires) */
  saved?: Maybe<Scalars['Boolean']['output']>;
  /** The id of the stream where inference responses are written */
  streamId: Scalars['ID']['output'];
  /** The name of the stream (set by the user with editAIInferenceStream) */
  streamName?: Maybe<Scalars['String']['output']>;
  /** Tool invocations for tools that require approval (if any) */
  toolInvocations?: Maybe<Array<AIToolInvocation>>;
  /** When the stream was updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who updated the stream */
  updatedBy?: Maybe<Actor>;
  /** The usage of the stream */
  usage?: Maybe<AIInferenceStreamUsage>;
  /** The user prompt that was used to create the stream */
  userPrompt?: Maybe<Scalars['String']['output']>;
};

/**
 * Metadata for a stream with its immediate children and the path to the root.
 * Used to display "breadcrumbs" for the stream and its children in the UI.
 */
export type AIInferenceStreamMetadataWithPath = {
  __typename?: 'AIInferenceStreamMetadataWithPath';
  /** The immediate children of the stream */
  children: Array<AIInferenceStream>;
  /** The path to the root of from the stream to the root */
  pathToRoot: Array<AIInferenceStream>;
  /** The stream */
  stream: AIInferenceStream;
};

/** Input to search an inference stream */
export type AIInferenceStreamTextSearchInput = {
  /** Optional alias to filter by */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Optional cursor to continue listing from for more results (not set if first page) */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter to conversation streams only. When omitted or false, returns non-conversation streams.
   * When true, returns only conversation streams.
   */
  isConversation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional kind of AI request to filter by */
  kind?: InputMaybe<AISummarizeKind>;
  /** Optional page size (defaults to 20, max 100) */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /** The search query */
  query: Scalars['String']['input'];
  /** Optional flag to filter by current user's responses only */
  searchMine?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of a text search on an inference stream */
export type AIInferenceStreamTextSearchResult = {
  __typename?: 'AIInferenceStreamTextSearchResult';
  /** The alias of the stream */
  alias?: Maybe<Scalars['String']['output']>;
  /** The alias type of the stream */
  aliasType?: Maybe<Scalars['String']['output']>;
  /** The conversation ID, if this result is from a conversation stream */
  conversationId?: Maybe<Scalars['String']['output']>;
  /** The created at timestamp of the stream */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who created the stream */
  createdBy?: Maybe<Actor>;
  /** Whether this result is from a conversation stream */
  isConversation?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the stream is private and not visible to other users */
  private?: Maybe<Scalars['Boolean']['output']>;
  /** The snippet of the matching text with highlights */
  snippetWithHighlights: SnippetWithHighlights;
  /** The id of the stream where inference responses are written */
  streamId: Scalars['ID']['output'];
  /** The title of the stream */
  title?: Maybe<Scalars['String']['output']>;
  /** The user prompt that was used to create the stream */
  userPrompt?: Maybe<Scalars['String']['output']>;
};

/** Edge for AIInferenceStreamTextSearchResultList */
export type AIInferenceStreamTextSearchResultEdge = {
  __typename?: 'AIInferenceStreamTextSearchResultEdge';
  /** The text search result */
  node: AIInferenceStreamTextSearchResult;
};

/** The paginated list of text search results */
export type AIInferenceStreamTextSearchResultList = {
  __typename?: 'AIInferenceStreamTextSearchResultList';
  /** The page of text search results */
  edges: Array<AIInferenceStreamTextSearchResultEdge>;
  /** Pagination information */
  pageInfo: CursorBasedPaginationPageInfo;
  /** Total number of results found */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** The usage stats of an inference stream */
export type AIInferenceStreamUsage = {
  __typename?: 'AIInferenceStreamUsage';
  /** The input tokens written to the prompt cache on this request (cache miss / cache write). */
  cacheCreationInputTokens: Scalars['Int']['output'];
  /** The input tokens served from the prompt cache on this request (cache hit). */
  cacheReadInputTokens: Scalars['Int']['output'];
  /** The duration of the inference in seconds */
  durationSeconds: Scalars['Float']['output'];
  /**
   * The input tokens used by the stream that were neither served from nor written to the prompt cache.
   * Total prompt size is inputTokens + cacheCreationInputTokens + cacheReadInputTokens.
   */
  inputTokens: Scalars['Int']['output'];
  /** The model used to generate the stream */
  modelID: Scalars['String']['output'];
  /** The output tokens generated by the stream */
  outputTokens: Scalars['Int']['output'];
};

/** Input to retrieve inference streams metadata */
export type AIInferenceStreamsMetadataInput = {
  /** Optional alias to filter streams by */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Optional cursor to continue listing from for more results (not set if first page) */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Optional page size (defaults to 100) */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /** Optional parentID to filter streams by, if empty (""), filter for root streams (no parentID) */
  parentID?: InputMaybe<Scalars['String']['input']>;
};

/** The metadata for a list of inference streams */
export type AIInferenceStreamsMetadataList = {
  __typename?: 'AIInferenceStreamsMetadataList';
  /** The page of inference stream metadata */
  edges: Array<AIInferenceStreamsMetadataListEdge>;
  /** Pagination information */
  pageInfo: CursorBasedPaginationPageInfo;
};

/** Edge for AIInferenceStreamsMetadataList */
export type AIInferenceStreamsMetadataListEdge = {
  __typename?: 'AIInferenceStreamsMetadataListEdge';
  /** The inference stream metadata */
  node: AIInferenceStream;
};

/** Request an AI replay for a detection rule. */
export type AIReplayDetectionInput = {
  /** The detection rule to replay */
  detectionId: Scalars['ID']['input'];
  /** End time of the replay */
  endTime: Scalars['DateTime']['input'];
  /** Optional list of log types to replay (subset of detection rule log types) */
  logTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Caller context */
  metadata?: InputMaybe<AISummarizeMetadata>;
  /** The requested output length */
  outputLength?: InputMaybe<OutputLength>;
  /** Additional optional prompt to append for added context */
  prompt?: InputMaybe<Scalars['String']['input']>;
  /** Start time of the replay */
  startTime: Scalars['DateTime']['input'];
};

export type AIResolveAnalysisItemMergeConflictsInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  analysisType: AnalysisType;
  id: Scalars['ID']['input'];
  python?: InputMaybe<Scalars['String']['input']>;
  yaml: Scalars['String']['input'];
};

/** Request an AI schema inference for a log source. */
export type AISchemaInferenceInput = {
  /** Caller context */
  metadata?: InputMaybe<AISummarizeMetadata>;
  /** The requested output length */
  outputLength?: InputMaybe<OutputLength>;
  /** Whether the stream should be private and not visible to other users */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  /** Additional optional prompt to append for added context */
  prompt?: InputMaybe<Scalars['String']['input']>;
  /** The session id for the schema inference */
  sessionId: Scalars['ID']['input'];
  /** The stream type for the schema inference */
  streamType?: InputMaybe<LogStreamType>;
};

/** An AI skill that provides specialized instructions to the AI */
export type AISkill = {
  __typename?: 'AISkill';
  /** When the skill was created */
  createdAt: Scalars['DateTime']['output'];
  /** Who created the skill */
  createdBy?: Maybe<Actor>;
  /** Whether the skill has been soft-deleted */
  deleted: Scalars['Boolean']['output'];
  /** When the skill was deleted (null if not deleted) */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who deleted the skill (null if not deleted) */
  deletedBy?: Maybe<Actor>;
  /** Names of other skills this skill depends on. Dependency prompts are included when this skill is invoked. */
  dependsOn: Array<Scalars['String']['output']>;
  /** Description shown to the AI to help it decide when to use this skill */
  description: Scalars['String']['output'];
  /**
   * Whether the skill is disabled (disabled skills are not loaded for inference).
   * Note: The API uses "disabled" (negative) while storage uses "enabled" (positive).
   * This allows null in UpdateAISkillInput to mean "don't change" rather than "enable".
   */
  disabled: Scalars['Boolean']['output'];
  /** Human-readable display name for the skill (shown in UI) */
  displayName: Scalars['String']['output'];
  /**
   * Whether this skill is eagerly loaded into the AI model's initial tool list.
   * When false (default), the skill is deferred and discovered on demand via
   * tool search. Eager skills are always available to the model but consume
   * context space on every request.
   */
  eagerLoading: Scalars['Boolean']['output'];
  /** Unique identifier for the skill */
  id: Scalars['ID']['output'];
  /** The tool name used to invoke this skill (e.g., panther_ai_detections_writer_skill) */
  name: Scalars['String']['output'];
  /** The tool namespace this skill belongs to (e.g., "panther_ai" for built-in, or an MCP integration namespace) */
  namespace: Scalars['String']['output'];
  /**
   * Whether this skill is managed by Panther (default skills).
   * Panther-managed skills cannot be modified, disabled, or deleted through the API.
   */
  pantherManaged: Scalars['Boolean']['output'];
  /** The instructions/prompt returned when this skill is invoked */
  prompt: Scalars['String']['output'];
  /** Regex patterns for required tool names. The skill will only load if all patterns match at least one registered tool. */
  requiredTools: Array<Scalars['String']['output']>;
  /** Labels for organizing and filtering skills */
  tags: Array<Scalars['String']['output']>;
  /** User-facing message shown when skill is invoked (optional) */
  toolMessage?: Maybe<Scalars['String']['output']>;
  /** When the skill was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Who last updated the skill */
  updatedBy?: Maybe<Actor>;
};

/** Minimal skill metadata returned to the chat editor's /-picker. */
export type AISkillListItem = {
  __typename?: 'AISkillListItem';
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Output from getting a single AI skill */
export type AISkillOutput = {
  __typename?: 'AISkillOutput';
  /** Error information if the operation failed */
  error?: Maybe<Error>;
  /** The skill (null if not found) */
  skill?: Maybe<AISkill>;
};

/** Input for listing AI skills */
export type AISkillsInput = {
  /** Opaque cursor for resuming pagination (omit for first page) */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Include deleted skills in the results (default false) */
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include disabled skills in the results (default false) */
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter skills by name or description containing this string (case-insensitive) */
  nameContains?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter skills by namespace (e.g., "panther_ai" or an MCP integration namespace).
   * Omit to return skills from all namespaces.
   */
  namespace?: InputMaybe<Scalars['String']['input']>;
  /**
   * Maximum number of skills to return (default 50, max 200).
   * Values greater than 200 are silently clamped to 200. Values less than 1 are
   * rejected with an error rather than clamped — a zero or negative pageSize is
   * almost certainly a client bug (for example, a zero-value input struct from a
   * code-generated client) and silent clamping would mask it.
   */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** Output from listing AI skills */
export type AISkillsOutput = {
  __typename?: 'AISkillsOutput';
  /** The list of skills */
  edges: Array<AISkillsOutputEdge>;
  /** Pagination information */
  pageInfo: CursorBasedPaginationPageInfo;
};

/** Edge for AISkillsOutput */
export type AISkillsOutputEdge = {
  __typename?: 'AISkillsOutputEdge';
  /** The skill */
  node: AISkill;
};

/** Output of a stream-to-conversation lookup. */
export type AIStreamConversationLookupOutput = {
  __typename?: 'AIStreamConversationLookupOutput';
  /** The conversation ID the stream was migrated to, if it exists */
  conversationId?: Maybe<Scalars['ID']['output']>;
  /** Whether the provided ID (stream or conversation) exists */
  streamExists: Scalars['Boolean']['output'];
};

/** Request an AI summary for an alert. */
export type AISummarizeAlertInput = {
  /** The alert to summarize */
  alertId: Scalars['ID']['input'];
  /** Optional s3:// URIs of uploaded attachments to include in the prompt */
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Caller context */
  metadata?: InputMaybe<AISummarizeMetadata>;
  /** The requested output length */
  outputLength?: InputMaybe<OutputLength>;
  /** Whether the stream should be private and not visible to other users */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  /** Additional optional prompt to append for added context */
  prompt?: InputMaybe<Scalars['String']['input']>;
};

/** Request an AI summary for a detection. */
export type AISummarizeDetectionInput = {
  /** The detection to summarize */
  detectionId: Scalars['ID']['input'];
  /** Caller context */
  metadata?: InputMaybe<AISummarizeMetadata>;
  /** The requested output length */
  outputLength?: InputMaybe<OutputLength>;
  /** Whether the stream should be private and not visible to other users */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  /** Additional optional prompt to append for added context */
  prompt?: InputMaybe<Scalars['String']['input']>;
};

/** Kinds of AI summaries */
export enum AISummarizeKind {
  /** Analyzing a single alert */
  Alert = 'alert',
  /** Analyzing an alert listing */
  AlertList = 'alertList',
  /** Authoring a new detection with iterative testing */
  DetectionAuthor = 'detectionAuthor',
  /** Analyzing a detection overview */
  DetectionOverview = 'detectionOverview',
  /** Generating a detection tests */
  DetectionTests = 'detectionTests',
  /** Drill down analysis for the provided stream ids */
  DrillDown = 'drillDown',
  /** Analyzing a set of events */
  Events = 'events',
  /** Authoring or reviewing an organization profile */
  OrganizationProfile = 'organizationProfile',
  /** System overview analysis */
  Overview = 'overview',
  /** Generating a PantherFlow query from natural language */
  PantherFlowQuery = 'pantherFlowQuery',
  /** Analyzing a set of query results */
  QueryResults = 'queryResults',
  /** Replaying a detection rule */
  Replay = 'replay',
  /** Co-authoring a structured runbook for a detection */
  RunbookAuthor = 'runbookAuthor',
  /** Analyzing a set of schema inference results */
  SchemaInference = 'schemaInference',
  /** Authoring a new AI skill with iterative refinement */
  SkillAuthor = 'skillAuthor',
  /** Authoring a SQL query from natural language */
  SqlQueryAuthor = 'sqlQueryAuthor',
}

/** Request an AI summary for logs. */
export type AISummarizeLogEventsInput = {
  /** Optional alias of the inference stream, used to retrieve the stream */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Optional s3:// URIs of uploaded attachments to include in the prompt */
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Events to analyze as an array of JSON strings */
  events: Array<Scalars['String']['input']>;
  /** Caller context */
  metadata?: InputMaybe<AISummarizeMetadata>;
  /** The requested output length */
  outputLength?: InputMaybe<OutputLength>;
  /** Whether the stream should be private and not visible to other users */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  /** Additional optional prompt to append for added context */
  prompt?: InputMaybe<Scalars['String']['input']>;
};

/** Describe the context of the caller */
export type AISummarizeMetadata = {
  /** The kind of AI request */
  kind?: InputMaybe<AISummarizeKind>;
  /** The page of the caller */
  page?: InputMaybe<Scalars['String']['input']>;
  /** The parent stream id from which this response was derived */
  parentStreamId?: InputMaybe<Scalars['ID']['input']>;
};

/** Request an AI summary for query results. */
export type AISummarizeQueryResultsInput = {
  /** Optional s3:// URIs of uploaded attachments to include in the prompt */
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Caller context */
  metadata?: InputMaybe<AISummarizeMetadata>;
  /** The requested output length */
  outputLength?: InputMaybe<OutputLength>;
  /** Whether the stream should be private and not visible to other users */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  /** Additional optional prompt to append for added context */
  prompt?: InputMaybe<Scalars['String']['input']>;
  /** The queryId */
  queryId: Scalars['ID']['input'];
};

/** Information about a tool invocation that may require approval */
export type AIToolInvocation = {
  __typename?: 'AIToolInvocation';
  /** When the user approved the tool invocation (null if not approved) */
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the tool invocation (as returned by the AI model) */
  id: Scalars['ID']['output'];
  /** Additional metadata about the tool invocation (JSON payload) */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** The reason for the rejection (optional) */
  rejectReason?: Maybe<Scalars['String']['output']>;
  /** When the user rejected the tool invocation (null if not rejected) */
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the tool invocation timed out waiting for approval (null if no timeout) */
  timedOutAt?: Maybe<Scalars['DateTime']['output']>;
  /** The name of the tool that was invoked */
  toolName: Scalars['String']['output'];
};

/** Get AI usage values */
export type AIUsageOutput = {
  __typename?: 'AIUsageOutput';
  /** Contract limit of Number of AI runs */
  aiRunsQuota: Scalars['Long']['output'];
};

export enum APIAuthType {
  ApiToken = 'APIToken',
  OAuth = 'OAuth',
}

export enum APIPaginationStrategy {
  NextPageLink = 'NextPageLink',
  None = 'None',
  Offset = 'Offset',
}

/** The metadata of an API token that can act upon Panther resources. */
export type APIToken = {
  __typename?: 'APIToken';
  /** The set of CIDR blocks that are allowed to use this API token. If empty, all CIDR blocks are allowed. */
  allowedCIDRBlocks: Array<Scalars['String']['output']>;
  /** Date and time when the API token got created */
  createdAt: Scalars['DateTime']['output'];
  /** The physical User that created this API token */
  createdBy: User;
  /** Date and time when the API token will expire. Will be `null` if the token is non-expiring. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier of this token */
  id: Scalars['ID']['output'];
  /** The last time this token was used to authenticate */
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The name given to this token during its creation */
  name: Scalars['String']['output'];
  /** The set of permissions associated with this token */
  permissions: Array<Permission>;
  /** Date and time when the API token last got rotated, if applicable */
  rotatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date and time when the API token last got rotated, if applicable */
  rotatedBy?: Maybe<Actor>;
  /** Date and time when the API token last got updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The physical User that last updated this API token */
  updatedBy?: Maybe<User>;
  /** The API token value, only populated during create and rotate actions */
  value?: Maybe<Scalars['String']['output']>;
};

/** Scan configuration options */
export type AWSScanConfig = {
  __typename?: 'AWSScanConfig';
  /** The role used to scan the AWS Account */
  auditRole: Scalars['String']['output'];
};

/** Input for updating the AWS Scan Config */
export type AWSScanConfigInput = {
  auditRole: Scalars['String']['input'];
};

export type ActiveSuppressCount = {
  __typename?: 'ActiveSuppressCount';
  active?: Maybe<ComplianceStatusCounts>;
  suppressed?: Maybe<ComplianceStatusCounts>;
};

/** An Actor is an entity that performs a CRUD operation in Panther */
export type Actor = APIToken | User;

export type AddAnalysisPackSourceInput = {
  githubAccessToken?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  kmsKey?: InputMaybe<Scalars['String']['input']>;
  owner: Scalars['String']['input'];
  repository: Scalars['String']['input'];
};

export type AddCloudWatchLogIntegrationInput = {
  awsAccountId: Scalars['String']['input'];
  filterPattern?: InputMaybe<Scalars['String']['input']>;
  logGroup: Scalars['String']['input'];
  logProcessingRole: Scalars['String']['input'];
  logProviderId?: InputMaybe<Scalars['String']['input']>;
  logStreamTypeOptions?: InputMaybe<LogStreamTypeOptionsInput>;
  logTypes: Array<Scalars['String']['input']>;
  managedBucketNotifications: Scalars['Boolean']['input'];
  s3Bucket: Scalars['String']['input'];
};

export type AddEnrichmentIntegrationInput = {
  config: EnrichmentIntegrationConfigInput;
  integrationLabel: Scalars['String']['input'];
};

export type AddGlobalHelperInput = {
  body: Scalars['String']['input'];
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  managed?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type AddLogSourceInput = {
  amazonSecurityLake?: InputMaybe<PutAmazonSecurityLakeLogIntegrationInput>;
  azureEventHub?: InputMaybe<PutAzureEventHubLogIntegrationInput>;
  cloudwatch?: InputMaybe<AddCloudWatchLogIntegrationInput>;
  eventbridge?: InputMaybe<PutEventBridgeIntegrationInput>;
  gcpPubSub?: InputMaybe<PutGcpPubSubLogIntegrationInput>;
  gcs?: InputMaybe<PutGcsLogIntegrationInput>;
  http?: InputMaybe<PutHttpLogIntegrationInput>;
  label: Scalars['String']['input'];
  logForwarder?: InputMaybe<PutLogForwarderLogIntegrationInput>;
  otlp?: InputMaybe<PutOTLPLogIntegrationInput>;
  puller?: InputMaybe<PutLogPullingIntegrationInput>;
  s3?: InputMaybe<AddS3LogIntegrationInput>;
  sqs?: InputMaybe<PutSqsLogIntegrationInput>;
  type: SourceType;
};

export type AddLookupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  logTypeMap: LogTypeMapInput;
  lookupSchema?: InputMaybe<LookupSchemaInput>;
  name: Scalars['String']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  refresh?: InputMaybe<LookupRefreshConfigInput>;
  scheduledQuery?: InputMaybe<LookupScheduledQueryConfigInput>;
};

export type AddOrUpdateDataModelInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  logTypes: Array<Scalars['String']['input']>;
  managed?: InputMaybe<Scalars['Boolean']['input']>;
  mappings: Array<DataModelMappingInput>;
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type AddPolicyInput = {
  body: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  managed?: InputMaybe<Scalars['Boolean']['input']>;
  outputIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  reports: Array<DetectionReportMappingInput>;
  resourceTypes: Array<Scalars['String']['input']>;
  runbook?: InputMaybe<Scalars['String']['input']>;
  severity: Severity;
  suppressions?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tests?: InputMaybe<Array<DetectionTestDefinitionInput>>;
};

export type AddRuleInput = {
  analysisType: DetectionType;
  baseDetection?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  createAlert: Scalars['Boolean']['input'];
  dedupPeriodMinutes: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  dynamicAlertContext?: InputMaybe<Scalars['String']['input']>;
  dynamicAlertTitle?: InputMaybe<Scalars['String']['input']>;
  dynamicGroupBy?: InputMaybe<Scalars['String']['input']>;
  dynamicSeverities?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  filterStatement?: InputMaybe<DetectionFilterStatementInput>;
  id: Scalars['ID']['input'];
  inlineFilters?: InputMaybe<Scalars['String']['input']>;
  isSimpleDetection: Scalars['Boolean']['input'];
  logTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  managed?: InputMaybe<Scalars['Boolean']['input']>;
  outputIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  reports: Array<DetectionReportMappingInput>;
  runbook?: InputMaybe<Scalars['String']['input']>;
  scheduledQueries?: InputMaybe<Array<Scalars['String']['input']>>;
  severity: Severity;
  simpleDetectionBody?: InputMaybe<Scalars['String']['input']>;
  summaryAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tests?: InputMaybe<Array<DetectionTestDefinitionInput>>;
  threshold: Scalars['Int']['input'];
};

export type AddRuleV2Input = {
  body: Scalars['String']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddRuleV2Output = {
  __typename?: 'AddRuleV2Output';
  rule?: Maybe<Rule>;
  testResults?: Maybe<Array<TestResult>>;
};

export type AddS3LogIntegrationInput = {
  awsAccountId: Scalars['String']['input'];
  kmsKey?: InputMaybe<Scalars['String']['input']>;
  logProcessingRole: Scalars['String']['input'];
  logProviderId?: InputMaybe<Scalars['String']['input']>;
  logStreamType?: InputMaybe<LogStreamType>;
  logStreamTypeOptions?: InputMaybe<LogStreamTypeOptionsInput>;
  managedBucketNotifications: Scalars['Boolean']['input'];
  s3Bucket: Scalars['String']['input'];
  s3PrefixLogTypes: Array<S3PrefixLogTypesInput>;
};

export type AddSavedQueryInput = {
  defaultDatabase?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disable?: InputMaybe<Scalars['Boolean']['input']>;
  emailConfig?: InputMaybe<EmailConfigInput>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
  queryCookie?: InputMaybe<Scalars['String']['input']>;
  queryKind?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<ScheduleInput>;
  sqlQuery?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The metadata around an Alert */
export type Alert = {
  __typename?: 'Alert';
  activityHistory?: Maybe<AlertActivityHistoryOutput>;
  /** The User assigned to the Alert.  If null, the alert is "unassigned" */
  assignee?: Maybe<User>;
  contextTags?: Maybe<Array<Scalars['String']['output']>>;
  /** Date and time when the Alert got created */
  createdAt: Scalars['DateTime']['output'];
  /** The metadata around the alert's delivery attempts */
  deliveries: Array<Maybe<AlertDelivery>>;
  deliveryOverflow: Scalars['Boolean']['output'];
  /** The type of this Alert, as extracted from its origin */
  description: Scalars['String']['output'];
  /** Alert events */
  events?: Maybe<AlertEventsOutput>;
  /** Date and time of this alert's first event */
  firstEventOccurredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier of this Alert */
  id: Scalars['ID']['output'];
  /** Date and time that the last event related to this Alert was received */
  lastReceivedEventAt: Scalars['DateTime']['output'];
  /** The Panther entity that generated (triggered) this alert */
  origin: AlertOrigin;
  originID: Scalars['String']['output'];
  quality?: Maybe<Scalars['String']['output']>;
  /** The reference for this Alert, as extracted from its origin */
  reference: Scalars['String']['output'];
  /** Risk scoring evidence for this alert */
  riskScore?: Maybe<RiskScoreEvidence>;
  /** The runbook for this Alert, as extracted from its origin */
  runbook: Scalars['String']['output'];
  /** The severity of this Alert */
  severity: Severity;
  /** The status of this Alert */
  status: AlertStatus;
  /** The title of this Alert */
  title: Scalars['String']['output'];
  /** The type of this Alert */
  type: AlertType;
  /** Date and time when the Alert got last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The Actor that last updated the state of this alert */
  updatedBy?: Maybe<Actor>;
};

/** The metadata around an Alert */
export type AlertActivityHistoryArgs = {
  input?: InputMaybe<AlertActivityHistoryInput>;
};

/** The metadata around an Alert */
export type AlertEventsArgs = {
  input?: InputMaybe<AlertEventsInput>;
};

export type AlertActivityHistoryAssigneeChange = {
  __typename?: 'AlertActivityHistoryAssigneeChange';
  newAssignee?: Maybe<User>;
};

export type AlertActivityHistoryCommentAdded = {
  __typename?: 'AlertActivityHistoryCommentAdded';
  comment: Comment;
};

export type AlertActivityHistoryContextTagsChange = {
  __typename?: 'AlertActivityHistoryContextTagsChange';
  newContextTags?: Maybe<Array<Scalars['String']['output']>>;
};

export type AlertActivityHistoryInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type AlertActivityHistoryOutput = {
  __typename?: 'AlertActivityHistoryOutput';
  edges: Array<AlertActivityHistoryOutputEdge>;
  pageInfo: AlertActivityHistoryOutputPageInfo;
};

export type AlertActivityHistoryOutputEdge = {
  __typename?: 'AlertActivityHistoryOutputEdge';
  node: AlertActivityHistoryRecord;
};

export type AlertActivityHistoryOutputPageInfo = {
  __typename?: 'AlertActivityHistoryOutputPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type AlertActivityHistoryQualityChange = {
  __typename?: 'AlertActivityHistoryQualityChange';
  newQuality?: Maybe<Scalars['String']['output']>;
};

export type AlertActivityHistoryRecord = {
  __typename?: 'AlertActivityHistoryRecord';
  content: AlertActivityHistoryRecordContent;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  triggeredBy: Actor;
  type: AlertActivityHistoryRecordTypes;
};

export type AlertActivityHistoryRecordContent =
  | AlertActivityHistoryAssigneeChange
  | AlertActivityHistoryCommentAdded
  | AlertActivityHistoryContextTagsChange
  | AlertActivityHistoryQualityChange
  | AlertActivityHistorySlackbotBoomerang
  | AlertActivityHistoryStatusChange;

export enum AlertActivityHistoryRecordTypes {
  AssigneeChange = 'ASSIGNEE_CHANGE',
  Comment = 'COMMENT',
  ContextTagsChange = 'CONTEXT_TAGS_CHANGE',
  QualityChange = 'QUALITY_CHANGE',
  SlackbotBoomerang = 'SLACKBOT_BOOMERANG',
  StatusChange = 'STATUS_CHANGE',
}

export type AlertActivityHistorySlackbotBoomerang = {
  __typename?: 'AlertActivityHistorySlackbotBoomerang';
  slackbotBoomerangHistory: SlackbotBoomerangHistory;
};

export type AlertActivityHistoryStatusChange = {
  __typename?: 'AlertActivityHistoryStatusChange';
  newStatus: AlertStatus;
};

export type AlertContextTag = {
  __typename?: 'AlertContextTag';
  category: Scalars['String']['output'];
  managed: Scalars['Boolean']['output'];
  tag: Scalars['String']['output'];
};

export type AlertContextTagEdge = {
  __typename?: 'AlertContextTagEdge';
  node: AlertContextTag;
};

export type AlertDashboardDataInput = {
  alertLimit?: Scalars['Int']['input'];
  fromDate: Scalars['DateTime']['input'];
  toDate: Scalars['DateTime']['input'];
};

export type AlertDashboardDataOutput = {
  __typename?: 'AlertDashboardDataOutput';
  alertsByDetection: Array<AlertsByDetection>;
  alertsBySeverityAndStatus: AlertsBySeverityAndStatus;
  logTypeAlertsBySeverity: Array<LogTypeAlertsBySeverity>;
  myAssignedAlerts: Array<Alert>;
  status: JobStatus;
  unassignedAlertsBySeverity: AlertsBySeverity;
};

/** The metadata around a single Alert delivery attempt */
export type AlertDelivery = {
  __typename?: 'AlertDelivery';
  dispatchedAt: Scalars['DateTime']['output'];
  /** The label of the alert at where it was delivered (channel name/ID, jira ticket, asana issue, etc) */
  label: Scalars['String']['output'];
  message: Scalars['String']['output'];
  outputId: Scalars['ID']['output'];
  statusCode: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  /** The url to where the alert was delivered */
  url: Scalars['String']['output'];
};

export type AlertEvents = {
  __typename?: 'AlertEvents';
  items: Array<AlertEventsEdge>;
  lastEvaluatedKey?: Maybe<Scalars['String']['output']>;
};

export type AlertEventsEdge = {
  __typename?: 'AlertEventsEdge';
  node: Scalars['JSON']['output'];
  nodeAsString: Scalars['String']['output'];
};

/** The payload to the `events` query */
export type AlertEventsInput = {
  /** An opaque string used when paginating across multiple pages of results */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** The size of each page of results. Defaults to 25 */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * The response of the alert events query.
 *
 * NOTE: It is valid for `edges` to be empty while `pageInfo.hasNextPage` is true.
 * This occurs when the S3 event scan hits its deadline before finding matching events
 * but the pagination cursor has advanced past scanned objects. The client should
 * continue paginating with the returned cursor to make forward progress.
 */
export type AlertEventsOutput = {
  __typename?: 'AlertEventsOutput';
  /** A list of paginated alert events edges */
  edges: Array<AlertEventsOutputEdge>;
  /** Metadata around this page of results */
  pageInfo: CursorBasedPaginationPageInfo;
};

/** The edge shape of the AlertEventsOutput type */
export type AlertEventsOutputEdge = {
  __typename?: 'AlertEventsOutputEdge';
  /** An event node */
  node: Scalars['JSON']['output'];
};

/** The type of items that a list of alerts can be filtered by */
export enum AlertListingType {
  /** Alerts that got created as a result of a detection match from Rules, Policies & Scheduled Rules */
  Alert = 'ALERT',
  /** Alerts that got created as a result of a detection error. Includes errors from Rules, Policies & Scheduled Rules */
  DetectionError = 'DETECTION_ERROR',
  /** Alerts that got created as a result of a Panther system error */
  SystemError = 'SYSTEM_ERROR',
}

/** The entities that generated this alert */
export type AlertOrigin =
  | AlertOriginPolicy
  | AlertOriginReplayedRule
  | AlertOriginRule
  | AlertOriginSystemError
  | DeletedDetection
  | Detection
  | SystemError;

export type AlertOriginPolicy = {
  __typename?: 'AlertOriginPolicy';
  dedupString: Scalars['String']['output'];
  policyId?: Maybe<Scalars['ID']['output']>;
  policySourceId: Scalars['String']['output'];
  resourceId?: Maybe<Scalars['String']['output']>;
  resourceTypes: Array<Scalars['String']['output']>;
};

export type AlertOriginReplayedRule = {
  __typename?: 'AlertOriginReplayedRule';
  alertId: Scalars['ID']['output'];
  dedupString: Scalars['String']['output'];
  events?: Maybe<AlertEvents>;
  eventsMatched: Scalars['Int']['output'];
  logTypes?: Maybe<Array<Scalars['String']['output']>>;
  replayId: Scalars['ID']['output'];
  ruleId?: Maybe<Scalars['ID']['output']>;
  scheduledQueries?: Maybe<Array<Scalars['String']['output']>>;
};

export type AlertOriginReplayedRuleEventsArgs = {
  input?: InputMaybe<GetAlertEventsInput>;
};

export type AlertOriginRule = {
  __typename?: 'AlertOriginRule';
  dedupString: Scalars['String']['output'];
  events?: Maybe<AlertEvents>;
  eventsMatched: Scalars['Int']['output'];
  logTypes?: Maybe<Array<Scalars['String']['output']>>;
  ruleId?: Maybe<Scalars['ID']['output']>;
  scheduledQueries?: Maybe<Array<Scalars['String']['output']>>;
};

export type AlertOriginRuleEventsArgs = {
  input?: InputMaybe<GetAlertEventsInput>;
};

export type AlertOriginSystemError = {
  __typename?: 'AlertOriginSystemError';
  alerts: RelatedAlertsOutput;
  events?: Maybe<AlertEvents>;
  relatedComponent: RelatedComponent;
  relatedEntity?: Maybe<SystemErrorRelatedEntity>;
  type: SystemErrorType;
};

export type AlertOriginSystemErrorAlertsArgs = {
  input?: InputMaybe<GetRelatedAlertsInput>;
};

export type AlertOriginSystemErrorEventsArgs = {
  input?: InputMaybe<GetAlertEventsInput>;
};

/** The different status that an Alert can have */
export enum AlertStatus {
  /** The alert has been flagged as a false-positive. This is shown as Invalid in the Panther UI. */
  Closed = 'CLOSED',
  /** The alert is still open & pending triage */
  Open = 'OPEN',
  /** The alert has been resolved along with the issue that caused it */
  Resolved = 'RESOLVED',
  /** The alert has been successfully triaged, but it hasn't yet been closed or resolved */
  Triaged = 'TRIAGED',
}

export type AlertSummaryAttributeForAnalysis = {
  __typename?: 'AlertSummaryAttributeForAnalysis';
  error?: Maybe<Error>;
  logType: Scalars['String']['output'];
  query?: Maybe<AlertSummaryAttributeQueryData>;
  summaryAttribute: Scalars['String']['output'];
};

export type AlertSummaryAttributeQueryData = {
  __typename?: 'AlertSummaryAttributeQueryData';
  id: Scalars['String']['output'];
  sql: Scalars['String']['output'];
};

/** The different type of alerts that Panther Supports */
export enum AlertType {
  CorrelationRule = 'CORRELATION_RULE',
  CorrelationRuleError = 'CORRELATION_RULE_ERROR',
  /** Alert that got created due to a Policy failure */
  Policy = 'POLICY',
  /** Alert that got created due to a Rule match */
  Rule = 'RULE',
  /** Alert that got created due to an error in the python code of the associated Rule */
  RuleError = 'RULE_ERROR',
  /** Alert that got created due to a Scheduled Rule match */
  ScheduledRule = 'SCHEDULED_RULE',
  /** Alert that got created due to an error in the python code of the associated Scheduled Rule */
  ScheduledRuleError = 'SCHEDULED_RULE_ERROR',
  /** Alert that got created by Panther due to an issue with the data ingestion process */
  SystemError = 'SYSTEM_ERROR',
}

export type AlertsByDetection = {
  __typename?: 'AlertsByDetection';
  detectionDisplayName: Scalars['String']['output'];
  detectionID: Scalars['String']['output'];
  detectionSeverity: Scalars['String']['output'];
  detectionType: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type AlertsBySeverity = {
  __typename?: 'AlertsBySeverity';
  critical: AlertsPreview;
  high: AlertsPreview;
  info: AlertsPreview;
  low: AlertsPreview;
  medium: AlertsPreview;
};

export type AlertsBySeverityAndStatus = {
  __typename?: 'AlertsBySeverityAndStatus';
  critical: AlertsByStatus;
  high: AlertsByStatus;
  info: AlertsByStatus;
  low: AlertsByStatus;
  medium: AlertsByStatus;
};

export type AlertsByStatus = {
  __typename?: 'AlertsByStatus';
  invalid: AlertsPreview;
  open: AlertsPreview;
  resolved: AlertsPreview;
  triaged: AlertsPreview;
};

/**
 * The available filters of the `alerts` query. You must either specify a particular `detectionId` or a combination of
 * `createdAtAfter` & `createdAtBefore` for the query to be issued successfully.
 */
export type AlertsInput = {
  /** A list of userIds to filter alert assignees by */
  assigneeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contextTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Returns alerts created after this date */
  createdAtAfter?: InputMaybe<Scalars['DateTime']['input']>;
  /** Returns alerts created before this date */
  createdAtBefore?: InputMaybe<Scalars['DateTime']['input']>;
  /** An opaque string used when paginating across multiple pages of results */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** A detection (rule, scheduled rule or policy) ID that all returned alerts should originate from */
  detectionId?: InputMaybe<Scalars['ID']['input']>;
  /** A maximum number of events that the returned alerts must have */
  eventCountMax?: InputMaybe<Scalars['Int']['input']>;
  /** A minimum number of events that the returned alerts must have */
  eventCountMin?: InputMaybe<Scalars['Int']['input']>;
  /** A list of log source IDs to filter alerts by */
  logSources?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list of log type names (custom or not) to filter alerts by */
  logTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A string/text to look for in the alert's title */
  nameContains?: InputMaybe<Scalars['String']['input']>;
  /** The size of each page of results. Defaults to `25` */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  quality?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list of AWS resource type names to filter alerts by */
  resourceTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list of severities to filter alerts by */
  severities?: InputMaybe<Array<Severity>>;
  /** The field to used for sorting purposes. Currently, `createdAt` is the only option */
  sortBy?: InputMaybe<AlertsSortFieldsEnum>;
  /** The direction to sort alerts by, based on the value of the `sortBy` filter. Defaults to `descending` */
  sortDir?: InputMaybe<SortDirEnum>;
  /** A list of statuses to filter alerts by */
  statuses?: InputMaybe<Array<AlertStatus>>;
  /**
   * Further filter the items returned when `type` is also set.
   *
   * - Valid subtypes when `type: ALERT` is set are `POLICY`, `RULE`, and `SCHEDULED_RULE`.
   * - Valid subtypes when `type: DETECTION_ERROR` is set are `RULE_ERROR` and `SCHEDULED_RULE_ERROR`
   * - There are no subtypes for `type: SYSTEM_ERROR`
   */
  subtypes?: InputMaybe<Array<AlertType>>;
  /** The type of items that are going to be returned from your query. Defaults to detection alerts. */
  type?: InputMaybe<AlertListingType>;
  /**
   * @deprecated
   * Deprecated. This field will be removed soon. Please use the `type` field
   */
  types?: InputMaybe<Array<AlertType>>;
};

/**
 * The response of the `alerts` query
 *
 * NOTE: A page may contain fewer edges than the requested page size — even zero —
 * while `pageInfo.hasNextPage` is true. This occurs when a filtered scan hits its
 * server-side time budget before filling the page. The client should continue
 * paginating with the returned cursor to make forward progress.
 */
export type AlertsOutput = {
  __typename?: 'AlertsOutput';
  /** A list of paginated alert edges */
  edges: Array<AlertsOutputEdge>;
  /** Metadata around this page of results */
  pageInfo: AlertsOutputPageInfo;
};

/** The edge shape of the `AlertsOutput` type */
export type AlertsOutputEdge = {
  __typename?: 'AlertsOutputEdge';
  /** An alert node */
  node: Alert;
};

/** The metadata around a page of results for the `alerts` query */
export type AlertsOutputPageInfo = {
  __typename?: 'AlertsOutputPageInfo';
  /** The cursor that the next page of results should start from or `null` if this is the last page */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** A boolean indicating whether more results exist */
  hasNextPage: Scalars['Boolean']['output'];
  /** A boolean indicating whether this is the first page of results or not */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The cursor that this page of results started from or `null` if this is the first page */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type AlertsPreview = {
  __typename?: 'AlertsPreview';
  totalCount: Scalars['Int']['output'];
};

/** The supported sorting field when listing alerts */
export enum AlertsSortFieldsEnum {
  CreatedAt = 'createdAt',
}

/** Input used to fetch all datalake schema entities */
export type AllDatalakeSchemaEntitiesInput = {
  /** The cursor to start from for paginated queries */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Types of entities to fetch. leave empty to fetch all */
  entities?: InputMaybe<Array<DatalakeSchemaEntityType>>;
  /** The number of results that each page will contain. */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /**
   * A search term to filter the properties returned, if PROPERTY entity type is requested.
   * This uses a substring search on both the property's pull path and its display name, if
   * it has one. If the filter is found in either, the property is included in the response.
   */
  propertyFilter?: InputMaybe<Scalars['String']['input']>;
};

/** Output containing the paginated datalake schema entities */
export type AllDatalakeSchemaEntitiesOutput = {
  __typename?: 'AllDatalakeSchemaEntitiesOutput';
  /** List of all the datalake schema entities for this page */
  entities: Array<Maybe<DatalakeSchemaEntity>>;
  /** Page info for the resulting entities */
  pageInfo: CursorBasedPaginationPageInfo;
};

export type AllDatalakeSchemaPropertiesInput = {
  /** The cursor to start from for paginated queries */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** The number of results that each page will contain. */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /**
   * A search term to filter the properties returned, case insensitive.
   * This uses a substring search on both the property's full path and its display name, if
   * it has one. If the filter is found in either, the property is included in the response.
   */
  propertyFilter?: InputMaybe<Scalars['String']['input']>;
};

export type AllDatalakeSchemaPropertiesOutput = {
  __typename?: 'AllDatalakeSchemaPropertiesOutput';
  /** Page info for the resulting entities */
  pageInfo: CursorBasedPaginationPageInfo;
  properties: Array<DatalakeSchemaProperty>;
};

export type AllGitConfigs = {
  __typename?: 'AllGitConfigs';
  genericGitConfigs?: Maybe<Array<GenericGitConfig>>;
  gitHubAppConfigs?: Maybe<Array<GitHubAppConfig>>;
};

export type AmazonSecurityLakeConfig = {
  __typename?: 'AmazonSecurityLakeConfig';
  externalId: Scalars['String']['output'];
  queueArn: Scalars['String']['output'];
  roleArn: Scalars['String']['output'];
};

export type AmazonSecurityLakeLogIntegration = LogIntegration & {
  __typename?: 'AmazonSecurityLakeLogIntegration';
  alarms: LogIntegrationAlarms;
  amazonSecurityLakeConfig: AmazonSecurityLakeConfig;
  createdAtTime: Scalars['DateTime']['output'];
  createdBy?: Maybe<Actor>;
  filters: SourceFilters;
  health: AmazonSecurityLakeLogIntegrationHealth;
  integrationId: Scalars['ID']['output'];
  integrationLabel: Scalars['String']['output'];
  integrationType: Scalars['String']['output'];
  isEditable: Scalars['Boolean']['output'];
  isHealthy: Scalars['Boolean']['output'];
  isPantherManaged: Scalars['Boolean']['output'];
  lastEventProcessedAtTime?: Maybe<Scalars['DateTime']['output']>;
  lastEventReceivedAtTime?: Maybe<Scalars['DateTime']['output']>;
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  logProviderId?: Maybe<Scalars['String']['output']>;
  logTypes: Array<Scalars['String']['output']>;
};

export type AmazonSecurityLakeLogIntegrationHealth = {
  __typename?: 'AmazonSecurityLakeLogIntegrationHealth';
  amazonSecurityLakeQueueStatus?: Maybe<IntegrationItemHealthStatus>;
  amazonSecurityLakeRoleStatus?: Maybe<IntegrationItemHealthStatus>;
  classificationFailuresStatus?: Maybe<IntegrationItemHealthStatus>;
  logProcessingErrorsStatus?: Maybe<IntegrationItemHealthStatus>;
  systemAlarmStatus?: Maybe<IntegrationItemHealthStatus>;
};

export type AnalysisItemForSave = {
  analysisType: AnalysisType;
  id: Scalars['ID']['input'];
  mergedAtVersion?: InputMaybe<Scalars['Int']['input']>;
  python?: InputMaybe<Scalars['String']['input']>;
  yaml: Scalars['String']['input'];
};

export type AnalysisItemForTest = {
  analysisType: AnalysisType;
  id: Scalars['ID']['input'];
  python?: InputMaybe<Scalars['String']['input']>;
  yaml: Scalars['String']['input'];
};

export type AnalysisItemSaveResult = {
  __typename?: 'AnalysisItemSaveResult';
  analysisType: AnalysisType;
  id: Scalars['ID']['output'];
  itemError?: Maybe<Error>;
  saved: Scalars['Boolean']['output'];
  testResults?: Maybe<Array<TestRecord>>;
};

export type AnalysisItemTestRunResult = {
  __typename?: 'AnalysisItemTestRunResult';
  analysisType: AnalysisType;
  id: Scalars['ID']['output'];
  itemError?: Maybe<Error>;
  testResults: Array<TestRecord>;
};

export type AnalysisPack = {
  __typename?: 'AnalysisPack';
  availableVersions: Array<AnalysisPackVersion>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Actor>;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastModified: Scalars['DateTime']['output'];
  lastModifiedBy?: Maybe<Actor>;
  packDefinition: AnalysisPackDefinition;
  packTypes: AnalysisPackTypes;
  packVersion: AnalysisPackVersion;
  updateAvailable: Scalars['Boolean']['output'];
};

export type AnalysisPackDefinition = {
  __typename?: 'AnalysisPackDefinition';
  IDs?: Maybe<Array<Scalars['ID']['output']>>;
};

export type AnalysisPackSource = {
  __typename?: 'AnalysisPackSource';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Actor>;
  githubAccessToken?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kmsKey?: Maybe<Scalars['String']['output']>;
  lastModified: Scalars['DateTime']['output'];
  lastModifiedBy?: Maybe<Actor>;
  owner: Scalars['String']['output'];
  repository: Scalars['String']['output'];
};

export type AnalysisPackTypes = {
  __typename?: 'AnalysisPackTypes';
  CORRELATION_RULE?: Maybe<Scalars['Int']['output']>;
  DATAMODEL?: Maybe<Scalars['Int']['output']>;
  GLOBAL?: Maybe<Scalars['Int']['output']>;
  POLICY?: Maybe<Scalars['Int']['output']>;
  RULE?: Maybe<Scalars['Int']['output']>;
  SCHEDULED_QUERY?: Maybe<Scalars['Int']['output']>;
  SCHEDULED_RULE?: Maybe<Scalars['Int']['output']>;
};

export type AnalysisPackVersion = {
  __typename?: 'AnalysisPackVersion';
  id: Scalars['Int']['output'];
  semVer: Scalars['String']['output'];
};

export enum AnalysisType {
  CorrelationRule = 'CORRELATION_RULE',
  DataModel = 'DATA_MODEL',
  Enrichment = 'ENRICHMENT',
  GlobalHelper = 'GLOBAL_HELPER',
  Policy = 'POLICY',
  Rule = 'RULE',
  SavedQuery = 'SAVED_QUERY',
  ScheduledQuery = 'SCHEDULED_QUERY',
  ScheduledRule = 'SCHEDULED_RULE',
}

/** The annotations attached to a query */
export type Annotations = {
  __typename?: 'Annotations';
  /** An object containing "key: value" pairs parsed from the pantherflow "visualize" command */
  visualize?: Maybe<Scalars['JSON']['output']>;
};

export type AnomaliConfig = {
  __typename?: 'AnomaliConfig';
  apiToken: Scalars['String']['output'];
  profilePullers: AnomaliProfilePullerConfig;
  query: Scalars['String']['output'];
  subdomain: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type AnomaliConfigInput = {
  apiToken: Scalars['String']['input'];
  profilePullers: AnomaliProfilePullerConfigInput;
  query: Scalars['String']['input'];
  subdomain: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type AnomaliProfilePullerConfig = {
  __typename?: 'AnomaliProfilePullerConfig';
  indicators: ProfilePullerConfig;
};

export type AnomaliProfilePullerConfigInput = {
  indicators: ProfilePullerConfigInput;
};

export type AnthropicConfig = {
  __typename?: 'AnthropicConfig';
  apiKey: Scalars['String']['output'];
  organizationIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type AnthropicConfigInput = {
  apiKey: Scalars['String']['input'];
  organizationIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AppConfig = {
  __typename?: 'AppConfig';
  accountId: Scalars['String']['output'];
  /** @deprecated No longer used. Always returns null; field will be removed in a future release. */
  accountType?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the structured AI Runbooks path is enabled for this deployment
   * (Pulumi-managed feature flag, defaults to off).
   */
  aiEnableRunbooks?: Maybe<Scalars['Boolean']['output']>;
  aiEnableScheduledPrompts?: Maybe<Scalars['Boolean']['output']>;
  alertSummariesEnabled: Scalars['Boolean']['output'];
  awsAccountAlias?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the AWS MCP Server (SigV4) integration is enabled for this deployment.
   * Gates the SigV4 option in the Add MCP Server UI.
   */
  awsMcpEnabled?: Maybe<Scalars['Boolean']['output']>;
  awsOrgId?: Maybe<Scalars['String']['output']>;
  awsPartition: Scalars['String']['output'];
  contractEndDate?: Maybe<Scalars['String']['output']>;
  contractStartDate?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  databaseApi: Scalars['String']['output'];
  datadogRumEnabled: Scalars['Boolean']['output'];
  datadogWebApplicationId?: Maybe<Scalars['String']['output']>;
  datadogWebClientToken?: Maybe<Scalars['String']['output']>;
  datadogWebServiceName?: Maybe<Scalars['String']['output']>;
  enableClassyDetections?: Maybe<Scalars['Boolean']['output']>;
  enableDataExplorerTruncation?: Maybe<Scalars['Boolean']['output']>;
  enableDatalakeRbac?: Maybe<Scalars['Boolean']['output']>;
  enableDetectionFilters?: Maybe<Scalars['Boolean']['output']>;
  enableExperimentalCrowdstrikeParsing?: Maybe<Scalars['Boolean']['output']>;
  enablePantherGitConfiguration?: Maybe<Scalars['Boolean']['output']>;
  enableReplays?: Maybe<Scalars['Boolean']['output']>;
  enableReports?: Maybe<Scalars['Boolean']['output']>;
  maxLookupTableCompressedSizeInMb?: Maybe<Scalars['Int']['output']>;
  pantherCommit: Scalars['String']['output'];
  pantherDataLakeType: Scalars['String']['output'];
  processedDataBucketRetentionDays?: Maybe<Scalars['Int']['output']>;
  publicHTTPIngestDomain?: Maybe<Scalars['String']['output']>;
  pylonAppId?: Maybe<Scalars['String']['output']>;
  remoteMcpEnabled?: Maybe<Scalars['Boolean']['output']>;
  salesPhase?: Maybe<Scalars['String']['output']>;
  snowflakeAdminSecretArn?: Maybe<Scalars['String']['output']>;
  snowflakeClusterArns?: Maybe<Scalars['String']['output']>;
  snowflakeReadonlySecretArn?: Maybe<Scalars['String']['output']>;
  splitClientToken?: Maybe<Scalars['String']['output']>;
};

export type ApproveRemoteMcpAuthorizationInput = {
  /**
   * Value of the flow_id cookie set by /oauth/authorize, forwarded by the frontend
   * via document.cookie. Used by the backend to reject cross-browser state
   * injection (see internal/ai/remotemcp/CLAUDE.md — "Browser binding via
   * FlowID cookie").
   */
  flowId: Scalars['String']['input'];
  permissions: Array<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};

export type ApproveRemoteMcpAuthorizationResult = {
  __typename?: 'ApproveRemoteMcpAuthorizationResult';
  redirectUrl: Scalars['String']['output'];
};

export type AsanaConfig = {
  __typename?: 'AsanaConfig';
  personalAccessToken: Scalars['String']['output'];
  projectGids: Array<Scalars['String']['output']>;
  syncAlertStatus: Scalars['Boolean']['output'];
};

export type AsanaConfigInput = {
  personalAccessToken: Scalars['String']['input'];
  projectGids: Array<Scalars['String']['input']>;
  syncAlertStatus: Scalars['Boolean']['input'];
};

export type AsanaLogSourceConfig = {
  __typename?: 'AsanaLogSourceConfig';
  organizationId: Scalars['String']['output'];
  serviceAccountToken: Scalars['String']['output'];
};

export type AsanaLogSourceConfigInput = {
  organizationId: Scalars['String']['input'];
  serviceAccountToken: Scalars['String']['input'];
};

export type AssociatedLogType = {
  __typename?: 'AssociatedLogType';
  /**
   * The time the log type was auto-mapped to the lookup table.
   * It is used to determine if the log type has been auto-mapped to the lookup table
   */
  autoMappedAt?: Maybe<Scalars['DateTime']['output']>;
  logType: Scalars['String']['output'];
  selectors: Array<Scalars['String']['output']>;
};

export type AssociatedLogTypeInput = {
  autoMappedAt?: InputMaybe<Scalars['DateTime']['input']>;
  logType: Scalars['String']['input'];
  selectors: Array<Scalars['String']['input']>;
};

export type AtlassianConfig = {
  __typename?: 'AtlassianConfig';
  apiKey: Scalars['String']['output'];
  organization: Scalars['String']['output'];
};

export type AtlassianConfigInput = {
  apiKey: Scalars['String']['input'];
  organization: Scalars['String']['input'];
};

export type AutodetectIndicatorFiltersInput = {
  indicators: Array<Scalars['String']['input']>;
};

export type AutodetectIndicatorFiltersOutput = {
  __typename?: 'AutodetectIndicatorFiltersOutput';
  filters: Scalars['String']['output'];
};

export type AvailableLogProvider = {
  __typename?: 'AvailableLogProvider';
  availableParsers: Array<AvailableLogProviderParser>;
  categories: Array<Scalars['String']['output']>;
  details?: Maybe<AvailableLogProviderDetails>;
  displayName: Scalars['String']['output'];
  docUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  popularityIndex: Scalars['Int']['output'];
  searchTerms: Array<Scalars['String']['output']>;
  tagLine: Scalars['String']['output'];
  transports: Array<Scalars['String']['output']>;
};

export type AvailableLogProviderDetails = {
  __typename?: 'AvailableLogProviderDetails';
  appInfo?: Maybe<Scalars['String']['output']>;
  defaultParsers: Array<Scalars['String']['output']>;
  howItWorks?: Maybe<Scalars['String']['output']>;
  transportOptions?: Maybe<TransportOptions>;
  useCases?: Maybe<Scalars['String']['output']>;
};

export type AvailableLogProviderParser = {
  __typename?: 'AvailableLogProviderParser';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  referenceUrl?: Maybe<Scalars['String']['output']>;
};

export type AzureBlobConfig = {
  __typename?: 'AzureBlobConfig';
  clientId: Scalars['String']['output'];
  cloud?: Maybe<AzureCloudType>;
  secret: Scalars['String']['output'];
  storageAccountName: Scalars['String']['output'];
  storageQueueName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type AzureBlobLogIntegrationHealth = {
  __typename?: 'AzureBlobLogIntegrationHealth';
  azureBlobStatus?: Maybe<IntegrationItemHealthStatus>;
  classificationFailuresStatus?: Maybe<IntegrationItemHealthStatus>;
  logProcessingErrorsStatus?: Maybe<IntegrationItemHealthStatus>;
  systemAlarmStatus?: Maybe<IntegrationItemHealthStatus>;
};

export type AzureBlobSourceIntegration = LogIntegration & {
  __typename?: 'AzureBlobSourceIntegration';
  alarms: LogIntegrationAlarms;
  azureBlobConfig: AzureBlobConfig;
  createdAtTime: Scalars['DateTime']['output'];
  createdBy?: Maybe<Actor>;
  filters: SourceFilters;
  health: AzureBlobLogIntegrationHealth;
  integrationId: Scalars['ID']['output'];
  integrationLabel: Scalars['String']['output'];
  integrationType: Scalars['String']['output'];
  isEditable: Scalars['Boolean']['output'];
  isHealthy: Scalars['Boolean']['output'];
  isPantherManaged: Scalars['Boolean']['output'];
  lastEventProcessedAtTime?: Maybe<Scalars['DateTime']['output']>;
  lastEventReceivedAtTime?: Maybe<Scalars['DateTime']['output']>;
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  logProviderId?: Maybe<Scalars['String']['output']>;
  logStreamType?: Maybe<LogStreamType>;
  logStreamTypeOptions?: Maybe<LogStreamTypeOptions>;
  logTypes: Array<Scalars['String']['output']>;
};

export enum AzureCloudType {
  Azure = 'Azure',
  AzureGov = 'AzureGov',
}

export type AzureEventHubConfig = {
  __typename?: 'AzureEventHubConfig';
  connectionString: Scalars['String']['output'];
  consumerGroup?: Maybe<Scalars['String']['output']>;
};

export type AzureEventHubLogIntegrationHealth = {
  __typename?: 'AzureEventHubLogIntegrationHealth';
  azureEventHubStatus?: Maybe<IntegrationItemHealthStatus>;
  classificationFailuresStatus?: Maybe<IntegrationItemHealthStatus>;
  logProcessingErrorsStatus?: Maybe<IntegrationItemHealthStatus>;
  systemAlarmStatus?: Maybe<IntegrationItemHealthStatus>;
};

export type AzureEventHubOptions = {
  __typename?: 'AzureEventHubOptions';
  logStreamType?: Maybe<LogStreamType>;
  logStreamTypeOptions?: Maybe<LogStreamTypeOptions>;
};

export type AzureEventHubSourceIntegration = LogIntegration & {
  __typename?: 'AzureEventHubSourceIntegration';
  alarms: LogIntegrationAlarms;
  azureEventHubConfig: AzureEventHubConfig;
  createdAtTime: Scalars['DateTime']['output'];
  createdBy?: Maybe<Actor>;
  filters: SourceFilters;
  health: AzureEventHubLogIntegrationHealth;
  integrationId: Scalars['ID']['output'];
  integrationLabel: Scalars['String']['output'];
  integrationType: Scalars['String']['output'];
  isEditable: Scalars['Boolean']['output'];
  isHealthy: Scalars['Boolean']['output'];
  isPantherManaged: Scalars['Boolean']['output'];
  lastEventProcessedAtTime?: Maybe<Scalars['DateTime']['output']>;
  lastEventReceivedAtTime?: Maybe<Scalars['DateTime']['output']>;
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  logProviderId?: Maybe<Scalars['String']['output']>;
  logStreamType?: Maybe<LogStreamType>;
  logStreamTypeOptions?: Maybe<LogStreamTypeOptions>;
  logTypes: Array<Scalars['String']['output']>;
};

export type BatchInferJobsInput = {
  batchId: Scalars['String']['input'];
  inferParameters: Array<InferSchemaFromSourceBucketInput>;
  sourceId: Scalars['String']['input'];
  streamType: LogStreamType;
};

export type BatchInferJobsOutput = {
  __typename?: 'BatchInferJobsOutput';
  tasks: Array<Job>;
};

export type BitwardenConfig = {
  __typename?: 'BitwardenConfig';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  server: Scalars['String']['output'];
};

export type BitwardenConfigInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  server: Scalars['String']['input'];
};

export type BlinkOpsWebhookConfig = {
  __typename?: 'BlinkOpsWebhookConfig';
  apiKey: Scalars['String']['output'];
  webhookURL: Scalars['String']['output'];
};

export type BlinkOpsWebhookConfigInput = {
  apiKey: Scalars['String']['input'];
  webhookURL: Scalars['String']['input'];
};

export type BulkDownloadInput = {
  dataModelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  detectionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  globalHelperIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  savedQueryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type BulkDownloadResponse = {
  __typename?: 'BulkDownloadResponse';
  data: Scalars['String']['output'];
};

/**
 * Input for bulkDownloadScheduledPromptsUrl. When scheduledPromptIds is null or empty
 * ("download all"), only shared prompts are included by default — bulk upload is
 * shared-only, so private prompts can't be re-imported. Set includePrivate to also
 * include private prompts the actor is allowed to view (an admin with
 * ViewAIPrivateResponses gets others' private prompts). includePrivate is ignored when
 * scheduledPromptIds is set — an explicit by-id request can always download a private
 * prompt as backup. (The query docstring above covers the .yml-vs-.zip output shape.)
 */
export type BulkDownloadScheduledPromptsInput = {
  includePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledPromptIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Input for bulkDownloadSkillsUrl. When skillIds is null or empty, all visible
 * (non-panther-managed, non-deleted) skills are included.
 *
 * Unlike `bulkDownloadUrl`, this input does NOT expose a `fileName` field.
 * Downloads use fixed defaults: a single skill becomes `<skill-name>.yml`; multi-
 * skill or "download all" requests become `panther-ai-skills.zip`. If a custom
 * filename surface is needed in the future, add `fileName: String` here and
 * propagate to `BulkDownloadInput.FileName` in the resolver.
 */
export type BulkDownloadSkillsInput = {
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type BulkDownloadUrlResponse = {
  __typename?: 'BulkDownloadUrlResponse';
  expiresAt: Scalars['DateTime']['output'];
  presignedURL: Scalars['String']['output'];
};

export type BulkUpdateDetectionsInput = {
  detections: Array<DetectionPatch>;
};

export type BulkUpdateDetectionsResponse = {
  __typename?: 'BulkUpdateDetectionsResponse';
  detections: Array<InternalDetection>;
  errors: Array<Maybe<DetectionUpdateError>>;
};

/** The payload of the `bulkUploadDetections` mutation */
export type BulkUploadDetectionsInput = {
  /** Determines if this is a preview of the bulk upload */
  dryRun: Scalars['Boolean']['input'];
  /** The session ID for the bulk upload */
  sessionId: Scalars['String']['input'];
};

/** The issue associated to a bulk upload */
export type BulkUploadIssue = {
  __typename?: 'BulkUploadIssue';
  /** The error associated to this particular issue */
  errorMessage: Scalars['String']['output'];
  /** The path within the upload that this issue is associated to */
  path: Scalars['String']['output'];
};

/** The status of a bulk upload job */
export type BulkUploadJob = Job & {
  __typename?: 'BulkUploadJob';
  /** The unique identifier of the job */
  id: Scalars['ID']['output'];
  /** The message associated with the job */
  message?: Maybe<Scalars['String']['output']>;
  /** The results of the bulk upload job, only available when the job is succeeded */
  results?: Maybe<BulkUploadJobResults>;
  /** The current status of the job */
  status: JobStatus;
};

/** The results of a bulk upload job */
export type BulkUploadJobResults = {
  __typename?: 'BulkUploadJobResults';
  /** The total deleted rule IDs */
  deletedRuleIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** The total modified rule IDs */
  modifiedRuleIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** The total new rule IDs */
  newRuleIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** The total rule IDs */
  totalRuleIds?: Maybe<Array<Scalars['ID']['output']>>;
};

/** The output of the `bulkUploadPresignedUrl` query */
export type BulkUploadPresignedUrlOutput = {
  __typename?: 'BulkUploadPresignedUrlOutput';
  /** The pre-signed URL for the bulk upload */
  detectionsURL: Scalars['String']['output'];
  /** The session ID for the bulk upload */
  sessionId: Scalars['String']['output'];
};

/**
 * The result of a validateBulkUpload mutation that outlines
 * any relevant issues associated with the upload
 */
export type BulkValidateResult = {
  __typename?: 'BulkValidateResult';
  /** The list of issues associated to the bulk upload */
  issues?: Maybe<Array<BulkUploadIssue>>;
};

/** Input to cancel an inference stream */
export type CancelAIInferenceStreamInput = {
  /** The id of the stream to cancel */
  streamId: Scalars['ID']['input'];
};

export type CancelDashboardOutput = {
  __typename?: 'CancelDashboardOutput';
  queryIds: Array<Scalars['String']['output']>;
};

/** The input to a data lake query cancellation operation */
export type CancelDataLakeQueryInput = {
  /** The ID of the query to cancel */
  id: Scalars['ID']['input'];
};

/** The return value of a data lake or indicator search query cancellation request */
export type CancelDataLakeQueryOutput = {
  __typename?: 'CancelDataLakeQueryOutput';
  /** The ID of the query that just got cancelled */
  id: Scalars['ID']['output'];
};

export type CatalogDataModel = {
  __typename?: 'CatalogDataModel';
  configFilePath?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  installed: Scalars['Boolean']['output'];
  logType: Scalars['String']['output'];
};

export type CatalogDetection = {
  __typename?: 'CatalogDetection';
  analysisType: AnalysisType;
  configFilePath?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  installed: Scalars['Boolean']['output'];
  logTypes?: Maybe<Array<Scalars['String']['output']>>;
  resourceTypes?: Maybe<Array<Scalars['String']['output']>>;
  scheduledQueries?: Maybe<Array<Scalars['String']['output']>>;
  severity: Severity;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type CatalogEnrichment = {
  __typename?: 'CatalogEnrichment';
  associatedLogTypes?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  installed: Scalars['Boolean']['output'];
  installedId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  schema?: Maybe<Scalars['String']['output']>;
};

export type CatalogGlobalHelper = {
  __typename?: 'CatalogGlobalHelper';
  configFilePath?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  installed: Scalars['Boolean']['output'];
};

export type CatalogItemRef = {
  __typename?: 'CatalogItemRef';
  analysisType: AnalysisType;
  id: Scalars['ID']['output'];
};

export type CatalogQuery = {
  __typename?: 'CatalogQuery';
  configFilePath?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  installed: Scalars['Boolean']['output'];
  installedQueryId: Scalars['String']['output'];
  queryName: Scalars['String']['output'];
  scheduled: Scalars['Boolean']['output'];
};

/** Represents a Cloud Account integration */
export type CloudAccount = {
  __typename?: 'CloudAccount';
  /** The AWS Account ID of the Cloud Account */
  awsAccountId: Scalars['String']['output'];
  /** Regions to be ignored by scans of this cloud account */
  awsRegionIgnoreList: Array<Scalars['String']['output']>;
  /** Account scan configuration options */
  awsScanConfig?: Maybe<AWSScanConfig>;
  /** The name of the cloudformation stack monitoring the account */
  awsStackName: Scalars['String']['output'];
  /** The time the Cloud Account integration was created */
  createdAt: Scalars['DateTime']['output'];
  /** The user who created the Cloud Account integration */
  createdBy?: Maybe<Actor>;
  /** The health status of this Cloud Account */
  health: ComplianceIntegrationHealth;
  /** The ID of the Cloud Account integration */
  id: Scalars['ID']['output'];
  /** True if the Cloud Account integration can be modified */
  isEditable: Scalars['Boolean']['output'];
  /** True if the Cloud Account is managed by Panther */
  isPantherManaged: Scalars['Boolean']['output'];
  /** True if realtime scanning is enabled for this Cloud Account */
  isRealtimeScanningEnabled: Scalars['Boolean']['output'];
  /** The name of the Cloud Account integration */
  label: Scalars['String']['output'];
  /** The time the Cloud Account integration was last modified */
  lastModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Resources that match this regex will be ignored by scans of this cloud account */
  resourceRegexIgnoreList: Array<Scalars['String']['output']>;
  /** Resource types to be ignored by scans of this cloud account */
  resourceTypeIgnoreList: Array<Scalars['String']['output']>;
};

/** Input for the cloudAccounts query */
export type CloudAccountsInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
};

/** Output for the cloudAccounts query */
export type CloudAccountsOutput = {
  __typename?: 'CloudAccountsOutput';
  /** A list of paginated cloud account edges */
  edges: Array<CloudAccountsOutputEdge>;
  /** Metadata around this page of results */
  pageInfo: CursorBasedPaginationPageInfo;
};

/** The edge shape of the `CloudAccount` type */
export type CloudAccountsOutputEdge = {
  __typename?: 'CloudAccountsOutputEdge';
  /** A Cloud Account Node */
  node: CloudAccount;
};

export type CloudWatchLogIntegration = LogIntegration & {
  __typename?: 'CloudWatchLogIntegration';
  alarms: LogIntegrationAlarms;
  awsAccountId: Scalars['String']['output'];
  createdAtTime: Scalars['DateTime']['output'];
  createdBy?: Maybe<Actor>;
  filterPattern: Scalars['String']['output'];
  filters: SourceFilters;
  health: CloudWatchLogIntegrationHealth;
  integrationId: Scalars['ID']['output'];
  integrationLabel: Scalars['String']['output'];
  integrationType: Scalars['String']['output'];
  isEditable: Scalars['Boolean']['output'];
  isHealthy: Scalars['Boolean']['output'];
  isPantherManaged: Scalars['Boolean']['output'];
  lastEventProcessedAtTime?: Maybe<Scalars['DateTime']['output']>;
  lastEventReceivedAtTime?: Maybe<Scalars['DateTime']['output']>;
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  logGroup: Scalars['String']['output'];
  logProcessingRole?: Maybe<Scalars['String']['output']>;
  logProviderId?: Maybe<Scalars['String']['output']>;
  logStreamTypeOptions?: Maybe<LogStreamTypeOptions>;
  logTypes: Array<Scalars['String']['output']>;
  managedBucketNotifications: Scalars['Boolean']['output'];
  notificationsConfigurationSucceeded: Scalars['Boolean']['output'];
  s3Bucket: Scalars['String']['output'];
  stackName: Scalars['String']['output'];
};

export type CloudWatchLogIntegrationHealth = {
  __typename?: 'CloudWatchLogIntegrationHealth';
  bucketNotificationsStatus?: Maybe<IntegrationItemHealthStatus>;
  classificationFailuresStatus?: Maybe<IntegrationItemHealthStatus>;
  logProcessingErrorsStatus?: Maybe<IntegrationItemHealthStatus>;
  processingRoleStatus: IntegrationItemHealthStatus;
  s3BucketStatus?: Maybe<IntegrationItemHealthStatus>;
  systemAlarmStatus?: Maybe<IntegrationItemHealthStatus>;
};

/** Column types return in data lake query results for visualization */
export enum ColumnType {
  /** returned when the column contains data of multiple types */
  Any = 'any',
  Array = 'array',
  Boolean = 'boolean',
  Number = 'number',
  Object = 'object',
  String = 'string',
  Timestamp = 'timestamp',
}

/** A comment posted within a Panther alert */
export type Comment = {
  __typename?: 'Comment';
  /** Body of comment */
  body: Scalars['String']['output'];
  /** Date and time when the Alert got last updated */
  createdAt: Scalars['DateTime']['output'];
  /** The Actor that last updated the state of this alert */
  createdBy: Actor;
  /** The entity that this comment was added to */
  entity: CommentEntity;
  /** The format of the comment's body, as it was originally submitted */
  format: CommentFormat;
  /** Comment identifier */
  id: Scalars['ID']['output'];
};

/** The available entities that can host a comment */
export type CommentEntity = Alert;

/** The format that a Comment's body can be submitted as */
export enum CommentFormat {
  /** A string that should be interpreted as HTML */
  Html = 'HTML',
  /**
   * A document format that allows you to add rich text to your comment as per the ADF
   * https://developer.atlassian.com/cloud/jira/platform/apis/document/structure/
   */
  JsonSchema = 'JSON_SCHEMA',
  /** A string that should be interpreted as plain text */
  PlainText = 'PLAIN_TEXT',
}

export type CompleteMcpAuthorizationInput = {
  code: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type ComplianceIntegrationHealth = {
  __typename?: 'ComplianceIntegrationHealth';
  auditRoleStatus: IntegrationItemHealthStatus;
  realtimeStatus: IntegrationItemHealthStatus;
};

export type ComplianceItem = {
  __typename?: 'ComplianceItem';
  errorMessage?: Maybe<Scalars['String']['output']>;
  integration?: Maybe<CloudAccount>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  policyId?: Maybe<Scalars['ID']['output']>;
  policySeverity?: Maybe<Severity>;
  resourceId?: Maybe<Scalars['ID']['output']>;
  resourceType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ComplianceStatusEnum>;
  suppressed?: Maybe<Scalars['Boolean']['output']>;
};

export type ComplianceStatusCounts = {
  __typename?: 'ComplianceStatusCounts';
  error?: Maybe<Scalars['Int']['output']>;
  fail?: Maybe<Scalars['Int']['output']>;
  pass?: Maybe<Scalars['Int']['output']>;
};

export enum ComplianceStatusEnum {
  Error = 'ERROR',
  Fail = 'FAIL',
  Pass = 'PASS',
}

/** Input for continuing an existing AI conversation */
export type ContinueAIConversationInput = {
  /** Optional s3:// URIs of uploaded attachments to include in the prompt */
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The ID of the conversation to continue */
  conversationId: Scalars['ID']['input'];
  /**
   * Requests the one-directional investigation->response runbook phase transition on this turn.
   * When true and the conversation is in the investigation phase with a structured runbook pinned,
   * the pinned phase flips to response before this turn runs and this turn becomes the response
   * phase's entry turn (carrying the execution mandate). No-op if already in response; user error if
   * the conversation has no structured runbook.
   */
  enterResponsePhase?: InputMaybe<Scalars['Boolean']['input']>;
  /** Requested output length for the AI response */
  outputLength?: InputMaybe<OutputLength>;
  /** The user's message */
  userPrompt: Scalars['String']['input'];
};

/** Output from continuing an AI conversation */
export type ContinueAIConversationOutput = {
  __typename?: 'ContinueAIConversationOutput';
  /** The stream ID for polling the inference result */
  streamId: Scalars['ID']['output'];
};

export type CorrelationRule = {
  __typename?: 'CorrelationRule';
  analysisType: DetectionType;
  body: Scalars['String']['output'];
  correlationRuleReferenceIds: Array<Scalars['ID']['output']>;
  createAlert: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Actor>;
  createdByExternal?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isSimpleDetection: Scalars['Boolean']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  lastModifiedBy?: Maybe<Actor>;
  logTypes?: Maybe<Array<Scalars['String']['output']>>;
  managed?: Maybe<Scalars['Boolean']['output']>;
  outputIds: Array<Scalars['ID']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  reports: Array<DetectionReportMapping>;
  runbook?: Maybe<Scalars['String']['output']>;
  severity: Severity;
  simpleDetectionBody?: Maybe<Scalars['String']['output']>;
  summaryAttributes: Array<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  tests: Array<DetectionTestDefinition>;
  userOverrides?: Maybe<Array<Scalars['String']['output']>>;
  versionId?: Maybe<Scalars['ID']['output']>;
};

export type CorrelationRuleTestCaseRuleOutputDefinition = {
  __typename?: 'CorrelationRuleTestCaseRuleOutputDefinition';
  id: Scalars['String']['output'];
  matches?: Maybe<Scalars['JSON']['output']>;
};

export type CorrelationRuleTestCaseRuleOutputDefinitionInput = {
  id: Scalars['String']['input'];
  matches?: InputMaybe<Scalars['JSON']['input']>;
};

/** Input for creating a new AI conversation */
export type CreateAIConversationInput = {
  /** Optional alias for the originating context (e.g., alertID, queryID) */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Optional s3:// URIs of uploaded attachments to include in the prompt */
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Events to analyze as an array of JSON strings (e.g., alert objects for multi-alert triage) */
  events?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The kind of conversation (defaults to overview) */
  kind?: InputMaybe<AISummarizeKind>;
  /** Requested output length for the AI response */
  outputLength?: InputMaybe<OutputLength>;
  /** Whether the conversation should be private (default false) */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional first message to send (if omitted, creates empty conversation) */
  userPrompt?: InputMaybe<Scalars['String']['input']>;
};

/** Output from creating a new AI conversation */
export type CreateAIConversationOutput = {
  __typename?: 'CreateAIConversationOutput';
  /** The newly created conversation */
  conversation: AIConversation;
  /** The stream ID for polling the first message's inference (if userPrompt was provided) */
  streamId?: Maybe<Scalars['ID']['output']>;
};

/** Input for creating a new AI skill */
export type CreateAISkillInput = {
  /** Names of other skills this skill depends on (optional). Dependency prompts are included when this skill is invoked. */
  dependsOn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Description shown to the AI to help it decide when to use this skill */
  description: Scalars['String']['input'];
  /** Human-readable display name for the skill (shown in UI). Defaults to name if not provided. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Load this skill into the model's initial tool list (optional, default false).
   * When false, the skill is deferred and must typically be named in a prompt
   * for the AI to discover it.
   */
  eagerLoading?: InputMaybe<Scalars['Boolean']['input']>;
  /** The tool name for this skill (must be unique, must include namespace prefix, e.g., panther_ai_my_custom_skill) */
  name: Scalars['String']['input'];
  /**
   * The tool namespace for this skill. Defaults to "panther_ai".
   * Use an MCP integration namespace to create skills scoped to that integration.
   */
  namespace?: InputMaybe<Scalars['String']['input']>;
  /** The instructions/prompt returned when this skill is invoked */
  prompt: Scalars['String']['input'];
  /** Regex patterns for required tool names (optional). The skill will only load if all patterns match at least one registered tool. */
  requiredTools?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Labels for organizing and filtering skills (optional) */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** User-facing message shown when skill is invoked (optional) */
  toolMessage?: InputMaybe<Scalars['String']['input']>;
};

/** Output from creating an AI skill */
export type CreateAISkillOutput = {
  __typename?: 'CreateAISkillOutput';
  /** Error information if the operation failed */
  error?: Maybe<Error>;
  /** The created skill */
  skill?: Maybe<AISkill>;
};

export type CreateAPITokenInput = {
  allowedCIDRBlocks?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  permissions: Array<Permission>;
};

export type CreateAPITokenOutput = {
  __typename?: 'CreateAPITokenOutput';
  error?: Maybe<Error>;
  token?: Maybe<APIToken>;
};

/** The payload to the createComment mutation. */
export type CreateAlertCommentInput = {
  /** The alert ID you want to post a comment to */
  alertId: Scalars['ID']['input'];
  /** The comment body */
  body: Scalars['String']['input'];
  /** The format that the comment's body is going to be in. Defaults to plain text. */
  format?: InputMaybe<CommentFormat>;
};

/** The response to the mutation createComment. */
export type CreateAlertCommentOutput = {
  __typename?: 'CreateAlertCommentOutput';
  comment: Comment;
};

export type CreateAzureBlobSourceInput = {
  clientId: Scalars['String']['input'];
  cloud: AzureCloudType;
  label: Scalars['String']['input'];
  logStreamType?: InputMaybe<LogStreamType>;
  logStreamTypeOptions?: InputMaybe<LogStreamTypeOptionsInput>;
  logTypes: Array<Scalars['String']['input']>;
  secret: Scalars['String']['input'];
  storageAccountName: Scalars['String']['input'];
  storageQueueName: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type CreateAzureBlobSourceOutput = {
  __typename?: 'CreateAzureBlobSourceOutput';
  azureBlobSource: AzureBlobSourceIntegration;
};

/** Input for the createCloudAccount mutation */
export type CreateCloudAccountInput = {
  /** The AWS Account ID of the Cloud Account */
  awsAccountId: Scalars['String']['input'];
  /** Regions to be ignored by scans of this cloud account */
  awsRegionIgnoreList?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Account scan configuration options */
  awsScanConfig: AWSScanConfigInput;
  /** Label applied to the Cloud Account integration */
  label: Scalars['String']['input'];
  /** Resources that match this regex will be ignored by scans of this cloud account */
  resourceRegexIgnoreList?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Resource types to be ignored by scans of this cloud account */
  resourceTypeIgnoreList?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Output for the createCloudAccount mutation */
export type CreateCloudAccountOutput = {
  __typename?: 'CreateCloudAccountOutput';
  /** The cloud account that was created */
  cloudAccount: CloudAccount;
};

export type CreateDashboardInput = {
  icon: DashboardIconInput;
  inputs?: InputMaybe<Array<InputMaybe<DashboardInputInput>>>;
  name: Scalars['String']['input'];
  widgets?: InputMaybe<Array<InputMaybe<CreateWidgetInput>>>;
};

export type CreateDetectionFilterInput = {
  detectionId: Scalars['String']['input'];
  statement: DetectionFilterStatementInput;
};

export type CreateDetectionFilterOutput = {
  __typename?: 'CreateDetectionFilterOutput';
  detectionFilter: DetectionFilter;
};

export type CreateGitHubAppConfigInput = {
  organization: Scalars['String']['input'];
  readBranch: Scalars['String']['input'];
  repository: Scalars['String']['input'];
};

export type CreateGitHubAppConfigResponse = {
  __typename?: 'CreateGitHubAppConfigResponse';
  gitHubAppConfig: GitHubAppConfig;
};

export type CreateGitHubAppRegistrationUrlInput = {
  configID: Scalars['ID']['input'];
  organization: Scalars['String']['input'];
};

export type CreateGitHubAppRegistrationUrlResponse = {
  __typename?: 'CreateGitHubAppRegistrationUrlResponse';
  url: Scalars['String']['output'];
};

export type CreateMcpServerInput = {
  authType: McpAuthType;
  awsExternalId?: InputMaybe<Scalars['String']['input']>;
  awsRoleArn?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  oauthClientId?: InputMaybe<Scalars['String']['input']>;
  oauthClientSecret?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

/** The payload to the `createOrUpdateSchema` mutation */
export type CreateOrUpdateSchemaInput = {
  /** The description of the schema */
  description?: InputMaybe<Scalars['String']['input']>;
  /** A boolean indicating whether the automatic schema field discovery feature is enabled */
  isFieldDiscoveryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the schema */
  name: Scalars['String']['input'];
  /** An optional field that can be used to reference documentation related to the schema */
  referenceURL?: InputMaybe<Scalars['String']['input']>;
  /** Revision number for the schema */
  revision?: InputMaybe<Scalars['Int']['input']>;
  /** The schema spec in YAML or JSON format */
  spec: Scalars['String']['input'];
};

/** The response of the 'createOrUpdateSchema' mutation */
export type CreateOrUpdateSchemaOutput = {
  __typename?: 'CreateOrUpdateSchemaOutput';
  error?: Maybe<Error>;
  schema?: Maybe<Schema>;
};

/** The input needed to create a replay-style performance test */
export type CreatePerfTestInput = {
  /** One detection, files zipped and base64 encoded like for bulk upload */
  detection: Scalars['String']['input'];
  /** Start of the 1 hour window to replay, truncated to the hour */
  hour: Scalars['DateTime']['input'];
  /** Must be a log type associated with the detection */
  logType: Scalars['String']['input'];
  /** If set, we will process datalake query results and not S3 objects */
  queryIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreatePullRequestForCatalogDataModelInstallInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  dataModelId: Scalars['ID']['input'];
  filePath: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePullRequestForCatalogGlobalHelperInstallInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  filePath: Scalars['String']['input'];
  globalHelperId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePullRequestForCatalogInstallInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  detectionId: Scalars['ID']['input'];
  filePath: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePullRequestForCatalogSavedQueryInstallInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  filePath: Scalars['String']['input'];
  queryName: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePullRequestForCorrelationRuleEditInput = {
  options?: InputMaybe<PullRequestOptions>;
  ruleInput: PutCorrelationRuleInput;
};

export type CreatePullRequestForDataModelDeletionInput = {
  dataModels: Array<DeleteEntry>;
  options?: InputMaybe<PullRequestOptions>;
};

export type CreatePullRequestForDataModelEditInput = {
  dataModelInput: AddOrUpdateDataModelInput;
  options?: InputMaybe<PullRequestOptions>;
};

export type CreatePullRequestForDetectionDeletionInput = {
  detections: Array<DetectionRefInput>;
  options?: InputMaybe<PullRequestOptions>;
};

export type CreatePullRequestForGlobalHelperDeletionInput = {
  globalHelpers: Array<DeleteEntry>;
  options?: InputMaybe<PullRequestOptions>;
};

export type CreatePullRequestForGlobalHelperEditInput = {
  globalHelperInput: ModifyGlobalHelperInput;
  options?: InputMaybe<PullRequestOptions>;
};

export type CreatePullRequestForNewDataModelInput = {
  dataModelInput: AddOrUpdateDataModelInput;
  options?: InputMaybe<PullRequestOptions>;
};

export type CreatePullRequestForNewGlobalHelperInput = {
  globalHelperInput: AddGlobalHelperInput;
  options?: InputMaybe<PullRequestOptions>;
};

export type CreatePullRequestForNewPolicyInput = {
  options: PullRequestOptions;
  policyCreateInput: AddPolicyInput;
};

export type CreatePullRequestForNewRuleInput = {
  options: PullRequestOptions;
  ruleCreateInput: AddRuleInput;
};

export type CreatePullRequestForNewSavedQueryInput = {
  options?: InputMaybe<PullRequestOptions>;
  savedQueryInput: AddSavedQueryInput;
};

export type CreatePullRequestForPolicyEditInput = {
  options?: InputMaybe<PullRequestOptions>;
  policyEditInput: UpdatePolicyInput;
};

export type CreatePullRequestForRuleEditInput = {
  options?: InputMaybe<PullRequestOptions>;
  ruleEditInput: UpdateRuleAndFilterInput;
};

export type CreatePullRequestForSavedQueryDeletionInput = {
  options?: InputMaybe<PullRequestOptions>;
  savedQueries: Array<SavedQueryDeleteEntry>;
};

export type CreatePullRequestForSavedQueryEditInput = {
  options?: InputMaybe<PullRequestOptions>;
  savedQueryInput: UpdateSavedQueryInput;
};

export type CreatePullRequestResponse = {
  __typename?: 'CreatePullRequestResponse';
  url: Scalars['String']['output'];
};

export type CreateRSAKeyInput = {
  rotate?: InputMaybe<Scalars['Boolean']['input']>;
  snowflakeUser: Scalars['String']['input'];
  snowflakeWarehouse: Scalars['String']['input'];
};

export type CreateReplayInput = {
  dataWindow: DataWindowInput;
  detectionId: Scalars['ID']['input'];
  logTypes: Array<Scalars['String']['input']>;
  queryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedDetection?: InputMaybe<UpdateRuleAndFilterInput>;
};

/** The result of creating a replay */
export type CreateReplayOutput = {
  __typename?: 'CreateReplayOutput';
  replay: Replay;
};

/** The input to the createRole mutation */
export type CreateRoleInput = {
  /** The log types that the role can or cannot access, according to the `logTypeAccessKind` field. This field should be omitted if `logTypeAccessKind` has a value of `ALLOW_ALL` or `DENY_ALL` */
  logTypeAccess?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Defines the role's access to log types. This field is required and has effect only if the datalake RBAC feature is enabled. */
  logTypeAccessKind?: InputMaybe<LogTypeAccessKind>;
  /** The name of the role */
  name: Scalars['String']['input'];
  /** An array of the role's permissions */
  permissions: Array<Permission>;
};

/** The output to the createRole mutation */
export type CreateRoleOutput = {
  __typename?: 'CreateRoleOutput';
  /** The created role */
  role: Role;
};

/** Input for the createS3LogSource mutation */
export type CreateS3SourceInput = {
  awsAccountId: Scalars['String']['input'];
  kmsKey?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  logProcessingRole: Scalars['String']['input'];
  logStreamType: LogStreamType;
  logStreamTypeOptions?: InputMaybe<LogStreamTypeOptionsInput>;
  managedBucketNotifications: Scalars['Boolean']['input'];
  s3Bucket: Scalars['String']['input'];
  s3PrefixLogTypes: Array<S3PrefixLogTypesInput>;
};

/** Output for the createS3LogSource mutation */
export type CreateS3SourceOutput = {
  __typename?: 'CreateS3SourceOutput';
  logSource: S3LogIntegration;
};

/** Input for creating a scheduled prompt */
export type CreateScheduledPromptInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable label shown in lists, breadcrumbs, and headers. */
  displayName: Scalars['String']['input'];
  kind?: InputMaybe<AISummarizeKind>;
  /**
   * Technical identifier — must be ^[a-z][a-z0-9_]*$, ≤128 chars. The UI
   * auto-derives this from `displayName` on first keystroke and exposes it as
   * an editable field for advanced users. Cannot be changed after creation.
   */
  name: Scalars['String']['input'];
  outputLength?: InputMaybe<OutputLength>;
  /** Whether conversations created by this prompt should be private */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  promptText: Scalars['String']['input'];
  runAsUserId?: InputMaybe<Scalars['String']['input']>;
  schedule: ScheduleInput;
};

export type CreateWidgetInput = {
  content: Scalars['JSON']['input'];
  layout: WidgetLayoutInput;
  type: DashboardWidgetType;
};

export type CredentialFormField = {
  __typename?: 'CredentialFormField';
  isSensitive: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  placeholder: Scalars['String']['output'];
};

export type CrowdstrikeConfig = {
  __typename?: 'CrowdstrikeConfig';
  awsAccessKey: Scalars['String']['output'];
  awsAccessSecret: Scalars['String']['output'];
  queueUrl: Scalars['String']['output'];
};

export type CrowdstrikeEventStreamsConfig = {
  __typename?: 'CrowdstrikeEventStreamsConfig';
  appId: Scalars['String']['output'];
  clientCloud: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  memberCid?: Maybe<Scalars['String']['output']>;
};

export type CrowdstrikeEventStreamsConfigInput = {
  appId: Scalars['String']['input'];
  clientCloud: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  memberCid?: InputMaybe<Scalars['String']['input']>;
};

export type CrowdstrikeInput = {
  awsAccessKey: Scalars['String']['input'];
  awsAccessSecret: Scalars['String']['input'];
  queueUrl: Scalars['String']['input'];
};

/** The metadata around a page of results */
export type CursorBasedPaginationPageInfo = {
  __typename?: 'CursorBasedPaginationPageInfo';
  /** The cursor that the next page of results should start from or `null` if this is the last page */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** A boolean indicating whether more results exist */
  hasNextPage: Scalars['Boolean']['output'];
  /** A boolean indicating whether this is the first page of results or not */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The cursor that this page of results started from or `null` if this is the first page */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type CustomHeader = {
  __typename?: 'CustomHeader';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CustomHeaderInput = {
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type CustomWebhookConfig = {
  __typename?: 'CustomWebhookConfig';
  customHeaders?: Maybe<Array<CustomHeader>>;
  webhookURL: Scalars['String']['output'];
};

export type CustomWebhookConfigInput = {
  customHeaders?: InputMaybe<Array<CustomHeaderInput>>;
  webhookURL: Scalars['String']['input'];
};

export type Dashboard = {
  __typename?: 'Dashboard';
  createdAt: Scalars['Timestamp']['output'];
  createdBy: User;
  deleted: Scalars['Boolean']['output'];
  icon: DashboardIcon;
  id: Scalars['ID']['output'];
  inputs?: Maybe<Array<Maybe<DashboardInput>>>;
  lastAccessedAt: Scalars['Timestamp']['output'];
  lastUpdatedAt: Scalars['Timestamp']['output'];
  lastUpdatedBy: User;
  name: Scalars['String']['output'];
  previouslyHadWidgets: Scalars['Boolean']['output'];
  widgets?: Maybe<Array<Maybe<Widget>>>;
};

export type DashboardIcon = {
  __typename?: 'DashboardIcon';
  content: Scalars['String']['output'];
  type: DashboardIconType;
};

export type DashboardIconInput = {
  content: Scalars['String']['input'];
  type: DashboardIconType;
};

export enum DashboardIconType {
  Emoji = 'EMOJI',
}

export type DashboardInput = {
  __typename?: 'DashboardInput';
  displayName: Scalars['String']['output'];
  paramName: Scalars['String']['output'];
  paramType: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type DashboardInputInput = {
  displayName: Scalars['String']['input'];
  paramName: Scalars['String']['input'];
  paramType: Scalars['String']['input'];
  path: Array<Scalars['String']['input']>;
};

export type DashboardMetadata = {
  __typename?: 'DashboardMetadata';
  createdAt: Scalars['Timestamp']['output'];
  createdBy: User;
  deleted: Scalars['Boolean']['output'];
  icon: DashboardIcon;
  id: Scalars['ID']['output'];
  lastAccessedAt: Scalars['Timestamp']['output'];
  lastUpdatedAt: Scalars['Timestamp']['output'];
  lastUpdatedBy: User;
  name: Scalars['String']['output'];
};

export enum DashboardSortOrder {
  AlphanumericAsc = 'ALPHANUMERIC_ASC',
  LastAccessedDesc = 'LAST_ACCESSED_DESC',
  LastCreatedDesc = 'LAST_CREATED_DESC',
  LastUpdatedDesc = 'LAST_UPDATED_DESC',
}

export enum DashboardWidgetType {
  Markdown = 'MARKDOWN',
  PantherflowQuery = 'PANTHERFLOW_QUERY',
}

export type DashboardsInput = {
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  includeDeleted: Scalars['Boolean']['input'];
  nameIncludes?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy: DashboardSortOrder;
};

export type DashboardsOutput = {
  __typename?: 'DashboardsOutput';
  dashboards: Array<DashboardMetadata>;
  pageInfo: CursorBasedPaginationPageInfo;
};

/** A Panther data lake database */
export type DataLakeDatabase = {
  __typename?: 'DataLakeDatabase';
  /** A description for this database */
  description?: Maybe<Scalars['String']['output']>;
  /** The name of this database */
  name: Scalars['String']['output'];
  /** The tables that this database has */
  tables: Array<DataLakeDatabaseTable>;
};

/** A table within a Panther data lake database */
export type DataLakeDatabaseTable = {
  __typename?: 'DataLakeDatabaseTable';
  /** The columns that this table has */
  columns: Array<DataLakeDatabaseTableColumn>;
  databaseName: Scalars['String']['output'];
  /** Optional description for this table */
  description?: Maybe<Scalars['String']['output']>;
  /** Optional display name for table */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Optional logType */
  logType?: Maybe<Scalars['String']['output']>;
  /** The name of the table */
  name: Scalars['String']['output'];
  /** Optional count of hits in this table (used in query results) */
  numMatches?: Maybe<Scalars['Int']['output']>;
};

/** The column of a Panther data lake table */
export type DataLakeDatabaseTableColumn = {
  __typename?: 'DataLakeDatabaseTableColumn';
  /** A description for this column */
  description?: Maybe<Scalars['String']['output']>;
  /** The name of the column */
  name: Scalars['String']['output'];
  /** Nested properties available on the column (for dictionary-like types) */
  properties: Array<DataLakePropertyDefinition>;
  /** The column's type. Exact values depend on your choice of data lake. */
  type?: Maybe<Scalars['String']['output']>;
};

/** The input used to describe a data lake table */
export type DataLakeDatabaseTableInput = {
  /** The name of the database that the table belongs in */
  databaseName: Scalars['String']['input'];
  /** The name of the table */
  tableName: Scalars['String']['input'];
};

/** The shape of the edges in an edge collection */
export type DataLakeDatabaseTablesEdges = {
  __typename?: 'DataLakeDatabaseTablesEdges';
  /** a node containing the table information */
  node: DataLakeDatabaseTable;
};

/** The input used to describe a collection of data lake tables */
export type DataLakeDatabaseTablesInput = {
  /** The cursor to start from for paginated queries */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** The name of the database that the tables belong in */
  databaseName: Scalars['String']['input'];
  /** The number of results that each page will contain. */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** The results of a DataLakeDatabaseTables query */
export type DataLakeDatabaseTablesOutput = {
  __typename?: 'DataLakeDatabaseTablesOutput';
  /** A list of paginated edges */
  edges: Array<DataLakeDatabaseTablesEdges>;
  /** Metadata around this page of results */
  pageInfo: DataLakeDatabaseTablesOutputPageInfo;
};

/** The metadata about the page in a Table collection */
export type DataLakeDatabaseTablesOutputPageInfo = {
  __typename?: 'DataLakeDatabaseTablesOutputPageInfo';
  /** The cursor that the next page of results should start from or `null` if this is the last page */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** A boolean indicating whether more results exist */
  hasNextPage: Scalars['Boolean']['output'];
  /** A boolean indicating whether this is the first page of results or not */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The cursor that this page of results started from or `null` if this is the first page */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type DataLakeListDefinition = {
  __typename?: 'DataLakeListDefinition';
  /** The items' type. Exact values depend on your choice of data lake. */
  type: Scalars['String']['output'];
};

export type DataLakePropertyDefinition = {
  __typename?: 'DataLakePropertyDefinition';
  /** A description for this property */
  description?: Maybe<Scalars['String']['output']>;
  /** Display name for the property */
  displayName: Scalars['String']['output'];
  /** ID for the property */
  id: Scalars['ID']['output'];
  isPantherField: Scalars['Boolean']['output'];
  /** Additional type information for items (for list-like types) */
  items?: Maybe<DataLakeListDefinition>;
  /** JSON path to the property */
  path: Scalars['String']['output'];
  table?: Maybe<Scalars['String']['output']>;
  /** The property's type. Exact values depend on your choice of data lake. */
  type: Scalars['String']['output'];
};

export type DataLakePropertyDefinitionsInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  databases?: InputMaybe<Array<Scalars['String']['input']>>;
  pageSize: Scalars['Int']['input'];
  tables?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DataLakePropertyDefinitionsOutput = {
  __typename?: 'DataLakePropertyDefinitionsOutput';
  edges: Array<DataLakePropertyDefinitionsOutputEdge>;
  pageInfo: CursorBasedPaginationPageInfo;
};

export type DataLakePropertyDefinitionsOutputEdge = {
  __typename?: 'DataLakePropertyDefinitionsOutputEdge';
  node: DataLakePropertyDefinition;
};

export type DataLakePropertySummary = {
  __typename?: 'DataLakePropertySummary';
  entries: Array<DataLakePropertySummaryEntry>;
  pageInfo: CursorBasedPaginationPageInfo;
  queryId: Scalars['ID']['output'];
  status: DataLakeQueryStatus;
  totalEntryCount: Scalars['Int']['output'];
};

export type DataLakePropertySummaryEntry = {
  __typename?: 'DataLakePropertySummaryEntry';
  count: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

/** The optional input filters to the `dataLakeQueries` query */
export type DataLakeQueriesInput = {
  /** Filter queries by their name and/or SQL statement */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** An opaque string used when paginating across multiple pages of results */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Only return queries that are either scheduled or not (i.e. issued by a user). Leave blank to return both. */
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only return queries issued by those user IDs */
  issuedBy?: InputMaybe<Array<Scalars['ID']['input']>>;
  kind?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The number of results that each page will contain. Defaults to 25 with a maximum value of 999. */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** Field used for sorting purposes. Currently, `startedAt` is the only option */
  sortBy?: InputMaybe<DataLakeQueriesSortFields>;
  /** The direction to sort results by */
  sortDir?: InputMaybe<SortDirEnum>;
  /** Only return queries that started after this fdate */
  startedAtAfter?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only return queries that started after this fdate */
  startedAtBefore?: InputMaybe<Scalars['DateTime']['input']>;
  /** A list of query statuses to filter queries by */
  status?: InputMaybe<Array<DataLakeQueryStatus>>;
};

/** The return value of a `dataLakeQueries` query */
export type DataLakeQueriesOutput = {
  __typename?: 'DataLakeQueriesOutput';
  /** A list of paginated query edges */
  edges: Array<DataLakeQueryEdge>;
  /** Metadata around this page of results */
  pageInfo: DataLakeQueriesOutputPageInfo;
};

/** The metadata around a page of results for the `dataLakeQueries` query */
export type DataLakeQueriesOutputPageInfo = {
  __typename?: 'DataLakeQueriesOutputPageInfo';
  /** The cursor that the next page of results should start from or `null` if this is the last page */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** A boolean indicating whether more results exist */
  hasNextPage: Scalars['Boolean']['output'];
  /** A boolean indicating whether this is the first page of results or not */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The cursor that this page of results started from or `null` if this is the first page */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** The available sort values for sorting a paginated list of data lake queries */
export enum DataLakeQueriesSortFields {
  StartedAt = 'startedAt',
}

/** The metadata around a data lake or indicator search query */
export type DataLakeQuery = {
  __typename?: 'DataLakeQuery';
  annotations?: Maybe<Annotations>;
  /** The children queries (subqueries) for queries (e.g., used by the Query Builder). This field is empty for simple queries */
  children: Array<DataLakeQuery>;
  /** The datetime at which the query completed or errored. This value is empty if the query is still running */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of this query */
  id: Scalars['ID']['output'];
  /** A boolean denoting whether this was a scheduled query or not */
  isScheduled: Scalars['Boolean']['output'];
  /** The entity that issued this query */
  issuedBy?: Maybe<Actor>;
  kind: Scalars['String']['output'];
  /** A message that describes the current status of this query */
  message: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** The name of this query or empty if it's an ad-hoc query */
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['ID']['output']>;
  /** The results this query yielded. This field is `null` if the query hasn't successfully completed */
  results?: Maybe<DataLakeQueryResults>;
  /** The SQL statement that was ran */
  sql: Scalars['String']['output'];
  /** The datetime at which the query started executing */
  startedAt: Scalars['DateTime']['output'];
  /** The current status of this query */
  status: DataLakeQueryStatus;
  userConfig?: Maybe<QueryUserConfig>;
};

/** The metadata around a data lake or indicator search query */
export type DataLakeQueryResultsArgs = {
  input?: InputMaybe<DataLakeQueryResultsInput>;
};

/** The edge shape of the `DataLakeQueryEdge` type */
export type DataLakeQueryEdge = {
  __typename?: 'DataLakeQueryEdge';
  /** A data lake query node */
  node: DataLakeQuery;
};

/** The edge shape of the `DataLakeQueryResultRecords` type */
export type DataLakeQueryResultEdge = {
  __typename?: 'DataLakeQueryResultEdge';
  /** A data lake record object */
  id?: Maybe<Scalars['String']['output']>;
  node: Scalars['JSON']['output'];
  /**
   * Stringified version of the node. This is useful when we need to deserialize the node
   * with a custom json parser (e.g. JSONBig) to support large numbers.
   */
  nodeAsString: Scalars['String']['output'];
};

/** Pagination metadata for the records returned by a data lake or indicator search query */
export type DataLakeQueryResultRecordsPageInfo = {
  __typename?: 'DataLakeQueryResultRecordsPageInfo';
  /** The cursor that the next page of results should start from or `null` if this is the last page */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** A boolean indicating whether more results exist */
  hasNextPage: Scalars['Boolean']['output'];
  /** A boolean indicating whether this is the first page of results or not */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The cursor that this page of results started from or `null` if this is the first page */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** The shape of a data lake query results */
export type DataLakeQueryResults = {
  __typename?: 'DataLakeQueryResults';
  /** Metadata around the data lake columns returned in this page of results */
  columnInfo: DataLakeQueryResultsColumnInfo;
  /** A list of paginated data lake result edges */
  edges: Array<DataLakeQueryResultEdge>;
  /** Metadata around this page of results */
  pageInfo: DataLakeQueryResultRecordsPageInfo;
  /** Stats around the data lake or indicator search query results */
  stats: DataLakeQueryStats;
  /** If true, caller should try again */
  tryAgain: Scalars['Boolean']['output'];
  /** Warning message about the results (e.g. truncation due to size limits) */
  warningMessage?: Maybe<Scalars['String']['output']>;
};

/** Metadata related to the underlying database columns returned as part of a data lake or indicator search query */
export type DataLakeQueryResultsColumnInfo = {
  __typename?: 'DataLakeQueryResultsColumnInfo';
  /** The ordered name of the columns as returned by the underlying database */
  order: Array<Scalars['String']['output']>;
  /**
   * A mapping of column name to column type. The type of each column is directly related to the underlying database
   * and varies from one backend to another (e.g. Snowflake, etc.)
   */
  types: Scalars['JSON']['output'];
};

/** The input to the `results` field of the `DataLakeQuery` type */
export type DataLakeQueryResultsInput = {
  /** The pagination cursor used to fetch more pages. `null` if you're fetching the first page of results */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** The number of results that each page will contain. Defaults to the maximum value of 999. */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export enum DataLakeQuerySortDirection {
  Asc = 'asc',
  Desc = 'desc',
}

/** Data lake query execution stats */
export type DataLakeQueryStats = {
  __typename?: 'DataLakeQueryStats';
  /** The amount of data scanned (expressed in bytes) during this data lake or indicator query execution */
  bytesScanned: Scalars['Float']['output'];
  /** The amount of time (expressed in milliseconds) that the data lake or indicator search query ran for */
  executionTime: Scalars['Float']['output'];
  /** The the total number of rows returned by the query */
  rowCount: Scalars['Float']['output'];
};

/** The available statuses for a data lake or indicator search query */
export enum DataLakeQueryStatus {
  /** The status when the query was cancelled by the user */
  Cancelled = 'cancelled',
  /** The status when the query has errored out */
  Failed = 'failed',
  /** The status when the query is running */
  Running = 'running',
  /** The status when the query has successfully completed */
  Succeeded = 'succeeded',
}

/** The results of a DataLakeQueryVisualization */
export type DataLakeQueryVisualization = {
  __typename?: 'DataLakeQueryVisualization';
  /** The query annotations */
  annotations?: Maybe<Annotations>;
  /** The ID of this query */
  id: Scalars['ID']['output'];
  /** An explanation of the query status, or the error if the query failed */
  message: Scalars['String']['output'];
  /** The query metadata */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** The results this query yielded. This field is `null` if the query hasn't successfully completed */
  results?: Maybe<DataLakeQueryVisualizationResults>;
  /** The current status of this query */
  status: DataLakeQueryStatus;
};

/** The results of a DataLakeQueryVisualization */
export type DataLakeQueryVisualizationResultsArgs = {
  input?: InputMaybe<DataLakeQueryResultsInput>;
};

/** The shape of a data lake query visualization results */
export type DataLakeQueryVisualizationResults = {
  __typename?: 'DataLakeQueryVisualizationResults';
  /** Metadata around the data lake columns returned in this page of results */
  columns: Array<DataLakeQueryVisualizationResultsColumn>;
  /** Metadata around this page of results */
  pageInfo: DataLakeQueryResultRecordsPageInfo;
  /** A list of paginated data lake rows */
  rows: Array<DataLakeQueryVisualizationResultsRow>;
  /** Stats around the data lake or indicator search query results */
  stats: DataLakeQueryStats;
  /** If true, caller should try again */
  tryAgain: Scalars['Boolean']['output'];
};

/** Metadata related to the underlying database columns returned as part of a data lake or indicator search query */
export type DataLakeQueryVisualizationResultsColumn = {
  __typename?: 'DataLakeQueryVisualizationResultsColumn';
  /** The name of the column */
  name: Scalars['String']['output'];
  /** The type of the column */
  type: ColumnType;
};

/** A row of `DataLakeQueryVisualizationResults` */
export type DataLakeQueryVisualizationResultsRow = {
  __typename?: 'DataLakeQueryVisualizationResultsRow';
  /** A unique id for this row */
  id?: Maybe<Scalars['String']['output']>;
  /** The row data */
  item: Scalars['JSON']['output'];
};

export type DataModel = {
  __typename?: 'DataModel';
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Actor>;
  displayName: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastModified: Scalars['DateTime']['output'];
  lastModifiedBy?: Maybe<Actor>;
  logTypes: Array<Scalars['String']['output']>;
  managed?: Maybe<Scalars['Boolean']['output']>;
  mappings: Array<DataModelMapping>;
  parentId?: Maybe<Scalars['String']['output']>;
};

export type DataModelMapping = {
  __typename?: 'DataModelMapping';
  method?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
};

export type DataModelMappingInput = {
  method?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
};

/**
 * What data to run the replay on
 * Either SizeWindow or TimeWindow needs to be set
 * Setting neither is invalid
 */
export type DataWindow = {
  __typename?: 'DataWindow';
  sizeWindow?: Maybe<SizeWindow>;
  timeWindow?: Maybe<TimeWindow>;
};

export type DataWindowInput = {
  sizeWindow?: InputMaybe<SizeWindowInput>;
  timeWindow?: InputMaybe<TimeWindowInput>;
};

export type DatabaseAndTable = {
  __typename?: 'DatabaseAndTable';
  /** Name of the database. */
  databaseName: Scalars['String']['output'];
  /** Name of the table. */
  tableName: Scalars['String']['output'];
};

export type DatabaseAndTableInput = {
  /** Name of the database. */
  databaseName: Scalars['String']['input'];
  /** Name of the table. */
  tableName: Scalars['String']['input'];
};

export type DatalakeFieldValuesInput = {
  /** End time of a time range to search for values over. Use with start time. Do not set if using relative time. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The path to the field being used as a dashboard input. */
  path: Array<Scalars['String']['input']>;
  /** Search string prefix to further filter the available fields */
  prefix?: InputMaybe<Scalars['String']['input']>;
  /**
   * The relative time range to search for values over. Do not set if using start and end time.
   * Follows the ISO 8601 Duration spec (except for PAllTime).
   */
  relativeTime?: InputMaybe<Scalars['String']['input']>;
  /** Start time of a time range to search for values over. Use with end time. Do not set if using relative time. */
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** List of databases and tables to find the options in. */
  tables: Array<DatabaseAndTableInput>;
};

export type DatalakeFieldValuesOutput = {
  __typename?: 'DatalakeFieldValuesOutput';
  values: Array<Scalars['String']['output']>;
};

export type DatalakeSchemaColumnEntity = {
  __typename?: 'DatalakeSchemaColumnEntity';
  /** Database this column is from */
  database: Scalars['String']['output'];
  /** A description for this column */
  description: Scalars['String']['output'];
  /** The name of the column */
  name: Scalars['String']['output'];
  /** Table this column is from */
  table: Scalars['String']['output'];
  /** The column's type. Exact values depend on your choice of data lake. */
  type: Scalars['String']['output'];
};

export type DatalakeSchemaDatalakeEntity = {
  __typename?: 'DatalakeSchemaDatalakeEntity';
  /** A description for this database */
  description: Scalars['String']['output'];
  /** The name of this database */
  name: Scalars['String']['output'];
};

export type DatalakeSchemaEntity =
  | DatalakeSchemaColumnEntity
  | DatalakeSchemaDatalakeEntity
  | DatalakeSchemaPropertyEntity
  | DatalakeSchemaTableEntity;

export enum DatalakeSchemaEntityType {
  Column = 'COLUMN',
  Datalake = 'DATALAKE',
  Property = 'PROPERTY',
  Table = 'TABLE',
}

export type DatalakeSchemaProperty = {
  __typename?: 'DatalakeSchemaProperty';
  /** Display name for the property */
  displayName: Scalars['String']['output'];
  /** ID for the property */
  id: Scalars['ID']['output'];
  /** True if it is a p_ field */
  isPantherField: Scalars['Boolean']['output'];
  /** JSON path to the property */
  path: Array<Scalars['String']['output']>;
  /**
   * The property's Panther type that comes from the log schema. If the property does not have an available
   * log schema type, a best effort is made to map it to a Panther log schema type.
   */
  schemaType: SchemaValueType;
  /** Tables that the property was a part of. Will be multiple if the property was in multiple tables before being deduplicated. */
  tables: Array<DatabaseAndTable>;
  /** The property's type. Exact values depend on your choice of data lake. */
  type: Scalars['String']['output'];
  /** Additional type information for items (for list-like types) */
  typeOfItems?: Maybe<Scalars['String']['output']>;
};

export type DatalakeSchemaPropertyEntity = {
  __typename?: 'DatalakeSchemaPropertyEntity';
  /** Column this property is from */
  column: Scalars['String']['output'];
  /** Database this property is from */
  database: Scalars['String']['output'];
  /** A description for this property */
  description: Scalars['String']['output'];
  /** Display name for the property */
  displayName: Scalars['String']['output'];
  /** ID for the property */
  id: Scalars['ID']['output'];
  /** True if it is a p_ field */
  isPantherField: Scalars['Boolean']['output'];
  /** Additional type information for items (for list-like types) */
  items?: Maybe<DataLakeListDefinition>;
  /** JSON path to the property */
  path: Scalars['String']['output'];
  /** Table this property is from */
  table: Scalars['String']['output'];
  /** The property's type. Exact values depend on your choice of data lake. */
  type: Scalars['String']['output'];
};

export type DatalakeSchemaTableEntity = {
  __typename?: 'DatalakeSchemaTableEntity';
  /** Database this table is from */
  database: Scalars['String']['output'];
  /** Optional description for this table */
  description: Scalars['String']['output'];
  /** Optional display name for table */
  displayName: Scalars['String']['output'];
  /** Optional logType */
  logType: Scalars['String']['output'];
  /** The name of the table */
  name: Scalars['String']['output'];
};

export type DateRange = {
  __typename?: 'DateRange';
  from: Scalars['DateTime']['output'];
  to: Scalars['DateTime']['output'];
};

/** Input to decide the outcome of a tool invocation */
export type DecideToolInvocationInput = {
  /** Whether the tool invocation was approved */
  approved: Scalars['Boolean']['input'];
  /** Additional metadata to merge into the tool invocation (e.g., user's answer for ask_question tool) */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The reason for the decision */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the stream containing the tool invocation */
  streamId: Scalars['ID']['input'];
  /** The ID of the tool invocation to approve/reject */
  toolInvocationId: Scalars['ID']['input'];
};

/** Output from deleting an AI skill */
export type DeleteAISkillOutput = {
  __typename?: 'DeleteAISkillOutput';
  /** Error information if the operation failed */
  error?: Maybe<Error>;
  /** Whether the deletion was successful */
  success: Scalars['Boolean']['output'];
};

export type DeleteAPITokenOutput = {
  __typename?: 'DeleteAPITokenOutput';
  error?: Maybe<Error>;
  token?: Maybe<APIToken>;
};

export type DeleteAlertContextTagInput = {
  tag: Scalars['String']['input'];
};

/** Input for the deleteCloudAccount mutation */
export type DeleteCloudAccountInput = {
  id: Scalars['ID']['input'];
};

/** Output for the deleteCloudAccounts mutation */
export type DeleteCloudAccountOutput = {
  __typename?: 'DeleteCloudAccountOutput';
  id: Scalars['ID']['output'];
};

export type DeleteDataModelInput = {
  dataModels: Array<DeleteEntry>;
};

/** The payload to the `deleteDetections` mutation */
export type DeleteDetectionsInput = {
  /** Preview what would be deleted, without deleting any detections */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** IDs of detections to be deleted */
  ids: Array<Scalars['ID']['input']>;
  /** When true, deletes any saved queries associated with the detection */
  includeSavedQueries?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The response of the `deleteDetections` mutation */
export type DeleteDetectionsOutput = {
  __typename?: 'DeleteDetectionsOutput';
  /**
   * IDs of detections that were deleted
   * If dryRun was set to True in the response, this will include IDs that would have been deleted.
   */
  ids: Array<Scalars['ID']['output']>;
  /**
   * Names of saved queries that were deleted
   * If dryRun was set to True in the request, this will include the names of Saved Queries that would have been deleted.
   */
  savedQueryNames?: Maybe<Array<Scalars['String']['output']>>;
};

export type DeleteEntry = {
  id: Scalars['ID']['input'];
};

export type DeleteGitConfigInput = {
  configID: Scalars['ID']['input'];
};

export type DeleteGlobalHelpersInput = {
  globals: Array<DeleteEntry>;
};

export type DeleteLookupsInput = {
  ids: Array<Scalars['ID']['input']>;
};

/** The input to the deleteRole mutation */
export type DeleteRoleInput = {
  /** The ID of the role */
  id: Scalars['ID']['input'];
};

/** The output to the deleteRole mutation */
export type DeleteRoleOutput = {
  __typename?: 'DeleteRoleOutput';
  /** The ID of the deleted role */
  id: Scalars['ID']['output'];
};

/** The input to the 'deleteSavedQueriesByName' mutation */
export type DeleteSavedQueriesByNameInput = {
  /** Preview what would be deleted, without deleting any saved queries */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, deletes any detections associated with the saved queries */
  includeDetections?: InputMaybe<Scalars['Boolean']['input']>;
  /** Saved Query names to be deleted */
  names: Array<Scalars['String']['input']>;
};

/** The output of the 'deleteSavedQueriesByName' mutation */
export type DeleteSavedQueriesByNameOutput = {
  __typename?: 'DeleteSavedQueriesByNameOutput';
  /**
   * The IDs of any Detections that were deleted
   * If dryRun was set to True in the response, this will include the IDs of Detections that would have been deleted.
   */
  detectionIDs?: Maybe<Array<Scalars['ID']['output']>>;
  /**
   * The names of the Saved Queries that were deleted
   * If dryRun was set to True in the response, this will include names of queries that would have been deleted.
   */
  names: Array<Scalars['String']['output']>;
};

export type DeleteSavedQueryInput = {
  ids: Array<Scalars['ID']['input']>;
};

/** Input for deleting a scheduled prompt */
export type DeleteScheduledPromptInput = {
  id: Scalars['ID']['input'];
};

/** Input for the deleteSource mutation */
export type DeleteSourceInput = {
  id: Scalars['ID']['input'];
};

/** Output for the deleteSource mutation */
export type DeleteSourceOutput = {
  __typename?: 'DeleteSourceOutput';
  id: Scalars['ID']['output'];
};

/** The input for the deleteUser mutation */
export type DeleteUserInput = {
  /** The ID of the user to delete */
  id: Scalars['ID']['input'];
};

/** The return value of the Delete User mutation */
export type DeleteUserOutput = {
  __typename?: 'DeleteUserOutput';
  /** The deleted Panther User object */
  id: Scalars['ID']['output'];
};

/** Represents a Detection that has been deleted but still has alerts associated with it */
export type DeletedDetection = {
  __typename?: 'DeletedDetection';
  /** The unique identifier of the Detection that generated this alert */
  id: Scalars['ID']['output'];
};

export type DeliverAlertInput = {
  alertId: Scalars['ID']['input'];
  outputIds: Array<Scalars['ID']['input']>;
};

export type Destination = {
  __typename?: 'Destination';
  alertTypes: Array<AlertType>;
  allowManualDispatch: Scalars['Boolean']['output'];
  apiToken?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Actor>;
  creationTime: Scalars['DateTime']['output'];
  defaultForSeverity: Array<Maybe<Severity>>;
  displayName: Scalars['String']['output'];
  lastModifiedBy?: Maybe<Actor>;
  lastModifiedTime: Scalars['DateTime']['output'];
  logTypes: Array<Scalars['String']['output']>;
  outputConfig: DestinationConfig;
  outputId: Scalars['ID']['output'];
  outputType: DestinationTypeEnum;
  verificationStatus?: Maybe<Scalars['String']['output']>;
};

export type DestinationConfig = {
  __typename?: 'DestinationConfig';
  asana?: Maybe<AsanaConfig>;
  blinkOpsWebhook?: Maybe<BlinkOpsWebhookConfig>;
  customWebhook?: Maybe<CustomWebhookConfig>;
  discord?: Maybe<DiscordConfig>;
  expelWebhook?: Maybe<ExpelWebhookConfig>;
  gcpPubSub?: Maybe<GcpPubSubDestinationConfig>;
  github?: Maybe<GithubConfig>;
  incidentIoWebhook?: Maybe<IncidentIoWebhookConfig>;
  jira?: Maybe<JiraConfig>;
  jiraDataCenter?: Maybe<JiraConfig>;
  mindflowWebhook?: Maybe<MindflowWebhookConfig>;
  msTeams?: Maybe<MsTeamsConfig>;
  opsgenie?: Maybe<OpsgenieConfig>;
  pagerDuty?: Maybe<PagerDutyConfig>;
  rapid7InsightConnect?: Maybe<Rapid7InsightConnectConfig>;
  slack?: Maybe<SlackConfig>;
  slackBot?: Maybe<SlackBotConfig>;
  sns?: Maybe<SnsConfig>;
  splunkWebhook?: Maybe<SplunkWebhookConfig>;
  sqs?: Maybe<SqsDestinationConfig>;
  tinesWebhook?: Maybe<TinesWebhookConfig>;
  torqWebhook?: Maybe<TorqWebhookConfig>;
};

export type DestinationConfigInput = {
  asana?: InputMaybe<AsanaConfigInput>;
  blinkOpsWebhook?: InputMaybe<BlinkOpsWebhookConfigInput>;
  customWebhook?: InputMaybe<CustomWebhookConfigInput>;
  discord?: InputMaybe<DiscordConfigInput>;
  expelWebhook?: InputMaybe<ExpelWebhookConfigInput>;
  gcpPubSub?: InputMaybe<GcpPubSubDestinationConfigInput>;
  github?: InputMaybe<GithubConfigInput>;
  incidentIoWebhook?: InputMaybe<IncidentIoWebhookConfigInput>;
  jira?: InputMaybe<JiraConfigInput>;
  jiraDataCenter?: InputMaybe<JiraConfigInput>;
  mindflowWebhook?: InputMaybe<MindflowWebhookConfigInput>;
  msTeams?: InputMaybe<MsTeamsConfigInput>;
  opsgenie?: InputMaybe<OpsgenieConfigInput>;
  pagerDuty?: InputMaybe<PagerDutyConfigInput>;
  rapid7InsightConnect?: InputMaybe<Rapid7InsightConnectConfigInput>;
  slack?: InputMaybe<SlackConfigInput>;
  slackBot?: InputMaybe<SlackBotConfigInput>;
  sns?: InputMaybe<SnsConfigInput>;
  splunkWebhook?: InputMaybe<SplunkWebhookConfigInput>;
  sqs?: InputMaybe<SqsConfigInput>;
  tinesWebhook?: InputMaybe<TinesWebhookConfigInput>;
  torqWebhook?: InputMaybe<TorqWebhookConfigInput>;
};

export type DestinationInput = {
  alertTypes: Array<InputMaybe<AlertType>>;
  allowManualDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  defaultForSeverity: Array<InputMaybe<Severity>>;
  displayName: Scalars['String']['input'];
  logTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  outputConfig: DestinationConfigInput;
  outputId?: InputMaybe<Scalars['ID']['input']>;
  outputType: Scalars['String']['input'];
};

export enum DestinationTypeEnum {
  Asana = 'asana',
  Blinkopswebhook = 'blinkopswebhook',
  Customwebhook = 'customwebhook',
  Discord = 'discord',
  Expelwebhook = 'expelwebhook',
  Gcppubsub = 'gcppubsub',
  Github = 'github',
  Incidentiowebhook = 'incidentiowebhook',
  Jira = 'jira',
  Jiradatacenter = 'jiradatacenter',
  Mindflowwebhook = 'mindflowwebhook',
  Msteams = 'msteams',
  Opsgenie = 'opsgenie',
  Pagerduty = 'pagerduty',
  Rapid7insightconnect = 'rapid7insightconnect',
  Slack = 'slack',
  Slackbot = 'slackbot',
  Sns = 'sns',
  Splunkwebhook = 'splunkwebhook',
  Sqs = 'sqs',
  Tineswebhook = 'tineswebhook',
  Torqwebhook = 'torqwebhook',
}

/** A Panther detection that generates alerts */
export type Detection = {
  __typename?: 'Detection';
  /** The date and time that this detection was created */
  createdAt: Scalars['DateTime']['output'];
  /** The actor that created this detection */
  createdBy?: Maybe<Actor>;
  /** An extended description for this detection */
  description?: Maybe<Scalars['String']['output']>;
  /** The ID of this detection, which is typically human-readable */
  id: Scalars['ID']['output'];
  /** The publicly visible display name for this detection */
  name: Scalars['String']['output'];
  /** The type of this detection. Can be a Rule, a Scheduled Rule or a Policy */
  type: DetectionType;
  /** The date and time that this detection was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The actor that was last to modify this detection */
  updatedBy?: Maybe<Actor>;
};

export type DetectionAlertMetricsInput = {
  detections: Array<DetectionAlertMetricsInputDetection>;
  fromDate: Scalars['DateTime']['input'];
  toDate: Scalars['DateTime']['input'];
};

export type DetectionAlertMetricsInputDetection = {
  id: Scalars['String']['input'];
  type: DetectionType;
};

export type DetectionAlertMetricsOutput = {
  __typename?: 'DetectionAlertMetricsOutput';
  detectionAlerts: Array<SeriesWithBreakdown>;
};

/** The response of the `uploadDetectionEntitiesStatus` query */
export type DetectionEntitiesUploadStatusOutput = {
  __typename?: 'DetectionEntitiesUploadStatusOutput';
  /** The time the detection entities upload was created */
  createdAt: Scalars['DateTime']['output'];
  /** If the detection entities upload failed, the error that occurred */
  error?: Maybe<Scalars['String']['output']>;
  /** The mode of the detection entities upload */
  mode: UploadDetectionEntitiesMode;
  /** If the detection entities upload succeeded, the result of the upload */
  result?: Maybe<UploadDetectionEntitiesOutput>;
  /** The current status of the detection entities upload */
  status: UploadStatus;
  /** The time the detection entities upload was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type DetectionFilter = {
  __typename?: 'DetectionFilter';
  detectionId: Scalars['ID']['output'];
  statement?: Maybe<DetectionFilterStatement>;
};

export type DetectionFilterCondition = {
  __typename?: 'DetectionFilterCondition';
  operator: Scalars['String']['output'];
  source?: Maybe<Scalars['String']['output']>;
  target: Scalars['String']['output'];
  targetTypeHint?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type DetectionFilterConditionInput = {
  operator: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  target: Scalars['String']['input'];
  targetTypeHint?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type DetectionFilterStatement = {
  __typename?: 'DetectionFilterStatement';
  and?: Maybe<Array<DetectionFilterStatement>>;
  condition?: Maybe<DetectionFilterCondition>;
  not?: Maybe<Array<DetectionFilterStatement>>;
  or?: Maybe<Array<DetectionFilterStatement>>;
};

export type DetectionFilterStatementInput = {
  and?: InputMaybe<Array<DetectionFilterStatementInput>>;
  condition?: InputMaybe<DetectionFilterConditionInput>;
  not?: InputMaybe<Array<DetectionFilterStatementInput>>;
  or?: InputMaybe<Array<DetectionFilterStatementInput>>;
};

export type DetectionPatch = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
};

export type DetectionRefInput = {
  analysisType: DetectionType;
  id: Scalars['ID']['input'];
};

export type DetectionReportEntry = MitreReportEntry | StandardReportEntry;

export type DetectionReportMapping = {
  __typename?: 'DetectionReportMapping';
  entries?: Maybe<Array<DetectionReportEntry>>;
  key: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type DetectionReportMappingInput = {
  key: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type DetectionStatsDetectionTypeCount = {
  __typename?: 'DetectionStatsDetectionTypeCount';
  count: Scalars['Int']['output'];
  detectionType: DetectionType;
};

export type DetectionStatsEnabledStateCount = {
  __typename?: 'DetectionStatsEnabledStateCount';
  count: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
};

export type DetectionStatsResponse = {
  __typename?: 'DetectionStatsResponse';
  detectionTypeCounts: Array<DetectionStatsDetectionTypeCount>;
  enabledCounts: Array<DetectionStatsEnabledStateCount>;
  severityCounts: Array<DetectionStatsSeverityCount>;
};

export type DetectionStatsSeverityCount = {
  __typename?: 'DetectionStatsSeverityCount';
  count: Scalars['Int']['output'];
  severity: Severity;
};

export type DetectionTestDefinition = {
  __typename?: 'DetectionTestDefinition';
  expectedResult: Scalars['Boolean']['output'];
  mocks?: Maybe<Array<DetectionTestMockDefinition>>;
  name: Scalars['String']['output'];
  resource: Scalars['String']['output'];
  ruleOutputs?: Maybe<Array<CorrelationRuleTestCaseRuleOutputDefinition>>;
};

export type DetectionTestDefinitionInput = {
  expectedResult: Scalars['Boolean']['input'];
  mocks?: InputMaybe<Array<DetectionTestDefinitionMockInput>>;
  name: Scalars['String']['input'];
  resource: Scalars['String']['input'];
  ruleOutputs?: InputMaybe<Array<CorrelationRuleTestCaseRuleOutputDefinitionInput>>;
};

export type DetectionTestDefinitionMockInput = {
  objectName: Scalars['String']['input'];
  returnValue?: InputMaybe<Scalars['String']['input']>;
};

/** The model describing a detection test */
export type DetectionTestDefinitionProtected = {
  __typename?: 'DetectionTestDefinitionProtected';
  /** Expected result the test should return */
  expectedResult: Scalars['Boolean']['output'];
  /** Mocks of the test if any */
  mocks?: Maybe<Array<DetectionTestMockDefinitionProtected>>;
  /** Unique identifier for the test */
  name: Scalars['String']['output'];
  /** Input for the test case */
  resource: Scalars['String']['output'];
};

export type DetectionTestFilterDefinition = {
  statement: DetectionFilterStatementInput;
};

export type DetectionTestMockDefinition = {
  __typename?: 'DetectionTestMockDefinition';
  objectName: Scalars['String']['output'];
  returnValue?: Maybe<Scalars['String']['output']>;
};

/** The model describing a detection test mock */
export type DetectionTestMockDefinitionProtected = {
  __typename?: 'DetectionTestMockDefinitionProtected';
  /** The name of the object to mock */
  objectName: Scalars['String']['output'];
  /** The value that object should return */
  returnValue?: Maybe<Scalars['String']['output']>;
};

/** The types of detections that Panther supports */
export enum DetectionType {
  CorrelationRule = 'CORRELATION_RULE',
  DerivedRule = 'DERIVED_RULE',
  Policy = 'POLICY',
  Rule = 'RULE',
  ScheduledRule = 'SCHEDULED_RULE',
}

export type DetectionUpdateError = {
  __typename?: 'DetectionUpdateError';
  detectionId: Scalars['String']['output'];
  error: Error;
};

export type DiscordConfig = {
  __typename?: 'DiscordConfig';
  webhookURL: Scalars['String']['output'];
};

export type DiscordConfigInput = {
  webhookURL: Scalars['String']['input'];
};

export type DiscoverMcpServerInput = {
  url: Scalars['String']['input'];
};

export type DiscoverTaxiiCollectionsInput = {
  /** One of "bearer" or "basic" */
  authMode: Scalars['String']['input'];
  basicPassword?: InputMaybe<Scalars['String']['input']>;
  basicUsername?: InputMaybe<Scalars['String']['input']>;
  bearerToken?: InputMaybe<Scalars['String']['input']>;
  discoveryUrl: Scalars['String']['input'];
  /** When set, blank credentials are backfilled from the stored integration config. */
  integrationId?: InputMaybe<Scalars['ID']['input']>;
};

export type DiscoverTaxiiCollectionsOutput = {
  __typename?: 'DiscoverTaxiiCollectionsOutput';
  collections: Array<DiscoveredTaxiiCollection>;
};

export type DiscoveredTaxiiCollection = {
  __typename?: 'DiscoveredTaxiiCollection';
  alias?: Maybe<Scalars['String']['output']>;
  collectionUrl: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type DraftSchema = {
  __typename?: 'DraftSchema';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  referenceURL: Scalars['String']['output'];
  spec: Scalars['String']['output'];
};

export type DuoConfig = {
  __typename?: 'DuoConfig';
  apiHostname: Scalars['String']['output'];
  integrationKey: Scalars['String']['output'];
  secretKey: Scalars['String']['output'];
};

export type DuoConfigInput = {
  apiHostname: Scalars['String']['input'];
  integrationKey: Scalars['String']['input'];
  secretKey: Scalars['String']['input'];
};

/** Input to edit an inference stream */
export type EditAIInferenceStreamInput = {
  /** If set, the stream will be deleted (soft delete, can be undone and by default is not is not in listings) */
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, the stream will be pinned */
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, the stream will be private and not visible to other users */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, the stream will be saved (never expires) */
  saved?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the stream to edit */
  streamId: Scalars['ID']['input'];
  /** If set, the name of the stream will be updated */
  streamName?: InputMaybe<Scalars['String']['input']>;
};

export type EmailConfig = {
  __typename?: 'EmailConfig';
  preferAttachment?: Maybe<Scalars['Boolean']['output']>;
  recipients?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sendEmpty?: Maybe<Scalars['Boolean']['output']>;
};

export type EmailConfigInput = {
  preferAttachment?: InputMaybe<Scalars['Boolean']['input']>;
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sendEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnrichmentIntegration = {
  __typename?: 'EnrichmentIntegration';
  config: EnrichmentIntegrationConfig;
  createdAtTime: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  enabled: Scalars['Boolean']['output'];
  enabledAt: Scalars['DateTime']['output'];
  health: EnrichmentIntegrationHealth;
  integrationId: Scalars['ID']['output'];
  integrationLabel: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
};

export type EnrichmentIntegrationConfig = {
  __typename?: 'EnrichmentIntegrationConfig';
  anomali?: Maybe<AnomaliConfig>;
  greynoise?: Maybe<GreyNoiseConfig>;
  gtiIoCStream?: Maybe<GtiIoCStreamConfig>;
  otx?: Maybe<OTXConfig>;
  taxii?: Maybe<TaxiiConfig>;
  virustotalIoCStream?: Maybe<VirusTotalIoCStreamConfig>;
};

export type EnrichmentIntegrationConfigInput = {
  anomali?: InputMaybe<AnomaliConfigInput>;
  greynoise?: InputMaybe<GreyNoiseConfigInput>;
  gtiIoCStream?: InputMaybe<GtiIoCStreamConfigInput>;
  otx?: InputMaybe<OTXConfigInput>;
  taxii?: InputMaybe<TaxiiConfigInput>;
  virustotalIoCStream?: InputMaybe<VirusTotalIoCStreamConfigInput>;
};

export type EnrichmentIntegrationHealth = {
  __typename?: 'EnrichmentIntegrationHealth';
  profilePullingStatus?: Maybe<IntegrationItemHealthStatus>;
};

/** Error type that can be returned by the API */
export type Error = {
  __typename?: 'Error';
  /** The error code that can be used to identify the error */
  code?: Maybe<ErrorCode>;
  /** A human-readable message that describes the error */
  message: Scalars['String']['output'];
};

/** The available error codes that can be returned by the API */
export enum ErrorCode {
  AlreadyExists = 'AlreadyExists',
  InUse = 'InUse',
  InvalidInput = 'InvalidInput',
  InvalidLogSchema = 'InvalidLogSchema',
  InvalidSyntax = 'InvalidSyntax',
  InvalidUpdate = 'InvalidUpdate',
  NotFound = 'NotFound',
  RevisionConflict = 'RevisionConflict',
  ServerError = 'ServerError',
}

export type EventBridgeConfig = {
  __typename?: 'EventBridgeConfig';
  busNames: Array<Scalars['String']['output']>;
  includeEventType: Scalars['Boolean']['output'];
};

export type EventBridgeIntegration = LogIntegration & {
  __typename?: 'EventBridgeIntegration';
  alarms: LogIntegrationAlarms;
  createdAtTime: Scalars['DateTime']['output'];
  createdBy?: Maybe<Actor>;
  eventbridgeConfig: EventBridgeConfig;
  filters: SourceFilters;
  health: EventBridgeIntegrationHealth;
  integrationId: Scalars['ID']['output'];
  integrationLabel: Scalars['String']['output'];
  integrationType: Scalars['String']['output'];
  isEditable: Scalars['Boolean']['output'];
  isHealthy: Scalars['Boolean']['output'];
  isPantherManaged: Scalars['Boolean']['output'];
  lastEventProcessedAtTime?: Maybe<Scalars['DateTime']['output']>;
  lastEventReceivedAtTime?: Maybe<Scalars['DateTime']['output']>;
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  logProviderId?: Maybe<Scalars['String']['output']>;
  logTypes: Array<Scalars['String']['output']>;
};

export type EventBridgeIntegrationHealth = {
  __typename?: 'EventBridgeIntegrationHealth';
  classificationFailuresStatus?: Maybe<IntegrationItemHealthStatus>;
  eventBridgeStatus?: Maybe<IntegrationItemHealthStatus>;
  logProcessingErrorsStatus?: Maybe<IntegrationItemHealthStatus>;
  systemAlarmStatus?: Maybe<IntegrationItemHealthStatus>;
};

export type EventFilter = {
  __typename?: 'EventFilter';
  description: Scalars['String']['output'];
  expression: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  logType: Scalars['String']['output'];
  mode: FilterMode;
};

export type EventFilterInput = {
  description: Scalars['String']['input'];
  expression: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
  logType: Scalars['String']['input'];
  mode: FilterMode;
};

export type EventThresholdAlarm = {
  __typename?: 'EventThresholdAlarm';
  minutesThreshold: Scalars['Int']['output'];
};

export type EventThresholdAlarmInput = {
  integrationId: Scalars['ID']['input'];
  minutesThreshold: Scalars['Int']['input'];
};

export type EventbridgeOptions = {
  __typename?: 'EventbridgeOptions';
  hasMultipleBuses: Scalars['Boolean']['output'];
  includeEventType: Scalars['Boolean']['output'];
};

/** The input to a data lake query execution */
export type ExecuteDataLakeQueryInput = {
  /**
   * The name of the database that the query should be executed against. This is optional you prefix all tables with
   * their corresponding database names in your SQL queries. Defaults to `panther_logs`
   */
  databaseName?: InputMaybe<Scalars['String']['input']>;
  queryName?: InputMaybe<Scalars['String']['input']>;
  /** The SQL code of the data lake query */
  sql: Scalars['String']['input'];
};

/** The return value of a data lake query execution request */
export type ExecuteDataLakeQueryOutput = {
  __typename?: 'ExecuteDataLakeQueryOutput';
  /** The ID of the data lake sql query that started executing */
  id: Scalars['ID']['output'];
};

/** The input to the indicator search query */
export type ExecuteIndicatorSearchQueryInput = {
  /** The databases to search (if empty all databases will be searched) */
  databases?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The end of the indicator search period */
  endTime: Scalars['DateTime']['input'];
  /** The type of the indicator to search for */
  indicatorName?: InputMaybe<IndicatorType>;
  /** An array of indicators to search for */
  indicators: Array<Scalars['String']['input']>;
  /** The start of the indicator search period */
  startTime: Scalars['DateTime']['input'];
  /** The tables to search (if empty all tables will be searched) */
  tables?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The return value of a data lake indicator search query execution request */
export type ExecuteIndicatorSearchQueryOutput = {
  __typename?: 'ExecuteIndicatorSearchQueryOutput';
  /** The ID of the indicator search query that started executing */
  id: Scalars['ID']['output'];
};

/** The input to the execute simple search query */
export type ExecuteSimpleSearchQueryInput = {
  params?: InputMaybe<FilterInput>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  type?: SimpleSearchQueryType;
};

/** The return value of the simple search query execution request */
export type ExecuteSimpleSearchQueryOutput = {
  __typename?: 'ExecuteSimpleSearchQueryOutput';
  /** The ID of the query getting the logs for the query */
  logsQueryID: Scalars['ID']['output'];
};

/** The input to the execute uber search */
export type ExecuteUberSearchInput = {
  copyUserConfigQueryId?: InputMaybe<Scalars['ID']['input']>;
  params: FilterInput;
};

/** The return value of the uber search execution request */
export type ExecuteUberSearchOutput = {
  __typename?: 'ExecuteUberSearchOutput';
  annotations?: Maybe<Annotations>;
  /** The ID of the query getting the results */
  queryID: Scalars['ID']['output'];
};

export type ExecuteUberSearchPropertySummaryInput = {
  limit?: Scalars['Int']['input'];
  parentQueryId: Scalars['ID']['input'];
  propertyId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<DataLakeQuerySortDirection>;
};

export type ExecuteUberSearchPropertySummaryOutput = {
  __typename?: 'ExecuteUberSearchPropertySummaryOutput';
  queryId: Scalars['ID']['output'];
  status: DataLakeQueryStatus;
};

export type ExpelWebhookConfig = {
  __typename?: 'ExpelWebhookConfig';
  webhookPassword: Scalars['String']['output'];
  webhookURL: Scalars['String']['output'];
  webhookUsername: Scalars['String']['output'];
};

export type ExpelWebhookConfigInput = {
  webhookPassword: Scalars['String']['input'];
  webhookURL: Scalars['String']['input'];
  webhookUsername: Scalars['String']['input'];
};

/** A feature flag name with its treatment */
export type FeatureFlagTreatment = {
  __typename?: 'FeatureFlagTreatment';
  /** The feature flag name */
  flag: Scalars['String']['output'];
  /** The treatment for the flag, with 'on' being true and 'off' or otherwise being false */
  treatment: Scalars['Boolean']['output'];
};

/** Feature flag name with a default treatment */
export type FeatureFlagWithDefault = {
  /**
   * The default treatment to use for the flag if the treatment is unavailable,
   * with 'on' being true and 'off' or otherwise being false. If no default is given,
   * a default default of 'off' will be used
   */
  defaultTreatment?: InputMaybe<Scalars['Boolean']['input']>;
  /** The feature flag name */
  flag: Scalars['String']['input'];
};

export type FilterField = {
  __typename?: 'FilterField';
  description: Scalars['String']['output'];
  isPantherManaged: Scalars['Boolean']['output'];
  logType: Scalars['String']['output'];
  target: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type FilterFieldsInput = {
  logTypes: Array<Scalars['String']['input']>;
};

export type FilterFieldsOutput = {
  __typename?: 'FilterFieldsOutput';
  filtersByLogType: Array<GroupedFilterField>;
  pantherManaged: Array<FilterField>;
  shared: Array<FilterField>;
};

/** FilterInput is a simple search filter. */
export type FilterInput = {
  databases?: InputMaybe<Array<Scalars['String']['input']>>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  lookbackTimeInSeconds?: InputMaybe<Scalars['Int']['input']>;
  parameters?: InputMaybe<Array<Parameter>>;
  relativeTime?: InputMaybe<Scalars['RelativeTimeDuration']['input']>;
  sortDir?: InputMaybe<DataLakeQuerySortDirection>;
  source?: InputMaybe<SimpleSearchSource>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  tables?: InputMaybe<Array<Scalars['String']['input']>>;
  timeColumn?: InputMaybe<Scalars['String']['input']>;
};

export enum FilterMode {
  Exclusion = 'exclusion',
  Inclusion = 'inclusion',
}

export enum FilterType {
  Contains = 'contains',
  Regex = 'regex',
}

export type FlatFilterFieldsInput = {
  logTypes: Array<Scalars['String']['input']>;
  showUnsafeTypes?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlatFilterFieldsOutput = {
  __typename?: 'FlatFilterFieldsOutput';
  flatFields: Array<FilterField>;
};

export type GcpPubSubConfig = {
  __typename?: 'GcpPubSubConfig';
  credentials: Scalars['String']['output'];
  credentialsType: Scalars['String']['output'];
  enforcedRegionalEndpoint?: Maybe<Scalars['String']['output']>;
  logTypes: Array<Scalars['String']['output']>;
  projectId: Scalars['String']['output'];
  subscriptionId: Scalars['String']['output'];
  userEmail: Scalars['String']['output'];
};

export type GcpPubSubDestinationConfig = {
  __typename?: 'GcpPubSubDestinationConfig';
  credentials: Scalars['String']['output'];
  credentialsType: Scalars['String']['output'];
  projectId: Scalars['String']['output'];
  topicId: Scalars['String']['output'];
};

export type GcpPubSubDestinationConfigInput = {
  credentials: Scalars['String']['input'];
  credentialsType: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  topicId: Scalars['String']['input'];
};

export type GcpPubSubLogConfigInput = {
  credentials: Scalars['String']['input'];
  credentialsType: Scalars['String']['input'];
  enforcedRegionalEndpoint?: InputMaybe<Scalars['String']['input']>;
  logTypes: Array<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
};

export type GcpPubSubLogIntegrationHealth = {
  __typename?: 'GcpPubSubLogIntegrationHealth';
  classificationFailuresStatus?: Maybe<IntegrationItemHealthStatus>;
  gcpPubSubStatus?: Maybe<IntegrationItemHealthStatus>;
  logProcessingErrorsStatus?: Maybe<IntegrationItemHealthStatus>;
  systemAlarmStatus?: Maybe<IntegrationItemHealthStatus>;
};

export type GcpPubSubLogSourceIntegration = LogIntegration & {
  __typename?: 'GcpPubSubLogSourceIntegration';
  alarms: LogIntegrationAlarms;
  createdAtTime: Scalars['DateTime']['output'];
  createdBy?: Maybe<Actor>;
  filters: SourceFilters;
  gcpPubSubConfig: GcpPubSubConfig;
  health: GcpPubSubLogIntegrationHealth;
  integrationId: Scalars['ID']['output'];
  integrationLabel: Scalars['String']['output'];
  integrationType: Scalars['String']['output'];
  isEditable: Scalars['Boolean']['output'];
  isHealthy: Scalars['Boolean']['output'];
  isPantherManaged: Scalars['Boolean']['output'];
  lastEventProcessedAtTime?: Maybe<Scalars['DateTime']['output']>;
  lastEventReceivedAtTime?: Maybe<Scalars['DateTime']['output']>;
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  logProviderId?: Maybe<Scalars['String']['output']>;
  logStreamType?: Maybe<LogStreamType>;
  logStreamTypeOptions?: Maybe<LogStreamTypeOptions>;
  logTypes: Array<Scalars['String']['output']>;
};

export type GcsConfig = {
  __typename?: 'GcsConfig';
  credentials: Scalars['String']['output'];
  credentialsType: Scalars['String']['output'];
  gcsBucket: Scalars['String']['output'];
  prefixLogTypes: Array<S3PrefixLogTypes>;
  projectId: Scalars['String']['output'];
  subscriptionId: Scalars['String']['output'];
  userEmail: Scalars['String']['output'];
};

export type GcsLogConfigInput = {
  credentials: Scalars['String']['input'];
  credentialsType: Scalars['String']['input'];
  gcsBucket: Scalars['String']['input'];
  prefixLogTypes: Array<S3PrefixLogTypesInput>;
  projectId: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
};

export type GcsLogIntegrationHealth = {
  __typename?: 'GcsLogIntegrationHealth';
  classificationFailuresStatus?: Maybe<IntegrationItemHealthStatus>;
  gcsStatus?: Maybe<IntegrationItemHealthStatus>;
  logProcessingErrorsStatus?: Maybe<IntegrationItemHealthStatus>;
  systemAlarmStatus?: Maybe<IntegrationItemHealthStatus>;
};

export type GcsLogSourceIntegration = LogIntegration & {
  __typename?: 'GcsLogSourceIntegration';
  alarms: LogIntegrationAlarms;
  createdAtTime: Scalars['DateTime']['output'];
  createdBy?: Maybe<Actor>;
  filters: SourceFilters;
  gcsConfig: GcsConfig;
  health: GcsLogIntegrationHealth;
  integrationId: Scalars['ID']['output'];
  integrationLabel: Scalars['String']['output'];
  integrationType: Scalars['String']['output'];
  isEditable: Scalars['Boolean']['output'];
  isHealthy: Scalars['Boolean']['output'];
  isPantherManaged: Scalars['Boolean']['output'];
  lastEventProcessedAtTime?: Maybe<Scalars['DateTime']['output']>;
  lastEventReceivedAtTime?: Maybe<Scalars['DateTime']['output']>;
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  logProviderId?: Maybe<Scalars['String']['output']>;
  logStreamType?: Maybe<LogStreamType>;
  logStreamTypeOptions?: Maybe<LogStreamTypeOptions>;
  logTypes: Array<Scalars['String']['output']>;
};

/** General Panther configuration settings */
export type GeneralSettingsConfig = {
  __typename?: 'GeneralSettingsConfig';
  analyticsConsent?: Maybe<Scalars['Boolean']['output']>;
  databricksRoleArn?: Maybe<Scalars['String']['output']>;
  deltaAdminRoleArn?: Maybe<Scalars['String']['output']>;
  deltaControllerRoleArn?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  infrastructureInfo?: Maybe<InfrastructureInfo>;
  licenseAccepted?: Maybe<Scalars['Boolean']['output']>;
  lookupTableQueryExportS3Path?: Maybe<Scalars['String']['output']>;
  lookupTablesLambdaRoleArn?: Maybe<Scalars['String']['output']>;
  pantherAIAutoResolve?: Maybe<PantherAIAutoResolveConfig>;
  pantherAIAutoRunOnAlert?: Maybe<PantherAIAutoRunOnAlertConfig>;
  pantherAICustomerPrompt?: Maybe<Scalars['String']['output']>;
  pantherAIEnabled?: Maybe<Scalars['Boolean']['output']>;
  pantherAIKendra?: Maybe<PantherAIKendraConfig>;
  pantherAIRemoteMcp?: Maybe<PantherAIRemoteMCPConfig>;
  pantherAIWebTool?: Maybe<PantherAIWebToolConfig>;
  /** The currently deployed version of Panther */
  pantherVersion?: Maybe<Scalars['String']['output']>;
  processedDataBucket?: Maybe<Scalars['String']['output']>;
  publicAPIRootDomain?: Maybe<Scalars['String']['output']>;
  publicGraphqlAPIEndpoint?: Maybe<Scalars['String']['output']>;
  publicRestAPIEndpoint?: Maybe<Scalars['String']['output']>;
  publicScimAPIEndpoint?: Maybe<Scalars['String']['output']>;
  publicWebhookAPIEndpoint?: Maybe<Scalars['String']['output']>;
  scheduledQueriesRequireLimitClause?: Maybe<Scalars['Boolean']['output']>;
  shouldEmailAlertAssignees?: Maybe<Scalars['Boolean']['output']>;
  snowflakeAdminLambdaRoleArn?: Maybe<Scalars['String']['output']>;
  snowflakeReadonlyLambdaRoleArn?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Timezone>;
  usesPAT?: Maybe<Scalars['Boolean']['output']>;
};

export type GenerateAlertSummaryAttributesQueriesInput = {
  alertId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * The input to the `generateEnrichedEvent` query. The `event` is a single
 * JSON-format Log Event.
 */
export type GenerateEnrichedEventInput = {
  event: Scalars['JSON']['input'];
};

/**
 * The response of the `generateEnrichedEvent` query. The `enrichedEvent` is
 * a single JSON-format Log Event, with the added enriched field (e.g. p_enrichment).s
 */
export type GenerateEnrichedEventResponse = {
  __typename?: 'GenerateEnrichedEventResponse';
  enrichedEvent: Scalars['JSON']['output'];
};

export type GenerateLogForwarderConfigInput = {
  input: LogForwarderInputConfigInput;
  integrationId: Scalars['ID']['input'];
};

export type GenerateS3SampleUploadInput = {
  sessionId?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateS3SampleUploadResponse = {
  __typename?: 'GenerateS3SampleUploadResponse';
  sessionId: Scalars['String']['output'];
  uploadURL: Scalars['String']['output'];
};

export type GenerateSchemaFromSqlInput = {
  sql: Scalars['String']['input'];
};

export type GenerateSchemaFromSqlJob = Job & {
  __typename?: 'GenerateSchemaFromSqlJob';
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  spec?: Maybe<Scalars['String']['output']>;
  status: JobStatus;
};

/** The input to the generate a simple search query but not execute it */
export type GenerateSimpleSearchQueryInput = {
  params?: InputMaybe<FilterInput>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  type?: SimpleSearchQueryType;
};

/** The return value for generating but not executing a simple search query. */
export type GenerateSimpleSearchQueryOutput = {
  __typename?: 'GenerateSimpleSearchQueryOutput';
  /** The raw sql string of the query that will be generated by the simple search input. */
  sql: Scalars['String']['output'];
};

export type GenerateSqlQuerySnippetInput = {
  queryParameters: Scalars['JSON']['input'];
  queryType: Scalars['String']['input'];
};

export type GenerateSqlQuerySnippetOutput = {
  __typename?: 'GenerateSqlQuerySnippetOutput';
  sqlQuery: Scalars['String']['output'];
};

export type GenerateUberSearchQueryInput = {
  filter: Scalars['String']['input'];
  inputQuery: Scalars['String']['input'];
  inputQueryLanguage: Scalars['String']['input'];
  operation: Scalars['String']['input'];
};

export type GenerateUberSearchQueryOutput = {
  __typename?: 'GenerateUberSearchQueryOutput';
  query: Scalars['String']['output'];
};

export type GenericGitConfig = {
  __typename?: 'GenericGitConfig';
  universalGitConfig: UniversalGitConfig;
};

export type GenericPullerAuthentication = {
  __typename?: 'GenericPullerAuthentication';
  strategy: APIAuthType;
};

export type GenericPullerAuthenticationInput = {
  strategy: APIAuthType;
};

export type GenericPullerConfig = {
  __typename?: 'GenericPullerConfig';
  pullerParams: Scalars['JSON']['output'];
  pullerStrategyConfig: GenericPullerStrategyConfig;
};

export type GenericPullerConfigInput = {
  logProviderId?: InputMaybe<Scalars['String']['input']>;
  pullerParams: Scalars['JSON']['input'];
  pullerStrategyConfig: GenericPullerStrategyConfigInput;
};

export type GenericPullerExpectedParam = {
  __typename?: 'GenericPullerExpectedParam';
  isSensitive: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
};

export type GenericPullerExpectedParamInput = {
  isSensitive: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
};

export type GenericPullerGeneralSettings = {
  __typename?: 'GenericPullerGeneralSettings';
  /** Time window the puller will query when backfilling */
  backfillPeriod: GenericPullerTimeUnit;
  /** Delay between each query */
  delay: GenericPullerTimeUnit;
  /** Max time window the puller will query */
  maxQueryWindow: GenericPullerTimeUnit;
  /** Min time window the puller will query */
  minQueryWindow?: Maybe<GenericPullerTimeUnit>;
  /** Time format to be used when specifying start and end time in API request */
  timeFormat: TimeFormat;
};

export type GenericPullerGeneralSettingsInput = {
  backfillPeriod: GenericPullerTimeUnitInput;
  delay: GenericPullerTimeUnitInput;
  maxQueryWindow: GenericPullerTimeUnitInput;
  minQueryWindow?: InputMaybe<GenericPullerTimeUnitInput>;
  timeFormat: TimeFormat;
};

export type GenericPullerPagination = {
  __typename?: 'GenericPullerPagination';
  settings?: Maybe<GenericPullerPaginationSettings>;
  strategy: APIPaginationStrategy;
};

export type GenericPullerPaginationInput = {
  settings?: InputMaybe<GenericPullerPaginationSettingsInput>;
  strategy: APIPaginationStrategy;
};

export type GenericPullerPaginationSettings = {
  __typename?: 'GenericPullerPaginationSettings';
  /** Number of items per page (used when calculating next offset) */
  pageSize: Scalars['Int']['output'];
};

export type GenericPullerPaginationSettingsInput = {
  pageSize: Scalars['Int']['input'];
};

export type GenericPullerResponseParsing = {
  __typename?: 'GenericPullerResponseParsing';
  /** Path to the pagination value (e.g. next link, token) in the response */
  paginationPath: Array<Scalars['String']['output']>;
  /** Path to the result value (e.g. list of items) in the response */
  resultPaths: Array<Array<Scalars['String']['output']>>;
};

export type GenericPullerResponseParsingInput = {
  paginationPath: Array<Scalars['String']['input']>;
  resultPaths: Array<Array<Scalars['String']['input']>>;
};

export type GenericPullerStrategyConfig = {
  __typename?: 'GenericPullerStrategyConfig';
  authentication: GenericPullerAuthentication;
  expectedParams?: Maybe<Array<GenericPullerExpectedParam>>;
  generalSettings: GenericPullerGeneralSettings;
  headers?: Maybe<Scalars['JSON']['output']>;
  pagination: GenericPullerPagination;
  queryStringParams?: Maybe<Scalars['JSON']['output']>;
  responseParsing: GenericPullerResponseParsing;
  url: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GenericPullerStrategyConfigInput = {
  authentication: GenericPullerAuthenticationInput;
  expectedParams?: InputMaybe<Array<GenericPullerExpectedParamInput>>;
  generalSettings: GenericPullerGeneralSettingsInput;
  headers?: InputMaybe<Scalars['JSON']['input']>;
  pagination: GenericPullerPaginationInput;
  queryStringParams?: InputMaybe<Scalars['JSON']['input']>;
  responseParsing: GenericPullerResponseParsingInput;
  url: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type GenericPullerTimeUnit = {
  __typename?: 'GenericPullerTimeUnit';
  unit: TimeUnit;
  value: Scalars['Int']['output'];
};

export type GenericPullerTimeUnitInput = {
  unit: TimeUnit;
  value: Scalars['Int']['input'];
};

export type GetAPITokenOutput = {
  __typename?: 'GetAPITokenOutput';
  error?: Maybe<Error>;
  token?: Maybe<APIToken>;
};

export type GetAlertEventsInput = {
  exclusiveStartKey?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type GetAsyncQueryDownloadUrlInput = {
  /** If present, emit just these columns in this order. */
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
};

export type GetAsyncQueryDownloadUrlOutput = {
  __typename?: 'GetAsyncQueryDownloadUrlOutput';
  error?: Maybe<Error>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GetAvailableLogProviderResponse = {
  __typename?: 'GetAvailableLogProviderResponse';
  error?: Maybe<Error>;
  result?: Maybe<AvailableLogProvider>;
};

export type GetCloudWatchLogIntegrationTemplateInput = {
  cloudwatchFilter?: InputMaybe<Scalars['String']['input']>;
  cloudwatchLogGroup: Scalars['String']['input'];
  integrationLabel: Scalars['String']['input'];
  managedBucketNotifications: Scalars['Boolean']['input'];
};

export type GetComplianceIntegrationTemplateInput = {
  integrationLabel: Scalars['String']['input'];
};

export type GetCorrelationRuleInput = {
  id: Scalars['ID']['input'];
  versionId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetDetectionInput = {
  id: Scalars['ID']['input'];
  versionId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetDetectionResponse = {
  __typename?: 'GetDetectionResponse';
  detection: InternalDetection;
};

/** The input to get the treatments for feature flags */
export type GetFeatureFlagsInput = {
  /** The set of feature flag names and default treatments */
  flags: Array<FeatureFlagWithDefault>;
};

/** The feature flags response */
export type GetFeatureFlagsResponse = {
  __typename?: 'GetFeatureFlagsResponse';
  /**
   * A map of the feature flag names given in the input to their states value. Values will be booleans
   * with 'on' being true and 'off' being false
   */
  flags: Array<FeatureFlagTreatment>;
};

export type GetGlobalHelperInput = {
  id: Scalars['ID']['input'];
  versionId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetLookupCloudFormationRoleTemplateInput = {
  integrationLabel: Scalars['String']['input'];
  kmsKey?: InputMaybe<Scalars['String']['input']>;
  s3FileLocation: Scalars['String']['input'];
};

export type GetPolicyInput = {
  id: Scalars['ID']['input'];
  versionId?: InputMaybe<Scalars['ID']['input']>;
};

/** The input to the `bulkUploadPresignedUrl` query. The `pypantherVersion` is the version of the PyPanther client. */
export type GetPresignedUploadURLInput = {
  pypantherVersion: Scalars['String']['input'];
};

export type GetRelatedAlertsInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type GetResourceInput = {
  resourceId: Scalars['ID']['input'];
};

export type GetRuleInput = {
  id: Scalars['ID']['input'];
  versionId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetRuleV2Input = {
  id: Scalars['ID']['input'];
};

export type GetS3LogIntegrationTemplateInput = {
  integrationLabel: Scalars['String']['input'];
  kmsKey?: InputMaybe<Scalars['String']['input']>;
  managedBucketNotifications: Scalars['Boolean']['input'];
  s3Bucket: Scalars['String']['input'];
};

export type GetSampleDataInput = {
  sessionId: Scalars['String']['input'];
  streamType?: InputMaybe<LogStreamType>;
};

export type GetSampleDataResponse = {
  __typename?: 'GetSampleDataResponse';
  data: Array<Scalars['String']['output']>;
  error?: Maybe<Error>;
  total: Scalars['Int']['output'];
};

export type GetSchemaInput = {
  clone?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

/** The response of the 'getSchema' query */
export type GetSchemaOutput = {
  __typename?: 'GetSchemaOutput';
  /** Error related to the schema */
  error?: Maybe<Error>;
  /** Schema metadata */
  schema?: Maybe<Schema>;
};

export type GetTerraformTemplateInput = {
  integrationLabel: Scalars['String']['input'];
  integrationType: Scalars['String']['input'];
};

export type GitHubAppConfig = {
  __typename?: 'GitHubAppConfig';
  installationID?: Maybe<Scalars['String']['output']>;
  organization: Scalars['String']['output'];
  readBranch: Scalars['String']['output'];
  repository: Scalars['String']['output'];
  universalGitConfig: UniversalGitConfig;
};

export enum GithubAuthorizationMethodEnum {
  Oauth2 = 'OAUTH2',
  Pat = 'PAT',
}

export type GithubConfig = {
  __typename?: 'GithubConfig';
  repoName: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type GithubConfigInput = {
  repoName: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type GithubLogSourceConfig = {
  __typename?: 'GithubLogSourceConfig';
  authorizationMethod: GithubAuthorizationMethodEnum;
  credentials: GithubLogSourceCredentialsConfig;
  organization: Scalars['String']['output'];
};

export type GithubLogSourceCredentialsConfig =
  | GithubLogSourceOAuth2Config
  | GithubLogSourcePatConfig;

export type GithubLogSourceInput = {
  authorizationMethod: GithubAuthorizationMethodEnum;
  oauth2Credentials?: InputMaybe<GithubOAuth2ConfigInput>;
  organization: Scalars['String']['input'];
  patCredentials?: InputMaybe<GithubPatConfigInput>;
};

export type GithubLogSourceOAuth2Config = {
  __typename?: 'GithubLogSourceOAuth2Config';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
};

export type GithubLogSourcePatConfig = {
  __typename?: 'GithubLogSourcePatConfig';
  personalAccessToken: Scalars['String']['output'];
};

export type GithubOAuth2ConfigInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
};

export type GithubPatConfigInput = {
  personalAccessToken: Scalars['String']['input'];
};

export type GlobalHelper = {
  __typename?: 'GlobalHelper';
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastModified: Scalars['DateTime']['output'];
  managed?: Maybe<Scalars['Boolean']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
};

export type GrantMcpServerAccessInput = {
  serverId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type GreyNoiseConfig = {
  __typename?: 'GreyNoiseConfig';
  apiKey: Scalars['String']['output'];
  profilePullers: GreyNoiseProfilePullerConfig;
};

export type GreyNoiseConfigInput = {
  apiKey: Scalars['String']['input'];
  profilePullers: GreyNoiseProfilePullerConfigInput;
};

export type GreyNoiseProfilePullerConfig = {
  __typename?: 'GreyNoiseProfilePullerConfig';
  noise: ProfilePullerConfig;
};

export type GreyNoiseProfilePullerConfigInput = {
  noise: ProfilePullerConfigInput;
};

export type GroupedFilterField = {
  __typename?: 'GroupedFilterField';
  filters: Array<FilterField>;
  logType: Scalars['String']['output'];
};

export enum GsuiteAuthorizationMethodEnum {
  Oauth = 'OAUTH',
  ServiceAccount = 'SERVICE_ACCOUNT',
  WorkloadIdentityFederation = 'WORKLOAD_IDENTITY_FEDERATION',
}

export type GsuiteConfig = {
  __typename?: 'GsuiteConfig';
  applications: Array<Scalars['String']['output']>;
  authorizationMethod: GsuiteAuthorizationMethodEnum;
  credentials: GsuiteCredentialsConfig;
  profilePullers?: Maybe<GsuiteProfilePullerConfig>;
};

export type GsuiteConfigInput = {
  applications: Array<Scalars['String']['input']>;
  authorizationMethod: GsuiteAuthorizationMethodEnum;
  oauth2Credentials?: InputMaybe<GsuiteOAuth2ConfigInput>;
  profilePullers?: InputMaybe<GsuiteProfilePullerConfigInput>;
  serviceAccountCredentials?: InputMaybe<GsuiteServiceAccountConfigInput>;
  workloadIdentityFederationCredentials?: InputMaybe<GsuiteWorkloadIdentityFederationConfigInput>;
};

export type GsuiteCredentialsConfig =
  | GsuiteOAuth2Config
  | GsuiteServiceAccountConfig
  | GsuiteWorkloadIdentityFederationConfig;

export type GsuiteOAuth2Config = {
  __typename?: 'GsuiteOAuth2Config';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
};

export type GsuiteOAuth2ConfigInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
};

export type GsuiteProfilePullerConfig = {
  __typename?: 'GsuiteProfilePullerConfig';
  users?: Maybe<ProfilePullerConfig>;
};

export type GsuiteProfilePullerConfigInput = {
  users?: InputMaybe<ProfilePullerConfigInput>;
};

export type GsuiteServiceAccountConfig = {
  __typename?: 'GsuiteServiceAccountConfig';
  adminUserEmail: Scalars['String']['output'];
  credentials: Scalars['String']['output'];
};

export type GsuiteServiceAccountConfigInput = {
  adminUserEmail: Scalars['String']['input'];
  credentials: Scalars['String']['input'];
};

export type GsuiteWorkloadIdentityFederationConfig = {
  __typename?: 'GsuiteWorkloadIdentityFederationConfig';
  adminUserEmail: Scalars['String']['output'];
  credentials: Scalars['String']['output'];
};

export type GsuiteWorkloadIdentityFederationConfigInput = {
  adminUserEmail: Scalars['String']['input'];
  credentials: Scalars['String']['input'];
};

export type GtiIoCStreamConfig = {
  __typename?: 'GtiIoCStreamConfig';
  apiKey: Scalars['String']['output'];
  maxAgeDays?: Maybe<Scalars['Int']['output']>;
  profilePullers: GtiIoCStreamProfilePullerConfig;
};

export type GtiIoCStreamConfigInput = {
  apiKey: Scalars['String']['input'];
  maxAgeDays?: InputMaybe<Scalars['Int']['input']>;
  profilePullers: GtiIoCStreamProfilePullerConfigInput;
};

export type GtiIoCStreamProfilePullerConfig = {
  __typename?: 'GtiIoCStreamProfilePullerConfig';
  iocStream: ProfilePullerConfig;
};

export type GtiIoCStreamProfilePullerConfigInput = {
  iocStream: ProfilePullerConfigInput;
};

export type HoldingTankFilters = {
  __typename?: 'HoldingTankFilters';
  contains?: Maybe<Scalars['String']['output']>;
  excludedPrefixes?: Maybe<Array<Scalars['String']['output']>>;
  from?: Maybe<Scalars['DateTime']['output']>;
  s3Prefix?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
};

export type HoldingTankFiltersInput = {
  contains?: InputMaybe<Scalars['String']['input']>;
  excludedPrefixes?: InputMaybe<Array<Scalars['String']['input']>>;
  from: Scalars['DateTime']['input'];
  s3Prefix?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};

export type HoldingTankGetRunningTaskInput = {
  sourceId: Scalars['String']['input'];
};

export type HoldingTankInferJob = Job & {
  __typename?: 'HoldingTankInferJob';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  inferParameters: HoldingTankInferJobParams;
  message?: Maybe<Scalars['String']['output']>;
  schemaInferenceResult?: Maybe<HoldingTankSchemaInferenceResult>;
  stats?: Maybe<HoldingTankJobStats>;
  status: JobStatus;
  taskType: Scalars['String']['output'];
};

export type HoldingTankInferJobParams = {
  __typename?: 'HoldingTankInferJobParams';
  batchId?: Maybe<Scalars['String']['output']>;
  filters: HoldingTankFilters;
  schemaName: Scalars['String']['output'];
  streamType: LogStreamType;
  useSourceBucket?: Maybe<Scalars['Boolean']['output']>;
};

export type HoldingTankInferSchemaInput = {
  filters: HoldingTankFiltersInput;
  schemaName: Scalars['String']['input'];
  sourceId: Scalars['String']['input'];
  streamType: LogStreamType;
};

export type HoldingTankJobStats = {
  __typename?: 'HoldingTankJobStats';
  elapsedTimeSeconds: Scalars['Int']['output'];
  totalEventsProcessed: Scalars['Int']['output'];
  totalSizeBytes: Scalars['Int']['output'];
};

export type HoldingTankListTasksResponse = {
  __typename?: 'HoldingTankListTasksResponse';
  tasks: Array<Job>;
};

export type HoldingTankLogTypeTestStats = {
  __typename?: 'HoldingTankLogTypeTestStats';
  logType: Scalars['String']['output'];
  matched: Scalars['Int']['output'];
};

export type HoldingTankRawDataInput = {
  filters: HoldingTankFiltersInput;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paginationToken?: InputMaybe<Scalars['String']['input']>;
  sourceId: Scalars['String']['input'];
  streamType?: InputMaybe<LogStreamType>;
};

export type HoldingTankRawDataResponse = {
  __typename?: 'HoldingTankRawDataResponse';
  data: Array<HoldingTankRawEvent>;
  pageInfo: PageInfo;
};

export type HoldingTankRawEvent = {
  __typename?: 'HoldingTankRawEvent';
  error?: Maybe<Scalars['String']['output']>;
  event: Scalars['String']['output'];
  isJson: Scalars['Boolean']['output'];
  s3Key: Scalars['String']['output'];
};

export type HoldingTankResults = {
  __typename?: 'HoldingTankResults';
  error?: Maybe<Scalars['String']['output']>;
  event: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
};

export type HoldingTankSchemaInferenceResult = {
  __typename?: 'HoldingTankSchemaInferenceResult';
  error?: Maybe<Scalars['String']['output']>;
  spec?: Maybe<Scalars['String']['output']>;
};

export type HoldingTankTestJob = Job & {
  __typename?: 'HoldingTankTestJob';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Actor>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  stats?: Maybe<HoldingTankJobStats>;
  status: JobStatus;
  taskType: Scalars['String']['output'];
  testParameters: HoldingTankTestJobParams;
  testResults?: Maybe<Array<HoldingTankTestJobPrefixStats>>;
};

export type HoldingTankTestJobParams = {
  __typename?: 'HoldingTankTestJobParams';
  filters: DateRange;
  newSchemas?: Maybe<Array<DraftSchema>>;
  s3PrefixLogTypes: Array<S3PrefixLogTypes>;
  streamType: LogStreamType;
};

export type HoldingTankTestJobPrefixStats = {
  __typename?: 'HoldingTankTestJobPrefixStats';
  errored: Scalars['Int']['output'];
  logTypeMatches: Array<HoldingTankLogTypeTestStats>;
  prefix: Scalars['String']['output'];
  unmatched: Scalars['Int']['output'];
};

export type HoldingTankTestSchemasResultInput = {
  logType: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paginationToken?: InputMaybe<Scalars['String']['input']>;
  prefix: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};

export type HoldingTankTestSchemasResultsResponse = {
  __typename?: 'HoldingTankTestSchemasResultsResponse';
  pageInfo: PageInfo;
  results: Array<HoldingTankResults>;
};

export type HttpConfig = {
  __typename?: 'HttpConfig';
  logProcessingRole?: Maybe<Scalars['String']['output']>;
  logStreamType: LogStreamType;
  logStreamTypeOptions?: Maybe<LogStreamTypeOptions>;
  queueUrl: Scalars['String']['output'];
  s3Bucket: Scalars['String']['output'];
  s3Prefix?: Maybe<Scalars['String']['output']>;
  securityAlg?: Maybe<HttpHMACDigestAlgType>;
  securityHeaderKey?: Maybe<Scalars['String']['output']>;
  securityPassword?: Maybe<Scalars['String']['output']>;
  securitySecretValue?: Maybe<Scalars['String']['output']>;
  securityType: HttpSecurityType;
  securityUsername?: Maybe<Scalars['String']['output']>;
};

export enum HttpHMACDigestAlgType {
  Sha1 = 'SHA1',
  Sha256 = 'SHA256',
}

export type HttpLogConfigInput = {
  logStreamType: LogStreamType;
  logStreamTypeOptions?: InputMaybe<LogStreamTypeOptionsInput>;
  logTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  securityAlg?: InputMaybe<HttpHMACDigestAlgType>;
  securityHeaderKey?: InputMaybe<Scalars['String']['input']>;
  securityPassword?: InputMaybe<Scalars['String']['input']>;
  securitySecretValue?: InputMaybe<Scalars['String']['input']>;
  securityType: HttpSecurityType;
  securityUsername?: InputMaybe<Scalars['String']['input']>;
};

export type HttpLogIntegrationHealth = {
  __typename?: 'HttpLogIntegrationHealth';
  classificationFailuresStatus?: Maybe<IntegrationItemHealthStatus>;
  httpStatus?: Maybe<IntegrationItemHealthStatus>;
  logProcessingErrorsStatus?: Maybe<IntegrationItemHealthStatus>;
  systemAlarmStatus?: Maybe<IntegrationItemHealthStatus>;
};

export type HttpLogSourceIntegration = LogIntegration & {
  __typename?: 'HttpLogSourceIntegration';
  alarms: LogIntegrationAlarms;
  createdAtTime: Scalars['DateTime']['output'];
  createdBy?: Maybe<Actor>;
  filters: SourceFilters;
  health: HttpLogIntegrationHealth;
  httpConfig: HttpConfig;
  integrationId: Scalars['ID']['output'];
  integrationLabel: Scalars['String']['output'];
  integrationType: Scalars['String']['output'];
  isEditable: Scalars['Boolean']['output'];
  isHealthy: Scalars['Boolean']['output'];
  isPantherManaged: Scalars['Boolean']['output'];
  lastEventProcessedAtTime?: Maybe<Scalars['DateTime']['output']>;
  lastEventReceivedAtTime?: Maybe<Scalars['DateTime']['output']>;
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  logProviderId?: Maybe<Scalars['String']['output']>;
  logTypes: Array<Scalars['String']['output']>;
};

export type HttpOptions = {
  __typename?: 'HttpOptions';
  securityAlgorithms: Array<HttpHMACDigestAlgType>;
  securityHeaderKey?: Maybe<Scalars['String']['output']>;
  securityType?: Maybe<HttpSecurityType>;
};

export enum HttpSecurityType {
  Basic = 'Basic',
  Bearer = 'Bearer',
  Hmac = 'HMAC',
  None = 'None',
  SharedSecret = 'SharedSecret',
}

export type ImportLookupDataInput = {
  lookupId: Scalars['ID']['input'];
  s3UploadUrl: Scalars['String']['input'];
};

export type IncidentIoWebhookConfig = {
  __typename?: 'IncidentIoWebhookConfig';
  apiKey: Scalars['String']['output'];
  webhookURL: Scalars['String']['output'];
};

export type IncidentIoWebhookConfigInput = {
  apiKey: Scalars['String']['input'];
  webhookURL: Scalars['String']['input'];
};

/** The available indicator types used in an Indicator Search Query */
export enum IndicatorType {
  AutoDetectType = 'AutoDetectType',
  SimpleSearch = 'SimpleSearch',
  TextSearch = 'TextSearch',
  PAnyActorIds = 'p_any_actor_ids',
  PAnyAwsAccountIds = 'p_any_aws_account_ids',
  PAnyAwsArns = 'p_any_aws_arns',
  PAnyAwsInstanceIds = 'p_any_aws_instance_ids',
  PAnyAwsTags = 'p_any_aws_tags',
  PAnyCves = 'p_any_cves',
  PAnyDomainNames = 'p_any_domain_names',
  PAnyEmails = 'p_any_emails',
  PAnyIpAddresses = 'p_any_ip_addresses',
  PAnyMacAddresses = 'p_any_mac_addresses',
  PAnyMd5Hashes = 'p_any_md5_hashes',
  PAnyMitreAttackTechniques = 'p_any_mitre_attack_techniques',
  PAnySerialNumbers = 'p_any_serial_numbers',
  PAnySha1Hashes = 'p_any_sha1_hashes',
  PAnySha256Hashes = 'p_any_sha256_hashes',
  PAnyTraceIds = 'p_any_trace_ids',
  PAnyUsernames = 'p_any_usernames',
}

export type InferSchemaFromBucketDataFiltersInput = {
  excludedPrefixes?: InputMaybe<Array<Scalars['String']['input']>>;
  s3Prefix?: InputMaybe<Scalars['String']['input']>;
};

export type InferSchemaFromBucketDataInput = {
  batchId: Scalars['String']['input'];
  filters: InferSchemaFromBucketDataFiltersInput;
  schemaName: Scalars['String']['input'];
  sourceId: Scalars['String']['input'];
  streamType: Scalars['String']['input'];
};

export type InferSchemaFromSourceBucketInput = {
  excludedPrefixes?: InputMaybe<Array<Scalars['String']['input']>>;
  s3Prefix: Scalars['String']['input'];
  schemaName: Scalars['String']['input'];
};

export type InferSchemaInput = {
  sessionId: Scalars['String']['input'];
  streamType?: InputMaybe<LogStreamType>;
};

export type InferSchemaResponse = {
  __typename?: 'InferSchemaResponse';
  error?: Maybe<Error>;
  schema?: Maybe<Scalars['String']['output']>;
};

export type InfraCategoryCosts = {
  __typename?: 'InfraCategoryCosts';
  costs?: Maybe<Array<InfraDailyCost>>;
};

export type InfraCostInput = {
  /** End time to include in the infra cost report. this date is exclusive. */
  endTime: Scalars['DateTime']['input'];
  /** Start time to include in the infra cost report. costs are returned by day, so this date time is truncated to a daily interval */
  startTime: Scalars['DateTime']['input'];
};

export type InfraCostOutput = {
  __typename?: 'InfraCostOutput';
  ai?: Maybe<InfraCategoryCosts>;
  alerting?: Maybe<InfraCategoryCosts>;
  cloudScanning?: Maybe<InfraCategoryCosts>;
  datalake?: Maybe<InfraCategoryCosts>;
  detections?: Maybe<InfraCategoryCosts>;
  ingestion?: Maybe<InfraCategoryCosts>;
  internal?: Maybe<InfraCategoryCosts>;
};

export type InfraDailyCost = {
  __typename?: 'InfraDailyCost';
  amount?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['String']['output']>;
};

export type InfrastructureInfo = {
  __typename?: 'InfrastructureInfo';
  networking: NetworkingInfo;
  storage: StorageInfo;
};

export type IngestionMonitoringSummary = {
  __typename?: 'IngestionMonitoringSummary';
  /** The number of events that got processed */
  eventsProcessedMetric: Array<SeriesWithBreakdown>;
  /** The ingestion quota limit */
  ingestionQuotaLimit: Scalars['Long']['output'];
  /** The total bytes of filtered events */
  totalBytesFiltered: Scalars['Float']['output'];
  /** The total number of bytes that Panther processed */
  totalBytesProcessed: Scalars['Float']['output'];
  /** The total count of filtered events */
  totalEventsFiltered: Scalars['Float']['output'];
  /** The total number of events (logs) that got processed */
  totalEventsProcessed: Scalars['Float']['output'];
};

export type InitiateMcpAuthorizationInput = {
  serverId: Scalars['ID']['input'];
};

export type InstallCatalogDataModelOutput = {
  __typename?: 'InstallCatalogDataModelOutput';
  dataModel?: Maybe<CatalogDataModel>;
};

export type InstallCatalogDetectionOutput = {
  __typename?: 'InstallCatalogDetectionOutput';
  detection?: Maybe<CatalogDetection>;
};

export type InstallCatalogEnrichmentOutput = {
  __typename?: 'InstallCatalogEnrichmentOutput';
  enrichment?: Maybe<CatalogEnrichment>;
};

export type InstallCatalogGlobalHelperOutput = {
  __typename?: 'InstallCatalogGlobalHelperOutput';
  globalHelper?: Maybe<CatalogGlobalHelper>;
};

export type InstallCatalogQueryOutput = {
  __typename?: 'InstallCatalogQueryOutput';
  query?: Maybe<CatalogQuery>;
};

export type InstalledCatalogItem = {
  __typename?: 'InstalledCatalogItem';
  analysisType: AnalysisType;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type InstalledCatalogItemUpdateStatus = {
  __typename?: 'InstalledCatalogItemUpdateStatus';
  analysisType: AnalysisType;
  id: Scalars['ID']['output'];
  status: UpdateStatus;
};

export type IntegrationItemHealthStatus = {
  __typename?: 'IntegrationItemHealthStatus';
  healthy: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  rawErrorMessage?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SourceHealthTypesEnum>;
};

export type IntegrationTemplate = {
  __typename?: 'IntegrationTemplate';
  body: Scalars['String']['output'];
  stackName: Scalars['String']['output'];
};

export type InternalDetection = CorrelationRule | Policy | Rule;

/** The input to invite a new User */
export type InviteUserInput = {
  /** The email address of the User */
  email: Scalars['Email']['input'];
  /** The family/last name of the User */
  familyName: Scalars['String']['input'];
  /** The given/first name of the User */
  givenName: Scalars['String']['input'];
  messageAction?: InputMaybe<MessageActionEnum>;
  /** The ID or Name of the User's role */
  role: UserRoleInput;
};

/** The return value of the Invite User mutation */
export type InviteUserOutput = {
  __typename?: 'InviteUserOutput';
  /** The created Panther User object */
  user: User;
};

export type JiraAssignableUser = {
  __typename?: 'JiraAssignableUser';
  accountId?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type JiraConfig = {
  __typename?: 'JiraConfig';
  apiKey: Scalars['String']['output'];
  assigneeId?: Maybe<Scalars['String']['output']>;
  assigneeName?: Maybe<Scalars['String']['output']>;
  issueType: Scalars['String']['output'];
  labels: Array<Scalars['String']['output']>;
  orgDomain: Scalars['String']['output'];
  priority?: Maybe<Scalars['String']['output']>;
  projectKey: Scalars['String']['output'];
  pullAlertAssignee?: Maybe<Scalars['Boolean']['output']>;
  pullAlertComments?: Maybe<Scalars['Boolean']['output']>;
  pullAlertStatus?: Maybe<Scalars['Boolean']['output']>;
  severityBasedConfig?: Maybe<Array<Maybe<SeverityBasedJiraConfig>>>;
  statusMap?: Maybe<JiraStatusMap>;
  syncAlertAssignee: Scalars['Boolean']['output'];
  syncAlertComments: Scalars['Boolean']['output'];
  syncAlertStatus: Scalars['Boolean']['output'];
  useSeverityBasedConfig?: Maybe<Scalars['Boolean']['output']>;
  userName: Scalars['String']['output'];
};

export type JiraConfigInput = {
  apiKey: Scalars['String']['input'];
  assigneeId?: InputMaybe<Scalars['String']['input']>;
  assigneeName?: InputMaybe<Scalars['String']['input']>;
  issueType: Scalars['String']['input'];
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  orgDomain: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['String']['input']>;
  projectKey: Scalars['String']['input'];
  pullAlertAssignee?: InputMaybe<Scalars['Boolean']['input']>;
  pullAlertComments?: InputMaybe<Scalars['Boolean']['input']>;
  pullAlertStatus?: InputMaybe<Scalars['Boolean']['input']>;
  severityBasedConfig?: InputMaybe<Array<InputMaybe<SeverityBasedJiraConfigInput>>>;
  statusMap?: InputMaybe<JiraStatusMapInput>;
  syncAlertAssignee?: InputMaybe<Scalars['Boolean']['input']>;
  syncAlertComments?: InputMaybe<Scalars['Boolean']['input']>;
  syncAlertStatus?: InputMaybe<Scalars['Boolean']['input']>;
  useSeverityBasedConfig?: InputMaybe<Scalars['Boolean']['input']>;
  userName: Scalars['String']['input'];
};

export type JiraOrgMetadata = {
  __typename?: 'JiraOrgMetadata';
  assignableUsers?: Maybe<Array<Maybe<JiraAssignableUser>>>;
  labels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  priorities?: Maybe<Array<Maybe<JiraPriority>>>;
  transitions?: Maybe<Array<Maybe<JiraTransitionStatus>>>;
};

export type JiraOrgMetadataInput = {
  config: JiraConfigInput;
  outputId?: InputMaybe<Scalars['ID']['input']>;
};

export type JiraPriority = {
  __typename?: 'JiraPriority';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type JiraStatusMap = {
  __typename?: 'JiraStatusMap';
  closed: JiraTransitionStatus;
  open: JiraTransitionStatus;
  resolved: JiraTransitionStatus;
  triaged: JiraTransitionStatus;
};

export type JiraStatusMapInput = {
  closed: JiraStatusTransitionInput;
  open: JiraStatusTransitionInput;
  resolved: JiraStatusTransitionInput;
  triaged: JiraStatusTransitionInput;
};

export type JiraStatusTransitionInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type JiraTransitionStatus = {
  __typename?: 'JiraTransitionStatus';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** An async operation that can be polled for status updates */
export type Job = {
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  status: JobStatus;
};

/** Different execution statuses on an async job */
export enum JobStatus {
  /** The job was manually cancelled before it was able to finish. */
  Cancelled = 'Cancelled',
  /** The job failed to finish successfully. */
  Failed = 'Failed',
  /** The job has been started, and is currently running. */
  Running = 'Running',
  /** The job finished successfully. */
  Succeeded = 'Succeeded',
}

export type ListAPITokensOutput = {
  __typename?: 'ListAPITokensOutput';
  error?: Maybe<Error>;
  tokens: Array<APIToken>;
};

export type ListAlertContextTagsOutput = {
  __typename?: 'ListAlertContextTagsOutput';
  edges: Array<AlertContextTagEdge>;
  pageInfo: ListAlertContextTagsPageInfo;
};

export type ListAlertContextTagsPageInfo = {
  __typename?: 'ListAlertContextTagsPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ListAnalysisItemsForWorkbenchInput = {
  analysisTypes?: InputMaybe<Array<AnalysisType>>;
  nameOrDescContains?: InputMaybe<Scalars['String']['input']>;
};

export type ListAnalysisItemsForWorkbenchOutput = {
  __typename?: 'ListAnalysisItemsForWorkbenchOutput';
  items: Array<WorkbenchPickerItem>;
};

export type ListAnalysisPackSourcesInput = {
  nameContains?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortDir?: InputMaybe<SortDirEnum>;
};

export type ListAnalysisPackSourcesResponse = {
  __typename?: 'ListAnalysisPackSourcesResponse';
  packs: Array<AnalysisPackSource>;
  paging: PagingData;
};

export type ListAnalysisPacksInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  logTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  mostRelevantLogTypes?: InputMaybe<Scalars['Boolean']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<SortDirEnum>;
  updateAvailable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListAnalysisPacksResponse = {
  __typename?: 'ListAnalysisPacksResponse';
  packs: Array<AnalysisPack>;
  paging: PagingData;
};

export type ListAvailableLogProvidersResponse = {
  __typename?: 'ListAvailableLogProvidersResponse';
  error?: Maybe<Error>;
  results?: Maybe<Array<AvailableLogProvider>>;
};

export type ListAvailableLogTypesResponse = {
  __typename?: 'ListAvailableLogTypesResponse';
  logTypes: Array<Scalars['String']['output']>;
};

export type ListBucketKeysInput = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paginationToken?: InputMaybe<Scalars['String']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  sourceId: Scalars['String']['input'];
};

export type ListBucketKeysResponse = {
  __typename?: 'ListBucketKeysResponse';
  commonPrefixes: Array<Scalars['String']['output']>;
  objects: Array<S3Object>;
  pageInfo: PageInfo;
};

export type ListCatalogDataModelsInput = {
  displayNameOrDescContains?: InputMaybe<Scalars['String']['input']>;
  logTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ListCatalogDataModelsOutput = {
  __typename?: 'ListCatalogDataModelsOutput';
  dataModels: Array<CatalogDataModel>;
};

export type ListCatalogDetectionsInput = {
  analysisTypes?: InputMaybe<Array<AnalysisType>>;
  dataSources?: InputMaybe<Array<Scalars['String']['input']>>;
  displayNameOrDescContains?: InputMaybe<Scalars['String']['input']>;
  severities?: InputMaybe<Array<Severity>>;
};

export type ListCatalogDetectionsOutput = {
  __typename?: 'ListCatalogDetectionsOutput';
  detections: Array<CatalogDetection>;
};

export type ListCatalogEnrichmentsInput = {
  logTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  nameOrDescContains?: InputMaybe<Scalars['String']['input']>;
};

export type ListCatalogEnrichmentsOutput = {
  __typename?: 'ListCatalogEnrichmentsOutput';
  enrichments: Array<CatalogEnrichment>;
};

export type ListCatalogGlobalHelpersInput = {
  idOrDescContains?: InputMaybe<Scalars['String']['input']>;
};

export type ListCatalogGlobalHelpersOutput = {
  __typename?: 'ListCatalogGlobalHelpersOutput';
  globalHelpers: Array<CatalogGlobalHelper>;
};

export type ListCatalogQueriesInput = {
  analysisTypes?: InputMaybe<Array<AnalysisType>>;
  queryNameOrDescContains?: InputMaybe<Scalars['String']['input']>;
};

export type ListCatalogQueriesOutput = {
  __typename?: 'ListCatalogQueriesOutput';
  queries: Array<CatalogQuery>;
};

export type ListComplianceItemsResponse = {
  __typename?: 'ListComplianceItemsResponse';
  items?: Maybe<Array<Maybe<ComplianceItem>>>;
  paging?: Maybe<PagingData>;
  status?: Maybe<ComplianceStatusEnum>;
  totals?: Maybe<ActiveSuppressCount>;
};

export type ListDataModelsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  logTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  packIds?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<ListDataModelsSortFieldsEnum>;
  sortDir?: InputMaybe<SortDirEnum>;
};

export type ListDataModelsResponse = {
  __typename?: 'ListDataModelsResponse';
  models: Array<DataModel>;
  paging: PagingData;
};

export enum ListDataModelsSortFieldsEnum {
  Enabled = 'enabled',
  Id = 'id',
  LastModified = 'lastModified',
  LogTypes = 'logTypes',
}

export type ListDetectionsInput = {
  analysisTypes?: InputMaybe<Array<DetectionType>>;
  complianceStatus?: InputMaybe<ComplianceStatusEnum>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  initialSet?: InputMaybe<Scalars['Boolean']['input']>;
  isSimpleDetection?: InputMaybe<Scalars['Boolean']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  logTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  packIds?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  resourceTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduledQueries?: InputMaybe<Array<Scalars['String']['input']>>;
  severity?: InputMaybe<Array<Severity>>;
  sortBy?: InputMaybe<ListDetectionsSortFieldsEnum>;
  sortDir?: InputMaybe<SortDirEnum>;
  specVersion?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ListDetectionsResponse = {
  __typename?: 'ListDetectionsResponse';
  detections: Array<InternalDetection>;
  paging: PagingData;
};

export enum ListDetectionsSortFieldsEnum {
  DisplayName = 'displayName',
  Enabled = 'enabled',
  Id = 'id',
  LastModified = 'lastModified',
  Severity = 'severity',
}

export type ListGitConfigsInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ListGitConfigsResponse = {
  __typename?: 'ListGitConfigsResponse';
  allGitConfigs?: Maybe<AllGitConfigs>;
  cursor?: Maybe<Scalars['String']['output']>;
};

export type ListGlobalHelpersInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  packIds?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortDir?: InputMaybe<SortDirEnum>;
};

export type ListGlobalHelpersResponse = {
  __typename?: 'ListGlobalHelpersResponse';
  globals?: Maybe<Array<Maybe<GlobalHelper>>>;
  paging?: Maybe<PagingData>;
};

export type ListInstalledCatalogItemUpdateStatusesInput = {
  analysisTypes?: InputMaybe<Array<AnalysisType>>;
  nameOrDescContains?: InputMaybe<Scalars['String']['input']>;
};

export type ListInstalledCatalogItemUpdateStatusesOutput = {
  __typename?: 'ListInstalledCatalogItemUpdateStatusesOutput';
  items: Array<InstalledCatalogItemUpdateStatus>;
};

export type ListInstalledCatalogItemsInput = {
  analysisTypes?: InputMaybe<Array<AnalysisType>>;
  nameOrDescContains?: InputMaybe<Scalars['String']['input']>;
};

export type ListInstalledCatalogItemsOutput = {
  __typename?: 'ListInstalledCatalogItemsOutput';
  items: Array<InstalledCatalogItem>;
};

export type ListLookupResponse = {
  __typename?: 'ListLookupResponse';
  lastEvaluatedKey?: Maybe<Scalars['String']['output']>;
  lookups: Array<Lookup>;
};

export type ListLookupsInput = {
  contains?: InputMaybe<Scalars['String']['input']>;
  exclusiveStartKey?: InputMaybe<Scalars['String']['input']>;
  importMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  managed?: InputMaybe<Scalars['Boolean']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type ListMcpServersInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type ListResourcesInput = {
  complianceStatus?: InputMaybe<ComplianceStatusEnum>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  idContains?: InputMaybe<Scalars['String']['input']>;
  integrationId?: InputMaybe<Scalars['ID']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<ListResourcesSortFieldsEnum>;
  sortDir?: InputMaybe<SortDirEnum>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ListResourcesResponse = {
  __typename?: 'ListResourcesResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  resources?: Maybe<Array<Maybe<ResourceSummary>>>;
};

export enum ListResourcesSortFieldsEnum {
  ComplianceStatus = 'complianceStatus',
  Id = 'id',
  LastModified = 'lastModified',
  Type = 'type',
}

export type ListSavedQueriesInput = {
  contains?: InputMaybe<Scalars['String']['input']>;
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  exclusiveStartKey?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  packIds?: InputMaybe<Array<Scalars['String']['input']>>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  queryKind?: InputMaybe<Array<Scalars['String']['input']>>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  sortDir?: InputMaybe<SortDirEnum>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type ListSavedQueriesResponse = {
  __typename?: 'ListSavedQueriesResponse';
  lastEvaluatedKey?: Maybe<Scalars['String']['output']>;
  savedQueries: Array<SavedQuery>;
};

/** Input for listing scheduled prompts */
export type ListScheduledPromptsInput = {
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  onlyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Paginated list of scheduled prompts */
export type ListScheduledPromptsResponse = {
  __typename?: 'ListScheduledPromptsResponse';
  edges: Array<ListScheduledPromptsResponseEdge>;
  /**
   * Whether any live shared (non-private) prompt exists tenant-wide, independent of the page
   * returned in `edges`. Shared prompts are visible to every caller, so a shared-only "download
   * all" produces something exactly when this is true. The download-all UI uses it to warn /
   * disable the shared-only export instead of guessing from the loaded (paginated) rows.
   */
  hasSharedPrompts: Scalars['Boolean']['output'];
  pageInfo: CursorBasedPaginationPageInfo;
};

/** Edge for ListScheduledPromptsResponse */
export type ListScheduledPromptsResponseEdge = {
  __typename?: 'ListScheduledPromptsResponseEdge';
  node: ScheduledPrompt;
};

export type LoadAnalysisItemForWorkbenchInput = {
  analysisType: AnalysisType;
  id: Scalars['ID']['input'];
};

export type LoadAnalysisItemForWorkbenchOutput = {
  __typename?: 'LoadAnalysisItemForWorkbenchOutput';
  analysisType: AnalysisType;
  baseVersion?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  latestVersion?: Maybe<Scalars['Int']['output']>;
  python?: Maybe<WorkbenchFile>;
  yaml: WorkbenchFile;
};

export type LogForwarderConfigYaml = {
  __typename?: 'LogForwarderConfigYaml';
  yaml: Scalars['String']['output'];
};

export type LogForwarderGeneratorInput = {
  __typename?: 'LogForwarderGeneratorInput';
  mode?: Maybe<LogForwarderSyslogMode>;
  path?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Scalars['Int']['output']>;
  type: LogForwarderInputType;
};

export type LogForwarderInputConfigInput = {
  mode?: InputMaybe<LogForwarderSyslogMode>;
  path?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  type: LogForwarderInputType;
};

export enum LogForwarderInputType {
  File = 'File',
  Syslog = 'Syslog',
}

export type LogForwarderLogConfigInput = {
  logStreamType?: InputMaybe<LogStreamType>;
  logStreamTypeOptions?: InputMaybe<LogStreamTypeOptionsInput>;
  logTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LogForwarderLogIntegrationHealth = {
  __typename?: 'LogForwarderLogIntegrationHealth';
  bucketNotificationsStatus?: Maybe<IntegrationItemHealthStatus>;
  classificationFailuresStatus?: Maybe<IntegrationItemHealthStatus>;
  logProcessingErrorsStatus?: Maybe<IntegrationItemHealthStatus>;
  managedS3IamUserStatus?: Maybe<IntegrationItemHealthStatus>;
  s3BucketStatus?: Maybe<IntegrationItemHealthStatus>;
  systemAlarmStatus?: Maybe<IntegrationItemHealthStatus>;
};

export type LogForwarderLogSourceIntegration = LogIntegration & {
  __typename?: 'LogForwarderLogSourceIntegration';
  alarms: LogIntegrationAlarms;
  createdAtTime: Scalars['DateTime']['output'];
  createdBy?: Maybe<Actor>;
  filters: SourceFilters;
  generatorInput?: Maybe<LogForwarderGeneratorInput>;
  health: LogForwarderLogIntegrationHealth;
  integrationId: Scalars['ID']['output'];
  integrationLabel: Scalars['String']['output'];
  integrationType: Scalars['String']['output'];
  isEditable: Scalars['Boolean']['output'];
  isHealthy: Scalars['Boolean']['output'];
  isPantherManaged: Scalars['Boolean']['output'];
  lastEventProcessedAtTime?: Maybe<Scalars['DateTime']['output']>;
  lastEventReceivedAtTime?: Maybe<Scalars['DateTime']['output']>;
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  logProviderId?: Maybe<Scalars['String']['output']>;
  logTypes: Array<Scalars['String']['output']>;
};

export enum LogForwarderSyslogMode {
  Tcp = 'TCP',
  Udp = 'UDP',
}

/** Represents a Log Source Integration */
export type LogIntegration = {
  alarms: LogIntegrationAlarms;
  /** The time the S3 Log Source was created */
  createdAtTime: Scalars['DateTime']['output'];
  /** The actor who created the S3 Log Source */
  createdBy?: Maybe<Actor>;
  /** The ID of the Log Source integration */
  integrationId: Scalars['ID']['output'];
  /** The name of the Log Source integration */
  integrationLabel: Scalars['String']['output'];
  /** The type of Log Source integration */
  integrationType: Scalars['String']['output'];
  /** True if the Log Source can be modified */
  isEditable: Scalars['Boolean']['output'];
  /** True if the Log Source is healthy */
  isHealthy: Scalars['Boolean']['output'];
  /** True if the Cloud Account is managed by Panther */
  isPantherManaged: Scalars['Boolean']['output'];
  /** The timestamp of the last event processed */
  lastEventProcessedAtTime?: Maybe<Scalars['DateTime']['output']>;
  /** The timestamp of the last event received */
  lastEventReceivedAtTime?: Maybe<Scalars['DateTime']['output']>;
  /** The time the log source was last modified */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** The log types being ingested */
  logTypes: Array<Scalars['String']['output']>;
};

export type LogIntegrationAlarms = {
  __typename?: 'LogIntegrationAlarms';
  eventThreshold?: Maybe<EventThresholdAlarm>;
};

export enum LogPullerTypeEnum {
  Anthropic = 'anthropic',
  Asana = 'asana',
  Atlassian = 'atlassian',
  Bitwarden = 'bitwarden',
  Box = 'box',
  CarbonblackAudit = 'carbonblackAudit',
  Crowdstrike = 'crowdstrike',
  CrowdstrikeEventStreams = 'crowdstrikeEventStreams',
  Dropbox = 'dropbox',
  Duo = 'duo',
  Generic = 'generic',
  Github = 'github',
  Gsuite = 'gsuite',
  M365 = 'm365',
  Microsoftgraph = 'microsoftgraph',
  Mongodb = 'mongodb',
  Netskope = 'netskope',
  Okta = 'okta',
  Onepassword = 'onepassword',
  Openai = 'openai',
  Proofpoint = 'proofpoint',
  Rapid7 = 'rapid7',
  Salesforce = 'salesforce',
  SentinelOneApi = 'sentinelOneApi',
  SentinelOneCloudFunnel = 'sentinelOneCloudFunnel',
  Slack = 'slack',
  Snowflakeaudit = 'snowflakeaudit',
  Snyk = 'snyk',
  Sysdig = 'sysdig',
  Tenable = 'tenable',
  Tines = 'tines',
  Wiz = 'wiz',
  Workday = 'workday',
  Zendesk = 'zendesk',
  Zoom = 'zoom',
}

export type LogPullingIntegration = LogIntegration & {
  __typename?: 'LogPullingIntegration';
  alarms: LogIntegrationAlarms;
  createdAtTime: Scalars['DateTime']['output'];
  createdBy?: Maybe<Actor>;
  filters: SourceFilters;
  health: LogPullingIntegrationHealth;
  integrationId: Scalars['ID']['output'];
  integrationLabel: Scalars['String']['output'];
  integrationType: Scalars['String']['output'];
  isEditable: Scalars['Boolean']['output'];
  isHealthy: Scalars['Boolean']['output'];
  isPantherManaged: Scalars['Boolean']['output'];
  lastEventProcessedAtTime?: Maybe<Scalars['DateTime']['output']>;
  lastEventReceivedAtTime?: Maybe<Scalars['DateTime']['output']>;
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  logProviderId?: Maybe<Scalars['String']['output']>;
  logTypes: Array<Scalars['String']['output']>;
  oauth2?: Maybe<OAuth2Info>;
  pullerConfig: PullerConfig;
  pullerType: LogPullerTypeEnum;
};

export type LogPullingIntegrationHealth = {
  __typename?: 'LogPullingIntegrationHealth';
  classificationFailuresStatus?: Maybe<IntegrationItemHealthStatus>;
  logProcessingErrorsStatus?: Maybe<IntegrationItemHealthStatus>;
  logPullingStatus?: Maybe<IntegrationItemHealthStatus>;
  systemAlarmStatus?: Maybe<IntegrationItemHealthStatus>;
};

export type LogPullingOptions = {
  __typename?: 'LogPullingOptions';
  credentialFormFields?: Maybe<Array<CredentialFormField>>;
  pullerStrategyConfig?: Maybe<GenericPullerStrategyConfig>;
};

/** SeriesWithBreakdown, broken down by log source */
export type LogSourceBreakdown = {
  __typename?: 'LogSourceBreakdown';
  /** The name of the Log Source for which the series breakdown is given */
  logSourceName: Scalars['String']['output'];
  /** The metric time series data */
  metricData: SeriesWithBreakdown;
};

/** Enum representation of Log Stream types */
export enum LogStreamType {
  Auto = 'Auto',
  CloudWatchLogs = 'CloudWatchLogs',
  Json = 'JSON',
  JsonArray = 'JsonArray',
  Lines = 'Lines',
  Xml = 'XML',
}

/** Options for the log stream type */
export type LogStreamTypeOptions = {
  __typename?: 'LogStreamTypeOptions';
  /**
   * Path to the array value to extract elements from, only applicable if logStreamType is JsonArray.
   * Leave empty if the input JSON is an array itself
   */
  jsonArrayEnvelopeField?: Maybe<Scalars['String']['output']>;
  /**
   * When enabled, envelope metadata from CloudWatch Logs is preserved
   * in a p_header column on each unpacked event.
   */
  retainEnvelopeFields?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The root element name for XML streams, only applicable if logStreamType is XML.
   * Leave empty if the XML events are not enclosed in a root element
   */
  xmlRootElement?: Maybe<Scalars['String']['output']>;
};

/** Input for the LogStreamTypeOptions */
export type LogStreamTypeOptionsInput = {
  /**
   * Path to the array value to extract elements from, only applicable if logStreamType is JsonArray.
   * Leave empty if the input JSON is an array itself
   */
  jsonArrayEnvelopeField?: InputMaybe<Scalars['String']['input']>;
  /**
   * When enabled, envelope metadata from CloudWatch Logs is preserved
   * in a p_header column on each unpacked event.
   */
  retainEnvelopeFields?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The root element name for XML streams, only applicable if logStreamType is XML.
   * Leave empty if the XML events are not enclosed in a root element
   */
  xmlRootElement?: InputMaybe<Scalars['String']['input']>;
};

/** The supported types for log types access management */
export enum LogTypeAccessKind {
  /** Allow access to selected log types */
  Allow = 'ALLOW',
  /** Allow access to all log types */
  AllowAll = 'ALLOW_ALL',
  /** Deny access to the selected log types */
  Deny = 'DENY',
  /** Deny access to all log types */
  DenyAll = 'DENY_ALL',
}

export type LogTypeAlertsBySeverity = {
  __typename?: 'LogTypeAlertsBySeverity';
  alertsBySeverity: AlertsBySeverity;
  name: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type LogTypeMapInput = {
  associatedLogTypes: Array<AssociatedLogTypeInput>;
  primaryKey: Scalars['String']['input'];
};

export type Lookup = {
  __typename?: 'Lookup';
  activeVersion?: Maybe<LookupVersion>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  integration?: Maybe<LookupIntegration>;
  lastModifiedAt: Scalars['DateTime']['output'];
  lastModifiedBy: Scalars['ID']['output'];
  /** Whether the lookup table is provided out-of-the-box by Panther or set up by the customer. */
  managed: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  packIds?: Maybe<Array<Scalars['String']['output']>>;
  reference: Scalars['String']['output'];
  /** Sending a `null` refresh value will remove any existing refresh settings. */
  refresh?: Maybe<LookupRefreshConfig>;
  /** Configuration for scheduled query-based lookup tables. */
  scheduledQuery?: Maybe<LookupScheduledQueryConfig>;
};

export type LookupEnrichHit = {
  __typename?: 'LookupEnrichHit';
  jsonValue: Scalars['String']['output'];
  logType: Scalars['String']['output'];
  lookupTableName: Scalars['String']['output'];
};

export type LookupEnrichOutput = {
  __typename?: 'LookupEnrichOutput';
  hits?: Maybe<Array<LookupEnrichHit>>;
  key: Scalars['String']['output'];
};

export type LookupImportDataJob = Job & {
  __typename?: 'LookupImportDataJob';
  /** In the import lookup job, the `id` for polling will be the execution ARN of the step function. */
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  stats?: Maybe<LookupImportDataJobStats>;
  status: JobStatus;
};

export type LookupImportDataJobStats = {
  __typename?: 'LookupImportDataJobStats';
  skipped: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LookupIntegration = EnrichmentIntegration | LogPullingIntegration;

/**
 * Configuration about how the lookup table refreshes data from an S3 object or a GCS object, if the
 * lookup table is configured to import data from the cloud storage
 */
export type LookupRefreshConfig = {
  __typename?: 'LookupRefreshConfig';
  alarmPeriodMinutes?: Maybe<Scalars['Int']['output']>;
  gcsCredentials?: Maybe<Scalars['String']['output']>;
  objectKMSKey?: Maybe<Scalars['String']['output']>;
  objectPath: Scalars['String']['output'];
  periodMinutes: Scalars['Int']['output'];
  roleARN?: Maybe<Scalars['String']['output']>;
  storageProvider?: Maybe<StorageProvider>;
};

export type LookupRefreshConfigInput = {
  alarmPeriodMinutes?: InputMaybe<Scalars['Int']['input']>;
  gcsCredentials?: InputMaybe<Scalars['String']['input']>;
  objectKMSKey?: InputMaybe<Scalars['String']['input']>;
  objectPath: Scalars['String']['input'];
  periodMinutes: Scalars['Int']['input'];
  roleARN?: InputMaybe<Scalars['String']['input']>;
  storageProvider?: InputMaybe<StorageProvider>;
};

export type LookupS3ImportConfig = {
  __typename?: 'LookupS3ImportConfig';
  url: Scalars['String']['output'];
};

export type LookupS3ImportConfigInput = {
  lookupId: Scalars['ID']['input'];
};

/** Configuration for scheduled query-based lookup tables */
export type LookupScheduledQueryConfig = {
  __typename?: 'LookupScheduledQueryConfig';
  cronExpression?: Maybe<Scalars['String']['output']>;
  periodMinutes?: Maybe<Scalars['Int']['output']>;
  schemaSpec: Scalars['String']['output'];
  sqlQuery: Scalars['String']['output'];
};

export type LookupScheduledQueryConfigInput = {
  cronExpression?: InputMaybe<Scalars['String']['input']>;
  periodMinutes?: InputMaybe<Scalars['Int']['input']>;
  schemaSpec: Scalars['String']['input'];
  sqlQuery: Scalars['String']['input'];
};

export type LookupSchemaInput = {
  logType: Scalars['String']['input'];
};

export type LookupStats = {
  __typename?: 'LookupStats';
  disabledCount: Scalars['Int']['output'];
  enabledCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type LookupSyncJob = Job & {
  __typename?: 'LookupSyncJob';
  /** In the import lookup job, the `id` for polling will be the execution ARN of the step function. */
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  stats?: Maybe<LookupSyncJobStats>;
  status: JobStatus;
};

export type LookupSyncJobStats = {
  __typename?: 'LookupSyncJobStats';
  skipped: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LookupVersion = {
  __typename?: 'LookupVersion';
  associatedLogTypes: Array<AssociatedLogType>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  erroredAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  logType?: Maybe<Scalars['String']['output']>;
  lookupId?: Maybe<Scalars['ID']['output']>;
  objectPath?: Maybe<Scalars['String']['output']>;
  primaryKey: Scalars['String']['output'];
  refreshedAt?: Maybe<Scalars['DateTime']['output']>;
  rowCount?: Maybe<Scalars['Int']['output']>;
  version: Scalars['Int']['output'];
};

export type M365Config = {
  __typename?: 'M365Config';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  subscriptionPlan?: Maybe<Scalars['String']['output']>;
  tenantDomain?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
};

export type M365ConfigInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  subscriptionPlan?: InputMaybe<Scalars['String']['input']>;
  tenantDomain?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

export type MarkAllNotificationsAsReadInput = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type MarkAllNotificationsAsReadOutput = {
  __typename?: 'MarkAllNotificationsAsReadOutput';
  notifications: Array<Notification>;
};

export type MarkNotificationAsReadInput = {
  id: Scalars['String']['input'];
};

export type MatchedLog = {
  __typename?: 'MatchedLog';
  event: Scalars['String']['output'];
  raw: Scalars['String']['output'];
};

/** Authentication type for an MCP server. */
export enum McpAuthType {
  AwsSigv4 = 'AWS_SIGV4',
  Oauth2 = 'OAUTH2',
}

export type McpAuthorizationResponse = {
  __typename?: 'McpAuthorizationResponse';
  authorizationUrl: Scalars['String']['output'];
};

/** Health status of an MCP server connection. */
export enum McpConnectionStatus {
  /** OAuth token is expired or revoked. */
  AuthError = 'AUTH_ERROR',
  /** ListTools succeeded - server is reachable and tokens are valid. */
  Healthy = 'HEALTHY',
  /** OAuth flow initiated but not yet completed - no access token. */
  Pending = 'PENDING',
  /** HTTP or connection error - server is unreachable. */
  Unreachable = 'UNREACHABLE',
}

/** Result of testing the connection to an MCP server. */
export type McpConnectionTestResult = {
  __typename?: 'McpConnectionTestResult';
  message?: Maybe<Scalars['String']['output']>;
  status: McpConnectionStatus;
  toolCount: Scalars['Int']['output'];
};

export enum McpRegistrationMode {
  ClientIdMetadata = 'CLIENT_ID_METADATA',
  Dcr = 'DCR',
  Manual = 'MANUAL',
}

/** An MCP server configuration for extending Panther AI capabilities. */
export type McpServer = {
  __typename?: 'McpServer';
  authType: McpAuthType;
  awsRoleArn?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Actor>;
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastModifiedBy?: Maybe<Actor>;
  name: Scalars['String']['output'];
  oauthClientId?: Maybe<Scalars['String']['output']>;
  oauthTokenUrl?: Maybe<Scalars['String']['output']>;
  registrationMode: McpRegistrationMode;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  /** The current user's connection to this server. */
  userConnection?: Maybe<McpUserConnection>;
};

/** Discovery result for an MCP server's OAuth metadata. */
export type McpServerDiscovery = {
  __typename?: 'McpServerDiscovery';
  /**
   * The OAuth redirect URL for this Panther instance.
   * Users must register this URL in their OAuth app settings when using custom credentials.
   */
  mcpOAuthRedirectUrl: Scalars['String']['output'];
  requiresManualCredentials: Scalars['Boolean']['output'];
  resourceName?: Maybe<Scalars['String']['output']>;
};

/** Paginated result for listing MCP servers. */
export type McpServersOutput = {
  __typename?: 'McpServersOutput';
  edges: Array<McpServersOutputEdge>;
  pageInfo: CursorBasedPaginationPageInfo;
};

/** The edge shape of the McpServer type. */
export type McpServersOutputEdge = {
  __typename?: 'McpServersOutputEdge';
  node: McpServer;
};

/** A tool discovered from an MCP server with user's settings merged. */
export type McpTool = {
  __typename?: 'McpTool';
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  isNew: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  readOnly: Scalars['Boolean']['output'];
  requiresApproval: Scalars['Boolean']['output'];
};

export type McpToolSettingInput = {
  enabled: Scalars['Boolean']['input'];
  requiresApproval: Scalars['Boolean']['input'];
  toolName: Scalars['String']['input'];
};

/**
 * A user's connection to an MCP server.
 * Contains connection metadata, health status, and discovered tools.
 */
export type McpUserConnection = {
  __typename?: 'McpUserConnection';
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
  externalUserEmail?: Maybe<Scalars['String']['output']>;
  externalUserId?: Maybe<Scalars['String']['output']>;
  grantedScopes: Array<Scalars['String']['output']>;
  isConnected: Scalars['Boolean']['output'];
  /** Health status from the most recent ListTools call. */
  status: McpConnectionStatus;
  tokenExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Tools discovered from the MCP server with user's settings merged.
   * Populated by calling ListTools on the MCP server using the user's token.
   */
  tools: Array<McpTool>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum MessageActionEnum {
  Resend = 'RESEND',
  Suppress = 'SUPPRESS',
}

/** The input to the `metrics` query */
export type MetricsInput = {
  /** The start date for the metrics evaluation */
  fromDate: Scalars['DateTime']['input'];
  /**
   * The interval between metric checks. Used for plotting charts.
   * Leave empty for automatic interval
   */
  intervalInMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** The end date for the metrics evaluation */
  toDate: Scalars['DateTime']['input'];
};

/** The output to the `metrics` query */
export type MetricsOutput = {
  __typename?: 'MetricsOutput';
  /** The number of alerts corresponding to each rule */
  alertsPerRule?: Maybe<Array<SeriesWithEntityID>>;
  /** The number of alerts corresponding to each severity */
  alertsPerSeverity: Array<SeriesWithBreakdown>;
  /** The number of alerts corresponding to each alert type */
  alertsPerType: Array<SeriesWithBreakdown>;
  /** The bytes filtered for all log sources */
  bytesFiltered: Array<SeriesWithBreakdown>;
  /** The number of bytes that Panther ingested over the past year, for each individual log type */
  bytesIngestedPerSource?: Maybe<Array<Series>>;
  /**
   * The number of bytes that Panther ingested over the queried time period, for each individual log type
   * This metric may not be accurate when there are significant numbers of log sources.
   * In this case prefer the bytesProcessedTotal metric
   */
  bytesProcessedPerSource: Array<SeriesWithBreakdown>;
  /**
   * The total number of bytes that Panther processed over the queried time period as a time series. Unlike
   * `bytesProcessedPerSource`, this is not broken down per log type.
   */
  bytesProcessedTotal: Array<SeriesWithBreakdown>;
  /** The number of bytes that got queried via Panther for each individual source */
  bytesQueriedPerSource: Array<SeriesWithBreakdown>;
  /** The total number of correlation rules, both enabled and disabled */
  correlationRulesCount: Scalars['Float']['output'];
  /** The number of currently disabled correlation rules */
  correlationRulesDisabledCount: Scalars['Float']['output'];
  /** The number of currently enabled correlation rules */
  correlationRulesEnabledCount: Scalars['Float']['output'];
  /** The number of matches per lookup table during enrichment */
  enrichmentMatchCount: Array<SeriesWithBreakdown>;
  /** The events filtered for all log sources */
  eventsFiltered: Array<SeriesWithBreakdown>;
  /** The number of events that got processed for each log type */
  eventsProcessedPerLogType: Array<SeriesWithBreakdown>;
  /** The start date for the metrics evaluation */
  fromDate: Scalars['DateTime']['output'];
  /** The bytes processed per log source */
  ingestionPerLogSource: Array<LogSourceBreakdown>;
  /** The interval between metric checks. Used for plotting charts */
  intervalInMinutes: Scalars['Int']['output'];
  /** The latency related to each log type */
  latencyPerLogType?: Maybe<Array<Series>>;
  /** The total number of policies, both enabled and disabled */
  policiesCount: Scalars['Float']['output'];
  /** The number of currently disabled policies */
  policiesDisabledCount: Scalars['Float']['output'];
  /** The number of currently enabled policies */
  policiesEnabledCount: Scalars['Float']['output'];
  /** The total number of rules, both enabled and disabled */
  rulesCount: Scalars['Float']['output'];
  /** The number of currently disabled rules */
  rulesDisabledCount: Scalars['Float']['output'];
  /** The number of currently enabled rules */
  rulesEnabledCount: Scalars['Float']['output'];
  /** The number of rules enabled per each log type */
  rulesEnabledPerLogType: Array<Series>;
  /** The total number of scheduled rules, both enabled and disabled */
  scheduledRulesCount: Scalars['Float']['output'];
  /** The number of currently disabled scheduled rules */
  scheduledRulesDisabledCount: Scalars['Float']['output'];
  /** The number of currently enabled scheduled rules */
  scheduledRulesEnabledCount: Scalars['Float']['output'];
  /** The end date for the metrics evaluation */
  toDate: Scalars['DateTime']['output'];
  /** The total number of alerts */
  totalAlerts: Scalars['Float']['output'];
  totalAlertsDiff: Scalars['Float']['output'];
  /** The total number of bytes filtered for all log sources */
  totalBytesFiltered: Scalars['Float']['output'];
  /** The total number of bytes that Panther ingested over the past year */
  totalBytesIngested: Scalars['Float']['output'];
  /** The total number of bytes that Panther ingested over the queried time period */
  totalBytesProcessed: Scalars['Float']['output'];
  /** The total number of bytes that got queried via Panther */
  totalBytesQueried: Scalars['Float']['output'];
  /** The total number of events filtered for all log sources */
  totalEventsFiltered: Scalars['Float']['output'];
  /** The total number of events (logs) that got processed */
  totalEventsProcessed: Scalars['Float']['output'];
};

export type MicrosoftGraphConfig = {
  __typename?: 'MicrosoftGraphConfig';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  subscriptionPlan?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
};

export type MicrosoftGraphConfigInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  subscriptionPlan?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

export type MindflowWebhookConfig = {
  __typename?: 'MindflowWebhookConfig';
  webhookURL: Scalars['String']['output'];
};

export type MindflowWebhookConfigInput = {
  webhookURL: Scalars['String']['input'];
};

export type MitreCombo = {
  __typename?: 'MitreCombo';
  tactic: MitreTactic;
  technique: MitreTechnique;
};

export type MitreMatrix = {
  __typename?: 'MitreMatrix';
  content: MitreMatrixContent;
  id: Scalars['ID']['output'];
  mappings: Array<MitreMatrixTacticMapping>;
  name: Scalars['String']['output'];
  reportSettings: Array<ReportSetting>;
};

export type MitreMatrixContent = {
  __typename?: 'MitreMatrixContent';
  tactics: Array<MitreTactic>;
  techniques: Array<MitreTechnique>;
};

export type MitreMatrixTacticMapping = {
  __typename?: 'MitreMatrixTacticMapping';
  tacticId: Scalars['ID']['output'];
  techniqueIds: Array<Scalars['ID']['output']>;
};

export type MitreMatrixTree = {
  __typename?: 'MitreMatrixTree';
  defaultMatrixId: Scalars['String']['output'];
  enabledLogTypes: Array<Scalars['String']['output']>;
  matrices: Array<MitreMatrixTreeNode>;
  mitreVersion: Scalars['String']['output'];
  mitreVersionUrl: Scalars['String']['output'];
};

export type MitreMatrixTreeNode = {
  __typename?: 'MitreMatrixTreeNode';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  submatrices: Array<MitreMatrixTreeNode>;
};

export type MitreReportEntry = {
  __typename?: 'MitreReportEntry';
  tactic: NamedMitreAttack;
  technique: NamedMitreAttack;
};

export type MitreTactic = {
  __typename?: 'MitreTactic';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type MitreTechnique = {
  __typename?: 'MitreTechnique';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ModifyGlobalHelperInput = {
  body: Scalars['String']['input'];
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  managed?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type MongoDBConfig = {
  __typename?: 'MongoDBConfig';
  orgId: Scalars['String']['output'];
  privateKey: Scalars['String']['output'];
  publicKey: Scalars['String']['output'];
};

export type MongoDBConfigInput = {
  orgId: Scalars['String']['input'];
  privateKey: Scalars['String']['input'];
  publicKey: Scalars['String']['input'];
};

export type MsTeamsConfig = {
  __typename?: 'MsTeamsConfig';
  webhookURL: Scalars['String']['output'];
};

export type MsTeamsConfigInput = {
  webhookURL: Scalars['String']['input'];
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type Mutation = {
  __typename?: 'Mutation';
  addAnalysisPackSource: AnalysisPackSource;
  addDataModel: DataModel;
  addDestination?: Maybe<Destination>;
  /** Enrichment integrations are used to enrich data by pulling data from external sources. */
  addEnrichmentIntegration: EnrichmentIntegration;
  addGlobalHelper: GlobalHelper;
  addLogSource: LogIntegration;
  addLookup: Lookup;
  addLookupAsync: SaveLookupJob;
  addPolicy?: Maybe<Policy>;
  addRule?: Maybe<Rule>;
  addRuleV2?: Maybe<AddRuleV2Output>;
  addSavedQuery: SavedQuery;
  /** Starts AI detection authoring with iterative testing */
  aiAuthorDetection: AIInferenceStream;
  /** Starts AI-assisted organization profile authoring */
  aiAuthorOrganizationProfile: AIInferenceStream;
  /**
   * Starts AI runbook co-authoring for a detection. Drafting only — the returned spec is
   * reviewed by the user and persisted through the ordinary detection save. Gated on
   * detection read (not write): previewing a draft requires no more than seeing the
   * detection; the existing write permissions still gate the actual save.
   */
  aiAuthorRunbook: AIInferenceStream;
  /** Starts AI skill authoring with iterative refinement */
  aiAuthorSkill: AIInferenceStream;
  /** Generates PantherFlow queries from natural language descriptions */
  aiGeneratePantherFlowQuery: AIInferenceStream;
  /** Authors SQL queries from natural language descriptions */
  aiGenerateSqlQuery: AIInferenceStream;
  /** Starts a detection rule replay inference in the background writing to inference stream, returns immediately */
  aiReplayDetection: AIInferenceStream;
  aiResolveAnalysisItemMergeConflicts: AIInferenceStream;
  /** Starts inference in the background writing to inference stream, returns immediately */
  aiSchemaInference: AIInferenceStream;
  /** Starts an alert analysis inference in the background writing to inference stream, returns immediately */
  aiSummarizeAlert: AIInferenceStream;
  /** Starts a detection analysis inference in the background writing to inference stream, returns immediately */
  aiSummarizeDetection: AIInferenceStream;
  /** Starts a log events analysis inference in the background writing to inference stream, returns immediately */
  aiSummarizeLogEvents: AIInferenceStream;
  /** Starts a query results analysis inference in the background writing to inference stream, returns immediately */
  aiSummarizeQueryResults: AIInferenceStream;
  /**
   * Approve a remote MCP OAuth authorization request, granting the requested permissions.
   * Returns the redirect URL to send the user back to the requesting application.
   * `@auth(permissions: [])` is intentional — any authenticated user may complete their
   * own flow. See the self-service mutation pattern in internal/core/graph_api/CLAUDE.md.
   */
  approveRemoteMcpAuthorization: ApproveRemoteMcpAuthorizationResult;
  batchInferJobs: BatchInferJobsOutput;
  bulkUpdateDetections?: Maybe<BulkUpdateDetectionsResponse>;
  /** Starts a job to bulk upload detection entities from a valid session ID */
  bulkUploadDetections: BulkUploadJob;
  /**
   * Cancels a running AI inference stream. The next per-fragment write from the
   * inference Lambda will fail its conditional check and unwind cleanly,
   * stopping the upstream model call. Idempotent: repeated calls are safe.
   */
  cancelAIInferenceStream: AIInferenceStream;
  cancelDashboardQueries: CancelDashboardOutput;
  /** Cancels a data lake or indicator search query that's currently running */
  cancelDataLakeQuery: CancelDataLakeQueryOutput;
  cancelHoldingTankJob: Job;
  /** Cancels an uber search */
  cancelUberSearch: CancelDataLakeQueryOutput;
  /**
   * Complete OAuth authorization after the user is redirected back.
   * Exchanges the authorization code for tokens and stores the connection.
   * Returns true if authorization completed successfully.
   */
  completeMcpAuthorization: Scalars['Boolean']['output'];
  /** Continues an existing AI conversation with a new message */
  continueAIConversation: ContinueAIConversationOutput;
  /** Creates a new AI conversation and optionally sends the first message */
  createAIConversation: CreateAIConversationOutput;
  /** Creates a new custom AI skill */
  createAISkill: CreateAISkillOutput;
  createAPIToken: CreateAPITokenOutput;
  /** Creates a comment on an Alert */
  createAlertComment: CreateAlertCommentOutput;
  createAzureBlobSource: CreateAzureBlobSourceOutput;
  /** Creates a Cloud Account */
  createCloudAccount: CreateCloudAccountOutput;
  createDashboard: Dashboard;
  createDetectionFilter: CreateDetectionFilterOutput;
  createGitHubAppConfig?: Maybe<CreateGitHubAppConfigResponse>;
  createGitHubAppRegistrationUrl?: Maybe<CreateGitHubAppRegistrationUrlResponse>;
  /**
   * Create a new MCP server configuration.
   * Runs discovery automatically. If manual credentials are required,
   * oauthClientId and oauthClientSecret must be provided.
   */
  createMcpServer: McpServer;
  createOrUpdateSchema: CreateOrUpdateSchemaOutput;
  createPerfTest: CreateReplayOutput;
  createPullRequestForCatalogDataModelInstall?: Maybe<CreatePullRequestResponse>;
  createPullRequestForCatalogGlobalHelperInstall?: Maybe<CreatePullRequestResponse>;
  createPullRequestForCatalogInstall?: Maybe<CreatePullRequestResponse>;
  createPullRequestForCatalogSavedQueryInstall?: Maybe<CreatePullRequestResponse>;
  createPullRequestForCorrelationRuleEdit?: Maybe<CreatePullRequestResponse>;
  createPullRequestForDataModelDeletion?: Maybe<CreatePullRequestResponse>;
  createPullRequestForDataModelEdit?: Maybe<CreatePullRequestResponse>;
  createPullRequestForDetectionDeletion?: Maybe<CreatePullRequestResponse>;
  createPullRequestForGlobalHelperDeletion?: Maybe<CreatePullRequestResponse>;
  createPullRequestForGlobalHelperEdit?: Maybe<CreatePullRequestResponse>;
  createPullRequestForNewDataModel?: Maybe<CreatePullRequestResponse>;
  createPullRequestForNewGlobalHelper?: Maybe<CreatePullRequestResponse>;
  createPullRequestForNewPolicy?: Maybe<CreatePullRequestResponse>;
  createPullRequestForNewRule?: Maybe<CreatePullRequestResponse>;
  createPullRequestForNewSavedQuery?: Maybe<CreatePullRequestResponse>;
  createPullRequestForPolicyEdit?: Maybe<CreatePullRequestResponse>;
  createPullRequestForRuleEdit?: Maybe<CreatePullRequestResponse>;
  createPullRequestForSavedQueryDeletion?: Maybe<CreatePullRequestResponse>;
  createPullRequestForSavedQueryEdit?: Maybe<CreatePullRequestResponse>;
  createRSAKey: RSAKey;
  createReplay: CreateReplayOutput;
  /** Adds a new User role to Panther */
  createRole: CreateRoleOutput;
  /** Creates an S3 Log Source */
  createS3Source: CreateS3SourceOutput;
  /** Creates a new scheduled prompt */
  createScheduledPrompt: ScheduledPrompt;
  /** Decide the outcome of a tool invocation */
  decideToolInvocation: AIToolInvocation;
  /**
   * Deletes an AI skill (soft delete). Only custom skills can be deleted.
   * Panther-managed skills cannot be deleted or modified through the API.
   */
  deleteAISkill: DeleteAISkillOutput;
  deleteAPIToken: DeleteAPITokenOutput;
  deleteAlertContextTag: Scalars['Boolean']['output'];
  deleteAnalysisPackSource?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes a Cloud Account by ID */
  deleteCloudAccount: DeleteCloudAccountOutput;
  deleteDashboard: Dashboard;
  deleteDataModel?: Maybe<Scalars['Boolean']['output']>;
  deleteDestination?: Maybe<Scalars['Boolean']['output']>;
  deleteDetectionFilter: DetectionFilter;
  /** Delete detections by ID */
  deleteDetections: DeleteDetectionsOutput;
  deleteEnrichmentIntegration?: Maybe<Scalars['Boolean']['output']>;
  deleteGitConfig?: Maybe<Scalars['Boolean']['output']>;
  deleteGlobalHelpers?: Maybe<Scalars['Boolean']['output']>;
  deleteLogIntegration?: Maybe<Scalars['Boolean']['output']>;
  deleteLogIntegrationEventThresholdAlarm?: Maybe<Scalars['Boolean']['output']>;
  deleteLookups?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Delete an MCP server configuration.
   * This will also disconnect all users from the server.
   */
  deleteMcpServer: Scalars['Boolean']['output'];
  /** Deletes a user role */
  deleteRole: DeleteRoleOutput;
  deleteRuleV2?: Maybe<Scalars['Boolean']['output']>;
  deleteSavedQueries?: Maybe<Scalars['Boolean']['output']>;
  /** Batch deletes a set of saved queries. Returns the names of the deleted queries. */
  deleteSavedQueriesByName: DeleteSavedQueriesByNameOutput;
  /** Soft-deletes a scheduled prompt */
  deleteScheduledPrompt: Scalars['Boolean']['output'];
  /** Deletes a Log Source by ID */
  deleteSource: DeleteSourceOutput;
  /** Deletes a user */
  deleteUser: DeleteUserOutput;
  deliverAlert: Alert;
  /**
   * Disconnect the current user from an MCP server.
   * Revokes tokens and removes the connection.
   */
  disconnectMcpServer: Scalars['Boolean']['output'];
  /**
   * Discovers OAuth metadata for an MCP server URL.
   * Returns authorization server details and whether manual credentials are required.
   */
  discoverMcpServer: McpServerDiscovery;
  /** Edits an inference stream */
  editAIInferenceStream: AIInferenceStream;
  /** Executes an SQL query against a selected data lake database */
  executeDataLakeQuery: ExecuteDataLakeQueryOutput;
  /** Executes an Indicator Search query against Panther's data lake */
  executeIndicatorSearchQuery: ExecuteIndicatorSearchQueryOutput;
  /** Executes a simple search against selected data lake tables */
  executeSimpleSearchQuery: ExecuteSimpleSearchQueryOutput;
  /** Executes an uber search against selected data lake tables */
  executeUberSearch: ExecuteUberSearchOutput;
  /** Executes a uber search to summarize a property */
  executeUberSearchPropertySummary: ExecuteUberSearchPropertySummaryOutput;
  /**
   * Generates a presigned URL for uploading an AI attachment to S3.
   * The contentType is enforced on the presigned URL — the upload will fail if the
   * Content-Type header does not match. Use the browser's File.type for reliable MIME detection.
   */
  generateAIAttachmentUploadUrl: AIAttachmentUploadUrl;
  generateLookupImportUrl?: Maybe<LookupS3ImportConfig>;
  generateS3SampleDataUpload: GenerateS3SampleUploadResponse;
  generateSchemaFromSql: GenerateSchemaFromSqlJob;
  /** Grant one or more users access to an AWS SigV4 MCP server. */
  grantMcpServerAccess: Scalars['Boolean']['output'];
  /** Imports data into a lookup table and updates global database views. */
  importLookupData: LookupImportDataJob;
  inferSchema?: Maybe<InferSchemaResponse>;
  inferSchemaFromBucketData: Job;
  inferSchemaFromRawData: Job;
  /**
   * Initiate OAuth authorization for the current user with an MCP server.
   * Returns the authorization URL to redirect the user to.
   */
  initiateMcpAuthorization: McpAuthorizationResponse;
  installCatalogDataModel: InstallCatalogDataModelOutput;
  installCatalogDetection: InstallCatalogDetectionOutput;
  installCatalogEnrichment: InstallCatalogEnrichmentOutput;
  installCatalogGlobalHelper: InstallCatalogGlobalHelperOutput;
  installCatalogQuery: InstallCatalogQueryOutput;
  /** Invites a new user */
  inviteUser: InviteUserOutput;
  /** @deprecated Use updateUserNotifications instead */
  markAllNotificationsAsRead: MarkAllNotificationsAsReadOutput;
  /** @deprecated Use updateNotification instead */
  markNotificationAsRead: Notification;
  migratePacksToCatalog: PackMigrationResult;
  parseRunbook: ParseRunbookOutput;
  patchAlertsById: PatchAlertsByIdOutput;
  putAlertContextTag: Scalars['Boolean']['output'];
  putCorrelationRule?: Maybe<CorrelationRule>;
  putNotificationPreferences: NotificationPreferencesOutput;
  putUserPreferences: UserPreferencesOutput;
  /** Re-runs the health check for a single log source and returns the refreshed source. */
  refreshLogSourceHealth: LogIntegration;
  renameAlertContextTag: Scalars['Boolean']['output'];
  requestSource?: Maybe<RequestSourceOutput>;
  /** Forces a user password reset */
  resetUserPassword: ResetUserPasswordOutput;
  resolveAlarmAndReclassify?: Maybe<ReclassifySourceAlarmJob>;
  resolveSourceAlarm?: Maybe<Scalars['Boolean']['output']>;
  restoreDashboard: Dashboard;
  /** Revoke a user's access to an AWS SigV4 MCP server. */
  revokeMcpServerAccess: Scalars['Boolean']['output'];
  /** Allows an API token to rotate itself without any additional permissions */
  rotateAPIToken: RotateAPITokenOutput;
  rotateAPITokenByID: RotateAPITokenOutput;
  /**
   * Immediately triggers execution of a scheduled prompt without affecting its ongoing schedule.
   * Runs the prompt as the calling user (NOT the prompt's run-as identity), so — like running a
   * query (executeDataLakeQuery → DataAnalyticsRead) — it gates on ViewScheduledPrompts, plus
   * RunPantherAI since it consumes inference; ManageScheduledPrompts is not required. The resolver
   * still enforces per-prompt access via CanModify: public prompts are runnable by any viewer,
   * private prompts only by the owner or a ManageAIResponses holder.
   */
  runScheduledPromptNow: RunScheduledPromptNowOutput;
  saveResolvedWorkbenchAnalysisItems: SaveResolvedWorkbenchAnalysisItemsOutput;
  /** Receives a webhook / event from Jira */
  sendJiraEvent?: Maybe<SendJiraEventOutput>;
  /** Sends user feedback to Panther as an email */
  sendUserFeedback: SendUserFeedbackOutput;
  serializeRunbook: SerializeRunbookOutput;
  setLogIntegrationEventThresholdAlarm: EventThresholdAlarm;
  /** Signs a user out of all of their active sessions by revoking their refresh tokens */
  signOutUserSessions: SignOutSessionsOutput;
  /** Starts an asynchronous download of all results of a query in the datalake */
  startAsyncDownloadOfAllQueryResults: StartAsyncDownloadOfAllQueryResultsOutput;
  stopReplay: StopReplayOutput;
  summarizeDataLakeQuery: SummarizeDataLakeQueryJob;
  suppressPolicies?: Maybe<Scalars['Boolean']['output']>;
  syncLookupData: LookupSyncJob;
  testCorrelationRule: TestCorrelationRuleResponse;
  /** Run unit tests for correlation rules */
  testCorrelationRuleYAML?: Maybe<TestCorrelationRuleYAMLOutput>;
  testHoldingTankSchemas: Job;
  /** Test the connection to an MCP server, returning its health status and tool count. */
  testMcpServerConnection: McpConnectionTestResult;
  testPolicy: TestPolicyResponse;
  testPollGit?: Maybe<TestPollGitResponse>;
  testRule: TestRuleResponse;
  testSchema?: Maybe<TestSchemaResponse>;
  /** Enables or disables a scheduled prompt */
  toggleScheduledPrompt: ScheduledPrompt;
  /** Transpiles simple detection filters to no code filters */
  transpileFilters?: Maybe<TranspileFiltersOutput>;
  /** Transpiles simple detections to Python */
  transpileSimpleDetectionsToPython?: Maybe<TranspileSimpleDetectionsToPythonOutput>;
  /** Updates an AI conversation's metadata (title, privacy, saved status) */
  updateAIConversation: AIConversation;
  /** Updates an existing AI skill */
  updateAISkill: UpdateAISkillOutput;
  updateAPIToken: UpdateAPITokenOutput;
  updateAlertStatusByFilter: UpdateAlertStatusByFilterJob;
  /** Updates the status of one or more alerts via a list of IDs */
  updateAlertStatusById: UpdateAlertStatusByIdOutput;
  /** Updates the assignee of one or more alerts through the assignee's email */
  updateAlertsAssigneeByEmail: UpdateAlertsAssigneeByEmailOutput;
  /** Updates the assignee of one or more alerts through the the assignee's ID */
  updateAlertsAssigneeById: UpdateAlertsAssigneeByIdOutput;
  updateAllCatalogItems: UpdateAllCatalogItemsJob;
  updateAnalysisPack: AnalysisPack;
  updateAnalysisPackSource: AnalysisPackSource;
  updateAzureBlobSource: UpdateAzureBlobSourceOutput;
  updateCatalogItem: UpdateCatalogItemOutput;
  /** Updates a Cloud Account */
  updateCloudAccount: UpdateCloudAccountOutput;
  updateDashboard: Dashboard;
  updateDataModel: DataModel;
  updateDestination?: Maybe<Destination>;
  updateDetectionFilter: DetectionFilter;
  updateEnrichmentIntegration: EnrichmentIntegration;
  updateGeneralSettings: GeneralSettingsConfig;
  updateGitHubAppConfig?: Maybe<UpdateGitHubAppConfigResponse>;
  updateGlobalHelper: GlobalHelper;
  updateLogSource: LogIntegration;
  updateLogSourceFilters: SourceFilters;
  /** Updates the metadata for a single lookup table. */
  updateLookup: Lookup;
  updateLookupAsync: SaveLookupJob;
  /** Update an existing MCP server configuration. */
  updateMcpServer: McpServer;
  /**
   * Update the current user's tool settings for a connected MCP server.
   * Returns the updated tool settings.
   */
  updateMcpToolSettings: Array<McpTool>;
  updateMitreReportMapping: UpdateMitreReportMappingOutput;
  updateMitreReportSettings: ReportSetting;
  updateNotification: Notification;
  updatePolicy?: Maybe<Policy>;
  /** Updates user config for a datalake query */
  updateQueryUserConfig: DataLakeQuery;
  /** Updates a role's name or permissions */
  updateRole: UpdateRoleOutput;
  updateRuleAndFilter?: Maybe<Rule>;
  updateRuleV2?: Maybe<UpdateRuleV2Output>;
  /** Updates an S3 Log Source */
  updateS3Source: UpdateS3SourceOutput;
  updateSamlConfig: SamlConfig;
  updateSavedQuery: SavedQuery;
  /** Updates an existing scheduled prompt */
  updateScheduledPrompt: ScheduledPrompt;
  updateSchemaStatus: GetSchemaOutput;
  /** Updates the information for a user */
  updateUser: UpdateUserOutput;
  updateUserNotifications: UpdateUserNotificationsOutput;
  /** Bulk updates detection entities via a base-64 encoded zip file */
  uploadDetectionEntities?: Maybe<UploadDetectionEntitiesOutput>;
  /** Asynchronously bulk updates detection entities via a base-64 encoded zip file */
  uploadDetectionEntitiesAsync?: Maybe<UploadDetectionEntitiesAsyncOutput>;
  validateAndTestAllAnalysisItems: ValidateAndTestAllAnalysisItemsOutput;
  /** Asynchronously bulk validates detection entities via a base-64 encoded zip file */
  validateBulkUpload?: Maybe<ValidateBulkUploadOutput>;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationAddAnalysisPackSourceArgs = {
  input: AddAnalysisPackSourceInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationAddDataModelArgs = {
  input: AddOrUpdateDataModelInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationAddDestinationArgs = {
  input: DestinationInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationAddEnrichmentIntegrationArgs = {
  input: AddEnrichmentIntegrationInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationAddGlobalHelperArgs = {
  input: AddGlobalHelperInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationAddLogSourceArgs = {
  input: AddLogSourceInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationAddLookupArgs = {
  input: AddLookupInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationAddLookupAsyncArgs = {
  input: AddLookupInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationAddPolicyArgs = {
  input: AddPolicyInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationAddRuleArgs = {
  input: AddRuleInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationAddRuleV2Args = {
  input: AddRuleV2Input;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationAddSavedQueryArgs = {
  input: AddSavedQueryInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationAiAuthorDetectionArgs = {
  input: AIAuthorDetectionInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationAiAuthorOrganizationProfileArgs = {
  input: AIAuthorOrganizationProfileInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationAiAuthorRunbookArgs = {
  input: AIAuthorRunbookInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationAiAuthorSkillArgs = {
  input: AIAuthorSkillInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationAiGeneratePantherFlowQueryArgs = {
  input: AIGeneratePantherFlowQueryInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationAiGenerateSqlQueryArgs = {
  input: AIGenerateSqlQueryInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationAiReplayDetectionArgs = {
  input: AIReplayDetectionInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationAiResolveAnalysisItemMergeConflictsArgs = {
  input: AIResolveAnalysisItemMergeConflictsInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationAiSchemaInferenceArgs = {
  input: AISchemaInferenceInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationAiSummarizeAlertArgs = {
  input: AISummarizeAlertInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationAiSummarizeDetectionArgs = {
  input: AISummarizeDetectionInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationAiSummarizeLogEventsArgs = {
  input: AISummarizeLogEventsInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationAiSummarizeQueryResultsArgs = {
  input: AISummarizeQueryResultsInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationApproveRemoteMcpAuthorizationArgs = {
  input: ApproveRemoteMcpAuthorizationInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationBatchInferJobsArgs = {
  input: BatchInferJobsInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationBulkUpdateDetectionsArgs = {
  input: BulkUpdateDetectionsInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationBulkUploadDetectionsArgs = {
  input: BulkUploadDetectionsInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCancelAIInferenceStreamArgs = {
  input: CancelAIInferenceStreamInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCancelDashboardQueriesArgs = {
  queryIds: Array<Scalars['String']['input']>;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCancelDataLakeQueryArgs = {
  input: CancelDataLakeQueryInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCancelHoldingTankJobArgs = {
  id: Scalars['String']['input'];
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCancelUberSearchArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCompleteMcpAuthorizationArgs = {
  input: CompleteMcpAuthorizationInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationContinueAIConversationArgs = {
  input: ContinueAIConversationInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreateAIConversationArgs = {
  input: CreateAIConversationInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreateAISkillArgs = {
  input: CreateAISkillInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreateAPITokenArgs = {
  input: CreateAPITokenInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreateAlertCommentArgs = {
  input: CreateAlertCommentInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreateAzureBlobSourceArgs = {
  input: CreateAzureBlobSourceInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreateCloudAccountArgs = {
  input: CreateCloudAccountInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreateDashboardArgs = {
  input: CreateDashboardInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreateDetectionFilterArgs = {
  input: CreateDetectionFilterInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreateGitHubAppConfigArgs = {
  input: CreateGitHubAppConfigInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreateGitHubAppRegistrationUrlArgs = {
  input: CreateGitHubAppRegistrationUrlInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreateMcpServerArgs = {
  input: CreateMcpServerInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreateOrUpdateSchemaArgs = {
  input: CreateOrUpdateSchemaInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreatePerfTestArgs = {
  input: CreatePerfTestInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreatePullRequestForCatalogDataModelInstallArgs = {
  input: CreatePullRequestForCatalogDataModelInstallInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreatePullRequestForCatalogGlobalHelperInstallArgs = {
  input: CreatePullRequestForCatalogGlobalHelperInstallInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreatePullRequestForCatalogInstallArgs = {
  input: CreatePullRequestForCatalogInstallInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreatePullRequestForCatalogSavedQueryInstallArgs = {
  input: CreatePullRequestForCatalogSavedQueryInstallInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreatePullRequestForCorrelationRuleEditArgs = {
  input: CreatePullRequestForCorrelationRuleEditInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreatePullRequestForDataModelDeletionArgs = {
  input: CreatePullRequestForDataModelDeletionInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreatePullRequestForDataModelEditArgs = {
  input: CreatePullRequestForDataModelEditInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreatePullRequestForDetectionDeletionArgs = {
  input: CreatePullRequestForDetectionDeletionInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreatePullRequestForGlobalHelperDeletionArgs = {
  input: CreatePullRequestForGlobalHelperDeletionInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreatePullRequestForGlobalHelperEditArgs = {
  input: CreatePullRequestForGlobalHelperEditInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreatePullRequestForNewDataModelArgs = {
  input: CreatePullRequestForNewDataModelInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreatePullRequestForNewGlobalHelperArgs = {
  input: CreatePullRequestForNewGlobalHelperInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreatePullRequestForNewPolicyArgs = {
  input: CreatePullRequestForNewPolicyInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreatePullRequestForNewRuleArgs = {
  input: CreatePullRequestForNewRuleInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreatePullRequestForNewSavedQueryArgs = {
  input: CreatePullRequestForNewSavedQueryInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreatePullRequestForPolicyEditArgs = {
  input: CreatePullRequestForPolicyEditInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreatePullRequestForRuleEditArgs = {
  input: CreatePullRequestForRuleEditInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreatePullRequestForSavedQueryDeletionArgs = {
  input: CreatePullRequestForSavedQueryDeletionInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreatePullRequestForSavedQueryEditArgs = {
  input: CreatePullRequestForSavedQueryEditInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreateRSAKeyArgs = {
  input: CreateRSAKeyInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreateReplayArgs = {
  input: CreateReplayInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreateS3SourceArgs = {
  input: CreateS3SourceInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationCreateScheduledPromptArgs = {
  input: CreateScheduledPromptInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDecideToolInvocationArgs = {
  input: DecideToolInvocationInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDeleteAISkillArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDeleteAPITokenArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDeleteAlertContextTagArgs = {
  input?: InputMaybe<DeleteAlertContextTagInput>;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDeleteAnalysisPackSourceArgs = {
  input: Array<DeleteEntry>;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDeleteCloudAccountArgs = {
  input: DeleteCloudAccountInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDeleteDashboardArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDeleteDataModelArgs = {
  input: DeleteDataModelInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDeleteDestinationArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDeleteDetectionFilterArgs = {
  detectionId: Scalars['ID']['input'];
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDeleteDetectionsArgs = {
  input: DeleteDetectionsInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDeleteEnrichmentIntegrationArgs = {
  input: Scalars['ID']['input'];
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDeleteGitConfigArgs = {
  input: DeleteGitConfigInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDeleteGlobalHelpersArgs = {
  input: DeleteGlobalHelpersInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDeleteLogIntegrationArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDeleteLogIntegrationEventThresholdAlarmArgs = {
  integrationId: Scalars['ID']['input'];
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDeleteLookupsArgs = {
  input: DeleteLookupsInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDeleteMcpServerArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDeleteRoleArgs = {
  input: DeleteRoleInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDeleteRuleV2Args = {
  id: Scalars['ID']['input'];
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDeleteSavedQueriesArgs = {
  input: DeleteSavedQueryInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDeleteSavedQueriesByNameArgs = {
  input: DeleteSavedQueriesByNameInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDeleteScheduledPromptArgs = {
  input: DeleteScheduledPromptInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDeleteSourceArgs = {
  input: DeleteSourceInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDeliverAlertArgs = {
  input: DeliverAlertInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDisconnectMcpServerArgs = {
  serverId: Scalars['ID']['input'];
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationDiscoverMcpServerArgs = {
  input: DiscoverMcpServerInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationEditAIInferenceStreamArgs = {
  input: EditAIInferenceStreamInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationExecuteDataLakeQueryArgs = {
  input: ExecuteDataLakeQueryInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationExecuteIndicatorSearchQueryArgs = {
  input: ExecuteIndicatorSearchQueryInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationExecuteSimpleSearchQueryArgs = {
  input: ExecuteSimpleSearchQueryInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationExecuteUberSearchArgs = {
  input: ExecuteUberSearchInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationExecuteUberSearchPropertySummaryArgs = {
  input: ExecuteUberSearchPropertySummaryInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationGenerateAIAttachmentUploadUrlArgs = {
  contentType: Scalars['String']['input'];
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationGenerateLookupImportUrlArgs = {
  input: LookupS3ImportConfigInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationGenerateS3SampleDataUploadArgs = {
  input?: InputMaybe<GenerateS3SampleUploadInput>;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationGenerateSchemaFromSqlArgs = {
  input: GenerateSchemaFromSqlInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationGrantMcpServerAccessArgs = {
  input: GrantMcpServerAccessInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationImportLookupDataArgs = {
  input: ImportLookupDataInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationInferSchemaArgs = {
  input: InferSchemaInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationInferSchemaFromBucketDataArgs = {
  input: InferSchemaFromBucketDataInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationInferSchemaFromRawDataArgs = {
  input: HoldingTankInferSchemaInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationInitiateMcpAuthorizationArgs = {
  input: InitiateMcpAuthorizationInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationInstallCatalogDataModelArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationInstallCatalogDetectionArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationInstallCatalogEnrichmentArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationInstallCatalogGlobalHelperArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationInstallCatalogQueryArgs = {
  queryName: Scalars['String']['input'];
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationInviteUserArgs = {
  input: InviteUserInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationMarkAllNotificationsAsReadArgs = {
  input?: InputMaybe<MarkAllNotificationsAsReadInput>;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationMarkNotificationAsReadArgs = {
  input: MarkNotificationAsReadInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationParseRunbookArgs = {
  input: ParseRunbookInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationPatchAlertsByIdArgs = {
  input: PatchAlertsByIdInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationPutAlertContextTagArgs = {
  input?: InputMaybe<PutAlertContextTagInput>;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationPutCorrelationRuleArgs = {
  input: PutCorrelationRuleInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationPutNotificationPreferencesArgs = {
  input?: InputMaybe<PutNotificationPreferencesInput>;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationPutUserPreferencesArgs = {
  input: PutUserPreferencesInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationRefreshLogSourceHealthArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationRenameAlertContextTagArgs = {
  input?: InputMaybe<RenameAlertContextTagInput>;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationRequestSourceArgs = {
  input: RequestSourceInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationResetUserPasswordArgs = {
  input: ResetUserPasswordInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationResolveAlarmAndReclassifyArgs = {
  input: ResolveAlarmAndReclassifyInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationResolveSourceAlarmArgs = {
  input: ResolveSourceAlarmInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationRestoreDashboardArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationRevokeMcpServerAccessArgs = {
  input: RevokeMcpServerAccessInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationRotateAPITokenByIDArgs = {
  input?: InputMaybe<RotateAPITokenInput>;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationRunScheduledPromptNowArgs = {
  input: RunScheduledPromptNowInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationSaveResolvedWorkbenchAnalysisItemsArgs = {
  input: SaveResolvedWorkbenchAnalysisItemsInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationSendJiraEventArgs = {
  input?: InputMaybe<SendJiraEventInput>;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationSendUserFeedbackArgs = {
  input: SendUserFeedbackInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationSerializeRunbookArgs = {
  input: SerializeRunbookInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationSetLogIntegrationEventThresholdAlarmArgs = {
  input: EventThresholdAlarmInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationSignOutUserSessionsArgs = {
  userId: Scalars['ID']['input'];
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationStartAsyncDownloadOfAllQueryResultsArgs = {
  input: StartAsyncDownloadOfAllQueryResultsInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationStopReplayArgs = {
  input: StopReplayInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationSummarizeDataLakeQueryArgs = {
  input: SummarizeDataLakeQueryInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationSuppressPoliciesArgs = {
  input: SuppressPoliciesInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationSyncLookupDataArgs = {
  input: SyncLookupDataInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationTestCorrelationRuleArgs = {
  input: TestCorrelationRuleInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationTestCorrelationRuleYAMLArgs = {
  input: TestCorrelationRuleYAMLInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationTestHoldingTankSchemasArgs = {
  input: TestHoldingTankSchemasInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationTestMcpServerConnectionArgs = {
  serverId: Scalars['ID']['input'];
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationTestPolicyArgs = {
  input: TestPolicyInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationTestRuleArgs = {
  input: TestRuleInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationTestSchemaArgs = {
  input: TestSchemaInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationToggleScheduledPromptArgs = {
  input: ToggleScheduledPromptInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationTranspileFiltersArgs = {
  input: TranspileFiltersInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationTranspileSimpleDetectionsToPythonArgs = {
  input: TranspileSimpleDetectionsToPythonInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateAIConversationArgs = {
  input: UpdateAIConversationInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateAISkillArgs = {
  input: UpdateAISkillInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateAPITokenArgs = {
  input: UpdateAPITokenInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateAlertStatusByFilterArgs = {
  input: UpdateAlertStatusByFilterInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateAlertStatusByIdArgs = {
  input: UpdateAlertStatusByIdInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateAlertsAssigneeByEmailArgs = {
  input: UpdateAlertsAssigneeByEmailInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateAlertsAssigneeByIdArgs = {
  input: UpdateAlertsAssigneeByIdInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateAllCatalogItemsArgs = {
  input: UpdateAllCatalogItemsInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateAnalysisPackArgs = {
  input: UpdateAnalysisPackInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateAnalysisPackSourceArgs = {
  input: UpdateAnalysisPackSourceInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateAzureBlobSourceArgs = {
  input: UpdateAzureBlobSourceInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateCatalogItemArgs = {
  input: UpdateCatalogItemInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateCloudAccountArgs = {
  input: UpdateCloudAccountInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateDashboardArgs = {
  input: UpdateDashboardInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateDataModelArgs = {
  input: AddOrUpdateDataModelInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateDestinationArgs = {
  input: DestinationInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateDetectionFilterArgs = {
  input: UpdateDetectionFilterInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateEnrichmentIntegrationArgs = {
  input: UpdateEnrichmentIntegrationInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateGeneralSettingsArgs = {
  input: UpdateGeneralSettingsConfigInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateGitHubAppConfigArgs = {
  input: UpdateGitHubAppConfigInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateGlobalHelperArgs = {
  input: ModifyGlobalHelperInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateLogSourceArgs = {
  input: UpdateLogSourceInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateLogSourceFiltersArgs = {
  input: UpdateLogSourceFiltersInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateLookupArgs = {
  input: UpdateLookupInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateLookupAsyncArgs = {
  input: UpdateLookupInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateMcpServerArgs = {
  input: UpdateMcpServerInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateMcpToolSettingsArgs = {
  input: UpdateMcpToolSettingsInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateMitreReportMappingArgs = {
  input: UpdateMitreReportMappingInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateMitreReportSettingsArgs = {
  input: UpdateMitreReportSettings;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateNotificationArgs = {
  input: UpdateNotificationInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdatePolicyArgs = {
  input: UpdatePolicyInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateQueryUserConfigArgs = {
  input: UpdateQueryUserConfigInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateRuleAndFilterArgs = {
  input: UpdateRuleAndFilterInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateRuleV2Args = {
  input: UpdateRuleV2Input;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateS3SourceArgs = {
  input: UpdateS3SourceInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateSamlConfigArgs = {
  input: UpdateSamlConfigInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateSavedQueryArgs = {
  input: UpdateSavedQueryInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateScheduledPromptArgs = {
  input: UpdateScheduledPromptInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateSchemaStatusArgs = {
  input: UpdateSchemaStatusInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUpdateUserNotificationsArgs = {
  input?: InputMaybe<UpdateUserNotificationsInput>;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUploadDetectionEntitiesArgs = {
  input: UploadDetectionEntitiesInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationUploadDetectionEntitiesAsyncArgs = {
  input: UploadDetectionEntitiesAsyncInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationValidateAndTestAllAnalysisItemsArgs = {
  input: ValidateAndTestAllAnalysisItemsInput;
};

/** The top-level Mutation type. Mutations are used to make requests that create or modify data. */
export type MutationValidateBulkUploadArgs = {
  input: ValidateBulkUploadInput;
};

export type NamedMitreAttack = {
  __typename?: 'NamedMitreAttack';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type NetskopeConfig = {
  __typename?: 'NetskopeConfig';
  apiToken: Scalars['String']['output'];
  organizationDomain: Scalars['String']['output'];
};

export type NetskopeConfigInput = {
  apiToken: Scalars['String']['input'];
  organizationDomain: Scalars['String']['input'];
};

export type NetworkingInfo = {
  __typename?: 'NetworkingInfo';
  publicIp: Scalars['String']['output'];
};

export type Notification = {
  __typename?: 'Notification';
  /** The time the notification was archived by the user */
  archivedAt?: Maybe<Scalars['String']['output']>;
  /** The time the notification was created */
  createdAt: Scalars['String']['output'];
  /** The ID of notification */
  id: Scalars['ID']['output'];
  /** The Level that define the severity of the notification */
  level: NotificationLevel;
  /** The Message of the notification */
  message: Scalars['String']['output'];
  /** The metadata of the notification */
  metadata?: Maybe<NotificationMetadata>;
  /** The time the notification was read it by the user */
  readAt?: Maybe<Scalars['String']['output']>;
  /** The Title of the notification */
  title: Scalars['String']['output'];
  /** The Topic of notification */
  topic: NotificationTopic;
  /** The User ID of the notification */
  userId: Scalars['ID']['output'];
};

export type NotificationChannel = {
  __typename?: 'NotificationChannel';
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type NotificationChannelInput = {
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export enum NotificationLevel {
  /** Error represents an error notification. */
  Error = 'ERROR',
  /** Info represents an informational notification. */
  Info = 'INFO',
  /** Warning represents a warning notification. */
  Warning = 'WARNING',
}

export type NotificationMetadata = {
  __typename?: 'NotificationMetadata';
  alertID?: Maybe<Scalars['String']['output']>;
  originalQueryId?: Maybe<Scalars['String']['output']>;
  presignedUrl?: Maybe<Scalars['String']['output']>;
  presignedUrlKeepAliveDuration?: Maybe<Scalars['Int']['output']>;
  presignedUrlTtl?: Maybe<Scalars['String']['output']>;
};

export type NotificationPreference = {
  __typename?: 'NotificationPreference';
  channels: Array<NotificationChannel>;
  topic: NotificationTopic;
};

export type NotificationPreferenceInput = {
  channels: Array<NotificationChannelInput>;
  topic: NotificationTopic;
};

export type NotificationPreferencesOutput = {
  __typename?: 'NotificationPreferencesOutput';
  preferences: Array<NotificationPreference>;
};

export enum NotificationTopic {
  DetectionNotification = 'DETECTION_NOTIFICATION',
  SystemError = 'SYSTEM_ERROR',
  SystemNotification = 'SYSTEM_NOTIFICATION',
}

/** The payload to the `notifications` query */
export type NotificationsInput = {
  /**
   * An opaque string used when paginating across multiple pages of results
   * Currently, pagination is not supported and this value will always be null
   */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** The size of each page of results. Defaults to `25` */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type NotificationsOutput = {
  __typename?: 'NotificationsOutput';
  /** A list of paginated alert edges */
  edges: Array<NotificationsOutputEdge>;
  /** Metadata around this page of results */
  pageInfo: NotificationsPageInfo;
};

/** The edge shape of the `NotificationsOutput` type */
export type NotificationsOutputEdge = {
  __typename?: 'NotificationsOutputEdge';
  /** An notification node */
  node: Notification;
};

/** The metadata around a page of results for the `notifications` query */
export type NotificationsPageInfo = {
  __typename?: 'NotificationsPageInfo';
  /** The cursor that the next page of results should start from or `null` if this is the last page */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** A boolean indicating whether more results exist */
  hasNextPage: Scalars['Boolean']['output'];
  /** A boolean indicating whether this is the first page of results or not */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The cursor that this page of results started from or `null` if this is the first page */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type OAuth2Info = {
  __typename?: 'OAuth2Info';
  mustAuthorize: Scalars['Boolean']['output'];
};

export type OAuthConfig = {
  __typename?: 'OAuthConfig';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
};

export type OAuthConfigInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
};

export type OTLPConfig = {
  __typename?: 'OTLPConfig';
  logProcessingRole?: Maybe<Scalars['String']['output']>;
  queueUrl: Scalars['String']['output'];
  s3Bucket: Scalars['String']['output'];
  s3Prefix?: Maybe<Scalars['String']['output']>;
  securityHeaderKey?: Maybe<Scalars['String']['output']>;
  securityPassword?: Maybe<Scalars['String']['output']>;
  securitySecretValue?: Maybe<Scalars['String']['output']>;
  securityType: OTLPSecurityType;
  securityUsername?: Maybe<Scalars['String']['output']>;
};

export type OTLPLogConfigInput = {
  logTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  securityHeaderKey?: InputMaybe<Scalars['String']['input']>;
  securityPassword?: InputMaybe<Scalars['String']['input']>;
  securitySecretValue?: InputMaybe<Scalars['String']['input']>;
  securityType: OTLPSecurityType;
  securityUsername?: InputMaybe<Scalars['String']['input']>;
};

export type OTLPLogIntegrationHealth = {
  __typename?: 'OTLPLogIntegrationHealth';
  classificationFailuresStatus?: Maybe<IntegrationItemHealthStatus>;
  logProcessingErrorsStatus?: Maybe<IntegrationItemHealthStatus>;
  otlpStatus?: Maybe<IntegrationItemHealthStatus>;
  systemAlarmStatus?: Maybe<IntegrationItemHealthStatus>;
};

export type OTLPLogSourceIntegration = LogIntegration & {
  __typename?: 'OTLPLogSourceIntegration';
  alarms: LogIntegrationAlarms;
  createdAtTime: Scalars['DateTime']['output'];
  createdBy?: Maybe<Actor>;
  filters: SourceFilters;
  health: OTLPLogIntegrationHealth;
  integrationId: Scalars['ID']['output'];
  integrationLabel: Scalars['String']['output'];
  integrationType: Scalars['String']['output'];
  isEditable: Scalars['Boolean']['output'];
  isHealthy: Scalars['Boolean']['output'];
  isPantherManaged: Scalars['Boolean']['output'];
  lastEventProcessedAtTime?: Maybe<Scalars['DateTime']['output']>;
  lastEventReceivedAtTime?: Maybe<Scalars['DateTime']['output']>;
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  logProviderId?: Maybe<Scalars['String']['output']>;
  logTypes: Array<Scalars['String']['output']>;
  otlpConfig: OTLPConfig;
};

export type OTLPOptions = {
  __typename?: 'OTLPOptions';
  securityHeaderKey?: Maybe<Scalars['String']['output']>;
  securityType?: Maybe<OTLPSecurityType>;
};

export enum OTLPSecurityType {
  Basic = 'Basic',
  Bearer = 'Bearer',
  SharedSecret = 'SharedSecret',
}

export type OTXConfig = {
  __typename?: 'OTXConfig';
  apiToken: Scalars['String']['output'];
  maxAgeDays?: Maybe<Scalars['Int']['output']>;
  profilePullers: OTXProfilePullerConfig;
};

export type OTXConfigInput = {
  apiToken: Scalars['String']['input'];
  maxAgeDays?: InputMaybe<Scalars['Int']['input']>;
  profilePullers: OTXProfilePullerConfigInput;
};

export type OTXProfilePullerConfig = {
  __typename?: 'OTXProfilePullerConfig';
  pulses: ProfilePullerConfig;
};

export type OTXProfilePullerConfigInput = {
  pulses: ProfilePullerConfigInput;
};

export type OktaConfig = {
  __typename?: 'OktaConfig';
  apiToken: Scalars['String']['output'];
  domain: Scalars['String']['output'];
  profilePullers?: Maybe<OktaProfilePullerConfig>;
};

export type OktaConfigInput = {
  apiToken: Scalars['String']['input'];
  domain: Scalars['String']['input'];
  profilePullers?: InputMaybe<OktaProfilePullerConfigInput>;
};

export type OktaProfilePullerConfig = {
  __typename?: 'OktaProfilePullerConfig';
  devices?: Maybe<ProfilePullerConfig>;
  users?: Maybe<ProfilePullerConfig>;
};

export type OktaProfilePullerConfigInput = {
  devices?: InputMaybe<ProfilePullerConfigInput>;
  users?: InputMaybe<ProfilePullerConfigInput>;
};

export type OnePasswordConfig = {
  __typename?: 'OnePasswordConfig';
  host: OnePasswordHost;
  token: Scalars['String']['output'];
};

export type OnePasswordConfigInput = {
  host: OnePasswordHost;
  token: Scalars['String']['input'];
};

export enum OnePasswordHost {
  Business = 'Business',
  Canada = 'Canada',
  Enterprise = 'Enterprise',
  Europe = 'Europe',
}

export type OpenAIConfig = {
  __typename?: 'OpenAIConfig';
  apiKey: Scalars['String']['output'];
};

export type OpenAIConfigInput = {
  apiKey: Scalars['String']['input'];
};

export type OpsgenieConfig = {
  __typename?: 'OpsgenieConfig';
  apiKey: Scalars['String']['output'];
  serviceRegion: OpsgenieServiceRegionEnum;
};

export type OpsgenieConfigInput = {
  apiKey: Scalars['String']['input'];
  serviceRegion: OpsgenieServiceRegionEnum;
};

export enum OpsgenieServiceRegionEnum {
  Eu = 'EU',
  Us = 'US',
}

export type OrganizationReportBySeverity = {
  __typename?: 'OrganizationReportBySeverity';
  critical?: Maybe<ComplianceStatusCounts>;
  high?: Maybe<ComplianceStatusCounts>;
  info?: Maybe<ComplianceStatusCounts>;
  low?: Maybe<ComplianceStatusCounts>;
  medium?: Maybe<ComplianceStatusCounts>;
};

export type OrganizationStatsInput = {
  limitTopFailing?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationStatsResponse = {
  __typename?: 'OrganizationStatsResponse';
  appliedPolicies?: Maybe<OrganizationReportBySeverity>;
  scannedResources?: Maybe<ScannedResources>;
  topFailingPolicies: Array<Policy>;
  topFailingResources: Array<ResourceSummary>;
};

/** T-shirt sizes for output */
export enum OutputLength {
  /** Large output */
  Large = 'large',
  /** Largest possible output */
  Largest = 'largest',
  /** Medium output */
  Medium = 'medium',
  /** Small output */
  Small = 'small',
  /** Extra large output */
  Xlarge = 'xlarge',
  /** Extra small output */
  Xsmall = 'xsmall',
}

export type PackMigrationFailure = {
  __typename?: 'PackMigrationFailure';
  analysisType: AnalysisType;
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
};

export type PackMigrationResult = {
  __typename?: 'PackMigrationResult';
  failed: Array<PackMigrationFailure>;
  migrated: Scalars['Int']['output'];
  skippedAlreadyMigrated: Scalars['Int']['output'];
  skippedOrphan: Scalars['Int']['output'];
};

export type PackMigrationStatus = {
  __typename?: 'PackMigrationStatus';
  itemCount: Scalars['Int']['output'];
  needsMigration: Scalars['Boolean']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage: Scalars['Boolean']['output'];
  paginationToken?: Maybe<Scalars['ID']['output']>;
};

export type PagerDutyConfig = {
  __typename?: 'PagerDutyConfig';
  integrationKey: Scalars['String']['output'];
};

export type PagerDutyConfigInput = {
  integrationKey: Scalars['String']['input'];
};

export type PagingData = {
  __typename?: 'PagingData';
  thisPage?: Maybe<Scalars['Int']['output']>;
  totalItems?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type PantherAIAutoResolveConfig = {
  __typename?: 'PantherAIAutoResolveConfig';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  riskScoreThreshold?: Maybe<Scalars['Float']['output']>;
  severities?: Maybe<Array<Scalars['String']['output']>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type PantherAIAutoResolveConfigInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  riskScoreThreshold?: InputMaybe<Scalars['Float']['input']>;
  severities?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PantherAIAutoRunOnAlertConfig = {
  __typename?: 'PantherAIAutoRunOnAlertConfig';
  deferNotifications?: Maybe<Scalars['Boolean']['output']>;
  deferNotificationsTimeoutMinutes?: Maybe<Scalars['Int']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  runAsUser?: Maybe<Actor>;
  runAsUserId?: Maybe<Scalars['ID']['output']>;
  severities?: Maybe<Array<Scalars['String']['output']>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type PantherAIAutoRunOnAlertConfigInput = {
  deferNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  deferNotificationsTimeoutMinutes?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  runAsUserId?: InputMaybe<Scalars['String']['input']>;
  severities?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PantherAIKendraConfig = {
  __typename?: 'PantherAIKendraConfig';
  dataSourceId?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  indexId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type PantherAIKendraConfigInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PantherAIRemoteMCPConfig = {
  __typename?: 'PantherAIRemoteMCPConfig';
  /**
   * Allowlist of non-http(s) redirect URI schemes — typically native-app
   * deep-links like "mcp" or "com.acme.app". Each entry is a bare scheme
   * name (no "://"). Reserved/dangerous values (http, https, javascript,
   * data, file, vbscript) are rejected at update time. An empty or unset
   * list blocks every custom scheme; allowlisted https hosts and loopback
   * http are unaffected.
   */
  allowedCustomSchemes?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Hostname allowlist for remote-MCP OAuth redirect URIs.
   * Supports exact ("app.acme.com") and wildcard ("*.acme.com") entries.
   * HTTP loopback (localhost, 127.0.0.1, ::1) is always permitted and does not
   * need to be listed. Leaving this empty blocks all https redirect URIs;
   * loopback http still works.
   */
  allowedRedirectDomains?: Maybe<Array<Scalars['String']['output']>>;
};

export type PantherAIRemoteMCPConfigInput = {
  /**
   * Allowlist of non-http(s) redirect URI schemes — typically native-app
   * deep-links like "mcp" or "com.acme.app". Each entry is a bare scheme
   * name (no "://"). Reserved/dangerous values (http, https, javascript,
   * data, file, vbscript) are rejected. An empty or unset list blocks every
   * custom scheme; allowlisted https hosts and loopback http are unaffected.
   */
  allowedCustomSchemes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Hostname allowlist for remote-MCP OAuth redirect URIs.
   * Supports exact ("app.acme.com") and wildcard ("*.acme.com") entries.
   * HTTP loopback (localhost, 127.0.0.1, ::1) is always permitted and does not
   * need to be listed. An empty list blocks all https redirect URIs; loopback
   * http still works.
   */
  allowedRedirectDomains?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PantherAIWebToolConfig = {
  __typename?: 'PantherAIWebToolConfig';
  /** List of domains the AI web tool can access without requiring approval */
  approvedDomains?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the AI web tool is enabled */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * List of domains the AI web tool is never allowed to access.
   * These domains are blocked even if requiresApproval is true.
   */
  forbiddenDomains?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * If true, the web tool will require user approval for non-approved domains.
   * If false, only approved domains are allowed.
   */
  requiresApproval?: Maybe<Scalars['Boolean']['output']>;
};

export type PantherAIWebToolConfigInput = {
  approvedDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  forbiddenDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  requiresApproval?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PantherFlowQueryWithParametersInput = {
  parameters: Array<Parameter>;
  query: Scalars['String']['input'];
};

export type PantherFlowQueryWithParametersOutput = {
  __typename?: 'PantherFlowQueryWithParametersOutput';
  query: Scalars['String']['output'];
};

/** Parameter is a query parameter. */
export type Parameter = {
  /** Parameter name */
  name: Scalars['String']['input'];
  /** Parameter value statement string */
  statement: Scalars['String']['input'];
};

export type ParseRunbookInput = {
  runbook: Scalars['String']['input'];
};

export type ParseRunbookOutput = {
  __typename?: 'ParseRunbookOutput';
  runbook?: Maybe<Runbook>;
};

export type PatchAlertsByIdInput = {
  contextTags?: InputMaybe<Array<Scalars['String']['input']>>;
  ids: Array<Scalars['ID']['input']>;
  quality?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AlertStatus>;
};

export type PatchAlertsByIdOutput = {
  __typename?: 'PatchAlertsByIdOutput';
  alerts: Array<Alert>;
};

/** The available permissions that an API Token or a Role (and thus a User) can hold */
export enum Permission {
  AiRunAsModify = 'AIRunAsModify',
  AlertModify = 'AlertModify',
  AlertRead = 'AlertRead',
  BulkUpload = 'BulkUpload',
  BulkUploadValidate = 'BulkUploadValidate',
  CloudsecSourceModify = 'CloudsecSourceModify',
  CloudsecSourceRead = 'CloudsecSourceRead',
  DataAnalyticsModify = 'DataAnalyticsModify',
  DataAnalyticsRead = 'DataAnalyticsRead',
  DestinationModify = 'DestinationModify',
  DestinationRead = 'DestinationRead',
  GeneralSettingsModify = 'GeneralSettingsModify',
  GeneralSettingsRead = 'GeneralSettingsRead',
  InfraCostRead = 'InfraCostRead',
  LogSourceModify = 'LogSourceModify',
  LogSourceRawDataRead = 'LogSourceRawDataRead',
  LogSourceRead = 'LogSourceRead',
  LookupModify = 'LookupModify',
  LookupRead = 'LookupRead',
  ManageAiResponses = 'ManageAIResponses',
  ManageAiSkills = 'ManageAISkills',
  ManageScheduledPrompts = 'ManageScheduledPrompts',
  McpServerModify = 'McpServerModify',
  McpServerRead = 'McpServerRead',
  NotificationsSend = 'NotificationsSend',
  OrganizationApiTokenModify = 'OrganizationAPITokenModify',
  OrganizationApiTokenRead = 'OrganizationAPITokenRead',
  PolicyModify = 'PolicyModify',
  PolicyRead = 'PolicyRead',
  ResourceModify = 'ResourceModify',
  ResourceRead = 'ResourceRead',
  RuleModify = 'RuleModify',
  RuleRead = 'RuleRead',
  RunPantherAi = 'RunPantherAI',
  SummaryRead = 'SummaryRead',
  UserModify = 'UserModify',
  UserRead = 'UserRead',
  ViewAiPrivateResponses = 'ViewAIPrivateResponses',
  ViewAiSkills = 'ViewAISkills',
  ViewScheduledPrompts = 'ViewScheduledPrompts',
}

export type PoliciesForResourceInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  resourceId?: InputMaybe<Scalars['ID']['input']>;
  severity?: InputMaybe<Severity>;
  status?: InputMaybe<ComplianceStatusEnum>;
  suppressed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Policy = {
  __typename?: 'Policy';
  analysisType: DetectionType;
  body: Scalars['String']['output'];
  complianceStatus?: Maybe<ComplianceStatusEnum>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Actor>;
  createdByExternal?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isSimpleDetection: Scalars['Boolean']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  lastModifiedBy?: Maybe<Actor>;
  managed?: Maybe<Scalars['Boolean']['output']>;
  outputIds: Array<Scalars['ID']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  reports: Array<DetectionReportMapping>;
  resourceTypes?: Maybe<Array<Scalars['String']['output']>>;
  runbook?: Maybe<Scalars['String']['output']>;
  severity: Severity;
  suppressions?: Maybe<Array<Scalars['String']['output']>>;
  tags: Array<Scalars['String']['output']>;
  tests: Array<DetectionTestDefinition>;
  versionId?: Maybe<Scalars['ID']['output']>;
};

export type ProfilePullerConfig = {
  __typename?: 'ProfilePullerConfig';
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  refreshPeriodMin: Scalars['Int']['output'];
};

export type ProfilePullerConfigInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  refreshPeriodMin: Scalars['Int']['input'];
};

export type PullRequestOptions = {
  body?: InputMaybe<Scalars['String']['input']>;
  otherFilePath?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  yamlFilePath?: InputMaybe<Scalars['String']['input']>;
};

export type PullerConfig = {
  __typename?: 'PullerConfig';
  anomali?: Maybe<AnomaliConfig>;
  anthropic?: Maybe<AnthropicConfig>;
  asana?: Maybe<AsanaLogSourceConfig>;
  atlassian?: Maybe<AtlassianConfig>;
  bitwarden?: Maybe<BitwardenConfig>;
  box?: Maybe<OAuthConfig>;
  crowdstrike?: Maybe<CrowdstrikeConfig>;
  crowdstrikeEventStreams?: Maybe<CrowdstrikeEventStreamsConfig>;
  dropbox?: Maybe<OAuthConfig>;
  duo?: Maybe<DuoConfig>;
  generic?: Maybe<GenericPullerConfig>;
  github?: Maybe<GithubLogSourceConfig>;
  greynoise?: Maybe<GreyNoiseConfig>;
  gsuite?: Maybe<GsuiteConfig>;
  m365?: Maybe<M365Config>;
  microsoftGraph?: Maybe<MicrosoftGraphConfig>;
  mongoDb?: Maybe<MongoDBConfig>;
  netskope?: Maybe<NetskopeConfig>;
  okta?: Maybe<OktaConfig>;
  onePassword?: Maybe<OnePasswordConfig>;
  openai?: Maybe<OpenAIConfig>;
  rapid7?: Maybe<Rapid7Config>;
  salesforce?: Maybe<SalesforceConfig>;
  sentinelOneApi?: Maybe<SentinelOneApiConfig>;
  sentinelOneCloudFunnel?: Maybe<SentinelOneCloudFunnelConfig>;
  slack?: Maybe<OAuthConfig>;
  snowflakeaudit?: Maybe<SnowflakeAuditConfig>;
  snyk?: Maybe<SnykLogSourceConfig>;
  sysdig?: Maybe<SysdigConfig>;
  tenable?: Maybe<TenableConfig>;
  tines?: Maybe<TinesConfig>;
  wiz?: Maybe<WizConfig>;
  workday?: Maybe<WorkdayConfig>;
  zendesk?: Maybe<ZendeskLogSourceConfig>;
  zoom?: Maybe<ZoomConfig>;
};

export type PutAlertContextTagInput = {
  tag: Scalars['String']['input'];
};

export type PutAmazonSecurityLakeLogIntegrationInput = {
  externalId: Scalars['String']['input'];
  logProviderId?: InputMaybe<Scalars['String']['input']>;
  queueArn: Scalars['String']['input'];
  roleArn: Scalars['String']['input'];
};

export type PutAzureEventHubLogIntegrationInput = {
  connectionString: Scalars['String']['input'];
  consumerGroup?: InputMaybe<Scalars['String']['input']>;
  logProviderId?: InputMaybe<Scalars['String']['input']>;
  logStreamType: LogStreamType;
  logStreamTypeOptions?: InputMaybe<LogStreamTypeOptionsInput>;
  logTypes: Array<Scalars['String']['input']>;
};

export type PutCorrelationRuleInput = {
  createAlert: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  managed?: InputMaybe<Scalars['Boolean']['input']>;
  outputIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  reports: Array<DetectionReportMappingInput>;
  runbook?: InputMaybe<Scalars['String']['input']>;
  severity: Severity;
  simpleDetectionBody?: InputMaybe<Scalars['String']['input']>;
  summaryAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tests?: InputMaybe<Array<DetectionTestDefinitionInput>>;
};

export type PutEventBridgeIntegrationInput = {
  busNames: Array<Scalars['String']['input']>;
  includeEventType: Scalars['Boolean']['input'];
  logProviderId?: InputMaybe<Scalars['String']['input']>;
  logType: Scalars['String']['input'];
};

export type PutGcpPubSubLogIntegrationInput = {
  gcpPubSubConfig: GcpPubSubLogConfigInput;
  logProviderId?: InputMaybe<Scalars['String']['input']>;
  logStreamType: LogStreamType;
  logStreamTypeOptions?: InputMaybe<LogStreamTypeOptionsInput>;
};

export type PutGcsLogIntegrationInput = {
  gcsConfig: GcsLogConfigInput;
  logProviderId?: InputMaybe<Scalars['String']['input']>;
  logStreamType: LogStreamType;
  logStreamTypeOptions?: InputMaybe<LogStreamTypeOptionsInput>;
};

export type PutHttpLogIntegrationInput = {
  httpConfig: HttpLogConfigInput;
  logProviderId?: InputMaybe<Scalars['String']['input']>;
};

export type PutLogForwarderLogIntegrationInput = {
  logForwarderConfig: LogForwarderLogConfigInput;
  logProviderId?: InputMaybe<Scalars['String']['input']>;
};

export type PutLogPullingIntegrationInput = {
  anthropic?: InputMaybe<AnthropicConfigInput>;
  asana?: InputMaybe<AsanaLogSourceConfigInput>;
  atlassian?: InputMaybe<AtlassianConfigInput>;
  bitwarden?: InputMaybe<BitwardenConfigInput>;
  box?: InputMaybe<OAuthConfigInput>;
  crowdstrike?: InputMaybe<CrowdstrikeInput>;
  crowdstrikeEventStreams?: InputMaybe<CrowdstrikeEventStreamsConfigInput>;
  dropbox?: InputMaybe<OAuthConfigInput>;
  duo?: InputMaybe<DuoConfigInput>;
  generic?: InputMaybe<GenericPullerConfigInput>;
  github?: InputMaybe<GithubLogSourceInput>;
  gsuite?: InputMaybe<GsuiteConfigInput>;
  logTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  m365?: InputMaybe<M365ConfigInput>;
  microsoftGraph?: InputMaybe<MicrosoftGraphConfigInput>;
  mongoDb?: InputMaybe<MongoDBConfigInput>;
  netskope?: InputMaybe<NetskopeConfigInput>;
  okta?: InputMaybe<OktaConfigInput>;
  onePassword?: InputMaybe<OnePasswordConfigInput>;
  openai?: InputMaybe<OpenAIConfigInput>;
  rapid7?: InputMaybe<Rapid7ConfigInput>;
  salesforce?: InputMaybe<SalesforceConfigInput>;
  sentinelOneApi?: InputMaybe<SentinelOneApiConfigInput>;
  sentinelOneCloudFunnel?: InputMaybe<SentinelOneCloudFunnelConfigInput>;
  slack?: InputMaybe<OAuthConfigInput>;
  snowflakeaudit?: InputMaybe<SnowflakeAuditConfigInput>;
  snyk?: InputMaybe<SnykConfigInput>;
  sysdig?: InputMaybe<SysdigConfigInput>;
  tenable?: InputMaybe<TenableConfigInput>;
  tines?: InputMaybe<TinesConfigInput>;
  wiz?: InputMaybe<WizConfigInput>;
  workday?: InputMaybe<WorkdayConfigInput>;
  zendesk?: InputMaybe<ZendeskLogSourceInput>;
  zoom?: InputMaybe<ZoomConfigInput>;
};

export type PutNotificationPreferencesInput = {
  preferences: Array<NotificationPreferenceInput>;
};

export type PutOTLPLogIntegrationInput = {
  logProviderId?: InputMaybe<Scalars['String']['input']>;
  otlpConfig: OTLPLogConfigInput;
};

export type PutSqsLogIntegrationInput = {
  logProviderId?: InputMaybe<Scalars['String']['input']>;
  sqsConfig: SqsLogConfigInput;
};

export type PutUserPreferencesInput = {
  aiPrompt?: InputMaybe<Scalars['String']['input']>;
  bookmarkedConversationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  displayUtcTimeZone?: InputMaybe<Scalars['Boolean']['input']>;
  receiveAlertAssignmentEmails?: InputMaybe<Scalars['Boolean']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
};

/** The top-level Query type. Queries are used to fetch data. */
export type Query = {
  __typename?: 'Query';
  /** Returns a single AI conversation by ID */
  aiConversation: AIConversation;
  /** Returns a paginated list of AI conversations for the current user */
  aiConversations: AIConversationsOutput;
  /**
   * Returns the output of an inference call (e.g., aiSummarizeLogEvents).
   * The streamId is the id of the stream where inference responses are written.
   * You may pass in the associated alias as the streamId.
   * Caller should poll until `finished` is true then check `error`.
   */
  aiInferenceStream: AIInferenceStream;
  /**
   * Returns the metadata for a stream with its immediate children and the path to the root.
   * Used to display "breadcrumbs" for the stream and its children in the UI.
   */
  aiInferenceStreamMetadataWithPath: AIInferenceStreamMetadataWithPath;
  /** Returns the results of a text search over all inference streams */
  aiInferenceStreamTextSearch: AIInferenceStreamTextSearchResultList;
  /** Returns the metadata for up to 100 most recent inference streams by alias. */
  aiInferenceStreamsMetadata: AIInferenceStreamsMetadataList;
  /** Returns a single AI skill by ID */
  aiSkill: AISkillOutput;
  /** Returns a paginated list of AI skills */
  aiSkills: AISkillsOutput;
  /**
   * Looks up whether an AI inference stream has been migrated to a conversation.
   * Accepts either an aistream-* ID or aiconv-* ID.
   * Returns the conversation ID if the stream exists and was migrated, null otherwise.
   */
  aiStreamConversationLookup: AIStreamConversationLookupOutput;
  aiUsage: AIUsageOutput;
  /** Returns the details of a Panther alert */
  alert: Alert;
  alertDashboardData: AlertDashboardDataOutput;
  /** Returns a filtered & paginated set of all Panther alerts. */
  alerts: AlertsOutput;
  /** Returns all databases, tables, columns, and properties of columns a user has */
  allDatalakeSchemaEntities: AllDatalakeSchemaEntitiesOutput;
  /** Returns all properties a user has in the datalake, deduplicated by path and type. */
  allDatalakeSchemaProperties: AllDatalakeSchemaPropertiesOutput;
  appConfig: AppConfig;
  /** Parses array of strings and attempts to detect types to generate p_any filters used in search UI. */
  autodetectIndicatorFilters: AutodetectIndicatorFiltersOutput;
  bulkDownload: BulkDownloadResponse;
  /**
   * Returns a presigned S3 URL for downloading one or more scheduled prompts as YAML.
   * When scheduledPromptIds contains a single ID, the URL points at a single .yml file.
   * When scheduledPromptIds contains multiple IDs (or is null/empty for "download all"),
   * the URL points at a .zip archive of YAML files. Soft-deleted prompts are excluded.
   * Like bulkDownloadSkillsUrl, this path reads stored YAML and consumes no inference
   * tokens, so RunPantherAI is intentionally NOT required — keeping exports available
   * on token-gated tenants.
   */
  bulkDownloadScheduledPromptsUrl: BulkDownloadUrlResponse;
  /**
   * Returns a presigned S3 URL for downloading one or more AI skills as YAML.
   * When skillIds contains a single ID, the URL points at a single .yml file.
   * When skillIds contains multiple IDs (or is null/empty for "download all"),
   * the URL points at a .zip archive of YAML files. Panther-managed and deleted
   * skills are excluded.
   */
  bulkDownloadSkillsUrl: BulkDownloadUrlResponse;
  bulkDownloadUrl: BulkDownloadUrlResponse;
  /** Get the status of a bulk upload job */
  bulkUploadDetectionsStatus: BulkUploadJob;
  /** Get a pre-signed URL for a bulk upload of detection entities */
  bulkUploadPresignedUrl: BulkUploadPresignedUrlOutput;
  catalogDataModels: ListCatalogDataModelsOutput;
  catalogDetections: ListCatalogDetectionsOutput;
  catalogEnrichments: ListCatalogEnrichmentsOutput;
  catalogGlobalHelpers: ListCatalogGlobalHelpersOutput;
  catalogQueries: ListCatalogQueriesOutput;
  checkGenerateSchemaFromSqlJob: GenerateSchemaFromSqlJob;
  checkIfPacksNeedMigrating: PackMigrationStatus;
  /**
   * Polls the status of the job for importing data into a lookup table, and, if the
   * job is complete, returns the results of the job.
   */
  checkLookupImportDataJob: LookupImportDataJob;
  checkSaveLookupJob: SaveLookupJob;
  checkSyncLookupDataJob: LookupSyncJob;
  checkUpdateAllCatalogItemsJob?: Maybe<UpdateAllCatalogItemsJob>;
  /** Returns a Cloud Account by ID */
  cloudAccount?: Maybe<CloudAccount>;
  /** Returns all Cloud Accounts */
  cloudAccounts: CloudAccountsOutput;
  correlationRule?: Maybe<CorrelationRule>;
  dashboard: Dashboard;
  dashboards: DashboardsOutput;
  /** Retrieves the details of a single data lake database */
  dataLakeDatabase: DataLakeDatabase;
  /** Retrieves the details of a table from a single data lake database */
  dataLakeDatabaseTable: DataLakeDatabaseTable;
  /** Retrieves all tables from a single database */
  dataLakeDatabaseTables: DataLakeDatabaseTablesOutput;
  /** Lists the details of all available data lake databases */
  dataLakeDatabases: Array<DataLakeDatabase>;
  dataLakePropertyDefinitions: DataLakePropertyDefinitionsOutput;
  /** Returns a paginated list of all your previously executed data lake or indicator search queries */
  dataLakeQueries: DataLakeQueriesOutput;
  /** Returns information about previously executed data lake or indicator search query. In the case of a query constructed through the query builder, specifying `root=true` will return the parent execution */
  dataLakeQuery: DataLakeQuery;
  dataLakeQuerySummary: SummarizeDataLakeQueryJob;
  /**
   * Gets a list of values from the datalake for a given field. Will return at most 10,000 values. It
   * will return less if there are less values available or it reaches the max size limit of 5mb.
   */
  datalakeFieldValues: DatalakeFieldValuesOutput;
  destination?: Maybe<Destination>;
  destinations?: Maybe<Array<Maybe<Destination>>>;
  detection?: Maybe<GetDetectionResponse>;
  detectionAlertMetrics: DetectionAlertMetricsOutput;
  /** Get the status of an asynchronous bulk upload of detection entities */
  detectionEntitiesUploadStatus?: Maybe<DetectionEntitiesUploadStatusOutput>;
  detectionFilter: DetectionFilter;
  detectionStats: DetectionStatsResponse;
  detections: ListDetectionsResponse;
  /**
   * Probes a TAXII 2.1 server's discovery endpoint and returns all readable, STIX-capable
   * collections. When integrationId is set and credentials are blank, the stored credentials
   * of that integration are used, so edit flows never re-send secrets.
   */
  discoverTaxiiCollections: DiscoverTaxiiCollectionsOutput;
  enrichmentIntegration: EnrichmentIntegration;
  /** Get one or more feature flag treatments by name */
  featureFlags: GetFeatureFlagsResponse;
  filterFields: FilterFieldsOutput;
  flatFilterFields: FlatFilterFieldsOutput;
  /** Returns Panther general settings */
  generalSettings: GeneralSettingsConfig;
  generateAlertSummaryAttributesQueries: Array<AlertSummaryAttributeForAnalysis>;
  /** Generate an enriched event from a single JSON-format Log Event */
  generateEnrichedEvent: GenerateEnrichedEventResponse;
  generateLogForwarderConfig: LogForwarderConfigYaml;
  generateSimpleSearchQuery: GenerateSimpleSearchQueryOutput;
  generateSqlQuerySnippet: GenerateSqlQuerySnippetOutput;
  /** Returns results table metadata for an uber search */
  generateUberSearchQuery: GenerateUberSearchQueryOutput;
  getAPIToken: GetAPITokenOutput;
  getAnalysisPack: AnalysisPack;
  getAnalysisPackSource: AnalysisPackSource;
  getAsyncQueryDownloadUrl: GetAsyncQueryDownloadUrlOutput;
  /** Returns the information of a particular 3rd-party log service or provider that Panther supports */
  getAvailableLogProvider: GetAvailableLogProviderResponse;
  getCloudWatchLogIntegrationTemplate: IntegrationTemplate;
  getComplianceIntegrationTemplate: IntegrationTemplate;
  getDataModel?: Maybe<DataModel>;
  getGlobalHelper: GlobalHelper;
  getLookup: Lookup;
  getLookupCloudFormationRoleTemplate: IntegrationTemplate;
  /** Returns statistics about lookup tables including total count and enabled/disabled counts. */
  getLookupStats: LookupStats;
  /**
   * The return argument is intentionally not required as a running
   * task may not be available
   */
  getRunningTask?: Maybe<Job>;
  getS3LogIntegrationTemplate: IntegrationTemplate;
  getSampleData: GetSampleDataResponse;
  getSavedQuery: SavedQuery;
  getSchema: GetSchemaOutput;
  getTerraformTemplate: TerraformTemplateResponse;
  holdingTankJob: Job;
  holdingTankRawData: HoldingTankRawDataResponse;
  holdingTankTestSchemasResult: HoldingTankTestSchemasResultsResponse;
  infraCostReport: InfraCostOutput;
  ingestionMonitoringSummary: IngestionMonitoringSummary;
  installedCatalogItemUpdateStatuses: ListInstalledCatalogItemUpdateStatusesOutput;
  installedCatalogItems: ListInstalledCatalogItemsOutput;
  /**
   * Returns active (enabled, non-deleted) AI skills for the chat editor's /-picker,
   * sorted alphabetically by name. The chat mutation re-validates at session
   * creation and rejects with SKILL_NOT_INVOKABLE if a picked skill is not
   * registerable in the resulting session.
   *
   * `entryPoint` should match the entry point the resulting chat session will be
   * created with (e.g. "alert", "detection-author"). Omit for default-entry-point
   * chats. Tools gated by required/excluded entry points are evaluated against
   * this value so picker visibility matches session registration.
   */
  invokableAISkills: Array<AISkillListItem>;
  jiraOrgMetadata?: Maybe<JiraOrgMetadata>;
  listAPITokens: ListAPITokensOutput;
  listAlertContextTags: ListAlertContextTagsOutput;
  listAnalysisItemsForWorkbench: ListAnalysisItemsForWorkbenchOutput;
  listAnalysisPackSources: ListAnalysisPackSourcesResponse;
  listAnalysisPacks: ListAnalysisPacksResponse;
  /** Lists information around the 3rd-party log services or providers that Panther supports */
  listAvailableLogProviders: ListAvailableLogProvidersResponse;
  /** Lists all the available log types that this Panther installation supports */
  listAvailableLogTypes: ListAvailableLogTypesResponse;
  listBucketKeys: ListBucketKeysResponse;
  listDataModels: ListDataModelsResponse;
  listGitConfigs?: Maybe<ListGitConfigsResponse>;
  listGlobalHelpers: ListGlobalHelpersResponse;
  /** Returns a paginated list of lookup tables. */
  listLookups: ListLookupResponse;
  listSavedQueries: ListSavedQueriesResponse;
  /**
   * Returns a paginated list of scheduled prompts. Reads stored records and consumes no
   * inference tokens, so RunPantherAI is intentionally NOT required (matches
   * bulkDownloadScheduledPromptsUrl) — ViewScheduledPrompts alone gates it.
   */
  listScheduledPrompts: ListScheduledPromptsResponse;
  listTasks: HoldingTankListTasksResponse;
  loadAnalysisItemForWorkbench: LoadAnalysisItemForWorkbenchOutput;
  logSource: LogIntegration;
  logSources: Array<Maybe<LogIntegration>>;
  /** Looks up key in all active lookup tables. */
  lookupEnrich: LookupEnrichOutput;
  /**
   * Get a single MCP server configuration by ID.
   * Includes the current user's connection (with status and tools) if connected.
   */
  mcpServer?: Maybe<McpServer>;
  /**
   * List the user IDs granted access to an AWS SigV4 MCP server.
   * Scoped to SigV4 servers today; OAuth2 servers manage access per-user via the
   * OAuth handshake. If we ever want a unified view of who has onboarded any server
   * type, this can be generalized beyond SigV4.
   */
  mcpServerAccess: Array<Scalars['ID']['output']>;
  /**
   * List configured MCP servers with pagination.
   * Each server includes the current user's connection status if connected.
   */
  mcpServers: McpServersOutput;
  /** Returns Data & Alert metrics about your Panther installation */
  metrics: MetricsOutput;
  mitreMatrix?: Maybe<MitreMatrix>;
  mitreMatrixTree: MitreMatrixTree;
  mitreTacticAndTechnique: MitreCombo;
  notificationPreferences: NotificationPreferencesOutput;
  notifications: NotificationsOutput;
  organizationStats?: Maybe<OrganizationStatsResponse>;
  /**
   * Returns whether Panther AI is enabled for the organization.
   * Lightweight query so that users with only the RunPantherAI permission can
   * gate AI navigation without needing access to the full generalSettings.
   */
  pantherAIEnabled: Scalars['Boolean']['output'];
  /** Inserts parameters into a PantherFlow query and returns the resulting PantherFlow query */
  pantherFlowQueryWithParameters: PantherFlowQueryWithParametersOutput;
  policiesForResource?: Maybe<ListComplianceItemsResponse>;
  policy?: Maybe<Policy>;
  pypantherVersion?: Maybe<Scalars['String']['output']>;
  replay: Replay;
  replayPreview: ReplayPreview;
  replayedAlert: Alert;
  replayedAlerts: ReplayedAlertsOutput;
  replays: Array<Replay>;
  reportSetting: ReportSetting;
  resource?: Maybe<ResourceDetails>;
  resources?: Maybe<ListResourcesResponse>;
  resourcesForPolicy?: Maybe<ListComplianceItemsResponse>;
  /** Returns a role matching the provided ID */
  roleById: Role;
  /** Returns a role matching the provided case-insensitive name */
  roleByName: Role;
  /** Returns a list of Panther user roles */
  roles: Array<Role>;
  rule?: Maybe<Rule>;
  /** Get Rule's python body and tests */
  rulePythonBody?: Maybe<RulePythonBodyOutput>;
  ruleV2?: Maybe<Rule>;
  /**
   * Live runbook execution state for an alert, derived deterministically from the alert's AI
   * conversation snapshot — no AI inference is run. Intended for frontend polling.
   *
   * Returns null (never an error) when there is no conversation for the alert, the conversation
   * has no structured runbook, or the runbook snapshot is malformed.
   */
  runbookExecutionState?: Maybe<RunbookExecutionState>;
  samlConfig: SamlConfig;
  /**
   * Returns a single scheduled prompt by ID. Reads a stored record and consumes no inference
   * tokens, so RunPantherAI is intentionally NOT required (matches bulkDownloadScheduledPromptsUrl).
   */
  scheduledPrompt?: Maybe<ScheduledPrompt>;
  schemas: SchemasOutput;
  sendTestAlert: Array<Maybe<AlertDelivery>>;
  /** Returns a Log Source by ID */
  source?: Maybe<LogIntegration>;
  sourceMetrics: SourceMetricsResponse;
  sourceStatistics: SourceStatisticsResponse;
  /** Returns all Log Sources */
  sources: SourcesOutput;
  testFilterEvent: TestFilterEventOutput;
  /** Returns results for an uber search. */
  uberSearch: DataLakeQuery;
  /** Wraps getAsyncQueryDownloadUrl for an uberSearch */
  uberSearchAsyncQueryDownloadUrl: GetAsyncQueryDownloadUrlOutput;
  /** Returns a summary for column/jsonPath values in an uber search result */
  uberSearchColumnSummary: DataLakeQuery;
  /** Returns a summary for property values in an uber search result */
  uberSearchPropertySummary: DataLakePropertySummary;
  /** Returns results table metadata for an uber search */
  uberSearchTables: UberSearchTablesOutput;
  /** Returns results for an uber search visualization */
  uberSearchVisualization: DataLakeQueryVisualization;
  universalSettings: UniversalSettingsConfig;
  /** Returns a single user by Email Address */
  userByEmail: User;
  /** Returns a single user by ID */
  userById: User;
  userPreferences: UserPreferencesOutput;
  /** Returns a list of Panther user accounts */
  users: Array<User>;
  /** Get the status of a validate bulk upload request */
  validateBulkUploadStatus?: Maybe<ValidateUploadStatusOutput>;
  viewBucketData: HoldingTankRawDataResponse;
  viewParsedEvents: ViewParsedEventsResponse;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryAiConversationArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryAiConversationsArgs = {
  input?: InputMaybe<AIConversationsInput>;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryAiInferenceStreamArgs = {
  streamId: Scalars['String']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryAiInferenceStreamMetadataWithPathArgs = {
  streamId: Scalars['String']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryAiInferenceStreamTextSearchArgs = {
  input: AIInferenceStreamTextSearchInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryAiInferenceStreamsMetadataArgs = {
  input: AIInferenceStreamsMetadataInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryAiSkillArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryAiSkillsArgs = {
  input?: InputMaybe<AISkillsInput>;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryAiStreamConversationLookupArgs = {
  id: Scalars['String']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryAlertArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryAlertDashboardDataArgs = {
  input?: InputMaybe<AlertDashboardDataInput>;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryAlertsArgs = {
  input: AlertsInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryAllDatalakeSchemaEntitiesArgs = {
  input: AllDatalakeSchemaEntitiesInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryAllDatalakeSchemaPropertiesArgs = {
  input: AllDatalakeSchemaPropertiesInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryAutodetectIndicatorFiltersArgs = {
  input: AutodetectIndicatorFiltersInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryBulkDownloadArgs = {
  input: BulkDownloadInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryBulkDownloadScheduledPromptsUrlArgs = {
  input: BulkDownloadScheduledPromptsInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryBulkDownloadSkillsUrlArgs = {
  input: BulkDownloadSkillsInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryBulkDownloadUrlArgs = {
  input: BulkDownloadInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryBulkUploadDetectionsStatusArgs = {
  jobId: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryBulkUploadPresignedUrlArgs = {
  input: GetPresignedUploadURLInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryCatalogDataModelsArgs = {
  input: ListCatalogDataModelsInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryCatalogDetectionsArgs = {
  input: ListCatalogDetectionsInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryCatalogEnrichmentsArgs = {
  input: ListCatalogEnrichmentsInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryCatalogGlobalHelpersArgs = {
  input: ListCatalogGlobalHelpersInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryCatalogQueriesArgs = {
  input: ListCatalogQueriesInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryCheckGenerateSchemaFromSqlJobArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryCheckLookupImportDataJobArgs = {
  jobId: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryCheckSaveLookupJobArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryCheckSyncLookupDataJobArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryCloudAccountArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryCloudAccountsArgs = {
  input?: InputMaybe<CloudAccountsInput>;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryCorrelationRuleArgs = {
  input: GetCorrelationRuleInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryDashboardArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryDashboardsArgs = {
  input?: InputMaybe<DashboardsInput>;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryDataLakeDatabaseArgs = {
  name: Scalars['String']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryDataLakeDatabaseTableArgs = {
  input: DataLakeDatabaseTableInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryDataLakeDatabaseTablesArgs = {
  input: DataLakeDatabaseTablesInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryDataLakePropertyDefinitionsArgs = {
  input?: InputMaybe<DataLakePropertyDefinitionsInput>;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryDataLakeQueriesArgs = {
  input?: InputMaybe<DataLakeQueriesInput>;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryDataLakeQueryArgs = {
  id: Scalars['ID']['input'];
  root?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryDataLakeQuerySummaryArgs = {
  jobId: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryDatalakeFieldValuesArgs = {
  input: DatalakeFieldValuesInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryDestinationArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryDetectionArgs = {
  input: GetDetectionInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryDetectionAlertMetricsArgs = {
  input?: InputMaybe<DetectionAlertMetricsInput>;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryDetectionEntitiesUploadStatusArgs = {
  receiptId: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryDetectionFilterArgs = {
  detectionId: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryDetectionsArgs = {
  input?: InputMaybe<ListDetectionsInput>;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryDiscoverTaxiiCollectionsArgs = {
  input: DiscoverTaxiiCollectionsInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryEnrichmentIntegrationArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryFeatureFlagsArgs = {
  input: GetFeatureFlagsInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryFilterFieldsArgs = {
  input: FilterFieldsInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryFlatFilterFieldsArgs = {
  input: FlatFilterFieldsInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryGenerateAlertSummaryAttributesQueriesArgs = {
  input: GenerateAlertSummaryAttributesQueriesInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryGenerateEnrichedEventArgs = {
  input: GenerateEnrichedEventInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryGenerateLogForwarderConfigArgs = {
  input: GenerateLogForwarderConfigInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryGenerateSimpleSearchQueryArgs = {
  input: GenerateSimpleSearchQueryInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryGenerateSqlQuerySnippetArgs = {
  input: GenerateSqlQuerySnippetInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryGenerateUberSearchQueryArgs = {
  input?: InputMaybe<GenerateUberSearchQueryInput>;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryGetAPITokenArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryGetAnalysisPackArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryGetAnalysisPackSourceArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryGetAsyncQueryDownloadUrlArgs = {
  input: GetAsyncQueryDownloadUrlInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryGetAvailableLogProviderArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryGetCloudWatchLogIntegrationTemplateArgs = {
  input: GetCloudWatchLogIntegrationTemplateInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryGetComplianceIntegrationTemplateArgs = {
  input: GetComplianceIntegrationTemplateInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryGetDataModelArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryGetGlobalHelperArgs = {
  input: GetGlobalHelperInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryGetLookupArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryGetLookupCloudFormationRoleTemplateArgs = {
  input: GetLookupCloudFormationRoleTemplateInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryGetRunningTaskArgs = {
  input: HoldingTankGetRunningTaskInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryGetS3LogIntegrationTemplateArgs = {
  input: GetS3LogIntegrationTemplateInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryGetSampleDataArgs = {
  input: GetSampleDataInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryGetSavedQueryArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryGetSchemaArgs = {
  input: GetSchemaInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryGetTerraformTemplateArgs = {
  input: GetTerraformTemplateInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryHoldingTankJobArgs = {
  id: Scalars['String']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryHoldingTankRawDataArgs = {
  input: HoldingTankRawDataInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryHoldingTankTestSchemasResultArgs = {
  input?: InputMaybe<HoldingTankTestSchemasResultInput>;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryInfraCostReportArgs = {
  input: InfraCostInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryInstalledCatalogItemUpdateStatusesArgs = {
  input: ListInstalledCatalogItemUpdateStatusesInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryInstalledCatalogItemsArgs = {
  input: ListInstalledCatalogItemsInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryInvokableAISkillsArgs = {
  entryPoint?: InputMaybe<Scalars['String']['input']>;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryJiraOrgMetadataArgs = {
  input: JiraOrgMetadataInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryListAnalysisItemsForWorkbenchArgs = {
  input: ListAnalysisItemsForWorkbenchInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryListAnalysisPackSourcesArgs = {
  input?: InputMaybe<ListAnalysisPackSourcesInput>;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryListAnalysisPacksArgs = {
  input?: InputMaybe<ListAnalysisPacksInput>;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryListBucketKeysArgs = {
  input: ListBucketKeysInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryListDataModelsArgs = {
  input: ListDataModelsInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryListGitConfigsArgs = {
  input: ListGitConfigsInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryListGlobalHelpersArgs = {
  input: ListGlobalHelpersInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryListLookupsArgs = {
  input: ListLookupsInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryListSavedQueriesArgs = {
  input: ListSavedQueriesInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryListScheduledPromptsArgs = {
  input?: InputMaybe<ListScheduledPromptsInput>;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryListTasksArgs = {
  sourceId: Scalars['String']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryLoadAnalysisItemForWorkbenchArgs = {
  input: LoadAnalysisItemForWorkbenchInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryLogSourceArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryLookupEnrichArgs = {
  key: Scalars['String']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryMcpServerArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryMcpServerAccessArgs = {
  serverId: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryMcpServersArgs = {
  input?: InputMaybe<ListMcpServersInput>;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryMetricsArgs = {
  input: MetricsInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryMitreMatrixArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryMitreTacticAndTechniqueArgs = {
  tacticId: Scalars['ID']['input'];
  techniqueId: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryNotificationsArgs = {
  input: NotificationsInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryOrganizationStatsArgs = {
  input?: InputMaybe<OrganizationStatsInput>;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryPantherFlowQueryWithParametersArgs = {
  input: PantherFlowQueryWithParametersInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryPoliciesForResourceArgs = {
  input?: InputMaybe<PoliciesForResourceInput>;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryPolicyArgs = {
  input: GetPolicyInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryReplayArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryReplayPreviewArgs = {
  dataWindow: DataWindowInput;
  logTypes: Array<Scalars['String']['input']>;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryReplayedAlertArgs = {
  alertId: Scalars['ID']['input'];
  replayId: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryReplayedAlertsArgs = {
  input: ReplayedAlertsInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryReplaysArgs = {
  detectionId: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryReportSettingArgs = {
  tacticId: Scalars['ID']['input'];
  techniqueId: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryResourceArgs = {
  input: GetResourceInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryResourcesArgs = {
  input?: InputMaybe<ListResourcesInput>;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryResourcesForPolicyArgs = {
  input: ResourcesForPolicyInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryRoleByIdArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryRoleByNameArgs = {
  name: Scalars['String']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryRolesArgs = {
  input?: InputMaybe<RolesInput>;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryRuleArgs = {
  input: GetRuleInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryRulePythonBodyArgs = {
  input: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryRuleV2Args = {
  input: GetRuleV2Input;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryRunbookExecutionStateArgs = {
  alertId: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryScheduledPromptArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QuerySchemasArgs = {
  input: SchemasInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QuerySendTestAlertArgs = {
  input: SendTestAlertInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QuerySourceArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QuerySourceMetricsArgs = {
  input: SourceMetricsInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QuerySourceStatisticsArgs = {
  input: SourceStatisticsInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QuerySourcesArgs = {
  input?: InputMaybe<SourcesInput>;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryTestFilterEventArgs = {
  input: TestFilterEventInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryUberSearchArgs = {
  component: UberSearchComponent;
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryUberSearchAsyncQueryDownloadUrlArgs = {
  component: UberSearchComponent;
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryUberSearchColumnSummaryArgs = {
  input?: InputMaybe<UberSearchColumnSummaryInput>;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryUberSearchPropertySummaryArgs = {
  input?: InputMaybe<UberSearchPropertySummaryInput>;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryUberSearchTablesArgs = {
  input?: InputMaybe<UberSearchTablesInput>;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryUberSearchVisualizationArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryUserByEmailArgs = {
  email: Scalars['String']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryUserByIdArgs = {
  id: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryValidateBulkUploadStatusArgs = {
  receiptId: Scalars['ID']['input'];
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryViewBucketDataArgs = {
  input: ViewBucketDataInput;
};

/** The top-level Query type. Queries are used to fetch data. */
export type QueryViewParsedEventsArgs = {
  input: ViewParsedEventsInput;
};

export type QueryChartPropertyConfig = {
  __typename?: 'QueryChartPropertyConfig';
  chartType: QueryChartType;
  colorHexes?: Maybe<Array<Scalars['String']['output']>>;
  limit: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  propertyDisplayName: Scalars['String']['output'];
  propertyId: Scalars['ID']['output'];
  propertyPath: Scalars['String']['output'];
  propertyTableName: Scalars['String']['output'];
  sortDirection: DataLakeQuerySortDirection;
};

export type QueryChartPropertyConfigInput = {
  chartType: QueryChartType;
  colorHexes?: InputMaybe<Array<Scalars['String']['input']>>;
  limit: Scalars['Int']['input'];
  order: Scalars['Int']['input'];
  propertyId: Scalars['ID']['input'];
  sortDirection: DataLakeQuerySortDirection;
};

export enum QueryChartType {
  HorizontalBar = 'horizontalBar',
}

export type QueryTablePropertyConfig = {
  __typename?: 'QueryTablePropertyConfig';
  order: Scalars['Int']['output'];
  propertyDisplayName: Scalars['String']['output'];
  propertyId: Scalars['ID']['output'];
  propertyPath: Scalars['String']['output'];
  propertyTableName: Scalars['String']['output'];
};

export type QueryTablePropertyConfigInput = {
  order: Scalars['Int']['input'];
  propertyId: Scalars['ID']['input'];
};

export type QueryUserConfig = {
  __typename?: 'QueryUserConfig';
  chartProperties: Array<QueryChartPropertyConfig>;
  queryId: Scalars['ID']['output'];
  tableProperties: Array<QueryTablePropertyConfig>;
};

export type RSAKey = {
  __typename?: 'RSAKey';
  publicKey?: Maybe<Scalars['String']['output']>;
  publicKey2?: Maybe<Scalars['String']['output']>;
  rotated: Scalars['Boolean']['output'];
  secretARN: Scalars['String']['output'];
};

export type Rapid7Config = {
  __typename?: 'Rapid7Config';
  apiKey: Scalars['String']['output'];
  storageRegion: Scalars['String']['output'];
};

export type Rapid7ConfigInput = {
  apiKey: Scalars['String']['input'];
  storageRegion: Scalars['String']['input'];
};

export type Rapid7InsightConnectConfig = {
  __typename?: 'Rapid7InsightConnectConfig';
  apiKey: Scalars['String']['output'];
  workflowURL: Scalars['String']['output'];
};

export type Rapid7InsightConnectConfigInput = {
  apiKey: Scalars['String']['input'];
  workflowURL: Scalars['String']['input'];
};

export type RawFilter = {
  __typename?: 'RawFilter';
  description: Scalars['String']['output'];
  filterType: FilterType;
  isEnabled: Scalars['Boolean']['output'];
  mode: FilterMode;
  pattern: Scalars['String']['output'];
};

export type RawFiltersInput = {
  description: Scalars['String']['input'];
  filterType: FilterType;
  isEnabled: Scalars['Boolean']['input'];
  mode: FilterMode;
  pattern: Scalars['String']['input'];
};

export type ReclassifySourceAlarmJob = Job & {
  __typename?: 'ReclassifySourceAlarmJob';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Actor>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  status: JobStatus;
  taskType: Scalars['String']['output'];
};

export type RelatedAlertsOutput = {
  __typename?: 'RelatedAlertsOutput';
  edges: Array<RelatedAlertsOutputEdge>;
  pageInfo: RelatedAlertsOutputPageInfo;
};

export type RelatedAlertsOutputEdge = {
  __typename?: 'RelatedAlertsOutputEdge';
  node: Alert;
};

export type RelatedAlertsOutputPageInfo = {
  __typename?: 'RelatedAlertsOutputPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** The Panther component related to the System Error at hand */
export enum RelatedComponent {
  CloudAccount = 'CLOUD_ACCOUNT',
  Destination = 'DESTINATION',
  Detection = 'DETECTION',
  Enrichment = 'ENRICHMENT',
  GitConfig = 'GIT_CONFIG',
  LogSource = 'LOG_SOURCE',
  LookupTable = 'LOOKUP_TABLE',
  SavedQuery = 'SAVED_QUERY',
}

export type RenameAlertContextTagInput = {
  newTag: Scalars['String']['input'];
  oldTag: Scalars['String']['input'];
};

/** Details of a Replay */
export type Replay = {
  __typename?: 'Replay';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  detectionId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  queryIds?: Maybe<Array<Scalars['String']['output']>>;
  replayType: Scalars['String']['output'];
  scope: ReplayScope;
  state: ReplayState;
  summary: ReplaySummary;
  updatedAt: Scalars['DateTime']['output'];
};

export type ReplayPreview = {
  __typename?: 'ReplayPreview';
  errInstanceTooNew: Scalars['Boolean']['output'];
  logDataSizeEstimate: Scalars['Int']['output'];
  timeEstimate: Scalars['Int']['output'];
};

/** The context on which a replay is performed */
export type ReplayScope = {
  __typename?: 'ReplayScope';
  dataWindow: DataWindow;
  logTypes: Array<Scalars['String']['output']>;
};

export enum ReplayState {
  Canceled = 'CANCELED',
  ComputationInProgress = 'COMPUTATION_IN_PROGRESS',
  Done = 'DONE',
  ErrorComputation = 'ERROR_COMPUTATION',
  ErrorEvaluation = 'ERROR_EVALUATION',
  EvaluationInProgress = 'EVALUATION_IN_PROGRESS',
  Unknown = 'UNKNOWN',
}

/** Replay statistics */
export type ReplaySummary = {
  __typename?: 'ReplaySummary';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  computationProgress: Scalars['Int']['output'];
  evaluationProgress: Scalars['Int']['output'];
  eventsMatchedCount: Scalars['Int']['output'];
  eventsProcessedCount: Scalars['Int']['output'];
  logDataSizeEstimate: Scalars['Int']['output'];
  matchesProcessedCount: Scalars['Int']['output'];
  processingTimeNanos: Scalars['Int']['output'];
  readTimeNanos: Scalars['Int']['output'];
  ruleErrorCount: Scalars['Int']['output'];
  ruleMatchCount: Scalars['Int']['output'];
  totalAlerts: Scalars['Int']['output'];
};

export type ReplayedAlertsInput = {
  createdAtAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtBefore?: InputMaybe<Scalars['DateTime']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  eventCountMax?: InputMaybe<Scalars['Int']['input']>;
  eventCountMin?: InputMaybe<Scalars['Int']['input']>;
  logTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  pageSize: Scalars['Int']['input'];
  replayId: Scalars['ID']['input'];
  severities?: InputMaybe<Array<Scalars['String']['input']>>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ReplayedAlertsOutput = {
  __typename?: 'ReplayedAlertsOutput';
  alerts: Array<Alert>;
  cursor?: Maybe<Scalars['String']['output']>;
};

export enum ReportOverrideSetting {
  Covered = 'COVERED',
  Ignored = 'IGNORED',
  None = 'NONE',
  NotCovered = 'NOT_COVERED',
  Unknown = 'UNKNOWN',
}

export type ReportSetting = {
  __typename?: 'ReportSetting';
  association: ReportSettingAssociation;
  detections: Array<InternalDetection>;
  id: Scalars['ID']['output'];
  matchingDetectionIds: Array<Scalars['String']['output']>;
  matchingLogTypes: Array<Scalars['String']['output']>;
  note: Scalars['String']['output'];
  override: ReportOverrideSetting;
  reportType: ReportType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Actor>;
};

export type ReportSettingAssociation = {
  __typename?: 'ReportSettingAssociation';
  mitre: ReportSettingAssociationMitre;
};

export type ReportSettingAssociationMitre = {
  __typename?: 'ReportSettingAssociationMitre';
  tactic: MitreTactic;
  tacticId: Scalars['String']['output'];
  technique: MitreTechnique;
  techniqueId: Scalars['String']['output'];
};

export enum ReportType {
  Mitre = 'MITRE',
  Unknown = 'UNKNOWN',
}

export type RequestSourceInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type RequestSourceOutput = {
  __typename?: 'RequestSourceOutput';
  id: Scalars['String']['output'];
};

/** The input for the resetUserPassword mutation */
export type ResetUserPasswordInput = {
  /** The ID of the User */
  id: Scalars['ID']['input'];
};

/** The Output of resetting a user password */
export type ResetUserPasswordOutput = {
  __typename?: 'ResetUserPasswordOutput';
  /** The ID of the user */
  user: User;
};

export type ResolveAlarmAndReclassifyInput = {
  sourceId: Scalars['ID']['input'];
};

export type ResolveSourceAlarmInput = {
  sourceId: Scalars['ID']['input'];
  type: SourceAlarmsEnum;
};

export type ResourceDetails = {
  __typename?: 'ResourceDetails';
  attributes?: Maybe<Scalars['JSON']['output']>;
  complianceStatus?: Maybe<ComplianceStatusEnum>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  integration?: Maybe<CloudAccount>;
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ResourceSummary = {
  __typename?: 'ResourceSummary';
  complianceStatus?: Maybe<ComplianceStatusEnum>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  integration?: Maybe<CloudAccount>;
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ResourcesForPolicyInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  policyId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ComplianceStatusEnum>;
  suppressed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RevokeMcpServerAccessInput = {
  serverId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** A single risk or benign indicator with scoring information */
export type RiskIndicator = {
  __typename?: 'RiskIndicator';
  /** Context weighting (0.0 to 1.0] */
  contextWeighting: Scalars['Float']['output'];
  /** Human-readable description of this indicator */
  description: Scalars['String']['output'];
  /** Evidence confidence (0.0 to 1.0] */
  evidenceConfidence: Scalars['Float']['output'];
  /** The risk score value (positive for risky, negative for benign) */
  riskScore: Scalars['Int']['output'];
  /** Temporal relevance (0.0 to 1.0] */
  temporalRelevance: Scalars['Float']['output'];
};

/** Risk scoring evidence and analysis for an alert */
export type RiskScoreEvidence = {
  __typename?: 'RiskScoreEvidence';
  /** Formula used to calculate benign indicators score */
  aggregateBenignIndicatorsFormula: Scalars['String']['output'];
  /** Aggregate score for all benign indicators */
  aggregateBenignIndicatorsScore: Scalars['Float']['output'];
  /** Formula used to calculate risky indicators score */
  aggregateRiskyIndicatorsFormula: Scalars['String']['output'];
  /** Aggregate score for all risky indicators */
  aggregateRiskyIndicatorsScore: Scalars['Float']['output'];
  /** List of benign (low-risk) indicators */
  benignIndicators: Array<RiskIndicator>;
  /** Threshold at which the normalized score is classified as Benign (score <= threshold) */
  benignThreshold: Scalars['Float']['output'];
  /** Classification of the risk level (e.g., 'very_low_risk', 'low_risk', etc.) */
  classification: Scalars['String']['output'];
  /** Reasoning behind the classification */
  classificationReasoning: Scalars['String']['output'];
  /** Formula used to calculate normalized total risk score */
  normalizedTotalRiskFormula: Scalars['String']['output'];
  /** Normalized total risk score */
  normalizedTotalRiskScore: Scalars['Float']['output'];
  /** List of risky (high-risk) indicators */
  riskyIndicators: Array<RiskIndicator>;
  /** Threshold at which the normalized score is classified as Risky (score >= threshold) */
  riskyThreshold: Scalars['Float']['output'];
};

/** The details of a Role entity in Panther */
export type Role = {
  __typename?: 'Role';
  /** Date and time when the Role got created */
  createdAt: Scalars['DateTime']['output'];
  /** The unique identifier of this Role */
  id: Scalars['ID']['output'];
  /**
   * The set of log types the Role is allowed/denied access to, according to the `logTypeAccessKind` field.
   * Null if logTypeAccessKind is ALLOW_ALL or DENY_ALL.
   */
  logTypeAccess?: Maybe<Array<Scalars['String']['output']>>;
  /** Indicates whether the Role is allowed or denied to query the selected log types */
  logTypeAccessKind: LogTypeAccessKind;
  /** The name given to this Role */
  name: Scalars['String']['output'];
  /** The set of permissions associated with the Role (and it's holder) */
  permissions: Array<Permission>;
  /**
   * The name of the Snowflake role Panther provisions for this Role's data-lake (RBAC) log
   * type access. Null when the Role has no data-lake access, since no Snowflake role is
   * provisioned in that case.
   */
  snowflakeRoleName?: Maybe<Scalars['String']['output']>;
  /** Date and time when the Role got last updated */
  updatedAt: Scalars['Timestamp']['output'];
  /** The Actor that last updated this Role */
  updatedBy?: Maybe<Actor>;
};

/** The filter input to the Roles query */
export type RolesInput = {
  /** A string to search for in the Role name */
  nameContains?: InputMaybe<Scalars['String']['input']>;
  /** The sort direction of the results */
  sortDir?: InputMaybe<SortDirEnum>;
};

/** The input for rotating an API token */
export type RotateAPITokenInput = {
  /** The ID of the token to rotate */
  id: Scalars['ID']['input'];
};

/** The output of rotating an API token */
export type RotateAPITokenOutput = {
  __typename?: 'RotateAPITokenOutput';
  /** The rotated API token */
  token?: Maybe<APIToken>;
};

export type Rule = {
  __typename?: 'Rule';
  analysisType: DetectionType;
  baseDetection?: Maybe<Scalars['String']['output']>;
  body: Scalars['String']['output'];
  createAlert: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Actor>;
  createdByExternal?: Maybe<Scalars['String']['output']>;
  dedupPeriodMinutes: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  dynamicAlertContext?: Maybe<Scalars['String']['output']>;
  dynamicAlertTitle?: Maybe<Scalars['String']['output']>;
  dynamicGroupBy?: Maybe<Scalars['String']['output']>;
  dynamicSeverities?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  filePath?: Maybe<Scalars['String']['output']>;
  filterStatement?: Maybe<DetectionFilterStatement>;
  fullScheduledQueries?: Maybe<Array<SavedQuery>>;
  id: Scalars['ID']['output'];
  inlineFilters?: Maybe<Scalars['String']['output']>;
  isConsoleCompatible: Scalars['Boolean']['output'];
  isSimpleDetection: Scalars['Boolean']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  lastModifiedBy?: Maybe<Actor>;
  logTypes?: Maybe<Array<Scalars['String']['output']>>;
  managed?: Maybe<Scalars['Boolean']['output']>;
  outputIds: Array<Scalars['ID']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  reports: Array<DetectionReportMapping>;
  runbook?: Maybe<Scalars['String']['output']>;
  scheduledQueries?: Maybe<Array<Scalars['String']['output']>>;
  severity: Severity;
  simpleDetectionBody?: Maybe<Scalars['String']['output']>;
  specVersion?: Maybe<Scalars['String']['output']>;
  summaryAttributes: Array<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  tests: Array<DetectionTestDefinition>;
  threshold: Scalars['Int']['output'];
  userOverrides?: Maybe<Array<Scalars['String']['output']>>;
  versionId?: Maybe<Scalars['ID']['output']>;
};

/** The output of the `rulePythonBody` query */
export type RulePythonBodyOutput = {
  __typename?: 'RulePythonBodyOutput';
  /** The Python body of the corresponding rule */
  pythonBody: Scalars['String']['output'];
  /** The tests of the corresponding rule */
  tests: Array<DetectionTestDefinitionProtected>;
};

/** Input for immediately running a scheduled prompt */
export type RunScheduledPromptNowInput = {
  id: Scalars['ID']['input'];
};

/** Output from immediately running a scheduled prompt */
export type RunScheduledPromptNowOutput = {
  __typename?: 'RunScheduledPromptNowOutput';
  id: Scalars['ID']['output'];
};

export type Runbook = {
  __typename?: 'Runbook';
  phases: Array<RunbookPhase>;
};

export type RunbookExecutionPhase = {
  __typename?: 'RunbookExecutionPhase';
  completedSteps: Scalars['Int']['output'];
  steps: Array<RunbookExecutionStep>;
  totalSteps: Scalars['Int']['output'];
  type: RunbookPhaseType;
};

export type RunbookExecutionState = {
  __typename?: 'RunbookExecutionState';
  /** Whether execution is paused awaiting human approval before proceeding. */
  approvalRequired: Scalars['Boolean']['output'];
  /**
   * Advisory only: whether the alert's current AI triage classified it as risky (the `ai_risk_risky`
   * context tag). Evaluated live, so a re-triage that changes the classification is reflected on the
   * next poll. Null unless the run is awaiting approval (approvalRequired == true) — it is only
   * meaningful at the phase-shift decision point. The UI should warn when approvalRequired is true
   * and this is false; it does NOT block the phase shift — the analyst can still proceed.
   */
  classifiedRisky?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Terminal poll-stop signal: true once the response phase has been reached and every required
   * response step is completed. Non-required steps and the completedSteps/totalSteps counters do
   * not affect this — completedSteps == totalSteps is not equivalent to complete.
   */
  complete: Scalars['Boolean']['output'];
  completedSteps: Scalars['Int']['output'];
  /** Phase the runbook is currently executing. */
  phase: RunbookPhaseType;
  phases: Array<RunbookExecutionPhase>;
  totalSteps: Scalars['Int']['output'];
};

export type RunbookExecutionStep = {
  __typename?: 'RunbookExecutionStep';
  id: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  status: RunbookStepStatus;
  /** Free-text outcome recorded when the step reached a terminal status; null while pending. */
  summary?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type RunbookPhase = {
  __typename?: 'RunbookPhase';
  steps: Array<RunbookStep>;
  type: RunbookPhaseType;
};

export type RunbookPhaseInput = {
  steps: Array<RunbookStepInput>;
  type: RunbookPhaseType;
};

export enum RunbookPhaseType {
  Investigation = 'INVESTIGATION',
  Response = 'RESPONSE',
}

export type RunbookStep = {
  __typename?: 'RunbookStep';
  required: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
};

export type RunbookStepInput = {
  required: Scalars['Boolean']['input'];
  text: Scalars['String']['input'];
};

/** Status of a single runbook step within an alert's live execution. */
export enum RunbookStepStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Skipped = 'SKIPPED',
}

/** Represents an S3 Log Source Integration */
export type S3LogIntegration = LogIntegration & {
  __typename?: 'S3LogIntegration';
  alarms: LogIntegrationAlarms;
  /** The ID of the AWS Account where the S3 Bucket is located */
  awsAccountId: Scalars['String']['output'];
  /** The time the S3 Log Source was created */
  createdAtTime: Scalars['DateTime']['output'];
  /** The actor who created the S3 Log Source */
  createdBy?: Maybe<Actor>;
  filters: SourceFilters;
  health: S3LogIntegrationHealth;
  /** The ID of the Log Source integration */
  integrationId: Scalars['ID']['output'];
  /** The name of the Log Source integration */
  integrationLabel: Scalars['String']['output'];
  /** The type of Log Source integration */
  integrationType: Scalars['String']['output'];
  /** True if the Log Source can be modified */
  isEditable: Scalars['Boolean']['output'];
  /** True if the Log Source is healthy */
  isHealthy: Scalars['Boolean']['output'];
  isPantherManaged: Scalars['Boolean']['output'];
  /** KMS key used to access the S3 Bucket */
  kmsKey?: Maybe<Scalars['String']['output']>;
  /** The timestamp of the last event processed */
  lastEventProcessedAtTime?: Maybe<Scalars['DateTime']['output']>;
  /** The timestamp of the last event received */
  lastEventReceivedAtTime?: Maybe<Scalars['DateTime']['output']>;
  /** The time the log source was last modified */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** The AWS Role used to access the S3 Bucket */
  logProcessingRole?: Maybe<Scalars['String']['output']>;
  logProviderId?: Maybe<Scalars['String']['output']>;
  /** The format of the log files being ingested */
  logStreamType?: Maybe<LogStreamType>;
  /** Options for the log stream type */
  logStreamTypeOptions?: Maybe<LogStreamTypeOptions>;
  /** The log types being ingested */
  logTypes: Array<Scalars['String']['output']>;
  /** True if bucket notifications are being managed by Panther */
  managedBucketNotifications: Scalars['Boolean']['output'];
  notificationsConfigurationSucceeded: Scalars['Boolean']['output'];
  /** The S3 Bucket name being ingested */
  s3Bucket: Scalars['String']['output'];
  /** The prefix on the S3 Bucket name being ingested */
  s3Prefix?: Maybe<Scalars['String']['output']>;
  /** Used to map prefixes to log types */
  s3PrefixLogTypes: Array<S3PrefixLogTypes>;
  /** The AWS stack name where Panther's log ingestion infrastructure is deployed */
  stackName: Scalars['String']['output'];
};

export type S3LogIntegrationHealth = {
  __typename?: 'S3LogIntegrationHealth';
  bucketNotificationsStatus?: Maybe<IntegrationItemHealthStatus>;
  classificationFailuresStatus?: Maybe<IntegrationItemHealthStatus>;
  kmsKeyStatus?: Maybe<IntegrationItemHealthStatus>;
  logProcessingErrorsStatus?: Maybe<IntegrationItemHealthStatus>;
  processingRoleStatus: IntegrationItemHealthStatus;
  s3BucketStatus?: Maybe<IntegrationItemHealthStatus>;
  systemAlarmStatus?: Maybe<IntegrationItemHealthStatus>;
};

export type S3Object = {
  __typename?: 'S3Object';
  key: Scalars['String']['output'];
  lastModified: Scalars['DateTime']['output'];
  size?: Maybe<Scalars['Int']['output']>;
};

/** Mapping of S3 prefixes to log types */
export type S3PrefixLogTypes = {
  __typename?: 'S3PrefixLogTypes';
  /** S3 Prefixes to exclude */
  excludedPrefixes: Array<Scalars['String']['output']>;
  /** Log types to map to prefix */
  logTypes: Array<Scalars['String']['output']>;
  /** S3 Prefix to map to log types */
  prefix: Scalars['String']['output'];
};

/** Mapping of S3 prefixes to log types */
export type S3PrefixLogTypesInput = {
  /** S3 Prefixes to exclude */
  excludedPrefixes: Array<Scalars['String']['input']>;
  /** Log types to map to prefix */
  logTypes: Array<Scalars['String']['input']>;
  /** S3 Prefix to map to log types */
  prefix: Scalars['String']['input'];
};

export type SalesforceConfig = {
  __typename?: 'SalesforceConfig';
  domainConfig: SalesforceConfigDomainConfig;
  environment: SalesforceEnvironment;
  fileInterval: Scalars['String']['output'];
  password: Scalars['String']['output'];
  securityToken: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type SalesforceConfigDomainConfig = {
  __typename?: 'SalesforceConfigDomainConfig';
  domain?: Maybe<Scalars['String']['output']>;
  type: SalesforceDomainType;
};

export type SalesforceConfigDomainConfigInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
  type: SalesforceDomainType;
};

export type SalesforceConfigInput = {
  domainConfig?: InputMaybe<SalesforceConfigDomainConfigInput>;
  environment: SalesforceEnvironment;
  fileInterval: Scalars['String']['input'];
  password: Scalars['String']['input'];
  securityToken: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export enum SalesforceDomainType {
  Default = 'Default',
  MyDomain = 'MyDomain',
}

export enum SalesforceEnvironment {
  Production = 'Production',
  Sandbox = 'Sandbox',
}

export type SamlConfig = {
  __typename?: 'SamlConfig';
  defaultRoleId?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  hasMetadataFile?: Maybe<Scalars['Boolean']['output']>;
  idpInitiated?: Maybe<Scalars['Boolean']['output']>;
  metadataUrl?: Maybe<Scalars['String']['output']>;
  ssoOnly: Scalars['Boolean']['output'];
};

export type SaveLookupJob = Job & {
  __typename?: 'SaveLookupJob';
  id: Scalars['ID']['output'];
  lookup?: Maybe<Lookup>;
  message?: Maybe<Scalars['String']['output']>;
  status: JobStatus;
};

export type SaveResolvedWorkbenchAnalysisItemsInput = {
  items: Array<AnalysisItemForSave>;
};

export type SaveResolvedWorkbenchAnalysisItemsOutput = {
  __typename?: 'SaveResolvedWorkbenchAnalysisItemsOutput';
  affectedDependents?: Maybe<Array<AnalysisItemTestRunResult>>;
  items: Array<AnalysisItemSaveResult>;
};

export type SavedQuery = {
  __typename?: 'SavedQuery';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Actor>;
  defaultDatabase?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  emailConfig?: Maybe<EmailConfig>;
  id: Scalars['ID']['output'];
  lastModifiedAt: Scalars['DateTime']['output'];
  lastModifiedBy?: Maybe<Actor>;
  managed?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  parent?: Maybe<SavedQuery>;
  queryCookie?: Maybe<Scalars['String']['output']>;
  queryKind?: Maybe<Scalars['String']['output']>;
  requiresLimitClause: Scalars['Boolean']['output'];
  schedule?: Maybe<Schedule>;
  sqlQuery?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type SavedQueryDeleteEntry = {
  isScheduled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type ScannedResourceStats = {
  __typename?: 'ScannedResourceStats';
  count?: Maybe<ComplianceStatusCounts>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ScannedResources = {
  __typename?: 'ScannedResources';
  byType?: Maybe<Array<Maybe<ScannedResourceStats>>>;
};

export type Schedule = {
  __typename?: 'Schedule';
  cronExpression?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  rateMinutes?: Maybe<Scalars['Int']['output']>;
  timeout: Scalars['Int']['output'];
};

export type ScheduleInput = {
  cronExpression?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  rateMinutes?: InputMaybe<Scalars['Int']['input']>;
  timeout: Scalars['Int']['input'];
};

/** A scheduled AI prompt that runs automatically on a schedule */
export type ScheduledPrompt = {
  __typename?: 'ScheduledPrompt';
  alias?: Maybe<Scalars['String']['output']>;
  aliasType?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the current user can edit or delete this scheduled prompt. Public
   * prompts are editable by anyone; private prompts only by the owner or a user
   * with the ManageAIResponses permission.
   */
  canEdit: Scalars['Boolean']['output'];
  /**
   * Whether the current user can change this scheduled prompt's privacy (the
   * private flag). Stricter than canEdit: changing visibility — in either
   * direction, even on a public prompt anyone can otherwise edit — is restricted
   * to the owner or a user with the ManageAIResponses permission.
   */
  canManagePrivacy: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Actor>;
  createdById: Scalars['ID']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deletedBy?: Maybe<Actor>;
  deletedById?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Human-readable label rendered in the UI. Empty for legacy records — the UI
   * falls back to `name` in that case.
   */
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind?: Maybe<AISummarizeKind>;
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  lastRunConversationId?: Maybe<Scalars['String']['output']>;
  lastRunError?: Maybe<Scalars['String']['output']>;
  lastRunStatus?: Maybe<ScheduledPromptRunStatus>;
  /**
   * Technical identifier. Tightened to ^[a-z][a-z0-9_]*$ for prompts authored
   * after the displayName split; legacy records (created before the split) may
   * carry free-form values until the displayName_backfill migration runs.
   */
  name: Scalars['String']['output'];
  nextRunAt?: Maybe<Scalars['DateTime']['output']>;
  outputLength?: Maybe<OutputLength>;
  /** Whether conversations created by this prompt are private */
  private: Scalars['Boolean']['output'];
  promptText: Scalars['String']['output'];
  runAsUser?: Maybe<Actor>;
  runAsUserId?: Maybe<Scalars['ID']['output']>;
  schedule: Schedule;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Actor>;
  updatedById?: Maybe<Scalars['ID']['output']>;
};

/** Execution status of a scheduled prompt run */
export enum ScheduledPromptRunStatus {
  Failed = 'failed',
  Running = 'running',
  Succeeded = 'succeeded',
}

/** Metadata that represents a schema */
export type Schema = {
  __typename?: 'Schema';
  /** The time the schema was created */
  createdAt: Scalars['String']['output'];
  /** The description of the schema */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Disabled field is deprecated and will be removed in an upcoming release.
   * Use isArchived instead
   * @deprecated Field no longer supported
   */
  disabled: Scalars['Boolean']['output'];
  /** The schema discovered spec */
  discoveredSpec: Scalars['String']['output'];
  fields: Array<SchemaField>;
  /** True if the schema is archived */
  isArchived: Scalars['Boolean']['output'];
  /** A boolean indicating whether the automatic schema field discovery feature is enabled */
  isFieldDiscoveryEnabled: Scalars['Boolean']['output'];
  /** True if the schema is managed by a pack */
  isManaged: Scalars['Boolean']['output'];
  /** List of log sources that this schema is attached to */
  logSources?: Maybe<Array<LogIntegration>>;
  /** The name of the schema */
  name: Scalars['String']['output'];
  /** An optional field that can be used to reference documentation related to the schema */
  referenceURL?: Maybe<Scalars['String']['output']>;
  /** Revision number for the schema */
  revision: Scalars['Int']['output'];
  /** The schema spec in YAML or JSON format */
  spec: Scalars['String']['output'];
  /** The time the schema was last updated */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** The Version of the Schema. This is automatically incremented with every in-place change of the schema. */
  version: Scalars['Int']['output'];
};

export type SchemaField = {
  __typename?: 'SchemaField';
  description?: Maybe<Scalars['String']['output']>;
  indicators: Array<Scalars['String']['output']>;
  isEmbeddedJSON?: Maybe<Scalars['Boolean']['output']>;
  isEventTime?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  timeFormat?: Maybe<Scalars['String']['output']>;
  type: SchemaValueType;
  validate?: Maybe<SchemaFieldValueValidation>;
};

export type SchemaFieldValueValidation = {
  __typename?: 'SchemaFieldValueValidation';
  allow: Array<Scalars['String']['output']>;
  cidr?: Maybe<Scalars['String']['output']>;
  deny: Array<Scalars['String']['output']>;
  ip?: Maybe<Scalars['String']['output']>;
};

export enum SchemaValueType {
  Array = 'array',
  Bigint = 'bigint',
  Boolean = 'boolean',
  Float = 'float',
  Int = 'int',
  Json = 'json',
  Object = 'object',
  Smallint = 'smallint',
  String = 'string',
  Timestamp = 'timestamp',
}

/** The payload to the `schemas` query */
export type SchemasInput = {
  /** Filter by name or by schema field name */
  contains?: InputMaybe<Scalars['String']['input']>;
  /**
   * An opaque string used when paginating across multiple pages of results
   * Currently, pagination is not supported and this value will always be null
   */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /**
   * IsActive field is deprecated. Use isInUse instead
   * @deprecated Field no longer supported
   */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by archive status. Leave empty to return all schemas */
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * IsDisabled field is deprecated. Use isArchived instead
   * @deprecated Field no longer supported
   */
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter used/not used schemas. Leave empty to return all schemas */
  isInUse?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by pack managed schemas */
  isManaged?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The response of the 'schemas' query */
export type SchemasOutput = {
  __typename?: 'SchemasOutput';
  /** A list of paginated schema edges */
  edges: Array<SchemasOutputEdge>;
  /**
   * Metadata around this page of results
   * Currently, Schemas will only return 1 page of results
   */
  pageInfo: SchemasOutputPageInfo;
};

/** The edge shape of the `SchemaOutput` type */
export type SchemasOutputEdge = {
  __typename?: 'SchemasOutputEdge';
  /** A schema node */
  node: Schema;
};

/** The metadata around a page of results for the `schemas` query */
export type SchemasOutputPageInfo = {
  __typename?: 'SchemasOutputPageInfo';
  /** The cursor that the next page of results should start from or `null` if this is the last page */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** A boolean indicating whether more results exist */
  hasNextPage: Scalars['Boolean']['output'];
  /** A boolean indicating whether this is the first page of results or not */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The cursor that this page of results started from or `null` if this is the first page */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/**
 * Supported operators for the simple search query. This enum will be serialized
 * in the filters field in ExecuteSimpleSearchQueryInput.
 */
export enum SearchQueryOperator {
  Between = 'BETWEEN',
  Contains = 'CONTAINS',
  DoesNotContain = 'DOES_NOT_CONTAIN',
  DoesNotHave = 'DOES_NOT_HAVE',
  DoesNotHaveAny = 'DOES_NOT_HAVE_ANY',
  DoesNotHaveLike = 'DOES_NOT_HAVE_LIKE',
  Empty = 'EMPTY',
  Equals = 'EQUALS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  Has = 'HAS',
  HasAny = 'HAS_ANY',
  HasLike = 'HAS_LIKE',
  In = 'IN',
  IsNotNull = 'IS_NOT_NULL',
  IsNull = 'IS_NULL',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Like = 'LIKE',
  NotEmpty = 'NOT_EMPTY',
  NotEqual = 'NOT_EQUAL',
  NotIn = 'NOT_IN',
  NotLike = 'NOT_LIKE',
  ObjectContains = 'OBJECT_CONTAINS',
  ObjectDoesNotContain = 'OBJECT_DOES_NOT_CONTAIN',
  RowContains = 'ROW_CONTAINS',
  RowIlike = 'ROW_ILIKE',
  RowRegexpContains = 'ROW_REGEXP_CONTAINS',
  Since = 'SINCE',
  WithinCidr = 'WITHIN_CIDR',
}

/** The request payload for the SendJiraEvent mutation */
export type SendJiraEventInput = {
  /** Version of the jira app being used */
  appVersion: Scalars['String']['input'];
  /** The JSON event object from Jira */
  payload: Scalars['JSON']['input'];
};

/**
 * The response payload for the SendJiraEvent mutation
 * Currently, a response body is not necessary
 */
export type SendJiraEventOutput = {
  __typename?: 'SendJiraEventOutput';
  /** The Jira application does not need a response, but a message may be useful for debugging */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SendTestAlertInput = {
  outputIds: Array<Scalars['ID']['input']>;
};

/** The input for the sendUserFeedback mutation */
export type SendUserFeedbackInput = {
  /** Information around the feature that the user is submitting feedback for */
  feature: UserFeedbackFeatureInput;
  /** The feedback data that the user submitted */
  feedback: UserFeedbackDataInput;
};

/** The output of the sendUserFeedback mutation */
export type SendUserFeedbackOutput = {
  __typename?: 'SendUserFeedbackOutput';
  /** The ID of the ticket that got created. Included in the email title that got sent as a result of the feedback submission */
  id: Scalars['ID']['output'];
};

export type SentinelOneApiConfig = {
  __typename?: 'SentinelOneApiConfig';
  apiToken: Scalars['String']['output'];
  domain?: Maybe<Scalars['String']['output']>;
  organization: Scalars['String']['output'];
};

export type SentinelOneApiConfigInput = {
  apiToken: Scalars['String']['input'];
  domain?: InputMaybe<Scalars['String']['input']>;
  organization: Scalars['String']['input'];
};

export type SentinelOneCloudFunnelConfig = {
  __typename?: 'SentinelOneCloudFunnelConfig';
  awsAccessKey: Scalars['String']['output'];
  awsAccessSecret: Scalars['String']['output'];
  queueArn: Scalars['String']['output'];
};

export type SentinelOneCloudFunnelConfigInput = {
  awsAccessKey: Scalars['String']['input'];
  awsAccessSecret: Scalars['String']['input'];
  queueArn: Scalars['String']['input'];
};

export type SerializeRunbookInput = {
  phases: Array<RunbookPhaseInput>;
};

export type SerializeRunbookOutput = {
  __typename?: 'SerializeRunbookOutput';
  runbook: Scalars['String']['output'];
};

/** A simple series represented as a label/value pair */
export type Series = {
  __typename?: 'Series';
  /** The label of this particular value */
  label: Scalars['String']['output'];
  /** The value for the label above */
  value: Scalars['Float']['output'];
};

export type SeriesData = {
  __typename?: 'SeriesData';
  series: Array<SeriesMetric>;
  timestamps: Array<Scalars['DateTime']['output']>;
};

export type SeriesMetric = {
  __typename?: 'SeriesMetric';
  label: Scalars['String']['output'];
  values: Array<Scalars['Long']['output']>;
};

/** Same as `Series` with the addition of a timestamp breakdown. Useful for plotting charts. */
export type SeriesWithBreakdown = {
  __typename?: 'SeriesWithBreakdown';
  /**
   * A key/value pair that breaks down the `value` field to its constituents. Each key is a timestamp and each value is a
   * fraction of the (total) `value` above
   */
  breakdown: Scalars['JSON']['output'];
  /** The label of this particular value */
  label: Scalars['String']['output'];
  /** The (total) value for the label above */
  value: Scalars['Float']['output'];
};

/**
 * Same as `Series` with the addition of an Panther Entity ID. The ID can be mapped to any Panther entity, depending on the
 * field that uses the type
 */
export type SeriesWithEntityID = {
  __typename?: 'SeriesWithEntityID';
  /**
   * The ID of an entity. Could be a Detection ID, a Resource ID, an Alert ID, etc. depending on the field that uses this
   * particular type
   */
  entityId: Scalars['ID']['output'];
  /** The label of this particular value */
  label: Scalars['String']['output'];
  /** The value for the label above */
  value: Scalars['Float']['output'];
};

/** The available severity levels that can be associated with a detection or an alert */
export enum Severity {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Info = 'INFO',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export type SeverityBasedJiraConfig = {
  __typename?: 'SeverityBasedJiraConfig';
  labels: Array<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  severity: Severity;
};

export type SeverityBasedJiraConfigInput = {
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  priority?: InputMaybe<Scalars['String']['input']>;
  severity: Severity;
};

/** The output of the signOutUserSessions mutation */
export type SignOutSessionsOutput = {
  __typename?: 'SignOutSessionsOutput';
  /** The ID of the user that was signed out */
  id: Scalars['ID']['output'];
};

/** Types of simple search queries */
export enum SimpleSearchQueryType {
  SimpleSearch = 'simpleSearch',
  SimpleSearchColumnsMetadata = 'simpleSearchColumnsMetadata',
  SimpleSearchColumnsSummary = 'simpleSearchColumnsSummary',
  SimpleSearchTimeline = 'simpleSearchTimeline',
}

/** Sources of uber search executions */
export enum SimpleSearchSource {
  AdHoc = 'AD_HOC',
  DashboardWidget = 'DASHBOARD_WIDGET',
}

/** Data volume to run the replay on */
export type SizeWindow = {
  __typename?: 'SizeWindow';
  maxSizeInGB: Scalars['Int']['output'];
};

export type SizeWindowInput = {
  maxSizeInGB: Scalars['Int']['input'];
};

export type SlackBotConfig = {
  __typename?: 'SlackBotConfig';
  botToken: Scalars['String']['output'];
  channel: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  signingSecret: Scalars['String']['output'];
  syncAITriage: Scalars['Boolean']['output'];
  syncAlertAssignee: Scalars['Boolean']['output'];
  syncAlertComments: Scalars['Boolean']['output'];
  syncAlertStatus: Scalars['Boolean']['output'];
  timeLocation: Scalars['String']['output'];
};

export type SlackBotConfigInput = {
  botToken: Scalars['String']['input'];
  channel: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  signingSecret: Scalars['String']['input'];
  syncAITriage: Scalars['Boolean']['input'];
  syncAlertAssignee: Scalars['Boolean']['input'];
  syncAlertComments: Scalars['Boolean']['input'];
  syncAlertStatus: Scalars['Boolean']['input'];
  timeLocation: Scalars['String']['input'];
};

export type SlackConfig = {
  __typename?: 'SlackConfig';
  webhookURL: Scalars['String']['output'];
};

export type SlackConfigInput = {
  webhookURL: Scalars['String']['input'];
};

export type SlackbotBoomerangHistory = {
  __typename?: 'SlackbotBoomerangHistory';
  /** The alertId this slackbot boomerang belongs to */
  alertId: Scalars['ID']['output'];
  /** Date and time when the slackbot boomerang got created */
  createdAt: Scalars['DateTime']['output'];
  /** The Actor that initiated the slackbot boomerang */
  createdBy: Actor;
  /** The type of slackbot boomerang history (QUESTION_ASKED, RESPONSE, etc) */
  historyType: SlackbotBoomerangHistoryType;
  /** Slackbot boomerang identifier */
  id: Scalars['ID']['output'];
  parsingVersion: Scalars['String']['output'];
  /** Question asked in slackbot boomerang */
  question: Scalars['String']['output'];
  /** Recipient who receives the question */
  recipientName: Scalars['String']['output'];
  /** The action of the response */
  responseAction?: Maybe<Scalars['String']['output']>;
  /** The response to the question asked */
  responseMessage?: Maybe<Scalars['String']['output']>;
};

export enum SlackbotBoomerangHistoryType {
  QuestionAsked = 'QUESTION_ASKED',
  Response = 'RESPONSE',
}

/** The highlight of a search result snippet */
export type SnippetHighlight = {
  __typename?: 'SnippetHighlight';
  /** The begin offset of the highlight (zero-based) */
  beginOffset: Scalars['Int']['output'];
  /** The end offset of the highlight (zero-based) */
  endOffset: Scalars['Int']['output'];
};

/** Search result snippet of the matching text with highlights */
export type SnippetWithHighlights = {
  __typename?: 'SnippetWithHighlights';
  /** The highlights of the snippet */
  highlights?: Maybe<Array<SnippetHighlight>>;
  /** The text of the snippet */
  text: Scalars['String']['output'];
};

export type SnowflakeAuditConfig = {
  __typename?: 'SnowflakeAuditConfig';
  accountIdentifier: Scalars['String']['output'];
  database?: Maybe<Scalars['String']['output']>;
  profilePullers?: Maybe<SnowflakeProfilePullerConfig>;
  role?: Maybe<Scalars['String']['output']>;
  rsaKey?: Maybe<Scalars['String']['output']>;
  rsaKeyARN: Scalars['String']['output'];
  rsaPublicKey?: Maybe<Scalars['String']['output']>;
  runEveryMinutes: Scalars['Int']['output'];
  schema?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
  warehouse: Scalars['String']['output'];
};

export type SnowflakeAuditConfigInput = {
  accountIdentifier: Scalars['String']['input'];
  database?: InputMaybe<Scalars['String']['input']>;
  profilePullers?: InputMaybe<SnowflakeProfilePullerConfigInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  rsaKey?: InputMaybe<Scalars['String']['input']>;
  rsaKeyARN: Scalars['String']['input'];
  rsaPublicKey?: InputMaybe<Scalars['String']['input']>;
  runEveryMinutes: Scalars['Int']['input'];
  schema?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
  warehouse: Scalars['String']['input'];
};

export type SnowflakeProfilePullerConfig = {
  __typename?: 'SnowflakeProfilePullerConfig';
  grantsToRoles?: Maybe<ProfilePullerConfig>;
  grantsToUsers?: Maybe<ProfilePullerConfig>;
  networkPolicies?: Maybe<ProfilePullerConfig>;
  roles?: Maybe<ProfilePullerConfig>;
  stages?: Maybe<ProfilePullerConfig>;
  users?: Maybe<ProfilePullerConfig>;
};

export type SnowflakeProfilePullerConfigInput = {
  grantsToRoles?: InputMaybe<ProfilePullerConfigInput>;
  grantsToUsers?: InputMaybe<ProfilePullerConfigInput>;
  networkPolicies?: InputMaybe<ProfilePullerConfigInput>;
  roles?: InputMaybe<ProfilePullerConfigInput>;
  stages?: InputMaybe<ProfilePullerConfigInput>;
  users?: InputMaybe<ProfilePullerConfigInput>;
};

export type SnsConfig = {
  __typename?: 'SnsConfig';
  topicArn: Scalars['String']['output'];
};

export type SnsConfigInput = {
  topicArn: Scalars['String']['input'];
};

export type SnykConfigInput = {
  apiToken: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
};

export type SnykLogSourceConfig = {
  __typename?: 'SnykLogSourceConfig';
  apiToken: Scalars['String']['output'];
  orgId: Scalars['String']['output'];
};

/** The available sorting direction on a listing operation */
export enum SortDirEnum {
  Ascending = 'ascending',
  Descending = 'descending',
}

export enum SourceAlarmsEnum {
  SourceClassificationFailures = 'SOURCE_CLASSIFICATION_FAILURES',
  SourceLogProcessingErrors = 'SOURCE_LOG_PROCESSING_ERRORS',
  SourceNoData = 'SOURCE_NO_DATA',
}

export type SourceFilters = {
  __typename?: 'SourceFilters';
  eventFilters: Array<EventFilter>;
  rawFilters: Array<RawFilter>;
};

export type SourceFiltersInput = {
  eventFilters?: InputMaybe<Array<EventFilterInput>>;
  rawFilters?: InputMaybe<Array<RawFiltersInput>>;
};

export enum SourceHealthTypesEnum {
  AmazonSecurityLakeQueueStatus = 'amazonSecurityLakeQueueStatus',
  AmazonSecurityLakeRoleStatus = 'amazonSecurityLakeRoleStatus',
  AuditRoleStatus = 'auditRoleStatus',
  AzureBlobStatus = 'azureBlobStatus',
  AzureEventHubStatus = 'azureEventHubStatus',
  BucketNotificationsStatus = 'bucketNotificationsStatus',
  ClassificationFailuresStatus = 'classificationFailuresStatus',
  EventBridgeStatus = 'eventBridgeStatus',
  GcpPubSubStatus = 'gcpPubSubStatus',
  GcsStatus = 'gcsStatus',
  HttpStatus = 'httpStatus',
  KmsKeyStatus = 'kmsKeyStatus',
  LogProcessingErrorsStatus = 'logProcessingErrorsStatus',
  LogPullingStatus = 'logPullingStatus',
  ProcessingRoleStatus = 'processingRoleStatus',
  RealtimeStatus = 'realtimeStatus',
  S3BucketStatus = 's3BucketStatus',
  SqsStatus = 'sqsStatus',
  SystemAlarmStatus = 'systemAlarmStatus',
}

export type SourceMetric = {
  __typename?: 'SourceMetric';
  found: Scalars['Boolean']['output'];
  value: Scalars['Long']['output'];
};

export type SourceMetricsInput = {
  fromDate: Scalars['DateTime']['input'];
  integrationId: Scalars['String']['input'];
  intervalInMinutes?: InputMaybe<Scalars['Int']['input']>;
  toDate: Scalars['DateTime']['input'];
};

export type SourceMetricsResponse = {
  __typename?: 'SourceMetricsResponse';
  bytesFiltered?: Maybe<SeriesData>;
  bytesProcessed?: Maybe<SeriesData>;
  bytesProcessedPerLogSource?: Maybe<SeriesData>;
  classificationFailures?: Maybe<SeriesData>;
  eventsFiltered?: Maybe<SeriesData>;
  eventsProcessed?: Maybe<SeriesData>;
};

export enum SourceStatistics {
  AverageLatency = 'averageLatency',
  BytesFiltered = 'bytesFiltered',
  BytesProcessed = 'bytesProcessed',
  ClassificationFailures = 'classificationFailures',
  EventsFiltered = 'eventsFiltered',
  EventsProcessed = 'eventsProcessed',
}

export type SourceStatisticsInput = {
  from: Scalars['DateTime']['input'];
  sourceIds: Array<Scalars['String']['input']>;
  statistics: Array<SourceStatistics>;
  to: Scalars['DateTime']['input'];
};

export type SourceStatisticsResponse = {
  __typename?: 'SourceStatisticsResponse';
  statistics: Array<SourceStats>;
};

export type SourceStats = {
  __typename?: 'SourceStats';
  averageLatencySeconds?: Maybe<SourceMetric>;
  bytesFiltered?: Maybe<SourceMetric>;
  bytesProcessed?: Maybe<SourceMetric>;
  classificationFailures?: Maybe<SourceMetric>;
  eventsFiltered?: Maybe<SourceMetric>;
  eventsProcessed?: Maybe<SourceMetric>;
  sourceId: Scalars['ID']['output'];
};

export enum SourceType {
  AmazonSecurityLake = 'AmazonSecurityLake',
  AzureEventHub = 'AzureEventHub',
  CloudWatch = 'CloudWatch',
  EventBridge = 'EventBridge',
  GcpPubSub = 'GcpPubSub',
  Gcs = 'Gcs',
  Http = 'HTTP',
  LogForwarder = 'LogForwarder',
  LogPulling = 'LogPulling',
  Otlp = 'OTLP',
  ProfilePulling = 'ProfilePulling',
  S3 = 'S3',
  Sqs = 'Sqs',
}

/** Input for the sources query */
export type SourcesInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
};

/** Output for the sources query */
export type SourcesOutput = {
  __typename?: 'SourcesOutput';
  /** A list of paginated log source edges */
  edges: Array<SourcesOutputEdge>;
  /** Metadata around this page of results */
  pageInfo: CursorBasedPaginationPageInfo;
};

/** The edge shape of the `LogIntegration` source type */
export type SourcesOutputEdge = {
  __typename?: 'SourcesOutputEdge';
  /** A Log Source integration Node */
  node: LogIntegration;
};

export type SplunkWebhookConfig = {
  __typename?: 'SplunkWebhookConfig';
  authToken: Scalars['String']['output'];
  webhookURL: Scalars['String']['output'];
};

export type SplunkWebhookConfigInput = {
  authToken: Scalars['String']['input'];
  webhookURL: Scalars['String']['input'];
};

export type SqsConfig = {
  __typename?: 'SqsConfig';
  allowedPrincipalArns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  allowedSourceArns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  logProcessingRole?: Maybe<Scalars['String']['output']>;
  logStreamType?: Maybe<LogStreamType>;
  logStreamTypeOptions?: Maybe<LogStreamTypeOptions>;
  queueUrl: Scalars['String']['output'];
  s3Bucket: Scalars['String']['output'];
  s3Prefix?: Maybe<Scalars['String']['output']>;
};

export type SqsConfigInput = {
  queueUrl: Scalars['String']['input'];
};

export type SqsDestinationConfig = {
  __typename?: 'SqsDestinationConfig';
  queueUrl: Scalars['String']['output'];
};

export type SqsLogConfigInput = {
  allowedPrincipalArns: Array<InputMaybe<Scalars['String']['input']>>;
  allowedSourceArns: Array<InputMaybe<Scalars['String']['input']>>;
  logStreamType?: InputMaybe<LogStreamType>;
  logStreamTypeOptions?: InputMaybe<LogStreamTypeOptionsInput>;
  logTypes: Array<Scalars['String']['input']>;
};

export type SqsLogIntegrationHealth = {
  __typename?: 'SqsLogIntegrationHealth';
  classificationFailuresStatus?: Maybe<IntegrationItemHealthStatus>;
  logProcessingErrorsStatus?: Maybe<IntegrationItemHealthStatus>;
  sqsStatus?: Maybe<IntegrationItemHealthStatus>;
  systemAlarmStatus?: Maybe<IntegrationItemHealthStatus>;
};

export type SqsLogSourceIntegration = LogIntegration & {
  __typename?: 'SqsLogSourceIntegration';
  alarms: LogIntegrationAlarms;
  createdAtTime: Scalars['DateTime']['output'];
  createdBy?: Maybe<Actor>;
  filters: SourceFilters;
  health: SqsLogIntegrationHealth;
  integrationId: Scalars['ID']['output'];
  integrationLabel: Scalars['String']['output'];
  integrationType: Scalars['String']['output'];
  isEditable: Scalars['Boolean']['output'];
  isHealthy: Scalars['Boolean']['output'];
  isPantherManaged: Scalars['Boolean']['output'];
  lastEventProcessedAtTime?: Maybe<Scalars['DateTime']['output']>;
  lastEventReceivedAtTime?: Maybe<Scalars['DateTime']['output']>;
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  logProviderId?: Maybe<Scalars['String']['output']>;
  logTypes: Array<Scalars['String']['output']>;
  sqsConfig: SqsConfig;
};

export type StandardReportEntry = {
  __typename?: 'StandardReportEntry';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type StartAsyncDownloadOfAllQueryResultsInput = {
  /** If present, emit just these columns in this order. */
  columns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * ID of the query that the user wants to download, used for differentiating different download results.
   * This query ID is to the query that had an internal row limit applied. This endpoint will start a new query
   * that has a different query ID and will not have the row limit applied.
   */
  originalQueryId: Scalars['String']['input'];
  /**
   * Params for the query.
   * params.Filter contains the query text.
   * If params.Language is SQL, all other input options are ignored.
   */
  params: FilterInput;
};

export type StartAsyncDownloadOfAllQueryResultsOutput = {
  __typename?: 'StartAsyncDownloadOfAllQueryResultsOutput';
  /** Any error that occurred. Response structs cannot be empty so this is just a redundant error field. */
  error?: Maybe<Error>;
};

/** The input needed to stop an ongoing replay */
export type StopReplayInput = {
  id: Scalars['ID']['input'];
};

/** The output result of stopping a replay */
export type StopReplayOutput = {
  __typename?: 'StopReplayOutput';
  replay: Replay;
};

export type StorageInfo = {
  __typename?: 'StorageInfo';
  processedDataRetentionDays: Scalars['Int']['output'];
};

/** Storage provider type for lookup table data sources */
export enum StorageProvider {
  Gcs = 'GCS',
  S3 = 'S3',
}

export type SummarizeDataLakeQueryInput = {
  /** The column to summarize results by. */
  column: Scalars['String']['input'];
  /** The direction to sort the summarized results. */
  direction: DataLakeQuerySortDirection;
  /** The ID of the query to summarize */
  id: Scalars['ID']['input'];
};

export type SummarizeDataLakeQueryJob = Job & {
  __typename?: 'SummarizeDataLakeQueryJob';
  columnInfo?: Maybe<DataLakeQueryResultsColumnInfo>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  rows?: Maybe<Array<Scalars['JSON']['output']>>;
  status: JobStatus;
};

export type SuppressPoliciesInput = {
  policyIds: Array<InputMaybe<Scalars['ID']['input']>>;
  resourcePatterns: Array<InputMaybe<Scalars['String']['input']>>;
};

export type SyncLookupDataInput = {
  lookupId: Scalars['ID']['input'];
};

export type SysdigConfig = {
  __typename?: 'SysdigConfig';
  apiKey: Scalars['String']['output'];
  host: Scalars['String']['output'];
};

export type SysdigConfigInput = {
  apiKey: Scalars['String']['input'];
  host: Scalars['String']['input'];
};

/** The details of a System Error in Panther */
export type SystemError = {
  __typename?: 'SystemError';
  /** The component related to the particular system error */
  relatedComponent: RelatedComponent;
  /** The type of this system error */
  type: SystemErrorType;
};

export type SystemErrorRelatedEntity =
  | AmazonSecurityLakeLogIntegration
  | AzureEventHubSourceIntegration
  | CloudWatchLogIntegration
  | CorrelationRule
  | Destination
  | EnrichmentIntegration
  | EventBridgeIntegration
  | GcpPubSubLogSourceIntegration
  | GcsLogSourceIntegration
  | HttpLogSourceIntegration
  | LogForwarderLogSourceIntegration
  | LogPullingIntegration
  | OTLPLogSourceIntegration
  | Rule
  | S3LogIntegration
  | SqsLogSourceIntegration;

/** The types of system errors that Panther supports */
export enum SystemErrorType {
  AlertDelivery = 'ALERT_DELIVERY',
  DetectionAlertLimitExceeded = 'DETECTION_ALERT_LIMIT_EXCEEDED',
  GitBulkUploadFailed = 'GIT_BULK_UPLOAD_FAILED',
  SourceClassificationFailures = 'SOURCE_CLASSIFICATION_FAILURES',
  SourceLogProcessingErrors = 'SOURCE_LOG_PROCESSING_ERRORS',
  SourceNoData = 'SOURCE_NO_DATA',
  SourcePermissionsChecks = 'SOURCE_PERMISSIONS_CHECKS',
  SourceScanningErrors = 'SOURCE_SCANNING_ERRORS',
}

export type TaxiiCollection = {
  __typename?: 'TaxiiCollection';
  collectionUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type TaxiiCollectionInput = {
  collectionUrl: Scalars['String']['input'];
  id: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type TaxiiConfig = {
  __typename?: 'TaxiiConfig';
  /** One of "bearer" or "basic" */
  authMode: Scalars['String']['output'];
  basicPassword?: Maybe<Scalars['String']['output']>;
  basicUsername?: Maybe<Scalars['String']['output']>;
  bearerToken?: Maybe<Scalars['String']['output']>;
  collections: Array<TaxiiCollection>;
  discoveryUrl: Scalars['String']['output'];
  maxAgeDays: Scalars['Int']['output'];
  profilePullers: TaxiiProfilePullerConfig;
};

export type TaxiiConfigInput = {
  /** One of "bearer" or "basic" */
  authMode: Scalars['String']['input'];
  basicPassword?: InputMaybe<Scalars['String']['input']>;
  basicUsername?: InputMaybe<Scalars['String']['input']>;
  bearerToken?: InputMaybe<Scalars['String']['input']>;
  collections: Array<TaxiiCollectionInput>;
  discoveryUrl: Scalars['String']['input'];
  maxAgeDays: Scalars['Int']['input'];
  profilePullers: TaxiiProfilePullerConfigInput;
};

export type TaxiiProfilePullerConfig = {
  __typename?: 'TaxiiProfilePullerConfig';
  indicators: ProfilePullerConfig;
};

export type TaxiiProfilePullerConfigInput = {
  indicators: ProfilePullerConfigInput;
};

export type TenableConfig = {
  __typename?: 'TenableConfig';
  accessKey: Scalars['String']['output'];
  secretKey: Scalars['String']['output'];
};

export type TenableConfigInput = {
  accessKey: Scalars['String']['input'];
  secretKey: Scalars['String']['input'];
};

export type TerraformTemplateResponse = {
  __typename?: 'TerraformTemplateResponse';
  data: Scalars['String']['output'];
  stackName: Scalars['String']['output'];
};

export type TestCorrelationRuleInput = {
  simpleDetectionBody?: InputMaybe<Scalars['String']['input']>;
  tests?: InputMaybe<Array<DetectionTestDefinitionInput>>;
};

export type TestCorrelationRuleResponse = {
  __typename?: 'TestCorrelationRuleResponse';
  results?: Maybe<Array<TestCorrelationRuleYAMLTestResult>>;
};

/** The payload of the `testCorrelationRuleYAML` mutation */
export type TestCorrelationRuleYAMLInput = {
  /** The YAML file contents of a correlation rule */
  yaml: Scalars['String']['input'];
};

/** The output of the `testCorrelationRuleYAML` mutation */
export type TestCorrelationRuleYAMLOutput = {
  __typename?: 'TestCorrelationRuleYAMLOutput';
  /** The test results */
  results?: Maybe<Array<TestCorrelationRuleYAMLTestResult>>;
};

/** The test case result associated to the `TestCorrelationRuleYAMLOutput` */
export type TestCorrelationRuleYAMLTestResult = {
  __typename?: 'TestCorrelationRuleYAMLTestResult';
  /** Error will be set if an error specific to the test case occurs */
  error?: Maybe<Scalars['String']['output']>;
  /** The name of the associated test case input */
  name: Scalars['String']['output'];
  /** Determines if the test passed or not */
  passed: Scalars['Boolean']['output'];
};

export type TestDetectionRecord = TestRecord & {
  __typename?: 'TestDetectionRecord';
  error?: Maybe<Error>;
  functions: TestDetectionRecordFunctions;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  passed: Scalars['Boolean']['output'];
};

export type TestDetectionRecordFunctions = {
  __typename?: 'TestDetectionRecordFunctions';
  alertContextFunction?: Maybe<TestDetectionSubRecord>;
  dedupFunction?: Maybe<TestDetectionSubRecord>;
  descriptionFunction?: Maybe<TestDetectionSubRecord>;
  destinationsFunction?: Maybe<TestDetectionSubRecord>;
  detectionFunction?: Maybe<TestDetectionSubRecord>;
  referenceFunction?: Maybe<TestDetectionSubRecord>;
  runbookFunction?: Maybe<TestDetectionSubRecord>;
  severityFunction?: Maybe<TestDetectionSubRecord>;
  titleFunction?: Maybe<TestDetectionSubRecord>;
};

export type TestDetectionSubRecord = {
  __typename?: 'TestDetectionSubRecord';
  error?: Maybe<Error>;
  output?: Maybe<Scalars['String']['output']>;
};

export type TestFailure = {
  __typename?: 'TestFailure';
  error: Scalars['String']['output'];
  functionName: Scalars['String']['output'];
};

export type TestFilterEventInput = {
  event: Scalars['String']['input'];
  exclusionPattern: Scalars['String']['input'];
  filterType: Scalars['String']['input'];
};

export type TestFilterEventMatch = {
  __typename?: 'TestFilterEventMatch';
  endIndex: Scalars['Int']['output'];
  startIndex: Scalars['Int']['output'];
};

export type TestFilterEventOutput = {
  __typename?: 'TestFilterEventOutput';
  isFiltered: Scalars['Boolean']['output'];
  matches?: Maybe<Array<TestFilterEventMatch>>;
};

export type TestHoldingTankSchemaFiltersInput = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type TestHoldingTankSchemasInput = {
  filters: TestHoldingTankSchemaFiltersInput;
  newSchemas?: InputMaybe<Array<CreateOrUpdateSchemaInput>>;
  s3PrefixLogTypes: Array<S3PrefixLogTypesInput>;
  sourceId: Scalars['String']['input'];
  streamType: LogStreamType;
};

export type TestPolicyInput = {
  body: Scalars['String']['input'];
  resourceTypes: Array<Scalars['String']['input']>;
  tests: Array<DetectionTestDefinitionInput>;
};

export type TestPolicyRecord = TestRecord & {
  __typename?: 'TestPolicyRecord';
  error?: Maybe<Error>;
  functions: TestPolicyRecordFunctions;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  passed: Scalars['Boolean']['output'];
};

export type TestPolicyRecordFunctions = {
  __typename?: 'TestPolicyRecordFunctions';
  alertContextFunction?: Maybe<TestDetectionSubRecord>;
  dedupFunction?: Maybe<TestDetectionSubRecord>;
  descriptionFunction?: Maybe<TestDetectionSubRecord>;
  destinationsFunction?: Maybe<TestDetectionSubRecord>;
  detectionFunction?: Maybe<TestDetectionSubRecord>;
  referenceFunction?: Maybe<TestDetectionSubRecord>;
  runbookFunction?: Maybe<TestDetectionSubRecord>;
  severityFunction?: Maybe<TestDetectionSubRecord>;
  titleFunction?: Maybe<TestDetectionSubRecord>;
};

export type TestPolicyResponse = {
  __typename?: 'TestPolicyResponse';
  results: Array<TestPolicyRecord>;
};

export type TestPollGitResponse = {
  __typename?: 'TestPollGitResponse';
  error?: Maybe<Scalars['String']['output']>;
};

export type TestRecord = {
  error?: Maybe<Error>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  passed: Scalars['Boolean']['output'];
};

export type TestResult = {
  __typename?: 'TestResult';
  failures?: Maybe<Array<TestFailure>>;
  name: Scalars['String']['output'];
};

export type TestRuleInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  createAlert: Scalars['Boolean']['input'];
  dynamicAlertContext?: InputMaybe<Scalars['String']['input']>;
  dynamicAlertTitle?: InputMaybe<Scalars['String']['input']>;
  dynamicGroupBy?: InputMaybe<Scalars['String']['input']>;
  dynamicSeverities?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DetectionTestFilterDefinition>;
  inlineFilters?: InputMaybe<Scalars['String']['input']>;
  isSimpleDetection: Scalars['Boolean']['input'];
  logTypes: Array<Scalars['String']['input']>;
  simpleDetectionBody?: InputMaybe<Scalars['String']['input']>;
  tests: Array<DetectionTestDefinitionInput>;
};

export type TestRuleResponse = {
  __typename?: 'TestRuleResponse';
  results: Array<TestDetectionRecord>;
};

export type TestSchemaData = {
  __typename?: 'TestSchemaData';
  matched: Array<MatchedLog>;
  unmatched: Array<UnmatchedLog>;
};

export type TestSchemaInput = {
  isFieldDiscoveryEnabled: Scalars['Boolean']['input'];
  schema: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  streamType?: InputMaybe<LogStreamType>;
};

export type TestSchemaResponse = {
  __typename?: 'TestSchemaResponse';
  error?: Maybe<Error>;
  result?: Maybe<TestSchemaResult>;
};

export type TestSchemaResult = {
  __typename?: 'TestSchemaResult';
  data: TestSchemaData;
  stats: TestSchemaStats;
};

export type TestSchemaStats = {
  __typename?: 'TestSchemaStats';
  matched: Scalars['Int']['output'];
  totalLogs: Scalars['Int']['output'];
  unmatched: Scalars['Int']['output'];
};

export enum TimeFormat {
  Iso8601 = 'ISO8601',
  Rfc3339 = 'RFC3339',
}

export enum TimeUnit {
  Day = 'Day',
  Hour = 'Hour',
  Minute = 'Minute',
  Second = 'Second',
}

/** Time range to run the replay on */
export type TimeWindow = {
  __typename?: 'TimeWindow';
  endsAt: Scalars['DateTime']['output'];
  startsAt: Scalars['DateTime']['output'];
};

export type TimeWindowInput = {
  endsAt: Scalars['DateTime']['input'];
  startsAt: Scalars['DateTime']['input'];
};

export enum Timezone {
  Local = 'Local',
  Utc = 'UTC',
}

export type TinesConfig = {
  __typename?: 'TinesConfig';
  apiToken: Scalars['String']['output'];
  organizationDomain: Scalars['String']['output'];
};

export type TinesConfigInput = {
  apiToken: Scalars['String']['input'];
  organizationDomain: Scalars['String']['input'];
};

export type TinesWebhookConfig = {
  __typename?: 'TinesWebhookConfig';
  webhookURL: Scalars['String']['output'];
};

export type TinesWebhookConfigInput = {
  webhookURL: Scalars['String']['input'];
};

/** Input for toggling a scheduled prompt enabled/disabled */
export type ToggleScheduledPromptInput = {
  disabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type TorqWebhookConfig = {
  __typename?: 'TorqWebhookConfig';
  authenticationHeaders?: Maybe<Array<CustomHeader>>;
  webhookURL: Scalars['String']['output'];
};

export type TorqWebhookConfigInput = {
  authenticationHeaders?: InputMaybe<Array<CustomHeaderInput>>;
  webhookURL: Scalars['String']['input'];
};

/** The payload to the `transpileFilters` mutation */
export type TranspileFiltersInput = {
  /** The YAML file contents of the simple detections filters to be transpiled */
  data: Array<Scalars['String']['input']>;
  /** Version of the panther_analysis_tool being used */
  patVersion: Scalars['String']['input'];
};

/** The output of the `transpileFilters` mutation */
export type TranspileFiltersOutput = {
  __typename?: 'TranspileFiltersOutput';
  /** The no code filters that were generated from transpiling the simple detections filters in the input */
  transpiledFilters: Array<Scalars['String']['output']>;
};

/** The payload to the `transpileSimpleDetectionsToPython` mutation */
export type TranspileSimpleDetectionsToPythonInput = {
  /** The YAML file contents of the simple detections to be transpiled */
  data: Array<Scalars['String']['input']>;
};

/** The output of the `transpileSimpleDetectionsToPython` mutation */
export type TranspileSimpleDetectionsToPythonOutput = {
  __typename?: 'TranspileSimpleDetectionsToPythonOutput';
  /** The python that was generated from transpiling the simple detections in the input */
  transpiledPython: Array<Scalars['String']['output']>;
};

export type TransportOptions = {
  __typename?: 'TransportOptions';
  azureEventHub?: Maybe<AzureEventHubOptions>;
  eventbridge?: Maybe<EventbridgeOptions>;
  httpIngest: Array<HttpOptions>;
  logPulling?: Maybe<LogPullingOptions>;
  otlpIngest: Array<OTLPOptions>;
};

/** The input used to summarize a column in uber search results */
export type UberSearchColumnSummaryInput = {
  /** Column name */
  columnName: Scalars['String']['input'];
  /** Optional database name (if not present, all databases will be summarized) */
  databaseName?: InputMaybe<Scalars['String']['input']>;
  /** The id of the uber search */
  id: Scalars['ID']['input'];
  /** Optional jsonPath (if present, summarize this path down from the column) */
  jsonPath?: InputMaybe<Scalars['String']['input']>;
  /** Optional table name (if not present, all tables will be summarized) */
  tableName?: InputMaybe<Scalars['String']['input']>;
};

export enum UberSearchComponent {
  ColumnSummary = 'columnSummary',
  DetailsSortAsc = 'detailsSortAsc',
  DetailsSortDesc = 'detailsSortDesc',
  Timeline = 'timeline',
}

export type UberSearchPropertySummaryInput = {
  pageSize?: Scalars['Int']['input'];
  queryId: Scalars['ID']['input'];
};

/** The input used to get the tables metata for uber search results */
export type UberSearchTablesInput = {
  /** The cursor to start from for paginated queries */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** The id of the uber search */
  id: Scalars['ID']['input'];
  /** The number of results that each page will contain. */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** The return value of the uber search tables request */
export type UberSearchTablesOutput = {
  __typename?: 'UberSearchTablesOutput';
  /** Metadata around this page of results */
  pageInfo: UberSearchTablesOutputPageInfo;
  /** The meta data describing the tables in an uber search result */
  tables?: Maybe<Array<DataLakeDatabaseTable>>;
};

/** The metadata about the page in a uber search tables output */
export type UberSearchTablesOutputPageInfo = {
  __typename?: 'UberSearchTablesOutputPageInfo';
  /** The cursor that the next page of results should start from or `null` if this is the last page */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** A boolean indicating whether more results exist */
  hasNextPage: Scalars['Boolean']['output'];
  /** A boolean indicating whether this is the first page of results or not */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The cursor that this page of results started from or `null` if this is the first page */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type UniversalGitConfig = {
  __typename?: 'UniversalGitConfig';
  configID?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  lastPolled?: Maybe<Scalars['DateTime']['output']>;
  lastUploaded?: Maybe<Scalars['DateTime']['output']>;
  updated: Scalars['DateTime']['output'];
};

export type UniversalSettingsConfig = {
  __typename?: 'UniversalSettingsConfig';
  timezone?: Maybe<Timezone>;
};

export type UnmatchedLog = {
  __typename?: 'UnmatchedLog';
  error: Scalars['String']['output'];
  raw: Scalars['String']['output'];
};

/** Input for updating an AI conversation */
export type UpdateAIConversationInput = {
  /** The ID of the conversation to update */
  conversationId: Scalars['ID']['input'];
  /** Whether to soft-delete the conversation (optional) */
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** New privacy setting (optional) */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to save the conversation permanently (optional) */
  saved?: InputMaybe<Scalars['Boolean']['input']>;
  /** New title for the conversation (optional) */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating an AI skill */
export type UpdateAISkillInput = {
  /** Recover a deleted skill by setting to false (optional) */
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Names of other skills this skill depends on (optional, replaces existing). Dependency prompts are included when this skill is invoked. */
  dependsOn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** New description (optional) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Enable or disable the skill (optional) */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** New display name (optional) */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Change eager-loading mode for this skill (optional). */
  eagerLoading?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the skill to update */
  id: Scalars['ID']['input'];
  /** New prompt/instructions (optional) */
  prompt?: InputMaybe<Scalars['String']['input']>;
  /** Regex patterns for required tool names (optional, replaces existing). The skill will only load if all patterns match at least one registered tool. */
  requiredTools?: InputMaybe<Array<Scalars['String']['input']>>;
  /** New tags for organizing skills (optional, replaces existing tags) */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** New tool message (optional) */
  toolMessage?: InputMaybe<Scalars['String']['input']>;
};

/** Output from updating an AI skill */
export type UpdateAISkillOutput = {
  __typename?: 'UpdateAISkillOutput';
  /** Error information if the operation failed */
  error?: Maybe<Error>;
  /** The updated skill */
  skill?: Maybe<AISkill>;
};

export type UpdateAPITokenInput = {
  allowedCIDRBlocks?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<Permission>>;
};

export type UpdateAPITokenOutput = {
  __typename?: 'UpdateAPITokenOutput';
  error?: Maybe<Error>;
  token?: Maybe<APIToken>;
};

export type UpdateAlertStatusByFilterInput = {
  contextTags?: InputMaybe<Array<Scalars['String']['input']>>;
  filter: AlertsInput;
  quality?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AlertStatus>;
};

export type UpdateAlertStatusByFilterJob = Job & {
  __typename?: 'UpdateAlertStatusByFilterJob';
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  status: JobStatus;
};

/** The payload to the `updateAlertStatusById` mutation */
export type UpdateAlertStatusByIdInput = {
  /** A list of alert IDs to update the status for */
  ids: Array<Scalars['ID']['input']>;
  /** The new/updated status that those alerts should have */
  status: AlertStatus;
};

/** The response of the updateAlertStatusById mutation */
export type UpdateAlertStatusByIdOutput = {
  __typename?: 'UpdateAlertStatusByIdOutput';
  alerts: Array<Alert>;
};

/** The payload to the `updateAlertsAssigneeById` mutation. */
export type UpdateAlertsAssigneeByEmailInput = {
  /** If `assigneeEmail` is not provided, the alert is considered `Unassigned`. */
  assigneeEmail?: InputMaybe<Scalars['String']['input']>;
  /** A list of AlertIds that we are updating. */
  ids: Array<Scalars['ID']['input']>;
};

/** The response of the updateAlertsAssigneeByEmail mutation */
export type UpdateAlertsAssigneeByEmailOutput = {
  __typename?: 'UpdateAlertsAssigneeByEmailOutput';
  alerts: Array<Alert>;
};

/** The payload to the `updateAlertsAssigneeById` mutation. */
export type UpdateAlertsAssigneeByIdInput = {
  /** If `assigneeId` is not provided, the alert is considered `Unassigned`. */
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** A list of AlertIds that we are updating. */
  ids: Array<Scalars['ID']['input']>;
};

/** The response of the updateAlertsAssigneeById mutation */
export type UpdateAlertsAssigneeByIdOutput = {
  __typename?: 'UpdateAlertsAssigneeByIdOutput';
  alerts: Array<Alert>;
};

export type UpdateAllCatalogItemsFailure = {
  __typename?: 'UpdateAllCatalogItemsFailure';
  analysisType: AnalysisType;
  failureReason: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type UpdateAllCatalogItemsInput = {
  items: Array<UpdateCatalogItemInput>;
};

export type UpdateAllCatalogItemsJob = Job & {
  __typename?: 'UpdateAllCatalogItemsJob';
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  stats?: Maybe<UpdateAllCatalogItemsJobStats>;
  status: JobStatus;
};

export type UpdateAllCatalogItemsJobStats = {
  __typename?: 'UpdateAllCatalogItemsJobStats';
  failed: Array<UpdateAllCatalogItemsFailure>;
  succeededRefs: Array<CatalogItemRef>;
};

export type UpdateAnalysisPackInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  versionId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAnalysisPackSourceInput = {
  githubAccessToken?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  kmsKey?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAzureBlobSourceInput = {
  clientId: Scalars['String']['input'];
  cloud: AzureCloudType;
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
  logStreamType?: InputMaybe<LogStreamType>;
  logStreamTypeOptions?: InputMaybe<LogStreamTypeOptionsInput>;
  logTypes: Array<Scalars['String']['input']>;
  secret: Scalars['String']['input'];
  storageAccountName: Scalars['String']['input'];
  storageQueueName: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type UpdateAzureBlobSourceOutput = {
  __typename?: 'UpdateAzureBlobSourceOutput';
  azureBlobSource: AzureBlobSourceIntegration;
};

export type UpdateCatalogItemInput = {
  analysisType: AnalysisType;
  id: Scalars['ID']['input'];
};

export type UpdateCatalogItemOutput = {
  __typename?: 'UpdateCatalogItemOutput';
  item: InstalledCatalogItem;
};

/** Input for the UpdateCloudAccount mutation */
export type UpdateCloudAccountInput = {
  /** Regions to be ignored by scans of this cloud account */
  awsRegionIgnoreList?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Scan configuration options */
  awsScanConfig: AWSScanConfigInput;
  /** The ID of the cloud account integration */
  id: Scalars['String']['input'];
  /** Label applied to the Cloud Account integration */
  label: Scalars['String']['input'];
  /** Resources that match this regex will be ignored by scans of this cloud account */
  resourceRegexIgnoreList?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Resource types to be ignored by scans of this cloud account */
  resourceTypeIgnoreList?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Output for the updateCloudAccount mutation */
export type UpdateCloudAccountOutput = {
  __typename?: 'UpdateCloudAccountOutput';
  /** The cloud account after updates have been applied */
  cloudAccount: CloudAccount;
};

export type UpdateCloudWatchLogIntegrationInput = {
  filterPattern?: InputMaybe<Scalars['String']['input']>;
  logGroup: Scalars['String']['input'];
  logProcessingRole: Scalars['String']['input'];
  logStreamTypeOptions?: InputMaybe<LogStreamTypeOptionsInput>;
  logTypes: Array<Scalars['String']['input']>;
  managedBucketNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  s3Bucket?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDashboardInput = {
  icon: DashboardIconInput;
  id: Scalars['ID']['input'];
  inputs?: InputMaybe<Array<InputMaybe<DashboardInputInput>>>;
  name: Scalars['String']['input'];
  widgets?: InputMaybe<Array<InputMaybe<UpdateWidgetInput>>>;
};

export type UpdateDetectionFilterInput = {
  detectionId: Scalars['String']['input'];
  statement: DetectionFilterStatementInput;
};

export type UpdateEnrichmentIntegrationInput = {
  config: EnrichmentIntegrationConfigInput;
  integrationId: Scalars['ID']['input'];
  integrationLabel: Scalars['String']['input'];
};

export type UpdateGeneralSettingsConfigInput = {
  analyticsConsent?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  licenseAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  pantherAIAutoResolve?: InputMaybe<PantherAIAutoResolveConfigInput>;
  pantherAIAutoRunOnAlert?: InputMaybe<PantherAIAutoRunOnAlertConfigInput>;
  pantherAICustomerPrompt?: InputMaybe<Scalars['String']['input']>;
  pantherAIEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pantherAIKendra?: InputMaybe<PantherAIKendraConfigInput>;
  pantherAIRemoteMcp?: InputMaybe<PantherAIRemoteMCPConfigInput>;
  pantherAIWebTool?: InputMaybe<PantherAIWebToolConfigInput>;
  scheduledQueriesRequireLimitClause?: InputMaybe<Scalars['Boolean']['input']>;
  shouldEmailAlertAssignees?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Timezone>;
  usesPAT?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateGitHubAppConfigInput = {
  configID?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Ignored by the backend. installationId is owned by the GitHub install callback (SetInstallationID); to repoint at a different installation, re-run the registration flow. */
  installationID?: InputMaybe<Scalars['String']['input']>;
  organization: Scalars['String']['input'];
  readBranch: Scalars['String']['input'];
  repository: Scalars['String']['input'];
};

export type UpdateGitHubAppConfigResponse = {
  __typename?: 'UpdateGitHubAppConfigResponse';
  gitHubAppConfig: GitHubAppConfig;
};

export type UpdateLogSourceFiltersInput = {
  filters: SourceFiltersInput;
  id: Scalars['String']['input'];
};

export type UpdateLogSourceInput = {
  amazonSecurityLake?: InputMaybe<PutAmazonSecurityLakeLogIntegrationInput>;
  azureEventHub?: InputMaybe<PutAzureEventHubLogIntegrationInput>;
  cloudwatch?: InputMaybe<UpdateCloudWatchLogIntegrationInput>;
  eventbridge?: InputMaybe<PutEventBridgeIntegrationInput>;
  gcpPubSub?: InputMaybe<PutGcpPubSubLogIntegrationInput>;
  gcs?: InputMaybe<PutGcsLogIntegrationInput>;
  http?: InputMaybe<PutHttpLogIntegrationInput>;
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
  logForwarder?: InputMaybe<PutLogForwarderLogIntegrationInput>;
  otlp?: InputMaybe<PutOTLPLogIntegrationInput>;
  puller?: InputMaybe<PutLogPullingIntegrationInput>;
  s3?: InputMaybe<UpdateS3LogIntegrationInput>;
  sqs?: InputMaybe<PutSqsLogIntegrationInput>;
  type: SourceType;
};

export type UpdateLookupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  logTypeMap?: InputMaybe<LogTypeMapInput>;
  lookupSchema?: InputMaybe<LookupSchemaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  refresh?: InputMaybe<LookupRefreshConfigInput>;
  scheduledQuery?: InputMaybe<LookupScheduledQueryConfigInput>;
};

export type UpdateMcpServerInput = {
  awsExternalId?: InputMaybe<Scalars['String']['input']>;
  awsRoleArn?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  oauthClientId?: InputMaybe<Scalars['String']['input']>;
  oauthClientSecret?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMcpToolSettingsInput = {
  serverId: Scalars['ID']['input'];
  toolSettings: Array<McpToolSettingInput>;
};

export type UpdateMitreReportMappingInput = {
  add: UpdateMitreReportMappingSelection;
  remove: UpdateMitreReportMappingSelection;
  reportKeys: Array<Scalars['String']['input']>;
};

export type UpdateMitreReportMappingOutput = {
  __typename?: 'UpdateMitreReportMappingOutput';
  detections: Array<InternalDetection>;
};

export type UpdateMitreReportMappingSelection = {
  detectionIds: Array<Scalars['ID']['input']>;
};

export type UpdateMitreReportSettings = {
  note: Scalars['String']['input'];
  override: ReportOverrideSetting;
  tacticId: Scalars['ID']['input'];
  techniqueId: Scalars['ID']['input'];
};

export type UpdateNotificationInput = {
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  readAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdatePolicyInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  managed?: InputMaybe<Scalars['Boolean']['input']>;
  outputIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  reports: Array<DetectionReportMappingInput>;
  resourceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  runbook?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<Severity>;
  suppressions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tests?: InputMaybe<Array<InputMaybe<DetectionTestDefinitionInput>>>;
};

export type UpdateQueryUserConfigInput = {
  chartProperties: Array<QueryChartPropertyConfigInput>;
  queryId: Scalars['ID']['input'];
  tableProperties: Array<QueryTablePropertyConfigInput>;
};

/** The input to the updateRole mutation */
export type UpdateRoleInput = {
  /** The ID of the role to update */
  id: Scalars['ID']['input'];
  /** The log types that the role can or cannot access, according to the `logTypeAccessKind` field. This field should be omitted if `logTypeAccessKind` has a value of `ALLOW_ALL` or `DENY_ALL` */
  logTypeAccess?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Defines the role's access to log types. This field is required and has effect only if the datalake RBAC feature is enabled. */
  logTypeAccessKind?: InputMaybe<LogTypeAccessKind>;
  /** A new name for the role */
  name?: InputMaybe<Scalars['String']['input']>;
  /** An array of the role's new permissions */
  permissions?: InputMaybe<Array<Permission>>;
};

/** The output to the updateRole mutation */
export type UpdateRoleOutput = {
  __typename?: 'UpdateRoleOutput';
  /** The updated role */
  role: Role;
};

export type UpdateRuleAndFilterInput = {
  analysisType: DetectionType;
  baseDetection?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  createAlert: Scalars['Boolean']['input'];
  dedupPeriodMinutes?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  dynamicAlertContext?: InputMaybe<Scalars['String']['input']>;
  dynamicAlertTitle?: InputMaybe<Scalars['String']['input']>;
  dynamicGroupBy?: InputMaybe<Scalars['String']['input']>;
  dynamicSeverities?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  filterStatement?: InputMaybe<DetectionFilterStatementInput>;
  id: Scalars['ID']['input'];
  inlineFilters?: InputMaybe<Scalars['String']['input']>;
  isSimpleDetection: Scalars['Boolean']['input'];
  logTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  managed?: InputMaybe<Scalars['Boolean']['input']>;
  outputIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  reports: Array<DetectionReportMappingInput>;
  runbook?: InputMaybe<Scalars['String']['input']>;
  scheduledQueries?: InputMaybe<Array<Scalars['String']['input']>>;
  severity?: InputMaybe<Severity>;
  simpleDetectionBody?: InputMaybe<Scalars['String']['input']>;
  summaryAttributes: Array<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tests?: InputMaybe<Array<DetectionTestDefinitionInput>>;
  threshold?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateRuleV2Input = {
  body: Scalars['String']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateRuleV2Output = {
  __typename?: 'UpdateRuleV2Output';
  rule?: Maybe<Rule>;
  testResults?: Maybe<Array<TestResult>>;
};

export type UpdateS3LogIntegrationInput = {
  kmsKey?: InputMaybe<Scalars['String']['input']>;
  logProcessingRole: Scalars['String']['input'];
  logStreamType?: InputMaybe<LogStreamType>;
  logStreamTypeOptions?: InputMaybe<LogStreamTypeOptionsInput>;
  managedBucketNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  s3Bucket?: InputMaybe<Scalars['String']['input']>;
  s3PrefixLogTypes?: InputMaybe<Array<S3PrefixLogTypesInput>>;
};

/** Input for the updateS3Source mutation */
export type UpdateS3SourceInput = {
  /** The Id of the S3 Log Source */
  id: Scalars['String']['input'];
  /** The KMS key ARN. Only necessary if your bucket has KMS encryption */
  kmsKey: Scalars['String']['input'];
  /** The label of the S3 Log Source */
  label: Scalars['String']['input'];
  /** The IAM role ARN that Panther will assume to process data from this S3 bucket */
  logProcessingRole: Scalars['String']['input'];
  /** The stream type of the S3 Log Source */
  logStreamType: LogStreamType;
  /** Options for the log stream type */
  logStreamTypeOptions?: InputMaybe<LogStreamTypeOptionsInput>;
  /** True if bucket notifications should be managed by Panther */
  managedBucketNotifications: Scalars['Boolean']['input'];
  /** The S3 prefix settings of the S3 Log Source */
  s3PrefixLogTypes: Array<S3PrefixLogTypesInput>;
};

/** Output for the updateS3LogSource mutation */
export type UpdateS3SourceOutput = {
  __typename?: 'UpdateS3SourceOutput';
  logSource: S3LogIntegration;
};

export type UpdateSamlConfigInput = {
  defaultRoleId?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  idpInitiated?: InputMaybe<Scalars['Boolean']['input']>;
  metadataFile?: InputMaybe<Scalars['String']['input']>;
  metadataUrl?: InputMaybe<Scalars['String']['input']>;
  ssoOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSavedQueryInput = {
  defaultDatabase?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disable?: InputMaybe<Scalars['Boolean']['input']>;
  emailConfig?: InputMaybe<EmailConfigInput>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
  queryCookie?: InputMaybe<Scalars['String']['input']>;
  queryKind?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<ScheduleInput>;
  sqlQuery: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input for updating a scheduled prompt */
export type UpdateScheduledPromptInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  kind?: InputMaybe<AISummarizeKind>;
  /**
   * Allowed only on legacy records (whose name predates the displayName split).
   * The UI keeps the field readonly for records authored after the split, since
   * changing the upsert key would break YAML re-import and external references.
   */
  name?: InputMaybe<Scalars['String']['input']>;
  outputLength?: InputMaybe<OutputLength>;
  /** Whether conversations created by this prompt should be private */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  promptText?: InputMaybe<Scalars['String']['input']>;
  runAsUserId?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<ScheduleInput>;
};

/**
 * The payload to the `updateSchemaStatus` mutation
 * Used to toggle the archive state of a Custom Schema
 */
export type UpdateSchemaStatusInput = {
  /** The new archive state of the schema */
  isArchived: Scalars['Boolean']['input'];
  /** The name of the Custom Schema */
  name: Scalars['String']['input'];
};

export enum UpdateStatus {
  AlreadyBeingUpdated = 'ALREADY_BEING_UPDATED',
  CanBeUpdated = 'CAN_BE_UPDATED',
  UnableToDetermine = 'UNABLE_TO_DETERMINE',
  UpdateProducesFailingUnitTests = 'UPDATE_PRODUCES_FAILING_UNIT_TESTS',
  UpdateProducesMergeConflicts = 'UPDATE_PRODUCES_MERGE_CONFLICTS',
}

/** The input to the updateUser query */
export type UpdateUserInput = {
  /** The email address of the User */
  email?: InputMaybe<Scalars['Email']['input']>;
  /** The family/last Name of the User */
  familyName?: InputMaybe<Scalars['String']['input']>;
  /** The given/first name of the User */
  givenName?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier of this User */
  id: Scalars['ID']['input'];
  /** The ID or Name of the User's role */
  role?: InputMaybe<UserRoleInput>;
};

export type UpdateUserNotificationsInput = {
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  readAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateUserNotificationsOutput = {
  __typename?: 'UpdateUserNotificationsOutput';
  notifications: Array<Notification>;
};

/** The return value of the Update User mutation */
export type UpdateUserOutput = {
  __typename?: 'UpdateUserOutput';
  /** The updated Panther User object */
  user: User;
};

export type UpdateWidgetInput = {
  content: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  layout: WidgetLayoutInput;
  type: DashboardWidgetType;
};

/** The payload to the `uploadDetectionEntitiesAsync` mutation */
export type UploadDetectionEntitiesAsyncInput = {
  /** Base64-encoded zipfile (up to 5MB) containing detection entities */
  data: Scalars['String']['input'];
  /**
   * When true, the upload will be a dry run and no changes will be made
   * It is only applicable for the V2_ZIP mode
   */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The mode of the upload. Defaults to CLASSIC_ZIP */
  mode?: InputMaybe<UploadDetectionEntitiesMode>;
  /** Version of the panther_analysis_tool being used to upload */
  patVersion?: InputMaybe<Scalars['String']['input']>;
  /** Version of the pypanther tool being used to upload */
  pypantherVersion?: InputMaybe<Scalars['String']['input']>;
};

/** The response of the `uploadDetectionEntitiesAsync` mutation */
export type UploadDetectionEntitiesAsyncOutput = {
  __typename?: 'UploadDetectionEntitiesAsyncOutput';
  /** The receipt ID that can be used to check on the status of the upload */
  receiptId: Scalars['ID']['output'];
};

/** The payload to the `uploadDetectionEntities` mutation */
export type UploadDetectionEntitiesInput = {
  /** Base64-encoded zipfile (up to 5MB) containing detection entities */
  data: Scalars['String']['input'];
  /** The mode of the upload. Defaults to CLASSIC_ZIP */
  mode?: InputMaybe<UploadDetectionEntitiesMode>;
};

/** The different modes available for uploading Detection entities */
export enum UploadDetectionEntitiesMode {
  /** Classic ZIP file upload */
  ClassicZip = 'CLASSIC_ZIP',
  /** V2 of the detection content, with class based detections */
  V2Zip = 'V2_ZIP',
}

/** The response of the `uploadDetectionEntities` mutation */
export type UploadDetectionEntitiesOutput = {
  __typename?: 'UploadDetectionEntitiesOutput';
  correlationRules: UploadStatistics;
  dataModels: UploadStatistics;
  globalHelpers: UploadStatistics;
  lookupTables: UploadStatistics;
  policies: UploadStatistics;
  queries: UploadStatistics;
  rules: UploadStatistics;
  scheduledPrompts: UploadStatistics;
  skills: UploadStatistics;
};

/** The statistics about entities uploaded */
export type UploadStatistics = {
  __typename?: 'UploadStatistics';
  /** The number of items deleted */
  deleted: Scalars['Int']['output'];
  /** The IDs of the items deleted */
  deletedIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** The number of items modified */
  modified: Scalars['Int']['output'];
  /** The IDs of the items modified */
  modifiedIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** The number of items added */
  new: Scalars['Int']['output'];
  /** The IDs of the items added */
  newIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** The total number of items uploaded */
  total: Scalars['Int']['output'];
  /** The IDs of the total items uploaded */
  totalIds?: Maybe<Array<Scalars['ID']['output']>>;
};

/** The different modes available for uploading Detection entities */
export enum UploadStatus {
  /** The detection entities upload has completed */
  Completed = 'COMPLETED',
  /** The detection entities upload has failed */
  Failed = 'FAILED',
  /** The detection entities upload has not yet been processed */
  NotProcessed = 'NOT_PROCESSED',
}

/** The details around a physical User entity in Panther */
export type User = {
  __typename?: 'User';
  /** Date and time when the User got created */
  createdAt: Scalars['DateTime']['output'];
  /** The email address of the User */
  email: Scalars['Email']['output'];
  /** Whether the user is active or deactivated. */
  enabled: Scalars['Boolean']['output'];
  /** The family/last name of the User */
  familyName?: Maybe<Scalars['String']['output']>;
  /** The given/first name of the User */
  givenName?: Maybe<Scalars['String']['output']>;
  /** Whether the user's current role is coming from the SAML assertion */
  hasSamlAssignedRole: Scalars['Boolean']['output'];
  /** Whether the user's current role is the SAML default role */
  hasSamlDefaultRole: Scalars['Boolean']['output'];
  /** The unique identifier of this User */
  id: Scalars['ID']['output'];
  /** Date and time when the User last logged in. This value is null if the user has never logged in. */
  lastLoggedInAt?: Maybe<Scalars['DateTime']['output']>;
  /** The details of the Role that this User has */
  role: Role;
  /** The Cognito auth-related status of this User */
  status: Scalars['String']['output'];
};

/** The input payload for the `feedback` field of the `SendUserFeedbackInput` */
export type UserFeedbackDataInput = {
  /** The URL of the page that the feedback was given from */
  locationUrl?: InputMaybe<Scalars['String']['input']>;
  /** The width of the user's screen in pixels */
  screenWidth?: InputMaybe<Scalars['Int']['input']>;
  /** The text that the user sent as feedback */
  text: Scalars['String']['input'];
  /** Marks how useful the feature is on a scale of 1 to 5 */
  usefulness?: InputMaybe<Scalars['Int']['input']>;
};

/** The input payload for the `feature` field of the `SendUserFeedbackInput` */
export type UserFeedbackFeatureInput = {
  /** The name of the feature that the user is submitting feedback for */
  name: Scalars['String']['input'];
};

export type UserPreferencesOutput = {
  __typename?: 'UserPreferencesOutput';
  aiPrompt?: Maybe<Scalars['String']['output']>;
  bookmarkedConversationIds?: Maybe<Array<Scalars['ID']['output']>>;
  displayUtcTimeZone?: Maybe<Scalars['Boolean']['output']>;
  receiveAlertAssignmentEmails?: Maybe<Scalars['Boolean']['output']>;
  theme?: Maybe<Scalars['String']['output']>;
};

/** The input to select a role by either ID or Name */
export type UserRoleInput = {
  /** The role field to search by */
  kind: UserRoleInputKind;
  /** The value of the role field */
  value: Scalars['String']['input'];
};

/** The role field to search by */
export enum UserRoleInputKind {
  Id = 'ID',
  Name = 'NAME',
}

export type ValidateAndTestAllAnalysisItemsInput = {
  items: Array<AnalysisItemForTest>;
};

export type ValidateAndTestAllAnalysisItemsOutput = {
  __typename?: 'ValidateAndTestAllAnalysisItemsOutput';
  items: Array<AnalysisItemTestRunResult>;
};

/** The payload to the `validateBulkUpload` mutation */
export type ValidateBulkUploadInput = {
  /** Base64-encoded zipfile (up to 5MB) containing detection entities */
  data: Scalars['String']['input'];
  /** The mode of the upload. Defaults to CLASSIC_ZIP */
  mode?: InputMaybe<UploadDetectionEntitiesMode>;
  /** Version of the panther_analysis_tool being used to upload */
  patVersion: Scalars['String']['input'];
};

/** The response of the `validateBulkUpload` mutation */
export type ValidateBulkUploadOutput = {
  __typename?: 'ValidateBulkUploadOutput';
  /** The receipt ID that can be used to check on the status of the upload */
  receiptId: Scalars['ID']['output'];
};

/** The response of the `validateBulkUploadStatus` query */
export type ValidateUploadStatusOutput = {
  __typename?: 'ValidateUploadStatusOutput';
  /** The time the detection entities upload was created */
  createdAt: Scalars['DateTime']['output'];
  /** If the detection entities upload failed, the error that occurred */
  error?: Maybe<Scalars['String']['output']>;
  /** If the detection entities upload succeeded, the result of the upload */
  result?: Maybe<BulkValidateResult>;
  /** The current status of the detection entities upload */
  status: UploadStatus;
};

export type ViewBucketDataFilterInput = {
  excludedPrefixes?: InputMaybe<Array<Scalars['String']['input']>>;
  prefix?: InputMaybe<Scalars['String']['input']>;
};

export type ViewBucketDataInput = {
  filters?: InputMaybe<ViewBucketDataFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paginationToken?: InputMaybe<Scalars['String']['input']>;
  sourceId: Scalars['String']['input'];
  streamType: LogStreamType;
};

export type ViewParsedEvent = {
  __typename?: 'ViewParsedEvent';
  error?: Maybe<Scalars['String']['output']>;
  parsedEvent: Scalars['String']['output'];
  rawEvent: Scalars['String']['output'];
  s3ObjectKey: Scalars['String']['output'];
};

export type ViewParsedEventsInput = {
  excludedPrefixes?: InputMaybe<Array<Scalars['String']['input']>>;
  s3Prefix?: InputMaybe<Scalars['String']['input']>;
  schemaName: Scalars['String']['input'];
  schemaSpec?: InputMaybe<Scalars['String']['input']>;
  sourceId: Scalars['String']['input'];
  streamType: LogStreamType;
};

export type ViewParsedEventsResponse = {
  __typename?: 'ViewParsedEventsResponse';
  results: Array<ViewParsedEvent>;
};

export type VirusTotalIoCStreamConfig = {
  __typename?: 'VirusTotalIoCStreamConfig';
  apiKey: Scalars['String']['output'];
  maxAgeDays?: Maybe<Scalars['Int']['output']>;
  profilePullers: VirusTotalIoCStreamProfilePullerConfig;
};

export type VirusTotalIoCStreamConfigInput = {
  apiKey: Scalars['String']['input'];
  maxAgeDays?: InputMaybe<Scalars['Int']['input']>;
  profilePullers: VirusTotalIoCStreamProfilePullerConfigInput;
};

export type VirusTotalIoCStreamProfilePullerConfig = {
  __typename?: 'VirusTotalIoCStreamProfilePullerConfig';
  iocStream: ProfilePullerConfig;
};

export type VirusTotalIoCStreamProfilePullerConfigInput = {
  iocStream: ProfilePullerConfigInput;
};

export type Widget = {
  __typename?: 'Widget';
  content: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  layout: WidgetLayout;
  type: DashboardWidgetType;
};

export type WidgetLayout = {
  __typename?: 'WidgetLayout';
  h: Scalars['Int']['output'];
  w: Scalars['Int']['output'];
  x: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
};

export type WidgetLayoutInput = {
  h: Scalars['Int']['input'];
  w: Scalars['Int']['input'];
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
};

export type WizConfig = {
  __typename?: 'WizConfig';
  apiEndpoint: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  projectIds: Array<Scalars['String']['output']>;
  tokenUrl: Scalars['String']['output'];
};

export type WizConfigInput = {
  apiEndpoint: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  projectIds: Array<Scalars['String']['input']>;
  tokenUrl: Scalars['String']['input'];
};

export type WorkbenchFile = {
  __typename?: 'WorkbenchFile';
  conflictCount: Scalars['Int']['output'];
  content: Scalars['String']['output'];
};

export type WorkbenchPickerItem = {
  __typename?: 'WorkbenchPickerItem';
  analysisType: AnalysisType;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type WorkdayConfig = {
  __typename?: 'WorkdayConfig';
  activityClientId: Scalars['String']['output'];
  activityClientSecret: Scalars['String']['output'];
  activityRefreshToken: Scalars['String']['output'];
  domainName: WorkdayDomainName;
  integrationPassword: Scalars['String']['output'];
  integrationUsername: Scalars['String']['output'];
  signOnAccountName: Scalars['String']['output'];
  signOnCustomReport: Scalars['String']['output'];
  tenantHostName: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
};

export type WorkdayConfigInput = {
  activityClientId?: InputMaybe<Scalars['String']['input']>;
  activityClientSecret?: InputMaybe<Scalars['String']['input']>;
  activityRefreshToken?: InputMaybe<Scalars['String']['input']>;
  domainName: WorkdayDomainName;
  integrationPassword?: InputMaybe<Scalars['String']['input']>;
  integrationUsername?: InputMaybe<Scalars['String']['input']>;
  signOnAccountName?: InputMaybe<Scalars['String']['input']>;
  signOnCustomReport?: InputMaybe<Scalars['String']['input']>;
  tenantHostName: Scalars['String']['input'];
  tenantName: Scalars['String']['input'];
};

export enum WorkdayDomainName {
  Myworkday = 'myworkday',
  Workday = 'workday',
}

export type ZendeskApiConfigInput = {
  apiToken: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export enum ZendeskAuthorizationMethodEnum {
  ApiToken = 'API_TOKEN',
  Basic = 'BASIC',
  Oauth2 = 'OAUTH2',
}

export type ZendeskBasicConfigInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type ZendeskLogSourceApiConfig = {
  __typename?: 'ZendeskLogSourceApiConfig';
  apiToken: Scalars['String']['output'];
  email: Scalars['String']['output'];
};

export type ZendeskLogSourceBasicConfig = {
  __typename?: 'ZendeskLogSourceBasicConfig';
  email: Scalars['String']['output'];
  password: Scalars['String']['output'];
};

export type ZendeskLogSourceConfig = {
  __typename?: 'ZendeskLogSourceConfig';
  authorizationMethod: ZendeskAuthorizationMethodEnum;
  credentials: ZendeskLogSourceCredentialsConfig;
  subdomain: Scalars['String']['output'];
};

export type ZendeskLogSourceCredentialsConfig =
  | ZendeskLogSourceApiConfig
  | ZendeskLogSourceBasicConfig
  | ZendeskLogSourceOAuth2Config;

export type ZendeskLogSourceInput = {
  apiCredentials?: InputMaybe<ZendeskApiConfigInput>;
  authorizationMethod: ZendeskAuthorizationMethodEnum;
  basicCredentials?: InputMaybe<ZendeskBasicConfigInput>;
  oauth2Credentials?: InputMaybe<ZendeskOAuth2ConfigInput>;
  subdomain: Scalars['String']['input'];
};

export type ZendeskLogSourceOAuth2Config = {
  __typename?: 'ZendeskLogSourceOAuth2Config';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
};

export type ZendeskOAuth2ConfigInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
};

export type ZoomConfig = {
  __typename?: 'ZoomConfig';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  granularScopesEnabled: Scalars['Boolean']['output'];
};

export type ZoomConfigInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  granularScopesEnabled: Scalars['Boolean']['input'];
};

export type ResolverTypeWrapper<T> = Promise<T> | T;

export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs,
> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<
  TResult,
  TKey extends string,
  TParent = {},
  TContext = {},
  TArgs = {},
> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo,
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (
  obj: T,
  context: TContext,
  info: GraphQLResolveInfo,
) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => TResult | Promise<TResult>;

/** Mapping of union types */
export type ResolversUnionTypes<RefType extends Record<string, unknown>> = {
  Actor: (Omit<APIToken, 'rotatedBy'> & { rotatedBy?: Maybe<RefType['Actor']> }) | User;
  AlertActivityHistoryRecordContent:
    | AlertActivityHistoryAssigneeChange
    | AlertActivityHistoryCommentAdded
    | AlertActivityHistoryContextTagsChange
    | AlertActivityHistoryQualityChange
    | AlertActivityHistorySlackbotBoomerang
    | AlertActivityHistoryStatusChange;
  AlertOrigin:
    | AlertOriginPolicy
    | AlertOriginReplayedRule
    | AlertOriginRule
    | (Omit<AlertOriginSystemError, 'relatedEntity'> & {
        relatedEntity?: Maybe<RefType['SystemErrorRelatedEntity']>;
      })
    | DeletedDetection
    | (Omit<Detection, 'createdBy' | 'updatedBy'> & {
        createdBy?: Maybe<RefType['Actor']>;
        updatedBy?: Maybe<RefType['Actor']>;
      })
    | SystemError;
  CommentEntity: Omit<Alert, 'origin' | 'updatedBy'> & {
    origin: RefType['AlertOrigin'];
    updatedBy?: Maybe<RefType['Actor']>;
  };
  DatalakeSchemaEntity:
    | DatalakeSchemaColumnEntity
    | DatalakeSchemaDatalakeEntity
    | DatalakeSchemaPropertyEntity
    | DatalakeSchemaTableEntity;
  DetectionReportEntry: MitreReportEntry | StandardReportEntry;
  GithubLogSourceCredentialsConfig: GithubLogSourceOAuth2Config | GithubLogSourcePatConfig;
  GsuiteCredentialsConfig:
    | GsuiteOAuth2Config
    | GsuiteServiceAccountConfig
    | GsuiteWorkloadIdentityFederationConfig;
  InternalDetection:
    | (Omit<CorrelationRule, 'createdBy' | 'lastModifiedBy'> & {
        createdBy?: Maybe<RefType['Actor']>;
        lastModifiedBy?: Maybe<RefType['Actor']>;
      })
    | (Omit<Policy, 'createdBy' | 'lastModifiedBy'> & {
        createdBy?: Maybe<RefType['Actor']>;
        lastModifiedBy?: Maybe<RefType['Actor']>;
      })
    | (Omit<Rule, 'createdBy' | 'lastModifiedBy'> & {
        createdBy?: Maybe<RefType['Actor']>;
        lastModifiedBy?: Maybe<RefType['Actor']>;
      });
  LookupIntegration:
    | EnrichmentIntegration
    | (Omit<LogPullingIntegration, 'createdBy'> & { createdBy?: Maybe<RefType['Actor']> });
  SystemErrorRelatedEntity:
    | (Omit<AmazonSecurityLakeLogIntegration, 'createdBy'> & {
        createdBy?: Maybe<RefType['Actor']>;
      })
    | (Omit<AzureEventHubSourceIntegration, 'createdBy'> & { createdBy?: Maybe<RefType['Actor']> })
    | (Omit<CloudWatchLogIntegration, 'createdBy'> & { createdBy?: Maybe<RefType['Actor']> })
    | (Omit<CorrelationRule, 'createdBy' | 'lastModifiedBy'> & {
        createdBy?: Maybe<RefType['Actor']>;
        lastModifiedBy?: Maybe<RefType['Actor']>;
      })
    | (Omit<Destination, 'createdBy' | 'lastModifiedBy'> & {
        createdBy?: Maybe<RefType['Actor']>;
        lastModifiedBy?: Maybe<RefType['Actor']>;
      })
    | EnrichmentIntegration
    | (Omit<EventBridgeIntegration, 'createdBy'> & { createdBy?: Maybe<RefType['Actor']> })
    | (Omit<GcpPubSubLogSourceIntegration, 'createdBy'> & { createdBy?: Maybe<RefType['Actor']> })
    | (Omit<GcsLogSourceIntegration, 'createdBy'> & { createdBy?: Maybe<RefType['Actor']> })
    | (Omit<HttpLogSourceIntegration, 'createdBy'> & { createdBy?: Maybe<RefType['Actor']> })
    | (Omit<LogForwarderLogSourceIntegration, 'createdBy'> & {
        createdBy?: Maybe<RefType['Actor']>;
      })
    | (Omit<LogPullingIntegration, 'createdBy'> & { createdBy?: Maybe<RefType['Actor']> })
    | (Omit<OTLPLogSourceIntegration, 'createdBy'> & { createdBy?: Maybe<RefType['Actor']> })
    | (Omit<Rule, 'createdBy' | 'lastModifiedBy'> & {
        createdBy?: Maybe<RefType['Actor']>;
        lastModifiedBy?: Maybe<RefType['Actor']>;
      })
    | (Omit<S3LogIntegration, 'createdBy'> & { createdBy?: Maybe<RefType['Actor']> })
    | (Omit<SqsLogSourceIntegration, 'createdBy'> & { createdBy?: Maybe<RefType['Actor']> });
  ZendeskLogSourceCredentialsConfig:
    | ZendeskLogSourceApiConfig
    | ZendeskLogSourceBasicConfig
    | ZendeskLogSourceOAuth2Config;
};

/** Mapping of interface types */
export type ResolversInterfaceTypes<RefType extends Record<string, unknown>> = {
  Job:
    | BulkUploadJob
    | GenerateSchemaFromSqlJob
    | HoldingTankInferJob
    | (Omit<HoldingTankTestJob, 'createdBy'> & { createdBy?: Maybe<RefType['Actor']> })
    | LookupImportDataJob
    | LookupSyncJob
    | (Omit<ReclassifySourceAlarmJob, 'createdBy'> & { createdBy?: Maybe<RefType['Actor']> })
    | SaveLookupJob
    | SummarizeDataLakeQueryJob
    | UpdateAlertStatusByFilterJob
    | UpdateAllCatalogItemsJob;
  LogIntegration:
    | (Omit<AmazonSecurityLakeLogIntegration, 'createdBy'> & {
        createdBy?: Maybe<RefType['Actor']>;
      })
    | (Omit<AzureBlobSourceIntegration, 'createdBy'> & { createdBy?: Maybe<RefType['Actor']> })
    | (Omit<AzureEventHubSourceIntegration, 'createdBy'> & { createdBy?: Maybe<RefType['Actor']> })
    | (Omit<CloudWatchLogIntegration, 'createdBy'> & { createdBy?: Maybe<RefType['Actor']> })
    | (Omit<EventBridgeIntegration, 'createdBy'> & { createdBy?: Maybe<RefType['Actor']> })
    | (Omit<GcpPubSubLogSourceIntegration, 'createdBy'> & { createdBy?: Maybe<RefType['Actor']> })
    | (Omit<GcsLogSourceIntegration, 'createdBy'> & { createdBy?: Maybe<RefType['Actor']> })
    | (Omit<HttpLogSourceIntegration, 'createdBy'> & { createdBy?: Maybe<RefType['Actor']> })
    | (Omit<LogForwarderLogSourceIntegration, 'createdBy'> & {
        createdBy?: Maybe<RefType['Actor']>;
      })
    | (Omit<LogPullingIntegration, 'createdBy'> & { createdBy?: Maybe<RefType['Actor']> })
    | (Omit<OTLPLogSourceIntegration, 'createdBy'> & { createdBy?: Maybe<RefType['Actor']> })
    | (Omit<S3LogIntegration, 'createdBy'> & { createdBy?: Maybe<RefType['Actor']> })
    | (Omit<SqsLogSourceIntegration, 'createdBy'> & { createdBy?: Maybe<RefType['Actor']> });
  TestRecord: TestDetectionRecord | TestPolicyRecord;
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AIAttachmentUploadUrl: ResolverTypeWrapper<AIAttachmentUploadUrl>;
  AIAuthorDetectionInput: AIAuthorDetectionInput;
  AIAuthorDetectionInputDetection: AIAuthorDetectionInputDetection;
  AIAuthorOrganizationProfileInput: AIAuthorOrganizationProfileInput;
  AIAuthorRunbookInput: AIAuthorRunbookInput;
  AIAuthorRunbookInputDetection: AIAuthorRunbookInputDetection;
  AIAuthorSkillInput: AIAuthorSkillInput;
  AIAuthorSkillInputSkill: AIAuthorSkillInputSkill;
  AIConversation: ResolverTypeWrapper<
    Omit<AIConversation, 'createdBy'> & { createdBy?: Maybe<ResolversTypes['Actor']> }
  >;
  AIConversationCategory: AIConversationCategory;
  AIConversationPrivacy: AIConversationPrivacy;
  AIConversationStreamsInput: AIConversationStreamsInput;
  AIConversationsInput: AIConversationsInput;
  AIConversationsOutput: ResolverTypeWrapper<AIConversationsOutput>;
  AIConversationsOutputEdge: ResolverTypeWrapper<AIConversationsOutputEdge>;
  AIConversationsSort: AIConversationsSort;
  AIGeneratePantherFlowQueryContext: AIGeneratePantherFlowQueryContext;
  AIGeneratePantherFlowQueryInput: AIGeneratePantherFlowQueryInput;
  AIGenerateSqlQueryContext: AIGenerateSqlQueryContext;
  AIGenerateSqlQueryInput: AIGenerateSqlQueryInput;
  AIInferenceStream: ResolverTypeWrapper<
    Omit<AIInferenceStream, 'cancelledBy' | 'createdBy' | 'deletedBy' | 'updatedBy'> & {
      cancelledBy?: Maybe<ResolversTypes['Actor']>;
      createdBy?: Maybe<ResolversTypes['Actor']>;
      deletedBy?: Maybe<ResolversTypes['Actor']>;
      updatedBy?: Maybe<ResolversTypes['Actor']>;
    }
  >;
  AIInferenceStreamMetadataWithPath: ResolverTypeWrapper<AIInferenceStreamMetadataWithPath>;
  AIInferenceStreamTextSearchInput: AIInferenceStreamTextSearchInput;
  AIInferenceStreamTextSearchResult: ResolverTypeWrapper<
    Omit<AIInferenceStreamTextSearchResult, 'createdBy'> & {
      createdBy?: Maybe<ResolversTypes['Actor']>;
    }
  >;
  AIInferenceStreamTextSearchResultEdge: ResolverTypeWrapper<AIInferenceStreamTextSearchResultEdge>;
  AIInferenceStreamTextSearchResultList: ResolverTypeWrapper<AIInferenceStreamTextSearchResultList>;
  AIInferenceStreamUsage: ResolverTypeWrapper<AIInferenceStreamUsage>;
  AIInferenceStreamsMetadataInput: AIInferenceStreamsMetadataInput;
  AIInferenceStreamsMetadataList: ResolverTypeWrapper<AIInferenceStreamsMetadataList>;
  AIInferenceStreamsMetadataListEdge: ResolverTypeWrapper<AIInferenceStreamsMetadataListEdge>;
  AIReplayDetectionInput: AIReplayDetectionInput;
  AIResolveAnalysisItemMergeConflictsInput: AIResolveAnalysisItemMergeConflictsInput;
  AISchemaInferenceInput: AISchemaInferenceInput;
  AISkill: ResolverTypeWrapper<
    Omit<AISkill, 'createdBy' | 'deletedBy' | 'updatedBy'> & {
      createdBy?: Maybe<ResolversTypes['Actor']>;
      deletedBy?: Maybe<ResolversTypes['Actor']>;
      updatedBy?: Maybe<ResolversTypes['Actor']>;
    }
  >;
  AISkillListItem: ResolverTypeWrapper<AISkillListItem>;
  AISkillOutput: ResolverTypeWrapper<AISkillOutput>;
  AISkillsInput: AISkillsInput;
  AISkillsOutput: ResolverTypeWrapper<AISkillsOutput>;
  AISkillsOutputEdge: ResolverTypeWrapper<AISkillsOutputEdge>;
  AIStreamConversationLookupOutput: ResolverTypeWrapper<AIStreamConversationLookupOutput>;
  AISummarizeAlertInput: AISummarizeAlertInput;
  AISummarizeDetectionInput: AISummarizeDetectionInput;
  AISummarizeKind: AISummarizeKind;
  AISummarizeLogEventsInput: AISummarizeLogEventsInput;
  AISummarizeMetadata: AISummarizeMetadata;
  AISummarizeQueryResultsInput: AISummarizeQueryResultsInput;
  AIToolInvocation: ResolverTypeWrapper<AIToolInvocation>;
  AIUsageOutput: ResolverTypeWrapper<AIUsageOutput>;
  APIAuthType: APIAuthType;
  APIPaginationStrategy: APIPaginationStrategy;
  APIToken: ResolverTypeWrapper<
    Omit<APIToken, 'rotatedBy'> & { rotatedBy?: Maybe<ResolversTypes['Actor']> }
  >;
  AWSScanConfig: ResolverTypeWrapper<AWSScanConfig>;
  AWSScanConfigInput: AWSScanConfigInput;
  ActiveSuppressCount: ResolverTypeWrapper<ActiveSuppressCount>;
  Actor: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['Actor']>;
  AddAnalysisPackSourceInput: AddAnalysisPackSourceInput;
  AddCloudWatchLogIntegrationInput: AddCloudWatchLogIntegrationInput;
  AddEnrichmentIntegrationInput: AddEnrichmentIntegrationInput;
  AddGlobalHelperInput: AddGlobalHelperInput;
  AddLogSourceInput: AddLogSourceInput;
  AddLookupInput: AddLookupInput;
  AddOrUpdateDataModelInput: AddOrUpdateDataModelInput;
  AddPolicyInput: AddPolicyInput;
  AddRuleInput: AddRuleInput;
  AddRuleV2Input: AddRuleV2Input;
  AddRuleV2Output: ResolverTypeWrapper<AddRuleV2Output>;
  AddS3LogIntegrationInput: AddS3LogIntegrationInput;
  AddSavedQueryInput: AddSavedQueryInput;
  Alert: ResolverTypeWrapper<
    Omit<Alert, 'origin' | 'updatedBy'> & {
      origin: ResolversTypes['AlertOrigin'];
      updatedBy?: Maybe<ResolversTypes['Actor']>;
    }
  >;
  AlertActivityHistoryAssigneeChange: ResolverTypeWrapper<AlertActivityHistoryAssigneeChange>;
  AlertActivityHistoryCommentAdded: ResolverTypeWrapper<AlertActivityHistoryCommentAdded>;
  AlertActivityHistoryContextTagsChange: ResolverTypeWrapper<AlertActivityHistoryContextTagsChange>;
  AlertActivityHistoryInput: AlertActivityHistoryInput;
  AlertActivityHistoryOutput: ResolverTypeWrapper<AlertActivityHistoryOutput>;
  AlertActivityHistoryOutputEdge: ResolverTypeWrapper<AlertActivityHistoryOutputEdge>;
  AlertActivityHistoryOutputPageInfo: ResolverTypeWrapper<AlertActivityHistoryOutputPageInfo>;
  AlertActivityHistoryQualityChange: ResolverTypeWrapper<AlertActivityHistoryQualityChange>;
  AlertActivityHistoryRecord: ResolverTypeWrapper<
    Omit<AlertActivityHistoryRecord, 'content' | 'triggeredBy'> & {
      content: ResolversTypes['AlertActivityHistoryRecordContent'];
      triggeredBy: ResolversTypes['Actor'];
    }
  >;
  AlertActivityHistoryRecordContent: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>['AlertActivityHistoryRecordContent']
  >;
  AlertActivityHistoryRecordTypes: AlertActivityHistoryRecordTypes;
  AlertActivityHistorySlackbotBoomerang: ResolverTypeWrapper<AlertActivityHistorySlackbotBoomerang>;
  AlertActivityHistoryStatusChange: ResolverTypeWrapper<AlertActivityHistoryStatusChange>;
  AlertContextTag: ResolverTypeWrapper<AlertContextTag>;
  AlertContextTagEdge: ResolverTypeWrapper<AlertContextTagEdge>;
  AlertDashboardDataInput: AlertDashboardDataInput;
  AlertDashboardDataOutput: ResolverTypeWrapper<AlertDashboardDataOutput>;
  AlertDelivery: ResolverTypeWrapper<AlertDelivery>;
  AlertEvents: ResolverTypeWrapper<AlertEvents>;
  AlertEventsEdge: ResolverTypeWrapper<AlertEventsEdge>;
  AlertEventsInput: AlertEventsInput;
  AlertEventsOutput: ResolverTypeWrapper<AlertEventsOutput>;
  AlertEventsOutputEdge: ResolverTypeWrapper<AlertEventsOutputEdge>;
  AlertListingType: AlertListingType;
  AlertOrigin: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['AlertOrigin']>;
  AlertOriginPolicy: ResolverTypeWrapper<AlertOriginPolicy>;
  AlertOriginReplayedRule: ResolverTypeWrapper<AlertOriginReplayedRule>;
  AlertOriginRule: ResolverTypeWrapper<AlertOriginRule>;
  AlertOriginSystemError: ResolverTypeWrapper<
    Omit<AlertOriginSystemError, 'relatedEntity'> & {
      relatedEntity?: Maybe<ResolversTypes['SystemErrorRelatedEntity']>;
    }
  >;
  AlertStatus: AlertStatus;
  AlertSummaryAttributeForAnalysis: ResolverTypeWrapper<AlertSummaryAttributeForAnalysis>;
  AlertSummaryAttributeQueryData: ResolverTypeWrapper<AlertSummaryAttributeQueryData>;
  AlertType: AlertType;
  AlertsByDetection: ResolverTypeWrapper<AlertsByDetection>;
  AlertsBySeverity: ResolverTypeWrapper<AlertsBySeverity>;
  AlertsBySeverityAndStatus: ResolverTypeWrapper<AlertsBySeverityAndStatus>;
  AlertsByStatus: ResolverTypeWrapper<AlertsByStatus>;
  AlertsInput: AlertsInput;
  AlertsOutput: ResolverTypeWrapper<AlertsOutput>;
  AlertsOutputEdge: ResolverTypeWrapper<AlertsOutputEdge>;
  AlertsOutputPageInfo: ResolverTypeWrapper<AlertsOutputPageInfo>;
  AlertsPreview: ResolverTypeWrapper<AlertsPreview>;
  AlertsSortFieldsEnum: AlertsSortFieldsEnum;
  AllDatalakeSchemaEntitiesInput: AllDatalakeSchemaEntitiesInput;
  AllDatalakeSchemaEntitiesOutput: ResolverTypeWrapper<
    Omit<AllDatalakeSchemaEntitiesOutput, 'entities'> & {
      entities: Array<Maybe<ResolversTypes['DatalakeSchemaEntity']>>;
    }
  >;
  AllDatalakeSchemaPropertiesInput: AllDatalakeSchemaPropertiesInput;
  AllDatalakeSchemaPropertiesOutput: ResolverTypeWrapper<AllDatalakeSchemaPropertiesOutput>;
  AllGitConfigs: ResolverTypeWrapper<AllGitConfigs>;
  AmazonSecurityLakeConfig: ResolverTypeWrapper<AmazonSecurityLakeConfig>;
  AmazonSecurityLakeLogIntegration: ResolverTypeWrapper<
    Omit<AmazonSecurityLakeLogIntegration, 'createdBy'> & {
      createdBy?: Maybe<ResolversTypes['Actor']>;
    }
  >;
  AmazonSecurityLakeLogIntegrationHealth: ResolverTypeWrapper<AmazonSecurityLakeLogIntegrationHealth>;
  AnalysisItemForSave: AnalysisItemForSave;
  AnalysisItemForTest: AnalysisItemForTest;
  AnalysisItemSaveResult: ResolverTypeWrapper<AnalysisItemSaveResult>;
  AnalysisItemTestRunResult: ResolverTypeWrapper<AnalysisItemTestRunResult>;
  AnalysisPack: ResolverTypeWrapper<
    Omit<AnalysisPack, 'createdBy' | 'lastModifiedBy'> & {
      createdBy?: Maybe<ResolversTypes['Actor']>;
      lastModifiedBy?: Maybe<ResolversTypes['Actor']>;
    }
  >;
  AnalysisPackDefinition: ResolverTypeWrapper<AnalysisPackDefinition>;
  AnalysisPackSource: ResolverTypeWrapper<
    Omit<AnalysisPackSource, 'createdBy' | 'lastModifiedBy'> & {
      createdBy?: Maybe<ResolversTypes['Actor']>;
      lastModifiedBy?: Maybe<ResolversTypes['Actor']>;
    }
  >;
  AnalysisPackTypes: ResolverTypeWrapper<AnalysisPackTypes>;
  AnalysisPackVersion: ResolverTypeWrapper<AnalysisPackVersion>;
  AnalysisType: AnalysisType;
  Annotations: ResolverTypeWrapper<Annotations>;
  AnomaliConfig: ResolverTypeWrapper<AnomaliConfig>;
  AnomaliConfigInput: AnomaliConfigInput;
  AnomaliProfilePullerConfig: ResolverTypeWrapper<AnomaliProfilePullerConfig>;
  AnomaliProfilePullerConfigInput: AnomaliProfilePullerConfigInput;
  AnthropicConfig: ResolverTypeWrapper<AnthropicConfig>;
  AnthropicConfigInput: AnthropicConfigInput;
  AppConfig: ResolverTypeWrapper<AppConfig>;
  ApproveRemoteMcpAuthorizationInput: ApproveRemoteMcpAuthorizationInput;
  ApproveRemoteMcpAuthorizationResult: ResolverTypeWrapper<ApproveRemoteMcpAuthorizationResult>;
  AsanaConfig: ResolverTypeWrapper<AsanaConfig>;
  AsanaConfigInput: AsanaConfigInput;
  AsanaLogSourceConfig: ResolverTypeWrapper<AsanaLogSourceConfig>;
  AsanaLogSourceConfigInput: AsanaLogSourceConfigInput;
  AssociatedLogType: ResolverTypeWrapper<AssociatedLogType>;
  AssociatedLogTypeInput: AssociatedLogTypeInput;
  AtlassianConfig: ResolverTypeWrapper<AtlassianConfig>;
  AtlassianConfigInput: AtlassianConfigInput;
  AutodetectIndicatorFiltersInput: AutodetectIndicatorFiltersInput;
  AutodetectIndicatorFiltersOutput: ResolverTypeWrapper<AutodetectIndicatorFiltersOutput>;
  AvailableLogProvider: ResolverTypeWrapper<AvailableLogProvider>;
  AvailableLogProviderDetails: ResolverTypeWrapper<AvailableLogProviderDetails>;
  AvailableLogProviderParser: ResolverTypeWrapper<AvailableLogProviderParser>;
  AzureBlobConfig: ResolverTypeWrapper<AzureBlobConfig>;
  AzureBlobLogIntegrationHealth: ResolverTypeWrapper<AzureBlobLogIntegrationHealth>;
  AzureBlobSourceIntegration: ResolverTypeWrapper<
    Omit<AzureBlobSourceIntegration, 'createdBy'> & { createdBy?: Maybe<ResolversTypes['Actor']> }
  >;
  AzureCloudType: AzureCloudType;
  AzureEventHubConfig: ResolverTypeWrapper<AzureEventHubConfig>;
  AzureEventHubLogIntegrationHealth: ResolverTypeWrapper<AzureEventHubLogIntegrationHealth>;
  AzureEventHubOptions: ResolverTypeWrapper<AzureEventHubOptions>;
  AzureEventHubSourceIntegration: ResolverTypeWrapper<
    Omit<AzureEventHubSourceIntegration, 'createdBy'> & {
      createdBy?: Maybe<ResolversTypes['Actor']>;
    }
  >;
  BatchInferJobsInput: BatchInferJobsInput;
  BatchInferJobsOutput: ResolverTypeWrapper<BatchInferJobsOutput>;
  BitwardenConfig: ResolverTypeWrapper<BitwardenConfig>;
  BitwardenConfigInput: BitwardenConfigInput;
  BlinkOpsWebhookConfig: ResolverTypeWrapper<BlinkOpsWebhookConfig>;
  BlinkOpsWebhookConfigInput: BlinkOpsWebhookConfigInput;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  BulkDownloadInput: BulkDownloadInput;
  BulkDownloadResponse: ResolverTypeWrapper<BulkDownloadResponse>;
  BulkDownloadScheduledPromptsInput: BulkDownloadScheduledPromptsInput;
  BulkDownloadSkillsInput: BulkDownloadSkillsInput;
  BulkDownloadUrlResponse: ResolverTypeWrapper<BulkDownloadUrlResponse>;
  BulkUpdateDetectionsInput: BulkUpdateDetectionsInput;
  BulkUpdateDetectionsResponse: ResolverTypeWrapper<
    Omit<BulkUpdateDetectionsResponse, 'detections'> & {
      detections: Array<ResolversTypes['InternalDetection']>;
    }
  >;
  BulkUploadDetectionsInput: BulkUploadDetectionsInput;
  BulkUploadIssue: ResolverTypeWrapper<BulkUploadIssue>;
  BulkUploadJob: ResolverTypeWrapper<BulkUploadJob>;
  BulkUploadJobResults: ResolverTypeWrapper<BulkUploadJobResults>;
  BulkUploadPresignedUrlOutput: ResolverTypeWrapper<BulkUploadPresignedUrlOutput>;
  BulkValidateResult: ResolverTypeWrapper<BulkValidateResult>;
  CancelAIInferenceStreamInput: CancelAIInferenceStreamInput;
  CancelDashboardOutput: ResolverTypeWrapper<CancelDashboardOutput>;
  CancelDataLakeQueryInput: CancelDataLakeQueryInput;
  CancelDataLakeQueryOutput: ResolverTypeWrapper<CancelDataLakeQueryOutput>;
  CatalogDataModel: ResolverTypeWrapper<CatalogDataModel>;
  CatalogDetection: ResolverTypeWrapper<CatalogDetection>;
  CatalogEnrichment: ResolverTypeWrapper<CatalogEnrichment>;
  CatalogGlobalHelper: ResolverTypeWrapper<CatalogGlobalHelper>;
  CatalogItemRef: ResolverTypeWrapper<CatalogItemRef>;
  CatalogQuery: ResolverTypeWrapper<CatalogQuery>;
  CloudAccount: ResolverTypeWrapper<
    Omit<CloudAccount, 'createdBy'> & { createdBy?: Maybe<ResolversTypes['Actor']> }
  >;
  CloudAccountsInput: CloudAccountsInput;
  CloudAccountsOutput: ResolverTypeWrapper<CloudAccountsOutput>;
  CloudAccountsOutputEdge: ResolverTypeWrapper<CloudAccountsOutputEdge>;
  CloudWatchLogIntegration: ResolverTypeWrapper<
    Omit<CloudWatchLogIntegration, 'createdBy'> & { createdBy?: Maybe<ResolversTypes['Actor']> }
  >;
  CloudWatchLogIntegrationHealth: ResolverTypeWrapper<CloudWatchLogIntegrationHealth>;
  ColumnType: ColumnType;
  Comment: ResolverTypeWrapper<
    Omit<Comment, 'createdBy' | 'entity'> & {
      createdBy: ResolversTypes['Actor'];
      entity: ResolversTypes['CommentEntity'];
    }
  >;
  CommentEntity: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['CommentEntity']>;
  CommentFormat: CommentFormat;
  CompleteMcpAuthorizationInput: CompleteMcpAuthorizationInput;
  ComplianceIntegrationHealth: ResolverTypeWrapper<ComplianceIntegrationHealth>;
  ComplianceItem: ResolverTypeWrapper<ComplianceItem>;
  ComplianceStatusCounts: ResolverTypeWrapper<ComplianceStatusCounts>;
  ComplianceStatusEnum: ComplianceStatusEnum;
  ContinueAIConversationInput: ContinueAIConversationInput;
  ContinueAIConversationOutput: ResolverTypeWrapper<ContinueAIConversationOutput>;
  CorrelationRule: ResolverTypeWrapper<
    Omit<CorrelationRule, 'createdBy' | 'lastModifiedBy'> & {
      createdBy?: Maybe<ResolversTypes['Actor']>;
      lastModifiedBy?: Maybe<ResolversTypes['Actor']>;
    }
  >;
  CorrelationRuleTestCaseRuleOutputDefinition: ResolverTypeWrapper<CorrelationRuleTestCaseRuleOutputDefinition>;
  CorrelationRuleTestCaseRuleOutputDefinitionInput: CorrelationRuleTestCaseRuleOutputDefinitionInput;
  CreateAIConversationInput: CreateAIConversationInput;
  CreateAIConversationOutput: ResolverTypeWrapper<CreateAIConversationOutput>;
  CreateAISkillInput: CreateAISkillInput;
  CreateAISkillOutput: ResolverTypeWrapper<CreateAISkillOutput>;
  CreateAPITokenInput: CreateAPITokenInput;
  CreateAPITokenOutput: ResolverTypeWrapper<CreateAPITokenOutput>;
  CreateAlertCommentInput: CreateAlertCommentInput;
  CreateAlertCommentOutput: ResolverTypeWrapper<CreateAlertCommentOutput>;
  CreateAzureBlobSourceInput: CreateAzureBlobSourceInput;
  CreateAzureBlobSourceOutput: ResolverTypeWrapper<CreateAzureBlobSourceOutput>;
  CreateCloudAccountInput: CreateCloudAccountInput;
  CreateCloudAccountOutput: ResolverTypeWrapper<CreateCloudAccountOutput>;
  CreateDashboardInput: CreateDashboardInput;
  CreateDetectionFilterInput: CreateDetectionFilterInput;
  CreateDetectionFilterOutput: ResolverTypeWrapper<CreateDetectionFilterOutput>;
  CreateGitHubAppConfigInput: CreateGitHubAppConfigInput;
  CreateGitHubAppConfigResponse: ResolverTypeWrapper<CreateGitHubAppConfigResponse>;
  CreateGitHubAppRegistrationUrlInput: CreateGitHubAppRegistrationUrlInput;
  CreateGitHubAppRegistrationUrlResponse: ResolverTypeWrapper<CreateGitHubAppRegistrationUrlResponse>;
  CreateMcpServerInput: CreateMcpServerInput;
  CreateOrUpdateSchemaInput: CreateOrUpdateSchemaInput;
  CreateOrUpdateSchemaOutput: ResolverTypeWrapper<CreateOrUpdateSchemaOutput>;
  CreatePerfTestInput: CreatePerfTestInput;
  CreatePullRequestForCatalogDataModelInstallInput: CreatePullRequestForCatalogDataModelInstallInput;
  CreatePullRequestForCatalogGlobalHelperInstallInput: CreatePullRequestForCatalogGlobalHelperInstallInput;
  CreatePullRequestForCatalogInstallInput: CreatePullRequestForCatalogInstallInput;
  CreatePullRequestForCatalogSavedQueryInstallInput: CreatePullRequestForCatalogSavedQueryInstallInput;
  CreatePullRequestForCorrelationRuleEditInput: CreatePullRequestForCorrelationRuleEditInput;
  CreatePullRequestForDataModelDeletionInput: CreatePullRequestForDataModelDeletionInput;
  CreatePullRequestForDataModelEditInput: CreatePullRequestForDataModelEditInput;
  CreatePullRequestForDetectionDeletionInput: CreatePullRequestForDetectionDeletionInput;
  CreatePullRequestForGlobalHelperDeletionInput: CreatePullRequestForGlobalHelperDeletionInput;
  CreatePullRequestForGlobalHelperEditInput: CreatePullRequestForGlobalHelperEditInput;
  CreatePullRequestForNewDataModelInput: CreatePullRequestForNewDataModelInput;
  CreatePullRequestForNewGlobalHelperInput: CreatePullRequestForNewGlobalHelperInput;
  CreatePullRequestForNewPolicyInput: CreatePullRequestForNewPolicyInput;
  CreatePullRequestForNewRuleInput: CreatePullRequestForNewRuleInput;
  CreatePullRequestForNewSavedQueryInput: CreatePullRequestForNewSavedQueryInput;
  CreatePullRequestForPolicyEditInput: CreatePullRequestForPolicyEditInput;
  CreatePullRequestForRuleEditInput: CreatePullRequestForRuleEditInput;
  CreatePullRequestForSavedQueryDeletionInput: CreatePullRequestForSavedQueryDeletionInput;
  CreatePullRequestForSavedQueryEditInput: CreatePullRequestForSavedQueryEditInput;
  CreatePullRequestResponse: ResolverTypeWrapper<CreatePullRequestResponse>;
  CreateRSAKeyInput: CreateRSAKeyInput;
  CreateReplayInput: CreateReplayInput;
  CreateReplayOutput: ResolverTypeWrapper<CreateReplayOutput>;
  CreateRoleInput: CreateRoleInput;
  CreateRoleOutput: ResolverTypeWrapper<CreateRoleOutput>;
  CreateS3SourceInput: CreateS3SourceInput;
  CreateS3SourceOutput: ResolverTypeWrapper<CreateS3SourceOutput>;
  CreateScheduledPromptInput: CreateScheduledPromptInput;
  CreateWidgetInput: CreateWidgetInput;
  CredentialFormField: ResolverTypeWrapper<CredentialFormField>;
  CrowdstrikeConfig: ResolverTypeWrapper<CrowdstrikeConfig>;
  CrowdstrikeEventStreamsConfig: ResolverTypeWrapper<CrowdstrikeEventStreamsConfig>;
  CrowdstrikeEventStreamsConfigInput: CrowdstrikeEventStreamsConfigInput;
  CrowdstrikeInput: CrowdstrikeInput;
  CursorBasedPaginationPageInfo: ResolverTypeWrapper<CursorBasedPaginationPageInfo>;
  CustomHeader: ResolverTypeWrapper<CustomHeader>;
  CustomHeaderInput: CustomHeaderInput;
  CustomWebhookConfig: ResolverTypeWrapper<CustomWebhookConfig>;
  CustomWebhookConfigInput: CustomWebhookConfigInput;
  Dashboard: ResolverTypeWrapper<Dashboard>;
  DashboardIcon: ResolverTypeWrapper<DashboardIcon>;
  DashboardIconInput: DashboardIconInput;
  DashboardIconType: DashboardIconType;
  DashboardInput: ResolverTypeWrapper<DashboardInput>;
  DashboardInputInput: DashboardInputInput;
  DashboardMetadata: ResolverTypeWrapper<DashboardMetadata>;
  DashboardSortOrder: DashboardSortOrder;
  DashboardWidgetType: DashboardWidgetType;
  DashboardsInput: DashboardsInput;
  DashboardsOutput: ResolverTypeWrapper<DashboardsOutput>;
  DataLakeDatabase: ResolverTypeWrapper<DataLakeDatabase>;
  DataLakeDatabaseTable: ResolverTypeWrapper<DataLakeDatabaseTable>;
  DataLakeDatabaseTableColumn: ResolverTypeWrapper<DataLakeDatabaseTableColumn>;
  DataLakeDatabaseTableInput: DataLakeDatabaseTableInput;
  DataLakeDatabaseTablesEdges: ResolverTypeWrapper<DataLakeDatabaseTablesEdges>;
  DataLakeDatabaseTablesInput: DataLakeDatabaseTablesInput;
  DataLakeDatabaseTablesOutput: ResolverTypeWrapper<DataLakeDatabaseTablesOutput>;
  DataLakeDatabaseTablesOutputPageInfo: ResolverTypeWrapper<DataLakeDatabaseTablesOutputPageInfo>;
  DataLakeListDefinition: ResolverTypeWrapper<DataLakeListDefinition>;
  DataLakePropertyDefinition: ResolverTypeWrapper<DataLakePropertyDefinition>;
  DataLakePropertyDefinitionsInput: DataLakePropertyDefinitionsInput;
  DataLakePropertyDefinitionsOutput: ResolverTypeWrapper<DataLakePropertyDefinitionsOutput>;
  DataLakePropertyDefinitionsOutputEdge: ResolverTypeWrapper<DataLakePropertyDefinitionsOutputEdge>;
  DataLakePropertySummary: ResolverTypeWrapper<DataLakePropertySummary>;
  DataLakePropertySummaryEntry: ResolverTypeWrapper<DataLakePropertySummaryEntry>;
  DataLakeQueriesInput: DataLakeQueriesInput;
  DataLakeQueriesOutput: ResolverTypeWrapper<DataLakeQueriesOutput>;
  DataLakeQueriesOutputPageInfo: ResolverTypeWrapper<DataLakeQueriesOutputPageInfo>;
  DataLakeQueriesSortFields: DataLakeQueriesSortFields;
  DataLakeQuery: ResolverTypeWrapper<
    Omit<DataLakeQuery, 'issuedBy'> & { issuedBy?: Maybe<ResolversTypes['Actor']> }
  >;
  DataLakeQueryEdge: ResolverTypeWrapper<DataLakeQueryEdge>;
  DataLakeQueryResultEdge: ResolverTypeWrapper<DataLakeQueryResultEdge>;
  DataLakeQueryResultRecordsPageInfo: ResolverTypeWrapper<DataLakeQueryResultRecordsPageInfo>;
  DataLakeQueryResults: ResolverTypeWrapper<DataLakeQueryResults>;
  DataLakeQueryResultsColumnInfo: ResolverTypeWrapper<DataLakeQueryResultsColumnInfo>;
  DataLakeQueryResultsInput: DataLakeQueryResultsInput;
  DataLakeQuerySortDirection: DataLakeQuerySortDirection;
  DataLakeQueryStats: ResolverTypeWrapper<DataLakeQueryStats>;
  DataLakeQueryStatus: DataLakeQueryStatus;
  DataLakeQueryVisualization: ResolverTypeWrapper<DataLakeQueryVisualization>;
  DataLakeQueryVisualizationResults: ResolverTypeWrapper<DataLakeQueryVisualizationResults>;
  DataLakeQueryVisualizationResultsColumn: ResolverTypeWrapper<DataLakeQueryVisualizationResultsColumn>;
  DataLakeQueryVisualizationResultsRow: ResolverTypeWrapper<DataLakeQueryVisualizationResultsRow>;
  DataModel: ResolverTypeWrapper<
    Omit<DataModel, 'createdBy' | 'lastModifiedBy'> & {
      createdBy?: Maybe<ResolversTypes['Actor']>;
      lastModifiedBy?: Maybe<ResolversTypes['Actor']>;
    }
  >;
  DataModelMapping: ResolverTypeWrapper<DataModelMapping>;
  DataModelMappingInput: DataModelMappingInput;
  DataWindow: ResolverTypeWrapper<DataWindow>;
  DataWindowInput: DataWindowInput;
  DatabaseAndTable: ResolverTypeWrapper<DatabaseAndTable>;
  DatabaseAndTableInput: DatabaseAndTableInput;
  DatalakeFieldValuesInput: DatalakeFieldValuesInput;
  DatalakeFieldValuesOutput: ResolverTypeWrapper<DatalakeFieldValuesOutput>;
  DatalakeSchemaColumnEntity: ResolverTypeWrapper<DatalakeSchemaColumnEntity>;
  DatalakeSchemaDatalakeEntity: ResolverTypeWrapper<DatalakeSchemaDatalakeEntity>;
  DatalakeSchemaEntity: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>['DatalakeSchemaEntity']
  >;
  DatalakeSchemaEntityType: DatalakeSchemaEntityType;
  DatalakeSchemaProperty: ResolverTypeWrapper<DatalakeSchemaProperty>;
  DatalakeSchemaPropertyEntity: ResolverTypeWrapper<DatalakeSchemaPropertyEntity>;
  DatalakeSchemaTableEntity: ResolverTypeWrapper<DatalakeSchemaTableEntity>;
  DateRange: ResolverTypeWrapper<DateRange>;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']['output']>;
  DecideToolInvocationInput: DecideToolInvocationInput;
  DeleteAISkillOutput: ResolverTypeWrapper<DeleteAISkillOutput>;
  DeleteAPITokenOutput: ResolverTypeWrapper<DeleteAPITokenOutput>;
  DeleteAlertContextTagInput: DeleteAlertContextTagInput;
  DeleteCloudAccountInput: DeleteCloudAccountInput;
  DeleteCloudAccountOutput: ResolverTypeWrapper<DeleteCloudAccountOutput>;
  DeleteDataModelInput: DeleteDataModelInput;
  DeleteDetectionsInput: DeleteDetectionsInput;
  DeleteDetectionsOutput: ResolverTypeWrapper<DeleteDetectionsOutput>;
  DeleteEntry: DeleteEntry;
  DeleteGitConfigInput: DeleteGitConfigInput;
  DeleteGlobalHelpersInput: DeleteGlobalHelpersInput;
  DeleteLookupsInput: DeleteLookupsInput;
  DeleteRoleInput: DeleteRoleInput;
  DeleteRoleOutput: ResolverTypeWrapper<DeleteRoleOutput>;
  DeleteSavedQueriesByNameInput: DeleteSavedQueriesByNameInput;
  DeleteSavedQueriesByNameOutput: ResolverTypeWrapper<DeleteSavedQueriesByNameOutput>;
  DeleteSavedQueryInput: DeleteSavedQueryInput;
  DeleteScheduledPromptInput: DeleteScheduledPromptInput;
  DeleteSourceInput: DeleteSourceInput;
  DeleteSourceOutput: ResolverTypeWrapper<DeleteSourceOutput>;
  DeleteUserInput: DeleteUserInput;
  DeleteUserOutput: ResolverTypeWrapper<DeleteUserOutput>;
  DeletedDetection: ResolverTypeWrapper<DeletedDetection>;
  DeliverAlertInput: DeliverAlertInput;
  Destination: ResolverTypeWrapper<
    Omit<Destination, 'createdBy' | 'lastModifiedBy'> & {
      createdBy?: Maybe<ResolversTypes['Actor']>;
      lastModifiedBy?: Maybe<ResolversTypes['Actor']>;
    }
  >;
  DestinationConfig: ResolverTypeWrapper<DestinationConfig>;
  DestinationConfigInput: DestinationConfigInput;
  DestinationInput: DestinationInput;
  DestinationTypeEnum: DestinationTypeEnum;
  Detection: ResolverTypeWrapper<
    Omit<Detection, 'createdBy' | 'updatedBy'> & {
      createdBy?: Maybe<ResolversTypes['Actor']>;
      updatedBy?: Maybe<ResolversTypes['Actor']>;
    }
  >;
  DetectionAlertMetricsInput: DetectionAlertMetricsInput;
  DetectionAlertMetricsInputDetection: DetectionAlertMetricsInputDetection;
  DetectionAlertMetricsOutput: ResolverTypeWrapper<DetectionAlertMetricsOutput>;
  DetectionEntitiesUploadStatusOutput: ResolverTypeWrapper<DetectionEntitiesUploadStatusOutput>;
  DetectionFilter: ResolverTypeWrapper<DetectionFilter>;
  DetectionFilterCondition: ResolverTypeWrapper<DetectionFilterCondition>;
  DetectionFilterConditionInput: DetectionFilterConditionInput;
  DetectionFilterStatement: ResolverTypeWrapper<DetectionFilterStatement>;
  DetectionFilterStatementInput: DetectionFilterStatementInput;
  DetectionPatch: DetectionPatch;
  DetectionRefInput: DetectionRefInput;
  DetectionReportEntry: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>['DetectionReportEntry']
  >;
  DetectionReportMapping: ResolverTypeWrapper<
    Omit<DetectionReportMapping, 'entries'> & {
      entries?: Maybe<Array<ResolversTypes['DetectionReportEntry']>>;
    }
  >;
  DetectionReportMappingInput: DetectionReportMappingInput;
  DetectionStatsDetectionTypeCount: ResolverTypeWrapper<DetectionStatsDetectionTypeCount>;
  DetectionStatsEnabledStateCount: ResolverTypeWrapper<DetectionStatsEnabledStateCount>;
  DetectionStatsResponse: ResolverTypeWrapper<DetectionStatsResponse>;
  DetectionStatsSeverityCount: ResolverTypeWrapper<DetectionStatsSeverityCount>;
  DetectionTestDefinition: ResolverTypeWrapper<DetectionTestDefinition>;
  DetectionTestDefinitionInput: DetectionTestDefinitionInput;
  DetectionTestDefinitionMockInput: DetectionTestDefinitionMockInput;
  DetectionTestDefinitionProtected: ResolverTypeWrapper<DetectionTestDefinitionProtected>;
  DetectionTestFilterDefinition: DetectionTestFilterDefinition;
  DetectionTestMockDefinition: ResolverTypeWrapper<DetectionTestMockDefinition>;
  DetectionTestMockDefinitionProtected: ResolverTypeWrapper<DetectionTestMockDefinitionProtected>;
  DetectionType: DetectionType;
  DetectionUpdateError: ResolverTypeWrapper<DetectionUpdateError>;
  DiscordConfig: ResolverTypeWrapper<DiscordConfig>;
  DiscordConfigInput: DiscordConfigInput;
  DiscoverMcpServerInput: DiscoverMcpServerInput;
  DiscoverTaxiiCollectionsInput: DiscoverTaxiiCollectionsInput;
  DiscoverTaxiiCollectionsOutput: ResolverTypeWrapper<DiscoverTaxiiCollectionsOutput>;
  DiscoveredTaxiiCollection: ResolverTypeWrapper<DiscoveredTaxiiCollection>;
  DraftSchema: ResolverTypeWrapper<DraftSchema>;
  DuoConfig: ResolverTypeWrapper<DuoConfig>;
  DuoConfigInput: DuoConfigInput;
  EditAIInferenceStreamInput: EditAIInferenceStreamInput;
  Email: ResolverTypeWrapper<Scalars['Email']['output']>;
  EmailConfig: ResolverTypeWrapper<EmailConfig>;
  EmailConfigInput: EmailConfigInput;
  EnrichmentIntegration: ResolverTypeWrapper<EnrichmentIntegration>;
  EnrichmentIntegrationConfig: ResolverTypeWrapper<EnrichmentIntegrationConfig>;
  EnrichmentIntegrationConfigInput: EnrichmentIntegrationConfigInput;
  EnrichmentIntegrationHealth: ResolverTypeWrapper<EnrichmentIntegrationHealth>;
  Error: ResolverTypeWrapper<Error>;
  ErrorCode: ErrorCode;
  EventBridgeConfig: ResolverTypeWrapper<EventBridgeConfig>;
  EventBridgeIntegration: ResolverTypeWrapper<
    Omit<EventBridgeIntegration, 'createdBy'> & { createdBy?: Maybe<ResolversTypes['Actor']> }
  >;
  EventBridgeIntegrationHealth: ResolverTypeWrapper<EventBridgeIntegrationHealth>;
  EventFilter: ResolverTypeWrapper<EventFilter>;
  EventFilterInput: EventFilterInput;
  EventThresholdAlarm: ResolverTypeWrapper<EventThresholdAlarm>;
  EventThresholdAlarmInput: EventThresholdAlarmInput;
  EventbridgeOptions: ResolverTypeWrapper<EventbridgeOptions>;
  ExecuteDataLakeQueryInput: ExecuteDataLakeQueryInput;
  ExecuteDataLakeQueryOutput: ResolverTypeWrapper<ExecuteDataLakeQueryOutput>;
  ExecuteIndicatorSearchQueryInput: ExecuteIndicatorSearchQueryInput;
  ExecuteIndicatorSearchQueryOutput: ResolverTypeWrapper<ExecuteIndicatorSearchQueryOutput>;
  ExecuteSimpleSearchQueryInput: ExecuteSimpleSearchQueryInput;
  ExecuteSimpleSearchQueryOutput: ResolverTypeWrapper<ExecuteSimpleSearchQueryOutput>;
  ExecuteUberSearchInput: ExecuteUberSearchInput;
  ExecuteUberSearchOutput: ResolverTypeWrapper<ExecuteUberSearchOutput>;
  ExecuteUberSearchPropertySummaryInput: ExecuteUberSearchPropertySummaryInput;
  ExecuteUberSearchPropertySummaryOutput: ResolverTypeWrapper<ExecuteUberSearchPropertySummaryOutput>;
  ExpelWebhookConfig: ResolverTypeWrapper<ExpelWebhookConfig>;
  ExpelWebhookConfigInput: ExpelWebhookConfigInput;
  FeatureFlagTreatment: ResolverTypeWrapper<FeatureFlagTreatment>;
  FeatureFlagWithDefault: FeatureFlagWithDefault;
  FilterField: ResolverTypeWrapper<FilterField>;
  FilterFieldsInput: FilterFieldsInput;
  FilterFieldsOutput: ResolverTypeWrapper<FilterFieldsOutput>;
  FilterInput: FilterInput;
  FilterMode: FilterMode;
  FilterType: FilterType;
  FlatFilterFieldsInput: FlatFilterFieldsInput;
  FlatFilterFieldsOutput: ResolverTypeWrapper<FlatFilterFieldsOutput>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  GcpPubSubConfig: ResolverTypeWrapper<GcpPubSubConfig>;
  GcpPubSubDestinationConfig: ResolverTypeWrapper<GcpPubSubDestinationConfig>;
  GcpPubSubDestinationConfigInput: GcpPubSubDestinationConfigInput;
  GcpPubSubLogConfigInput: GcpPubSubLogConfigInput;
  GcpPubSubLogIntegrationHealth: ResolverTypeWrapper<GcpPubSubLogIntegrationHealth>;
  GcpPubSubLogSourceIntegration: ResolverTypeWrapper<
    Omit<GcpPubSubLogSourceIntegration, 'createdBy'> & {
      createdBy?: Maybe<ResolversTypes['Actor']>;
    }
  >;
  GcsConfig: ResolverTypeWrapper<GcsConfig>;
  GcsLogConfigInput: GcsLogConfigInput;
  GcsLogIntegrationHealth: ResolverTypeWrapper<GcsLogIntegrationHealth>;
  GcsLogSourceIntegration: ResolverTypeWrapper<
    Omit<GcsLogSourceIntegration, 'createdBy'> & { createdBy?: Maybe<ResolversTypes['Actor']> }
  >;
  GeneralSettingsConfig: ResolverTypeWrapper<GeneralSettingsConfig>;
  GenerateAlertSummaryAttributesQueriesInput: GenerateAlertSummaryAttributesQueriesInput;
  GenerateEnrichedEventInput: GenerateEnrichedEventInput;
  GenerateEnrichedEventResponse: ResolverTypeWrapper<GenerateEnrichedEventResponse>;
  GenerateLogForwarderConfigInput: GenerateLogForwarderConfigInput;
  GenerateS3SampleUploadInput: GenerateS3SampleUploadInput;
  GenerateS3SampleUploadResponse: ResolverTypeWrapper<GenerateS3SampleUploadResponse>;
  GenerateSchemaFromSqlInput: GenerateSchemaFromSqlInput;
  GenerateSchemaFromSqlJob: ResolverTypeWrapper<GenerateSchemaFromSqlJob>;
  GenerateSimpleSearchQueryInput: GenerateSimpleSearchQueryInput;
  GenerateSimpleSearchQueryOutput: ResolverTypeWrapper<GenerateSimpleSearchQueryOutput>;
  GenerateSqlQuerySnippetInput: GenerateSqlQuerySnippetInput;
  GenerateSqlQuerySnippetOutput: ResolverTypeWrapper<GenerateSqlQuerySnippetOutput>;
  GenerateUberSearchQueryInput: GenerateUberSearchQueryInput;
  GenerateUberSearchQueryOutput: ResolverTypeWrapper<GenerateUberSearchQueryOutput>;
  GenericGitConfig: ResolverTypeWrapper<GenericGitConfig>;
  GenericPullerAuthentication: ResolverTypeWrapper<GenericPullerAuthentication>;
  GenericPullerAuthenticationInput: GenericPullerAuthenticationInput;
  GenericPullerConfig: ResolverTypeWrapper<GenericPullerConfig>;
  GenericPullerConfigInput: GenericPullerConfigInput;
  GenericPullerExpectedParam: ResolverTypeWrapper<GenericPullerExpectedParam>;
  GenericPullerExpectedParamInput: GenericPullerExpectedParamInput;
  GenericPullerGeneralSettings: ResolverTypeWrapper<GenericPullerGeneralSettings>;
  GenericPullerGeneralSettingsInput: GenericPullerGeneralSettingsInput;
  GenericPullerPagination: ResolverTypeWrapper<GenericPullerPagination>;
  GenericPullerPaginationInput: GenericPullerPaginationInput;
  GenericPullerPaginationSettings: ResolverTypeWrapper<GenericPullerPaginationSettings>;
  GenericPullerPaginationSettingsInput: GenericPullerPaginationSettingsInput;
  GenericPullerResponseParsing: ResolverTypeWrapper<GenericPullerResponseParsing>;
  GenericPullerResponseParsingInput: GenericPullerResponseParsingInput;
  GenericPullerStrategyConfig: ResolverTypeWrapper<GenericPullerStrategyConfig>;
  GenericPullerStrategyConfigInput: GenericPullerStrategyConfigInput;
  GenericPullerTimeUnit: ResolverTypeWrapper<GenericPullerTimeUnit>;
  GenericPullerTimeUnitInput: GenericPullerTimeUnitInput;
  GetAPITokenOutput: ResolverTypeWrapper<GetAPITokenOutput>;
  GetAlertEventsInput: GetAlertEventsInput;
  GetAsyncQueryDownloadUrlInput: GetAsyncQueryDownloadUrlInput;
  GetAsyncQueryDownloadUrlOutput: ResolverTypeWrapper<GetAsyncQueryDownloadUrlOutput>;
  GetAvailableLogProviderResponse: ResolverTypeWrapper<GetAvailableLogProviderResponse>;
  GetCloudWatchLogIntegrationTemplateInput: GetCloudWatchLogIntegrationTemplateInput;
  GetComplianceIntegrationTemplateInput: GetComplianceIntegrationTemplateInput;
  GetCorrelationRuleInput: GetCorrelationRuleInput;
  GetDetectionInput: GetDetectionInput;
  GetDetectionResponse: ResolverTypeWrapper<
    Omit<GetDetectionResponse, 'detection'> & { detection: ResolversTypes['InternalDetection'] }
  >;
  GetFeatureFlagsInput: GetFeatureFlagsInput;
  GetFeatureFlagsResponse: ResolverTypeWrapper<GetFeatureFlagsResponse>;
  GetGlobalHelperInput: GetGlobalHelperInput;
  GetLookupCloudFormationRoleTemplateInput: GetLookupCloudFormationRoleTemplateInput;
  GetPolicyInput: GetPolicyInput;
  GetPresignedUploadURLInput: GetPresignedUploadURLInput;
  GetRelatedAlertsInput: GetRelatedAlertsInput;
  GetResourceInput: GetResourceInput;
  GetRuleInput: GetRuleInput;
  GetRuleV2Input: GetRuleV2Input;
  GetS3LogIntegrationTemplateInput: GetS3LogIntegrationTemplateInput;
  GetSampleDataInput: GetSampleDataInput;
  GetSampleDataResponse: ResolverTypeWrapper<GetSampleDataResponse>;
  GetSchemaInput: GetSchemaInput;
  GetSchemaOutput: ResolverTypeWrapper<GetSchemaOutput>;
  GetTerraformTemplateInput: GetTerraformTemplateInput;
  GitHubAppConfig: ResolverTypeWrapper<GitHubAppConfig>;
  GithubAuthorizationMethodEnum: GithubAuthorizationMethodEnum;
  GithubConfig: ResolverTypeWrapper<GithubConfig>;
  GithubConfigInput: GithubConfigInput;
  GithubLogSourceConfig: ResolverTypeWrapper<
    Omit<GithubLogSourceConfig, 'credentials'> & {
      credentials: ResolversTypes['GithubLogSourceCredentialsConfig'];
    }
  >;
  GithubLogSourceCredentialsConfig: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>['GithubLogSourceCredentialsConfig']
  >;
  GithubLogSourceInput: GithubLogSourceInput;
  GithubLogSourceOAuth2Config: ResolverTypeWrapper<GithubLogSourceOAuth2Config>;
  GithubLogSourcePatConfig: ResolverTypeWrapper<GithubLogSourcePatConfig>;
  GithubOAuth2ConfigInput: GithubOAuth2ConfigInput;
  GithubPatConfigInput: GithubPatConfigInput;
  GlobalHelper: ResolverTypeWrapper<GlobalHelper>;
  GrantMcpServerAccessInput: GrantMcpServerAccessInput;
  GreyNoiseConfig: ResolverTypeWrapper<GreyNoiseConfig>;
  GreyNoiseConfigInput: GreyNoiseConfigInput;
  GreyNoiseProfilePullerConfig: ResolverTypeWrapper<GreyNoiseProfilePullerConfig>;
  GreyNoiseProfilePullerConfigInput: GreyNoiseProfilePullerConfigInput;
  GroupedFilterField: ResolverTypeWrapper<GroupedFilterField>;
  GsuiteAuthorizationMethodEnum: GsuiteAuthorizationMethodEnum;
  GsuiteConfig: ResolverTypeWrapper<
    Omit<GsuiteConfig, 'credentials'> & { credentials: ResolversTypes['GsuiteCredentialsConfig'] }
  >;
  GsuiteConfigInput: GsuiteConfigInput;
  GsuiteCredentialsConfig: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>['GsuiteCredentialsConfig']
  >;
  GsuiteOAuth2Config: ResolverTypeWrapper<GsuiteOAuth2Config>;
  GsuiteOAuth2ConfigInput: GsuiteOAuth2ConfigInput;
  GsuiteProfilePullerConfig: ResolverTypeWrapper<GsuiteProfilePullerConfig>;
  GsuiteProfilePullerConfigInput: GsuiteProfilePullerConfigInput;
  GsuiteServiceAccountConfig: ResolverTypeWrapper<GsuiteServiceAccountConfig>;
  GsuiteServiceAccountConfigInput: GsuiteServiceAccountConfigInput;
  GsuiteWorkloadIdentityFederationConfig: ResolverTypeWrapper<GsuiteWorkloadIdentityFederationConfig>;
  GsuiteWorkloadIdentityFederationConfigInput: GsuiteWorkloadIdentityFederationConfigInput;
  GtiIoCStreamConfig: ResolverTypeWrapper<GtiIoCStreamConfig>;
  GtiIoCStreamConfigInput: GtiIoCStreamConfigInput;
  GtiIoCStreamProfilePullerConfig: ResolverTypeWrapper<GtiIoCStreamProfilePullerConfig>;
  GtiIoCStreamProfilePullerConfigInput: GtiIoCStreamProfilePullerConfigInput;
  HoldingTankFilters: ResolverTypeWrapper<HoldingTankFilters>;
  HoldingTankFiltersInput: HoldingTankFiltersInput;
  HoldingTankGetRunningTaskInput: HoldingTankGetRunningTaskInput;
  HoldingTankInferJob: ResolverTypeWrapper<HoldingTankInferJob>;
  HoldingTankInferJobParams: ResolverTypeWrapper<HoldingTankInferJobParams>;
  HoldingTankInferSchemaInput: HoldingTankInferSchemaInput;
  HoldingTankJobStats: ResolverTypeWrapper<HoldingTankJobStats>;
  HoldingTankListTasksResponse: ResolverTypeWrapper<HoldingTankListTasksResponse>;
  HoldingTankLogTypeTestStats: ResolverTypeWrapper<HoldingTankLogTypeTestStats>;
  HoldingTankRawDataInput: HoldingTankRawDataInput;
  HoldingTankRawDataResponse: ResolverTypeWrapper<HoldingTankRawDataResponse>;
  HoldingTankRawEvent: ResolverTypeWrapper<HoldingTankRawEvent>;
  HoldingTankResults: ResolverTypeWrapper<HoldingTankResults>;
  HoldingTankSchemaInferenceResult: ResolverTypeWrapper<HoldingTankSchemaInferenceResult>;
  HoldingTankTestJob: ResolverTypeWrapper<
    Omit<HoldingTankTestJob, 'createdBy'> & { createdBy?: Maybe<ResolversTypes['Actor']> }
  >;
  HoldingTankTestJobParams: ResolverTypeWrapper<HoldingTankTestJobParams>;
  HoldingTankTestJobPrefixStats: ResolverTypeWrapper<HoldingTankTestJobPrefixStats>;
  HoldingTankTestSchemasResultInput: HoldingTankTestSchemasResultInput;
  HoldingTankTestSchemasResultsResponse: ResolverTypeWrapper<HoldingTankTestSchemasResultsResponse>;
  HttpConfig: ResolverTypeWrapper<HttpConfig>;
  HttpHMACDigestAlgType: HttpHMACDigestAlgType;
  HttpLogConfigInput: HttpLogConfigInput;
  HttpLogIntegrationHealth: ResolverTypeWrapper<HttpLogIntegrationHealth>;
  HttpLogSourceIntegration: ResolverTypeWrapper<
    Omit<HttpLogSourceIntegration, 'createdBy'> & { createdBy?: Maybe<ResolversTypes['Actor']> }
  >;
  HttpOptions: ResolverTypeWrapper<HttpOptions>;
  HttpSecurityType: HttpSecurityType;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  ImportLookupDataInput: ImportLookupDataInput;
  IncidentIoWebhookConfig: ResolverTypeWrapper<IncidentIoWebhookConfig>;
  IncidentIoWebhookConfigInput: IncidentIoWebhookConfigInput;
  IndicatorType: IndicatorType;
  InferSchemaFromBucketDataFiltersInput: InferSchemaFromBucketDataFiltersInput;
  InferSchemaFromBucketDataInput: InferSchemaFromBucketDataInput;
  InferSchemaFromSourceBucketInput: InferSchemaFromSourceBucketInput;
  InferSchemaInput: InferSchemaInput;
  InferSchemaResponse: ResolverTypeWrapper<InferSchemaResponse>;
  InfraCategoryCosts: ResolverTypeWrapper<InfraCategoryCosts>;
  InfraCostInput: InfraCostInput;
  InfraCostOutput: ResolverTypeWrapper<InfraCostOutput>;
  InfraDailyCost: ResolverTypeWrapper<InfraDailyCost>;
  InfrastructureInfo: ResolverTypeWrapper<InfrastructureInfo>;
  IngestionMonitoringSummary: ResolverTypeWrapper<IngestionMonitoringSummary>;
  InitiateMcpAuthorizationInput: InitiateMcpAuthorizationInput;
  InstallCatalogDataModelOutput: ResolverTypeWrapper<InstallCatalogDataModelOutput>;
  InstallCatalogDetectionOutput: ResolverTypeWrapper<InstallCatalogDetectionOutput>;
  InstallCatalogEnrichmentOutput: ResolverTypeWrapper<InstallCatalogEnrichmentOutput>;
  InstallCatalogGlobalHelperOutput: ResolverTypeWrapper<InstallCatalogGlobalHelperOutput>;
  InstallCatalogQueryOutput: ResolverTypeWrapper<InstallCatalogQueryOutput>;
  InstalledCatalogItem: ResolverTypeWrapper<InstalledCatalogItem>;
  InstalledCatalogItemUpdateStatus: ResolverTypeWrapper<InstalledCatalogItemUpdateStatus>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  IntegrationItemHealthStatus: ResolverTypeWrapper<IntegrationItemHealthStatus>;
  IntegrationTemplate: ResolverTypeWrapper<IntegrationTemplate>;
  InternalDetection: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['InternalDetection']>;
  InviteUserInput: InviteUserInput;
  InviteUserOutput: ResolverTypeWrapper<InviteUserOutput>;
  JSON: ResolverTypeWrapper<Scalars['JSON']['output']>;
  JiraAssignableUser: ResolverTypeWrapper<JiraAssignableUser>;
  JiraConfig: ResolverTypeWrapper<JiraConfig>;
  JiraConfigInput: JiraConfigInput;
  JiraOrgMetadata: ResolverTypeWrapper<JiraOrgMetadata>;
  JiraOrgMetadataInput: JiraOrgMetadataInput;
  JiraPriority: ResolverTypeWrapper<JiraPriority>;
  JiraStatusMap: ResolverTypeWrapper<JiraStatusMap>;
  JiraStatusMapInput: JiraStatusMapInput;
  JiraStatusTransitionInput: JiraStatusTransitionInput;
  JiraTransitionStatus: ResolverTypeWrapper<JiraTransitionStatus>;
  Job: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Job']>;
  JobStatus: JobStatus;
  ListAPITokensOutput: ResolverTypeWrapper<ListAPITokensOutput>;
  ListAlertContextTagsOutput: ResolverTypeWrapper<ListAlertContextTagsOutput>;
  ListAlertContextTagsPageInfo: ResolverTypeWrapper<ListAlertContextTagsPageInfo>;
  ListAnalysisItemsForWorkbenchInput: ListAnalysisItemsForWorkbenchInput;
  ListAnalysisItemsForWorkbenchOutput: ResolverTypeWrapper<ListAnalysisItemsForWorkbenchOutput>;
  ListAnalysisPackSourcesInput: ListAnalysisPackSourcesInput;
  ListAnalysisPackSourcesResponse: ResolverTypeWrapper<ListAnalysisPackSourcesResponse>;
  ListAnalysisPacksInput: ListAnalysisPacksInput;
  ListAnalysisPacksResponse: ResolverTypeWrapper<ListAnalysisPacksResponse>;
  ListAvailableLogProvidersResponse: ResolverTypeWrapper<ListAvailableLogProvidersResponse>;
  ListAvailableLogTypesResponse: ResolverTypeWrapper<ListAvailableLogTypesResponse>;
  ListBucketKeysInput: ListBucketKeysInput;
  ListBucketKeysResponse: ResolverTypeWrapper<ListBucketKeysResponse>;
  ListCatalogDataModelsInput: ListCatalogDataModelsInput;
  ListCatalogDataModelsOutput: ResolverTypeWrapper<ListCatalogDataModelsOutput>;
  ListCatalogDetectionsInput: ListCatalogDetectionsInput;
  ListCatalogDetectionsOutput: ResolverTypeWrapper<ListCatalogDetectionsOutput>;
  ListCatalogEnrichmentsInput: ListCatalogEnrichmentsInput;
  ListCatalogEnrichmentsOutput: ResolverTypeWrapper<ListCatalogEnrichmentsOutput>;
  ListCatalogGlobalHelpersInput: ListCatalogGlobalHelpersInput;
  ListCatalogGlobalHelpersOutput: ResolverTypeWrapper<ListCatalogGlobalHelpersOutput>;
  ListCatalogQueriesInput: ListCatalogQueriesInput;
  ListCatalogQueriesOutput: ResolverTypeWrapper<ListCatalogQueriesOutput>;
  ListComplianceItemsResponse: ResolverTypeWrapper<ListComplianceItemsResponse>;
  ListDataModelsInput: ListDataModelsInput;
  ListDataModelsResponse: ResolverTypeWrapper<ListDataModelsResponse>;
  ListDataModelsSortFieldsEnum: ListDataModelsSortFieldsEnum;
  ListDetectionsInput: ListDetectionsInput;
  ListDetectionsResponse: ResolverTypeWrapper<
    Omit<ListDetectionsResponse, 'detections'> & {
      detections: Array<ResolversTypes['InternalDetection']>;
    }
  >;
  ListDetectionsSortFieldsEnum: ListDetectionsSortFieldsEnum;
  ListGitConfigsInput: ListGitConfigsInput;
  ListGitConfigsResponse: ResolverTypeWrapper<ListGitConfigsResponse>;
  ListGlobalHelpersInput: ListGlobalHelpersInput;
  ListGlobalHelpersResponse: ResolverTypeWrapper<ListGlobalHelpersResponse>;
  ListInstalledCatalogItemUpdateStatusesInput: ListInstalledCatalogItemUpdateStatusesInput;
  ListInstalledCatalogItemUpdateStatusesOutput: ResolverTypeWrapper<ListInstalledCatalogItemUpdateStatusesOutput>;
  ListInstalledCatalogItemsInput: ListInstalledCatalogItemsInput;
  ListInstalledCatalogItemsOutput: ResolverTypeWrapper<ListInstalledCatalogItemsOutput>;
  ListLookupResponse: ResolverTypeWrapper<ListLookupResponse>;
  ListLookupsInput: ListLookupsInput;
  ListMcpServersInput: ListMcpServersInput;
  ListResourcesInput: ListResourcesInput;
  ListResourcesResponse: ResolverTypeWrapper<ListResourcesResponse>;
  ListResourcesSortFieldsEnum: ListResourcesSortFieldsEnum;
  ListSavedQueriesInput: ListSavedQueriesInput;
  ListSavedQueriesResponse: ResolverTypeWrapper<ListSavedQueriesResponse>;
  ListScheduledPromptsInput: ListScheduledPromptsInput;
  ListScheduledPromptsResponse: ResolverTypeWrapper<ListScheduledPromptsResponse>;
  ListScheduledPromptsResponseEdge: ResolverTypeWrapper<ListScheduledPromptsResponseEdge>;
  LoadAnalysisItemForWorkbenchInput: LoadAnalysisItemForWorkbenchInput;
  LoadAnalysisItemForWorkbenchOutput: ResolverTypeWrapper<LoadAnalysisItemForWorkbenchOutput>;
  LogForwarderConfigYaml: ResolverTypeWrapper<LogForwarderConfigYaml>;
  LogForwarderGeneratorInput: ResolverTypeWrapper<LogForwarderGeneratorInput>;
  LogForwarderInputConfigInput: LogForwarderInputConfigInput;
  LogForwarderInputType: LogForwarderInputType;
  LogForwarderLogConfigInput: LogForwarderLogConfigInput;
  LogForwarderLogIntegrationHealth: ResolverTypeWrapper<LogForwarderLogIntegrationHealth>;
  LogForwarderLogSourceIntegration: ResolverTypeWrapper<
    Omit<LogForwarderLogSourceIntegration, 'createdBy'> & {
      createdBy?: Maybe<ResolversTypes['Actor']>;
    }
  >;
  LogForwarderSyslogMode: LogForwarderSyslogMode;
  LogIntegration: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['LogIntegration']>;
  LogIntegrationAlarms: ResolverTypeWrapper<LogIntegrationAlarms>;
  LogPullerTypeEnum: LogPullerTypeEnum;
  LogPullingIntegration: ResolverTypeWrapper<
    Omit<LogPullingIntegration, 'createdBy'> & { createdBy?: Maybe<ResolversTypes['Actor']> }
  >;
  LogPullingIntegrationHealth: ResolverTypeWrapper<LogPullingIntegrationHealth>;
  LogPullingOptions: ResolverTypeWrapper<LogPullingOptions>;
  LogSourceBreakdown: ResolverTypeWrapper<LogSourceBreakdown>;
  LogStreamType: LogStreamType;
  LogStreamTypeOptions: ResolverTypeWrapper<LogStreamTypeOptions>;
  LogStreamTypeOptionsInput: LogStreamTypeOptionsInput;
  LogTypeAccessKind: LogTypeAccessKind;
  LogTypeAlertsBySeverity: ResolverTypeWrapper<LogTypeAlertsBySeverity>;
  LogTypeMapInput: LogTypeMapInput;
  Long: ResolverTypeWrapper<Scalars['Long']['output']>;
  Lookup: ResolverTypeWrapper<
    Omit<Lookup, 'integration'> & { integration?: Maybe<ResolversTypes['LookupIntegration']> }
  >;
  LookupEnrichHit: ResolverTypeWrapper<LookupEnrichHit>;
  LookupEnrichOutput: ResolverTypeWrapper<LookupEnrichOutput>;
  LookupImportDataJob: ResolverTypeWrapper<LookupImportDataJob>;
  LookupImportDataJobStats: ResolverTypeWrapper<LookupImportDataJobStats>;
  LookupIntegration: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['LookupIntegration']>;
  LookupRefreshConfig: ResolverTypeWrapper<LookupRefreshConfig>;
  LookupRefreshConfigInput: LookupRefreshConfigInput;
  LookupS3ImportConfig: ResolverTypeWrapper<LookupS3ImportConfig>;
  LookupS3ImportConfigInput: LookupS3ImportConfigInput;
  LookupScheduledQueryConfig: ResolverTypeWrapper<LookupScheduledQueryConfig>;
  LookupScheduledQueryConfigInput: LookupScheduledQueryConfigInput;
  LookupSchemaInput: LookupSchemaInput;
  LookupStats: ResolverTypeWrapper<LookupStats>;
  LookupSyncJob: ResolverTypeWrapper<LookupSyncJob>;
  LookupSyncJobStats: ResolverTypeWrapper<LookupSyncJobStats>;
  LookupVersion: ResolverTypeWrapper<LookupVersion>;
  M365Config: ResolverTypeWrapper<M365Config>;
  M365ConfigInput: M365ConfigInput;
  MarkAllNotificationsAsReadInput: MarkAllNotificationsAsReadInput;
  MarkAllNotificationsAsReadOutput: ResolverTypeWrapper<MarkAllNotificationsAsReadOutput>;
  MarkNotificationAsReadInput: MarkNotificationAsReadInput;
  MatchedLog: ResolverTypeWrapper<MatchedLog>;
  McpAuthType: McpAuthType;
  McpAuthorizationResponse: ResolverTypeWrapper<McpAuthorizationResponse>;
  McpConnectionStatus: McpConnectionStatus;
  McpConnectionTestResult: ResolverTypeWrapper<McpConnectionTestResult>;
  McpRegistrationMode: McpRegistrationMode;
  McpServer: ResolverTypeWrapper<
    Omit<McpServer, 'createdBy' | 'lastModifiedBy'> & {
      createdBy?: Maybe<ResolversTypes['Actor']>;
      lastModifiedBy?: Maybe<ResolversTypes['Actor']>;
    }
  >;
  McpServerDiscovery: ResolverTypeWrapper<McpServerDiscovery>;
  McpServersOutput: ResolverTypeWrapper<McpServersOutput>;
  McpServersOutputEdge: ResolverTypeWrapper<McpServersOutputEdge>;
  McpTool: ResolverTypeWrapper<McpTool>;
  McpToolSettingInput: McpToolSettingInput;
  McpUserConnection: ResolverTypeWrapper<McpUserConnection>;
  MessageActionEnum: MessageActionEnum;
  MetricsInput: MetricsInput;
  MetricsOutput: ResolverTypeWrapper<MetricsOutput>;
  MicrosoftGraphConfig: ResolverTypeWrapper<MicrosoftGraphConfig>;
  MicrosoftGraphConfigInput: MicrosoftGraphConfigInput;
  MindflowWebhookConfig: ResolverTypeWrapper<MindflowWebhookConfig>;
  MindflowWebhookConfigInput: MindflowWebhookConfigInput;
  MitreCombo: ResolverTypeWrapper<MitreCombo>;
  MitreMatrix: ResolverTypeWrapper<MitreMatrix>;
  MitreMatrixContent: ResolverTypeWrapper<MitreMatrixContent>;
  MitreMatrixTacticMapping: ResolverTypeWrapper<MitreMatrixTacticMapping>;
  MitreMatrixTree: ResolverTypeWrapper<MitreMatrixTree>;
  MitreMatrixTreeNode: ResolverTypeWrapper<MitreMatrixTreeNode>;
  MitreReportEntry: ResolverTypeWrapper<MitreReportEntry>;
  MitreTactic: ResolverTypeWrapper<MitreTactic>;
  MitreTechnique: ResolverTypeWrapper<MitreTechnique>;
  ModifyGlobalHelperInput: ModifyGlobalHelperInput;
  MongoDBConfig: ResolverTypeWrapper<MongoDBConfig>;
  MongoDBConfigInput: MongoDBConfigInput;
  MsTeamsConfig: ResolverTypeWrapper<MsTeamsConfig>;
  MsTeamsConfigInput: MsTeamsConfigInput;
  Mutation: ResolverTypeWrapper<{}>;
  NamedMitreAttack: ResolverTypeWrapper<NamedMitreAttack>;
  NetskopeConfig: ResolverTypeWrapper<NetskopeConfig>;
  NetskopeConfigInput: NetskopeConfigInput;
  NetworkingInfo: ResolverTypeWrapper<NetworkingInfo>;
  Notification: ResolverTypeWrapper<Notification>;
  NotificationChannel: ResolverTypeWrapper<NotificationChannel>;
  NotificationChannelInput: NotificationChannelInput;
  NotificationLevel: NotificationLevel;
  NotificationMetadata: ResolverTypeWrapper<NotificationMetadata>;
  NotificationPreference: ResolverTypeWrapper<NotificationPreference>;
  NotificationPreferenceInput: NotificationPreferenceInput;
  NotificationPreferencesOutput: ResolverTypeWrapper<NotificationPreferencesOutput>;
  NotificationTopic: NotificationTopic;
  NotificationsInput: NotificationsInput;
  NotificationsOutput: ResolverTypeWrapper<NotificationsOutput>;
  NotificationsOutputEdge: ResolverTypeWrapper<NotificationsOutputEdge>;
  NotificationsPageInfo: ResolverTypeWrapper<NotificationsPageInfo>;
  OAuth2Info: ResolverTypeWrapper<OAuth2Info>;
  OAuthConfig: ResolverTypeWrapper<OAuthConfig>;
  OAuthConfigInput: OAuthConfigInput;
  OTLPConfig: ResolverTypeWrapper<OTLPConfig>;
  OTLPLogConfigInput: OTLPLogConfigInput;
  OTLPLogIntegrationHealth: ResolverTypeWrapper<OTLPLogIntegrationHealth>;
  OTLPLogSourceIntegration: ResolverTypeWrapper<
    Omit<OTLPLogSourceIntegration, 'createdBy'> & { createdBy?: Maybe<ResolversTypes['Actor']> }
  >;
  OTLPOptions: ResolverTypeWrapper<OTLPOptions>;
  OTLPSecurityType: OTLPSecurityType;
  OTXConfig: ResolverTypeWrapper<OTXConfig>;
  OTXConfigInput: OTXConfigInput;
  OTXProfilePullerConfig: ResolverTypeWrapper<OTXProfilePullerConfig>;
  OTXProfilePullerConfigInput: OTXProfilePullerConfigInput;
  OktaConfig: ResolverTypeWrapper<OktaConfig>;
  OktaConfigInput: OktaConfigInput;
  OktaProfilePullerConfig: ResolverTypeWrapper<OktaProfilePullerConfig>;
  OktaProfilePullerConfigInput: OktaProfilePullerConfigInput;
  OnePasswordConfig: ResolverTypeWrapper<OnePasswordConfig>;
  OnePasswordConfigInput: OnePasswordConfigInput;
  OnePasswordHost: OnePasswordHost;
  OpenAIConfig: ResolverTypeWrapper<OpenAIConfig>;
  OpenAIConfigInput: OpenAIConfigInput;
  OpsgenieConfig: ResolverTypeWrapper<OpsgenieConfig>;
  OpsgenieConfigInput: OpsgenieConfigInput;
  OpsgenieServiceRegionEnum: OpsgenieServiceRegionEnum;
  OrganizationReportBySeverity: ResolverTypeWrapper<OrganizationReportBySeverity>;
  OrganizationStatsInput: OrganizationStatsInput;
  OrganizationStatsResponse: ResolverTypeWrapper<OrganizationStatsResponse>;
  OutputLength: OutputLength;
  PackMigrationFailure: ResolverTypeWrapper<PackMigrationFailure>;
  PackMigrationResult: ResolverTypeWrapper<PackMigrationResult>;
  PackMigrationStatus: ResolverTypeWrapper<PackMigrationStatus>;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  PagerDutyConfig: ResolverTypeWrapper<PagerDutyConfig>;
  PagerDutyConfigInput: PagerDutyConfigInput;
  PagingData: ResolverTypeWrapper<PagingData>;
  PantherAIAutoResolveConfig: ResolverTypeWrapper<PantherAIAutoResolveConfig>;
  PantherAIAutoResolveConfigInput: PantherAIAutoResolveConfigInput;
  PantherAIAutoRunOnAlertConfig: ResolverTypeWrapper<
    Omit<PantherAIAutoRunOnAlertConfig, 'runAsUser'> & {
      runAsUser?: Maybe<ResolversTypes['Actor']>;
    }
  >;
  PantherAIAutoRunOnAlertConfigInput: PantherAIAutoRunOnAlertConfigInput;
  PantherAIKendraConfig: ResolverTypeWrapper<PantherAIKendraConfig>;
  PantherAIKendraConfigInput: PantherAIKendraConfigInput;
  PantherAIRemoteMCPConfig: ResolverTypeWrapper<PantherAIRemoteMCPConfig>;
  PantherAIRemoteMCPConfigInput: PantherAIRemoteMCPConfigInput;
  PantherAIWebToolConfig: ResolverTypeWrapper<PantherAIWebToolConfig>;
  PantherAIWebToolConfigInput: PantherAIWebToolConfigInput;
  PantherFlowQueryWithParametersInput: PantherFlowQueryWithParametersInput;
  PantherFlowQueryWithParametersOutput: ResolverTypeWrapper<PantherFlowQueryWithParametersOutput>;
  Parameter: Parameter;
  ParseRunbookInput: ParseRunbookInput;
  ParseRunbookOutput: ResolverTypeWrapper<ParseRunbookOutput>;
  PatchAlertsByIdInput: PatchAlertsByIdInput;
  PatchAlertsByIdOutput: ResolverTypeWrapper<PatchAlertsByIdOutput>;
  Permission: Permission;
  PoliciesForResourceInput: PoliciesForResourceInput;
  Policy: ResolverTypeWrapper<
    Omit<Policy, 'createdBy' | 'lastModifiedBy'> & {
      createdBy?: Maybe<ResolversTypes['Actor']>;
      lastModifiedBy?: Maybe<ResolversTypes['Actor']>;
    }
  >;
  ProfilePullerConfig: ResolverTypeWrapper<ProfilePullerConfig>;
  ProfilePullerConfigInput: ProfilePullerConfigInput;
  PullRequestOptions: PullRequestOptions;
  PullerConfig: ResolverTypeWrapper<PullerConfig>;
  PutAlertContextTagInput: PutAlertContextTagInput;
  PutAmazonSecurityLakeLogIntegrationInput: PutAmazonSecurityLakeLogIntegrationInput;
  PutAzureEventHubLogIntegrationInput: PutAzureEventHubLogIntegrationInput;
  PutCorrelationRuleInput: PutCorrelationRuleInput;
  PutEventBridgeIntegrationInput: PutEventBridgeIntegrationInput;
  PutGcpPubSubLogIntegrationInput: PutGcpPubSubLogIntegrationInput;
  PutGcsLogIntegrationInput: PutGcsLogIntegrationInput;
  PutHttpLogIntegrationInput: PutHttpLogIntegrationInput;
  PutLogForwarderLogIntegrationInput: PutLogForwarderLogIntegrationInput;
  PutLogPullingIntegrationInput: PutLogPullingIntegrationInput;
  PutNotificationPreferencesInput: PutNotificationPreferencesInput;
  PutOTLPLogIntegrationInput: PutOTLPLogIntegrationInput;
  PutSqsLogIntegrationInput: PutSqsLogIntegrationInput;
  PutUserPreferencesInput: PutUserPreferencesInput;
  Query: ResolverTypeWrapper<{}>;
  QueryChartPropertyConfig: ResolverTypeWrapper<QueryChartPropertyConfig>;
  QueryChartPropertyConfigInput: QueryChartPropertyConfigInput;
  QueryChartType: QueryChartType;
  QueryTablePropertyConfig: ResolverTypeWrapper<QueryTablePropertyConfig>;
  QueryTablePropertyConfigInput: QueryTablePropertyConfigInput;
  QueryUserConfig: ResolverTypeWrapper<QueryUserConfig>;
  RSAKey: ResolverTypeWrapper<RSAKey>;
  Rapid7Config: ResolverTypeWrapper<Rapid7Config>;
  Rapid7ConfigInput: Rapid7ConfigInput;
  Rapid7InsightConnectConfig: ResolverTypeWrapper<Rapid7InsightConnectConfig>;
  Rapid7InsightConnectConfigInput: Rapid7InsightConnectConfigInput;
  RawFilter: ResolverTypeWrapper<RawFilter>;
  RawFiltersInput: RawFiltersInput;
  ReclassifySourceAlarmJob: ResolverTypeWrapper<
    Omit<ReclassifySourceAlarmJob, 'createdBy'> & { createdBy?: Maybe<ResolversTypes['Actor']> }
  >;
  RelatedAlertsOutput: ResolverTypeWrapper<RelatedAlertsOutput>;
  RelatedAlertsOutputEdge: ResolverTypeWrapper<RelatedAlertsOutputEdge>;
  RelatedAlertsOutputPageInfo: ResolverTypeWrapper<RelatedAlertsOutputPageInfo>;
  RelatedComponent: RelatedComponent;
  RelativeTimeDuration: ResolverTypeWrapper<Scalars['RelativeTimeDuration']['output']>;
  RenameAlertContextTagInput: RenameAlertContextTagInput;
  Replay: ResolverTypeWrapper<Replay>;
  ReplayPreview: ResolverTypeWrapper<ReplayPreview>;
  ReplayScope: ResolverTypeWrapper<ReplayScope>;
  ReplayState: ReplayState;
  ReplaySummary: ResolverTypeWrapper<ReplaySummary>;
  ReplayedAlertsInput: ReplayedAlertsInput;
  ReplayedAlertsOutput: ResolverTypeWrapper<ReplayedAlertsOutput>;
  ReportOverrideSetting: ReportOverrideSetting;
  ReportSetting: ResolverTypeWrapper<
    Omit<ReportSetting, 'detections' | 'updatedBy'> & {
      detections: Array<ResolversTypes['InternalDetection']>;
      updatedBy?: Maybe<ResolversTypes['Actor']>;
    }
  >;
  ReportSettingAssociation: ResolverTypeWrapper<ReportSettingAssociation>;
  ReportSettingAssociationMitre: ResolverTypeWrapper<ReportSettingAssociationMitre>;
  ReportType: ReportType;
  RequestSourceInput: RequestSourceInput;
  RequestSourceOutput: ResolverTypeWrapper<RequestSourceOutput>;
  ResetUserPasswordInput: ResetUserPasswordInput;
  ResetUserPasswordOutput: ResolverTypeWrapper<ResetUserPasswordOutput>;
  ResolveAlarmAndReclassifyInput: ResolveAlarmAndReclassifyInput;
  ResolveSourceAlarmInput: ResolveSourceAlarmInput;
  ResourceDetails: ResolverTypeWrapper<ResourceDetails>;
  ResourceSummary: ResolverTypeWrapper<ResourceSummary>;
  ResourcesForPolicyInput: ResourcesForPolicyInput;
  RevokeMcpServerAccessInput: RevokeMcpServerAccessInput;
  RiskIndicator: ResolverTypeWrapper<RiskIndicator>;
  RiskScoreEvidence: ResolverTypeWrapper<RiskScoreEvidence>;
  Role: ResolverTypeWrapper<
    Omit<Role, 'updatedBy'> & { updatedBy?: Maybe<ResolversTypes['Actor']> }
  >;
  RolesInput: RolesInput;
  RotateAPITokenInput: RotateAPITokenInput;
  RotateAPITokenOutput: ResolverTypeWrapper<RotateAPITokenOutput>;
  Rule: ResolverTypeWrapper<
    Omit<Rule, 'createdBy' | 'lastModifiedBy'> & {
      createdBy?: Maybe<ResolversTypes['Actor']>;
      lastModifiedBy?: Maybe<ResolversTypes['Actor']>;
    }
  >;
  RulePythonBodyOutput: ResolverTypeWrapper<RulePythonBodyOutput>;
  RunScheduledPromptNowInput: RunScheduledPromptNowInput;
  RunScheduledPromptNowOutput: ResolverTypeWrapper<RunScheduledPromptNowOutput>;
  Runbook: ResolverTypeWrapper<Runbook>;
  RunbookExecutionPhase: ResolverTypeWrapper<RunbookExecutionPhase>;
  RunbookExecutionState: ResolverTypeWrapper<RunbookExecutionState>;
  RunbookExecutionStep: ResolverTypeWrapper<RunbookExecutionStep>;
  RunbookPhase: ResolverTypeWrapper<RunbookPhase>;
  RunbookPhaseInput: RunbookPhaseInput;
  RunbookPhaseType: RunbookPhaseType;
  RunbookStep: ResolverTypeWrapper<RunbookStep>;
  RunbookStepInput: RunbookStepInput;
  RunbookStepStatus: RunbookStepStatus;
  S3LogIntegration: ResolverTypeWrapper<
    Omit<S3LogIntegration, 'createdBy'> & { createdBy?: Maybe<ResolversTypes['Actor']> }
  >;
  S3LogIntegrationHealth: ResolverTypeWrapper<S3LogIntegrationHealth>;
  S3Object: ResolverTypeWrapper<S3Object>;
  S3PrefixLogTypes: ResolverTypeWrapper<S3PrefixLogTypes>;
  S3PrefixLogTypesInput: S3PrefixLogTypesInput;
  SalesforceConfig: ResolverTypeWrapper<SalesforceConfig>;
  SalesforceConfigDomainConfig: ResolverTypeWrapper<SalesforceConfigDomainConfig>;
  SalesforceConfigDomainConfigInput: SalesforceConfigDomainConfigInput;
  SalesforceConfigInput: SalesforceConfigInput;
  SalesforceDomainType: SalesforceDomainType;
  SalesforceEnvironment: SalesforceEnvironment;
  SamlConfig: ResolverTypeWrapper<SamlConfig>;
  SaveLookupJob: ResolverTypeWrapper<SaveLookupJob>;
  SaveResolvedWorkbenchAnalysisItemsInput: SaveResolvedWorkbenchAnalysisItemsInput;
  SaveResolvedWorkbenchAnalysisItemsOutput: ResolverTypeWrapper<SaveResolvedWorkbenchAnalysisItemsOutput>;
  SavedQuery: ResolverTypeWrapper<
    Omit<SavedQuery, 'createdBy' | 'lastModifiedBy'> & {
      createdBy?: Maybe<ResolversTypes['Actor']>;
      lastModifiedBy?: Maybe<ResolversTypes['Actor']>;
    }
  >;
  SavedQueryDeleteEntry: SavedQueryDeleteEntry;
  ScannedResourceStats: ResolverTypeWrapper<ScannedResourceStats>;
  ScannedResources: ResolverTypeWrapper<ScannedResources>;
  Schedule: ResolverTypeWrapper<Schedule>;
  ScheduleInput: ScheduleInput;
  ScheduledPrompt: ResolverTypeWrapper<
    Omit<ScheduledPrompt, 'createdBy' | 'deletedBy' | 'runAsUser' | 'updatedBy'> & {
      createdBy?: Maybe<ResolversTypes['Actor']>;
      deletedBy?: Maybe<ResolversTypes['Actor']>;
      runAsUser?: Maybe<ResolversTypes['Actor']>;
      updatedBy?: Maybe<ResolversTypes['Actor']>;
    }
  >;
  ScheduledPromptRunStatus: ScheduledPromptRunStatus;
  Schema: ResolverTypeWrapper<Schema>;
  SchemaField: ResolverTypeWrapper<SchemaField>;
  SchemaFieldValueValidation: ResolverTypeWrapper<SchemaFieldValueValidation>;
  SchemaValueType: SchemaValueType;
  SchemasInput: SchemasInput;
  SchemasOutput: ResolverTypeWrapper<SchemasOutput>;
  SchemasOutputEdge: ResolverTypeWrapper<SchemasOutputEdge>;
  SchemasOutputPageInfo: ResolverTypeWrapper<SchemasOutputPageInfo>;
  SearchQueryOperator: SearchQueryOperator;
  SendJiraEventInput: SendJiraEventInput;
  SendJiraEventOutput: ResolverTypeWrapper<SendJiraEventOutput>;
  SendTestAlertInput: SendTestAlertInput;
  SendUserFeedbackInput: SendUserFeedbackInput;
  SendUserFeedbackOutput: ResolverTypeWrapper<SendUserFeedbackOutput>;
  SentinelOneApiConfig: ResolverTypeWrapper<SentinelOneApiConfig>;
  SentinelOneApiConfigInput: SentinelOneApiConfigInput;
  SentinelOneCloudFunnelConfig: ResolverTypeWrapper<SentinelOneCloudFunnelConfig>;
  SentinelOneCloudFunnelConfigInput: SentinelOneCloudFunnelConfigInput;
  SerializeRunbookInput: SerializeRunbookInput;
  SerializeRunbookOutput: ResolverTypeWrapper<SerializeRunbookOutput>;
  Series: ResolverTypeWrapper<Series>;
  SeriesData: ResolverTypeWrapper<SeriesData>;
  SeriesMetric: ResolverTypeWrapper<SeriesMetric>;
  SeriesWithBreakdown: ResolverTypeWrapper<SeriesWithBreakdown>;
  SeriesWithEntityID: ResolverTypeWrapper<SeriesWithEntityID>;
  Severity: Severity;
  SeverityBasedJiraConfig: ResolverTypeWrapper<SeverityBasedJiraConfig>;
  SeverityBasedJiraConfigInput: SeverityBasedJiraConfigInput;
  SignOutSessionsOutput: ResolverTypeWrapper<SignOutSessionsOutput>;
  SimpleSearchQueryType: SimpleSearchQueryType;
  SimpleSearchSource: SimpleSearchSource;
  SizeWindow: ResolverTypeWrapper<SizeWindow>;
  SizeWindowInput: SizeWindowInput;
  SlackBotConfig: ResolverTypeWrapper<SlackBotConfig>;
  SlackBotConfigInput: SlackBotConfigInput;
  SlackConfig: ResolverTypeWrapper<SlackConfig>;
  SlackConfigInput: SlackConfigInput;
  SlackbotBoomerangHistory: ResolverTypeWrapper<
    Omit<SlackbotBoomerangHistory, 'createdBy'> & { createdBy: ResolversTypes['Actor'] }
  >;
  SlackbotBoomerangHistoryType: SlackbotBoomerangHistoryType;
  SnippetHighlight: ResolverTypeWrapper<SnippetHighlight>;
  SnippetWithHighlights: ResolverTypeWrapper<SnippetWithHighlights>;
  SnowflakeAuditConfig: ResolverTypeWrapper<SnowflakeAuditConfig>;
  SnowflakeAuditConfigInput: SnowflakeAuditConfigInput;
  SnowflakeProfilePullerConfig: ResolverTypeWrapper<SnowflakeProfilePullerConfig>;
  SnowflakeProfilePullerConfigInput: SnowflakeProfilePullerConfigInput;
  SnsConfig: ResolverTypeWrapper<SnsConfig>;
  SnsConfigInput: SnsConfigInput;
  SnykConfigInput: SnykConfigInput;
  SnykLogSourceConfig: ResolverTypeWrapper<SnykLogSourceConfig>;
  SortDirEnum: SortDirEnum;
  SourceAlarmsEnum: SourceAlarmsEnum;
  SourceFilters: ResolverTypeWrapper<SourceFilters>;
  SourceFiltersInput: SourceFiltersInput;
  SourceHealthTypesEnum: SourceHealthTypesEnum;
  SourceMetric: ResolverTypeWrapper<SourceMetric>;
  SourceMetricsInput: SourceMetricsInput;
  SourceMetricsResponse: ResolverTypeWrapper<SourceMetricsResponse>;
  SourceStatistics: SourceStatistics;
  SourceStatisticsInput: SourceStatisticsInput;
  SourceStatisticsResponse: ResolverTypeWrapper<SourceStatisticsResponse>;
  SourceStats: ResolverTypeWrapper<SourceStats>;
  SourceType: SourceType;
  SourcesInput: SourcesInput;
  SourcesOutput: ResolverTypeWrapper<SourcesOutput>;
  SourcesOutputEdge: ResolverTypeWrapper<SourcesOutputEdge>;
  SplunkWebhookConfig: ResolverTypeWrapper<SplunkWebhookConfig>;
  SplunkWebhookConfigInput: SplunkWebhookConfigInput;
  SqsConfig: ResolverTypeWrapper<SqsConfig>;
  SqsConfigInput: SqsConfigInput;
  SqsDestinationConfig: ResolverTypeWrapper<SqsDestinationConfig>;
  SqsLogConfigInput: SqsLogConfigInput;
  SqsLogIntegrationHealth: ResolverTypeWrapper<SqsLogIntegrationHealth>;
  SqsLogSourceIntegration: ResolverTypeWrapper<
    Omit<SqsLogSourceIntegration, 'createdBy'> & { createdBy?: Maybe<ResolversTypes['Actor']> }
  >;
  StandardReportEntry: ResolverTypeWrapper<StandardReportEntry>;
  StartAsyncDownloadOfAllQueryResultsInput: StartAsyncDownloadOfAllQueryResultsInput;
  StartAsyncDownloadOfAllQueryResultsOutput: ResolverTypeWrapper<StartAsyncDownloadOfAllQueryResultsOutput>;
  StopReplayInput: StopReplayInput;
  StopReplayOutput: ResolverTypeWrapper<StopReplayOutput>;
  StorageInfo: ResolverTypeWrapper<StorageInfo>;
  StorageProvider: StorageProvider;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  SummarizeDataLakeQueryInput: SummarizeDataLakeQueryInput;
  SummarizeDataLakeQueryJob: ResolverTypeWrapper<SummarizeDataLakeQueryJob>;
  SuppressPoliciesInput: SuppressPoliciesInput;
  SyncLookupDataInput: SyncLookupDataInput;
  SysdigConfig: ResolverTypeWrapper<SysdigConfig>;
  SysdigConfigInput: SysdigConfigInput;
  SystemError: ResolverTypeWrapper<SystemError>;
  SystemErrorRelatedEntity: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>['SystemErrorRelatedEntity']
  >;
  SystemErrorType: SystemErrorType;
  TaxiiCollection: ResolverTypeWrapper<TaxiiCollection>;
  TaxiiCollectionInput: TaxiiCollectionInput;
  TaxiiConfig: ResolverTypeWrapper<TaxiiConfig>;
  TaxiiConfigInput: TaxiiConfigInput;
  TaxiiProfilePullerConfig: ResolverTypeWrapper<TaxiiProfilePullerConfig>;
  TaxiiProfilePullerConfigInput: TaxiiProfilePullerConfigInput;
  TenableConfig: ResolverTypeWrapper<TenableConfig>;
  TenableConfigInput: TenableConfigInput;
  TerraformTemplateResponse: ResolverTypeWrapper<TerraformTemplateResponse>;
  TestCorrelationRuleInput: TestCorrelationRuleInput;
  TestCorrelationRuleResponse: ResolverTypeWrapper<TestCorrelationRuleResponse>;
  TestCorrelationRuleYAMLInput: TestCorrelationRuleYAMLInput;
  TestCorrelationRuleYAMLOutput: ResolverTypeWrapper<TestCorrelationRuleYAMLOutput>;
  TestCorrelationRuleYAMLTestResult: ResolverTypeWrapper<TestCorrelationRuleYAMLTestResult>;
  TestDetectionRecord: ResolverTypeWrapper<TestDetectionRecord>;
  TestDetectionRecordFunctions: ResolverTypeWrapper<TestDetectionRecordFunctions>;
  TestDetectionSubRecord: ResolverTypeWrapper<TestDetectionSubRecord>;
  TestFailure: ResolverTypeWrapper<TestFailure>;
  TestFilterEventInput: TestFilterEventInput;
  TestFilterEventMatch: ResolverTypeWrapper<TestFilterEventMatch>;
  TestFilterEventOutput: ResolverTypeWrapper<TestFilterEventOutput>;
  TestHoldingTankSchemaFiltersInput: TestHoldingTankSchemaFiltersInput;
  TestHoldingTankSchemasInput: TestHoldingTankSchemasInput;
  TestPolicyInput: TestPolicyInput;
  TestPolicyRecord: ResolverTypeWrapper<TestPolicyRecord>;
  TestPolicyRecordFunctions: ResolverTypeWrapper<TestPolicyRecordFunctions>;
  TestPolicyResponse: ResolverTypeWrapper<TestPolicyResponse>;
  TestPollGitResponse: ResolverTypeWrapper<TestPollGitResponse>;
  TestRecord: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['TestRecord']>;
  TestResult: ResolverTypeWrapper<TestResult>;
  TestRuleInput: TestRuleInput;
  TestRuleResponse: ResolverTypeWrapper<TestRuleResponse>;
  TestSchemaData: ResolverTypeWrapper<TestSchemaData>;
  TestSchemaInput: TestSchemaInput;
  TestSchemaResponse: ResolverTypeWrapper<TestSchemaResponse>;
  TestSchemaResult: ResolverTypeWrapper<TestSchemaResult>;
  TestSchemaStats: ResolverTypeWrapper<TestSchemaStats>;
  TimeFormat: TimeFormat;
  TimeUnit: TimeUnit;
  TimeWindow: ResolverTypeWrapper<TimeWindow>;
  TimeWindowInput: TimeWindowInput;
  Timestamp: ResolverTypeWrapper<Scalars['Timestamp']['output']>;
  Timezone: Timezone;
  TinesConfig: ResolverTypeWrapper<TinesConfig>;
  TinesConfigInput: TinesConfigInput;
  TinesWebhookConfig: ResolverTypeWrapper<TinesWebhookConfig>;
  TinesWebhookConfigInput: TinesWebhookConfigInput;
  ToggleScheduledPromptInput: ToggleScheduledPromptInput;
  TorqWebhookConfig: ResolverTypeWrapper<TorqWebhookConfig>;
  TorqWebhookConfigInput: TorqWebhookConfigInput;
  TranspileFiltersInput: TranspileFiltersInput;
  TranspileFiltersOutput: ResolverTypeWrapper<TranspileFiltersOutput>;
  TranspileSimpleDetectionsToPythonInput: TranspileSimpleDetectionsToPythonInput;
  TranspileSimpleDetectionsToPythonOutput: ResolverTypeWrapper<TranspileSimpleDetectionsToPythonOutput>;
  TransportOptions: ResolverTypeWrapper<TransportOptions>;
  UberSearchColumnSummaryInput: UberSearchColumnSummaryInput;
  UberSearchComponent: UberSearchComponent;
  UberSearchPropertySummaryInput: UberSearchPropertySummaryInput;
  UberSearchTablesInput: UberSearchTablesInput;
  UberSearchTablesOutput: ResolverTypeWrapper<UberSearchTablesOutput>;
  UberSearchTablesOutputPageInfo: ResolverTypeWrapper<UberSearchTablesOutputPageInfo>;
  UniversalGitConfig: ResolverTypeWrapper<UniversalGitConfig>;
  UniversalSettingsConfig: ResolverTypeWrapper<UniversalSettingsConfig>;
  UnmatchedLog: ResolverTypeWrapper<UnmatchedLog>;
  UpdateAIConversationInput: UpdateAIConversationInput;
  UpdateAISkillInput: UpdateAISkillInput;
  UpdateAISkillOutput: ResolverTypeWrapper<UpdateAISkillOutput>;
  UpdateAPITokenInput: UpdateAPITokenInput;
  UpdateAPITokenOutput: ResolverTypeWrapper<UpdateAPITokenOutput>;
  UpdateAlertStatusByFilterInput: UpdateAlertStatusByFilterInput;
  UpdateAlertStatusByFilterJob: ResolverTypeWrapper<UpdateAlertStatusByFilterJob>;
  UpdateAlertStatusByIdInput: UpdateAlertStatusByIdInput;
  UpdateAlertStatusByIdOutput: ResolverTypeWrapper<UpdateAlertStatusByIdOutput>;
  UpdateAlertsAssigneeByEmailInput: UpdateAlertsAssigneeByEmailInput;
  UpdateAlertsAssigneeByEmailOutput: ResolverTypeWrapper<UpdateAlertsAssigneeByEmailOutput>;
  UpdateAlertsAssigneeByIdInput: UpdateAlertsAssigneeByIdInput;
  UpdateAlertsAssigneeByIdOutput: ResolverTypeWrapper<UpdateAlertsAssigneeByIdOutput>;
  UpdateAllCatalogItemsFailure: ResolverTypeWrapper<UpdateAllCatalogItemsFailure>;
  UpdateAllCatalogItemsInput: UpdateAllCatalogItemsInput;
  UpdateAllCatalogItemsJob: ResolverTypeWrapper<UpdateAllCatalogItemsJob>;
  UpdateAllCatalogItemsJobStats: ResolverTypeWrapper<UpdateAllCatalogItemsJobStats>;
  UpdateAnalysisPackInput: UpdateAnalysisPackInput;
  UpdateAnalysisPackSourceInput: UpdateAnalysisPackSourceInput;
  UpdateAzureBlobSourceInput: UpdateAzureBlobSourceInput;
  UpdateAzureBlobSourceOutput: ResolverTypeWrapper<UpdateAzureBlobSourceOutput>;
  UpdateCatalogItemInput: UpdateCatalogItemInput;
  UpdateCatalogItemOutput: ResolverTypeWrapper<UpdateCatalogItemOutput>;
  UpdateCloudAccountInput: UpdateCloudAccountInput;
  UpdateCloudAccountOutput: ResolverTypeWrapper<UpdateCloudAccountOutput>;
  UpdateCloudWatchLogIntegrationInput: UpdateCloudWatchLogIntegrationInput;
  UpdateDashboardInput: UpdateDashboardInput;
  UpdateDetectionFilterInput: UpdateDetectionFilterInput;
  UpdateEnrichmentIntegrationInput: UpdateEnrichmentIntegrationInput;
  UpdateGeneralSettingsConfigInput: UpdateGeneralSettingsConfigInput;
  UpdateGitHubAppConfigInput: UpdateGitHubAppConfigInput;
  UpdateGitHubAppConfigResponse: ResolverTypeWrapper<UpdateGitHubAppConfigResponse>;
  UpdateLogSourceFiltersInput: UpdateLogSourceFiltersInput;
  UpdateLogSourceInput: UpdateLogSourceInput;
  UpdateLookupInput: UpdateLookupInput;
  UpdateMcpServerInput: UpdateMcpServerInput;
  UpdateMcpToolSettingsInput: UpdateMcpToolSettingsInput;
  UpdateMitreReportMappingInput: UpdateMitreReportMappingInput;
  UpdateMitreReportMappingOutput: ResolverTypeWrapper<
    Omit<UpdateMitreReportMappingOutput, 'detections'> & {
      detections: Array<ResolversTypes['InternalDetection']>;
    }
  >;
  UpdateMitreReportMappingSelection: UpdateMitreReportMappingSelection;
  UpdateMitreReportSettings: UpdateMitreReportSettings;
  UpdateNotificationInput: UpdateNotificationInput;
  UpdatePolicyInput: UpdatePolicyInput;
  UpdateQueryUserConfigInput: UpdateQueryUserConfigInput;
  UpdateRoleInput: UpdateRoleInput;
  UpdateRoleOutput: ResolverTypeWrapper<UpdateRoleOutput>;
  UpdateRuleAndFilterInput: UpdateRuleAndFilterInput;
  UpdateRuleV2Input: UpdateRuleV2Input;
  UpdateRuleV2Output: ResolverTypeWrapper<UpdateRuleV2Output>;
  UpdateS3LogIntegrationInput: UpdateS3LogIntegrationInput;
  UpdateS3SourceInput: UpdateS3SourceInput;
  UpdateS3SourceOutput: ResolverTypeWrapper<UpdateS3SourceOutput>;
  UpdateSamlConfigInput: UpdateSamlConfigInput;
  UpdateSavedQueryInput: UpdateSavedQueryInput;
  UpdateScheduledPromptInput: UpdateScheduledPromptInput;
  UpdateSchemaStatusInput: UpdateSchemaStatusInput;
  UpdateStatus: UpdateStatus;
  UpdateUserInput: UpdateUserInput;
  UpdateUserNotificationsInput: UpdateUserNotificationsInput;
  UpdateUserNotificationsOutput: ResolverTypeWrapper<UpdateUserNotificationsOutput>;
  UpdateUserOutput: ResolverTypeWrapper<UpdateUserOutput>;
  UpdateWidgetInput: UpdateWidgetInput;
  UploadDetectionEntitiesAsyncInput: UploadDetectionEntitiesAsyncInput;
  UploadDetectionEntitiesAsyncOutput: ResolverTypeWrapper<UploadDetectionEntitiesAsyncOutput>;
  UploadDetectionEntitiesInput: UploadDetectionEntitiesInput;
  UploadDetectionEntitiesMode: UploadDetectionEntitiesMode;
  UploadDetectionEntitiesOutput: ResolverTypeWrapper<UploadDetectionEntitiesOutput>;
  UploadStatistics: ResolverTypeWrapper<UploadStatistics>;
  UploadStatus: UploadStatus;
  User: ResolverTypeWrapper<User>;
  UserFeedbackDataInput: UserFeedbackDataInput;
  UserFeedbackFeatureInput: UserFeedbackFeatureInput;
  UserPreferencesOutput: ResolverTypeWrapper<UserPreferencesOutput>;
  UserRoleInput: UserRoleInput;
  UserRoleInputKind: UserRoleInputKind;
  ValidateAndTestAllAnalysisItemsInput: ValidateAndTestAllAnalysisItemsInput;
  ValidateAndTestAllAnalysisItemsOutput: ResolverTypeWrapper<ValidateAndTestAllAnalysisItemsOutput>;
  ValidateBulkUploadInput: ValidateBulkUploadInput;
  ValidateBulkUploadOutput: ResolverTypeWrapper<ValidateBulkUploadOutput>;
  ValidateUploadStatusOutput: ResolverTypeWrapper<ValidateUploadStatusOutput>;
  ViewBucketDataFilterInput: ViewBucketDataFilterInput;
  ViewBucketDataInput: ViewBucketDataInput;
  ViewParsedEvent: ResolverTypeWrapper<ViewParsedEvent>;
  ViewParsedEventsInput: ViewParsedEventsInput;
  ViewParsedEventsResponse: ResolverTypeWrapper<ViewParsedEventsResponse>;
  VirusTotalIoCStreamConfig: ResolverTypeWrapper<VirusTotalIoCStreamConfig>;
  VirusTotalIoCStreamConfigInput: VirusTotalIoCStreamConfigInput;
  VirusTotalIoCStreamProfilePullerConfig: ResolverTypeWrapper<VirusTotalIoCStreamProfilePullerConfig>;
  VirusTotalIoCStreamProfilePullerConfigInput: VirusTotalIoCStreamProfilePullerConfigInput;
  Widget: ResolverTypeWrapper<Widget>;
  WidgetLayout: ResolverTypeWrapper<WidgetLayout>;
  WidgetLayoutInput: WidgetLayoutInput;
  WizConfig: ResolverTypeWrapper<WizConfig>;
  WizConfigInput: WizConfigInput;
  WorkbenchFile: ResolverTypeWrapper<WorkbenchFile>;
  WorkbenchPickerItem: ResolverTypeWrapper<WorkbenchPickerItem>;
  WorkdayConfig: ResolverTypeWrapper<WorkdayConfig>;
  WorkdayConfigInput: WorkdayConfigInput;
  WorkdayDomainName: WorkdayDomainName;
  ZendeskApiConfigInput: ZendeskApiConfigInput;
  ZendeskAuthorizationMethodEnum: ZendeskAuthorizationMethodEnum;
  ZendeskBasicConfigInput: ZendeskBasicConfigInput;
  ZendeskLogSourceApiConfig: ResolverTypeWrapper<ZendeskLogSourceApiConfig>;
  ZendeskLogSourceBasicConfig: ResolverTypeWrapper<ZendeskLogSourceBasicConfig>;
  ZendeskLogSourceConfig: ResolverTypeWrapper<
    Omit<ZendeskLogSourceConfig, 'credentials'> & {
      credentials: ResolversTypes['ZendeskLogSourceCredentialsConfig'];
    }
  >;
  ZendeskLogSourceCredentialsConfig: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>['ZendeskLogSourceCredentialsConfig']
  >;
  ZendeskLogSourceInput: ZendeskLogSourceInput;
  ZendeskLogSourceOAuth2Config: ResolverTypeWrapper<ZendeskLogSourceOAuth2Config>;
  ZendeskOAuth2ConfigInput: ZendeskOAuth2ConfigInput;
  ZoomConfig: ResolverTypeWrapper<ZoomConfig>;
  ZoomConfigInput: ZoomConfigInput;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AIAttachmentUploadUrl: AIAttachmentUploadUrl;
  AIAuthorDetectionInput: AIAuthorDetectionInput;
  AIAuthorDetectionInputDetection: AIAuthorDetectionInputDetection;
  AIAuthorOrganizationProfileInput: AIAuthorOrganizationProfileInput;
  AIAuthorRunbookInput: AIAuthorRunbookInput;
  AIAuthorRunbookInputDetection: AIAuthorRunbookInputDetection;
  AIAuthorSkillInput: AIAuthorSkillInput;
  AIAuthorSkillInputSkill: AIAuthorSkillInputSkill;
  AIConversation: Omit<AIConversation, 'createdBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  AIConversationStreamsInput: AIConversationStreamsInput;
  AIConversationsInput: AIConversationsInput;
  AIConversationsOutput: AIConversationsOutput;
  AIConversationsOutputEdge: AIConversationsOutputEdge;
  AIGeneratePantherFlowQueryContext: AIGeneratePantherFlowQueryContext;
  AIGeneratePantherFlowQueryInput: AIGeneratePantherFlowQueryInput;
  AIGenerateSqlQueryContext: AIGenerateSqlQueryContext;
  AIGenerateSqlQueryInput: AIGenerateSqlQueryInput;
  AIInferenceStream: Omit<
    AIInferenceStream,
    'cancelledBy' | 'createdBy' | 'deletedBy' | 'updatedBy'
  > & {
    cancelledBy?: Maybe<ResolversParentTypes['Actor']>;
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
    deletedBy?: Maybe<ResolversParentTypes['Actor']>;
    updatedBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  AIInferenceStreamMetadataWithPath: AIInferenceStreamMetadataWithPath;
  AIInferenceStreamTextSearchInput: AIInferenceStreamTextSearchInput;
  AIInferenceStreamTextSearchResult: Omit<AIInferenceStreamTextSearchResult, 'createdBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  AIInferenceStreamTextSearchResultEdge: AIInferenceStreamTextSearchResultEdge;
  AIInferenceStreamTextSearchResultList: AIInferenceStreamTextSearchResultList;
  AIInferenceStreamUsage: AIInferenceStreamUsage;
  AIInferenceStreamsMetadataInput: AIInferenceStreamsMetadataInput;
  AIInferenceStreamsMetadataList: AIInferenceStreamsMetadataList;
  AIInferenceStreamsMetadataListEdge: AIInferenceStreamsMetadataListEdge;
  AIReplayDetectionInput: AIReplayDetectionInput;
  AIResolveAnalysisItemMergeConflictsInput: AIResolveAnalysisItemMergeConflictsInput;
  AISchemaInferenceInput: AISchemaInferenceInput;
  AISkill: Omit<AISkill, 'createdBy' | 'deletedBy' | 'updatedBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
    deletedBy?: Maybe<ResolversParentTypes['Actor']>;
    updatedBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  AISkillListItem: AISkillListItem;
  AISkillOutput: AISkillOutput;
  AISkillsInput: AISkillsInput;
  AISkillsOutput: AISkillsOutput;
  AISkillsOutputEdge: AISkillsOutputEdge;
  AIStreamConversationLookupOutput: AIStreamConversationLookupOutput;
  AISummarizeAlertInput: AISummarizeAlertInput;
  AISummarizeDetectionInput: AISummarizeDetectionInput;
  AISummarizeLogEventsInput: AISummarizeLogEventsInput;
  AISummarizeMetadata: AISummarizeMetadata;
  AISummarizeQueryResultsInput: AISummarizeQueryResultsInput;
  AIToolInvocation: AIToolInvocation;
  AIUsageOutput: AIUsageOutput;
  APIToken: Omit<APIToken, 'rotatedBy'> & { rotatedBy?: Maybe<ResolversParentTypes['Actor']> };
  AWSScanConfig: AWSScanConfig;
  AWSScanConfigInput: AWSScanConfigInput;
  ActiveSuppressCount: ActiveSuppressCount;
  Actor: ResolversUnionTypes<ResolversParentTypes>['Actor'];
  AddAnalysisPackSourceInput: AddAnalysisPackSourceInput;
  AddCloudWatchLogIntegrationInput: AddCloudWatchLogIntegrationInput;
  AddEnrichmentIntegrationInput: AddEnrichmentIntegrationInput;
  AddGlobalHelperInput: AddGlobalHelperInput;
  AddLogSourceInput: AddLogSourceInput;
  AddLookupInput: AddLookupInput;
  AddOrUpdateDataModelInput: AddOrUpdateDataModelInput;
  AddPolicyInput: AddPolicyInput;
  AddRuleInput: AddRuleInput;
  AddRuleV2Input: AddRuleV2Input;
  AddRuleV2Output: AddRuleV2Output;
  AddS3LogIntegrationInput: AddS3LogIntegrationInput;
  AddSavedQueryInput: AddSavedQueryInput;
  Alert: Omit<Alert, 'origin' | 'updatedBy'> & {
    origin: ResolversParentTypes['AlertOrigin'];
    updatedBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  AlertActivityHistoryAssigneeChange: AlertActivityHistoryAssigneeChange;
  AlertActivityHistoryCommentAdded: AlertActivityHistoryCommentAdded;
  AlertActivityHistoryContextTagsChange: AlertActivityHistoryContextTagsChange;
  AlertActivityHistoryInput: AlertActivityHistoryInput;
  AlertActivityHistoryOutput: AlertActivityHistoryOutput;
  AlertActivityHistoryOutputEdge: AlertActivityHistoryOutputEdge;
  AlertActivityHistoryOutputPageInfo: AlertActivityHistoryOutputPageInfo;
  AlertActivityHistoryQualityChange: AlertActivityHistoryQualityChange;
  AlertActivityHistoryRecord: Omit<AlertActivityHistoryRecord, 'content' | 'triggeredBy'> & {
    content: ResolversParentTypes['AlertActivityHistoryRecordContent'];
    triggeredBy: ResolversParentTypes['Actor'];
  };
  AlertActivityHistoryRecordContent: ResolversUnionTypes<ResolversParentTypes>['AlertActivityHistoryRecordContent'];
  AlertActivityHistorySlackbotBoomerang: AlertActivityHistorySlackbotBoomerang;
  AlertActivityHistoryStatusChange: AlertActivityHistoryStatusChange;
  AlertContextTag: AlertContextTag;
  AlertContextTagEdge: AlertContextTagEdge;
  AlertDashboardDataInput: AlertDashboardDataInput;
  AlertDashboardDataOutput: AlertDashboardDataOutput;
  AlertDelivery: AlertDelivery;
  AlertEvents: AlertEvents;
  AlertEventsEdge: AlertEventsEdge;
  AlertEventsInput: AlertEventsInput;
  AlertEventsOutput: AlertEventsOutput;
  AlertEventsOutputEdge: AlertEventsOutputEdge;
  AlertOrigin: ResolversUnionTypes<ResolversParentTypes>['AlertOrigin'];
  AlertOriginPolicy: AlertOriginPolicy;
  AlertOriginReplayedRule: AlertOriginReplayedRule;
  AlertOriginRule: AlertOriginRule;
  AlertOriginSystemError: Omit<AlertOriginSystemError, 'relatedEntity'> & {
    relatedEntity?: Maybe<ResolversParentTypes['SystemErrorRelatedEntity']>;
  };
  AlertSummaryAttributeForAnalysis: AlertSummaryAttributeForAnalysis;
  AlertSummaryAttributeQueryData: AlertSummaryAttributeQueryData;
  AlertsByDetection: AlertsByDetection;
  AlertsBySeverity: AlertsBySeverity;
  AlertsBySeverityAndStatus: AlertsBySeverityAndStatus;
  AlertsByStatus: AlertsByStatus;
  AlertsInput: AlertsInput;
  AlertsOutput: AlertsOutput;
  AlertsOutputEdge: AlertsOutputEdge;
  AlertsOutputPageInfo: AlertsOutputPageInfo;
  AlertsPreview: AlertsPreview;
  AllDatalakeSchemaEntitiesInput: AllDatalakeSchemaEntitiesInput;
  AllDatalakeSchemaEntitiesOutput: Omit<AllDatalakeSchemaEntitiesOutput, 'entities'> & {
    entities: Array<Maybe<ResolversParentTypes['DatalakeSchemaEntity']>>;
  };
  AllDatalakeSchemaPropertiesInput: AllDatalakeSchemaPropertiesInput;
  AllDatalakeSchemaPropertiesOutput: AllDatalakeSchemaPropertiesOutput;
  AllGitConfigs: AllGitConfigs;
  AmazonSecurityLakeConfig: AmazonSecurityLakeConfig;
  AmazonSecurityLakeLogIntegration: Omit<AmazonSecurityLakeLogIntegration, 'createdBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  AmazonSecurityLakeLogIntegrationHealth: AmazonSecurityLakeLogIntegrationHealth;
  AnalysisItemForSave: AnalysisItemForSave;
  AnalysisItemForTest: AnalysisItemForTest;
  AnalysisItemSaveResult: AnalysisItemSaveResult;
  AnalysisItemTestRunResult: AnalysisItemTestRunResult;
  AnalysisPack: Omit<AnalysisPack, 'createdBy' | 'lastModifiedBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
    lastModifiedBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  AnalysisPackDefinition: AnalysisPackDefinition;
  AnalysisPackSource: Omit<AnalysisPackSource, 'createdBy' | 'lastModifiedBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
    lastModifiedBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  AnalysisPackTypes: AnalysisPackTypes;
  AnalysisPackVersion: AnalysisPackVersion;
  Annotations: Annotations;
  AnomaliConfig: AnomaliConfig;
  AnomaliConfigInput: AnomaliConfigInput;
  AnomaliProfilePullerConfig: AnomaliProfilePullerConfig;
  AnomaliProfilePullerConfigInput: AnomaliProfilePullerConfigInput;
  AnthropicConfig: AnthropicConfig;
  AnthropicConfigInput: AnthropicConfigInput;
  AppConfig: AppConfig;
  ApproveRemoteMcpAuthorizationInput: ApproveRemoteMcpAuthorizationInput;
  ApproveRemoteMcpAuthorizationResult: ApproveRemoteMcpAuthorizationResult;
  AsanaConfig: AsanaConfig;
  AsanaConfigInput: AsanaConfigInput;
  AsanaLogSourceConfig: AsanaLogSourceConfig;
  AsanaLogSourceConfigInput: AsanaLogSourceConfigInput;
  AssociatedLogType: AssociatedLogType;
  AssociatedLogTypeInput: AssociatedLogTypeInput;
  AtlassianConfig: AtlassianConfig;
  AtlassianConfigInput: AtlassianConfigInput;
  AutodetectIndicatorFiltersInput: AutodetectIndicatorFiltersInput;
  AutodetectIndicatorFiltersOutput: AutodetectIndicatorFiltersOutput;
  AvailableLogProvider: AvailableLogProvider;
  AvailableLogProviderDetails: AvailableLogProviderDetails;
  AvailableLogProviderParser: AvailableLogProviderParser;
  AzureBlobConfig: AzureBlobConfig;
  AzureBlobLogIntegrationHealth: AzureBlobLogIntegrationHealth;
  AzureBlobSourceIntegration: Omit<AzureBlobSourceIntegration, 'createdBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  AzureEventHubConfig: AzureEventHubConfig;
  AzureEventHubLogIntegrationHealth: AzureEventHubLogIntegrationHealth;
  AzureEventHubOptions: AzureEventHubOptions;
  AzureEventHubSourceIntegration: Omit<AzureEventHubSourceIntegration, 'createdBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  BatchInferJobsInput: BatchInferJobsInput;
  BatchInferJobsOutput: BatchInferJobsOutput;
  BitwardenConfig: BitwardenConfig;
  BitwardenConfigInput: BitwardenConfigInput;
  BlinkOpsWebhookConfig: BlinkOpsWebhookConfig;
  BlinkOpsWebhookConfigInput: BlinkOpsWebhookConfigInput;
  Boolean: Scalars['Boolean']['output'];
  BulkDownloadInput: BulkDownloadInput;
  BulkDownloadResponse: BulkDownloadResponse;
  BulkDownloadScheduledPromptsInput: BulkDownloadScheduledPromptsInput;
  BulkDownloadSkillsInput: BulkDownloadSkillsInput;
  BulkDownloadUrlResponse: BulkDownloadUrlResponse;
  BulkUpdateDetectionsInput: BulkUpdateDetectionsInput;
  BulkUpdateDetectionsResponse: Omit<BulkUpdateDetectionsResponse, 'detections'> & {
    detections: Array<ResolversParentTypes['InternalDetection']>;
  };
  BulkUploadDetectionsInput: BulkUploadDetectionsInput;
  BulkUploadIssue: BulkUploadIssue;
  BulkUploadJob: BulkUploadJob;
  BulkUploadJobResults: BulkUploadJobResults;
  BulkUploadPresignedUrlOutput: BulkUploadPresignedUrlOutput;
  BulkValidateResult: BulkValidateResult;
  CancelAIInferenceStreamInput: CancelAIInferenceStreamInput;
  CancelDashboardOutput: CancelDashboardOutput;
  CancelDataLakeQueryInput: CancelDataLakeQueryInput;
  CancelDataLakeQueryOutput: CancelDataLakeQueryOutput;
  CatalogDataModel: CatalogDataModel;
  CatalogDetection: CatalogDetection;
  CatalogEnrichment: CatalogEnrichment;
  CatalogGlobalHelper: CatalogGlobalHelper;
  CatalogItemRef: CatalogItemRef;
  CatalogQuery: CatalogQuery;
  CloudAccount: Omit<CloudAccount, 'createdBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  CloudAccountsInput: CloudAccountsInput;
  CloudAccountsOutput: CloudAccountsOutput;
  CloudAccountsOutputEdge: CloudAccountsOutputEdge;
  CloudWatchLogIntegration: Omit<CloudWatchLogIntegration, 'createdBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  CloudWatchLogIntegrationHealth: CloudWatchLogIntegrationHealth;
  Comment: Omit<Comment, 'createdBy' | 'entity'> & {
    createdBy: ResolversParentTypes['Actor'];
    entity: ResolversParentTypes['CommentEntity'];
  };
  CommentEntity: ResolversUnionTypes<ResolversParentTypes>['CommentEntity'];
  CompleteMcpAuthorizationInput: CompleteMcpAuthorizationInput;
  ComplianceIntegrationHealth: ComplianceIntegrationHealth;
  ComplianceItem: ComplianceItem;
  ComplianceStatusCounts: ComplianceStatusCounts;
  ContinueAIConversationInput: ContinueAIConversationInput;
  ContinueAIConversationOutput: ContinueAIConversationOutput;
  CorrelationRule: Omit<CorrelationRule, 'createdBy' | 'lastModifiedBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
    lastModifiedBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  CorrelationRuleTestCaseRuleOutputDefinition: CorrelationRuleTestCaseRuleOutputDefinition;
  CorrelationRuleTestCaseRuleOutputDefinitionInput: CorrelationRuleTestCaseRuleOutputDefinitionInput;
  CreateAIConversationInput: CreateAIConversationInput;
  CreateAIConversationOutput: CreateAIConversationOutput;
  CreateAISkillInput: CreateAISkillInput;
  CreateAISkillOutput: CreateAISkillOutput;
  CreateAPITokenInput: CreateAPITokenInput;
  CreateAPITokenOutput: CreateAPITokenOutput;
  CreateAlertCommentInput: CreateAlertCommentInput;
  CreateAlertCommentOutput: CreateAlertCommentOutput;
  CreateAzureBlobSourceInput: CreateAzureBlobSourceInput;
  CreateAzureBlobSourceOutput: CreateAzureBlobSourceOutput;
  CreateCloudAccountInput: CreateCloudAccountInput;
  CreateCloudAccountOutput: CreateCloudAccountOutput;
  CreateDashboardInput: CreateDashboardInput;
  CreateDetectionFilterInput: CreateDetectionFilterInput;
  CreateDetectionFilterOutput: CreateDetectionFilterOutput;
  CreateGitHubAppConfigInput: CreateGitHubAppConfigInput;
  CreateGitHubAppConfigResponse: CreateGitHubAppConfigResponse;
  CreateGitHubAppRegistrationUrlInput: CreateGitHubAppRegistrationUrlInput;
  CreateGitHubAppRegistrationUrlResponse: CreateGitHubAppRegistrationUrlResponse;
  CreateMcpServerInput: CreateMcpServerInput;
  CreateOrUpdateSchemaInput: CreateOrUpdateSchemaInput;
  CreateOrUpdateSchemaOutput: CreateOrUpdateSchemaOutput;
  CreatePerfTestInput: CreatePerfTestInput;
  CreatePullRequestForCatalogDataModelInstallInput: CreatePullRequestForCatalogDataModelInstallInput;
  CreatePullRequestForCatalogGlobalHelperInstallInput: CreatePullRequestForCatalogGlobalHelperInstallInput;
  CreatePullRequestForCatalogInstallInput: CreatePullRequestForCatalogInstallInput;
  CreatePullRequestForCatalogSavedQueryInstallInput: CreatePullRequestForCatalogSavedQueryInstallInput;
  CreatePullRequestForCorrelationRuleEditInput: CreatePullRequestForCorrelationRuleEditInput;
  CreatePullRequestForDataModelDeletionInput: CreatePullRequestForDataModelDeletionInput;
  CreatePullRequestForDataModelEditInput: CreatePullRequestForDataModelEditInput;
  CreatePullRequestForDetectionDeletionInput: CreatePullRequestForDetectionDeletionInput;
  CreatePullRequestForGlobalHelperDeletionInput: CreatePullRequestForGlobalHelperDeletionInput;
  CreatePullRequestForGlobalHelperEditInput: CreatePullRequestForGlobalHelperEditInput;
  CreatePullRequestForNewDataModelInput: CreatePullRequestForNewDataModelInput;
  CreatePullRequestForNewGlobalHelperInput: CreatePullRequestForNewGlobalHelperInput;
  CreatePullRequestForNewPolicyInput: CreatePullRequestForNewPolicyInput;
  CreatePullRequestForNewRuleInput: CreatePullRequestForNewRuleInput;
  CreatePullRequestForNewSavedQueryInput: CreatePullRequestForNewSavedQueryInput;
  CreatePullRequestForPolicyEditInput: CreatePullRequestForPolicyEditInput;
  CreatePullRequestForRuleEditInput: CreatePullRequestForRuleEditInput;
  CreatePullRequestForSavedQueryDeletionInput: CreatePullRequestForSavedQueryDeletionInput;
  CreatePullRequestForSavedQueryEditInput: CreatePullRequestForSavedQueryEditInput;
  CreatePullRequestResponse: CreatePullRequestResponse;
  CreateRSAKeyInput: CreateRSAKeyInput;
  CreateReplayInput: CreateReplayInput;
  CreateReplayOutput: CreateReplayOutput;
  CreateRoleInput: CreateRoleInput;
  CreateRoleOutput: CreateRoleOutput;
  CreateS3SourceInput: CreateS3SourceInput;
  CreateS3SourceOutput: CreateS3SourceOutput;
  CreateScheduledPromptInput: CreateScheduledPromptInput;
  CreateWidgetInput: CreateWidgetInput;
  CredentialFormField: CredentialFormField;
  CrowdstrikeConfig: CrowdstrikeConfig;
  CrowdstrikeEventStreamsConfig: CrowdstrikeEventStreamsConfig;
  CrowdstrikeEventStreamsConfigInput: CrowdstrikeEventStreamsConfigInput;
  CrowdstrikeInput: CrowdstrikeInput;
  CursorBasedPaginationPageInfo: CursorBasedPaginationPageInfo;
  CustomHeader: CustomHeader;
  CustomHeaderInput: CustomHeaderInput;
  CustomWebhookConfig: CustomWebhookConfig;
  CustomWebhookConfigInput: CustomWebhookConfigInput;
  Dashboard: Dashboard;
  DashboardIcon: DashboardIcon;
  DashboardIconInput: DashboardIconInput;
  DashboardInput: DashboardInput;
  DashboardInputInput: DashboardInputInput;
  DashboardMetadata: DashboardMetadata;
  DashboardsInput: DashboardsInput;
  DashboardsOutput: DashboardsOutput;
  DataLakeDatabase: DataLakeDatabase;
  DataLakeDatabaseTable: DataLakeDatabaseTable;
  DataLakeDatabaseTableColumn: DataLakeDatabaseTableColumn;
  DataLakeDatabaseTableInput: DataLakeDatabaseTableInput;
  DataLakeDatabaseTablesEdges: DataLakeDatabaseTablesEdges;
  DataLakeDatabaseTablesInput: DataLakeDatabaseTablesInput;
  DataLakeDatabaseTablesOutput: DataLakeDatabaseTablesOutput;
  DataLakeDatabaseTablesOutputPageInfo: DataLakeDatabaseTablesOutputPageInfo;
  DataLakeListDefinition: DataLakeListDefinition;
  DataLakePropertyDefinition: DataLakePropertyDefinition;
  DataLakePropertyDefinitionsInput: DataLakePropertyDefinitionsInput;
  DataLakePropertyDefinitionsOutput: DataLakePropertyDefinitionsOutput;
  DataLakePropertyDefinitionsOutputEdge: DataLakePropertyDefinitionsOutputEdge;
  DataLakePropertySummary: DataLakePropertySummary;
  DataLakePropertySummaryEntry: DataLakePropertySummaryEntry;
  DataLakeQueriesInput: DataLakeQueriesInput;
  DataLakeQueriesOutput: DataLakeQueriesOutput;
  DataLakeQueriesOutputPageInfo: DataLakeQueriesOutputPageInfo;
  DataLakeQuery: Omit<DataLakeQuery, 'issuedBy'> & {
    issuedBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  DataLakeQueryEdge: DataLakeQueryEdge;
  DataLakeQueryResultEdge: DataLakeQueryResultEdge;
  DataLakeQueryResultRecordsPageInfo: DataLakeQueryResultRecordsPageInfo;
  DataLakeQueryResults: DataLakeQueryResults;
  DataLakeQueryResultsColumnInfo: DataLakeQueryResultsColumnInfo;
  DataLakeQueryResultsInput: DataLakeQueryResultsInput;
  DataLakeQueryStats: DataLakeQueryStats;
  DataLakeQueryVisualization: DataLakeQueryVisualization;
  DataLakeQueryVisualizationResults: DataLakeQueryVisualizationResults;
  DataLakeQueryVisualizationResultsColumn: DataLakeQueryVisualizationResultsColumn;
  DataLakeQueryVisualizationResultsRow: DataLakeQueryVisualizationResultsRow;
  DataModel: Omit<DataModel, 'createdBy' | 'lastModifiedBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
    lastModifiedBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  DataModelMapping: DataModelMapping;
  DataModelMappingInput: DataModelMappingInput;
  DataWindow: DataWindow;
  DataWindowInput: DataWindowInput;
  DatabaseAndTable: DatabaseAndTable;
  DatabaseAndTableInput: DatabaseAndTableInput;
  DatalakeFieldValuesInput: DatalakeFieldValuesInput;
  DatalakeFieldValuesOutput: DatalakeFieldValuesOutput;
  DatalakeSchemaColumnEntity: DatalakeSchemaColumnEntity;
  DatalakeSchemaDatalakeEntity: DatalakeSchemaDatalakeEntity;
  DatalakeSchemaEntity: ResolversUnionTypes<ResolversParentTypes>['DatalakeSchemaEntity'];
  DatalakeSchemaProperty: DatalakeSchemaProperty;
  DatalakeSchemaPropertyEntity: DatalakeSchemaPropertyEntity;
  DatalakeSchemaTableEntity: DatalakeSchemaTableEntity;
  DateRange: DateRange;
  DateTime: Scalars['DateTime']['output'];
  DecideToolInvocationInput: DecideToolInvocationInput;
  DeleteAISkillOutput: DeleteAISkillOutput;
  DeleteAPITokenOutput: DeleteAPITokenOutput;
  DeleteAlertContextTagInput: DeleteAlertContextTagInput;
  DeleteCloudAccountInput: DeleteCloudAccountInput;
  DeleteCloudAccountOutput: DeleteCloudAccountOutput;
  DeleteDataModelInput: DeleteDataModelInput;
  DeleteDetectionsInput: DeleteDetectionsInput;
  DeleteDetectionsOutput: DeleteDetectionsOutput;
  DeleteEntry: DeleteEntry;
  DeleteGitConfigInput: DeleteGitConfigInput;
  DeleteGlobalHelpersInput: DeleteGlobalHelpersInput;
  DeleteLookupsInput: DeleteLookupsInput;
  DeleteRoleInput: DeleteRoleInput;
  DeleteRoleOutput: DeleteRoleOutput;
  DeleteSavedQueriesByNameInput: DeleteSavedQueriesByNameInput;
  DeleteSavedQueriesByNameOutput: DeleteSavedQueriesByNameOutput;
  DeleteSavedQueryInput: DeleteSavedQueryInput;
  DeleteScheduledPromptInput: DeleteScheduledPromptInput;
  DeleteSourceInput: DeleteSourceInput;
  DeleteSourceOutput: DeleteSourceOutput;
  DeleteUserInput: DeleteUserInput;
  DeleteUserOutput: DeleteUserOutput;
  DeletedDetection: DeletedDetection;
  DeliverAlertInput: DeliverAlertInput;
  Destination: Omit<Destination, 'createdBy' | 'lastModifiedBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
    lastModifiedBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  DestinationConfig: DestinationConfig;
  DestinationConfigInput: DestinationConfigInput;
  DestinationInput: DestinationInput;
  Detection: Omit<Detection, 'createdBy' | 'updatedBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
    updatedBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  DetectionAlertMetricsInput: DetectionAlertMetricsInput;
  DetectionAlertMetricsInputDetection: DetectionAlertMetricsInputDetection;
  DetectionAlertMetricsOutput: DetectionAlertMetricsOutput;
  DetectionEntitiesUploadStatusOutput: DetectionEntitiesUploadStatusOutput;
  DetectionFilter: DetectionFilter;
  DetectionFilterCondition: DetectionFilterCondition;
  DetectionFilterConditionInput: DetectionFilterConditionInput;
  DetectionFilterStatement: DetectionFilterStatement;
  DetectionFilterStatementInput: DetectionFilterStatementInput;
  DetectionPatch: DetectionPatch;
  DetectionRefInput: DetectionRefInput;
  DetectionReportEntry: ResolversUnionTypes<ResolversParentTypes>['DetectionReportEntry'];
  DetectionReportMapping: Omit<DetectionReportMapping, 'entries'> & {
    entries?: Maybe<Array<ResolversParentTypes['DetectionReportEntry']>>;
  };
  DetectionReportMappingInput: DetectionReportMappingInput;
  DetectionStatsDetectionTypeCount: DetectionStatsDetectionTypeCount;
  DetectionStatsEnabledStateCount: DetectionStatsEnabledStateCount;
  DetectionStatsResponse: DetectionStatsResponse;
  DetectionStatsSeverityCount: DetectionStatsSeverityCount;
  DetectionTestDefinition: DetectionTestDefinition;
  DetectionTestDefinitionInput: DetectionTestDefinitionInput;
  DetectionTestDefinitionMockInput: DetectionTestDefinitionMockInput;
  DetectionTestDefinitionProtected: DetectionTestDefinitionProtected;
  DetectionTestFilterDefinition: DetectionTestFilterDefinition;
  DetectionTestMockDefinition: DetectionTestMockDefinition;
  DetectionTestMockDefinitionProtected: DetectionTestMockDefinitionProtected;
  DetectionUpdateError: DetectionUpdateError;
  DiscordConfig: DiscordConfig;
  DiscordConfigInput: DiscordConfigInput;
  DiscoverMcpServerInput: DiscoverMcpServerInput;
  DiscoverTaxiiCollectionsInput: DiscoverTaxiiCollectionsInput;
  DiscoverTaxiiCollectionsOutput: DiscoverTaxiiCollectionsOutput;
  DiscoveredTaxiiCollection: DiscoveredTaxiiCollection;
  DraftSchema: DraftSchema;
  DuoConfig: DuoConfig;
  DuoConfigInput: DuoConfigInput;
  EditAIInferenceStreamInput: EditAIInferenceStreamInput;
  Email: Scalars['Email']['output'];
  EmailConfig: EmailConfig;
  EmailConfigInput: EmailConfigInput;
  EnrichmentIntegration: EnrichmentIntegration;
  EnrichmentIntegrationConfig: EnrichmentIntegrationConfig;
  EnrichmentIntegrationConfigInput: EnrichmentIntegrationConfigInput;
  EnrichmentIntegrationHealth: EnrichmentIntegrationHealth;
  Error: Error;
  EventBridgeConfig: EventBridgeConfig;
  EventBridgeIntegration: Omit<EventBridgeIntegration, 'createdBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  EventBridgeIntegrationHealth: EventBridgeIntegrationHealth;
  EventFilter: EventFilter;
  EventFilterInput: EventFilterInput;
  EventThresholdAlarm: EventThresholdAlarm;
  EventThresholdAlarmInput: EventThresholdAlarmInput;
  EventbridgeOptions: EventbridgeOptions;
  ExecuteDataLakeQueryInput: ExecuteDataLakeQueryInput;
  ExecuteDataLakeQueryOutput: ExecuteDataLakeQueryOutput;
  ExecuteIndicatorSearchQueryInput: ExecuteIndicatorSearchQueryInput;
  ExecuteIndicatorSearchQueryOutput: ExecuteIndicatorSearchQueryOutput;
  ExecuteSimpleSearchQueryInput: ExecuteSimpleSearchQueryInput;
  ExecuteSimpleSearchQueryOutput: ExecuteSimpleSearchQueryOutput;
  ExecuteUberSearchInput: ExecuteUberSearchInput;
  ExecuteUberSearchOutput: ExecuteUberSearchOutput;
  ExecuteUberSearchPropertySummaryInput: ExecuteUberSearchPropertySummaryInput;
  ExecuteUberSearchPropertySummaryOutput: ExecuteUberSearchPropertySummaryOutput;
  ExpelWebhookConfig: ExpelWebhookConfig;
  ExpelWebhookConfigInput: ExpelWebhookConfigInput;
  FeatureFlagTreatment: FeatureFlagTreatment;
  FeatureFlagWithDefault: FeatureFlagWithDefault;
  FilterField: FilterField;
  FilterFieldsInput: FilterFieldsInput;
  FilterFieldsOutput: FilterFieldsOutput;
  FilterInput: FilterInput;
  FlatFilterFieldsInput: FlatFilterFieldsInput;
  FlatFilterFieldsOutput: FlatFilterFieldsOutput;
  Float: Scalars['Float']['output'];
  GcpPubSubConfig: GcpPubSubConfig;
  GcpPubSubDestinationConfig: GcpPubSubDestinationConfig;
  GcpPubSubDestinationConfigInput: GcpPubSubDestinationConfigInput;
  GcpPubSubLogConfigInput: GcpPubSubLogConfigInput;
  GcpPubSubLogIntegrationHealth: GcpPubSubLogIntegrationHealth;
  GcpPubSubLogSourceIntegration: Omit<GcpPubSubLogSourceIntegration, 'createdBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  GcsConfig: GcsConfig;
  GcsLogConfigInput: GcsLogConfigInput;
  GcsLogIntegrationHealth: GcsLogIntegrationHealth;
  GcsLogSourceIntegration: Omit<GcsLogSourceIntegration, 'createdBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  GeneralSettingsConfig: GeneralSettingsConfig;
  GenerateAlertSummaryAttributesQueriesInput: GenerateAlertSummaryAttributesQueriesInput;
  GenerateEnrichedEventInput: GenerateEnrichedEventInput;
  GenerateEnrichedEventResponse: GenerateEnrichedEventResponse;
  GenerateLogForwarderConfigInput: GenerateLogForwarderConfigInput;
  GenerateS3SampleUploadInput: GenerateS3SampleUploadInput;
  GenerateS3SampleUploadResponse: GenerateS3SampleUploadResponse;
  GenerateSchemaFromSqlInput: GenerateSchemaFromSqlInput;
  GenerateSchemaFromSqlJob: GenerateSchemaFromSqlJob;
  GenerateSimpleSearchQueryInput: GenerateSimpleSearchQueryInput;
  GenerateSimpleSearchQueryOutput: GenerateSimpleSearchQueryOutput;
  GenerateSqlQuerySnippetInput: GenerateSqlQuerySnippetInput;
  GenerateSqlQuerySnippetOutput: GenerateSqlQuerySnippetOutput;
  GenerateUberSearchQueryInput: GenerateUberSearchQueryInput;
  GenerateUberSearchQueryOutput: GenerateUberSearchQueryOutput;
  GenericGitConfig: GenericGitConfig;
  GenericPullerAuthentication: GenericPullerAuthentication;
  GenericPullerAuthenticationInput: GenericPullerAuthenticationInput;
  GenericPullerConfig: GenericPullerConfig;
  GenericPullerConfigInput: GenericPullerConfigInput;
  GenericPullerExpectedParam: GenericPullerExpectedParam;
  GenericPullerExpectedParamInput: GenericPullerExpectedParamInput;
  GenericPullerGeneralSettings: GenericPullerGeneralSettings;
  GenericPullerGeneralSettingsInput: GenericPullerGeneralSettingsInput;
  GenericPullerPagination: GenericPullerPagination;
  GenericPullerPaginationInput: GenericPullerPaginationInput;
  GenericPullerPaginationSettings: GenericPullerPaginationSettings;
  GenericPullerPaginationSettingsInput: GenericPullerPaginationSettingsInput;
  GenericPullerResponseParsing: GenericPullerResponseParsing;
  GenericPullerResponseParsingInput: GenericPullerResponseParsingInput;
  GenericPullerStrategyConfig: GenericPullerStrategyConfig;
  GenericPullerStrategyConfigInput: GenericPullerStrategyConfigInput;
  GenericPullerTimeUnit: GenericPullerTimeUnit;
  GenericPullerTimeUnitInput: GenericPullerTimeUnitInput;
  GetAPITokenOutput: GetAPITokenOutput;
  GetAlertEventsInput: GetAlertEventsInput;
  GetAsyncQueryDownloadUrlInput: GetAsyncQueryDownloadUrlInput;
  GetAsyncQueryDownloadUrlOutput: GetAsyncQueryDownloadUrlOutput;
  GetAvailableLogProviderResponse: GetAvailableLogProviderResponse;
  GetCloudWatchLogIntegrationTemplateInput: GetCloudWatchLogIntegrationTemplateInput;
  GetComplianceIntegrationTemplateInput: GetComplianceIntegrationTemplateInput;
  GetCorrelationRuleInput: GetCorrelationRuleInput;
  GetDetectionInput: GetDetectionInput;
  GetDetectionResponse: Omit<GetDetectionResponse, 'detection'> & {
    detection: ResolversParentTypes['InternalDetection'];
  };
  GetFeatureFlagsInput: GetFeatureFlagsInput;
  GetFeatureFlagsResponse: GetFeatureFlagsResponse;
  GetGlobalHelperInput: GetGlobalHelperInput;
  GetLookupCloudFormationRoleTemplateInput: GetLookupCloudFormationRoleTemplateInput;
  GetPolicyInput: GetPolicyInput;
  GetPresignedUploadURLInput: GetPresignedUploadURLInput;
  GetRelatedAlertsInput: GetRelatedAlertsInput;
  GetResourceInput: GetResourceInput;
  GetRuleInput: GetRuleInput;
  GetRuleV2Input: GetRuleV2Input;
  GetS3LogIntegrationTemplateInput: GetS3LogIntegrationTemplateInput;
  GetSampleDataInput: GetSampleDataInput;
  GetSampleDataResponse: GetSampleDataResponse;
  GetSchemaInput: GetSchemaInput;
  GetSchemaOutput: GetSchemaOutput;
  GetTerraformTemplateInput: GetTerraformTemplateInput;
  GitHubAppConfig: GitHubAppConfig;
  GithubConfig: GithubConfig;
  GithubConfigInput: GithubConfigInput;
  GithubLogSourceConfig: Omit<GithubLogSourceConfig, 'credentials'> & {
    credentials: ResolversParentTypes['GithubLogSourceCredentialsConfig'];
  };
  GithubLogSourceCredentialsConfig: ResolversUnionTypes<ResolversParentTypes>['GithubLogSourceCredentialsConfig'];
  GithubLogSourceInput: GithubLogSourceInput;
  GithubLogSourceOAuth2Config: GithubLogSourceOAuth2Config;
  GithubLogSourcePatConfig: GithubLogSourcePatConfig;
  GithubOAuth2ConfigInput: GithubOAuth2ConfigInput;
  GithubPatConfigInput: GithubPatConfigInput;
  GlobalHelper: GlobalHelper;
  GrantMcpServerAccessInput: GrantMcpServerAccessInput;
  GreyNoiseConfig: GreyNoiseConfig;
  GreyNoiseConfigInput: GreyNoiseConfigInput;
  GreyNoiseProfilePullerConfig: GreyNoiseProfilePullerConfig;
  GreyNoiseProfilePullerConfigInput: GreyNoiseProfilePullerConfigInput;
  GroupedFilterField: GroupedFilterField;
  GsuiteConfig: Omit<GsuiteConfig, 'credentials'> & {
    credentials: ResolversParentTypes['GsuiteCredentialsConfig'];
  };
  GsuiteConfigInput: GsuiteConfigInput;
  GsuiteCredentialsConfig: ResolversUnionTypes<ResolversParentTypes>['GsuiteCredentialsConfig'];
  GsuiteOAuth2Config: GsuiteOAuth2Config;
  GsuiteOAuth2ConfigInput: GsuiteOAuth2ConfigInput;
  GsuiteProfilePullerConfig: GsuiteProfilePullerConfig;
  GsuiteProfilePullerConfigInput: GsuiteProfilePullerConfigInput;
  GsuiteServiceAccountConfig: GsuiteServiceAccountConfig;
  GsuiteServiceAccountConfigInput: GsuiteServiceAccountConfigInput;
  GsuiteWorkloadIdentityFederationConfig: GsuiteWorkloadIdentityFederationConfig;
  GsuiteWorkloadIdentityFederationConfigInput: GsuiteWorkloadIdentityFederationConfigInput;
  GtiIoCStreamConfig: GtiIoCStreamConfig;
  GtiIoCStreamConfigInput: GtiIoCStreamConfigInput;
  GtiIoCStreamProfilePullerConfig: GtiIoCStreamProfilePullerConfig;
  GtiIoCStreamProfilePullerConfigInput: GtiIoCStreamProfilePullerConfigInput;
  HoldingTankFilters: HoldingTankFilters;
  HoldingTankFiltersInput: HoldingTankFiltersInput;
  HoldingTankGetRunningTaskInput: HoldingTankGetRunningTaskInput;
  HoldingTankInferJob: HoldingTankInferJob;
  HoldingTankInferJobParams: HoldingTankInferJobParams;
  HoldingTankInferSchemaInput: HoldingTankInferSchemaInput;
  HoldingTankJobStats: HoldingTankJobStats;
  HoldingTankListTasksResponse: HoldingTankListTasksResponse;
  HoldingTankLogTypeTestStats: HoldingTankLogTypeTestStats;
  HoldingTankRawDataInput: HoldingTankRawDataInput;
  HoldingTankRawDataResponse: HoldingTankRawDataResponse;
  HoldingTankRawEvent: HoldingTankRawEvent;
  HoldingTankResults: HoldingTankResults;
  HoldingTankSchemaInferenceResult: HoldingTankSchemaInferenceResult;
  HoldingTankTestJob: Omit<HoldingTankTestJob, 'createdBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  HoldingTankTestJobParams: HoldingTankTestJobParams;
  HoldingTankTestJobPrefixStats: HoldingTankTestJobPrefixStats;
  HoldingTankTestSchemasResultInput: HoldingTankTestSchemasResultInput;
  HoldingTankTestSchemasResultsResponse: HoldingTankTestSchemasResultsResponse;
  HttpConfig: HttpConfig;
  HttpLogConfigInput: HttpLogConfigInput;
  HttpLogIntegrationHealth: HttpLogIntegrationHealth;
  HttpLogSourceIntegration: Omit<HttpLogSourceIntegration, 'createdBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  HttpOptions: HttpOptions;
  ID: Scalars['ID']['output'];
  ImportLookupDataInput: ImportLookupDataInput;
  IncidentIoWebhookConfig: IncidentIoWebhookConfig;
  IncidentIoWebhookConfigInput: IncidentIoWebhookConfigInput;
  InferSchemaFromBucketDataFiltersInput: InferSchemaFromBucketDataFiltersInput;
  InferSchemaFromBucketDataInput: InferSchemaFromBucketDataInput;
  InferSchemaFromSourceBucketInput: InferSchemaFromSourceBucketInput;
  InferSchemaInput: InferSchemaInput;
  InferSchemaResponse: InferSchemaResponse;
  InfraCategoryCosts: InfraCategoryCosts;
  InfraCostInput: InfraCostInput;
  InfraCostOutput: InfraCostOutput;
  InfraDailyCost: InfraDailyCost;
  InfrastructureInfo: InfrastructureInfo;
  IngestionMonitoringSummary: IngestionMonitoringSummary;
  InitiateMcpAuthorizationInput: InitiateMcpAuthorizationInput;
  InstallCatalogDataModelOutput: InstallCatalogDataModelOutput;
  InstallCatalogDetectionOutput: InstallCatalogDetectionOutput;
  InstallCatalogEnrichmentOutput: InstallCatalogEnrichmentOutput;
  InstallCatalogGlobalHelperOutput: InstallCatalogGlobalHelperOutput;
  InstallCatalogQueryOutput: InstallCatalogQueryOutput;
  InstalledCatalogItem: InstalledCatalogItem;
  InstalledCatalogItemUpdateStatus: InstalledCatalogItemUpdateStatus;
  Int: Scalars['Int']['output'];
  IntegrationItemHealthStatus: IntegrationItemHealthStatus;
  IntegrationTemplate: IntegrationTemplate;
  InternalDetection: ResolversUnionTypes<ResolversParentTypes>['InternalDetection'];
  InviteUserInput: InviteUserInput;
  InviteUserOutput: InviteUserOutput;
  JSON: Scalars['JSON']['output'];
  JiraAssignableUser: JiraAssignableUser;
  JiraConfig: JiraConfig;
  JiraConfigInput: JiraConfigInput;
  JiraOrgMetadata: JiraOrgMetadata;
  JiraOrgMetadataInput: JiraOrgMetadataInput;
  JiraPriority: JiraPriority;
  JiraStatusMap: JiraStatusMap;
  JiraStatusMapInput: JiraStatusMapInput;
  JiraStatusTransitionInput: JiraStatusTransitionInput;
  JiraTransitionStatus: JiraTransitionStatus;
  Job: ResolversInterfaceTypes<ResolversParentTypes>['Job'];
  ListAPITokensOutput: ListAPITokensOutput;
  ListAlertContextTagsOutput: ListAlertContextTagsOutput;
  ListAlertContextTagsPageInfo: ListAlertContextTagsPageInfo;
  ListAnalysisItemsForWorkbenchInput: ListAnalysisItemsForWorkbenchInput;
  ListAnalysisItemsForWorkbenchOutput: ListAnalysisItemsForWorkbenchOutput;
  ListAnalysisPackSourcesInput: ListAnalysisPackSourcesInput;
  ListAnalysisPackSourcesResponse: ListAnalysisPackSourcesResponse;
  ListAnalysisPacksInput: ListAnalysisPacksInput;
  ListAnalysisPacksResponse: ListAnalysisPacksResponse;
  ListAvailableLogProvidersResponse: ListAvailableLogProvidersResponse;
  ListAvailableLogTypesResponse: ListAvailableLogTypesResponse;
  ListBucketKeysInput: ListBucketKeysInput;
  ListBucketKeysResponse: ListBucketKeysResponse;
  ListCatalogDataModelsInput: ListCatalogDataModelsInput;
  ListCatalogDataModelsOutput: ListCatalogDataModelsOutput;
  ListCatalogDetectionsInput: ListCatalogDetectionsInput;
  ListCatalogDetectionsOutput: ListCatalogDetectionsOutput;
  ListCatalogEnrichmentsInput: ListCatalogEnrichmentsInput;
  ListCatalogEnrichmentsOutput: ListCatalogEnrichmentsOutput;
  ListCatalogGlobalHelpersInput: ListCatalogGlobalHelpersInput;
  ListCatalogGlobalHelpersOutput: ListCatalogGlobalHelpersOutput;
  ListCatalogQueriesInput: ListCatalogQueriesInput;
  ListCatalogQueriesOutput: ListCatalogQueriesOutput;
  ListComplianceItemsResponse: ListComplianceItemsResponse;
  ListDataModelsInput: ListDataModelsInput;
  ListDataModelsResponse: ListDataModelsResponse;
  ListDetectionsInput: ListDetectionsInput;
  ListDetectionsResponse: Omit<ListDetectionsResponse, 'detections'> & {
    detections: Array<ResolversParentTypes['InternalDetection']>;
  };
  ListGitConfigsInput: ListGitConfigsInput;
  ListGitConfigsResponse: ListGitConfigsResponse;
  ListGlobalHelpersInput: ListGlobalHelpersInput;
  ListGlobalHelpersResponse: ListGlobalHelpersResponse;
  ListInstalledCatalogItemUpdateStatusesInput: ListInstalledCatalogItemUpdateStatusesInput;
  ListInstalledCatalogItemUpdateStatusesOutput: ListInstalledCatalogItemUpdateStatusesOutput;
  ListInstalledCatalogItemsInput: ListInstalledCatalogItemsInput;
  ListInstalledCatalogItemsOutput: ListInstalledCatalogItemsOutput;
  ListLookupResponse: ListLookupResponse;
  ListLookupsInput: ListLookupsInput;
  ListMcpServersInput: ListMcpServersInput;
  ListResourcesInput: ListResourcesInput;
  ListResourcesResponse: ListResourcesResponse;
  ListSavedQueriesInput: ListSavedQueriesInput;
  ListSavedQueriesResponse: ListSavedQueriesResponse;
  ListScheduledPromptsInput: ListScheduledPromptsInput;
  ListScheduledPromptsResponse: ListScheduledPromptsResponse;
  ListScheduledPromptsResponseEdge: ListScheduledPromptsResponseEdge;
  LoadAnalysisItemForWorkbenchInput: LoadAnalysisItemForWorkbenchInput;
  LoadAnalysisItemForWorkbenchOutput: LoadAnalysisItemForWorkbenchOutput;
  LogForwarderConfigYaml: LogForwarderConfigYaml;
  LogForwarderGeneratorInput: LogForwarderGeneratorInput;
  LogForwarderInputConfigInput: LogForwarderInputConfigInput;
  LogForwarderLogConfigInput: LogForwarderLogConfigInput;
  LogForwarderLogIntegrationHealth: LogForwarderLogIntegrationHealth;
  LogForwarderLogSourceIntegration: Omit<LogForwarderLogSourceIntegration, 'createdBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  LogIntegration: ResolversInterfaceTypes<ResolversParentTypes>['LogIntegration'];
  LogIntegrationAlarms: LogIntegrationAlarms;
  LogPullingIntegration: Omit<LogPullingIntegration, 'createdBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  LogPullingIntegrationHealth: LogPullingIntegrationHealth;
  LogPullingOptions: LogPullingOptions;
  LogSourceBreakdown: LogSourceBreakdown;
  LogStreamTypeOptions: LogStreamTypeOptions;
  LogStreamTypeOptionsInput: LogStreamTypeOptionsInput;
  LogTypeAlertsBySeverity: LogTypeAlertsBySeverity;
  LogTypeMapInput: LogTypeMapInput;
  Long: Scalars['Long']['output'];
  Lookup: Omit<Lookup, 'integration'> & {
    integration?: Maybe<ResolversParentTypes['LookupIntegration']>;
  };
  LookupEnrichHit: LookupEnrichHit;
  LookupEnrichOutput: LookupEnrichOutput;
  LookupImportDataJob: LookupImportDataJob;
  LookupImportDataJobStats: LookupImportDataJobStats;
  LookupIntegration: ResolversUnionTypes<ResolversParentTypes>['LookupIntegration'];
  LookupRefreshConfig: LookupRefreshConfig;
  LookupRefreshConfigInput: LookupRefreshConfigInput;
  LookupS3ImportConfig: LookupS3ImportConfig;
  LookupS3ImportConfigInput: LookupS3ImportConfigInput;
  LookupScheduledQueryConfig: LookupScheduledQueryConfig;
  LookupScheduledQueryConfigInput: LookupScheduledQueryConfigInput;
  LookupSchemaInput: LookupSchemaInput;
  LookupStats: LookupStats;
  LookupSyncJob: LookupSyncJob;
  LookupSyncJobStats: LookupSyncJobStats;
  LookupVersion: LookupVersion;
  M365Config: M365Config;
  M365ConfigInput: M365ConfigInput;
  MarkAllNotificationsAsReadInput: MarkAllNotificationsAsReadInput;
  MarkAllNotificationsAsReadOutput: MarkAllNotificationsAsReadOutput;
  MarkNotificationAsReadInput: MarkNotificationAsReadInput;
  MatchedLog: MatchedLog;
  McpAuthorizationResponse: McpAuthorizationResponse;
  McpConnectionTestResult: McpConnectionTestResult;
  McpServer: Omit<McpServer, 'createdBy' | 'lastModifiedBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
    lastModifiedBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  McpServerDiscovery: McpServerDiscovery;
  McpServersOutput: McpServersOutput;
  McpServersOutputEdge: McpServersOutputEdge;
  McpTool: McpTool;
  McpToolSettingInput: McpToolSettingInput;
  McpUserConnection: McpUserConnection;
  MetricsInput: MetricsInput;
  MetricsOutput: MetricsOutput;
  MicrosoftGraphConfig: MicrosoftGraphConfig;
  MicrosoftGraphConfigInput: MicrosoftGraphConfigInput;
  MindflowWebhookConfig: MindflowWebhookConfig;
  MindflowWebhookConfigInput: MindflowWebhookConfigInput;
  MitreCombo: MitreCombo;
  MitreMatrix: MitreMatrix;
  MitreMatrixContent: MitreMatrixContent;
  MitreMatrixTacticMapping: MitreMatrixTacticMapping;
  MitreMatrixTree: MitreMatrixTree;
  MitreMatrixTreeNode: MitreMatrixTreeNode;
  MitreReportEntry: MitreReportEntry;
  MitreTactic: MitreTactic;
  MitreTechnique: MitreTechnique;
  ModifyGlobalHelperInput: ModifyGlobalHelperInput;
  MongoDBConfig: MongoDBConfig;
  MongoDBConfigInput: MongoDBConfigInput;
  MsTeamsConfig: MsTeamsConfig;
  MsTeamsConfigInput: MsTeamsConfigInput;
  Mutation: {};
  NamedMitreAttack: NamedMitreAttack;
  NetskopeConfig: NetskopeConfig;
  NetskopeConfigInput: NetskopeConfigInput;
  NetworkingInfo: NetworkingInfo;
  Notification: Notification;
  NotificationChannel: NotificationChannel;
  NotificationChannelInput: NotificationChannelInput;
  NotificationMetadata: NotificationMetadata;
  NotificationPreference: NotificationPreference;
  NotificationPreferenceInput: NotificationPreferenceInput;
  NotificationPreferencesOutput: NotificationPreferencesOutput;
  NotificationsInput: NotificationsInput;
  NotificationsOutput: NotificationsOutput;
  NotificationsOutputEdge: NotificationsOutputEdge;
  NotificationsPageInfo: NotificationsPageInfo;
  OAuth2Info: OAuth2Info;
  OAuthConfig: OAuthConfig;
  OAuthConfigInput: OAuthConfigInput;
  OTLPConfig: OTLPConfig;
  OTLPLogConfigInput: OTLPLogConfigInput;
  OTLPLogIntegrationHealth: OTLPLogIntegrationHealth;
  OTLPLogSourceIntegration: Omit<OTLPLogSourceIntegration, 'createdBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  OTLPOptions: OTLPOptions;
  OTXConfig: OTXConfig;
  OTXConfigInput: OTXConfigInput;
  OTXProfilePullerConfig: OTXProfilePullerConfig;
  OTXProfilePullerConfigInput: OTXProfilePullerConfigInput;
  OktaConfig: OktaConfig;
  OktaConfigInput: OktaConfigInput;
  OktaProfilePullerConfig: OktaProfilePullerConfig;
  OktaProfilePullerConfigInput: OktaProfilePullerConfigInput;
  OnePasswordConfig: OnePasswordConfig;
  OnePasswordConfigInput: OnePasswordConfigInput;
  OpenAIConfig: OpenAIConfig;
  OpenAIConfigInput: OpenAIConfigInput;
  OpsgenieConfig: OpsgenieConfig;
  OpsgenieConfigInput: OpsgenieConfigInput;
  OrganizationReportBySeverity: OrganizationReportBySeverity;
  OrganizationStatsInput: OrganizationStatsInput;
  OrganizationStatsResponse: OrganizationStatsResponse;
  PackMigrationFailure: PackMigrationFailure;
  PackMigrationResult: PackMigrationResult;
  PackMigrationStatus: PackMigrationStatus;
  PageInfo: PageInfo;
  PagerDutyConfig: PagerDutyConfig;
  PagerDutyConfigInput: PagerDutyConfigInput;
  PagingData: PagingData;
  PantherAIAutoResolveConfig: PantherAIAutoResolveConfig;
  PantherAIAutoResolveConfigInput: PantherAIAutoResolveConfigInput;
  PantherAIAutoRunOnAlertConfig: Omit<PantherAIAutoRunOnAlertConfig, 'runAsUser'> & {
    runAsUser?: Maybe<ResolversParentTypes['Actor']>;
  };
  PantherAIAutoRunOnAlertConfigInput: PantherAIAutoRunOnAlertConfigInput;
  PantherAIKendraConfig: PantherAIKendraConfig;
  PantherAIKendraConfigInput: PantherAIKendraConfigInput;
  PantherAIRemoteMCPConfig: PantherAIRemoteMCPConfig;
  PantherAIRemoteMCPConfigInput: PantherAIRemoteMCPConfigInput;
  PantherAIWebToolConfig: PantherAIWebToolConfig;
  PantherAIWebToolConfigInput: PantherAIWebToolConfigInput;
  PantherFlowQueryWithParametersInput: PantherFlowQueryWithParametersInput;
  PantherFlowQueryWithParametersOutput: PantherFlowQueryWithParametersOutput;
  Parameter: Parameter;
  ParseRunbookInput: ParseRunbookInput;
  ParseRunbookOutput: ParseRunbookOutput;
  PatchAlertsByIdInput: PatchAlertsByIdInput;
  PatchAlertsByIdOutput: PatchAlertsByIdOutput;
  PoliciesForResourceInput: PoliciesForResourceInput;
  Policy: Omit<Policy, 'createdBy' | 'lastModifiedBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
    lastModifiedBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  ProfilePullerConfig: ProfilePullerConfig;
  ProfilePullerConfigInput: ProfilePullerConfigInput;
  PullRequestOptions: PullRequestOptions;
  PullerConfig: PullerConfig;
  PutAlertContextTagInput: PutAlertContextTagInput;
  PutAmazonSecurityLakeLogIntegrationInput: PutAmazonSecurityLakeLogIntegrationInput;
  PutAzureEventHubLogIntegrationInput: PutAzureEventHubLogIntegrationInput;
  PutCorrelationRuleInput: PutCorrelationRuleInput;
  PutEventBridgeIntegrationInput: PutEventBridgeIntegrationInput;
  PutGcpPubSubLogIntegrationInput: PutGcpPubSubLogIntegrationInput;
  PutGcsLogIntegrationInput: PutGcsLogIntegrationInput;
  PutHttpLogIntegrationInput: PutHttpLogIntegrationInput;
  PutLogForwarderLogIntegrationInput: PutLogForwarderLogIntegrationInput;
  PutLogPullingIntegrationInput: PutLogPullingIntegrationInput;
  PutNotificationPreferencesInput: PutNotificationPreferencesInput;
  PutOTLPLogIntegrationInput: PutOTLPLogIntegrationInput;
  PutSqsLogIntegrationInput: PutSqsLogIntegrationInput;
  PutUserPreferencesInput: PutUserPreferencesInput;
  Query: {};
  QueryChartPropertyConfig: QueryChartPropertyConfig;
  QueryChartPropertyConfigInput: QueryChartPropertyConfigInput;
  QueryTablePropertyConfig: QueryTablePropertyConfig;
  QueryTablePropertyConfigInput: QueryTablePropertyConfigInput;
  QueryUserConfig: QueryUserConfig;
  RSAKey: RSAKey;
  Rapid7Config: Rapid7Config;
  Rapid7ConfigInput: Rapid7ConfigInput;
  Rapid7InsightConnectConfig: Rapid7InsightConnectConfig;
  Rapid7InsightConnectConfigInput: Rapid7InsightConnectConfigInput;
  RawFilter: RawFilter;
  RawFiltersInput: RawFiltersInput;
  ReclassifySourceAlarmJob: Omit<ReclassifySourceAlarmJob, 'createdBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  RelatedAlertsOutput: RelatedAlertsOutput;
  RelatedAlertsOutputEdge: RelatedAlertsOutputEdge;
  RelatedAlertsOutputPageInfo: RelatedAlertsOutputPageInfo;
  RelativeTimeDuration: Scalars['RelativeTimeDuration']['output'];
  RenameAlertContextTagInput: RenameAlertContextTagInput;
  Replay: Replay;
  ReplayPreview: ReplayPreview;
  ReplayScope: ReplayScope;
  ReplaySummary: ReplaySummary;
  ReplayedAlertsInput: ReplayedAlertsInput;
  ReplayedAlertsOutput: ReplayedAlertsOutput;
  ReportSetting: Omit<ReportSetting, 'detections' | 'updatedBy'> & {
    detections: Array<ResolversParentTypes['InternalDetection']>;
    updatedBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  ReportSettingAssociation: ReportSettingAssociation;
  ReportSettingAssociationMitre: ReportSettingAssociationMitre;
  RequestSourceInput: RequestSourceInput;
  RequestSourceOutput: RequestSourceOutput;
  ResetUserPasswordInput: ResetUserPasswordInput;
  ResetUserPasswordOutput: ResetUserPasswordOutput;
  ResolveAlarmAndReclassifyInput: ResolveAlarmAndReclassifyInput;
  ResolveSourceAlarmInput: ResolveSourceAlarmInput;
  ResourceDetails: ResourceDetails;
  ResourceSummary: ResourceSummary;
  ResourcesForPolicyInput: ResourcesForPolicyInput;
  RevokeMcpServerAccessInput: RevokeMcpServerAccessInput;
  RiskIndicator: RiskIndicator;
  RiskScoreEvidence: RiskScoreEvidence;
  Role: Omit<Role, 'updatedBy'> & { updatedBy?: Maybe<ResolversParentTypes['Actor']> };
  RolesInput: RolesInput;
  RotateAPITokenInput: RotateAPITokenInput;
  RotateAPITokenOutput: RotateAPITokenOutput;
  Rule: Omit<Rule, 'createdBy' | 'lastModifiedBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
    lastModifiedBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  RulePythonBodyOutput: RulePythonBodyOutput;
  RunScheduledPromptNowInput: RunScheduledPromptNowInput;
  RunScheduledPromptNowOutput: RunScheduledPromptNowOutput;
  Runbook: Runbook;
  RunbookExecutionPhase: RunbookExecutionPhase;
  RunbookExecutionState: RunbookExecutionState;
  RunbookExecutionStep: RunbookExecutionStep;
  RunbookPhase: RunbookPhase;
  RunbookPhaseInput: RunbookPhaseInput;
  RunbookStep: RunbookStep;
  RunbookStepInput: RunbookStepInput;
  S3LogIntegration: Omit<S3LogIntegration, 'createdBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  S3LogIntegrationHealth: S3LogIntegrationHealth;
  S3Object: S3Object;
  S3PrefixLogTypes: S3PrefixLogTypes;
  S3PrefixLogTypesInput: S3PrefixLogTypesInput;
  SalesforceConfig: SalesforceConfig;
  SalesforceConfigDomainConfig: SalesforceConfigDomainConfig;
  SalesforceConfigDomainConfigInput: SalesforceConfigDomainConfigInput;
  SalesforceConfigInput: SalesforceConfigInput;
  SamlConfig: SamlConfig;
  SaveLookupJob: SaveLookupJob;
  SaveResolvedWorkbenchAnalysisItemsInput: SaveResolvedWorkbenchAnalysisItemsInput;
  SaveResolvedWorkbenchAnalysisItemsOutput: SaveResolvedWorkbenchAnalysisItemsOutput;
  SavedQuery: Omit<SavedQuery, 'createdBy' | 'lastModifiedBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
    lastModifiedBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  SavedQueryDeleteEntry: SavedQueryDeleteEntry;
  ScannedResourceStats: ScannedResourceStats;
  ScannedResources: ScannedResources;
  Schedule: Schedule;
  ScheduleInput: ScheduleInput;
  ScheduledPrompt: Omit<ScheduledPrompt, 'createdBy' | 'deletedBy' | 'runAsUser' | 'updatedBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
    deletedBy?: Maybe<ResolversParentTypes['Actor']>;
    runAsUser?: Maybe<ResolversParentTypes['Actor']>;
    updatedBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  Schema: Schema;
  SchemaField: SchemaField;
  SchemaFieldValueValidation: SchemaFieldValueValidation;
  SchemasInput: SchemasInput;
  SchemasOutput: SchemasOutput;
  SchemasOutputEdge: SchemasOutputEdge;
  SchemasOutputPageInfo: SchemasOutputPageInfo;
  SendJiraEventInput: SendJiraEventInput;
  SendJiraEventOutput: SendJiraEventOutput;
  SendTestAlertInput: SendTestAlertInput;
  SendUserFeedbackInput: SendUserFeedbackInput;
  SendUserFeedbackOutput: SendUserFeedbackOutput;
  SentinelOneApiConfig: SentinelOneApiConfig;
  SentinelOneApiConfigInput: SentinelOneApiConfigInput;
  SentinelOneCloudFunnelConfig: SentinelOneCloudFunnelConfig;
  SentinelOneCloudFunnelConfigInput: SentinelOneCloudFunnelConfigInput;
  SerializeRunbookInput: SerializeRunbookInput;
  SerializeRunbookOutput: SerializeRunbookOutput;
  Series: Series;
  SeriesData: SeriesData;
  SeriesMetric: SeriesMetric;
  SeriesWithBreakdown: SeriesWithBreakdown;
  SeriesWithEntityID: SeriesWithEntityID;
  SeverityBasedJiraConfig: SeverityBasedJiraConfig;
  SeverityBasedJiraConfigInput: SeverityBasedJiraConfigInput;
  SignOutSessionsOutput: SignOutSessionsOutput;
  SizeWindow: SizeWindow;
  SizeWindowInput: SizeWindowInput;
  SlackBotConfig: SlackBotConfig;
  SlackBotConfigInput: SlackBotConfigInput;
  SlackConfig: SlackConfig;
  SlackConfigInput: SlackConfigInput;
  SlackbotBoomerangHistory: Omit<SlackbotBoomerangHistory, 'createdBy'> & {
    createdBy: ResolversParentTypes['Actor'];
  };
  SnippetHighlight: SnippetHighlight;
  SnippetWithHighlights: SnippetWithHighlights;
  SnowflakeAuditConfig: SnowflakeAuditConfig;
  SnowflakeAuditConfigInput: SnowflakeAuditConfigInput;
  SnowflakeProfilePullerConfig: SnowflakeProfilePullerConfig;
  SnowflakeProfilePullerConfigInput: SnowflakeProfilePullerConfigInput;
  SnsConfig: SnsConfig;
  SnsConfigInput: SnsConfigInput;
  SnykConfigInput: SnykConfigInput;
  SnykLogSourceConfig: SnykLogSourceConfig;
  SourceFilters: SourceFilters;
  SourceFiltersInput: SourceFiltersInput;
  SourceMetric: SourceMetric;
  SourceMetricsInput: SourceMetricsInput;
  SourceMetricsResponse: SourceMetricsResponse;
  SourceStatisticsInput: SourceStatisticsInput;
  SourceStatisticsResponse: SourceStatisticsResponse;
  SourceStats: SourceStats;
  SourcesInput: SourcesInput;
  SourcesOutput: SourcesOutput;
  SourcesOutputEdge: SourcesOutputEdge;
  SplunkWebhookConfig: SplunkWebhookConfig;
  SplunkWebhookConfigInput: SplunkWebhookConfigInput;
  SqsConfig: SqsConfig;
  SqsConfigInput: SqsConfigInput;
  SqsDestinationConfig: SqsDestinationConfig;
  SqsLogConfigInput: SqsLogConfigInput;
  SqsLogIntegrationHealth: SqsLogIntegrationHealth;
  SqsLogSourceIntegration: Omit<SqsLogSourceIntegration, 'createdBy'> & {
    createdBy?: Maybe<ResolversParentTypes['Actor']>;
  };
  StandardReportEntry: StandardReportEntry;
  StartAsyncDownloadOfAllQueryResultsInput: StartAsyncDownloadOfAllQueryResultsInput;
  StartAsyncDownloadOfAllQueryResultsOutput: StartAsyncDownloadOfAllQueryResultsOutput;
  StopReplayInput: StopReplayInput;
  StopReplayOutput: StopReplayOutput;
  StorageInfo: StorageInfo;
  String: Scalars['String']['output'];
  SummarizeDataLakeQueryInput: SummarizeDataLakeQueryInput;
  SummarizeDataLakeQueryJob: SummarizeDataLakeQueryJob;
  SuppressPoliciesInput: SuppressPoliciesInput;
  SyncLookupDataInput: SyncLookupDataInput;
  SysdigConfig: SysdigConfig;
  SysdigConfigInput: SysdigConfigInput;
  SystemError: SystemError;
  SystemErrorRelatedEntity: ResolversUnionTypes<ResolversParentTypes>['SystemErrorRelatedEntity'];
  TaxiiCollection: TaxiiCollection;
  TaxiiCollectionInput: TaxiiCollectionInput;
  TaxiiConfig: TaxiiConfig;
  TaxiiConfigInput: TaxiiConfigInput;
  TaxiiProfilePullerConfig: TaxiiProfilePullerConfig;
  TaxiiProfilePullerConfigInput: TaxiiProfilePullerConfigInput;
  TenableConfig: TenableConfig;
  TenableConfigInput: TenableConfigInput;
  TerraformTemplateResponse: TerraformTemplateResponse;
  TestCorrelationRuleInput: TestCorrelationRuleInput;
  TestCorrelationRuleResponse: TestCorrelationRuleResponse;
  TestCorrelationRuleYAMLInput: TestCorrelationRuleYAMLInput;
  TestCorrelationRuleYAMLOutput: TestCorrelationRuleYAMLOutput;
  TestCorrelationRuleYAMLTestResult: TestCorrelationRuleYAMLTestResult;
  TestDetectionRecord: TestDetectionRecord;
  TestDetectionRecordFunctions: TestDetectionRecordFunctions;
  TestDetectionSubRecord: TestDetectionSubRecord;
  TestFailure: TestFailure;
  TestFilterEventInput: TestFilterEventInput;
  TestFilterEventMatch: TestFilterEventMatch;
  TestFilterEventOutput: TestFilterEventOutput;
  TestHoldingTankSchemaFiltersInput: TestHoldingTankSchemaFiltersInput;
  TestHoldingTankSchemasInput: TestHoldingTankSchemasInput;
  TestPolicyInput: TestPolicyInput;
  TestPolicyRecord: TestPolicyRecord;
  TestPolicyRecordFunctions: TestPolicyRecordFunctions;
  TestPolicyResponse: TestPolicyResponse;
  TestPollGitResponse: TestPollGitResponse;
  TestRecord: ResolversInterfaceTypes<ResolversParentTypes>['TestRecord'];
  TestResult: TestResult;
  TestRuleInput: TestRuleInput;
  TestRuleResponse: TestRuleResponse;
  TestSchemaData: TestSchemaData;
  TestSchemaInput: TestSchemaInput;
  TestSchemaResponse: TestSchemaResponse;
  TestSchemaResult: TestSchemaResult;
  TestSchemaStats: TestSchemaStats;
  TimeWindow: TimeWindow;
  TimeWindowInput: TimeWindowInput;
  Timestamp: Scalars['Timestamp']['output'];
  TinesConfig: TinesConfig;
  TinesConfigInput: TinesConfigInput;
  TinesWebhookConfig: TinesWebhookConfig;
  TinesWebhookConfigInput: TinesWebhookConfigInput;
  ToggleScheduledPromptInput: ToggleScheduledPromptInput;
  TorqWebhookConfig: TorqWebhookConfig;
  TorqWebhookConfigInput: TorqWebhookConfigInput;
  TranspileFiltersInput: TranspileFiltersInput;
  TranspileFiltersOutput: TranspileFiltersOutput;
  TranspileSimpleDetectionsToPythonInput: TranspileSimpleDetectionsToPythonInput;
  TranspileSimpleDetectionsToPythonOutput: TranspileSimpleDetectionsToPythonOutput;
  TransportOptions: TransportOptions;
  UberSearchColumnSummaryInput: UberSearchColumnSummaryInput;
  UberSearchPropertySummaryInput: UberSearchPropertySummaryInput;
  UberSearchTablesInput: UberSearchTablesInput;
  UberSearchTablesOutput: UberSearchTablesOutput;
  UberSearchTablesOutputPageInfo: UberSearchTablesOutputPageInfo;
  UniversalGitConfig: UniversalGitConfig;
  UniversalSettingsConfig: UniversalSettingsConfig;
  UnmatchedLog: UnmatchedLog;
  UpdateAIConversationInput: UpdateAIConversationInput;
  UpdateAISkillInput: UpdateAISkillInput;
  UpdateAISkillOutput: UpdateAISkillOutput;
  UpdateAPITokenInput: UpdateAPITokenInput;
  UpdateAPITokenOutput: UpdateAPITokenOutput;
  UpdateAlertStatusByFilterInput: UpdateAlertStatusByFilterInput;
  UpdateAlertStatusByFilterJob: UpdateAlertStatusByFilterJob;
  UpdateAlertStatusByIdInput: UpdateAlertStatusByIdInput;
  UpdateAlertStatusByIdOutput: UpdateAlertStatusByIdOutput;
  UpdateAlertsAssigneeByEmailInput: UpdateAlertsAssigneeByEmailInput;
  UpdateAlertsAssigneeByEmailOutput: UpdateAlertsAssigneeByEmailOutput;
  UpdateAlertsAssigneeByIdInput: UpdateAlertsAssigneeByIdInput;
  UpdateAlertsAssigneeByIdOutput: UpdateAlertsAssigneeByIdOutput;
  UpdateAllCatalogItemsFailure: UpdateAllCatalogItemsFailure;
  UpdateAllCatalogItemsInput: UpdateAllCatalogItemsInput;
  UpdateAllCatalogItemsJob: UpdateAllCatalogItemsJob;
  UpdateAllCatalogItemsJobStats: UpdateAllCatalogItemsJobStats;
  UpdateAnalysisPackInput: UpdateAnalysisPackInput;
  UpdateAnalysisPackSourceInput: UpdateAnalysisPackSourceInput;
  UpdateAzureBlobSourceInput: UpdateAzureBlobSourceInput;
  UpdateAzureBlobSourceOutput: UpdateAzureBlobSourceOutput;
  UpdateCatalogItemInput: UpdateCatalogItemInput;
  UpdateCatalogItemOutput: UpdateCatalogItemOutput;
  UpdateCloudAccountInput: UpdateCloudAccountInput;
  UpdateCloudAccountOutput: UpdateCloudAccountOutput;
  UpdateCloudWatchLogIntegrationInput: UpdateCloudWatchLogIntegrationInput;
  UpdateDashboardInput: UpdateDashboardInput;
  UpdateDetectionFilterInput: UpdateDetectionFilterInput;
  UpdateEnrichmentIntegrationInput: UpdateEnrichmentIntegrationInput;
  UpdateGeneralSettingsConfigInput: UpdateGeneralSettingsConfigInput;
  UpdateGitHubAppConfigInput: UpdateGitHubAppConfigInput;
  UpdateGitHubAppConfigResponse: UpdateGitHubAppConfigResponse;
  UpdateLogSourceFiltersInput: UpdateLogSourceFiltersInput;
  UpdateLogSourceInput: UpdateLogSourceInput;
  UpdateLookupInput: UpdateLookupInput;
  UpdateMcpServerInput: UpdateMcpServerInput;
  UpdateMcpToolSettingsInput: UpdateMcpToolSettingsInput;
  UpdateMitreReportMappingInput: UpdateMitreReportMappingInput;
  UpdateMitreReportMappingOutput: Omit<UpdateMitreReportMappingOutput, 'detections'> & {
    detections: Array<ResolversParentTypes['InternalDetection']>;
  };
  UpdateMitreReportMappingSelection: UpdateMitreReportMappingSelection;
  UpdateMitreReportSettings: UpdateMitreReportSettings;
  UpdateNotificationInput: UpdateNotificationInput;
  UpdatePolicyInput: UpdatePolicyInput;
  UpdateQueryUserConfigInput: UpdateQueryUserConfigInput;
  UpdateRoleInput: UpdateRoleInput;
  UpdateRoleOutput: UpdateRoleOutput;
  UpdateRuleAndFilterInput: UpdateRuleAndFilterInput;
  UpdateRuleV2Input: UpdateRuleV2Input;
  UpdateRuleV2Output: UpdateRuleV2Output;
  UpdateS3LogIntegrationInput: UpdateS3LogIntegrationInput;
  UpdateS3SourceInput: UpdateS3SourceInput;
  UpdateS3SourceOutput: UpdateS3SourceOutput;
  UpdateSamlConfigInput: UpdateSamlConfigInput;
  UpdateSavedQueryInput: UpdateSavedQueryInput;
  UpdateScheduledPromptInput: UpdateScheduledPromptInput;
  UpdateSchemaStatusInput: UpdateSchemaStatusInput;
  UpdateUserInput: UpdateUserInput;
  UpdateUserNotificationsInput: UpdateUserNotificationsInput;
  UpdateUserNotificationsOutput: UpdateUserNotificationsOutput;
  UpdateUserOutput: UpdateUserOutput;
  UpdateWidgetInput: UpdateWidgetInput;
  UploadDetectionEntitiesAsyncInput: UploadDetectionEntitiesAsyncInput;
  UploadDetectionEntitiesAsyncOutput: UploadDetectionEntitiesAsyncOutput;
  UploadDetectionEntitiesInput: UploadDetectionEntitiesInput;
  UploadDetectionEntitiesOutput: UploadDetectionEntitiesOutput;
  UploadStatistics: UploadStatistics;
  User: User;
  UserFeedbackDataInput: UserFeedbackDataInput;
  UserFeedbackFeatureInput: UserFeedbackFeatureInput;
  UserPreferencesOutput: UserPreferencesOutput;
  UserRoleInput: UserRoleInput;
  ValidateAndTestAllAnalysisItemsInput: ValidateAndTestAllAnalysisItemsInput;
  ValidateAndTestAllAnalysisItemsOutput: ValidateAndTestAllAnalysisItemsOutput;
  ValidateBulkUploadInput: ValidateBulkUploadInput;
  ValidateBulkUploadOutput: ValidateBulkUploadOutput;
  ValidateUploadStatusOutput: ValidateUploadStatusOutput;
  ViewBucketDataFilterInput: ViewBucketDataFilterInput;
  ViewBucketDataInput: ViewBucketDataInput;
  ViewParsedEvent: ViewParsedEvent;
  ViewParsedEventsInput: ViewParsedEventsInput;
  ViewParsedEventsResponse: ViewParsedEventsResponse;
  VirusTotalIoCStreamConfig: VirusTotalIoCStreamConfig;
  VirusTotalIoCStreamConfigInput: VirusTotalIoCStreamConfigInput;
  VirusTotalIoCStreamProfilePullerConfig: VirusTotalIoCStreamProfilePullerConfig;
  VirusTotalIoCStreamProfilePullerConfigInput: VirusTotalIoCStreamProfilePullerConfigInput;
  Widget: Widget;
  WidgetLayout: WidgetLayout;
  WidgetLayoutInput: WidgetLayoutInput;
  WizConfig: WizConfig;
  WizConfigInput: WizConfigInput;
  WorkbenchFile: WorkbenchFile;
  WorkbenchPickerItem: WorkbenchPickerItem;
  WorkdayConfig: WorkdayConfig;
  WorkdayConfigInput: WorkdayConfigInput;
  ZendeskApiConfigInput: ZendeskApiConfigInput;
  ZendeskBasicConfigInput: ZendeskBasicConfigInput;
  ZendeskLogSourceApiConfig: ZendeskLogSourceApiConfig;
  ZendeskLogSourceBasicConfig: ZendeskLogSourceBasicConfig;
  ZendeskLogSourceConfig: Omit<ZendeskLogSourceConfig, 'credentials'> & {
    credentials: ResolversParentTypes['ZendeskLogSourceCredentialsConfig'];
  };
  ZendeskLogSourceCredentialsConfig: ResolversUnionTypes<ResolversParentTypes>['ZendeskLogSourceCredentialsConfig'];
  ZendeskLogSourceInput: ZendeskLogSourceInput;
  ZendeskLogSourceOAuth2Config: ZendeskLogSourceOAuth2Config;
  ZendeskOAuth2ConfigInput: ZendeskOAuth2ConfigInput;
  ZoomConfig: ZoomConfig;
  ZoomConfigInput: ZoomConfigInput;
};

export type AuditDirectiveArgs = {
  name: Scalars['String']['input'];
};

export type AuditDirectiveResolver<
  Result,
  Parent,
  ContextType = any,
  Args = AuditDirectiveArgs,
> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AuthDirectiveArgs = {
  permissions: Array<Permission>;
  permissionsAnd?: Maybe<Array<Permission>>;
};

export type AuthDirectiveResolver<
  Result,
  Parent,
  ContextType = any,
  Args = AuthDirectiveArgs,
> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type SensitiveDirectiveArgs = {};

export type SensitiveDirectiveResolver<
  Result,
  Parent,
  ContextType = any,
  Args = SensitiveDirectiveArgs,
> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AIAttachmentUploadUrlResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AIAttachmentUploadUrl'] =
    ResolversParentTypes['AIAttachmentUploadUrl'],
> = {
  s3Url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uploadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AIConversationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AIConversation'] =
    ResolversParentTypes['AIConversation'],
> = {
  alias?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aliasType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  canEdit?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  firstUserPrompt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isOwner?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isScheduled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  kind?: Resolver<Maybe<ResolversTypes['AISummarizeKind']>, ParentType, ContextType>;
  private?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  saved?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  scheduledPromptId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streams?: Resolver<
    ResolversTypes['AIInferenceStreamsMetadataList'],
    ParentType,
    ContextType,
    Partial<AIConversationStreamsArgs>
  >;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AIConversationsOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AIConversationsOutput'] =
    ResolversParentTypes['AIConversationsOutput'],
> = {
  edges?: Resolver<Array<ResolversTypes['AIConversationsOutputEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['CursorBasedPaginationPageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AIConversationsOutputEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AIConversationsOutputEdge'] =
    ResolversParentTypes['AIConversationsOutputEdge'],
> = {
  node?: Resolver<ResolversTypes['AIConversation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AIInferenceStreamResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AIInferenceStream'] =
    ResolversParentTypes['AIInferenceStream'],
> = {
  alias?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  canEdit?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  cancelled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  cancelledAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  cancelledBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  deleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  finished?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  parentStreamId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  pinned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  private?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  responseText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  riskScoreEvidence?: Resolver<Maybe<ResolversTypes['RiskScoreEvidence']>, ParentType, ContextType>;
  saved?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  streamId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  streamName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toolInvocations?: Resolver<
    Maybe<Array<ResolversTypes['AIToolInvocation']>>,
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  usage?: Resolver<Maybe<ResolversTypes['AIInferenceStreamUsage']>, ParentType, ContextType>;
  userPrompt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AIInferenceStreamMetadataWithPathResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AIInferenceStreamMetadataWithPath'] =
    ResolversParentTypes['AIInferenceStreamMetadataWithPath'],
> = {
  children?: Resolver<Array<ResolversTypes['AIInferenceStream']>, ParentType, ContextType>;
  pathToRoot?: Resolver<Array<ResolversTypes['AIInferenceStream']>, ParentType, ContextType>;
  stream?: Resolver<ResolversTypes['AIInferenceStream'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AIInferenceStreamTextSearchResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AIInferenceStreamTextSearchResult'] =
    ResolversParentTypes['AIInferenceStreamTextSearchResult'],
> = {
  alias?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aliasType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conversationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  isConversation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  private?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  snippetWithHighlights?: Resolver<
    ResolversTypes['SnippetWithHighlights'],
    ParentType,
    ContextType
  >;
  streamId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userPrompt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AIInferenceStreamTextSearchResultEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AIInferenceStreamTextSearchResultEdge'] =
    ResolversParentTypes['AIInferenceStreamTextSearchResultEdge'],
> = {
  node?: Resolver<ResolversTypes['AIInferenceStreamTextSearchResult'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AIInferenceStreamTextSearchResultListResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AIInferenceStreamTextSearchResultList'] =
    ResolversParentTypes['AIInferenceStreamTextSearchResultList'],
> = {
  edges?: Resolver<
    Array<ResolversTypes['AIInferenceStreamTextSearchResultEdge']>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['CursorBasedPaginationPageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AIInferenceStreamUsageResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AIInferenceStreamUsage'] =
    ResolversParentTypes['AIInferenceStreamUsage'],
> = {
  cacheCreationInputTokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  cacheReadInputTokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  durationSeconds?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  inputTokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  modelID?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  outputTokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AIInferenceStreamsMetadataListResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AIInferenceStreamsMetadataList'] =
    ResolversParentTypes['AIInferenceStreamsMetadataList'],
> = {
  edges?: Resolver<
    Array<ResolversTypes['AIInferenceStreamsMetadataListEdge']>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['CursorBasedPaginationPageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AIInferenceStreamsMetadataListEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AIInferenceStreamsMetadataListEdge'] =
    ResolversParentTypes['AIInferenceStreamsMetadataListEdge'],
> = {
  node?: Resolver<ResolversTypes['AIInferenceStream'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AISkillResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AISkill'] = ResolversParentTypes['AISkill'],
> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  dependsOn?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  disabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  eagerLoading?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  namespace?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pantherManaged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  prompt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requiredTools?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  tags?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  toolMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AISkillListItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AISkillListItem'] =
    ResolversParentTypes['AISkillListItem'],
> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AISkillOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AISkillOutput'] = ResolversParentTypes['AISkillOutput'],
> = {
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  skill?: Resolver<Maybe<ResolversTypes['AISkill']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AISkillsOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AISkillsOutput'] =
    ResolversParentTypes['AISkillsOutput'],
> = {
  edges?: Resolver<Array<ResolversTypes['AISkillsOutputEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['CursorBasedPaginationPageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AISkillsOutputEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AISkillsOutputEdge'] =
    ResolversParentTypes['AISkillsOutputEdge'],
> = {
  node?: Resolver<ResolversTypes['AISkill'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AIStreamConversationLookupOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AIStreamConversationLookupOutput'] =
    ResolversParentTypes['AIStreamConversationLookupOutput'],
> = {
  conversationId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  streamExists?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AIToolInvocationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AIToolInvocation'] =
    ResolversParentTypes['AIToolInvocation'],
> = {
  approvedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  rejectReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rejectedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  timedOutAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  toolName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AIUsageOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AIUsageOutput'] = ResolversParentTypes['AIUsageOutput'],
> = {
  aiRunsQuota?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type APITokenResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['APIToken'] = ResolversParentTypes['APIToken'],
> = {
  allowedCIDRBlocks?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastUsedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  permissions?: Resolver<Array<ResolversTypes['Permission']>, ParentType, ContextType>;
  rotatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  rotatedBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AWSScanConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AWSScanConfig'] = ResolversParentTypes['AWSScanConfig'],
> = {
  auditRole?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActiveSuppressCountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ActiveSuppressCount'] =
    ResolversParentTypes['ActiveSuppressCount'],
> = {
  active?: Resolver<Maybe<ResolversTypes['ComplianceStatusCounts']>, ParentType, ContextType>;
  suppressed?: Resolver<Maybe<ResolversTypes['ComplianceStatusCounts']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Actor'] = ResolversParentTypes['Actor'],
> = {
  __resolveType: TypeResolveFn<'APIToken' | 'User', ParentType, ContextType>;
};

export type AddRuleV2OutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AddRuleV2Output'] =
    ResolversParentTypes['AddRuleV2Output'],
> = {
  rule?: Resolver<Maybe<ResolversTypes['Rule']>, ParentType, ContextType>;
  testResults?: Resolver<Maybe<Array<ResolversTypes['TestResult']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Alert'] = ResolversParentTypes['Alert'],
> = {
  activityHistory?: Resolver<
    Maybe<ResolversTypes['AlertActivityHistoryOutput']>,
    ParentType,
    ContextType,
    Partial<AlertActivityHistoryArgs>
  >;
  assignee?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  contextTags?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deliveries?: Resolver<Array<Maybe<ResolversTypes['AlertDelivery']>>, ParentType, ContextType>;
  deliveryOverflow?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<
    Maybe<ResolversTypes['AlertEventsOutput']>,
    ParentType,
    ContextType,
    Partial<AlertEventsArgs>
  >;
  firstEventOccurredAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastReceivedEventAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  origin?: Resolver<ResolversTypes['AlertOrigin'], ParentType, ContextType>;
  originID?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quality?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  riskScore?: Resolver<Maybe<ResolversTypes['RiskScoreEvidence']>, ParentType, ContextType>;
  runbook?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  severity?: Resolver<ResolversTypes['Severity'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['AlertStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AlertType'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertActivityHistoryAssigneeChangeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertActivityHistoryAssigneeChange'] =
    ResolversParentTypes['AlertActivityHistoryAssigneeChange'],
> = {
  newAssignee?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertActivityHistoryCommentAddedResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertActivityHistoryCommentAdded'] =
    ResolversParentTypes['AlertActivityHistoryCommentAdded'],
> = {
  comment?: Resolver<ResolversTypes['Comment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertActivityHistoryContextTagsChangeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertActivityHistoryContextTagsChange'] =
    ResolversParentTypes['AlertActivityHistoryContextTagsChange'],
> = {
  newContextTags?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertActivityHistoryOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertActivityHistoryOutput'] =
    ResolversParentTypes['AlertActivityHistoryOutput'],
> = {
  edges?: Resolver<
    Array<ResolversTypes['AlertActivityHistoryOutputEdge']>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<
    ResolversTypes['AlertActivityHistoryOutputPageInfo'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertActivityHistoryOutputEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertActivityHistoryOutputEdge'] =
    ResolversParentTypes['AlertActivityHistoryOutputEdge'],
> = {
  node?: Resolver<ResolversTypes['AlertActivityHistoryRecord'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertActivityHistoryOutputPageInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertActivityHistoryOutputPageInfo'] =
    ResolversParentTypes['AlertActivityHistoryOutputPageInfo'],
> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertActivityHistoryQualityChangeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertActivityHistoryQualityChange'] =
    ResolversParentTypes['AlertActivityHistoryQualityChange'],
> = {
  newQuality?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertActivityHistoryRecordResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertActivityHistoryRecord'] =
    ResolversParentTypes['AlertActivityHistoryRecord'],
> = {
  content?: Resolver<ResolversTypes['AlertActivityHistoryRecordContent'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  triggeredBy?: Resolver<ResolversTypes['Actor'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AlertActivityHistoryRecordTypes'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertActivityHistoryRecordContentResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertActivityHistoryRecordContent'] =
    ResolversParentTypes['AlertActivityHistoryRecordContent'],
> = {
  __resolveType: TypeResolveFn<
    | 'AlertActivityHistoryAssigneeChange'
    | 'AlertActivityHistoryCommentAdded'
    | 'AlertActivityHistoryContextTagsChange'
    | 'AlertActivityHistoryQualityChange'
    | 'AlertActivityHistorySlackbotBoomerang'
    | 'AlertActivityHistoryStatusChange',
    ParentType,
    ContextType
  >;
};

export type AlertActivityHistorySlackbotBoomerangResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertActivityHistorySlackbotBoomerang'] =
    ResolversParentTypes['AlertActivityHistorySlackbotBoomerang'],
> = {
  slackbotBoomerangHistory?: Resolver<
    ResolversTypes['SlackbotBoomerangHistory'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertActivityHistoryStatusChangeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertActivityHistoryStatusChange'] =
    ResolversParentTypes['AlertActivityHistoryStatusChange'],
> = {
  newStatus?: Resolver<ResolversTypes['AlertStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertContextTagResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertContextTag'] =
    ResolversParentTypes['AlertContextTag'],
> = {
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  managed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  tag?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertContextTagEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertContextTagEdge'] =
    ResolversParentTypes['AlertContextTagEdge'],
> = {
  node?: Resolver<ResolversTypes['AlertContextTag'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertDashboardDataOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertDashboardDataOutput'] =
    ResolversParentTypes['AlertDashboardDataOutput'],
> = {
  alertsByDetection?: Resolver<Array<ResolversTypes['AlertsByDetection']>, ParentType, ContextType>;
  alertsBySeverityAndStatus?: Resolver<
    ResolversTypes['AlertsBySeverityAndStatus'],
    ParentType,
    ContextType
  >;
  logTypeAlertsBySeverity?: Resolver<
    Array<ResolversTypes['LogTypeAlertsBySeverity']>,
    ParentType,
    ContextType
  >;
  myAssignedAlerts?: Resolver<Array<ResolversTypes['Alert']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['JobStatus'], ParentType, ContextType>;
  unassignedAlertsBySeverity?: Resolver<
    ResolversTypes['AlertsBySeverity'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertDeliveryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertDelivery'] = ResolversParentTypes['AlertDelivery'],
> = {
  dispatchedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  outputId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  statusCode?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertEventsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertEvents'] = ResolversParentTypes['AlertEvents'],
> = {
  items?: Resolver<Array<ResolversTypes['AlertEventsEdge']>, ParentType, ContextType>;
  lastEvaluatedKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertEventsEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertEventsEdge'] =
    ResolversParentTypes['AlertEventsEdge'],
> = {
  node?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  nodeAsString?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertEventsOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertEventsOutput'] =
    ResolversParentTypes['AlertEventsOutput'],
> = {
  edges?: Resolver<Array<ResolversTypes['AlertEventsOutputEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['CursorBasedPaginationPageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertEventsOutputEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertEventsOutputEdge'] =
    ResolversParentTypes['AlertEventsOutputEdge'],
> = {
  node?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertOriginResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertOrigin'] = ResolversParentTypes['AlertOrigin'],
> = {
  __resolveType: TypeResolveFn<
    | 'AlertOriginPolicy'
    | 'AlertOriginReplayedRule'
    | 'AlertOriginRule'
    | 'AlertOriginSystemError'
    | 'DeletedDetection'
    | 'Detection'
    | 'SystemError',
    ParentType,
    ContextType
  >;
};

export type AlertOriginPolicyResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertOriginPolicy'] =
    ResolversParentTypes['AlertOriginPolicy'],
> = {
  dedupString?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  policyId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  policySourceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resourceTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertOriginReplayedRuleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertOriginReplayedRule'] =
    ResolversParentTypes['AlertOriginReplayedRule'],
> = {
  alertId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  dedupString?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<
    Maybe<ResolversTypes['AlertEvents']>,
    ParentType,
    ContextType,
    Partial<AlertOriginReplayedRuleEventsArgs>
  >;
  eventsMatched?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  logTypes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  replayId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  ruleId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  scheduledQueries?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertOriginRuleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertOriginRule'] =
    ResolversParentTypes['AlertOriginRule'],
> = {
  dedupString?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<
    Maybe<ResolversTypes['AlertEvents']>,
    ParentType,
    ContextType,
    Partial<AlertOriginRuleEventsArgs>
  >;
  eventsMatched?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  logTypes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  ruleId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  scheduledQueries?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertOriginSystemErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertOriginSystemError'] =
    ResolversParentTypes['AlertOriginSystemError'],
> = {
  alerts?: Resolver<
    ResolversTypes['RelatedAlertsOutput'],
    ParentType,
    ContextType,
    Partial<AlertOriginSystemErrorAlertsArgs>
  >;
  events?: Resolver<
    Maybe<ResolversTypes['AlertEvents']>,
    ParentType,
    ContextType,
    Partial<AlertOriginSystemErrorEventsArgs>
  >;
  relatedComponent?: Resolver<ResolversTypes['RelatedComponent'], ParentType, ContextType>;
  relatedEntity?: Resolver<
    Maybe<ResolversTypes['SystemErrorRelatedEntity']>,
    ParentType,
    ContextType
  >;
  type?: Resolver<ResolversTypes['SystemErrorType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertSummaryAttributeForAnalysisResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertSummaryAttributeForAnalysis'] =
    ResolversParentTypes['AlertSummaryAttributeForAnalysis'],
> = {
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  logType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  query?: Resolver<
    Maybe<ResolversTypes['AlertSummaryAttributeQueryData']>,
    ParentType,
    ContextType
  >;
  summaryAttribute?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertSummaryAttributeQueryDataResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertSummaryAttributeQueryData'] =
    ResolversParentTypes['AlertSummaryAttributeQueryData'],
> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sql?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertsByDetectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertsByDetection'] =
    ResolversParentTypes['AlertsByDetection'],
> = {
  detectionDisplayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  detectionID?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  detectionSeverity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  detectionType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertsBySeverityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertsBySeverity'] =
    ResolversParentTypes['AlertsBySeverity'],
> = {
  critical?: Resolver<ResolversTypes['AlertsPreview'], ParentType, ContextType>;
  high?: Resolver<ResolversTypes['AlertsPreview'], ParentType, ContextType>;
  info?: Resolver<ResolversTypes['AlertsPreview'], ParentType, ContextType>;
  low?: Resolver<ResolversTypes['AlertsPreview'], ParentType, ContextType>;
  medium?: Resolver<ResolversTypes['AlertsPreview'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertsBySeverityAndStatusResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertsBySeverityAndStatus'] =
    ResolversParentTypes['AlertsBySeverityAndStatus'],
> = {
  critical?: Resolver<ResolversTypes['AlertsByStatus'], ParentType, ContextType>;
  high?: Resolver<ResolversTypes['AlertsByStatus'], ParentType, ContextType>;
  info?: Resolver<ResolversTypes['AlertsByStatus'], ParentType, ContextType>;
  low?: Resolver<ResolversTypes['AlertsByStatus'], ParentType, ContextType>;
  medium?: Resolver<ResolversTypes['AlertsByStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertsByStatusResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertsByStatus'] =
    ResolversParentTypes['AlertsByStatus'],
> = {
  invalid?: Resolver<ResolversTypes['AlertsPreview'], ParentType, ContextType>;
  open?: Resolver<ResolversTypes['AlertsPreview'], ParentType, ContextType>;
  resolved?: Resolver<ResolversTypes['AlertsPreview'], ParentType, ContextType>;
  triaged?: Resolver<ResolversTypes['AlertsPreview'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertsOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertsOutput'] = ResolversParentTypes['AlertsOutput'],
> = {
  edges?: Resolver<Array<ResolversTypes['AlertsOutputEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['AlertsOutputPageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertsOutputEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertsOutputEdge'] =
    ResolversParentTypes['AlertsOutputEdge'],
> = {
  node?: Resolver<ResolversTypes['Alert'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertsOutputPageInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertsOutputPageInfo'] =
    ResolversParentTypes['AlertsOutputPageInfo'],
> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertsPreviewResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AlertsPreview'] = ResolversParentTypes['AlertsPreview'],
> = {
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AllDatalakeSchemaEntitiesOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AllDatalakeSchemaEntitiesOutput'] =
    ResolversParentTypes['AllDatalakeSchemaEntitiesOutput'],
> = {
  entities?: Resolver<
    Array<Maybe<ResolversTypes['DatalakeSchemaEntity']>>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['CursorBasedPaginationPageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AllDatalakeSchemaPropertiesOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AllDatalakeSchemaPropertiesOutput'] =
    ResolversParentTypes['AllDatalakeSchemaPropertiesOutput'],
> = {
  pageInfo?: Resolver<ResolversTypes['CursorBasedPaginationPageInfo'], ParentType, ContextType>;
  properties?: Resolver<Array<ResolversTypes['DatalakeSchemaProperty']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AllGitConfigsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AllGitConfigs'] = ResolversParentTypes['AllGitConfigs'],
> = {
  genericGitConfigs?: Resolver<
    Maybe<Array<ResolversTypes['GenericGitConfig']>>,
    ParentType,
    ContextType
  >;
  gitHubAppConfigs?: Resolver<
    Maybe<Array<ResolversTypes['GitHubAppConfig']>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AmazonSecurityLakeConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AmazonSecurityLakeConfig'] =
    ResolversParentTypes['AmazonSecurityLakeConfig'],
> = {
  externalId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  queueArn?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  roleArn?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AmazonSecurityLakeLogIntegrationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AmazonSecurityLakeLogIntegration'] =
    ResolversParentTypes['AmazonSecurityLakeLogIntegration'],
> = {
  alarms?: Resolver<ResolversTypes['LogIntegrationAlarms'], ParentType, ContextType>;
  amazonSecurityLakeConfig?: Resolver<
    ResolversTypes['AmazonSecurityLakeConfig'],
    ParentType,
    ContextType
  >;
  createdAtTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  filters?: Resolver<ResolversTypes['SourceFilters'], ParentType, ContextType>;
  health?: Resolver<
    ResolversTypes['AmazonSecurityLakeLogIntegrationHealth'],
    ParentType,
    ContextType
  >;
  integrationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  integrationLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  integrationType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isEditable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isHealthy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPantherManaged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastEventProcessedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastEventReceivedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastModified?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  logProviderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AmazonSecurityLakeLogIntegrationHealthResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AmazonSecurityLakeLogIntegrationHealth'] =
    ResolversParentTypes['AmazonSecurityLakeLogIntegrationHealth'],
> = {
  amazonSecurityLakeQueueStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  amazonSecurityLakeRoleStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  classificationFailuresStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  logProcessingErrorsStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  systemAlarmStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnalysisItemSaveResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AnalysisItemSaveResult'] =
    ResolversParentTypes['AnalysisItemSaveResult'],
> = {
  analysisType?: Resolver<ResolversTypes['AnalysisType'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  itemError?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  saved?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  testResults?: Resolver<Maybe<Array<ResolversTypes['TestRecord']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnalysisItemTestRunResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AnalysisItemTestRunResult'] =
    ResolversParentTypes['AnalysisItemTestRunResult'],
> = {
  analysisType?: Resolver<ResolversTypes['AnalysisType'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  itemError?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  testResults?: Resolver<Array<ResolversTypes['TestRecord']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnalysisPackResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AnalysisPack'] = ResolversParentTypes['AnalysisPack'],
> = {
  availableVersions?: Resolver<
    Array<ResolversTypes['AnalysisPackVersion']>,
    ParentType,
    ContextType
  >;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastModified?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  packDefinition?: Resolver<ResolversTypes['AnalysisPackDefinition'], ParentType, ContextType>;
  packTypes?: Resolver<ResolversTypes['AnalysisPackTypes'], ParentType, ContextType>;
  packVersion?: Resolver<ResolversTypes['AnalysisPackVersion'], ParentType, ContextType>;
  updateAvailable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnalysisPackDefinitionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AnalysisPackDefinition'] =
    ResolversParentTypes['AnalysisPackDefinition'],
> = {
  IDs?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnalysisPackSourceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AnalysisPackSource'] =
    ResolversParentTypes['AnalysisPackSource'],
> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  githubAccessToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  kmsKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModified?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  owner?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  repository?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnalysisPackTypesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AnalysisPackTypes'] =
    ResolversParentTypes['AnalysisPackTypes'],
> = {
  CORRELATION_RULE?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  DATAMODEL?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  GLOBAL?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  POLICY?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  RULE?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  SCHEDULED_QUERY?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  SCHEDULED_RULE?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnalysisPackVersionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AnalysisPackVersion'] =
    ResolversParentTypes['AnalysisPackVersion'],
> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  semVer?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnnotationsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Annotations'] = ResolversParentTypes['Annotations'],
> = {
  visualize?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnomaliConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AnomaliConfig'] = ResolversParentTypes['AnomaliConfig'],
> = {
  apiToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profilePullers?: Resolver<ResolversTypes['AnomaliProfilePullerConfig'], ParentType, ContextType>;
  query?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subdomain?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnomaliProfilePullerConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AnomaliProfilePullerConfig'] =
    ResolversParentTypes['AnomaliProfilePullerConfig'],
> = {
  indicators?: Resolver<ResolversTypes['ProfilePullerConfig'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnthropicConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AnthropicConfig'] =
    ResolversParentTypes['AnthropicConfig'],
> = {
  apiKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AppConfig'] = ResolversParentTypes['AppConfig'],
> = {
  accountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aiEnableRunbooks?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  aiEnableScheduledPrompts?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  alertSummariesEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  awsAccountAlias?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  awsMcpEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  awsOrgId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  awsPartition?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  contractEndDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contractStartDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  databaseApi?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  datadogRumEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  datadogWebApplicationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  datadogWebClientToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  datadogWebServiceName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enableClassyDetections?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  enableDataExplorerTruncation?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  enableDatalakeRbac?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  enableDetectionFilters?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  enableExperimentalCrowdstrikeParsing?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  enablePantherGitConfiguration?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  enableReplays?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  enableReports?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  maxLookupTableCompressedSizeInMb?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  pantherCommit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pantherDataLakeType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  processedDataBucketRetentionDays?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  publicHTTPIngestDomain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pylonAppId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  remoteMcpEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  salesPhase?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  snowflakeAdminSecretArn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  snowflakeClusterArns?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  snowflakeReadonlySecretArn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  splitClientToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApproveRemoteMcpAuthorizationResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ApproveRemoteMcpAuthorizationResult'] =
    ResolversParentTypes['ApproveRemoteMcpAuthorizationResult'],
> = {
  redirectUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AsanaConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AsanaConfig'] = ResolversParentTypes['AsanaConfig'],
> = {
  personalAccessToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projectGids?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  syncAlertStatus?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AsanaLogSourceConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AsanaLogSourceConfig'] =
    ResolversParentTypes['AsanaLogSourceConfig'],
> = {
  organizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  serviceAccountToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AssociatedLogTypeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AssociatedLogType'] =
    ResolversParentTypes['AssociatedLogType'],
> = {
  autoMappedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  logType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  selectors?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AtlassianConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AtlassianConfig'] =
    ResolversParentTypes['AtlassianConfig'],
> = {
  apiKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AutodetectIndicatorFiltersOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AutodetectIndicatorFiltersOutput'] =
    ResolversParentTypes['AutodetectIndicatorFiltersOutput'],
> = {
  filters?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvailableLogProviderResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AvailableLogProvider'] =
    ResolversParentTypes['AvailableLogProvider'],
> = {
  availableParsers?: Resolver<
    Array<ResolversTypes['AvailableLogProviderParser']>,
    ParentType,
    ContextType
  >;
  categories?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  details?: Resolver<Maybe<ResolversTypes['AvailableLogProviderDetails']>, ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  docUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  popularityIndex?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  searchTerms?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  tagLine?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transports?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvailableLogProviderDetailsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AvailableLogProviderDetails'] =
    ResolversParentTypes['AvailableLogProviderDetails'],
> = {
  appInfo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  defaultParsers?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  howItWorks?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transportOptions?: Resolver<Maybe<ResolversTypes['TransportOptions']>, ParentType, ContextType>;
  useCases?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvailableLogProviderParserResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AvailableLogProviderParser'] =
    ResolversParentTypes['AvailableLogProviderParser'],
> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  referenceUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AzureBlobConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AzureBlobConfig'] =
    ResolversParentTypes['AzureBlobConfig'],
> = {
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cloud?: Resolver<Maybe<ResolversTypes['AzureCloudType']>, ParentType, ContextType>;
  secret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  storageAccountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  storageQueueName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AzureBlobLogIntegrationHealthResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AzureBlobLogIntegrationHealth'] =
    ResolversParentTypes['AzureBlobLogIntegrationHealth'],
> = {
  azureBlobStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  classificationFailuresStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  logProcessingErrorsStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  systemAlarmStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AzureBlobSourceIntegrationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AzureBlobSourceIntegration'] =
    ResolversParentTypes['AzureBlobSourceIntegration'],
> = {
  alarms?: Resolver<ResolversTypes['LogIntegrationAlarms'], ParentType, ContextType>;
  azureBlobConfig?: Resolver<ResolversTypes['AzureBlobConfig'], ParentType, ContextType>;
  createdAtTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  filters?: Resolver<ResolversTypes['SourceFilters'], ParentType, ContextType>;
  health?: Resolver<ResolversTypes['AzureBlobLogIntegrationHealth'], ParentType, ContextType>;
  integrationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  integrationLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  integrationType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isEditable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isHealthy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPantherManaged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastEventProcessedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastEventReceivedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastModified?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  logProviderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logStreamType?: Resolver<Maybe<ResolversTypes['LogStreamType']>, ParentType, ContextType>;
  logStreamTypeOptions?: Resolver<
    Maybe<ResolversTypes['LogStreamTypeOptions']>,
    ParentType,
    ContextType
  >;
  logTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AzureEventHubConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AzureEventHubConfig'] =
    ResolversParentTypes['AzureEventHubConfig'],
> = {
  connectionString?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  consumerGroup?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AzureEventHubLogIntegrationHealthResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AzureEventHubLogIntegrationHealth'] =
    ResolversParentTypes['AzureEventHubLogIntegrationHealth'],
> = {
  azureEventHubStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  classificationFailuresStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  logProcessingErrorsStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  systemAlarmStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AzureEventHubOptionsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AzureEventHubOptions'] =
    ResolversParentTypes['AzureEventHubOptions'],
> = {
  logStreamType?: Resolver<Maybe<ResolversTypes['LogStreamType']>, ParentType, ContextType>;
  logStreamTypeOptions?: Resolver<
    Maybe<ResolversTypes['LogStreamTypeOptions']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AzureEventHubSourceIntegrationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AzureEventHubSourceIntegration'] =
    ResolversParentTypes['AzureEventHubSourceIntegration'],
> = {
  alarms?: Resolver<ResolversTypes['LogIntegrationAlarms'], ParentType, ContextType>;
  azureEventHubConfig?: Resolver<ResolversTypes['AzureEventHubConfig'], ParentType, ContextType>;
  createdAtTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  filters?: Resolver<ResolversTypes['SourceFilters'], ParentType, ContextType>;
  health?: Resolver<ResolversTypes['AzureEventHubLogIntegrationHealth'], ParentType, ContextType>;
  integrationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  integrationLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  integrationType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isEditable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isHealthy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPantherManaged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastEventProcessedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastEventReceivedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastModified?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  logProviderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logStreamType?: Resolver<Maybe<ResolversTypes['LogStreamType']>, ParentType, ContextType>;
  logStreamTypeOptions?: Resolver<
    Maybe<ResolversTypes['LogStreamTypeOptions']>,
    ParentType,
    ContextType
  >;
  logTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BatchInferJobsOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BatchInferJobsOutput'] =
    ResolversParentTypes['BatchInferJobsOutput'],
> = {
  tasks?: Resolver<Array<ResolversTypes['Job']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BitwardenConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BitwardenConfig'] =
    ResolversParentTypes['BitwardenConfig'],
> = {
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  server?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BlinkOpsWebhookConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BlinkOpsWebhookConfig'] =
    ResolversParentTypes['BlinkOpsWebhookConfig'],
> = {
  apiKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  webhookURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BulkDownloadResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BulkDownloadResponse'] =
    ResolversParentTypes['BulkDownloadResponse'],
> = {
  data?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BulkDownloadUrlResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BulkDownloadUrlResponse'] =
    ResolversParentTypes['BulkDownloadUrlResponse'],
> = {
  expiresAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  presignedURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BulkUpdateDetectionsResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BulkUpdateDetectionsResponse'] =
    ResolversParentTypes['BulkUpdateDetectionsResponse'],
> = {
  detections?: Resolver<Array<ResolversTypes['InternalDetection']>, ParentType, ContextType>;
  errors?: Resolver<Array<Maybe<ResolversTypes['DetectionUpdateError']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BulkUploadIssueResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BulkUploadIssue'] =
    ResolversParentTypes['BulkUploadIssue'],
> = {
  errorMessage?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  path?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BulkUploadJobResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BulkUploadJob'] = ResolversParentTypes['BulkUploadJob'],
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  results?: Resolver<Maybe<ResolversTypes['BulkUploadJobResults']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['JobStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BulkUploadJobResultsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BulkUploadJobResults'] =
    ResolversParentTypes['BulkUploadJobResults'],
> = {
  deletedRuleIds?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  modifiedRuleIds?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  newRuleIds?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  totalRuleIds?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BulkUploadPresignedUrlOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BulkUploadPresignedUrlOutput'] =
    ResolversParentTypes['BulkUploadPresignedUrlOutput'],
> = {
  detectionsURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sessionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BulkValidateResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BulkValidateResult'] =
    ResolversParentTypes['BulkValidateResult'],
> = {
  issues?: Resolver<Maybe<Array<ResolversTypes['BulkUploadIssue']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancelDashboardOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CancelDashboardOutput'] =
    ResolversParentTypes['CancelDashboardOutput'],
> = {
  queryIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancelDataLakeQueryOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CancelDataLakeQueryOutput'] =
    ResolversParentTypes['CancelDataLakeQueryOutput'],
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogDataModelResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CatalogDataModel'] =
    ResolversParentTypes['CatalogDataModel'],
> = {
  configFilePath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  installed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  logType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogDetectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CatalogDetection'] =
    ResolversParentTypes['CatalogDetection'],
> = {
  analysisType?: Resolver<ResolversTypes['AnalysisType'], ParentType, ContextType>;
  configFilePath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  installed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  logTypes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  resourceTypes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  scheduledQueries?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  severity?: Resolver<ResolversTypes['Severity'], ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogEnrichmentResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CatalogEnrichment'] =
    ResolversParentTypes['CatalogEnrichment'],
> = {
  associatedLogTypes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  installed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  installedId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  schema?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogGlobalHelperResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CatalogGlobalHelper'] =
    ResolversParentTypes['CatalogGlobalHelper'],
> = {
  configFilePath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  installed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogItemRefResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CatalogItemRef'] =
    ResolversParentTypes['CatalogItemRef'],
> = {
  analysisType?: Resolver<ResolversTypes['AnalysisType'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogQueryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CatalogQuery'] = ResolversParentTypes['CatalogQuery'],
> = {
  configFilePath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  installed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  installedQueryId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  queryName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  scheduled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CloudAccountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CloudAccount'] = ResolversParentTypes['CloudAccount'],
> = {
  awsAccountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  awsRegionIgnoreList?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  awsScanConfig?: Resolver<Maybe<ResolversTypes['AWSScanConfig']>, ParentType, ContextType>;
  awsStackName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  health?: Resolver<ResolversTypes['ComplianceIntegrationHealth'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isEditable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPantherManaged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRealtimeScanningEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastModifiedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  resourceRegexIgnoreList?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  resourceTypeIgnoreList?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CloudAccountsOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CloudAccountsOutput'] =
    ResolversParentTypes['CloudAccountsOutput'],
> = {
  edges?: Resolver<Array<ResolversTypes['CloudAccountsOutputEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['CursorBasedPaginationPageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CloudAccountsOutputEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CloudAccountsOutputEdge'] =
    ResolversParentTypes['CloudAccountsOutputEdge'],
> = {
  node?: Resolver<ResolversTypes['CloudAccount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CloudWatchLogIntegrationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CloudWatchLogIntegration'] =
    ResolversParentTypes['CloudWatchLogIntegration'],
> = {
  alarms?: Resolver<ResolversTypes['LogIntegrationAlarms'], ParentType, ContextType>;
  awsAccountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAtTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  filterPattern?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  filters?: Resolver<ResolversTypes['SourceFilters'], ParentType, ContextType>;
  health?: Resolver<ResolversTypes['CloudWatchLogIntegrationHealth'], ParentType, ContextType>;
  integrationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  integrationLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  integrationType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isEditable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isHealthy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPantherManaged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastEventProcessedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastEventReceivedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastModified?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  logGroup?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  logProcessingRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logProviderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logStreamTypeOptions?: Resolver<
    Maybe<ResolversTypes['LogStreamTypeOptions']>,
    ParentType,
    ContextType
  >;
  logTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  managedBucketNotifications?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  notificationsConfigurationSucceeded?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  s3Bucket?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stackName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CloudWatchLogIntegrationHealthResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CloudWatchLogIntegrationHealth'] =
    ResolversParentTypes['CloudWatchLogIntegrationHealth'],
> = {
  bucketNotificationsStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  classificationFailuresStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  logProcessingErrorsStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  processingRoleStatus?: Resolver<
    ResolversTypes['IntegrationItemHealthStatus'],
    ParentType,
    ContextType
  >;
  s3BucketStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  systemAlarmStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommentResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Comment'] = ResolversParentTypes['Comment'],
> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['Actor'], ParentType, ContextType>;
  entity?: Resolver<ResolversTypes['CommentEntity'], ParentType, ContextType>;
  format?: Resolver<ResolversTypes['CommentFormat'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommentEntityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CommentEntity'] = ResolversParentTypes['CommentEntity'],
> = {
  __resolveType: TypeResolveFn<'Alert', ParentType, ContextType>;
};

export type ComplianceIntegrationHealthResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ComplianceIntegrationHealth'] =
    ResolversParentTypes['ComplianceIntegrationHealth'],
> = {
  auditRoleStatus?: Resolver<
    ResolversTypes['IntegrationItemHealthStatus'],
    ParentType,
    ContextType
  >;
  realtimeStatus?: Resolver<ResolversTypes['IntegrationItemHealthStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ComplianceItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ComplianceItem'] =
    ResolversParentTypes['ComplianceItem'],
> = {
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  integration?: Resolver<Maybe<ResolversTypes['CloudAccount']>, ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  policyId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  policySeverity?: Resolver<Maybe<ResolversTypes['Severity']>, ParentType, ContextType>;
  resourceId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  resourceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ComplianceStatusEnum']>, ParentType, ContextType>;
  suppressed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ComplianceStatusCountsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ComplianceStatusCounts'] =
    ResolversParentTypes['ComplianceStatusCounts'],
> = {
  error?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  fail?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pass?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContinueAIConversationOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ContinueAIConversationOutput'] =
    ResolversParentTypes['ContinueAIConversationOutput'],
> = {
  streamId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CorrelationRuleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CorrelationRule'] =
    ResolversParentTypes['CorrelationRule'],
> = {
  analysisType?: Resolver<ResolversTypes['DetectionType'], ParentType, ContextType>;
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  correlationRuleReferenceIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  createAlert?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  createdByExternal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isSimpleDetection?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastModified?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  logTypes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  managed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  outputIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  parentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reports?: Resolver<Array<ResolversTypes['DetectionReportMapping']>, ParentType, ContextType>;
  runbook?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  severity?: Resolver<ResolversTypes['Severity'], ParentType, ContextType>;
  simpleDetectionBody?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summaryAttributes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  tags?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  tests?: Resolver<Array<ResolversTypes['DetectionTestDefinition']>, ParentType, ContextType>;
  userOverrides?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  versionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CorrelationRuleTestCaseRuleOutputDefinitionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CorrelationRuleTestCaseRuleOutputDefinition'] =
    ResolversParentTypes['CorrelationRuleTestCaseRuleOutputDefinition'],
> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  matches?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateAIConversationOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateAIConversationOutput'] =
    ResolversParentTypes['CreateAIConversationOutput'],
> = {
  conversation?: Resolver<ResolversTypes['AIConversation'], ParentType, ContextType>;
  streamId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateAISkillOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateAISkillOutput'] =
    ResolversParentTypes['CreateAISkillOutput'],
> = {
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  skill?: Resolver<Maybe<ResolversTypes['AISkill']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateAPITokenOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateAPITokenOutput'] =
    ResolversParentTypes['CreateAPITokenOutput'],
> = {
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['APIToken']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateAlertCommentOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateAlertCommentOutput'] =
    ResolversParentTypes['CreateAlertCommentOutput'],
> = {
  comment?: Resolver<ResolversTypes['Comment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateAzureBlobSourceOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateAzureBlobSourceOutput'] =
    ResolversParentTypes['CreateAzureBlobSourceOutput'],
> = {
  azureBlobSource?: Resolver<ResolversTypes['AzureBlobSourceIntegration'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateCloudAccountOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateCloudAccountOutput'] =
    ResolversParentTypes['CreateCloudAccountOutput'],
> = {
  cloudAccount?: Resolver<ResolversTypes['CloudAccount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateDetectionFilterOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateDetectionFilterOutput'] =
    ResolversParentTypes['CreateDetectionFilterOutput'],
> = {
  detectionFilter?: Resolver<ResolversTypes['DetectionFilter'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateGitHubAppConfigResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateGitHubAppConfigResponse'] =
    ResolversParentTypes['CreateGitHubAppConfigResponse'],
> = {
  gitHubAppConfig?: Resolver<ResolversTypes['GitHubAppConfig'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateGitHubAppRegistrationUrlResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateGitHubAppRegistrationUrlResponse'] =
    ResolversParentTypes['CreateGitHubAppRegistrationUrlResponse'],
> = {
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateOrUpdateSchemaOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateOrUpdateSchemaOutput'] =
    ResolversParentTypes['CreateOrUpdateSchemaOutput'],
> = {
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  schema?: Resolver<Maybe<ResolversTypes['Schema']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreatePullRequestResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreatePullRequestResponse'] =
    ResolversParentTypes['CreatePullRequestResponse'],
> = {
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateReplayOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateReplayOutput'] =
    ResolversParentTypes['CreateReplayOutput'],
> = {
  replay?: Resolver<ResolversTypes['Replay'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateRoleOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateRoleOutput'] =
    ResolversParentTypes['CreateRoleOutput'],
> = {
  role?: Resolver<ResolversTypes['Role'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateS3SourceOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreateS3SourceOutput'] =
    ResolversParentTypes['CreateS3SourceOutput'],
> = {
  logSource?: Resolver<ResolversTypes['S3LogIntegration'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CredentialFormFieldResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CredentialFormField'] =
    ResolversParentTypes['CredentialFormField'],
> = {
  isSensitive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  placeholder?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrowdstrikeConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CrowdstrikeConfig'] =
    ResolversParentTypes['CrowdstrikeConfig'],
> = {
  awsAccessKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  awsAccessSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  queueUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrowdstrikeEventStreamsConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CrowdstrikeEventStreamsConfig'] =
    ResolversParentTypes['CrowdstrikeEventStreamsConfig'],
> = {
  appId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientCloud?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  memberCid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CursorBasedPaginationPageInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CursorBasedPaginationPageInfo'] =
    ResolversParentTypes['CursorBasedPaginationPageInfo'],
> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomHeaderResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CustomHeader'] = ResolversParentTypes['CustomHeader'],
> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomWebhookConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CustomWebhookConfig'] =
    ResolversParentTypes['CustomWebhookConfig'],
> = {
  customHeaders?: Resolver<Maybe<Array<ResolversTypes['CustomHeader']>>, ParentType, ContextType>;
  webhookURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DashboardResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Dashboard'] = ResolversParentTypes['Dashboard'],
> = {
  createdAt?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['DashboardIcon'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inputs?: Resolver<Maybe<Array<Maybe<ResolversTypes['DashboardInput']>>>, ParentType, ContextType>;
  lastAccessedAt?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  lastUpdatedAt?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  lastUpdatedBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  previouslyHadWidgets?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  widgets?: Resolver<Maybe<Array<Maybe<ResolversTypes['Widget']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DashboardIconResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DashboardIcon'] = ResolversParentTypes['DashboardIcon'],
> = {
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DashboardIconType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DashboardInputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DashboardInput'] =
    ResolversParentTypes['DashboardInput'],
> = {
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paramName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paramType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  path?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DashboardMetadataResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DashboardMetadata'] =
    ResolversParentTypes['DashboardMetadata'],
> = {
  createdAt?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['DashboardIcon'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastAccessedAt?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  lastUpdatedAt?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  lastUpdatedBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DashboardsOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DashboardsOutput'] =
    ResolversParentTypes['DashboardsOutput'],
> = {
  dashboards?: Resolver<Array<ResolversTypes['DashboardMetadata']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['CursorBasedPaginationPageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataLakeDatabaseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataLakeDatabase'] =
    ResolversParentTypes['DataLakeDatabase'],
> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tables?: Resolver<Array<ResolversTypes['DataLakeDatabaseTable']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataLakeDatabaseTableResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataLakeDatabaseTable'] =
    ResolversParentTypes['DataLakeDatabaseTable'],
> = {
  columns?: Resolver<Array<ResolversTypes['DataLakeDatabaseTableColumn']>, ParentType, ContextType>;
  databaseName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  numMatches?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataLakeDatabaseTableColumnResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataLakeDatabaseTableColumn'] =
    ResolversParentTypes['DataLakeDatabaseTableColumn'],
> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  properties?: Resolver<
    Array<ResolversTypes['DataLakePropertyDefinition']>,
    ParentType,
    ContextType
  >;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataLakeDatabaseTablesEdgesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataLakeDatabaseTablesEdges'] =
    ResolversParentTypes['DataLakeDatabaseTablesEdges'],
> = {
  node?: Resolver<ResolversTypes['DataLakeDatabaseTable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataLakeDatabaseTablesOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataLakeDatabaseTablesOutput'] =
    ResolversParentTypes['DataLakeDatabaseTablesOutput'],
> = {
  edges?: Resolver<Array<ResolversTypes['DataLakeDatabaseTablesEdges']>, ParentType, ContextType>;
  pageInfo?: Resolver<
    ResolversTypes['DataLakeDatabaseTablesOutputPageInfo'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataLakeDatabaseTablesOutputPageInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataLakeDatabaseTablesOutputPageInfo'] =
    ResolversParentTypes['DataLakeDatabaseTablesOutputPageInfo'],
> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataLakeListDefinitionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataLakeListDefinition'] =
    ResolversParentTypes['DataLakeListDefinition'],
> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataLakePropertyDefinitionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataLakePropertyDefinition'] =
    ResolversParentTypes['DataLakePropertyDefinition'],
> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isPantherField?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Maybe<ResolversTypes['DataLakeListDefinition']>, ParentType, ContextType>;
  path?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  table?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataLakePropertyDefinitionsOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataLakePropertyDefinitionsOutput'] =
    ResolversParentTypes['DataLakePropertyDefinitionsOutput'],
> = {
  edges?: Resolver<
    Array<ResolversTypes['DataLakePropertyDefinitionsOutputEdge']>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['CursorBasedPaginationPageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataLakePropertyDefinitionsOutputEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataLakePropertyDefinitionsOutputEdge'] =
    ResolversParentTypes['DataLakePropertyDefinitionsOutputEdge'],
> = {
  node?: Resolver<ResolversTypes['DataLakePropertyDefinition'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataLakePropertySummaryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataLakePropertySummary'] =
    ResolversParentTypes['DataLakePropertySummary'],
> = {
  entries?: Resolver<
    Array<ResolversTypes['DataLakePropertySummaryEntry']>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['CursorBasedPaginationPageInfo'], ParentType, ContextType>;
  queryId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['DataLakeQueryStatus'], ParentType, ContextType>;
  totalEntryCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataLakePropertySummaryEntryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataLakePropertySummaryEntry'] =
    ResolversParentTypes['DataLakePropertySummaryEntry'],
> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataLakeQueriesOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataLakeQueriesOutput'] =
    ResolversParentTypes['DataLakeQueriesOutput'],
> = {
  edges?: Resolver<Array<ResolversTypes['DataLakeQueryEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['DataLakeQueriesOutputPageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataLakeQueriesOutputPageInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataLakeQueriesOutputPageInfo'] =
    ResolversParentTypes['DataLakeQueriesOutputPageInfo'],
> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataLakeQueryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataLakeQuery'] = ResolversParentTypes['DataLakeQuery'],
> = {
  annotations?: Resolver<Maybe<ResolversTypes['Annotations']>, ParentType, ContextType>;
  children?: Resolver<Array<ResolversTypes['DataLakeQuery']>, ParentType, ContextType>;
  completedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isScheduled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  issuedBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  results?: Resolver<
    Maybe<ResolversTypes['DataLakeQueryResults']>,
    ParentType,
    ContextType,
    Partial<DataLakeQueryResultsArgs>
  >;
  sql?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['DataLakeQueryStatus'], ParentType, ContextType>;
  userConfig?: Resolver<Maybe<ResolversTypes['QueryUserConfig']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataLakeQueryEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataLakeQueryEdge'] =
    ResolversParentTypes['DataLakeQueryEdge'],
> = {
  node?: Resolver<ResolversTypes['DataLakeQuery'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataLakeQueryResultEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataLakeQueryResultEdge'] =
    ResolversParentTypes['DataLakeQueryResultEdge'],
> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  nodeAsString?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataLakeQueryResultRecordsPageInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataLakeQueryResultRecordsPageInfo'] =
    ResolversParentTypes['DataLakeQueryResultRecordsPageInfo'],
> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataLakeQueryResultsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataLakeQueryResults'] =
    ResolversParentTypes['DataLakeQueryResults'],
> = {
  columnInfo?: Resolver<ResolversTypes['DataLakeQueryResultsColumnInfo'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['DataLakeQueryResultEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<
    ResolversTypes['DataLakeQueryResultRecordsPageInfo'],
    ParentType,
    ContextType
  >;
  stats?: Resolver<ResolversTypes['DataLakeQueryStats'], ParentType, ContextType>;
  tryAgain?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  warningMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataLakeQueryResultsColumnInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataLakeQueryResultsColumnInfo'] =
    ResolversParentTypes['DataLakeQueryResultsColumnInfo'],
> = {
  order?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  types?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataLakeQueryStatsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataLakeQueryStats'] =
    ResolversParentTypes['DataLakeQueryStats'],
> = {
  bytesScanned?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  executionTime?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  rowCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataLakeQueryVisualizationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataLakeQueryVisualization'] =
    ResolversParentTypes['DataLakeQueryVisualization'],
> = {
  annotations?: Resolver<Maybe<ResolversTypes['Annotations']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  results?: Resolver<
    Maybe<ResolversTypes['DataLakeQueryVisualizationResults']>,
    ParentType,
    ContextType,
    Partial<DataLakeQueryVisualizationResultsArgs>
  >;
  status?: Resolver<ResolversTypes['DataLakeQueryStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataLakeQueryVisualizationResultsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataLakeQueryVisualizationResults'] =
    ResolversParentTypes['DataLakeQueryVisualizationResults'],
> = {
  columns?: Resolver<
    Array<ResolversTypes['DataLakeQueryVisualizationResultsColumn']>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<
    ResolversTypes['DataLakeQueryResultRecordsPageInfo'],
    ParentType,
    ContextType
  >;
  rows?: Resolver<
    Array<ResolversTypes['DataLakeQueryVisualizationResultsRow']>,
    ParentType,
    ContextType
  >;
  stats?: Resolver<ResolversTypes['DataLakeQueryStats'], ParentType, ContextType>;
  tryAgain?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataLakeQueryVisualizationResultsColumnResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataLakeQueryVisualizationResultsColumn'] =
    ResolversParentTypes['DataLakeQueryVisualizationResultsColumn'],
> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ColumnType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataLakeQueryVisualizationResultsRowResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataLakeQueryVisualizationResultsRow'] =
    ResolversParentTypes['DataLakeQueryVisualizationResultsRow'],
> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  item?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataModelResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataModel'] = ResolversParentTypes['DataModel'],
> = {
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastModified?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  logTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  managed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  mappings?: Resolver<Array<ResolversTypes['DataModelMapping']>, ParentType, ContextType>;
  parentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataModelMappingResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataModelMapping'] =
    ResolversParentTypes['DataModelMapping'],
> = {
  method?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataWindowResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DataWindow'] = ResolversParentTypes['DataWindow'],
> = {
  sizeWindow?: Resolver<Maybe<ResolversTypes['SizeWindow']>, ParentType, ContextType>;
  timeWindow?: Resolver<Maybe<ResolversTypes['TimeWindow']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DatabaseAndTableResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DatabaseAndTable'] =
    ResolversParentTypes['DatabaseAndTable'],
> = {
  databaseName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tableName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DatalakeFieldValuesOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DatalakeFieldValuesOutput'] =
    ResolversParentTypes['DatalakeFieldValuesOutput'],
> = {
  values?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DatalakeSchemaColumnEntityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DatalakeSchemaColumnEntity'] =
    ResolversParentTypes['DatalakeSchemaColumnEntity'],
> = {
  database?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  table?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DatalakeSchemaDatalakeEntityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DatalakeSchemaDatalakeEntity'] =
    ResolversParentTypes['DatalakeSchemaDatalakeEntity'],
> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DatalakeSchemaEntityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DatalakeSchemaEntity'] =
    ResolversParentTypes['DatalakeSchemaEntity'],
> = {
  __resolveType: TypeResolveFn<
    | 'DatalakeSchemaColumnEntity'
    | 'DatalakeSchemaDatalakeEntity'
    | 'DatalakeSchemaPropertyEntity'
    | 'DatalakeSchemaTableEntity',
    ParentType,
    ContextType
  >;
};

export type DatalakeSchemaPropertyResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DatalakeSchemaProperty'] =
    ResolversParentTypes['DatalakeSchemaProperty'],
> = {
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isPantherField?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  path?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  schemaType?: Resolver<ResolversTypes['SchemaValueType'], ParentType, ContextType>;
  tables?: Resolver<Array<ResolversTypes['DatabaseAndTable']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  typeOfItems?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DatalakeSchemaPropertyEntityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DatalakeSchemaPropertyEntity'] =
    ResolversParentTypes['DatalakeSchemaPropertyEntity'],
> = {
  column?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  database?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isPantherField?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Maybe<ResolversTypes['DataLakeListDefinition']>, ParentType, ContextType>;
  path?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  table?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DatalakeSchemaTableEntityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DatalakeSchemaTableEntity'] =
    ResolversParentTypes['DatalakeSchemaTableEntity'],
> = {
  database?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  logType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DateRangeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DateRange'] = ResolversParentTypes['DateRange'],
> = {
  from?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<
  ResolversTypes['DateTime'],
  any
> {
  name: 'DateTime';
}

export type DeleteAISkillOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DeleteAISkillOutput'] =
    ResolversParentTypes['DeleteAISkillOutput'],
> = {
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteAPITokenOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DeleteAPITokenOutput'] =
    ResolversParentTypes['DeleteAPITokenOutput'],
> = {
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['APIToken']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteCloudAccountOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DeleteCloudAccountOutput'] =
    ResolversParentTypes['DeleteCloudAccountOutput'],
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteDetectionsOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DeleteDetectionsOutput'] =
    ResolversParentTypes['DeleteDetectionsOutput'],
> = {
  ids?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  savedQueryNames?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteRoleOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DeleteRoleOutput'] =
    ResolversParentTypes['DeleteRoleOutput'],
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteSavedQueriesByNameOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DeleteSavedQueriesByNameOutput'] =
    ResolversParentTypes['DeleteSavedQueriesByNameOutput'],
> = {
  detectionIDs?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  names?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteSourceOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DeleteSourceOutput'] =
    ResolversParentTypes['DeleteSourceOutput'],
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteUserOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DeleteUserOutput'] =
    ResolversParentTypes['DeleteUserOutput'],
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeletedDetectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DeletedDetection'] =
    ResolversParentTypes['DeletedDetection'],
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DestinationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Destination'] = ResolversParentTypes['Destination'],
> = {
  alertTypes?: Resolver<Array<ResolversTypes['AlertType']>, ParentType, ContextType>;
  allowManualDispatch?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  apiToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  creationTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  defaultForSeverity?: Resolver<Array<Maybe<ResolversTypes['Severity']>>, ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  lastModifiedTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  logTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  outputConfig?: Resolver<ResolversTypes['DestinationConfig'], ParentType, ContextType>;
  outputId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  outputType?: Resolver<ResolversTypes['DestinationTypeEnum'], ParentType, ContextType>;
  verificationStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DestinationConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DestinationConfig'] =
    ResolversParentTypes['DestinationConfig'],
> = {
  asana?: Resolver<Maybe<ResolversTypes['AsanaConfig']>, ParentType, ContextType>;
  blinkOpsWebhook?: Resolver<
    Maybe<ResolversTypes['BlinkOpsWebhookConfig']>,
    ParentType,
    ContextType
  >;
  customWebhook?: Resolver<Maybe<ResolversTypes['CustomWebhookConfig']>, ParentType, ContextType>;
  discord?: Resolver<Maybe<ResolversTypes['DiscordConfig']>, ParentType, ContextType>;
  expelWebhook?: Resolver<Maybe<ResolversTypes['ExpelWebhookConfig']>, ParentType, ContextType>;
  gcpPubSub?: Resolver<
    Maybe<ResolversTypes['GcpPubSubDestinationConfig']>,
    ParentType,
    ContextType
  >;
  github?: Resolver<Maybe<ResolversTypes['GithubConfig']>, ParentType, ContextType>;
  incidentIoWebhook?: Resolver<
    Maybe<ResolversTypes['IncidentIoWebhookConfig']>,
    ParentType,
    ContextType
  >;
  jira?: Resolver<Maybe<ResolversTypes['JiraConfig']>, ParentType, ContextType>;
  jiraDataCenter?: Resolver<Maybe<ResolversTypes['JiraConfig']>, ParentType, ContextType>;
  mindflowWebhook?: Resolver<
    Maybe<ResolversTypes['MindflowWebhookConfig']>,
    ParentType,
    ContextType
  >;
  msTeams?: Resolver<Maybe<ResolversTypes['MsTeamsConfig']>, ParentType, ContextType>;
  opsgenie?: Resolver<Maybe<ResolversTypes['OpsgenieConfig']>, ParentType, ContextType>;
  pagerDuty?: Resolver<Maybe<ResolversTypes['PagerDutyConfig']>, ParentType, ContextType>;
  rapid7InsightConnect?: Resolver<
    Maybe<ResolversTypes['Rapid7InsightConnectConfig']>,
    ParentType,
    ContextType
  >;
  slack?: Resolver<Maybe<ResolversTypes['SlackConfig']>, ParentType, ContextType>;
  slackBot?: Resolver<Maybe<ResolversTypes['SlackBotConfig']>, ParentType, ContextType>;
  sns?: Resolver<Maybe<ResolversTypes['SnsConfig']>, ParentType, ContextType>;
  splunkWebhook?: Resolver<Maybe<ResolversTypes['SplunkWebhookConfig']>, ParentType, ContextType>;
  sqs?: Resolver<Maybe<ResolversTypes['SqsDestinationConfig']>, ParentType, ContextType>;
  tinesWebhook?: Resolver<Maybe<ResolversTypes['TinesWebhookConfig']>, ParentType, ContextType>;
  torqWebhook?: Resolver<Maybe<ResolversTypes['TorqWebhookConfig']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DetectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Detection'] = ResolversParentTypes['Detection'],
> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DetectionType'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DetectionAlertMetricsOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DetectionAlertMetricsOutput'] =
    ResolversParentTypes['DetectionAlertMetricsOutput'],
> = {
  detectionAlerts?: Resolver<Array<ResolversTypes['SeriesWithBreakdown']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DetectionEntitiesUploadStatusOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DetectionEntitiesUploadStatusOutput'] =
    ResolversParentTypes['DetectionEntitiesUploadStatusOutput'],
> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mode?: Resolver<ResolversTypes['UploadDetectionEntitiesMode'], ParentType, ContextType>;
  result?: Resolver<
    Maybe<ResolversTypes['UploadDetectionEntitiesOutput']>,
    ParentType,
    ContextType
  >;
  status?: Resolver<ResolversTypes['UploadStatus'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DetectionFilterResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DetectionFilter'] =
    ResolversParentTypes['DetectionFilter'],
> = {
  detectionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  statement?: Resolver<Maybe<ResolversTypes['DetectionFilterStatement']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DetectionFilterConditionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DetectionFilterCondition'] =
    ResolversParentTypes['DetectionFilterCondition'],
> = {
  operator?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  target?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetTypeHint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DetectionFilterStatementResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DetectionFilterStatement'] =
    ResolversParentTypes['DetectionFilterStatement'],
> = {
  and?: Resolver<Maybe<Array<ResolversTypes['DetectionFilterStatement']>>, ParentType, ContextType>;
  condition?: Resolver<Maybe<ResolversTypes['DetectionFilterCondition']>, ParentType, ContextType>;
  not?: Resolver<Maybe<Array<ResolversTypes['DetectionFilterStatement']>>, ParentType, ContextType>;
  or?: Resolver<Maybe<Array<ResolversTypes['DetectionFilterStatement']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DetectionReportEntryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DetectionReportEntry'] =
    ResolversParentTypes['DetectionReportEntry'],
> = {
  __resolveType: TypeResolveFn<'MitreReportEntry' | 'StandardReportEntry', ParentType, ContextType>;
};

export type DetectionReportMappingResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DetectionReportMapping'] =
    ResolversParentTypes['DetectionReportMapping'],
> = {
  entries?: Resolver<Maybe<Array<ResolversTypes['DetectionReportEntry']>>, ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DetectionStatsDetectionTypeCountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DetectionStatsDetectionTypeCount'] =
    ResolversParentTypes['DetectionStatsDetectionTypeCount'],
> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  detectionType?: Resolver<ResolversTypes['DetectionType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DetectionStatsEnabledStateCountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DetectionStatsEnabledStateCount'] =
    ResolversParentTypes['DetectionStatsEnabledStateCount'],
> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DetectionStatsResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DetectionStatsResponse'] =
    ResolversParentTypes['DetectionStatsResponse'],
> = {
  detectionTypeCounts?: Resolver<
    Array<ResolversTypes['DetectionStatsDetectionTypeCount']>,
    ParentType,
    ContextType
  >;
  enabledCounts?: Resolver<
    Array<ResolversTypes['DetectionStatsEnabledStateCount']>,
    ParentType,
    ContextType
  >;
  severityCounts?: Resolver<
    Array<ResolversTypes['DetectionStatsSeverityCount']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DetectionStatsSeverityCountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DetectionStatsSeverityCount'] =
    ResolversParentTypes['DetectionStatsSeverityCount'],
> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  severity?: Resolver<ResolversTypes['Severity'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DetectionTestDefinitionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DetectionTestDefinition'] =
    ResolversParentTypes['DetectionTestDefinition'],
> = {
  expectedResult?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mocks?: Resolver<
    Maybe<Array<ResolversTypes['DetectionTestMockDefinition']>>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resource?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ruleOutputs?: Resolver<
    Maybe<Array<ResolversTypes['CorrelationRuleTestCaseRuleOutputDefinition']>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DetectionTestDefinitionProtectedResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DetectionTestDefinitionProtected'] =
    ResolversParentTypes['DetectionTestDefinitionProtected'],
> = {
  expectedResult?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mocks?: Resolver<
    Maybe<Array<ResolversTypes['DetectionTestMockDefinitionProtected']>>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resource?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DetectionTestMockDefinitionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DetectionTestMockDefinition'] =
    ResolversParentTypes['DetectionTestMockDefinition'],
> = {
  objectName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  returnValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DetectionTestMockDefinitionProtectedResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DetectionTestMockDefinitionProtected'] =
    ResolversParentTypes['DetectionTestMockDefinitionProtected'],
> = {
  objectName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  returnValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DetectionUpdateErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DetectionUpdateError'] =
    ResolversParentTypes['DetectionUpdateError'],
> = {
  detectionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  error?: Resolver<ResolversTypes['Error'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscordConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DiscordConfig'] = ResolversParentTypes['DiscordConfig'],
> = {
  webhookURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscoverTaxiiCollectionsOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DiscoverTaxiiCollectionsOutput'] =
    ResolversParentTypes['DiscoverTaxiiCollectionsOutput'],
> = {
  collections?: Resolver<
    Array<ResolversTypes['DiscoveredTaxiiCollection']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscoveredTaxiiCollectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DiscoveredTaxiiCollection'] =
    ResolversParentTypes['DiscoveredTaxiiCollection'],
> = {
  alias?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  collectionUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DraftSchemaResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DraftSchema'] = ResolversParentTypes['DraftSchema'],
> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  referenceURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  spec?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DuoConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DuoConfig'] = ResolversParentTypes['DuoConfig'],
> = {
  apiHostname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  integrationKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  secretKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface EmailScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Email'], any> {
  name: 'Email';
}

export type EmailConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EmailConfig'] = ResolversParentTypes['EmailConfig'],
> = {
  preferAttachment?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  recipients?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  sendEmpty?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrichmentIntegrationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EnrichmentIntegration'] =
    ResolversParentTypes['EnrichmentIntegration'],
> = {
  config?: Resolver<ResolversTypes['EnrichmentIntegrationConfig'], ParentType, ContextType>;
  createdAtTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  disabledAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  enabledAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  health?: Resolver<ResolversTypes['EnrichmentIntegrationHealth'], ParentType, ContextType>;
  integrationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  integrationLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastModified?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrichmentIntegrationConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EnrichmentIntegrationConfig'] =
    ResolversParentTypes['EnrichmentIntegrationConfig'],
> = {
  anomali?: Resolver<Maybe<ResolversTypes['AnomaliConfig']>, ParentType, ContextType>;
  greynoise?: Resolver<Maybe<ResolversTypes['GreyNoiseConfig']>, ParentType, ContextType>;
  gtiIoCStream?: Resolver<Maybe<ResolversTypes['GtiIoCStreamConfig']>, ParentType, ContextType>;
  otx?: Resolver<Maybe<ResolversTypes['OTXConfig']>, ParentType, ContextType>;
  taxii?: Resolver<Maybe<ResolversTypes['TaxiiConfig']>, ParentType, ContextType>;
  virustotalIoCStream?: Resolver<
    Maybe<ResolversTypes['VirusTotalIoCStreamConfig']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrichmentIntegrationHealthResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EnrichmentIntegrationHealth'] =
    ResolversParentTypes['EnrichmentIntegrationHealth'],
> = {
  profilePullingStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Error'] = ResolversParentTypes['Error'],
> = {
  code?: Resolver<Maybe<ResolversTypes['ErrorCode']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventBridgeConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EventBridgeConfig'] =
    ResolversParentTypes['EventBridgeConfig'],
> = {
  busNames?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  includeEventType?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventBridgeIntegrationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EventBridgeIntegration'] =
    ResolversParentTypes['EventBridgeIntegration'],
> = {
  alarms?: Resolver<ResolversTypes['LogIntegrationAlarms'], ParentType, ContextType>;
  createdAtTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  eventbridgeConfig?: Resolver<ResolversTypes['EventBridgeConfig'], ParentType, ContextType>;
  filters?: Resolver<ResolversTypes['SourceFilters'], ParentType, ContextType>;
  health?: Resolver<ResolversTypes['EventBridgeIntegrationHealth'], ParentType, ContextType>;
  integrationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  integrationLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  integrationType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isEditable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isHealthy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPantherManaged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastEventProcessedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastEventReceivedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastModified?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  logProviderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventBridgeIntegrationHealthResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EventBridgeIntegrationHealth'] =
    ResolversParentTypes['EventBridgeIntegrationHealth'],
> = {
  classificationFailuresStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  eventBridgeStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  logProcessingErrorsStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  systemAlarmStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventFilterResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EventFilter'] = ResolversParentTypes['EventFilter'],
> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expression?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  logType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mode?: Resolver<ResolversTypes['FilterMode'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventThresholdAlarmResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EventThresholdAlarm'] =
    ResolversParentTypes['EventThresholdAlarm'],
> = {
  minutesThreshold?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventbridgeOptionsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EventbridgeOptions'] =
    ResolversParentTypes['EventbridgeOptions'],
> = {
  hasMultipleBuses?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  includeEventType?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExecuteDataLakeQueryOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ExecuteDataLakeQueryOutput'] =
    ResolversParentTypes['ExecuteDataLakeQueryOutput'],
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExecuteIndicatorSearchQueryOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ExecuteIndicatorSearchQueryOutput'] =
    ResolversParentTypes['ExecuteIndicatorSearchQueryOutput'],
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExecuteSimpleSearchQueryOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ExecuteSimpleSearchQueryOutput'] =
    ResolversParentTypes['ExecuteSimpleSearchQueryOutput'],
> = {
  logsQueryID?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExecuteUberSearchOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ExecuteUberSearchOutput'] =
    ResolversParentTypes['ExecuteUberSearchOutput'],
> = {
  annotations?: Resolver<Maybe<ResolversTypes['Annotations']>, ParentType, ContextType>;
  queryID?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExecuteUberSearchPropertySummaryOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ExecuteUberSearchPropertySummaryOutput'] =
    ResolversParentTypes['ExecuteUberSearchPropertySummaryOutput'],
> = {
  queryId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['DataLakeQueryStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExpelWebhookConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ExpelWebhookConfig'] =
    ResolversParentTypes['ExpelWebhookConfig'],
> = {
  webhookPassword?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  webhookURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  webhookUsername?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeatureFlagTreatmentResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FeatureFlagTreatment'] =
    ResolversParentTypes['FeatureFlagTreatment'],
> = {
  flag?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  treatment?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FilterFieldResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FilterField'] = ResolversParentTypes['FilterField'],
> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isPantherManaged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  logType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  target?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FilterFieldsOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FilterFieldsOutput'] =
    ResolversParentTypes['FilterFieldsOutput'],
> = {
  filtersByLogType?: Resolver<Array<ResolversTypes['GroupedFilterField']>, ParentType, ContextType>;
  pantherManaged?: Resolver<Array<ResolversTypes['FilterField']>, ParentType, ContextType>;
  shared?: Resolver<Array<ResolversTypes['FilterField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlatFilterFieldsOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FlatFilterFieldsOutput'] =
    ResolversParentTypes['FlatFilterFieldsOutput'],
> = {
  flatFields?: Resolver<Array<ResolversTypes['FilterField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GcpPubSubConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GcpPubSubConfig'] =
    ResolversParentTypes['GcpPubSubConfig'],
> = {
  credentials?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  credentialsType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  enforcedRegionalEndpoint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscriptionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GcpPubSubDestinationConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GcpPubSubDestinationConfig'] =
    ResolversParentTypes['GcpPubSubDestinationConfig'],
> = {
  credentials?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  credentialsType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  topicId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GcpPubSubLogIntegrationHealthResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GcpPubSubLogIntegrationHealth'] =
    ResolversParentTypes['GcpPubSubLogIntegrationHealth'],
> = {
  classificationFailuresStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  gcpPubSubStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  logProcessingErrorsStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  systemAlarmStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GcpPubSubLogSourceIntegrationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GcpPubSubLogSourceIntegration'] =
    ResolversParentTypes['GcpPubSubLogSourceIntegration'],
> = {
  alarms?: Resolver<ResolversTypes['LogIntegrationAlarms'], ParentType, ContextType>;
  createdAtTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  filters?: Resolver<ResolversTypes['SourceFilters'], ParentType, ContextType>;
  gcpPubSubConfig?: Resolver<ResolversTypes['GcpPubSubConfig'], ParentType, ContextType>;
  health?: Resolver<ResolversTypes['GcpPubSubLogIntegrationHealth'], ParentType, ContextType>;
  integrationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  integrationLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  integrationType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isEditable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isHealthy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPantherManaged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastEventProcessedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastEventReceivedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastModified?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  logProviderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logStreamType?: Resolver<Maybe<ResolversTypes['LogStreamType']>, ParentType, ContextType>;
  logStreamTypeOptions?: Resolver<
    Maybe<ResolversTypes['LogStreamTypeOptions']>,
    ParentType,
    ContextType
  >;
  logTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GcsConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GcsConfig'] = ResolversParentTypes['GcsConfig'],
> = {
  credentials?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  credentialsType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  gcsBucket?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prefixLogTypes?: Resolver<Array<ResolversTypes['S3PrefixLogTypes']>, ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscriptionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GcsLogIntegrationHealthResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GcsLogIntegrationHealth'] =
    ResolversParentTypes['GcsLogIntegrationHealth'],
> = {
  classificationFailuresStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  gcsStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  logProcessingErrorsStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  systemAlarmStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GcsLogSourceIntegrationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GcsLogSourceIntegration'] =
    ResolversParentTypes['GcsLogSourceIntegration'],
> = {
  alarms?: Resolver<ResolversTypes['LogIntegrationAlarms'], ParentType, ContextType>;
  createdAtTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  filters?: Resolver<ResolversTypes['SourceFilters'], ParentType, ContextType>;
  gcsConfig?: Resolver<ResolversTypes['GcsConfig'], ParentType, ContextType>;
  health?: Resolver<ResolversTypes['GcsLogIntegrationHealth'], ParentType, ContextType>;
  integrationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  integrationLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  integrationType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isEditable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isHealthy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPantherManaged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastEventProcessedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastEventReceivedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastModified?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  logProviderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logStreamType?: Resolver<Maybe<ResolversTypes['LogStreamType']>, ParentType, ContextType>;
  logStreamTypeOptions?: Resolver<
    Maybe<ResolversTypes['LogStreamTypeOptions']>,
    ParentType,
    ContextType
  >;
  logTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeneralSettingsConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GeneralSettingsConfig'] =
    ResolversParentTypes['GeneralSettingsConfig'],
> = {
  analyticsConsent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  databricksRoleArn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deltaAdminRoleArn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deltaControllerRoleArn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  infrastructureInfo?: Resolver<
    Maybe<ResolversTypes['InfrastructureInfo']>,
    ParentType,
    ContextType
  >;
  licenseAccepted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lookupTableQueryExportS3Path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lookupTablesLambdaRoleArn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pantherAIAutoResolve?: Resolver<
    Maybe<ResolversTypes['PantherAIAutoResolveConfig']>,
    ParentType,
    ContextType
  >;
  pantherAIAutoRunOnAlert?: Resolver<
    Maybe<ResolversTypes['PantherAIAutoRunOnAlertConfig']>,
    ParentType,
    ContextType
  >;
  pantherAICustomerPrompt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pantherAIEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  pantherAIKendra?: Resolver<
    Maybe<ResolversTypes['PantherAIKendraConfig']>,
    ParentType,
    ContextType
  >;
  pantherAIRemoteMcp?: Resolver<
    Maybe<ResolversTypes['PantherAIRemoteMCPConfig']>,
    ParentType,
    ContextType
  >;
  pantherAIWebTool?: Resolver<
    Maybe<ResolversTypes['PantherAIWebToolConfig']>,
    ParentType,
    ContextType
  >;
  pantherVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  processedDataBucket?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  publicAPIRootDomain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  publicGraphqlAPIEndpoint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  publicRestAPIEndpoint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  publicScimAPIEndpoint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  publicWebhookAPIEndpoint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scheduledQueriesRequireLimitClause?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  shouldEmailAlertAssignees?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  snowflakeAdminLambdaRoleArn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  snowflakeReadonlyLambdaRoleArn?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  timezone?: Resolver<Maybe<ResolversTypes['Timezone']>, ParentType, ContextType>;
  usesPAT?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenerateEnrichedEventResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GenerateEnrichedEventResponse'] =
    ResolversParentTypes['GenerateEnrichedEventResponse'],
> = {
  enrichedEvent?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenerateS3SampleUploadResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GenerateS3SampleUploadResponse'] =
    ResolversParentTypes['GenerateS3SampleUploadResponse'],
> = {
  sessionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uploadURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenerateSchemaFromSqlJobResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GenerateSchemaFromSqlJob'] =
    ResolversParentTypes['GenerateSchemaFromSqlJob'],
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  spec?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['JobStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenerateSimpleSearchQueryOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GenerateSimpleSearchQueryOutput'] =
    ResolversParentTypes['GenerateSimpleSearchQueryOutput'],
> = {
  sql?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenerateSqlQuerySnippetOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GenerateSqlQuerySnippetOutput'] =
    ResolversParentTypes['GenerateSqlQuerySnippetOutput'],
> = {
  sqlQuery?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenerateUberSearchQueryOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GenerateUberSearchQueryOutput'] =
    ResolversParentTypes['GenerateUberSearchQueryOutput'],
> = {
  query?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenericGitConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GenericGitConfig'] =
    ResolversParentTypes['GenericGitConfig'],
> = {
  universalGitConfig?: Resolver<ResolversTypes['UniversalGitConfig'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenericPullerAuthenticationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GenericPullerAuthentication'] =
    ResolversParentTypes['GenericPullerAuthentication'],
> = {
  strategy?: Resolver<ResolversTypes['APIAuthType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenericPullerConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GenericPullerConfig'] =
    ResolversParentTypes['GenericPullerConfig'],
> = {
  pullerParams?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  pullerStrategyConfig?: Resolver<
    ResolversTypes['GenericPullerStrategyConfig'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenericPullerExpectedParamResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GenericPullerExpectedParam'] =
    ResolversParentTypes['GenericPullerExpectedParam'],
> = {
  isSensitive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenericPullerGeneralSettingsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GenericPullerGeneralSettings'] =
    ResolversParentTypes['GenericPullerGeneralSettings'],
> = {
  backfillPeriod?: Resolver<ResolversTypes['GenericPullerTimeUnit'], ParentType, ContextType>;
  delay?: Resolver<ResolversTypes['GenericPullerTimeUnit'], ParentType, ContextType>;
  maxQueryWindow?: Resolver<ResolversTypes['GenericPullerTimeUnit'], ParentType, ContextType>;
  minQueryWindow?: Resolver<
    Maybe<ResolversTypes['GenericPullerTimeUnit']>,
    ParentType,
    ContextType
  >;
  timeFormat?: Resolver<ResolversTypes['TimeFormat'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenericPullerPaginationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GenericPullerPagination'] =
    ResolversParentTypes['GenericPullerPagination'],
> = {
  settings?: Resolver<
    Maybe<ResolversTypes['GenericPullerPaginationSettings']>,
    ParentType,
    ContextType
  >;
  strategy?: Resolver<ResolversTypes['APIPaginationStrategy'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenericPullerPaginationSettingsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GenericPullerPaginationSettings'] =
    ResolversParentTypes['GenericPullerPaginationSettings'],
> = {
  pageSize?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenericPullerResponseParsingResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GenericPullerResponseParsing'] =
    ResolversParentTypes['GenericPullerResponseParsing'],
> = {
  paginationPath?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  resultPaths?: Resolver<Array<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenericPullerStrategyConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GenericPullerStrategyConfig'] =
    ResolversParentTypes['GenericPullerStrategyConfig'],
> = {
  authentication?: Resolver<ResolversTypes['GenericPullerAuthentication'], ParentType, ContextType>;
  expectedParams?: Resolver<
    Maybe<Array<ResolversTypes['GenericPullerExpectedParam']>>,
    ParentType,
    ContextType
  >;
  generalSettings?: Resolver<
    ResolversTypes['GenericPullerGeneralSettings'],
    ParentType,
    ContextType
  >;
  headers?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['GenericPullerPagination'], ParentType, ContextType>;
  queryStringParams?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  responseParsing?: Resolver<
    ResolversTypes['GenericPullerResponseParsing'],
    ParentType,
    ContextType
  >;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenericPullerTimeUnitResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GenericPullerTimeUnit'] =
    ResolversParentTypes['GenericPullerTimeUnit'],
> = {
  unit?: Resolver<ResolversTypes['TimeUnit'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetAPITokenOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GetAPITokenOutput'] =
    ResolversParentTypes['GetAPITokenOutput'],
> = {
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['APIToken']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetAsyncQueryDownloadUrlOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GetAsyncQueryDownloadUrlOutput'] =
    ResolversParentTypes['GetAsyncQueryDownloadUrlOutput'],
> = {
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetAvailableLogProviderResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GetAvailableLogProviderResponse'] =
    ResolversParentTypes['GetAvailableLogProviderResponse'],
> = {
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['AvailableLogProvider']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetDetectionResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GetDetectionResponse'] =
    ResolversParentTypes['GetDetectionResponse'],
> = {
  detection?: Resolver<ResolversTypes['InternalDetection'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetFeatureFlagsResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GetFeatureFlagsResponse'] =
    ResolversParentTypes['GetFeatureFlagsResponse'],
> = {
  flags?: Resolver<Array<ResolversTypes['FeatureFlagTreatment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetSampleDataResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GetSampleDataResponse'] =
    ResolversParentTypes['GetSampleDataResponse'],
> = {
  data?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetSchemaOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GetSchemaOutput'] =
    ResolversParentTypes['GetSchemaOutput'],
> = {
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  schema?: Resolver<Maybe<ResolversTypes['Schema']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GitHubAppConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GitHubAppConfig'] =
    ResolversParentTypes['GitHubAppConfig'],
> = {
  installationID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  readBranch?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  repository?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  universalGitConfig?: Resolver<ResolversTypes['UniversalGitConfig'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GithubConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GithubConfig'] = ResolversParentTypes['GithubConfig'],
> = {
  repoName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GithubLogSourceConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GithubLogSourceConfig'] =
    ResolversParentTypes['GithubLogSourceConfig'],
> = {
  authorizationMethod?: Resolver<
    ResolversTypes['GithubAuthorizationMethodEnum'],
    ParentType,
    ContextType
  >;
  credentials?: Resolver<
    ResolversTypes['GithubLogSourceCredentialsConfig'],
    ParentType,
    ContextType
  >;
  organization?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GithubLogSourceCredentialsConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GithubLogSourceCredentialsConfig'] =
    ResolversParentTypes['GithubLogSourceCredentialsConfig'],
> = {
  __resolveType: TypeResolveFn<
    'GithubLogSourceOAuth2Config' | 'GithubLogSourcePatConfig',
    ParentType,
    ContextType
  >;
};

export type GithubLogSourceOAuth2ConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GithubLogSourceOAuth2Config'] =
    ResolversParentTypes['GithubLogSourceOAuth2Config'],
> = {
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GithubLogSourcePatConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GithubLogSourcePatConfig'] =
    ResolversParentTypes['GithubLogSourcePatConfig'],
> = {
  personalAccessToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GlobalHelperResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GlobalHelper'] = ResolversParentTypes['GlobalHelper'],
> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastModified?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  managed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  parentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GreyNoiseConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GreyNoiseConfig'] =
    ResolversParentTypes['GreyNoiseConfig'],
> = {
  apiKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profilePullers?: Resolver<
    ResolversTypes['GreyNoiseProfilePullerConfig'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GreyNoiseProfilePullerConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GreyNoiseProfilePullerConfig'] =
    ResolversParentTypes['GreyNoiseProfilePullerConfig'],
> = {
  noise?: Resolver<ResolversTypes['ProfilePullerConfig'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupedFilterFieldResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GroupedFilterField'] =
    ResolversParentTypes['GroupedFilterField'],
> = {
  filters?: Resolver<Array<ResolversTypes['FilterField']>, ParentType, ContextType>;
  logType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GsuiteConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GsuiteConfig'] = ResolversParentTypes['GsuiteConfig'],
> = {
  applications?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  authorizationMethod?: Resolver<
    ResolversTypes['GsuiteAuthorizationMethodEnum'],
    ParentType,
    ContextType
  >;
  credentials?: Resolver<ResolversTypes['GsuiteCredentialsConfig'], ParentType, ContextType>;
  profilePullers?: Resolver<
    Maybe<ResolversTypes['GsuiteProfilePullerConfig']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GsuiteCredentialsConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GsuiteCredentialsConfig'] =
    ResolversParentTypes['GsuiteCredentialsConfig'],
> = {
  __resolveType: TypeResolveFn<
    'GsuiteOAuth2Config' | 'GsuiteServiceAccountConfig' | 'GsuiteWorkloadIdentityFederationConfig',
    ParentType,
    ContextType
  >;
};

export type GsuiteOAuth2ConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GsuiteOAuth2Config'] =
    ResolversParentTypes['GsuiteOAuth2Config'],
> = {
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GsuiteProfilePullerConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GsuiteProfilePullerConfig'] =
    ResolversParentTypes['GsuiteProfilePullerConfig'],
> = {
  users?: Resolver<Maybe<ResolversTypes['ProfilePullerConfig']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GsuiteServiceAccountConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GsuiteServiceAccountConfig'] =
    ResolversParentTypes['GsuiteServiceAccountConfig'],
> = {
  adminUserEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  credentials?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GsuiteWorkloadIdentityFederationConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GsuiteWorkloadIdentityFederationConfig'] =
    ResolversParentTypes['GsuiteWorkloadIdentityFederationConfig'],
> = {
  adminUserEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  credentials?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GtiIoCStreamConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GtiIoCStreamConfig'] =
    ResolversParentTypes['GtiIoCStreamConfig'],
> = {
  apiKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  maxAgeDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  profilePullers?: Resolver<
    ResolversTypes['GtiIoCStreamProfilePullerConfig'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GtiIoCStreamProfilePullerConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GtiIoCStreamProfilePullerConfig'] =
    ResolversParentTypes['GtiIoCStreamProfilePullerConfig'],
> = {
  iocStream?: Resolver<ResolversTypes['ProfilePullerConfig'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HoldingTankFiltersResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['HoldingTankFilters'] =
    ResolversParentTypes['HoldingTankFilters'],
> = {
  contains?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  excludedPrefixes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  from?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  s3Prefix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  to?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HoldingTankInferJobResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['HoldingTankInferJob'] =
    ResolversParentTypes['HoldingTankInferJob'],
> = {
  completedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inferParameters?: Resolver<ResolversTypes['HoldingTankInferJobParams'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  schemaInferenceResult?: Resolver<
    Maybe<ResolversTypes['HoldingTankSchemaInferenceResult']>,
    ParentType,
    ContextType
  >;
  stats?: Resolver<Maybe<ResolversTypes['HoldingTankJobStats']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['JobStatus'], ParentType, ContextType>;
  taskType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HoldingTankInferJobParamsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['HoldingTankInferJobParams'] =
    ResolversParentTypes['HoldingTankInferJobParams'],
> = {
  batchId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filters?: Resolver<ResolversTypes['HoldingTankFilters'], ParentType, ContextType>;
  schemaName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streamType?: Resolver<ResolversTypes['LogStreamType'], ParentType, ContextType>;
  useSourceBucket?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HoldingTankJobStatsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['HoldingTankJobStats'] =
    ResolversParentTypes['HoldingTankJobStats'],
> = {
  elapsedTimeSeconds?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalEventsProcessed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalSizeBytes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HoldingTankListTasksResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['HoldingTankListTasksResponse'] =
    ResolversParentTypes['HoldingTankListTasksResponse'],
> = {
  tasks?: Resolver<Array<ResolversTypes['Job']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HoldingTankLogTypeTestStatsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['HoldingTankLogTypeTestStats'] =
    ResolversParentTypes['HoldingTankLogTypeTestStats'],
> = {
  logType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  matched?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HoldingTankRawDataResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['HoldingTankRawDataResponse'] =
    ResolversParentTypes['HoldingTankRawDataResponse'],
> = {
  data?: Resolver<Array<ResolversTypes['HoldingTankRawEvent']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HoldingTankRawEventResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['HoldingTankRawEvent'] =
    ResolversParentTypes['HoldingTankRawEvent'],
> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  event?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isJson?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  s3Key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HoldingTankResultsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['HoldingTankResults'] =
    ResolversParentTypes['HoldingTankResults'],
> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  event?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  s3Key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HoldingTankSchemaInferenceResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['HoldingTankSchemaInferenceResult'] =
    ResolversParentTypes['HoldingTankSchemaInferenceResult'],
> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  spec?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HoldingTankTestJobResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['HoldingTankTestJob'] =
    ResolversParentTypes['HoldingTankTestJob'],
> = {
  completedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stats?: Resolver<Maybe<ResolversTypes['HoldingTankJobStats']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['JobStatus'], ParentType, ContextType>;
  taskType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  testParameters?: Resolver<ResolversTypes['HoldingTankTestJobParams'], ParentType, ContextType>;
  testResults?: Resolver<
    Maybe<Array<ResolversTypes['HoldingTankTestJobPrefixStats']>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HoldingTankTestJobParamsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['HoldingTankTestJobParams'] =
    ResolversParentTypes['HoldingTankTestJobParams'],
> = {
  filters?: Resolver<ResolversTypes['DateRange'], ParentType, ContextType>;
  newSchemas?: Resolver<Maybe<Array<ResolversTypes['DraftSchema']>>, ParentType, ContextType>;
  s3PrefixLogTypes?: Resolver<Array<ResolversTypes['S3PrefixLogTypes']>, ParentType, ContextType>;
  streamType?: Resolver<ResolversTypes['LogStreamType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HoldingTankTestJobPrefixStatsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['HoldingTankTestJobPrefixStats'] =
    ResolversParentTypes['HoldingTankTestJobPrefixStats'],
> = {
  errored?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  logTypeMatches?: Resolver<
    Array<ResolversTypes['HoldingTankLogTypeTestStats']>,
    ParentType,
    ContextType
  >;
  prefix?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  unmatched?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HoldingTankTestSchemasResultsResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['HoldingTankTestSchemasResultsResponse'] =
    ResolversParentTypes['HoldingTankTestSchemasResultsResponse'],
> = {
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  results?: Resolver<Array<ResolversTypes['HoldingTankResults']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HttpConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['HttpConfig'] = ResolversParentTypes['HttpConfig'],
> = {
  logProcessingRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logStreamType?: Resolver<ResolversTypes['LogStreamType'], ParentType, ContextType>;
  logStreamTypeOptions?: Resolver<
    Maybe<ResolversTypes['LogStreamTypeOptions']>,
    ParentType,
    ContextType
  >;
  queueUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  s3Bucket?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  s3Prefix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  securityAlg?: Resolver<Maybe<ResolversTypes['HttpHMACDigestAlgType']>, ParentType, ContextType>;
  securityHeaderKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  securityPassword?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  securitySecretValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  securityType?: Resolver<ResolversTypes['HttpSecurityType'], ParentType, ContextType>;
  securityUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HttpLogIntegrationHealthResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['HttpLogIntegrationHealth'] =
    ResolversParentTypes['HttpLogIntegrationHealth'],
> = {
  classificationFailuresStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  httpStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  logProcessingErrorsStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  systemAlarmStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HttpLogSourceIntegrationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['HttpLogSourceIntegration'] =
    ResolversParentTypes['HttpLogSourceIntegration'],
> = {
  alarms?: Resolver<ResolversTypes['LogIntegrationAlarms'], ParentType, ContextType>;
  createdAtTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  filters?: Resolver<ResolversTypes['SourceFilters'], ParentType, ContextType>;
  health?: Resolver<ResolversTypes['HttpLogIntegrationHealth'], ParentType, ContextType>;
  httpConfig?: Resolver<ResolversTypes['HttpConfig'], ParentType, ContextType>;
  integrationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  integrationLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  integrationType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isEditable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isHealthy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPantherManaged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastEventProcessedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastEventReceivedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastModified?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  logProviderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HttpOptionsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['HttpOptions'] = ResolversParentTypes['HttpOptions'],
> = {
  securityAlgorithms?: Resolver<
    Array<ResolversTypes['HttpHMACDigestAlgType']>,
    ParentType,
    ContextType
  >;
  securityHeaderKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  securityType?: Resolver<Maybe<ResolversTypes['HttpSecurityType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IncidentIoWebhookConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['IncidentIoWebhookConfig'] =
    ResolversParentTypes['IncidentIoWebhookConfig'],
> = {
  apiKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  webhookURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InferSchemaResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InferSchemaResponse'] =
    ResolversParentTypes['InferSchemaResponse'],
> = {
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  schema?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InfraCategoryCostsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InfraCategoryCosts'] =
    ResolversParentTypes['InfraCategoryCosts'],
> = {
  costs?: Resolver<Maybe<Array<ResolversTypes['InfraDailyCost']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InfraCostOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InfraCostOutput'] =
    ResolversParentTypes['InfraCostOutput'],
> = {
  ai?: Resolver<Maybe<ResolversTypes['InfraCategoryCosts']>, ParentType, ContextType>;
  alerting?: Resolver<Maybe<ResolversTypes['InfraCategoryCosts']>, ParentType, ContextType>;
  cloudScanning?: Resolver<Maybe<ResolversTypes['InfraCategoryCosts']>, ParentType, ContextType>;
  datalake?: Resolver<Maybe<ResolversTypes['InfraCategoryCosts']>, ParentType, ContextType>;
  detections?: Resolver<Maybe<ResolversTypes['InfraCategoryCosts']>, ParentType, ContextType>;
  ingestion?: Resolver<Maybe<ResolversTypes['InfraCategoryCosts']>, ParentType, ContextType>;
  internal?: Resolver<Maybe<ResolversTypes['InfraCategoryCosts']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InfraDailyCostResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InfraDailyCost'] =
    ResolversParentTypes['InfraDailyCost'],
> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InfrastructureInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InfrastructureInfo'] =
    ResolversParentTypes['InfrastructureInfo'],
> = {
  networking?: Resolver<ResolversTypes['NetworkingInfo'], ParentType, ContextType>;
  storage?: Resolver<ResolversTypes['StorageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IngestionMonitoringSummaryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['IngestionMonitoringSummary'] =
    ResolversParentTypes['IngestionMonitoringSummary'],
> = {
  eventsProcessedMetric?: Resolver<
    Array<ResolversTypes['SeriesWithBreakdown']>,
    ParentType,
    ContextType
  >;
  ingestionQuotaLimit?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  totalBytesFiltered?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalBytesProcessed?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalEventsFiltered?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalEventsProcessed?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InstallCatalogDataModelOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InstallCatalogDataModelOutput'] =
    ResolversParentTypes['InstallCatalogDataModelOutput'],
> = {
  dataModel?: Resolver<Maybe<ResolversTypes['CatalogDataModel']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InstallCatalogDetectionOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InstallCatalogDetectionOutput'] =
    ResolversParentTypes['InstallCatalogDetectionOutput'],
> = {
  detection?: Resolver<Maybe<ResolversTypes['CatalogDetection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InstallCatalogEnrichmentOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InstallCatalogEnrichmentOutput'] =
    ResolversParentTypes['InstallCatalogEnrichmentOutput'],
> = {
  enrichment?: Resolver<Maybe<ResolversTypes['CatalogEnrichment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InstallCatalogGlobalHelperOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InstallCatalogGlobalHelperOutput'] =
    ResolversParentTypes['InstallCatalogGlobalHelperOutput'],
> = {
  globalHelper?: Resolver<Maybe<ResolversTypes['CatalogGlobalHelper']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InstallCatalogQueryOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InstallCatalogQueryOutput'] =
    ResolversParentTypes['InstallCatalogQueryOutput'],
> = {
  query?: Resolver<Maybe<ResolversTypes['CatalogQuery']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InstalledCatalogItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InstalledCatalogItem'] =
    ResolversParentTypes['InstalledCatalogItem'],
> = {
  analysisType?: Resolver<ResolversTypes['AnalysisType'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InstalledCatalogItemUpdateStatusResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InstalledCatalogItemUpdateStatus'] =
    ResolversParentTypes['InstalledCatalogItemUpdateStatus'],
> = {
  analysisType?: Resolver<ResolversTypes['AnalysisType'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['UpdateStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationItemHealthStatusResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['IntegrationItemHealthStatus'] =
    ResolversParentTypes['IntegrationItemHealthStatus'],
> = {
  healthy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rawErrorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['SourceHealthTypesEnum']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationTemplateResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['IntegrationTemplate'] =
    ResolversParentTypes['IntegrationTemplate'],
> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stackName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalDetectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InternalDetection'] =
    ResolversParentTypes['InternalDetection'],
> = {
  __resolveType: TypeResolveFn<'CorrelationRule' | 'Policy' | 'Rule', ParentType, ContextType>;
};

export type InviteUserOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InviteUserOutput'] =
    ResolversParentTypes['InviteUserOutput'],
> = {
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JSONScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type JiraAssignableUserResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['JiraAssignableUser'] =
    ResolversParentTypes['JiraAssignableUser'],
> = {
  accountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JiraConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['JiraConfig'] = ResolversParentTypes['JiraConfig'],
> = {
  apiKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  assigneeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assigneeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  issueType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  labels?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  orgDomain?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  projectKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pullAlertAssignee?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  pullAlertComments?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  pullAlertStatus?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  severityBasedConfig?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SeverityBasedJiraConfig']>>>,
    ParentType,
    ContextType
  >;
  statusMap?: Resolver<Maybe<ResolversTypes['JiraStatusMap']>, ParentType, ContextType>;
  syncAlertAssignee?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  syncAlertComments?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  syncAlertStatus?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  useSeverityBasedConfig?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  userName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JiraOrgMetadataResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['JiraOrgMetadata'] =
    ResolversParentTypes['JiraOrgMetadata'],
> = {
  assignableUsers?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['JiraAssignableUser']>>>,
    ParentType,
    ContextType
  >;
  labels?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  priorities?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['JiraPriority']>>>,
    ParentType,
    ContextType
  >;
  transitions?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['JiraTransitionStatus']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JiraPriorityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['JiraPriority'] = ResolversParentTypes['JiraPriority'],
> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JiraStatusMapResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['JiraStatusMap'] = ResolversParentTypes['JiraStatusMap'],
> = {
  closed?: Resolver<ResolversTypes['JiraTransitionStatus'], ParentType, ContextType>;
  open?: Resolver<ResolversTypes['JiraTransitionStatus'], ParentType, ContextType>;
  resolved?: Resolver<ResolversTypes['JiraTransitionStatus'], ParentType, ContextType>;
  triaged?: Resolver<ResolversTypes['JiraTransitionStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JiraTransitionStatusResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['JiraTransitionStatus'] =
    ResolversParentTypes['JiraTransitionStatus'],
> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Job'] = ResolversParentTypes['Job'],
> = {
  __resolveType: TypeResolveFn<
    | 'BulkUploadJob'
    | 'GenerateSchemaFromSqlJob'
    | 'HoldingTankInferJob'
    | 'HoldingTankTestJob'
    | 'LookupImportDataJob'
    | 'LookupSyncJob'
    | 'ReclassifySourceAlarmJob'
    | 'SaveLookupJob'
    | 'SummarizeDataLakeQueryJob'
    | 'UpdateAlertStatusByFilterJob'
    | 'UpdateAllCatalogItemsJob',
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['JobStatus'], ParentType, ContextType>;
};

export type ListAPITokensOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ListAPITokensOutput'] =
    ResolversParentTypes['ListAPITokensOutput'],
> = {
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  tokens?: Resolver<Array<ResolversTypes['APIToken']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListAlertContextTagsOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ListAlertContextTagsOutput'] =
    ResolversParentTypes['ListAlertContextTagsOutput'],
> = {
  edges?: Resolver<Array<ResolversTypes['AlertContextTagEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['ListAlertContextTagsPageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListAlertContextTagsPageInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ListAlertContextTagsPageInfo'] =
    ResolversParentTypes['ListAlertContextTagsPageInfo'],
> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListAnalysisItemsForWorkbenchOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ListAnalysisItemsForWorkbenchOutput'] =
    ResolversParentTypes['ListAnalysisItemsForWorkbenchOutput'],
> = {
  items?: Resolver<Array<ResolversTypes['WorkbenchPickerItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListAnalysisPackSourcesResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ListAnalysisPackSourcesResponse'] =
    ResolversParentTypes['ListAnalysisPackSourcesResponse'],
> = {
  packs?: Resolver<Array<ResolversTypes['AnalysisPackSource']>, ParentType, ContextType>;
  paging?: Resolver<ResolversTypes['PagingData'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListAnalysisPacksResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ListAnalysisPacksResponse'] =
    ResolversParentTypes['ListAnalysisPacksResponse'],
> = {
  packs?: Resolver<Array<ResolversTypes['AnalysisPack']>, ParentType, ContextType>;
  paging?: Resolver<ResolversTypes['PagingData'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListAvailableLogProvidersResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ListAvailableLogProvidersResponse'] =
    ResolversParentTypes['ListAvailableLogProvidersResponse'],
> = {
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  results?: Resolver<Maybe<Array<ResolversTypes['AvailableLogProvider']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListAvailableLogTypesResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ListAvailableLogTypesResponse'] =
    ResolversParentTypes['ListAvailableLogTypesResponse'],
> = {
  logTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListBucketKeysResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ListBucketKeysResponse'] =
    ResolversParentTypes['ListBucketKeysResponse'],
> = {
  commonPrefixes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  objects?: Resolver<Array<ResolversTypes['S3Object']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListCatalogDataModelsOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ListCatalogDataModelsOutput'] =
    ResolversParentTypes['ListCatalogDataModelsOutput'],
> = {
  dataModels?: Resolver<Array<ResolversTypes['CatalogDataModel']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListCatalogDetectionsOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ListCatalogDetectionsOutput'] =
    ResolversParentTypes['ListCatalogDetectionsOutput'],
> = {
  detections?: Resolver<Array<ResolversTypes['CatalogDetection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListCatalogEnrichmentsOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ListCatalogEnrichmentsOutput'] =
    ResolversParentTypes['ListCatalogEnrichmentsOutput'],
> = {
  enrichments?: Resolver<Array<ResolversTypes['CatalogEnrichment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListCatalogGlobalHelpersOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ListCatalogGlobalHelpersOutput'] =
    ResolversParentTypes['ListCatalogGlobalHelpersOutput'],
> = {
  globalHelpers?: Resolver<Array<ResolversTypes['CatalogGlobalHelper']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListCatalogQueriesOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ListCatalogQueriesOutput'] =
    ResolversParentTypes['ListCatalogQueriesOutput'],
> = {
  queries?: Resolver<Array<ResolversTypes['CatalogQuery']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListComplianceItemsResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ListComplianceItemsResponse'] =
    ResolversParentTypes['ListComplianceItemsResponse'],
> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['ComplianceItem']>>>, ParentType, ContextType>;
  paging?: Resolver<Maybe<ResolversTypes['PagingData']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ComplianceStatusEnum']>, ParentType, ContextType>;
  totals?: Resolver<Maybe<ResolversTypes['ActiveSuppressCount']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListDataModelsResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ListDataModelsResponse'] =
    ResolversParentTypes['ListDataModelsResponse'],
> = {
  models?: Resolver<Array<ResolversTypes['DataModel']>, ParentType, ContextType>;
  paging?: Resolver<ResolversTypes['PagingData'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListDetectionsResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ListDetectionsResponse'] =
    ResolversParentTypes['ListDetectionsResponse'],
> = {
  detections?: Resolver<Array<ResolversTypes['InternalDetection']>, ParentType, ContextType>;
  paging?: Resolver<ResolversTypes['PagingData'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListGitConfigsResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ListGitConfigsResponse'] =
    ResolversParentTypes['ListGitConfigsResponse'],
> = {
  allGitConfigs?: Resolver<Maybe<ResolversTypes['AllGitConfigs']>, ParentType, ContextType>;
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListGlobalHelpersResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ListGlobalHelpersResponse'] =
    ResolversParentTypes['ListGlobalHelpersResponse'],
> = {
  globals?: Resolver<Maybe<Array<Maybe<ResolversTypes['GlobalHelper']>>>, ParentType, ContextType>;
  paging?: Resolver<Maybe<ResolversTypes['PagingData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListInstalledCatalogItemUpdateStatusesOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ListInstalledCatalogItemUpdateStatusesOutput'] =
    ResolversParentTypes['ListInstalledCatalogItemUpdateStatusesOutput'],
> = {
  items?: Resolver<
    Array<ResolversTypes['InstalledCatalogItemUpdateStatus']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListInstalledCatalogItemsOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ListInstalledCatalogItemsOutput'] =
    ResolversParentTypes['ListInstalledCatalogItemsOutput'],
> = {
  items?: Resolver<Array<ResolversTypes['InstalledCatalogItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListLookupResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ListLookupResponse'] =
    ResolversParentTypes['ListLookupResponse'],
> = {
  lastEvaluatedKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lookups?: Resolver<Array<ResolversTypes['Lookup']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListResourcesResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ListResourcesResponse'] =
    ResolversParentTypes['ListResourcesResponse'],
> = {
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resources?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['ResourceSummary']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListSavedQueriesResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ListSavedQueriesResponse'] =
    ResolversParentTypes['ListSavedQueriesResponse'],
> = {
  lastEvaluatedKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  savedQueries?: Resolver<Array<ResolversTypes['SavedQuery']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListScheduledPromptsResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ListScheduledPromptsResponse'] =
    ResolversParentTypes['ListScheduledPromptsResponse'],
> = {
  edges?: Resolver<
    Array<ResolversTypes['ListScheduledPromptsResponseEdge']>,
    ParentType,
    ContextType
  >;
  hasSharedPrompts?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['CursorBasedPaginationPageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListScheduledPromptsResponseEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ListScheduledPromptsResponseEdge'] =
    ResolversParentTypes['ListScheduledPromptsResponseEdge'],
> = {
  node?: Resolver<ResolversTypes['ScheduledPrompt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LoadAnalysisItemForWorkbenchOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LoadAnalysisItemForWorkbenchOutput'] =
    ResolversParentTypes['LoadAnalysisItemForWorkbenchOutput'],
> = {
  analysisType?: Resolver<ResolversTypes['AnalysisType'], ParentType, ContextType>;
  baseVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  latestVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  python?: Resolver<Maybe<ResolversTypes['WorkbenchFile']>, ParentType, ContextType>;
  yaml?: Resolver<ResolversTypes['WorkbenchFile'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LogForwarderConfigYamlResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LogForwarderConfigYaml'] =
    ResolversParentTypes['LogForwarderConfigYaml'],
> = {
  yaml?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LogForwarderGeneratorInputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LogForwarderGeneratorInput'] =
    ResolversParentTypes['LogForwarderGeneratorInput'],
> = {
  mode?: Resolver<Maybe<ResolversTypes['LogForwarderSyslogMode']>, ParentType, ContextType>;
  path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  port?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['LogForwarderInputType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LogForwarderLogIntegrationHealthResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LogForwarderLogIntegrationHealth'] =
    ResolversParentTypes['LogForwarderLogIntegrationHealth'],
> = {
  bucketNotificationsStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  classificationFailuresStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  logProcessingErrorsStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  managedS3IamUserStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  s3BucketStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  systemAlarmStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LogForwarderLogSourceIntegrationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LogForwarderLogSourceIntegration'] =
    ResolversParentTypes['LogForwarderLogSourceIntegration'],
> = {
  alarms?: Resolver<ResolversTypes['LogIntegrationAlarms'], ParentType, ContextType>;
  createdAtTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  filters?: Resolver<ResolversTypes['SourceFilters'], ParentType, ContextType>;
  generatorInput?: Resolver<
    Maybe<ResolversTypes['LogForwarderGeneratorInput']>,
    ParentType,
    ContextType
  >;
  health?: Resolver<ResolversTypes['LogForwarderLogIntegrationHealth'], ParentType, ContextType>;
  integrationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  integrationLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  integrationType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isEditable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isHealthy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPantherManaged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastEventProcessedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastEventReceivedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastModified?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  logProviderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LogIntegrationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LogIntegration'] =
    ResolversParentTypes['LogIntegration'],
> = {
  __resolveType: TypeResolveFn<
    | 'AmazonSecurityLakeLogIntegration'
    | 'AzureBlobSourceIntegration'
    | 'AzureEventHubSourceIntegration'
    | 'CloudWatchLogIntegration'
    | 'EventBridgeIntegration'
    | 'GcpPubSubLogSourceIntegration'
    | 'GcsLogSourceIntegration'
    | 'HttpLogSourceIntegration'
    | 'LogForwarderLogSourceIntegration'
    | 'LogPullingIntegration'
    | 'OTLPLogSourceIntegration'
    | 'S3LogIntegration'
    | 'SqsLogSourceIntegration',
    ParentType,
    ContextType
  >;
  alarms?: Resolver<ResolversTypes['LogIntegrationAlarms'], ParentType, ContextType>;
  createdAtTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  integrationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  integrationLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  integrationType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isEditable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isHealthy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPantherManaged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastEventProcessedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastEventReceivedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastModified?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  logTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
};

export type LogIntegrationAlarmsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LogIntegrationAlarms'] =
    ResolversParentTypes['LogIntegrationAlarms'],
> = {
  eventThreshold?: Resolver<Maybe<ResolversTypes['EventThresholdAlarm']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LogPullingIntegrationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LogPullingIntegration'] =
    ResolversParentTypes['LogPullingIntegration'],
> = {
  alarms?: Resolver<ResolversTypes['LogIntegrationAlarms'], ParentType, ContextType>;
  createdAtTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  filters?: Resolver<ResolversTypes['SourceFilters'], ParentType, ContextType>;
  health?: Resolver<ResolversTypes['LogPullingIntegrationHealth'], ParentType, ContextType>;
  integrationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  integrationLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  integrationType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isEditable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isHealthy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPantherManaged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastEventProcessedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastEventReceivedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastModified?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  logProviderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  oauth2?: Resolver<Maybe<ResolversTypes['OAuth2Info']>, ParentType, ContextType>;
  pullerConfig?: Resolver<ResolversTypes['PullerConfig'], ParentType, ContextType>;
  pullerType?: Resolver<ResolversTypes['LogPullerTypeEnum'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LogPullingIntegrationHealthResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LogPullingIntegrationHealth'] =
    ResolversParentTypes['LogPullingIntegrationHealth'],
> = {
  classificationFailuresStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  logProcessingErrorsStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  logPullingStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  systemAlarmStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LogPullingOptionsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LogPullingOptions'] =
    ResolversParentTypes['LogPullingOptions'],
> = {
  credentialFormFields?: Resolver<
    Maybe<Array<ResolversTypes['CredentialFormField']>>,
    ParentType,
    ContextType
  >;
  pullerStrategyConfig?: Resolver<
    Maybe<ResolversTypes['GenericPullerStrategyConfig']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LogSourceBreakdownResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LogSourceBreakdown'] =
    ResolversParentTypes['LogSourceBreakdown'],
> = {
  logSourceName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  metricData?: Resolver<ResolversTypes['SeriesWithBreakdown'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LogStreamTypeOptionsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LogStreamTypeOptions'] =
    ResolversParentTypes['LogStreamTypeOptions'],
> = {
  jsonArrayEnvelopeField?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  retainEnvelopeFields?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  xmlRootElement?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LogTypeAlertsBySeverityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LogTypeAlertsBySeverity'] =
    ResolversParentTypes['LogTypeAlertsBySeverity'],
> = {
  alertsBySeverity?: Resolver<ResolversTypes['AlertsBySeverity'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface LongScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Long'], any> {
  name: 'Long';
}

export type LookupResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Lookup'] = ResolversParentTypes['Lookup'],
> = {
  activeVersion?: Resolver<Maybe<ResolversTypes['LookupVersion']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  integration?: Resolver<Maybe<ResolversTypes['LookupIntegration']>, ParentType, ContextType>;
  lastModifiedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  managed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  packIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  refresh?: Resolver<Maybe<ResolversTypes['LookupRefreshConfig']>, ParentType, ContextType>;
  scheduledQuery?: Resolver<
    Maybe<ResolversTypes['LookupScheduledQueryConfig']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LookupEnrichHitResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LookupEnrichHit'] =
    ResolversParentTypes['LookupEnrichHit'],
> = {
  jsonValue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  logType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lookupTableName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LookupEnrichOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LookupEnrichOutput'] =
    ResolversParentTypes['LookupEnrichOutput'],
> = {
  hits?: Resolver<Maybe<Array<ResolversTypes['LookupEnrichHit']>>, ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LookupImportDataJobResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LookupImportDataJob'] =
    ResolversParentTypes['LookupImportDataJob'],
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stats?: Resolver<Maybe<ResolversTypes['LookupImportDataJobStats']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['JobStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LookupImportDataJobStatsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LookupImportDataJobStats'] =
    ResolversParentTypes['LookupImportDataJobStats'],
> = {
  skipped?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LookupIntegrationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LookupIntegration'] =
    ResolversParentTypes['LookupIntegration'],
> = {
  __resolveType: TypeResolveFn<
    'EnrichmentIntegration' | 'LogPullingIntegration',
    ParentType,
    ContextType
  >;
};

export type LookupRefreshConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LookupRefreshConfig'] =
    ResolversParentTypes['LookupRefreshConfig'],
> = {
  alarmPeriodMinutes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  gcsCredentials?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  objectKMSKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  objectPath?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  periodMinutes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  roleARN?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  storageProvider?: Resolver<Maybe<ResolversTypes['StorageProvider']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LookupS3ImportConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LookupS3ImportConfig'] =
    ResolversParentTypes['LookupS3ImportConfig'],
> = {
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LookupScheduledQueryConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LookupScheduledQueryConfig'] =
    ResolversParentTypes['LookupScheduledQueryConfig'],
> = {
  cronExpression?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  periodMinutes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  schemaSpec?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sqlQuery?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LookupStatsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LookupStats'] = ResolversParentTypes['LookupStats'],
> = {
  disabledCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  enabledCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LookupSyncJobResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LookupSyncJob'] = ResolversParentTypes['LookupSyncJob'],
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stats?: Resolver<Maybe<ResolversTypes['LookupSyncJobStats']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['JobStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LookupSyncJobStatsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LookupSyncJobStats'] =
    ResolversParentTypes['LookupSyncJobStats'],
> = {
  skipped?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LookupVersionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LookupVersion'] = ResolversParentTypes['LookupVersion'],
> = {
  associatedLogTypes?: Resolver<
    Array<ResolversTypes['AssociatedLogType']>,
    ParentType,
    ContextType
  >;
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  erroredAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  logType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lookupId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  objectPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  refreshedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  rowCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type M365ConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['M365Config'] = ResolversParentTypes['M365Config'],
> = {
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscriptionPlan?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tenantDomain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MarkAllNotificationsAsReadOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MarkAllNotificationsAsReadOutput'] =
    ResolversParentTypes['MarkAllNotificationsAsReadOutput'],
> = {
  notifications?: Resolver<Array<ResolversTypes['Notification']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MatchedLogResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MatchedLog'] = ResolversParentTypes['MatchedLog'],
> = {
  event?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  raw?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type McpAuthorizationResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['McpAuthorizationResponse'] =
    ResolversParentTypes['McpAuthorizationResponse'],
> = {
  authorizationUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type McpConnectionTestResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['McpConnectionTestResult'] =
    ResolversParentTypes['McpConnectionTestResult'],
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['McpConnectionStatus'], ParentType, ContextType>;
  toolCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type McpServerResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['McpServer'] = ResolversParentTypes['McpServer'],
> = {
  authType?: Resolver<ResolversTypes['McpAuthType'], ParentType, ContextType>;
  awsRoleArn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  oauthClientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oauthTokenUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrationMode?: Resolver<ResolversTypes['McpRegistrationMode'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userConnection?: Resolver<Maybe<ResolversTypes['McpUserConnection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type McpServerDiscoveryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['McpServerDiscovery'] =
    ResolversParentTypes['McpServerDiscovery'],
> = {
  mcpOAuthRedirectUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requiresManualCredentials?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  resourceName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type McpServersOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['McpServersOutput'] =
    ResolversParentTypes['McpServersOutput'],
> = {
  edges?: Resolver<Array<ResolversTypes['McpServersOutputEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['CursorBasedPaginationPageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type McpServersOutputEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['McpServersOutputEdge'] =
    ResolversParentTypes['McpServersOutputEdge'],
> = {
  node?: Resolver<ResolversTypes['McpServer'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type McpToolResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['McpTool'] = ResolversParentTypes['McpTool'],
> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isNew?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  readOnly?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  requiresApproval?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type McpUserConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['McpUserConnection'] =
    ResolversParentTypes['McpUserConnection'],
> = {
  connectedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  externalUserEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grantedScopes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  isConnected?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['McpConnectionStatus'], ParentType, ContextType>;
  tokenExpiresAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  tools?: Resolver<Array<ResolversTypes['McpTool']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MetricsOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MetricsOutput'] = ResolversParentTypes['MetricsOutput'],
> = {
  alertsPerRule?: Resolver<
    Maybe<Array<ResolversTypes['SeriesWithEntityID']>>,
    ParentType,
    ContextType
  >;
  alertsPerSeverity?: Resolver<
    Array<ResolversTypes['SeriesWithBreakdown']>,
    ParentType,
    ContextType
  >;
  alertsPerType?: Resolver<Array<ResolversTypes['SeriesWithBreakdown']>, ParentType, ContextType>;
  bytesFiltered?: Resolver<Array<ResolversTypes['SeriesWithBreakdown']>, ParentType, ContextType>;
  bytesIngestedPerSource?: Resolver<
    Maybe<Array<ResolversTypes['Series']>>,
    ParentType,
    ContextType
  >;
  bytesProcessedPerSource?: Resolver<
    Array<ResolversTypes['SeriesWithBreakdown']>,
    ParentType,
    ContextType
  >;
  bytesProcessedTotal?: Resolver<
    Array<ResolversTypes['SeriesWithBreakdown']>,
    ParentType,
    ContextType
  >;
  bytesQueriedPerSource?: Resolver<
    Array<ResolversTypes['SeriesWithBreakdown']>,
    ParentType,
    ContextType
  >;
  correlationRulesCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  correlationRulesDisabledCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  correlationRulesEnabledCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  enrichmentMatchCount?: Resolver<
    Array<ResolversTypes['SeriesWithBreakdown']>,
    ParentType,
    ContextType
  >;
  eventsFiltered?: Resolver<Array<ResolversTypes['SeriesWithBreakdown']>, ParentType, ContextType>;
  eventsProcessedPerLogType?: Resolver<
    Array<ResolversTypes['SeriesWithBreakdown']>,
    ParentType,
    ContextType
  >;
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  ingestionPerLogSource?: Resolver<
    Array<ResolversTypes['LogSourceBreakdown']>,
    ParentType,
    ContextType
  >;
  intervalInMinutes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  latencyPerLogType?: Resolver<Maybe<Array<ResolversTypes['Series']>>, ParentType, ContextType>;
  policiesCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  policiesDisabledCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  policiesEnabledCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  rulesCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  rulesDisabledCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  rulesEnabledCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  rulesEnabledPerLogType?: Resolver<Array<ResolversTypes['Series']>, ParentType, ContextType>;
  scheduledRulesCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  scheduledRulesDisabledCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  scheduledRulesEnabledCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  toDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  totalAlerts?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalAlertsDiff?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalBytesFiltered?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalBytesIngested?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalBytesProcessed?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalBytesQueried?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalEventsFiltered?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalEventsProcessed?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MicrosoftGraphConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MicrosoftGraphConfig'] =
    ResolversParentTypes['MicrosoftGraphConfig'],
> = {
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscriptionPlan?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MindflowWebhookConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MindflowWebhookConfig'] =
    ResolversParentTypes['MindflowWebhookConfig'],
> = {
  webhookURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MitreComboResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MitreCombo'] = ResolversParentTypes['MitreCombo'],
> = {
  tactic?: Resolver<ResolversTypes['MitreTactic'], ParentType, ContextType>;
  technique?: Resolver<ResolversTypes['MitreTechnique'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MitreMatrixResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MitreMatrix'] = ResolversParentTypes['MitreMatrix'],
> = {
  content?: Resolver<ResolversTypes['MitreMatrixContent'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mappings?: Resolver<Array<ResolversTypes['MitreMatrixTacticMapping']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reportSettings?: Resolver<Array<ResolversTypes['ReportSetting']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MitreMatrixContentResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MitreMatrixContent'] =
    ResolversParentTypes['MitreMatrixContent'],
> = {
  tactics?: Resolver<Array<ResolversTypes['MitreTactic']>, ParentType, ContextType>;
  techniques?: Resolver<Array<ResolversTypes['MitreTechnique']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MitreMatrixTacticMappingResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MitreMatrixTacticMapping'] =
    ResolversParentTypes['MitreMatrixTacticMapping'],
> = {
  tacticId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  techniqueIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MitreMatrixTreeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MitreMatrixTree'] =
    ResolversParentTypes['MitreMatrixTree'],
> = {
  defaultMatrixId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  enabledLogTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  matrices?: Resolver<Array<ResolversTypes['MitreMatrixTreeNode']>, ParentType, ContextType>;
  mitreVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mitreVersionUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MitreMatrixTreeNodeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MitreMatrixTreeNode'] =
    ResolversParentTypes['MitreMatrixTreeNode'],
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  submatrices?: Resolver<Array<ResolversTypes['MitreMatrixTreeNode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MitreReportEntryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MitreReportEntry'] =
    ResolversParentTypes['MitreReportEntry'],
> = {
  tactic?: Resolver<ResolversTypes['NamedMitreAttack'], ParentType, ContextType>;
  technique?: Resolver<ResolversTypes['NamedMitreAttack'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MitreTacticResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MitreTactic'] = ResolversParentTypes['MitreTactic'],
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MitreTechniqueResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MitreTechnique'] =
    ResolversParentTypes['MitreTechnique'],
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MongoDBConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MongoDBConfig'] = ResolversParentTypes['MongoDBConfig'],
> = {
  orgId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  privateKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publicKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MsTeamsConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MsTeamsConfig'] = ResolversParentTypes['MsTeamsConfig'],
> = {
  webhookURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation'],
> = {
  addAnalysisPackSource?: Resolver<
    ResolversTypes['AnalysisPackSource'],
    ParentType,
    ContextType,
    RequireFields<MutationAddAnalysisPackSourceArgs, 'input'>
  >;
  addDataModel?: Resolver<
    ResolversTypes['DataModel'],
    ParentType,
    ContextType,
    RequireFields<MutationAddDataModelArgs, 'input'>
  >;
  addDestination?: Resolver<
    Maybe<ResolversTypes['Destination']>,
    ParentType,
    ContextType,
    RequireFields<MutationAddDestinationArgs, 'input'>
  >;
  addEnrichmentIntegration?: Resolver<
    ResolversTypes['EnrichmentIntegration'],
    ParentType,
    ContextType,
    RequireFields<MutationAddEnrichmentIntegrationArgs, 'input'>
  >;
  addGlobalHelper?: Resolver<
    ResolversTypes['GlobalHelper'],
    ParentType,
    ContextType,
    RequireFields<MutationAddGlobalHelperArgs, 'input'>
  >;
  addLogSource?: Resolver<
    ResolversTypes['LogIntegration'],
    ParentType,
    ContextType,
    RequireFields<MutationAddLogSourceArgs, 'input'>
  >;
  addLookup?: Resolver<
    ResolversTypes['Lookup'],
    ParentType,
    ContextType,
    RequireFields<MutationAddLookupArgs, 'input'>
  >;
  addLookupAsync?: Resolver<
    ResolversTypes['SaveLookupJob'],
    ParentType,
    ContextType,
    RequireFields<MutationAddLookupAsyncArgs, 'input'>
  >;
  addPolicy?: Resolver<
    Maybe<ResolversTypes['Policy']>,
    ParentType,
    ContextType,
    RequireFields<MutationAddPolicyArgs, 'input'>
  >;
  addRule?: Resolver<
    Maybe<ResolversTypes['Rule']>,
    ParentType,
    ContextType,
    RequireFields<MutationAddRuleArgs, 'input'>
  >;
  addRuleV2?: Resolver<
    Maybe<ResolversTypes['AddRuleV2Output']>,
    ParentType,
    ContextType,
    RequireFields<MutationAddRuleV2Args, 'input'>
  >;
  addSavedQuery?: Resolver<
    ResolversTypes['SavedQuery'],
    ParentType,
    ContextType,
    RequireFields<MutationAddSavedQueryArgs, 'input'>
  >;
  aiAuthorDetection?: Resolver<
    ResolversTypes['AIInferenceStream'],
    ParentType,
    ContextType,
    RequireFields<MutationAiAuthorDetectionArgs, 'input'>
  >;
  aiAuthorOrganizationProfile?: Resolver<
    ResolversTypes['AIInferenceStream'],
    ParentType,
    ContextType,
    RequireFields<MutationAiAuthorOrganizationProfileArgs, 'input'>
  >;
  aiAuthorRunbook?: Resolver<
    ResolversTypes['AIInferenceStream'],
    ParentType,
    ContextType,
    RequireFields<MutationAiAuthorRunbookArgs, 'input'>
  >;
  aiAuthorSkill?: Resolver<
    ResolversTypes['AIInferenceStream'],
    ParentType,
    ContextType,
    RequireFields<MutationAiAuthorSkillArgs, 'input'>
  >;
  aiGeneratePantherFlowQuery?: Resolver<
    ResolversTypes['AIInferenceStream'],
    ParentType,
    ContextType,
    RequireFields<MutationAiGeneratePantherFlowQueryArgs, 'input'>
  >;
  aiGenerateSqlQuery?: Resolver<
    ResolversTypes['AIInferenceStream'],
    ParentType,
    ContextType,
    RequireFields<MutationAiGenerateSqlQueryArgs, 'input'>
  >;
  aiReplayDetection?: Resolver<
    ResolversTypes['AIInferenceStream'],
    ParentType,
    ContextType,
    RequireFields<MutationAiReplayDetectionArgs, 'input'>
  >;
  aiResolveAnalysisItemMergeConflicts?: Resolver<
    ResolversTypes['AIInferenceStream'],
    ParentType,
    ContextType,
    RequireFields<MutationAiResolveAnalysisItemMergeConflictsArgs, 'input'>
  >;
  aiSchemaInference?: Resolver<
    ResolversTypes['AIInferenceStream'],
    ParentType,
    ContextType,
    RequireFields<MutationAiSchemaInferenceArgs, 'input'>
  >;
  aiSummarizeAlert?: Resolver<
    ResolversTypes['AIInferenceStream'],
    ParentType,
    ContextType,
    RequireFields<MutationAiSummarizeAlertArgs, 'input'>
  >;
  aiSummarizeDetection?: Resolver<
    ResolversTypes['AIInferenceStream'],
    ParentType,
    ContextType,
    RequireFields<MutationAiSummarizeDetectionArgs, 'input'>
  >;
  aiSummarizeLogEvents?: Resolver<
    ResolversTypes['AIInferenceStream'],
    ParentType,
    ContextType,
    RequireFields<MutationAiSummarizeLogEventsArgs, 'input'>
  >;
  aiSummarizeQueryResults?: Resolver<
    ResolversTypes['AIInferenceStream'],
    ParentType,
    ContextType,
    RequireFields<MutationAiSummarizeQueryResultsArgs, 'input'>
  >;
  approveRemoteMcpAuthorization?: Resolver<
    ResolversTypes['ApproveRemoteMcpAuthorizationResult'],
    ParentType,
    ContextType,
    RequireFields<MutationApproveRemoteMcpAuthorizationArgs, 'input'>
  >;
  batchInferJobs?: Resolver<
    ResolversTypes['BatchInferJobsOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationBatchInferJobsArgs, 'input'>
  >;
  bulkUpdateDetections?: Resolver<
    Maybe<ResolversTypes['BulkUpdateDetectionsResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationBulkUpdateDetectionsArgs, 'input'>
  >;
  bulkUploadDetections?: Resolver<
    ResolversTypes['BulkUploadJob'],
    ParentType,
    ContextType,
    RequireFields<MutationBulkUploadDetectionsArgs, 'input'>
  >;
  cancelAIInferenceStream?: Resolver<
    ResolversTypes['AIInferenceStream'],
    ParentType,
    ContextType,
    RequireFields<MutationCancelAIInferenceStreamArgs, 'input'>
  >;
  cancelDashboardQueries?: Resolver<
    ResolversTypes['CancelDashboardOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationCancelDashboardQueriesArgs, 'queryIds'>
  >;
  cancelDataLakeQuery?: Resolver<
    ResolversTypes['CancelDataLakeQueryOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationCancelDataLakeQueryArgs, 'input'>
  >;
  cancelHoldingTankJob?: Resolver<
    ResolversTypes['Job'],
    ParentType,
    ContextType,
    RequireFields<MutationCancelHoldingTankJobArgs, 'id'>
  >;
  cancelUberSearch?: Resolver<
    ResolversTypes['CancelDataLakeQueryOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationCancelUberSearchArgs, 'id'>
  >;
  completeMcpAuthorization?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType,
    RequireFields<MutationCompleteMcpAuthorizationArgs, 'input'>
  >;
  continueAIConversation?: Resolver<
    ResolversTypes['ContinueAIConversationOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationContinueAIConversationArgs, 'input'>
  >;
  createAIConversation?: Resolver<
    ResolversTypes['CreateAIConversationOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateAIConversationArgs, 'input'>
  >;
  createAISkill?: Resolver<
    ResolversTypes['CreateAISkillOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateAISkillArgs, 'input'>
  >;
  createAPIToken?: Resolver<
    ResolversTypes['CreateAPITokenOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateAPITokenArgs, 'input'>
  >;
  createAlertComment?: Resolver<
    ResolversTypes['CreateAlertCommentOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateAlertCommentArgs, 'input'>
  >;
  createAzureBlobSource?: Resolver<
    ResolversTypes['CreateAzureBlobSourceOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateAzureBlobSourceArgs, 'input'>
  >;
  createCloudAccount?: Resolver<
    ResolversTypes['CreateCloudAccountOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateCloudAccountArgs, 'input'>
  >;
  createDashboard?: Resolver<
    ResolversTypes['Dashboard'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateDashboardArgs, 'input'>
  >;
  createDetectionFilter?: Resolver<
    ResolversTypes['CreateDetectionFilterOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateDetectionFilterArgs, 'input'>
  >;
  createGitHubAppConfig?: Resolver<
    Maybe<ResolversTypes['CreateGitHubAppConfigResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateGitHubAppConfigArgs, 'input'>
  >;
  createGitHubAppRegistrationUrl?: Resolver<
    Maybe<ResolversTypes['CreateGitHubAppRegistrationUrlResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateGitHubAppRegistrationUrlArgs, 'input'>
  >;
  createMcpServer?: Resolver<
    ResolversTypes['McpServer'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateMcpServerArgs, 'input'>
  >;
  createOrUpdateSchema?: Resolver<
    ResolversTypes['CreateOrUpdateSchemaOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateOrUpdateSchemaArgs, 'input'>
  >;
  createPerfTest?: Resolver<
    ResolversTypes['CreateReplayOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationCreatePerfTestArgs, 'input'>
  >;
  createPullRequestForCatalogDataModelInstall?: Resolver<
    Maybe<ResolversTypes['CreatePullRequestResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreatePullRequestForCatalogDataModelInstallArgs, 'input'>
  >;
  createPullRequestForCatalogGlobalHelperInstall?: Resolver<
    Maybe<ResolversTypes['CreatePullRequestResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreatePullRequestForCatalogGlobalHelperInstallArgs, 'input'>
  >;
  createPullRequestForCatalogInstall?: Resolver<
    Maybe<ResolversTypes['CreatePullRequestResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreatePullRequestForCatalogInstallArgs, 'input'>
  >;
  createPullRequestForCatalogSavedQueryInstall?: Resolver<
    Maybe<ResolversTypes['CreatePullRequestResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreatePullRequestForCatalogSavedQueryInstallArgs, 'input'>
  >;
  createPullRequestForCorrelationRuleEdit?: Resolver<
    Maybe<ResolversTypes['CreatePullRequestResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreatePullRequestForCorrelationRuleEditArgs, 'input'>
  >;
  createPullRequestForDataModelDeletion?: Resolver<
    Maybe<ResolversTypes['CreatePullRequestResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreatePullRequestForDataModelDeletionArgs, 'input'>
  >;
  createPullRequestForDataModelEdit?: Resolver<
    Maybe<ResolversTypes['CreatePullRequestResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreatePullRequestForDataModelEditArgs, 'input'>
  >;
  createPullRequestForDetectionDeletion?: Resolver<
    Maybe<ResolversTypes['CreatePullRequestResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreatePullRequestForDetectionDeletionArgs, 'input'>
  >;
  createPullRequestForGlobalHelperDeletion?: Resolver<
    Maybe<ResolversTypes['CreatePullRequestResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreatePullRequestForGlobalHelperDeletionArgs, 'input'>
  >;
  createPullRequestForGlobalHelperEdit?: Resolver<
    Maybe<ResolversTypes['CreatePullRequestResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreatePullRequestForGlobalHelperEditArgs, 'input'>
  >;
  createPullRequestForNewDataModel?: Resolver<
    Maybe<ResolversTypes['CreatePullRequestResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreatePullRequestForNewDataModelArgs, 'input'>
  >;
  createPullRequestForNewGlobalHelper?: Resolver<
    Maybe<ResolversTypes['CreatePullRequestResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreatePullRequestForNewGlobalHelperArgs, 'input'>
  >;
  createPullRequestForNewPolicy?: Resolver<
    Maybe<ResolversTypes['CreatePullRequestResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreatePullRequestForNewPolicyArgs, 'input'>
  >;
  createPullRequestForNewRule?: Resolver<
    Maybe<ResolversTypes['CreatePullRequestResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreatePullRequestForNewRuleArgs, 'input'>
  >;
  createPullRequestForNewSavedQuery?: Resolver<
    Maybe<ResolversTypes['CreatePullRequestResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreatePullRequestForNewSavedQueryArgs, 'input'>
  >;
  createPullRequestForPolicyEdit?: Resolver<
    Maybe<ResolversTypes['CreatePullRequestResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreatePullRequestForPolicyEditArgs, 'input'>
  >;
  createPullRequestForRuleEdit?: Resolver<
    Maybe<ResolversTypes['CreatePullRequestResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreatePullRequestForRuleEditArgs, 'input'>
  >;
  createPullRequestForSavedQueryDeletion?: Resolver<
    Maybe<ResolversTypes['CreatePullRequestResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreatePullRequestForSavedQueryDeletionArgs, 'input'>
  >;
  createPullRequestForSavedQueryEdit?: Resolver<
    Maybe<ResolversTypes['CreatePullRequestResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreatePullRequestForSavedQueryEditArgs, 'input'>
  >;
  createRSAKey?: Resolver<
    ResolversTypes['RSAKey'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateRSAKeyArgs, 'input'>
  >;
  createReplay?: Resolver<
    ResolversTypes['CreateReplayOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateReplayArgs, 'input'>
  >;
  createRole?: Resolver<
    ResolversTypes['CreateRoleOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateRoleArgs, 'input'>
  >;
  createS3Source?: Resolver<
    ResolversTypes['CreateS3SourceOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateS3SourceArgs, 'input'>
  >;
  createScheduledPrompt?: Resolver<
    ResolversTypes['ScheduledPrompt'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateScheduledPromptArgs, 'input'>
  >;
  decideToolInvocation?: Resolver<
    ResolversTypes['AIToolInvocation'],
    ParentType,
    ContextType,
    RequireFields<MutationDecideToolInvocationArgs, 'input'>
  >;
  deleteAISkill?: Resolver<
    ResolversTypes['DeleteAISkillOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationDeleteAISkillArgs, 'id'>
  >;
  deleteAPIToken?: Resolver<
    ResolversTypes['DeleteAPITokenOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationDeleteAPITokenArgs, 'id'>
  >;
  deleteAlertContextTag?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType,
    Partial<MutationDeleteAlertContextTagArgs>
  >;
  deleteAnalysisPackSource?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteAnalysisPackSourceArgs, 'input'>
  >;
  deleteCloudAccount?: Resolver<
    ResolversTypes['DeleteCloudAccountOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationDeleteCloudAccountArgs, 'input'>
  >;
  deleteDashboard?: Resolver<
    ResolversTypes['Dashboard'],
    ParentType,
    ContextType,
    RequireFields<MutationDeleteDashboardArgs, 'id'>
  >;
  deleteDataModel?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteDataModelArgs, 'input'>
  >;
  deleteDestination?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteDestinationArgs, 'id'>
  >;
  deleteDetectionFilter?: Resolver<
    ResolversTypes['DetectionFilter'],
    ParentType,
    ContextType,
    RequireFields<MutationDeleteDetectionFilterArgs, 'detectionId'>
  >;
  deleteDetections?: Resolver<
    ResolversTypes['DeleteDetectionsOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationDeleteDetectionsArgs, 'input'>
  >;
  deleteEnrichmentIntegration?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteEnrichmentIntegrationArgs, 'input'>
  >;
  deleteGitConfig?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteGitConfigArgs, 'input'>
  >;
  deleteGlobalHelpers?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteGlobalHelpersArgs, 'input'>
  >;
  deleteLogIntegration?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteLogIntegrationArgs, 'id'>
  >;
  deleteLogIntegrationEventThresholdAlarm?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteLogIntegrationEventThresholdAlarmArgs, 'integrationId'>
  >;
  deleteLookups?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteLookupsArgs, 'input'>
  >;
  deleteMcpServer?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType,
    RequireFields<MutationDeleteMcpServerArgs, 'id'>
  >;
  deleteRole?: Resolver<
    ResolversTypes['DeleteRoleOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationDeleteRoleArgs, 'input'>
  >;
  deleteRuleV2?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteRuleV2Args, 'id'>
  >;
  deleteSavedQueries?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteSavedQueriesArgs, 'input'>
  >;
  deleteSavedQueriesByName?: Resolver<
    ResolversTypes['DeleteSavedQueriesByNameOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationDeleteSavedQueriesByNameArgs, 'input'>
  >;
  deleteScheduledPrompt?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType,
    RequireFields<MutationDeleteScheduledPromptArgs, 'input'>
  >;
  deleteSource?: Resolver<
    ResolversTypes['DeleteSourceOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationDeleteSourceArgs, 'input'>
  >;
  deleteUser?: Resolver<
    ResolversTypes['DeleteUserOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationDeleteUserArgs, 'input'>
  >;
  deliverAlert?: Resolver<
    ResolversTypes['Alert'],
    ParentType,
    ContextType,
    RequireFields<MutationDeliverAlertArgs, 'input'>
  >;
  disconnectMcpServer?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType,
    RequireFields<MutationDisconnectMcpServerArgs, 'serverId'>
  >;
  discoverMcpServer?: Resolver<
    ResolversTypes['McpServerDiscovery'],
    ParentType,
    ContextType,
    RequireFields<MutationDiscoverMcpServerArgs, 'input'>
  >;
  editAIInferenceStream?: Resolver<
    ResolversTypes['AIInferenceStream'],
    ParentType,
    ContextType,
    RequireFields<MutationEditAIInferenceStreamArgs, 'input'>
  >;
  executeDataLakeQuery?: Resolver<
    ResolversTypes['ExecuteDataLakeQueryOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationExecuteDataLakeQueryArgs, 'input'>
  >;
  executeIndicatorSearchQuery?: Resolver<
    ResolversTypes['ExecuteIndicatorSearchQueryOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationExecuteIndicatorSearchQueryArgs, 'input'>
  >;
  executeSimpleSearchQuery?: Resolver<
    ResolversTypes['ExecuteSimpleSearchQueryOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationExecuteSimpleSearchQueryArgs, 'input'>
  >;
  executeUberSearch?: Resolver<
    ResolversTypes['ExecuteUberSearchOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationExecuteUberSearchArgs, 'input'>
  >;
  executeUberSearchPropertySummary?: Resolver<
    ResolversTypes['ExecuteUberSearchPropertySummaryOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationExecuteUberSearchPropertySummaryArgs, 'input'>
  >;
  generateAIAttachmentUploadUrl?: Resolver<
    ResolversTypes['AIAttachmentUploadUrl'],
    ParentType,
    ContextType,
    RequireFields<MutationGenerateAIAttachmentUploadUrlArgs, 'contentType'>
  >;
  generateLookupImportUrl?: Resolver<
    Maybe<ResolversTypes['LookupS3ImportConfig']>,
    ParentType,
    ContextType,
    RequireFields<MutationGenerateLookupImportUrlArgs, 'input'>
  >;
  generateS3SampleDataUpload?: Resolver<
    ResolversTypes['GenerateS3SampleUploadResponse'],
    ParentType,
    ContextType,
    Partial<MutationGenerateS3SampleDataUploadArgs>
  >;
  generateSchemaFromSql?: Resolver<
    ResolversTypes['GenerateSchemaFromSqlJob'],
    ParentType,
    ContextType,
    RequireFields<MutationGenerateSchemaFromSqlArgs, 'input'>
  >;
  grantMcpServerAccess?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType,
    RequireFields<MutationGrantMcpServerAccessArgs, 'input'>
  >;
  importLookupData?: Resolver<
    ResolversTypes['LookupImportDataJob'],
    ParentType,
    ContextType,
    RequireFields<MutationImportLookupDataArgs, 'input'>
  >;
  inferSchema?: Resolver<
    Maybe<ResolversTypes['InferSchemaResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationInferSchemaArgs, 'input'>
  >;
  inferSchemaFromBucketData?: Resolver<
    ResolversTypes['Job'],
    ParentType,
    ContextType,
    RequireFields<MutationInferSchemaFromBucketDataArgs, 'input'>
  >;
  inferSchemaFromRawData?: Resolver<
    ResolversTypes['Job'],
    ParentType,
    ContextType,
    RequireFields<MutationInferSchemaFromRawDataArgs, 'input'>
  >;
  initiateMcpAuthorization?: Resolver<
    ResolversTypes['McpAuthorizationResponse'],
    ParentType,
    ContextType,
    RequireFields<MutationInitiateMcpAuthorizationArgs, 'input'>
  >;
  installCatalogDataModel?: Resolver<
    ResolversTypes['InstallCatalogDataModelOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationInstallCatalogDataModelArgs, 'id'>
  >;
  installCatalogDetection?: Resolver<
    ResolversTypes['InstallCatalogDetectionOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationInstallCatalogDetectionArgs, 'id'>
  >;
  installCatalogEnrichment?: Resolver<
    ResolversTypes['InstallCatalogEnrichmentOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationInstallCatalogEnrichmentArgs, 'id'>
  >;
  installCatalogGlobalHelper?: Resolver<
    ResolversTypes['InstallCatalogGlobalHelperOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationInstallCatalogGlobalHelperArgs, 'id'>
  >;
  installCatalogQuery?: Resolver<
    ResolversTypes['InstallCatalogQueryOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationInstallCatalogQueryArgs, 'queryName'>
  >;
  inviteUser?: Resolver<
    ResolversTypes['InviteUserOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationInviteUserArgs, 'input'>
  >;
  markAllNotificationsAsRead?: Resolver<
    ResolversTypes['MarkAllNotificationsAsReadOutput'],
    ParentType,
    ContextType,
    Partial<MutationMarkAllNotificationsAsReadArgs>
  >;
  markNotificationAsRead?: Resolver<
    ResolversTypes['Notification'],
    ParentType,
    ContextType,
    RequireFields<MutationMarkNotificationAsReadArgs, 'input'>
  >;
  migratePacksToCatalog?: Resolver<ResolversTypes['PackMigrationResult'], ParentType, ContextType>;
  parseRunbook?: Resolver<
    ResolversTypes['ParseRunbookOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationParseRunbookArgs, 'input'>
  >;
  patchAlertsById?: Resolver<
    ResolversTypes['PatchAlertsByIdOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationPatchAlertsByIdArgs, 'input'>
  >;
  putAlertContextTag?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType,
    Partial<MutationPutAlertContextTagArgs>
  >;
  putCorrelationRule?: Resolver<
    Maybe<ResolversTypes['CorrelationRule']>,
    ParentType,
    ContextType,
    RequireFields<MutationPutCorrelationRuleArgs, 'input'>
  >;
  putNotificationPreferences?: Resolver<
    ResolversTypes['NotificationPreferencesOutput'],
    ParentType,
    ContextType,
    Partial<MutationPutNotificationPreferencesArgs>
  >;
  putUserPreferences?: Resolver<
    ResolversTypes['UserPreferencesOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationPutUserPreferencesArgs, 'input'>
  >;
  refreshLogSourceHealth?: Resolver<
    ResolversTypes['LogIntegration'],
    ParentType,
    ContextType,
    RequireFields<MutationRefreshLogSourceHealthArgs, 'id'>
  >;
  renameAlertContextTag?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType,
    Partial<MutationRenameAlertContextTagArgs>
  >;
  requestSource?: Resolver<
    Maybe<ResolversTypes['RequestSourceOutput']>,
    ParentType,
    ContextType,
    RequireFields<MutationRequestSourceArgs, 'input'>
  >;
  resetUserPassword?: Resolver<
    ResolversTypes['ResetUserPasswordOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationResetUserPasswordArgs, 'input'>
  >;
  resolveAlarmAndReclassify?: Resolver<
    Maybe<ResolversTypes['ReclassifySourceAlarmJob']>,
    ParentType,
    ContextType,
    RequireFields<MutationResolveAlarmAndReclassifyArgs, 'input'>
  >;
  resolveSourceAlarm?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<MutationResolveSourceAlarmArgs, 'input'>
  >;
  restoreDashboard?: Resolver<
    ResolversTypes['Dashboard'],
    ParentType,
    ContextType,
    RequireFields<MutationRestoreDashboardArgs, 'id'>
  >;
  revokeMcpServerAccess?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType,
    RequireFields<MutationRevokeMcpServerAccessArgs, 'input'>
  >;
  rotateAPIToken?: Resolver<ResolversTypes['RotateAPITokenOutput'], ParentType, ContextType>;
  rotateAPITokenByID?: Resolver<
    ResolversTypes['RotateAPITokenOutput'],
    ParentType,
    ContextType,
    Partial<MutationRotateAPITokenByIDArgs>
  >;
  runScheduledPromptNow?: Resolver<
    ResolversTypes['RunScheduledPromptNowOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationRunScheduledPromptNowArgs, 'input'>
  >;
  saveResolvedWorkbenchAnalysisItems?: Resolver<
    ResolversTypes['SaveResolvedWorkbenchAnalysisItemsOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationSaveResolvedWorkbenchAnalysisItemsArgs, 'input'>
  >;
  sendJiraEvent?: Resolver<
    Maybe<ResolversTypes['SendJiraEventOutput']>,
    ParentType,
    ContextType,
    Partial<MutationSendJiraEventArgs>
  >;
  sendUserFeedback?: Resolver<
    ResolversTypes['SendUserFeedbackOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationSendUserFeedbackArgs, 'input'>
  >;
  serializeRunbook?: Resolver<
    ResolversTypes['SerializeRunbookOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationSerializeRunbookArgs, 'input'>
  >;
  setLogIntegrationEventThresholdAlarm?: Resolver<
    ResolversTypes['EventThresholdAlarm'],
    ParentType,
    ContextType,
    RequireFields<MutationSetLogIntegrationEventThresholdAlarmArgs, 'input'>
  >;
  signOutUserSessions?: Resolver<
    ResolversTypes['SignOutSessionsOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationSignOutUserSessionsArgs, 'userId'>
  >;
  startAsyncDownloadOfAllQueryResults?: Resolver<
    ResolversTypes['StartAsyncDownloadOfAllQueryResultsOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationStartAsyncDownloadOfAllQueryResultsArgs, 'input'>
  >;
  stopReplay?: Resolver<
    ResolversTypes['StopReplayOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationStopReplayArgs, 'input'>
  >;
  summarizeDataLakeQuery?: Resolver<
    ResolversTypes['SummarizeDataLakeQueryJob'],
    ParentType,
    ContextType,
    RequireFields<MutationSummarizeDataLakeQueryArgs, 'input'>
  >;
  suppressPolicies?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<MutationSuppressPoliciesArgs, 'input'>
  >;
  syncLookupData?: Resolver<
    ResolversTypes['LookupSyncJob'],
    ParentType,
    ContextType,
    RequireFields<MutationSyncLookupDataArgs, 'input'>
  >;
  testCorrelationRule?: Resolver<
    ResolversTypes['TestCorrelationRuleResponse'],
    ParentType,
    ContextType,
    RequireFields<MutationTestCorrelationRuleArgs, 'input'>
  >;
  testCorrelationRuleYAML?: Resolver<
    Maybe<ResolversTypes['TestCorrelationRuleYAMLOutput']>,
    ParentType,
    ContextType,
    RequireFields<MutationTestCorrelationRuleYAMLArgs, 'input'>
  >;
  testHoldingTankSchemas?: Resolver<
    ResolversTypes['Job'],
    ParentType,
    ContextType,
    RequireFields<MutationTestHoldingTankSchemasArgs, 'input'>
  >;
  testMcpServerConnection?: Resolver<
    ResolversTypes['McpConnectionTestResult'],
    ParentType,
    ContextType,
    RequireFields<MutationTestMcpServerConnectionArgs, 'serverId'>
  >;
  testPolicy?: Resolver<
    ResolversTypes['TestPolicyResponse'],
    ParentType,
    ContextType,
    RequireFields<MutationTestPolicyArgs, 'input'>
  >;
  testPollGit?: Resolver<Maybe<ResolversTypes['TestPollGitResponse']>, ParentType, ContextType>;
  testRule?: Resolver<
    ResolversTypes['TestRuleResponse'],
    ParentType,
    ContextType,
    RequireFields<MutationTestRuleArgs, 'input'>
  >;
  testSchema?: Resolver<
    Maybe<ResolversTypes['TestSchemaResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationTestSchemaArgs, 'input'>
  >;
  toggleScheduledPrompt?: Resolver<
    ResolversTypes['ScheduledPrompt'],
    ParentType,
    ContextType,
    RequireFields<MutationToggleScheduledPromptArgs, 'input'>
  >;
  transpileFilters?: Resolver<
    Maybe<ResolversTypes['TranspileFiltersOutput']>,
    ParentType,
    ContextType,
    RequireFields<MutationTranspileFiltersArgs, 'input'>
  >;
  transpileSimpleDetectionsToPython?: Resolver<
    Maybe<ResolversTypes['TranspileSimpleDetectionsToPythonOutput']>,
    ParentType,
    ContextType,
    RequireFields<MutationTranspileSimpleDetectionsToPythonArgs, 'input'>
  >;
  updateAIConversation?: Resolver<
    ResolversTypes['AIConversation'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateAIConversationArgs, 'input'>
  >;
  updateAISkill?: Resolver<
    ResolversTypes['UpdateAISkillOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateAISkillArgs, 'input'>
  >;
  updateAPIToken?: Resolver<
    ResolversTypes['UpdateAPITokenOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateAPITokenArgs, 'input'>
  >;
  updateAlertStatusByFilter?: Resolver<
    ResolversTypes['UpdateAlertStatusByFilterJob'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateAlertStatusByFilterArgs, 'input'>
  >;
  updateAlertStatusById?: Resolver<
    ResolversTypes['UpdateAlertStatusByIdOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateAlertStatusByIdArgs, 'input'>
  >;
  updateAlertsAssigneeByEmail?: Resolver<
    ResolversTypes['UpdateAlertsAssigneeByEmailOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateAlertsAssigneeByEmailArgs, 'input'>
  >;
  updateAlertsAssigneeById?: Resolver<
    ResolversTypes['UpdateAlertsAssigneeByIdOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateAlertsAssigneeByIdArgs, 'input'>
  >;
  updateAllCatalogItems?: Resolver<
    ResolversTypes['UpdateAllCatalogItemsJob'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateAllCatalogItemsArgs, 'input'>
  >;
  updateAnalysisPack?: Resolver<
    ResolversTypes['AnalysisPack'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateAnalysisPackArgs, 'input'>
  >;
  updateAnalysisPackSource?: Resolver<
    ResolversTypes['AnalysisPackSource'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateAnalysisPackSourceArgs, 'input'>
  >;
  updateAzureBlobSource?: Resolver<
    ResolversTypes['UpdateAzureBlobSourceOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateAzureBlobSourceArgs, 'input'>
  >;
  updateCatalogItem?: Resolver<
    ResolversTypes['UpdateCatalogItemOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateCatalogItemArgs, 'input'>
  >;
  updateCloudAccount?: Resolver<
    ResolversTypes['UpdateCloudAccountOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateCloudAccountArgs, 'input'>
  >;
  updateDashboard?: Resolver<
    ResolversTypes['Dashboard'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateDashboardArgs, 'input'>
  >;
  updateDataModel?: Resolver<
    ResolversTypes['DataModel'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateDataModelArgs, 'input'>
  >;
  updateDestination?: Resolver<
    Maybe<ResolversTypes['Destination']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateDestinationArgs, 'input'>
  >;
  updateDetectionFilter?: Resolver<
    ResolversTypes['DetectionFilter'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateDetectionFilterArgs, 'input'>
  >;
  updateEnrichmentIntegration?: Resolver<
    ResolversTypes['EnrichmentIntegration'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateEnrichmentIntegrationArgs, 'input'>
  >;
  updateGeneralSettings?: Resolver<
    ResolversTypes['GeneralSettingsConfig'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateGeneralSettingsArgs, 'input'>
  >;
  updateGitHubAppConfig?: Resolver<
    Maybe<ResolversTypes['UpdateGitHubAppConfigResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateGitHubAppConfigArgs, 'input'>
  >;
  updateGlobalHelper?: Resolver<
    ResolversTypes['GlobalHelper'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateGlobalHelperArgs, 'input'>
  >;
  updateLogSource?: Resolver<
    ResolversTypes['LogIntegration'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateLogSourceArgs, 'input'>
  >;
  updateLogSourceFilters?: Resolver<
    ResolversTypes['SourceFilters'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateLogSourceFiltersArgs, 'input'>
  >;
  updateLookup?: Resolver<
    ResolversTypes['Lookup'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateLookupArgs, 'input'>
  >;
  updateLookupAsync?: Resolver<
    ResolversTypes['SaveLookupJob'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateLookupAsyncArgs, 'input'>
  >;
  updateMcpServer?: Resolver<
    ResolversTypes['McpServer'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateMcpServerArgs, 'input'>
  >;
  updateMcpToolSettings?: Resolver<
    Array<ResolversTypes['McpTool']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateMcpToolSettingsArgs, 'input'>
  >;
  updateMitreReportMapping?: Resolver<
    ResolversTypes['UpdateMitreReportMappingOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateMitreReportMappingArgs, 'input'>
  >;
  updateMitreReportSettings?: Resolver<
    ResolversTypes['ReportSetting'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateMitreReportSettingsArgs, 'input'>
  >;
  updateNotification?: Resolver<
    ResolversTypes['Notification'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateNotificationArgs, 'input'>
  >;
  updatePolicy?: Resolver<
    Maybe<ResolversTypes['Policy']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdatePolicyArgs, 'input'>
  >;
  updateQueryUserConfig?: Resolver<
    ResolversTypes['DataLakeQuery'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateQueryUserConfigArgs, 'input'>
  >;
  updateRole?: Resolver<
    ResolversTypes['UpdateRoleOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateRoleArgs, 'input'>
  >;
  updateRuleAndFilter?: Resolver<
    Maybe<ResolversTypes['Rule']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateRuleAndFilterArgs, 'input'>
  >;
  updateRuleV2?: Resolver<
    Maybe<ResolversTypes['UpdateRuleV2Output']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateRuleV2Args, 'input'>
  >;
  updateS3Source?: Resolver<
    ResolversTypes['UpdateS3SourceOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateS3SourceArgs, 'input'>
  >;
  updateSamlConfig?: Resolver<
    ResolversTypes['SamlConfig'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateSamlConfigArgs, 'input'>
  >;
  updateSavedQuery?: Resolver<
    ResolversTypes['SavedQuery'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateSavedQueryArgs, 'input'>
  >;
  updateScheduledPrompt?: Resolver<
    ResolversTypes['ScheduledPrompt'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateScheduledPromptArgs, 'input'>
  >;
  updateSchemaStatus?: Resolver<
    ResolversTypes['GetSchemaOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateSchemaStatusArgs, 'input'>
  >;
  updateUser?: Resolver<
    ResolversTypes['UpdateUserOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateUserArgs, 'input'>
  >;
  updateUserNotifications?: Resolver<
    ResolversTypes['UpdateUserNotificationsOutput'],
    ParentType,
    ContextType,
    Partial<MutationUpdateUserNotificationsArgs>
  >;
  uploadDetectionEntities?: Resolver<
    Maybe<ResolversTypes['UploadDetectionEntitiesOutput']>,
    ParentType,
    ContextType,
    RequireFields<MutationUploadDetectionEntitiesArgs, 'input'>
  >;
  uploadDetectionEntitiesAsync?: Resolver<
    Maybe<ResolversTypes['UploadDetectionEntitiesAsyncOutput']>,
    ParentType,
    ContextType,
    RequireFields<MutationUploadDetectionEntitiesAsyncArgs, 'input'>
  >;
  validateAndTestAllAnalysisItems?: Resolver<
    ResolversTypes['ValidateAndTestAllAnalysisItemsOutput'],
    ParentType,
    ContextType,
    RequireFields<MutationValidateAndTestAllAnalysisItemsArgs, 'input'>
  >;
  validateBulkUpload?: Resolver<
    Maybe<ResolversTypes['ValidateBulkUploadOutput']>,
    ParentType,
    ContextType,
    RequireFields<MutationValidateBulkUploadArgs, 'input'>
  >;
};

export type NamedMitreAttackResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['NamedMitreAttack'] =
    ResolversParentTypes['NamedMitreAttack'],
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NetskopeConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['NetskopeConfig'] =
    ResolversParentTypes['NetskopeConfig'],
> = {
  apiToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationDomain?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NetworkingInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['NetworkingInfo'] =
    ResolversParentTypes['NetworkingInfo'],
> = {
  publicIp?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Notification'] = ResolversParentTypes['Notification'],
> = {
  archivedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  level?: Resolver<ResolversTypes['NotificationLevel'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['NotificationMetadata']>, ParentType, ContextType>;
  readAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  topic?: Resolver<ResolversTypes['NotificationTopic'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationChannelResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['NotificationChannel'] =
    ResolversParentTypes['NotificationChannel'],
> = {
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationMetadataResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['NotificationMetadata'] =
    ResolversParentTypes['NotificationMetadata'],
> = {
  alertID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originalQueryId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  presignedUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  presignedUrlKeepAliveDuration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  presignedUrlTtl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationPreferenceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['NotificationPreference'] =
    ResolversParentTypes['NotificationPreference'],
> = {
  channels?: Resolver<Array<ResolversTypes['NotificationChannel']>, ParentType, ContextType>;
  topic?: Resolver<ResolversTypes['NotificationTopic'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationPreferencesOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['NotificationPreferencesOutput'] =
    ResolversParentTypes['NotificationPreferencesOutput'],
> = {
  preferences?: Resolver<Array<ResolversTypes['NotificationPreference']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationsOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['NotificationsOutput'] =
    ResolversParentTypes['NotificationsOutput'],
> = {
  edges?: Resolver<Array<ResolversTypes['NotificationsOutputEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['NotificationsPageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationsOutputEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['NotificationsOutputEdge'] =
    ResolversParentTypes['NotificationsOutputEdge'],
> = {
  node?: Resolver<ResolversTypes['Notification'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationsPageInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['NotificationsPageInfo'] =
    ResolversParentTypes['NotificationsPageInfo'],
> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OAuth2InfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OAuth2Info'] = ResolversParentTypes['OAuth2Info'],
> = {
  mustAuthorize?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OAuthConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OAuthConfig'] = ResolversParentTypes['OAuthConfig'],
> = {
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OTLPConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OTLPConfig'] = ResolversParentTypes['OTLPConfig'],
> = {
  logProcessingRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  queueUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  s3Bucket?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  s3Prefix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  securityHeaderKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  securityPassword?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  securitySecretValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  securityType?: Resolver<ResolversTypes['OTLPSecurityType'], ParentType, ContextType>;
  securityUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OTLPLogIntegrationHealthResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OTLPLogIntegrationHealth'] =
    ResolversParentTypes['OTLPLogIntegrationHealth'],
> = {
  classificationFailuresStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  logProcessingErrorsStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  otlpStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  systemAlarmStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OTLPLogSourceIntegrationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OTLPLogSourceIntegration'] =
    ResolversParentTypes['OTLPLogSourceIntegration'],
> = {
  alarms?: Resolver<ResolversTypes['LogIntegrationAlarms'], ParentType, ContextType>;
  createdAtTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  filters?: Resolver<ResolversTypes['SourceFilters'], ParentType, ContextType>;
  health?: Resolver<ResolversTypes['OTLPLogIntegrationHealth'], ParentType, ContextType>;
  integrationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  integrationLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  integrationType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isEditable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isHealthy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPantherManaged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastEventProcessedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastEventReceivedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastModified?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  logProviderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  otlpConfig?: Resolver<ResolversTypes['OTLPConfig'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OTLPOptionsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OTLPOptions'] = ResolversParentTypes['OTLPOptions'],
> = {
  securityHeaderKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  securityType?: Resolver<Maybe<ResolversTypes['OTLPSecurityType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OTXConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OTXConfig'] = ResolversParentTypes['OTXConfig'],
> = {
  apiToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  maxAgeDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  profilePullers?: Resolver<ResolversTypes['OTXProfilePullerConfig'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OTXProfilePullerConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OTXProfilePullerConfig'] =
    ResolversParentTypes['OTXProfilePullerConfig'],
> = {
  pulses?: Resolver<ResolversTypes['ProfilePullerConfig'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OktaConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OktaConfig'] = ResolversParentTypes['OktaConfig'],
> = {
  apiToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  domain?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profilePullers?: Resolver<
    Maybe<ResolversTypes['OktaProfilePullerConfig']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OktaProfilePullerConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OktaProfilePullerConfig'] =
    ResolversParentTypes['OktaProfilePullerConfig'],
> = {
  devices?: Resolver<Maybe<ResolversTypes['ProfilePullerConfig']>, ParentType, ContextType>;
  users?: Resolver<Maybe<ResolversTypes['ProfilePullerConfig']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OnePasswordConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OnePasswordConfig'] =
    ResolversParentTypes['OnePasswordConfig'],
> = {
  host?: Resolver<ResolversTypes['OnePasswordHost'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OpenAIConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OpenAIConfig'] = ResolversParentTypes['OpenAIConfig'],
> = {
  apiKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OpsgenieConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OpsgenieConfig'] =
    ResolversParentTypes['OpsgenieConfig'],
> = {
  apiKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  serviceRegion?: Resolver<ResolversTypes['OpsgenieServiceRegionEnum'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationReportBySeverityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OrganizationReportBySeverity'] =
    ResolversParentTypes['OrganizationReportBySeverity'],
> = {
  critical?: Resolver<Maybe<ResolversTypes['ComplianceStatusCounts']>, ParentType, ContextType>;
  high?: Resolver<Maybe<ResolversTypes['ComplianceStatusCounts']>, ParentType, ContextType>;
  info?: Resolver<Maybe<ResolversTypes['ComplianceStatusCounts']>, ParentType, ContextType>;
  low?: Resolver<Maybe<ResolversTypes['ComplianceStatusCounts']>, ParentType, ContextType>;
  medium?: Resolver<Maybe<ResolversTypes['ComplianceStatusCounts']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationStatsResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OrganizationStatsResponse'] =
    ResolversParentTypes['OrganizationStatsResponse'],
> = {
  appliedPolicies?: Resolver<
    Maybe<ResolversTypes['OrganizationReportBySeverity']>,
    ParentType,
    ContextType
  >;
  scannedResources?: Resolver<Maybe<ResolversTypes['ScannedResources']>, ParentType, ContextType>;
  topFailingPolicies?: Resolver<Array<ResolversTypes['Policy']>, ParentType, ContextType>;
  topFailingResources?: Resolver<Array<ResolversTypes['ResourceSummary']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PackMigrationFailureResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PackMigrationFailure'] =
    ResolversParentTypes['PackMigrationFailure'],
> = {
  analysisType?: Resolver<ResolversTypes['AnalysisType'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PackMigrationResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PackMigrationResult'] =
    ResolversParentTypes['PackMigrationResult'],
> = {
  failed?: Resolver<Array<ResolversTypes['PackMigrationFailure']>, ParentType, ContextType>;
  migrated?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  skippedAlreadyMigrated?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  skippedOrphan?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PackMigrationStatusResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PackMigrationStatus'] =
    ResolversParentTypes['PackMigrationStatus'],
> = {
  itemCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  needsMigration?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo'],
> = {
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  paginationToken?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PagerDutyConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PagerDutyConfig'] =
    ResolversParentTypes['PagerDutyConfig'],
> = {
  integrationKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PagingDataResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PagingData'] = ResolversParentTypes['PagingData'],
> = {
  thisPage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalItems?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalPages?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PantherAIAutoResolveConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PantherAIAutoResolveConfig'] =
    ResolversParentTypes['PantherAIAutoResolveConfig'],
> = {
  enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  riskScoreThreshold?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  severities?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PantherAIAutoRunOnAlertConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PantherAIAutoRunOnAlertConfig'] =
    ResolversParentTypes['PantherAIAutoRunOnAlertConfig'],
> = {
  deferNotifications?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  deferNotificationsTimeoutMinutes?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  runAsUser?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  runAsUserId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  severities?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PantherAIKendraConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PantherAIKendraConfig'] =
    ResolversParentTypes['PantherAIKendraConfig'],
> = {
  dataSourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  indexId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PantherAIRemoteMCPConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PantherAIRemoteMCPConfig'] =
    ResolversParentTypes['PantherAIRemoteMCPConfig'],
> = {
  allowedCustomSchemes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  allowedRedirectDomains?: Resolver<
    Maybe<Array<ResolversTypes['String']>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PantherAIWebToolConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PantherAIWebToolConfig'] =
    ResolversParentTypes['PantherAIWebToolConfig'],
> = {
  approvedDomains?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  forbiddenDomains?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  requiresApproval?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PantherFlowQueryWithParametersOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PantherFlowQueryWithParametersOutput'] =
    ResolversParentTypes['PantherFlowQueryWithParametersOutput'],
> = {
  query?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ParseRunbookOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ParseRunbookOutput'] =
    ResolversParentTypes['ParseRunbookOutput'],
> = {
  runbook?: Resolver<Maybe<ResolversTypes['Runbook']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatchAlertsByIdOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PatchAlertsByIdOutput'] =
    ResolversParentTypes['PatchAlertsByIdOutput'],
> = {
  alerts?: Resolver<Array<ResolversTypes['Alert']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PolicyResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Policy'] = ResolversParentTypes['Policy'],
> = {
  analysisType?: Resolver<ResolversTypes['DetectionType'], ParentType, ContextType>;
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  complianceStatus?: Resolver<
    Maybe<ResolversTypes['ComplianceStatusEnum']>,
    ParentType,
    ContextType
  >;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  createdByExternal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isSimpleDetection?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastModified?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  managed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  outputIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  parentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reports?: Resolver<Array<ResolversTypes['DetectionReportMapping']>, ParentType, ContextType>;
  resourceTypes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  runbook?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  severity?: Resolver<ResolversTypes['Severity'], ParentType, ContextType>;
  suppressions?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  tags?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  tests?: Resolver<Array<ResolversTypes['DetectionTestDefinition']>, ParentType, ContextType>;
  versionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfilePullerConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ProfilePullerConfig'] =
    ResolversParentTypes['ProfilePullerConfig'],
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  refreshPeriodMin?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PullerConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PullerConfig'] = ResolversParentTypes['PullerConfig'],
> = {
  anomali?: Resolver<Maybe<ResolversTypes['AnomaliConfig']>, ParentType, ContextType>;
  anthropic?: Resolver<Maybe<ResolversTypes['AnthropicConfig']>, ParentType, ContextType>;
  asana?: Resolver<Maybe<ResolversTypes['AsanaLogSourceConfig']>, ParentType, ContextType>;
  atlassian?: Resolver<Maybe<ResolversTypes['AtlassianConfig']>, ParentType, ContextType>;
  bitwarden?: Resolver<Maybe<ResolversTypes['BitwardenConfig']>, ParentType, ContextType>;
  box?: Resolver<Maybe<ResolversTypes['OAuthConfig']>, ParentType, ContextType>;
  crowdstrike?: Resolver<Maybe<ResolversTypes['CrowdstrikeConfig']>, ParentType, ContextType>;
  crowdstrikeEventStreams?: Resolver<
    Maybe<ResolversTypes['CrowdstrikeEventStreamsConfig']>,
    ParentType,
    ContextType
  >;
  dropbox?: Resolver<Maybe<ResolversTypes['OAuthConfig']>, ParentType, ContextType>;
  duo?: Resolver<Maybe<ResolversTypes['DuoConfig']>, ParentType, ContextType>;
  generic?: Resolver<Maybe<ResolversTypes['GenericPullerConfig']>, ParentType, ContextType>;
  github?: Resolver<Maybe<ResolversTypes['GithubLogSourceConfig']>, ParentType, ContextType>;
  greynoise?: Resolver<Maybe<ResolversTypes['GreyNoiseConfig']>, ParentType, ContextType>;
  gsuite?: Resolver<Maybe<ResolversTypes['GsuiteConfig']>, ParentType, ContextType>;
  m365?: Resolver<Maybe<ResolversTypes['M365Config']>, ParentType, ContextType>;
  microsoftGraph?: Resolver<Maybe<ResolversTypes['MicrosoftGraphConfig']>, ParentType, ContextType>;
  mongoDb?: Resolver<Maybe<ResolversTypes['MongoDBConfig']>, ParentType, ContextType>;
  netskope?: Resolver<Maybe<ResolversTypes['NetskopeConfig']>, ParentType, ContextType>;
  okta?: Resolver<Maybe<ResolversTypes['OktaConfig']>, ParentType, ContextType>;
  onePassword?: Resolver<Maybe<ResolversTypes['OnePasswordConfig']>, ParentType, ContextType>;
  openai?: Resolver<Maybe<ResolversTypes['OpenAIConfig']>, ParentType, ContextType>;
  rapid7?: Resolver<Maybe<ResolversTypes['Rapid7Config']>, ParentType, ContextType>;
  salesforce?: Resolver<Maybe<ResolversTypes['SalesforceConfig']>, ParentType, ContextType>;
  sentinelOneApi?: Resolver<Maybe<ResolversTypes['SentinelOneApiConfig']>, ParentType, ContextType>;
  sentinelOneCloudFunnel?: Resolver<
    Maybe<ResolversTypes['SentinelOneCloudFunnelConfig']>,
    ParentType,
    ContextType
  >;
  slack?: Resolver<Maybe<ResolversTypes['OAuthConfig']>, ParentType, ContextType>;
  snowflakeaudit?: Resolver<Maybe<ResolversTypes['SnowflakeAuditConfig']>, ParentType, ContextType>;
  snyk?: Resolver<Maybe<ResolversTypes['SnykLogSourceConfig']>, ParentType, ContextType>;
  sysdig?: Resolver<Maybe<ResolversTypes['SysdigConfig']>, ParentType, ContextType>;
  tenable?: Resolver<Maybe<ResolversTypes['TenableConfig']>, ParentType, ContextType>;
  tines?: Resolver<Maybe<ResolversTypes['TinesConfig']>, ParentType, ContextType>;
  wiz?: Resolver<Maybe<ResolversTypes['WizConfig']>, ParentType, ContextType>;
  workday?: Resolver<Maybe<ResolversTypes['WorkdayConfig']>, ParentType, ContextType>;
  zendesk?: Resolver<Maybe<ResolversTypes['ZendeskLogSourceConfig']>, ParentType, ContextType>;
  zoom?: Resolver<Maybe<ResolversTypes['ZoomConfig']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query'],
> = {
  aiConversation?: Resolver<
    ResolversTypes['AIConversation'],
    ParentType,
    ContextType,
    RequireFields<QueryAiConversationArgs, 'id'>
  >;
  aiConversations?: Resolver<
    ResolversTypes['AIConversationsOutput'],
    ParentType,
    ContextType,
    Partial<QueryAiConversationsArgs>
  >;
  aiInferenceStream?: Resolver<
    ResolversTypes['AIInferenceStream'],
    ParentType,
    ContextType,
    RequireFields<QueryAiInferenceStreamArgs, 'streamId'>
  >;
  aiInferenceStreamMetadataWithPath?: Resolver<
    ResolversTypes['AIInferenceStreamMetadataWithPath'],
    ParentType,
    ContextType,
    RequireFields<QueryAiInferenceStreamMetadataWithPathArgs, 'streamId'>
  >;
  aiInferenceStreamTextSearch?: Resolver<
    ResolversTypes['AIInferenceStreamTextSearchResultList'],
    ParentType,
    ContextType,
    RequireFields<QueryAiInferenceStreamTextSearchArgs, 'input'>
  >;
  aiInferenceStreamsMetadata?: Resolver<
    ResolversTypes['AIInferenceStreamsMetadataList'],
    ParentType,
    ContextType,
    RequireFields<QueryAiInferenceStreamsMetadataArgs, 'input'>
  >;
  aiSkill?: Resolver<
    ResolversTypes['AISkillOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryAiSkillArgs, 'id'>
  >;
  aiSkills?: Resolver<
    ResolversTypes['AISkillsOutput'],
    ParentType,
    ContextType,
    Partial<QueryAiSkillsArgs>
  >;
  aiStreamConversationLookup?: Resolver<
    ResolversTypes['AIStreamConversationLookupOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryAiStreamConversationLookupArgs, 'id'>
  >;
  aiUsage?: Resolver<ResolversTypes['AIUsageOutput'], ParentType, ContextType>;
  alert?: Resolver<
    ResolversTypes['Alert'],
    ParentType,
    ContextType,
    RequireFields<QueryAlertArgs, 'id'>
  >;
  alertDashboardData?: Resolver<
    ResolversTypes['AlertDashboardDataOutput'],
    ParentType,
    ContextType,
    Partial<QueryAlertDashboardDataArgs>
  >;
  alerts?: Resolver<
    ResolversTypes['AlertsOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryAlertsArgs, 'input'>
  >;
  allDatalakeSchemaEntities?: Resolver<
    ResolversTypes['AllDatalakeSchemaEntitiesOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryAllDatalakeSchemaEntitiesArgs, 'input'>
  >;
  allDatalakeSchemaProperties?: Resolver<
    ResolversTypes['AllDatalakeSchemaPropertiesOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryAllDatalakeSchemaPropertiesArgs, 'input'>
  >;
  appConfig?: Resolver<ResolversTypes['AppConfig'], ParentType, ContextType>;
  autodetectIndicatorFilters?: Resolver<
    ResolversTypes['AutodetectIndicatorFiltersOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryAutodetectIndicatorFiltersArgs, 'input'>
  >;
  bulkDownload?: Resolver<
    ResolversTypes['BulkDownloadResponse'],
    ParentType,
    ContextType,
    RequireFields<QueryBulkDownloadArgs, 'input'>
  >;
  bulkDownloadScheduledPromptsUrl?: Resolver<
    ResolversTypes['BulkDownloadUrlResponse'],
    ParentType,
    ContextType,
    RequireFields<QueryBulkDownloadScheduledPromptsUrlArgs, 'input'>
  >;
  bulkDownloadSkillsUrl?: Resolver<
    ResolversTypes['BulkDownloadUrlResponse'],
    ParentType,
    ContextType,
    RequireFields<QueryBulkDownloadSkillsUrlArgs, 'input'>
  >;
  bulkDownloadUrl?: Resolver<
    ResolversTypes['BulkDownloadUrlResponse'],
    ParentType,
    ContextType,
    RequireFields<QueryBulkDownloadUrlArgs, 'input'>
  >;
  bulkUploadDetectionsStatus?: Resolver<
    ResolversTypes['BulkUploadJob'],
    ParentType,
    ContextType,
    RequireFields<QueryBulkUploadDetectionsStatusArgs, 'jobId'>
  >;
  bulkUploadPresignedUrl?: Resolver<
    ResolversTypes['BulkUploadPresignedUrlOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryBulkUploadPresignedUrlArgs, 'input'>
  >;
  catalogDataModels?: Resolver<
    ResolversTypes['ListCatalogDataModelsOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryCatalogDataModelsArgs, 'input'>
  >;
  catalogDetections?: Resolver<
    ResolversTypes['ListCatalogDetectionsOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryCatalogDetectionsArgs, 'input'>
  >;
  catalogEnrichments?: Resolver<
    ResolversTypes['ListCatalogEnrichmentsOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryCatalogEnrichmentsArgs, 'input'>
  >;
  catalogGlobalHelpers?: Resolver<
    ResolversTypes['ListCatalogGlobalHelpersOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryCatalogGlobalHelpersArgs, 'input'>
  >;
  catalogQueries?: Resolver<
    ResolversTypes['ListCatalogQueriesOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryCatalogQueriesArgs, 'input'>
  >;
  checkGenerateSchemaFromSqlJob?: Resolver<
    ResolversTypes['GenerateSchemaFromSqlJob'],
    ParentType,
    ContextType,
    RequireFields<QueryCheckGenerateSchemaFromSqlJobArgs, 'id'>
  >;
  checkIfPacksNeedMigrating?: Resolver<
    ResolversTypes['PackMigrationStatus'],
    ParentType,
    ContextType
  >;
  checkLookupImportDataJob?: Resolver<
    ResolversTypes['LookupImportDataJob'],
    ParentType,
    ContextType,
    RequireFields<QueryCheckLookupImportDataJobArgs, 'jobId'>
  >;
  checkSaveLookupJob?: Resolver<
    ResolversTypes['SaveLookupJob'],
    ParentType,
    ContextType,
    RequireFields<QueryCheckSaveLookupJobArgs, 'id'>
  >;
  checkSyncLookupDataJob?: Resolver<
    ResolversTypes['LookupSyncJob'],
    ParentType,
    ContextType,
    RequireFields<QueryCheckSyncLookupDataJobArgs, 'id'>
  >;
  checkUpdateAllCatalogItemsJob?: Resolver<
    Maybe<ResolversTypes['UpdateAllCatalogItemsJob']>,
    ParentType,
    ContextType
  >;
  cloudAccount?: Resolver<
    Maybe<ResolversTypes['CloudAccount']>,
    ParentType,
    ContextType,
    RequireFields<QueryCloudAccountArgs, 'id'>
  >;
  cloudAccounts?: Resolver<
    ResolversTypes['CloudAccountsOutput'],
    ParentType,
    ContextType,
    Partial<QueryCloudAccountsArgs>
  >;
  correlationRule?: Resolver<
    Maybe<ResolversTypes['CorrelationRule']>,
    ParentType,
    ContextType,
    RequireFields<QueryCorrelationRuleArgs, 'input'>
  >;
  dashboard?: Resolver<
    ResolversTypes['Dashboard'],
    ParentType,
    ContextType,
    RequireFields<QueryDashboardArgs, 'id'>
  >;
  dashboards?: Resolver<
    ResolversTypes['DashboardsOutput'],
    ParentType,
    ContextType,
    Partial<QueryDashboardsArgs>
  >;
  dataLakeDatabase?: Resolver<
    ResolversTypes['DataLakeDatabase'],
    ParentType,
    ContextType,
    RequireFields<QueryDataLakeDatabaseArgs, 'name'>
  >;
  dataLakeDatabaseTable?: Resolver<
    ResolversTypes['DataLakeDatabaseTable'],
    ParentType,
    ContextType,
    RequireFields<QueryDataLakeDatabaseTableArgs, 'input'>
  >;
  dataLakeDatabaseTables?: Resolver<
    ResolversTypes['DataLakeDatabaseTablesOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryDataLakeDatabaseTablesArgs, 'input'>
  >;
  dataLakeDatabases?: Resolver<Array<ResolversTypes['DataLakeDatabase']>, ParentType, ContextType>;
  dataLakePropertyDefinitions?: Resolver<
    ResolversTypes['DataLakePropertyDefinitionsOutput'],
    ParentType,
    ContextType,
    Partial<QueryDataLakePropertyDefinitionsArgs>
  >;
  dataLakeQueries?: Resolver<
    ResolversTypes['DataLakeQueriesOutput'],
    ParentType,
    ContextType,
    Partial<QueryDataLakeQueriesArgs>
  >;
  dataLakeQuery?: Resolver<
    ResolversTypes['DataLakeQuery'],
    ParentType,
    ContextType,
    RequireFields<QueryDataLakeQueryArgs, 'id' | 'root'>
  >;
  dataLakeQuerySummary?: Resolver<
    ResolversTypes['SummarizeDataLakeQueryJob'],
    ParentType,
    ContextType,
    RequireFields<QueryDataLakeQuerySummaryArgs, 'jobId'>
  >;
  datalakeFieldValues?: Resolver<
    ResolversTypes['DatalakeFieldValuesOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryDatalakeFieldValuesArgs, 'input'>
  >;
  destination?: Resolver<
    Maybe<ResolversTypes['Destination']>,
    ParentType,
    ContextType,
    RequireFields<QueryDestinationArgs, 'id'>
  >;
  destinations?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Destination']>>>,
    ParentType,
    ContextType
  >;
  detection?: Resolver<
    Maybe<ResolversTypes['GetDetectionResponse']>,
    ParentType,
    ContextType,
    RequireFields<QueryDetectionArgs, 'input'>
  >;
  detectionAlertMetrics?: Resolver<
    ResolversTypes['DetectionAlertMetricsOutput'],
    ParentType,
    ContextType,
    Partial<QueryDetectionAlertMetricsArgs>
  >;
  detectionEntitiesUploadStatus?: Resolver<
    Maybe<ResolversTypes['DetectionEntitiesUploadStatusOutput']>,
    ParentType,
    ContextType,
    RequireFields<QueryDetectionEntitiesUploadStatusArgs, 'receiptId'>
  >;
  detectionFilter?: Resolver<
    ResolversTypes['DetectionFilter'],
    ParentType,
    ContextType,
    RequireFields<QueryDetectionFilterArgs, 'detectionId'>
  >;
  detectionStats?: Resolver<ResolversTypes['DetectionStatsResponse'], ParentType, ContextType>;
  detections?: Resolver<
    ResolversTypes['ListDetectionsResponse'],
    ParentType,
    ContextType,
    Partial<QueryDetectionsArgs>
  >;
  discoverTaxiiCollections?: Resolver<
    ResolversTypes['DiscoverTaxiiCollectionsOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryDiscoverTaxiiCollectionsArgs, 'input'>
  >;
  enrichmentIntegration?: Resolver<
    ResolversTypes['EnrichmentIntegration'],
    ParentType,
    ContextType,
    RequireFields<QueryEnrichmentIntegrationArgs, 'id'>
  >;
  featureFlags?: Resolver<
    ResolversTypes['GetFeatureFlagsResponse'],
    ParentType,
    ContextType,
    RequireFields<QueryFeatureFlagsArgs, 'input'>
  >;
  filterFields?: Resolver<
    ResolversTypes['FilterFieldsOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryFilterFieldsArgs, 'input'>
  >;
  flatFilterFields?: Resolver<
    ResolversTypes['FlatFilterFieldsOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryFlatFilterFieldsArgs, 'input'>
  >;
  generalSettings?: Resolver<ResolversTypes['GeneralSettingsConfig'], ParentType, ContextType>;
  generateAlertSummaryAttributesQueries?: Resolver<
    Array<ResolversTypes['AlertSummaryAttributeForAnalysis']>,
    ParentType,
    ContextType,
    RequireFields<QueryGenerateAlertSummaryAttributesQueriesArgs, 'input'>
  >;
  generateEnrichedEvent?: Resolver<
    ResolversTypes['GenerateEnrichedEventResponse'],
    ParentType,
    ContextType,
    RequireFields<QueryGenerateEnrichedEventArgs, 'input'>
  >;
  generateLogForwarderConfig?: Resolver<
    ResolversTypes['LogForwarderConfigYaml'],
    ParentType,
    ContextType,
    RequireFields<QueryGenerateLogForwarderConfigArgs, 'input'>
  >;
  generateSimpleSearchQuery?: Resolver<
    ResolversTypes['GenerateSimpleSearchQueryOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryGenerateSimpleSearchQueryArgs, 'input'>
  >;
  generateSqlQuerySnippet?: Resolver<
    ResolversTypes['GenerateSqlQuerySnippetOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryGenerateSqlQuerySnippetArgs, 'input'>
  >;
  generateUberSearchQuery?: Resolver<
    ResolversTypes['GenerateUberSearchQueryOutput'],
    ParentType,
    ContextType,
    Partial<QueryGenerateUberSearchQueryArgs>
  >;
  getAPIToken?: Resolver<
    ResolversTypes['GetAPITokenOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryGetAPITokenArgs, 'id'>
  >;
  getAnalysisPack?: Resolver<
    ResolversTypes['AnalysisPack'],
    ParentType,
    ContextType,
    RequireFields<QueryGetAnalysisPackArgs, 'id'>
  >;
  getAnalysisPackSource?: Resolver<
    ResolversTypes['AnalysisPackSource'],
    ParentType,
    ContextType,
    RequireFields<QueryGetAnalysisPackSourceArgs, 'id'>
  >;
  getAsyncQueryDownloadUrl?: Resolver<
    ResolversTypes['GetAsyncQueryDownloadUrlOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryGetAsyncQueryDownloadUrlArgs, 'input'>
  >;
  getAvailableLogProvider?: Resolver<
    ResolversTypes['GetAvailableLogProviderResponse'],
    ParentType,
    ContextType,
    RequireFields<QueryGetAvailableLogProviderArgs, 'id'>
  >;
  getCloudWatchLogIntegrationTemplate?: Resolver<
    ResolversTypes['IntegrationTemplate'],
    ParentType,
    ContextType,
    RequireFields<QueryGetCloudWatchLogIntegrationTemplateArgs, 'input'>
  >;
  getComplianceIntegrationTemplate?: Resolver<
    ResolversTypes['IntegrationTemplate'],
    ParentType,
    ContextType,
    RequireFields<QueryGetComplianceIntegrationTemplateArgs, 'input'>
  >;
  getDataModel?: Resolver<
    Maybe<ResolversTypes['DataModel']>,
    ParentType,
    ContextType,
    RequireFields<QueryGetDataModelArgs, 'id'>
  >;
  getGlobalHelper?: Resolver<
    ResolversTypes['GlobalHelper'],
    ParentType,
    ContextType,
    RequireFields<QueryGetGlobalHelperArgs, 'input'>
  >;
  getLookup?: Resolver<
    ResolversTypes['Lookup'],
    ParentType,
    ContextType,
    RequireFields<QueryGetLookupArgs, 'id'>
  >;
  getLookupCloudFormationRoleTemplate?: Resolver<
    ResolversTypes['IntegrationTemplate'],
    ParentType,
    ContextType,
    RequireFields<QueryGetLookupCloudFormationRoleTemplateArgs, 'input'>
  >;
  getLookupStats?: Resolver<ResolversTypes['LookupStats'], ParentType, ContextType>;
  getRunningTask?: Resolver<
    Maybe<ResolversTypes['Job']>,
    ParentType,
    ContextType,
    RequireFields<QueryGetRunningTaskArgs, 'input'>
  >;
  getS3LogIntegrationTemplate?: Resolver<
    ResolversTypes['IntegrationTemplate'],
    ParentType,
    ContextType,
    RequireFields<QueryGetS3LogIntegrationTemplateArgs, 'input'>
  >;
  getSampleData?: Resolver<
    ResolversTypes['GetSampleDataResponse'],
    ParentType,
    ContextType,
    RequireFields<QueryGetSampleDataArgs, 'input'>
  >;
  getSavedQuery?: Resolver<
    ResolversTypes['SavedQuery'],
    ParentType,
    ContextType,
    RequireFields<QueryGetSavedQueryArgs, 'id'>
  >;
  getSchema?: Resolver<
    ResolversTypes['GetSchemaOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryGetSchemaArgs, 'input'>
  >;
  getTerraformTemplate?: Resolver<
    ResolversTypes['TerraformTemplateResponse'],
    ParentType,
    ContextType,
    RequireFields<QueryGetTerraformTemplateArgs, 'input'>
  >;
  holdingTankJob?: Resolver<
    ResolversTypes['Job'],
    ParentType,
    ContextType,
    RequireFields<QueryHoldingTankJobArgs, 'id'>
  >;
  holdingTankRawData?: Resolver<
    ResolversTypes['HoldingTankRawDataResponse'],
    ParentType,
    ContextType,
    RequireFields<QueryHoldingTankRawDataArgs, 'input'>
  >;
  holdingTankTestSchemasResult?: Resolver<
    ResolversTypes['HoldingTankTestSchemasResultsResponse'],
    ParentType,
    ContextType,
    Partial<QueryHoldingTankTestSchemasResultArgs>
  >;
  infraCostReport?: Resolver<
    ResolversTypes['InfraCostOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryInfraCostReportArgs, 'input'>
  >;
  ingestionMonitoringSummary?: Resolver<
    ResolversTypes['IngestionMonitoringSummary'],
    ParentType,
    ContextType
  >;
  installedCatalogItemUpdateStatuses?: Resolver<
    ResolversTypes['ListInstalledCatalogItemUpdateStatusesOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryInstalledCatalogItemUpdateStatusesArgs, 'input'>
  >;
  installedCatalogItems?: Resolver<
    ResolversTypes['ListInstalledCatalogItemsOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryInstalledCatalogItemsArgs, 'input'>
  >;
  invokableAISkills?: Resolver<
    Array<ResolversTypes['AISkillListItem']>,
    ParentType,
    ContextType,
    Partial<QueryInvokableAISkillsArgs>
  >;
  jiraOrgMetadata?: Resolver<
    Maybe<ResolversTypes['JiraOrgMetadata']>,
    ParentType,
    ContextType,
    RequireFields<QueryJiraOrgMetadataArgs, 'input'>
  >;
  listAPITokens?: Resolver<ResolversTypes['ListAPITokensOutput'], ParentType, ContextType>;
  listAlertContextTags?: Resolver<
    ResolversTypes['ListAlertContextTagsOutput'],
    ParentType,
    ContextType
  >;
  listAnalysisItemsForWorkbench?: Resolver<
    ResolversTypes['ListAnalysisItemsForWorkbenchOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryListAnalysisItemsForWorkbenchArgs, 'input'>
  >;
  listAnalysisPackSources?: Resolver<
    ResolversTypes['ListAnalysisPackSourcesResponse'],
    ParentType,
    ContextType,
    Partial<QueryListAnalysisPackSourcesArgs>
  >;
  listAnalysisPacks?: Resolver<
    ResolversTypes['ListAnalysisPacksResponse'],
    ParentType,
    ContextType,
    Partial<QueryListAnalysisPacksArgs>
  >;
  listAvailableLogProviders?: Resolver<
    ResolversTypes['ListAvailableLogProvidersResponse'],
    ParentType,
    ContextType
  >;
  listAvailableLogTypes?: Resolver<
    ResolversTypes['ListAvailableLogTypesResponse'],
    ParentType,
    ContextType
  >;
  listBucketKeys?: Resolver<
    ResolversTypes['ListBucketKeysResponse'],
    ParentType,
    ContextType,
    RequireFields<QueryListBucketKeysArgs, 'input'>
  >;
  listDataModels?: Resolver<
    ResolversTypes['ListDataModelsResponse'],
    ParentType,
    ContextType,
    RequireFields<QueryListDataModelsArgs, 'input'>
  >;
  listGitConfigs?: Resolver<
    Maybe<ResolversTypes['ListGitConfigsResponse']>,
    ParentType,
    ContextType,
    RequireFields<QueryListGitConfigsArgs, 'input'>
  >;
  listGlobalHelpers?: Resolver<
    ResolversTypes['ListGlobalHelpersResponse'],
    ParentType,
    ContextType,
    RequireFields<QueryListGlobalHelpersArgs, 'input'>
  >;
  listLookups?: Resolver<
    ResolversTypes['ListLookupResponse'],
    ParentType,
    ContextType,
    RequireFields<QueryListLookupsArgs, 'input'>
  >;
  listSavedQueries?: Resolver<
    ResolversTypes['ListSavedQueriesResponse'],
    ParentType,
    ContextType,
    RequireFields<QueryListSavedQueriesArgs, 'input'>
  >;
  listScheduledPrompts?: Resolver<
    ResolversTypes['ListScheduledPromptsResponse'],
    ParentType,
    ContextType,
    Partial<QueryListScheduledPromptsArgs>
  >;
  listTasks?: Resolver<
    ResolversTypes['HoldingTankListTasksResponse'],
    ParentType,
    ContextType,
    RequireFields<QueryListTasksArgs, 'sourceId'>
  >;
  loadAnalysisItemForWorkbench?: Resolver<
    ResolversTypes['LoadAnalysisItemForWorkbenchOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryLoadAnalysisItemForWorkbenchArgs, 'input'>
  >;
  logSource?: Resolver<
    ResolversTypes['LogIntegration'],
    ParentType,
    ContextType,
    RequireFields<QueryLogSourceArgs, 'id'>
  >;
  logSources?: Resolver<Array<Maybe<ResolversTypes['LogIntegration']>>, ParentType, ContextType>;
  lookupEnrich?: Resolver<
    ResolversTypes['LookupEnrichOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryLookupEnrichArgs, 'key'>
  >;
  mcpServer?: Resolver<
    Maybe<ResolversTypes['McpServer']>,
    ParentType,
    ContextType,
    RequireFields<QueryMcpServerArgs, 'id'>
  >;
  mcpServerAccess?: Resolver<
    Array<ResolversTypes['ID']>,
    ParentType,
    ContextType,
    RequireFields<QueryMcpServerAccessArgs, 'serverId'>
  >;
  mcpServers?: Resolver<
    ResolversTypes['McpServersOutput'],
    ParentType,
    ContextType,
    Partial<QueryMcpServersArgs>
  >;
  metrics?: Resolver<
    ResolversTypes['MetricsOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryMetricsArgs, 'input'>
  >;
  mitreMatrix?: Resolver<
    Maybe<ResolversTypes['MitreMatrix']>,
    ParentType,
    ContextType,
    RequireFields<QueryMitreMatrixArgs, 'id'>
  >;
  mitreMatrixTree?: Resolver<ResolversTypes['MitreMatrixTree'], ParentType, ContextType>;
  mitreTacticAndTechnique?: Resolver<
    ResolversTypes['MitreCombo'],
    ParentType,
    ContextType,
    RequireFields<QueryMitreTacticAndTechniqueArgs, 'tacticId' | 'techniqueId'>
  >;
  notificationPreferences?: Resolver<
    ResolversTypes['NotificationPreferencesOutput'],
    ParentType,
    ContextType
  >;
  notifications?: Resolver<
    ResolversTypes['NotificationsOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryNotificationsArgs, 'input'>
  >;
  organizationStats?: Resolver<
    Maybe<ResolversTypes['OrganizationStatsResponse']>,
    ParentType,
    ContextType,
    Partial<QueryOrganizationStatsArgs>
  >;
  pantherAIEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pantherFlowQueryWithParameters?: Resolver<
    ResolversTypes['PantherFlowQueryWithParametersOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryPantherFlowQueryWithParametersArgs, 'input'>
  >;
  policiesForResource?: Resolver<
    Maybe<ResolversTypes['ListComplianceItemsResponse']>,
    ParentType,
    ContextType,
    Partial<QueryPoliciesForResourceArgs>
  >;
  policy?: Resolver<
    Maybe<ResolversTypes['Policy']>,
    ParentType,
    ContextType,
    RequireFields<QueryPolicyArgs, 'input'>
  >;
  pypantherVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  replay?: Resolver<
    ResolversTypes['Replay'],
    ParentType,
    ContextType,
    RequireFields<QueryReplayArgs, 'id'>
  >;
  replayPreview?: Resolver<
    ResolversTypes['ReplayPreview'],
    ParentType,
    ContextType,
    RequireFields<QueryReplayPreviewArgs, 'dataWindow' | 'logTypes'>
  >;
  replayedAlert?: Resolver<
    ResolversTypes['Alert'],
    ParentType,
    ContextType,
    RequireFields<QueryReplayedAlertArgs, 'alertId' | 'replayId'>
  >;
  replayedAlerts?: Resolver<
    ResolversTypes['ReplayedAlertsOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryReplayedAlertsArgs, 'input'>
  >;
  replays?: Resolver<
    Array<ResolversTypes['Replay']>,
    ParentType,
    ContextType,
    RequireFields<QueryReplaysArgs, 'detectionId'>
  >;
  reportSetting?: Resolver<
    ResolversTypes['ReportSetting'],
    ParentType,
    ContextType,
    RequireFields<QueryReportSettingArgs, 'tacticId' | 'techniqueId'>
  >;
  resource?: Resolver<
    Maybe<ResolversTypes['ResourceDetails']>,
    ParentType,
    ContextType,
    RequireFields<QueryResourceArgs, 'input'>
  >;
  resources?: Resolver<
    Maybe<ResolversTypes['ListResourcesResponse']>,
    ParentType,
    ContextType,
    Partial<QueryResourcesArgs>
  >;
  resourcesForPolicy?: Resolver<
    Maybe<ResolversTypes['ListComplianceItemsResponse']>,
    ParentType,
    ContextType,
    RequireFields<QueryResourcesForPolicyArgs, 'input'>
  >;
  roleById?: Resolver<
    ResolversTypes['Role'],
    ParentType,
    ContextType,
    RequireFields<QueryRoleByIdArgs, 'id'>
  >;
  roleByName?: Resolver<
    ResolversTypes['Role'],
    ParentType,
    ContextType,
    RequireFields<QueryRoleByNameArgs, 'name'>
  >;
  roles?: Resolver<Array<ResolversTypes['Role']>, ParentType, ContextType, Partial<QueryRolesArgs>>;
  rule?: Resolver<
    Maybe<ResolversTypes['Rule']>,
    ParentType,
    ContextType,
    RequireFields<QueryRuleArgs, 'input'>
  >;
  rulePythonBody?: Resolver<
    Maybe<ResolversTypes['RulePythonBodyOutput']>,
    ParentType,
    ContextType,
    RequireFields<QueryRulePythonBodyArgs, 'input'>
  >;
  ruleV2?: Resolver<
    Maybe<ResolversTypes['Rule']>,
    ParentType,
    ContextType,
    RequireFields<QueryRuleV2Args, 'input'>
  >;
  runbookExecutionState?: Resolver<
    Maybe<ResolversTypes['RunbookExecutionState']>,
    ParentType,
    ContextType,
    RequireFields<QueryRunbookExecutionStateArgs, 'alertId'>
  >;
  samlConfig?: Resolver<ResolversTypes['SamlConfig'], ParentType, ContextType>;
  scheduledPrompt?: Resolver<
    Maybe<ResolversTypes['ScheduledPrompt']>,
    ParentType,
    ContextType,
    RequireFields<QueryScheduledPromptArgs, 'id'>
  >;
  schemas?: Resolver<
    ResolversTypes['SchemasOutput'],
    ParentType,
    ContextType,
    RequireFields<QuerySchemasArgs, 'input'>
  >;
  sendTestAlert?: Resolver<
    Array<Maybe<ResolversTypes['AlertDelivery']>>,
    ParentType,
    ContextType,
    RequireFields<QuerySendTestAlertArgs, 'input'>
  >;
  source?: Resolver<
    Maybe<ResolversTypes['LogIntegration']>,
    ParentType,
    ContextType,
    RequireFields<QuerySourceArgs, 'id'>
  >;
  sourceMetrics?: Resolver<
    ResolversTypes['SourceMetricsResponse'],
    ParentType,
    ContextType,
    RequireFields<QuerySourceMetricsArgs, 'input'>
  >;
  sourceStatistics?: Resolver<
    ResolversTypes['SourceStatisticsResponse'],
    ParentType,
    ContextType,
    RequireFields<QuerySourceStatisticsArgs, 'input'>
  >;
  sources?: Resolver<
    ResolversTypes['SourcesOutput'],
    ParentType,
    ContextType,
    Partial<QuerySourcesArgs>
  >;
  testFilterEvent?: Resolver<
    ResolversTypes['TestFilterEventOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryTestFilterEventArgs, 'input'>
  >;
  uberSearch?: Resolver<
    ResolversTypes['DataLakeQuery'],
    ParentType,
    ContextType,
    RequireFields<QueryUberSearchArgs, 'component' | 'id'>
  >;
  uberSearchAsyncQueryDownloadUrl?: Resolver<
    ResolversTypes['GetAsyncQueryDownloadUrlOutput'],
    ParentType,
    ContextType,
    RequireFields<QueryUberSearchAsyncQueryDownloadUrlArgs, 'component' | 'id'>
  >;
  uberSearchColumnSummary?: Resolver<
    ResolversTypes['DataLakeQuery'],
    ParentType,
    ContextType,
    Partial<QueryUberSearchColumnSummaryArgs>
  >;
  uberSearchPropertySummary?: Resolver<
    ResolversTypes['DataLakePropertySummary'],
    ParentType,
    ContextType,
    Partial<QueryUberSearchPropertySummaryArgs>
  >;
  uberSearchTables?: Resolver<
    ResolversTypes['UberSearchTablesOutput'],
    ParentType,
    ContextType,
    Partial<QueryUberSearchTablesArgs>
  >;
  uberSearchVisualization?: Resolver<
    ResolversTypes['DataLakeQueryVisualization'],
    ParentType,
    ContextType,
    RequireFields<QueryUberSearchVisualizationArgs, 'id'>
  >;
  universalSettings?: Resolver<ResolversTypes['UniversalSettingsConfig'], ParentType, ContextType>;
  userByEmail?: Resolver<
    ResolversTypes['User'],
    ParentType,
    ContextType,
    RequireFields<QueryUserByEmailArgs, 'email'>
  >;
  userById?: Resolver<
    ResolversTypes['User'],
    ParentType,
    ContextType,
    RequireFields<QueryUserByIdArgs, 'id'>
  >;
  userPreferences?: Resolver<ResolversTypes['UserPreferencesOutput'], ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  validateBulkUploadStatus?: Resolver<
    Maybe<ResolversTypes['ValidateUploadStatusOutput']>,
    ParentType,
    ContextType,
    RequireFields<QueryValidateBulkUploadStatusArgs, 'receiptId'>
  >;
  viewBucketData?: Resolver<
    ResolversTypes['HoldingTankRawDataResponse'],
    ParentType,
    ContextType,
    RequireFields<QueryViewBucketDataArgs, 'input'>
  >;
  viewParsedEvents?: Resolver<
    ResolversTypes['ViewParsedEventsResponse'],
    ParentType,
    ContextType,
    RequireFields<QueryViewParsedEventsArgs, 'input'>
  >;
};

export type QueryChartPropertyConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['QueryChartPropertyConfig'] =
    ResolversParentTypes['QueryChartPropertyConfig'],
> = {
  chartType?: Resolver<ResolversTypes['QueryChartType'], ParentType, ContextType>;
  colorHexes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  propertyDisplayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  propertyPath?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  propertyTableName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sortDirection?: Resolver<ResolversTypes['DataLakeQuerySortDirection'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryTablePropertyConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['QueryTablePropertyConfig'] =
    ResolversParentTypes['QueryTablePropertyConfig'],
> = {
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  propertyDisplayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  propertyPath?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  propertyTableName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryUserConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['QueryUserConfig'] =
    ResolversParentTypes['QueryUserConfig'],
> = {
  chartProperties?: Resolver<
    Array<ResolversTypes['QueryChartPropertyConfig']>,
    ParentType,
    ContextType
  >;
  queryId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  tableProperties?: Resolver<
    Array<ResolversTypes['QueryTablePropertyConfig']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RSAKeyResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RSAKey'] = ResolversParentTypes['RSAKey'],
> = {
  publicKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  publicKey2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rotated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  secretARN?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Rapid7ConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Rapid7Config'] = ResolversParentTypes['Rapid7Config'],
> = {
  apiKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  storageRegion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Rapid7InsightConnectConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Rapid7InsightConnectConfig'] =
    ResolversParentTypes['Rapid7InsightConnectConfig'],
> = {
  apiKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  workflowURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RawFilterResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RawFilter'] = ResolversParentTypes['RawFilter'],
> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  filterType?: Resolver<ResolversTypes['FilterType'], ParentType, ContextType>;
  isEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mode?: Resolver<ResolversTypes['FilterMode'], ParentType, ContextType>;
  pattern?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReclassifySourceAlarmJobResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ReclassifySourceAlarmJob'] =
    ResolversParentTypes['ReclassifySourceAlarmJob'],
> = {
  completedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['JobStatus'], ParentType, ContextType>;
  taskType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RelatedAlertsOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RelatedAlertsOutput'] =
    ResolversParentTypes['RelatedAlertsOutput'],
> = {
  edges?: Resolver<Array<ResolversTypes['RelatedAlertsOutputEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['RelatedAlertsOutputPageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RelatedAlertsOutputEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RelatedAlertsOutputEdge'] =
    ResolversParentTypes['RelatedAlertsOutputEdge'],
> = {
  node?: Resolver<ResolversTypes['Alert'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RelatedAlertsOutputPageInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RelatedAlertsOutputPageInfo'] =
    ResolversParentTypes['RelatedAlertsOutputPageInfo'],
> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface RelativeTimeDurationScalarConfig extends GraphQLScalarTypeConfig<
  ResolversTypes['RelativeTimeDuration'],
  any
> {
  name: 'RelativeTimeDuration';
}

export type ReplayResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Replay'] = ResolversParentTypes['Replay'],
> = {
  completedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  detectionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  queryIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  replayType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  scope?: Resolver<ResolversTypes['ReplayScope'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['ReplayState'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['ReplaySummary'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReplayPreviewResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ReplayPreview'] = ResolversParentTypes['ReplayPreview'],
> = {
  errInstanceTooNew?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  logDataSizeEstimate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  timeEstimate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReplayScopeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ReplayScope'] = ResolversParentTypes['ReplayScope'],
> = {
  dataWindow?: Resolver<ResolversTypes['DataWindow'], ParentType, ContextType>;
  logTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReplaySummaryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ReplaySummary'] = ResolversParentTypes['ReplaySummary'],
> = {
  completedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  computationProgress?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  evaluationProgress?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  eventsMatchedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  eventsProcessedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  logDataSizeEstimate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  matchesProcessedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  processingTimeNanos?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  readTimeNanos?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ruleErrorCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ruleMatchCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalAlerts?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReplayedAlertsOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ReplayedAlertsOutput'] =
    ResolversParentTypes['ReplayedAlertsOutput'],
> = {
  alerts?: Resolver<Array<ResolversTypes['Alert']>, ParentType, ContextType>;
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportSettingResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ReportSetting'] = ResolversParentTypes['ReportSetting'],
> = {
  association?: Resolver<ResolversTypes['ReportSettingAssociation'], ParentType, ContextType>;
  detections?: Resolver<Array<ResolversTypes['InternalDetection']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  matchingDetectionIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  matchingLogTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  override?: Resolver<ResolversTypes['ReportOverrideSetting'], ParentType, ContextType>;
  reportType?: Resolver<ResolversTypes['ReportType'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportSettingAssociationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ReportSettingAssociation'] =
    ResolversParentTypes['ReportSettingAssociation'],
> = {
  mitre?: Resolver<ResolversTypes['ReportSettingAssociationMitre'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportSettingAssociationMitreResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ReportSettingAssociationMitre'] =
    ResolversParentTypes['ReportSettingAssociationMitre'],
> = {
  tactic?: Resolver<ResolversTypes['MitreTactic'], ParentType, ContextType>;
  tacticId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  technique?: Resolver<ResolversTypes['MitreTechnique'], ParentType, ContextType>;
  techniqueId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RequestSourceOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RequestSourceOutput'] =
    ResolversParentTypes['RequestSourceOutput'],
> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResetUserPasswordOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ResetUserPasswordOutput'] =
    ResolversParentTypes['ResetUserPasswordOutput'],
> = {
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResourceDetailsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ResourceDetails'] =
    ResolversParentTypes['ResourceDetails'],
> = {
  attributes?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  complianceStatus?: Resolver<
    Maybe<ResolversTypes['ComplianceStatusEnum']>,
    ParentType,
    ContextType
  >;
  deleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  integration?: Resolver<Maybe<ResolversTypes['CloudAccount']>, ParentType, ContextType>;
  lastModified?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResourceSummaryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ResourceSummary'] =
    ResolversParentTypes['ResourceSummary'],
> = {
  complianceStatus?: Resolver<
    Maybe<ResolversTypes['ComplianceStatusEnum']>,
    ParentType,
    ContextType
  >;
  deleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  integration?: Resolver<Maybe<ResolversTypes['CloudAccount']>, ParentType, ContextType>;
  lastModified?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RiskIndicatorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RiskIndicator'] = ResolversParentTypes['RiskIndicator'],
> = {
  contextWeighting?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  evidenceConfidence?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  riskScore?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  temporalRelevance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RiskScoreEvidenceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RiskScoreEvidence'] =
    ResolversParentTypes['RiskScoreEvidence'],
> = {
  aggregateBenignIndicatorsFormula?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  aggregateBenignIndicatorsScore?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  aggregateRiskyIndicatorsFormula?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  aggregateRiskyIndicatorsScore?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  benignIndicators?: Resolver<Array<ResolversTypes['RiskIndicator']>, ParentType, ContextType>;
  benignThreshold?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  classification?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  classificationReasoning?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  normalizedTotalRiskFormula?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  normalizedTotalRiskScore?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  riskyIndicators?: Resolver<Array<ResolversTypes['RiskIndicator']>, ParentType, ContextType>;
  riskyThreshold?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Role'] = ResolversParentTypes['Role'],
> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  logTypeAccess?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  logTypeAccessKind?: Resolver<ResolversTypes['LogTypeAccessKind'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  permissions?: Resolver<Array<ResolversTypes['Permission']>, ParentType, ContextType>;
  snowflakeRoleName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RotateAPITokenOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RotateAPITokenOutput'] =
    ResolversParentTypes['RotateAPITokenOutput'],
> = {
  token?: Resolver<Maybe<ResolversTypes['APIToken']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RuleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Rule'] = ResolversParentTypes['Rule'],
> = {
  analysisType?: Resolver<ResolversTypes['DetectionType'], ParentType, ContextType>;
  baseDetection?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createAlert?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  createdByExternal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dedupPeriodMinutes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dynamicAlertContext?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dynamicAlertTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dynamicGroupBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dynamicSeverities?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  filePath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filterStatement?: Resolver<
    Maybe<ResolversTypes['DetectionFilterStatement']>,
    ParentType,
    ContextType
  >;
  fullScheduledQueries?: Resolver<
    Maybe<Array<ResolversTypes['SavedQuery']>>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inlineFilters?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isConsoleCompatible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isSimpleDetection?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastModified?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  logTypes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  managed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  outputIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  parentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reports?: Resolver<Array<ResolversTypes['DetectionReportMapping']>, ParentType, ContextType>;
  runbook?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scheduledQueries?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  severity?: Resolver<ResolversTypes['Severity'], ParentType, ContextType>;
  simpleDetectionBody?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  specVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summaryAttributes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  tags?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  tests?: Resolver<Array<ResolversTypes['DetectionTestDefinition']>, ParentType, ContextType>;
  threshold?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  userOverrides?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  versionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RulePythonBodyOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RulePythonBodyOutput'] =
    ResolversParentTypes['RulePythonBodyOutput'],
> = {
  pythonBody?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tests?: Resolver<
    Array<ResolversTypes['DetectionTestDefinitionProtected']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunScheduledPromptNowOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RunScheduledPromptNowOutput'] =
    ResolversParentTypes['RunScheduledPromptNowOutput'],
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunbookResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Runbook'] = ResolversParentTypes['Runbook'],
> = {
  phases?: Resolver<Array<ResolversTypes['RunbookPhase']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunbookExecutionPhaseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RunbookExecutionPhase'] =
    ResolversParentTypes['RunbookExecutionPhase'],
> = {
  completedSteps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  steps?: Resolver<Array<ResolversTypes['RunbookExecutionStep']>, ParentType, ContextType>;
  totalSteps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['RunbookPhaseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunbookExecutionStateResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RunbookExecutionState'] =
    ResolversParentTypes['RunbookExecutionState'],
> = {
  approvalRequired?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  classifiedRisky?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  complete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  completedSteps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  phase?: Resolver<ResolversTypes['RunbookPhaseType'], ParentType, ContextType>;
  phases?: Resolver<Array<ResolversTypes['RunbookExecutionPhase']>, ParentType, ContextType>;
  totalSteps?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunbookExecutionStepResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RunbookExecutionStep'] =
    ResolversParentTypes['RunbookExecutionStep'],
> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  required?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['RunbookStepStatus'], ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunbookPhaseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RunbookPhase'] = ResolversParentTypes['RunbookPhase'],
> = {
  steps?: Resolver<Array<ResolversTypes['RunbookStep']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['RunbookPhaseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunbookStepResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RunbookStep'] = ResolversParentTypes['RunbookStep'],
> = {
  required?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type S3LogIntegrationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['S3LogIntegration'] =
    ResolversParentTypes['S3LogIntegration'],
> = {
  alarms?: Resolver<ResolversTypes['LogIntegrationAlarms'], ParentType, ContextType>;
  awsAccountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAtTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  filters?: Resolver<ResolversTypes['SourceFilters'], ParentType, ContextType>;
  health?: Resolver<ResolversTypes['S3LogIntegrationHealth'], ParentType, ContextType>;
  integrationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  integrationLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  integrationType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isEditable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isHealthy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPantherManaged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  kmsKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastEventProcessedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastEventReceivedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastModified?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  logProcessingRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logProviderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logStreamType?: Resolver<Maybe<ResolversTypes['LogStreamType']>, ParentType, ContextType>;
  logStreamTypeOptions?: Resolver<
    Maybe<ResolversTypes['LogStreamTypeOptions']>,
    ParentType,
    ContextType
  >;
  logTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  managedBucketNotifications?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  notificationsConfigurationSucceeded?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  s3Bucket?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  s3Prefix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  s3PrefixLogTypes?: Resolver<Array<ResolversTypes['S3PrefixLogTypes']>, ParentType, ContextType>;
  stackName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type S3LogIntegrationHealthResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['S3LogIntegrationHealth'] =
    ResolversParentTypes['S3LogIntegrationHealth'],
> = {
  bucketNotificationsStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  classificationFailuresStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  kmsKeyStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  logProcessingErrorsStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  processingRoleStatus?: Resolver<
    ResolversTypes['IntegrationItemHealthStatus'],
    ParentType,
    ContextType
  >;
  s3BucketStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  systemAlarmStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type S3ObjectResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['S3Object'] = ResolversParentTypes['S3Object'],
> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastModified?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type S3PrefixLogTypesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['S3PrefixLogTypes'] =
    ResolversParentTypes['S3PrefixLogTypes'],
> = {
  excludedPrefixes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  logTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  prefix?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalesforceConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SalesforceConfig'] =
    ResolversParentTypes['SalesforceConfig'],
> = {
  domainConfig?: Resolver<ResolversTypes['SalesforceConfigDomainConfig'], ParentType, ContextType>;
  environment?: Resolver<ResolversTypes['SalesforceEnvironment'], ParentType, ContextType>;
  fileInterval?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  password?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  securityToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalesforceConfigDomainConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SalesforceConfigDomainConfig'] =
    ResolversParentTypes['SalesforceConfigDomainConfig'],
> = {
  domain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SalesforceDomainType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SamlConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SamlConfig'] = ResolversParentTypes['SamlConfig'],
> = {
  defaultRoleId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasMetadataFile?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  idpInitiated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  metadataUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ssoOnly?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SaveLookupJobResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SaveLookupJob'] = ResolversParentTypes['SaveLookupJob'],
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lookup?: Resolver<Maybe<ResolversTypes['Lookup']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['JobStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SaveResolvedWorkbenchAnalysisItemsOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SaveResolvedWorkbenchAnalysisItemsOutput'] =
    ResolversParentTypes['SaveResolvedWorkbenchAnalysisItemsOutput'],
> = {
  affectedDependents?: Resolver<
    Maybe<Array<ResolversTypes['AnalysisItemTestRunResult']>>,
    ParentType,
    ContextType
  >;
  items?: Resolver<Array<ResolversTypes['AnalysisItemSaveResult']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SavedQueryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SavedQuery'] = ResolversParentTypes['SavedQuery'],
> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  defaultDatabase?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailConfig?: Resolver<Maybe<ResolversTypes['EmailConfig']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastModifiedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  managed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  parent?: Resolver<Maybe<ResolversTypes['SavedQuery']>, ParentType, ContextType>;
  queryCookie?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  queryKind?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requiresLimitClause?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  schedule?: Resolver<Maybe<ResolversTypes['Schedule']>, ParentType, ContextType>;
  sqlQuery?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScannedResourceStatsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ScannedResourceStats'] =
    ResolversParentTypes['ScannedResourceStats'],
> = {
  count?: Resolver<Maybe<ResolversTypes['ComplianceStatusCounts']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScannedResourcesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ScannedResources'] =
    ResolversParentTypes['ScannedResources'],
> = {
  byType?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['ScannedResourceStats']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScheduleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Schedule'] = ResolversParentTypes['Schedule'],
> = {
  cronExpression?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  disabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  rateMinutes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  timeout?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScheduledPromptResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ScheduledPrompt'] =
    ResolversParentTypes['ScheduledPrompt'],
> = {
  alias?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aliasType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  canEdit?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  canManagePrivacy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  createdById?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  deletedById?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  kind?: Resolver<Maybe<ResolversTypes['AISummarizeKind']>, ParentType, ContextType>;
  lastRunAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastRunConversationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastRunError?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastRunStatus?: Resolver<
    Maybe<ResolversTypes['ScheduledPromptRunStatus']>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nextRunAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  outputLength?: Resolver<Maybe<ResolversTypes['OutputLength']>, ParentType, ContextType>;
  private?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  promptText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  runAsUser?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  runAsUserId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  schedule?: Resolver<ResolversTypes['Schedule'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  updatedById?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SchemaResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Schema'] = ResolversParentTypes['Schema'],
> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  disabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  discoveredSpec?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fields?: Resolver<Array<ResolversTypes['SchemaField']>, ParentType, ContextType>;
  isArchived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isFieldDiscoveryEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isManaged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  logSources?: Resolver<Maybe<Array<ResolversTypes['LogIntegration']>>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  referenceURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  spec?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SchemaFieldResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SchemaField'] = ResolversParentTypes['SchemaField'],
> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  indicators?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  isEmbeddedJSON?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isEventTime?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  target?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timeFormat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SchemaValueType'], ParentType, ContextType>;
  validate?: Resolver<Maybe<ResolversTypes['SchemaFieldValueValidation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SchemaFieldValueValidationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SchemaFieldValueValidation'] =
    ResolversParentTypes['SchemaFieldValueValidation'],
> = {
  allow?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  cidr?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deny?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  ip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SchemasOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SchemasOutput'] = ResolversParentTypes['SchemasOutput'],
> = {
  edges?: Resolver<Array<ResolversTypes['SchemasOutputEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['SchemasOutputPageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SchemasOutputEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SchemasOutputEdge'] =
    ResolversParentTypes['SchemasOutputEdge'],
> = {
  node?: Resolver<ResolversTypes['Schema'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SchemasOutputPageInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SchemasOutputPageInfo'] =
    ResolversParentTypes['SchemasOutputPageInfo'],
> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SendJiraEventOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SendJiraEventOutput'] =
    ResolversParentTypes['SendJiraEventOutput'],
> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SendUserFeedbackOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SendUserFeedbackOutput'] =
    ResolversParentTypes['SendUserFeedbackOutput'],
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SentinelOneApiConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SentinelOneApiConfig'] =
    ResolversParentTypes['SentinelOneApiConfig'],
> = {
  apiToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  domain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SentinelOneCloudFunnelConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SentinelOneCloudFunnelConfig'] =
    ResolversParentTypes['SentinelOneCloudFunnelConfig'],
> = {
  awsAccessKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  awsAccessSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  queueArn?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SerializeRunbookOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SerializeRunbookOutput'] =
    ResolversParentTypes['SerializeRunbookOutput'],
> = {
  runbook?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SeriesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Series'] = ResolversParentTypes['Series'],
> = {
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SeriesDataResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SeriesData'] = ResolversParentTypes['SeriesData'],
> = {
  series?: Resolver<Array<ResolversTypes['SeriesMetric']>, ParentType, ContextType>;
  timestamps?: Resolver<Array<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SeriesMetricResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SeriesMetric'] = ResolversParentTypes['SeriesMetric'],
> = {
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<Array<ResolversTypes['Long']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SeriesWithBreakdownResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SeriesWithBreakdown'] =
    ResolversParentTypes['SeriesWithBreakdown'],
> = {
  breakdown?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SeriesWithEntityIDResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SeriesWithEntityID'] =
    ResolversParentTypes['SeriesWithEntityID'],
> = {
  entityId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SeverityBasedJiraConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SeverityBasedJiraConfig'] =
    ResolversParentTypes['SeverityBasedJiraConfig'],
> = {
  labels?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  severity?: Resolver<ResolversTypes['Severity'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SignOutSessionsOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SignOutSessionsOutput'] =
    ResolversParentTypes['SignOutSessionsOutput'],
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SizeWindowResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SizeWindow'] = ResolversParentTypes['SizeWindow'],
> = {
  maxSizeInGB?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SlackBotConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SlackBotConfig'] =
    ResolversParentTypes['SlackBotConfig'],
> = {
  botToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  channel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  signingSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  syncAITriage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  syncAlertAssignee?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  syncAlertComments?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  syncAlertStatus?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  timeLocation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SlackConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SlackConfig'] = ResolversParentTypes['SlackConfig'],
> = {
  webhookURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SlackbotBoomerangHistoryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SlackbotBoomerangHistory'] =
    ResolversParentTypes['SlackbotBoomerangHistory'],
> = {
  alertId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['Actor'], ParentType, ContextType>;
  historyType?: Resolver<ResolversTypes['SlackbotBoomerangHistoryType'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  parsingVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  question?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recipientName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  responseAction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  responseMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SnippetHighlightResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SnippetHighlight'] =
    ResolversParentTypes['SnippetHighlight'],
> = {
  beginOffset?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  endOffset?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SnippetWithHighlightsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SnippetWithHighlights'] =
    ResolversParentTypes['SnippetWithHighlights'],
> = {
  highlights?: Resolver<Maybe<Array<ResolversTypes['SnippetHighlight']>>, ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SnowflakeAuditConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SnowflakeAuditConfig'] =
    ResolversParentTypes['SnowflakeAuditConfig'],
> = {
  accountIdentifier?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  database?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profilePullers?: Resolver<
    Maybe<ResolversTypes['SnowflakeProfilePullerConfig']>,
    ParentType,
    ContextType
  >;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rsaKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rsaKeyARN?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rsaPublicKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  runEveryMinutes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  schema?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  warehouse?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SnowflakeProfilePullerConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SnowflakeProfilePullerConfig'] =
    ResolversParentTypes['SnowflakeProfilePullerConfig'],
> = {
  grantsToRoles?: Resolver<Maybe<ResolversTypes['ProfilePullerConfig']>, ParentType, ContextType>;
  grantsToUsers?: Resolver<Maybe<ResolversTypes['ProfilePullerConfig']>, ParentType, ContextType>;
  networkPolicies?: Resolver<Maybe<ResolversTypes['ProfilePullerConfig']>, ParentType, ContextType>;
  roles?: Resolver<Maybe<ResolversTypes['ProfilePullerConfig']>, ParentType, ContextType>;
  stages?: Resolver<Maybe<ResolversTypes['ProfilePullerConfig']>, ParentType, ContextType>;
  users?: Resolver<Maybe<ResolversTypes['ProfilePullerConfig']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SnsConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SnsConfig'] = ResolversParentTypes['SnsConfig'],
> = {
  topicArn?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SnykLogSourceConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SnykLogSourceConfig'] =
    ResolversParentTypes['SnykLogSourceConfig'],
> = {
  apiToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orgId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SourceFiltersResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SourceFilters'] = ResolversParentTypes['SourceFilters'],
> = {
  eventFilters?: Resolver<Array<ResolversTypes['EventFilter']>, ParentType, ContextType>;
  rawFilters?: Resolver<Array<ResolversTypes['RawFilter']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SourceMetricResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SourceMetric'] = ResolversParentTypes['SourceMetric'],
> = {
  found?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SourceMetricsResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SourceMetricsResponse'] =
    ResolversParentTypes['SourceMetricsResponse'],
> = {
  bytesFiltered?: Resolver<Maybe<ResolversTypes['SeriesData']>, ParentType, ContextType>;
  bytesProcessed?: Resolver<Maybe<ResolversTypes['SeriesData']>, ParentType, ContextType>;
  bytesProcessedPerLogSource?: Resolver<
    Maybe<ResolversTypes['SeriesData']>,
    ParentType,
    ContextType
  >;
  classificationFailures?: Resolver<Maybe<ResolversTypes['SeriesData']>, ParentType, ContextType>;
  eventsFiltered?: Resolver<Maybe<ResolversTypes['SeriesData']>, ParentType, ContextType>;
  eventsProcessed?: Resolver<Maybe<ResolversTypes['SeriesData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SourceStatisticsResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SourceStatisticsResponse'] =
    ResolversParentTypes['SourceStatisticsResponse'],
> = {
  statistics?: Resolver<Array<ResolversTypes['SourceStats']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SourceStatsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SourceStats'] = ResolversParentTypes['SourceStats'],
> = {
  averageLatencySeconds?: Resolver<Maybe<ResolversTypes['SourceMetric']>, ParentType, ContextType>;
  bytesFiltered?: Resolver<Maybe<ResolversTypes['SourceMetric']>, ParentType, ContextType>;
  bytesProcessed?: Resolver<Maybe<ResolversTypes['SourceMetric']>, ParentType, ContextType>;
  classificationFailures?: Resolver<Maybe<ResolversTypes['SourceMetric']>, ParentType, ContextType>;
  eventsFiltered?: Resolver<Maybe<ResolversTypes['SourceMetric']>, ParentType, ContextType>;
  eventsProcessed?: Resolver<Maybe<ResolversTypes['SourceMetric']>, ParentType, ContextType>;
  sourceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SourcesOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SourcesOutput'] = ResolversParentTypes['SourcesOutput'],
> = {
  edges?: Resolver<Array<ResolversTypes['SourcesOutputEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['CursorBasedPaginationPageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SourcesOutputEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SourcesOutputEdge'] =
    ResolversParentTypes['SourcesOutputEdge'],
> = {
  node?: Resolver<ResolversTypes['LogIntegration'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SplunkWebhookConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SplunkWebhookConfig'] =
    ResolversParentTypes['SplunkWebhookConfig'],
> = {
  authToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  webhookURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SqsConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SqsConfig'] = ResolversParentTypes['SqsConfig'],
> = {
  allowedPrincipalArns?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['String']>>>,
    ParentType,
    ContextType
  >;
  allowedSourceArns?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['String']>>>,
    ParentType,
    ContextType
  >;
  logProcessingRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logStreamType?: Resolver<Maybe<ResolversTypes['LogStreamType']>, ParentType, ContextType>;
  logStreamTypeOptions?: Resolver<
    Maybe<ResolversTypes['LogStreamTypeOptions']>,
    ParentType,
    ContextType
  >;
  queueUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  s3Bucket?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  s3Prefix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SqsDestinationConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SqsDestinationConfig'] =
    ResolversParentTypes['SqsDestinationConfig'],
> = {
  queueUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SqsLogIntegrationHealthResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SqsLogIntegrationHealth'] =
    ResolversParentTypes['SqsLogIntegrationHealth'],
> = {
  classificationFailuresStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  logProcessingErrorsStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  sqsStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  systemAlarmStatus?: Resolver<
    Maybe<ResolversTypes['IntegrationItemHealthStatus']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SqsLogSourceIntegrationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SqsLogSourceIntegration'] =
    ResolversParentTypes['SqsLogSourceIntegration'],
> = {
  alarms?: Resolver<ResolversTypes['LogIntegrationAlarms'], ParentType, ContextType>;
  createdAtTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Actor']>, ParentType, ContextType>;
  filters?: Resolver<ResolversTypes['SourceFilters'], ParentType, ContextType>;
  health?: Resolver<ResolversTypes['SqsLogIntegrationHealth'], ParentType, ContextType>;
  integrationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  integrationLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  integrationType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isEditable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isHealthy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPantherManaged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastEventProcessedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastEventReceivedAtTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastModified?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  logProviderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  sqsConfig?: Resolver<ResolversTypes['SqsConfig'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StandardReportEntryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['StandardReportEntry'] =
    ResolversParentTypes['StandardReportEntry'],
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StartAsyncDownloadOfAllQueryResultsOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['StartAsyncDownloadOfAllQueryResultsOutput'] =
    ResolversParentTypes['StartAsyncDownloadOfAllQueryResultsOutput'],
> = {
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StopReplayOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['StopReplayOutput'] =
    ResolversParentTypes['StopReplayOutput'],
> = {
  replay?: Resolver<ResolversTypes['Replay'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StorageInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['StorageInfo'] = ResolversParentTypes['StorageInfo'],
> = {
  processedDataRetentionDays?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SummarizeDataLakeQueryJobResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SummarizeDataLakeQueryJob'] =
    ResolversParentTypes['SummarizeDataLakeQueryJob'],
> = {
  columnInfo?: Resolver<
    Maybe<ResolversTypes['DataLakeQueryResultsColumnInfo']>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<Array<ResolversTypes['JSON']>>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['JobStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SysdigConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SysdigConfig'] = ResolversParentTypes['SysdigConfig'],
> = {
  apiKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  host?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SystemErrorResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SystemError'] = ResolversParentTypes['SystemError'],
> = {
  relatedComponent?: Resolver<ResolversTypes['RelatedComponent'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SystemErrorType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SystemErrorRelatedEntityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SystemErrorRelatedEntity'] =
    ResolversParentTypes['SystemErrorRelatedEntity'],
> = {
  __resolveType: TypeResolveFn<
    | 'AmazonSecurityLakeLogIntegration'
    | 'AzureEventHubSourceIntegration'
    | 'CloudWatchLogIntegration'
    | 'CorrelationRule'
    | 'Destination'
    | 'EnrichmentIntegration'
    | 'EventBridgeIntegration'
    | 'GcpPubSubLogSourceIntegration'
    | 'GcsLogSourceIntegration'
    | 'HttpLogSourceIntegration'
    | 'LogForwarderLogSourceIntegration'
    | 'LogPullingIntegration'
    | 'OTLPLogSourceIntegration'
    | 'Rule'
    | 'S3LogIntegration'
    | 'SqsLogSourceIntegration',
    ParentType,
    ContextType
  >;
};

export type TaxiiCollectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TaxiiCollection'] =
    ResolversParentTypes['TaxiiCollection'],
> = {
  collectionUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxiiConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TaxiiConfig'] = ResolversParentTypes['TaxiiConfig'],
> = {
  authMode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  basicPassword?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  basicUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bearerToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  collections?: Resolver<Array<ResolversTypes['TaxiiCollection']>, ParentType, ContextType>;
  discoveryUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  maxAgeDays?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  profilePullers?: Resolver<ResolversTypes['TaxiiProfilePullerConfig'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxiiProfilePullerConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TaxiiProfilePullerConfig'] =
    ResolversParentTypes['TaxiiProfilePullerConfig'],
> = {
  indicators?: Resolver<ResolversTypes['ProfilePullerConfig'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenableConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TenableConfig'] = ResolversParentTypes['TenableConfig'],
> = {
  accessKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  secretKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TerraformTemplateResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TerraformTemplateResponse'] =
    ResolversParentTypes['TerraformTemplateResponse'],
> = {
  data?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stackName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TestCorrelationRuleResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TestCorrelationRuleResponse'] =
    ResolversParentTypes['TestCorrelationRuleResponse'],
> = {
  results?: Resolver<
    Maybe<Array<ResolversTypes['TestCorrelationRuleYAMLTestResult']>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TestCorrelationRuleYAMLOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TestCorrelationRuleYAMLOutput'] =
    ResolversParentTypes['TestCorrelationRuleYAMLOutput'],
> = {
  results?: Resolver<
    Maybe<Array<ResolversTypes['TestCorrelationRuleYAMLTestResult']>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TestCorrelationRuleYAMLTestResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TestCorrelationRuleYAMLTestResult'] =
    ResolversParentTypes['TestCorrelationRuleYAMLTestResult'],
> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  passed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TestDetectionRecordResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TestDetectionRecord'] =
    ResolversParentTypes['TestDetectionRecord'],
> = {
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  functions?: Resolver<ResolversTypes['TestDetectionRecordFunctions'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  passed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TestDetectionRecordFunctionsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TestDetectionRecordFunctions'] =
    ResolversParentTypes['TestDetectionRecordFunctions'],
> = {
  alertContextFunction?: Resolver<
    Maybe<ResolversTypes['TestDetectionSubRecord']>,
    ParentType,
    ContextType
  >;
  dedupFunction?: Resolver<
    Maybe<ResolversTypes['TestDetectionSubRecord']>,
    ParentType,
    ContextType
  >;
  descriptionFunction?: Resolver<
    Maybe<ResolversTypes['TestDetectionSubRecord']>,
    ParentType,
    ContextType
  >;
  destinationsFunction?: Resolver<
    Maybe<ResolversTypes['TestDetectionSubRecord']>,
    ParentType,
    ContextType
  >;
  detectionFunction?: Resolver<
    Maybe<ResolversTypes['TestDetectionSubRecord']>,
    ParentType,
    ContextType
  >;
  referenceFunction?: Resolver<
    Maybe<ResolversTypes['TestDetectionSubRecord']>,
    ParentType,
    ContextType
  >;
  runbookFunction?: Resolver<
    Maybe<ResolversTypes['TestDetectionSubRecord']>,
    ParentType,
    ContextType
  >;
  severityFunction?: Resolver<
    Maybe<ResolversTypes['TestDetectionSubRecord']>,
    ParentType,
    ContextType
  >;
  titleFunction?: Resolver<
    Maybe<ResolversTypes['TestDetectionSubRecord']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TestDetectionSubRecordResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TestDetectionSubRecord'] =
    ResolversParentTypes['TestDetectionSubRecord'],
> = {
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  output?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TestFailureResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TestFailure'] = ResolversParentTypes['TestFailure'],
> = {
  error?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  functionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TestFilterEventMatchResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TestFilterEventMatch'] =
    ResolversParentTypes['TestFilterEventMatch'],
> = {
  endIndex?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  startIndex?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TestFilterEventOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TestFilterEventOutput'] =
    ResolversParentTypes['TestFilterEventOutput'],
> = {
  isFiltered?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  matches?: Resolver<Maybe<Array<ResolversTypes['TestFilterEventMatch']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TestPolicyRecordResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TestPolicyRecord'] =
    ResolversParentTypes['TestPolicyRecord'],
> = {
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  functions?: Resolver<ResolversTypes['TestPolicyRecordFunctions'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  passed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TestPolicyRecordFunctionsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TestPolicyRecordFunctions'] =
    ResolversParentTypes['TestPolicyRecordFunctions'],
> = {
  alertContextFunction?: Resolver<
    Maybe<ResolversTypes['TestDetectionSubRecord']>,
    ParentType,
    ContextType
  >;
  dedupFunction?: Resolver<
    Maybe<ResolversTypes['TestDetectionSubRecord']>,
    ParentType,
    ContextType
  >;
  descriptionFunction?: Resolver<
    Maybe<ResolversTypes['TestDetectionSubRecord']>,
    ParentType,
    ContextType
  >;
  destinationsFunction?: Resolver<
    Maybe<ResolversTypes['TestDetectionSubRecord']>,
    ParentType,
    ContextType
  >;
  detectionFunction?: Resolver<
    Maybe<ResolversTypes['TestDetectionSubRecord']>,
    ParentType,
    ContextType
  >;
  referenceFunction?: Resolver<
    Maybe<ResolversTypes['TestDetectionSubRecord']>,
    ParentType,
    ContextType
  >;
  runbookFunction?: Resolver<
    Maybe<ResolversTypes['TestDetectionSubRecord']>,
    ParentType,
    ContextType
  >;
  severityFunction?: Resolver<
    Maybe<ResolversTypes['TestDetectionSubRecord']>,
    ParentType,
    ContextType
  >;
  titleFunction?: Resolver<
    Maybe<ResolversTypes['TestDetectionSubRecord']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TestPolicyResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TestPolicyResponse'] =
    ResolversParentTypes['TestPolicyResponse'],
> = {
  results?: Resolver<Array<ResolversTypes['TestPolicyRecord']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TestPollGitResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TestPollGitResponse'] =
    ResolversParentTypes['TestPollGitResponse'],
> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TestRecordResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TestRecord'] = ResolversParentTypes['TestRecord'],
> = {
  __resolveType: TypeResolveFn<'TestDetectionRecord' | 'TestPolicyRecord', ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  passed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type TestResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TestResult'] = ResolversParentTypes['TestResult'],
> = {
  failures?: Resolver<Maybe<Array<ResolversTypes['TestFailure']>>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TestRuleResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TestRuleResponse'] =
    ResolversParentTypes['TestRuleResponse'],
> = {
  results?: Resolver<Array<ResolversTypes['TestDetectionRecord']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TestSchemaDataResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TestSchemaData'] =
    ResolversParentTypes['TestSchemaData'],
> = {
  matched?: Resolver<Array<ResolversTypes['MatchedLog']>, ParentType, ContextType>;
  unmatched?: Resolver<Array<ResolversTypes['UnmatchedLog']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TestSchemaResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TestSchemaResponse'] =
    ResolversParentTypes['TestSchemaResponse'],
> = {
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['TestSchemaResult']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TestSchemaResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TestSchemaResult'] =
    ResolversParentTypes['TestSchemaResult'],
> = {
  data?: Resolver<ResolversTypes['TestSchemaData'], ParentType, ContextType>;
  stats?: Resolver<ResolversTypes['TestSchemaStats'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TestSchemaStatsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TestSchemaStats'] =
    ResolversParentTypes['TestSchemaStats'],
> = {
  matched?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalLogs?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  unmatched?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TimeWindowResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TimeWindow'] = ResolversParentTypes['TimeWindow'],
> = {
  endsAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  startsAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface TimestampScalarConfig extends GraphQLScalarTypeConfig<
  ResolversTypes['Timestamp'],
  any
> {
  name: 'Timestamp';
}

export type TinesConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TinesConfig'] = ResolversParentTypes['TinesConfig'],
> = {
  apiToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationDomain?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TinesWebhookConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TinesWebhookConfig'] =
    ResolversParentTypes['TinesWebhookConfig'],
> = {
  webhookURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TorqWebhookConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TorqWebhookConfig'] =
    ResolversParentTypes['TorqWebhookConfig'],
> = {
  authenticationHeaders?: Resolver<
    Maybe<Array<ResolversTypes['CustomHeader']>>,
    ParentType,
    ContextType
  >;
  webhookURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TranspileFiltersOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TranspileFiltersOutput'] =
    ResolversParentTypes['TranspileFiltersOutput'],
> = {
  transpiledFilters?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TranspileSimpleDetectionsToPythonOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TranspileSimpleDetectionsToPythonOutput'] =
    ResolversParentTypes['TranspileSimpleDetectionsToPythonOutput'],
> = {
  transpiledPython?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransportOptionsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TransportOptions'] =
    ResolversParentTypes['TransportOptions'],
> = {
  azureEventHub?: Resolver<Maybe<ResolversTypes['AzureEventHubOptions']>, ParentType, ContextType>;
  eventbridge?: Resolver<Maybe<ResolversTypes['EventbridgeOptions']>, ParentType, ContextType>;
  httpIngest?: Resolver<Array<ResolversTypes['HttpOptions']>, ParentType, ContextType>;
  logPulling?: Resolver<Maybe<ResolversTypes['LogPullingOptions']>, ParentType, ContextType>;
  otlpIngest?: Resolver<Array<ResolversTypes['OTLPOptions']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UberSearchTablesOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UberSearchTablesOutput'] =
    ResolversParentTypes['UberSearchTablesOutput'],
> = {
  pageInfo?: Resolver<ResolversTypes['UberSearchTablesOutputPageInfo'], ParentType, ContextType>;
  tables?: Resolver<Maybe<Array<ResolversTypes['DataLakeDatabaseTable']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UberSearchTablesOutputPageInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UberSearchTablesOutputPageInfo'] =
    ResolversParentTypes['UberSearchTablesOutputPageInfo'],
> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversalGitConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UniversalGitConfig'] =
    ResolversParentTypes['UniversalGitConfig'],
> = {
  configID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  lastPolled?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastUploaded?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversalSettingsConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UniversalSettingsConfig'] =
    ResolversParentTypes['UniversalSettingsConfig'],
> = {
  timezone?: Resolver<Maybe<ResolversTypes['Timezone']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnmatchedLogResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UnmatchedLog'] = ResolversParentTypes['UnmatchedLog'],
> = {
  error?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  raw?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAISkillOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateAISkillOutput'] =
    ResolversParentTypes['UpdateAISkillOutput'],
> = {
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  skill?: Resolver<Maybe<ResolversTypes['AISkill']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAPITokenOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateAPITokenOutput'] =
    ResolversParentTypes['UpdateAPITokenOutput'],
> = {
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['APIToken']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAlertStatusByFilterJobResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateAlertStatusByFilterJob'] =
    ResolversParentTypes['UpdateAlertStatusByFilterJob'],
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['JobStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAlertStatusByIdOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateAlertStatusByIdOutput'] =
    ResolversParentTypes['UpdateAlertStatusByIdOutput'],
> = {
  alerts?: Resolver<Array<ResolversTypes['Alert']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAlertsAssigneeByEmailOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateAlertsAssigneeByEmailOutput'] =
    ResolversParentTypes['UpdateAlertsAssigneeByEmailOutput'],
> = {
  alerts?: Resolver<Array<ResolversTypes['Alert']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAlertsAssigneeByIdOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateAlertsAssigneeByIdOutput'] =
    ResolversParentTypes['UpdateAlertsAssigneeByIdOutput'],
> = {
  alerts?: Resolver<Array<ResolversTypes['Alert']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAllCatalogItemsFailureResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateAllCatalogItemsFailure'] =
    ResolversParentTypes['UpdateAllCatalogItemsFailure'],
> = {
  analysisType?: Resolver<ResolversTypes['AnalysisType'], ParentType, ContextType>;
  failureReason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAllCatalogItemsJobResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateAllCatalogItemsJob'] =
    ResolversParentTypes['UpdateAllCatalogItemsJob'],
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stats?: Resolver<Maybe<ResolversTypes['UpdateAllCatalogItemsJobStats']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['JobStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAllCatalogItemsJobStatsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateAllCatalogItemsJobStats'] =
    ResolversParentTypes['UpdateAllCatalogItemsJobStats'],
> = {
  failed?: Resolver<Array<ResolversTypes['UpdateAllCatalogItemsFailure']>, ParentType, ContextType>;
  succeededRefs?: Resolver<Array<ResolversTypes['CatalogItemRef']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAzureBlobSourceOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateAzureBlobSourceOutput'] =
    ResolversParentTypes['UpdateAzureBlobSourceOutput'],
> = {
  azureBlobSource?: Resolver<ResolversTypes['AzureBlobSourceIntegration'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateCatalogItemOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateCatalogItemOutput'] =
    ResolversParentTypes['UpdateCatalogItemOutput'],
> = {
  item?: Resolver<ResolversTypes['InstalledCatalogItem'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateCloudAccountOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateCloudAccountOutput'] =
    ResolversParentTypes['UpdateCloudAccountOutput'],
> = {
  cloudAccount?: Resolver<ResolversTypes['CloudAccount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateGitHubAppConfigResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateGitHubAppConfigResponse'] =
    ResolversParentTypes['UpdateGitHubAppConfigResponse'],
> = {
  gitHubAppConfig?: Resolver<ResolversTypes['GitHubAppConfig'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateMitreReportMappingOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateMitreReportMappingOutput'] =
    ResolversParentTypes['UpdateMitreReportMappingOutput'],
> = {
  detections?: Resolver<Array<ResolversTypes['InternalDetection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateRoleOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateRoleOutput'] =
    ResolversParentTypes['UpdateRoleOutput'],
> = {
  role?: Resolver<ResolversTypes['Role'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateRuleV2OutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateRuleV2Output'] =
    ResolversParentTypes['UpdateRuleV2Output'],
> = {
  rule?: Resolver<Maybe<ResolversTypes['Rule']>, ParentType, ContextType>;
  testResults?: Resolver<Maybe<Array<ResolversTypes['TestResult']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateS3SourceOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateS3SourceOutput'] =
    ResolversParentTypes['UpdateS3SourceOutput'],
> = {
  logSource?: Resolver<ResolversTypes['S3LogIntegration'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateUserNotificationsOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateUserNotificationsOutput'] =
    ResolversParentTypes['UpdateUserNotificationsOutput'],
> = {
  notifications?: Resolver<Array<ResolversTypes['Notification']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateUserOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdateUserOutput'] =
    ResolversParentTypes['UpdateUserOutput'],
> = {
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadDetectionEntitiesAsyncOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UploadDetectionEntitiesAsyncOutput'] =
    ResolversParentTypes['UploadDetectionEntitiesAsyncOutput'],
> = {
  receiptId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadDetectionEntitiesOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UploadDetectionEntitiesOutput'] =
    ResolversParentTypes['UploadDetectionEntitiesOutput'],
> = {
  correlationRules?: Resolver<ResolversTypes['UploadStatistics'], ParentType, ContextType>;
  dataModels?: Resolver<ResolversTypes['UploadStatistics'], ParentType, ContextType>;
  globalHelpers?: Resolver<ResolversTypes['UploadStatistics'], ParentType, ContextType>;
  lookupTables?: Resolver<ResolversTypes['UploadStatistics'], ParentType, ContextType>;
  policies?: Resolver<ResolversTypes['UploadStatistics'], ParentType, ContextType>;
  queries?: Resolver<ResolversTypes['UploadStatistics'], ParentType, ContextType>;
  rules?: Resolver<ResolversTypes['UploadStatistics'], ParentType, ContextType>;
  scheduledPrompts?: Resolver<ResolversTypes['UploadStatistics'], ParentType, ContextType>;
  skills?: Resolver<ResolversTypes['UploadStatistics'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadStatisticsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UploadStatistics'] =
    ResolversParentTypes['UploadStatistics'],
> = {
  deleted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  deletedIds?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  modified?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  modifiedIds?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  new?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  newIds?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalIds?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User'],
> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['Email'], ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  familyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  givenName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasSamlAssignedRole?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasSamlDefaultRole?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastLoggedInAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['Role'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPreferencesOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UserPreferencesOutput'] =
    ResolversParentTypes['UserPreferencesOutput'],
> = {
  aiPrompt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bookmarkedConversationIds?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  displayUtcTimeZone?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  receiveAlertAssignmentEmails?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  theme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidateAndTestAllAnalysisItemsOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ValidateAndTestAllAnalysisItemsOutput'] =
    ResolversParentTypes['ValidateAndTestAllAnalysisItemsOutput'],
> = {
  items?: Resolver<Array<ResolversTypes['AnalysisItemTestRunResult']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidateBulkUploadOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ValidateBulkUploadOutput'] =
    ResolversParentTypes['ValidateBulkUploadOutput'],
> = {
  receiptId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidateUploadStatusOutputResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ValidateUploadStatusOutput'] =
    ResolversParentTypes['ValidateUploadStatusOutput'],
> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['BulkValidateResult']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['UploadStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ViewParsedEventResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ViewParsedEvent'] =
    ResolversParentTypes['ViewParsedEvent'],
> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parsedEvent?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rawEvent?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  s3ObjectKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ViewParsedEventsResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ViewParsedEventsResponse'] =
    ResolversParentTypes['ViewParsedEventsResponse'],
> = {
  results?: Resolver<Array<ResolversTypes['ViewParsedEvent']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VirusTotalIoCStreamConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['VirusTotalIoCStreamConfig'] =
    ResolversParentTypes['VirusTotalIoCStreamConfig'],
> = {
  apiKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  maxAgeDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  profilePullers?: Resolver<
    ResolversTypes['VirusTotalIoCStreamProfilePullerConfig'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VirusTotalIoCStreamProfilePullerConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['VirusTotalIoCStreamProfilePullerConfig'] =
    ResolversParentTypes['VirusTotalIoCStreamProfilePullerConfig'],
> = {
  iocStream?: Resolver<ResolversTypes['ProfilePullerConfig'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WidgetResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Widget'] = ResolversParentTypes['Widget'],
> = {
  content?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  layout?: Resolver<ResolversTypes['WidgetLayout'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DashboardWidgetType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WidgetLayoutResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['WidgetLayout'] = ResolversParentTypes['WidgetLayout'],
> = {
  h?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  w?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  x?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  y?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WizConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['WizConfig'] = ResolversParentTypes['WizConfig'],
> = {
  apiEndpoint?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projectIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  tokenUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkbenchFileResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['WorkbenchFile'] = ResolversParentTypes['WorkbenchFile'],
> = {
  conflictCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkbenchPickerItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['WorkbenchPickerItem'] =
    ResolversParentTypes['WorkbenchPickerItem'],
> = {
  analysisType?: Resolver<ResolversTypes['AnalysisType'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkdayConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['WorkdayConfig'] = ResolversParentTypes['WorkdayConfig'],
> = {
  activityClientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityClientSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityRefreshToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  domainName?: Resolver<ResolversTypes['WorkdayDomainName'], ParentType, ContextType>;
  integrationPassword?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  integrationUsername?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  signOnAccountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  signOnCustomReport?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tenantHostName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tenantName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ZendeskLogSourceApiConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ZendeskLogSourceApiConfig'] =
    ResolversParentTypes['ZendeskLogSourceApiConfig'],
> = {
  apiToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ZendeskLogSourceBasicConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ZendeskLogSourceBasicConfig'] =
    ResolversParentTypes['ZendeskLogSourceBasicConfig'],
> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  password?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ZendeskLogSourceConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ZendeskLogSourceConfig'] =
    ResolversParentTypes['ZendeskLogSourceConfig'],
> = {
  authorizationMethod?: Resolver<
    ResolversTypes['ZendeskAuthorizationMethodEnum'],
    ParentType,
    ContextType
  >;
  credentials?: Resolver<
    ResolversTypes['ZendeskLogSourceCredentialsConfig'],
    ParentType,
    ContextType
  >;
  subdomain?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ZendeskLogSourceCredentialsConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ZendeskLogSourceCredentialsConfig'] =
    ResolversParentTypes['ZendeskLogSourceCredentialsConfig'],
> = {
  __resolveType: TypeResolveFn<
    'ZendeskLogSourceApiConfig' | 'ZendeskLogSourceBasicConfig' | 'ZendeskLogSourceOAuth2Config',
    ParentType,
    ContextType
  >;
};

export type ZendeskLogSourceOAuth2ConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ZendeskLogSourceOAuth2Config'] =
    ResolversParentTypes['ZendeskLogSourceOAuth2Config'],
> = {
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ZoomConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ZoomConfig'] = ResolversParentTypes['ZoomConfig'],
> = {
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  granularScopesEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  AIAttachmentUploadUrl?: AIAttachmentUploadUrlResolvers<ContextType>;
  AIConversation?: AIConversationResolvers<ContextType>;
  AIConversationsOutput?: AIConversationsOutputResolvers<ContextType>;
  AIConversationsOutputEdge?: AIConversationsOutputEdgeResolvers<ContextType>;
  AIInferenceStream?: AIInferenceStreamResolvers<ContextType>;
  AIInferenceStreamMetadataWithPath?: AIInferenceStreamMetadataWithPathResolvers<ContextType>;
  AIInferenceStreamTextSearchResult?: AIInferenceStreamTextSearchResultResolvers<ContextType>;
  AIInferenceStreamTextSearchResultEdge?: AIInferenceStreamTextSearchResultEdgeResolvers<ContextType>;
  AIInferenceStreamTextSearchResultList?: AIInferenceStreamTextSearchResultListResolvers<ContextType>;
  AIInferenceStreamUsage?: AIInferenceStreamUsageResolvers<ContextType>;
  AIInferenceStreamsMetadataList?: AIInferenceStreamsMetadataListResolvers<ContextType>;
  AIInferenceStreamsMetadataListEdge?: AIInferenceStreamsMetadataListEdgeResolvers<ContextType>;
  AISkill?: AISkillResolvers<ContextType>;
  AISkillListItem?: AISkillListItemResolvers<ContextType>;
  AISkillOutput?: AISkillOutputResolvers<ContextType>;
  AISkillsOutput?: AISkillsOutputResolvers<ContextType>;
  AISkillsOutputEdge?: AISkillsOutputEdgeResolvers<ContextType>;
  AIStreamConversationLookupOutput?: AIStreamConversationLookupOutputResolvers<ContextType>;
  AIToolInvocation?: AIToolInvocationResolvers<ContextType>;
  AIUsageOutput?: AIUsageOutputResolvers<ContextType>;
  APIToken?: APITokenResolvers<ContextType>;
  AWSScanConfig?: AWSScanConfigResolvers<ContextType>;
  ActiveSuppressCount?: ActiveSuppressCountResolvers<ContextType>;
  Actor?: ActorResolvers<ContextType>;
  AddRuleV2Output?: AddRuleV2OutputResolvers<ContextType>;
  Alert?: AlertResolvers<ContextType>;
  AlertActivityHistoryAssigneeChange?: AlertActivityHistoryAssigneeChangeResolvers<ContextType>;
  AlertActivityHistoryCommentAdded?: AlertActivityHistoryCommentAddedResolvers<ContextType>;
  AlertActivityHistoryContextTagsChange?: AlertActivityHistoryContextTagsChangeResolvers<ContextType>;
  AlertActivityHistoryOutput?: AlertActivityHistoryOutputResolvers<ContextType>;
  AlertActivityHistoryOutputEdge?: AlertActivityHistoryOutputEdgeResolvers<ContextType>;
  AlertActivityHistoryOutputPageInfo?: AlertActivityHistoryOutputPageInfoResolvers<ContextType>;
  AlertActivityHistoryQualityChange?: AlertActivityHistoryQualityChangeResolvers<ContextType>;
  AlertActivityHistoryRecord?: AlertActivityHistoryRecordResolvers<ContextType>;
  AlertActivityHistoryRecordContent?: AlertActivityHistoryRecordContentResolvers<ContextType>;
  AlertActivityHistorySlackbotBoomerang?: AlertActivityHistorySlackbotBoomerangResolvers<ContextType>;
  AlertActivityHistoryStatusChange?: AlertActivityHistoryStatusChangeResolvers<ContextType>;
  AlertContextTag?: AlertContextTagResolvers<ContextType>;
  AlertContextTagEdge?: AlertContextTagEdgeResolvers<ContextType>;
  AlertDashboardDataOutput?: AlertDashboardDataOutputResolvers<ContextType>;
  AlertDelivery?: AlertDeliveryResolvers<ContextType>;
  AlertEvents?: AlertEventsResolvers<ContextType>;
  AlertEventsEdge?: AlertEventsEdgeResolvers<ContextType>;
  AlertEventsOutput?: AlertEventsOutputResolvers<ContextType>;
  AlertEventsOutputEdge?: AlertEventsOutputEdgeResolvers<ContextType>;
  AlertOrigin?: AlertOriginResolvers<ContextType>;
  AlertOriginPolicy?: AlertOriginPolicyResolvers<ContextType>;
  AlertOriginReplayedRule?: AlertOriginReplayedRuleResolvers<ContextType>;
  AlertOriginRule?: AlertOriginRuleResolvers<ContextType>;
  AlertOriginSystemError?: AlertOriginSystemErrorResolvers<ContextType>;
  AlertSummaryAttributeForAnalysis?: AlertSummaryAttributeForAnalysisResolvers<ContextType>;
  AlertSummaryAttributeQueryData?: AlertSummaryAttributeQueryDataResolvers<ContextType>;
  AlertsByDetection?: AlertsByDetectionResolvers<ContextType>;
  AlertsBySeverity?: AlertsBySeverityResolvers<ContextType>;
  AlertsBySeverityAndStatus?: AlertsBySeverityAndStatusResolvers<ContextType>;
  AlertsByStatus?: AlertsByStatusResolvers<ContextType>;
  AlertsOutput?: AlertsOutputResolvers<ContextType>;
  AlertsOutputEdge?: AlertsOutputEdgeResolvers<ContextType>;
  AlertsOutputPageInfo?: AlertsOutputPageInfoResolvers<ContextType>;
  AlertsPreview?: AlertsPreviewResolvers<ContextType>;
  AllDatalakeSchemaEntitiesOutput?: AllDatalakeSchemaEntitiesOutputResolvers<ContextType>;
  AllDatalakeSchemaPropertiesOutput?: AllDatalakeSchemaPropertiesOutputResolvers<ContextType>;
  AllGitConfigs?: AllGitConfigsResolvers<ContextType>;
  AmazonSecurityLakeConfig?: AmazonSecurityLakeConfigResolvers<ContextType>;
  AmazonSecurityLakeLogIntegration?: AmazonSecurityLakeLogIntegrationResolvers<ContextType>;
  AmazonSecurityLakeLogIntegrationHealth?: AmazonSecurityLakeLogIntegrationHealthResolvers<ContextType>;
  AnalysisItemSaveResult?: AnalysisItemSaveResultResolvers<ContextType>;
  AnalysisItemTestRunResult?: AnalysisItemTestRunResultResolvers<ContextType>;
  AnalysisPack?: AnalysisPackResolvers<ContextType>;
  AnalysisPackDefinition?: AnalysisPackDefinitionResolvers<ContextType>;
  AnalysisPackSource?: AnalysisPackSourceResolvers<ContextType>;
  AnalysisPackTypes?: AnalysisPackTypesResolvers<ContextType>;
  AnalysisPackVersion?: AnalysisPackVersionResolvers<ContextType>;
  Annotations?: AnnotationsResolvers<ContextType>;
  AnomaliConfig?: AnomaliConfigResolvers<ContextType>;
  AnomaliProfilePullerConfig?: AnomaliProfilePullerConfigResolvers<ContextType>;
  AnthropicConfig?: AnthropicConfigResolvers<ContextType>;
  AppConfig?: AppConfigResolvers<ContextType>;
  ApproveRemoteMcpAuthorizationResult?: ApproveRemoteMcpAuthorizationResultResolvers<ContextType>;
  AsanaConfig?: AsanaConfigResolvers<ContextType>;
  AsanaLogSourceConfig?: AsanaLogSourceConfigResolvers<ContextType>;
  AssociatedLogType?: AssociatedLogTypeResolvers<ContextType>;
  AtlassianConfig?: AtlassianConfigResolvers<ContextType>;
  AutodetectIndicatorFiltersOutput?: AutodetectIndicatorFiltersOutputResolvers<ContextType>;
  AvailableLogProvider?: AvailableLogProviderResolvers<ContextType>;
  AvailableLogProviderDetails?: AvailableLogProviderDetailsResolvers<ContextType>;
  AvailableLogProviderParser?: AvailableLogProviderParserResolvers<ContextType>;
  AzureBlobConfig?: AzureBlobConfigResolvers<ContextType>;
  AzureBlobLogIntegrationHealth?: AzureBlobLogIntegrationHealthResolvers<ContextType>;
  AzureBlobSourceIntegration?: AzureBlobSourceIntegrationResolvers<ContextType>;
  AzureEventHubConfig?: AzureEventHubConfigResolvers<ContextType>;
  AzureEventHubLogIntegrationHealth?: AzureEventHubLogIntegrationHealthResolvers<ContextType>;
  AzureEventHubOptions?: AzureEventHubOptionsResolvers<ContextType>;
  AzureEventHubSourceIntegration?: AzureEventHubSourceIntegrationResolvers<ContextType>;
  BatchInferJobsOutput?: BatchInferJobsOutputResolvers<ContextType>;
  BitwardenConfig?: BitwardenConfigResolvers<ContextType>;
  BlinkOpsWebhookConfig?: BlinkOpsWebhookConfigResolvers<ContextType>;
  BulkDownloadResponse?: BulkDownloadResponseResolvers<ContextType>;
  BulkDownloadUrlResponse?: BulkDownloadUrlResponseResolvers<ContextType>;
  BulkUpdateDetectionsResponse?: BulkUpdateDetectionsResponseResolvers<ContextType>;
  BulkUploadIssue?: BulkUploadIssueResolvers<ContextType>;
  BulkUploadJob?: BulkUploadJobResolvers<ContextType>;
  BulkUploadJobResults?: BulkUploadJobResultsResolvers<ContextType>;
  BulkUploadPresignedUrlOutput?: BulkUploadPresignedUrlOutputResolvers<ContextType>;
  BulkValidateResult?: BulkValidateResultResolvers<ContextType>;
  CancelDashboardOutput?: CancelDashboardOutputResolvers<ContextType>;
  CancelDataLakeQueryOutput?: CancelDataLakeQueryOutputResolvers<ContextType>;
  CatalogDataModel?: CatalogDataModelResolvers<ContextType>;
  CatalogDetection?: CatalogDetectionResolvers<ContextType>;
  CatalogEnrichment?: CatalogEnrichmentResolvers<ContextType>;
  CatalogGlobalHelper?: CatalogGlobalHelperResolvers<ContextType>;
  CatalogItemRef?: CatalogItemRefResolvers<ContextType>;
  CatalogQuery?: CatalogQueryResolvers<ContextType>;
  CloudAccount?: CloudAccountResolvers<ContextType>;
  CloudAccountsOutput?: CloudAccountsOutputResolvers<ContextType>;
  CloudAccountsOutputEdge?: CloudAccountsOutputEdgeResolvers<ContextType>;
  CloudWatchLogIntegration?: CloudWatchLogIntegrationResolvers<ContextType>;
  CloudWatchLogIntegrationHealth?: CloudWatchLogIntegrationHealthResolvers<ContextType>;
  Comment?: CommentResolvers<ContextType>;
  CommentEntity?: CommentEntityResolvers<ContextType>;
  ComplianceIntegrationHealth?: ComplianceIntegrationHealthResolvers<ContextType>;
  ComplianceItem?: ComplianceItemResolvers<ContextType>;
  ComplianceStatusCounts?: ComplianceStatusCountsResolvers<ContextType>;
  ContinueAIConversationOutput?: ContinueAIConversationOutputResolvers<ContextType>;
  CorrelationRule?: CorrelationRuleResolvers<ContextType>;
  CorrelationRuleTestCaseRuleOutputDefinition?: CorrelationRuleTestCaseRuleOutputDefinitionResolvers<ContextType>;
  CreateAIConversationOutput?: CreateAIConversationOutputResolvers<ContextType>;
  CreateAISkillOutput?: CreateAISkillOutputResolvers<ContextType>;
  CreateAPITokenOutput?: CreateAPITokenOutputResolvers<ContextType>;
  CreateAlertCommentOutput?: CreateAlertCommentOutputResolvers<ContextType>;
  CreateAzureBlobSourceOutput?: CreateAzureBlobSourceOutputResolvers<ContextType>;
  CreateCloudAccountOutput?: CreateCloudAccountOutputResolvers<ContextType>;
  CreateDetectionFilterOutput?: CreateDetectionFilterOutputResolvers<ContextType>;
  CreateGitHubAppConfigResponse?: CreateGitHubAppConfigResponseResolvers<ContextType>;
  CreateGitHubAppRegistrationUrlResponse?: CreateGitHubAppRegistrationUrlResponseResolvers<ContextType>;
  CreateOrUpdateSchemaOutput?: CreateOrUpdateSchemaOutputResolvers<ContextType>;
  CreatePullRequestResponse?: CreatePullRequestResponseResolvers<ContextType>;
  CreateReplayOutput?: CreateReplayOutputResolvers<ContextType>;
  CreateRoleOutput?: CreateRoleOutputResolvers<ContextType>;
  CreateS3SourceOutput?: CreateS3SourceOutputResolvers<ContextType>;
  CredentialFormField?: CredentialFormFieldResolvers<ContextType>;
  CrowdstrikeConfig?: CrowdstrikeConfigResolvers<ContextType>;
  CrowdstrikeEventStreamsConfig?: CrowdstrikeEventStreamsConfigResolvers<ContextType>;
  CursorBasedPaginationPageInfo?: CursorBasedPaginationPageInfoResolvers<ContextType>;
  CustomHeader?: CustomHeaderResolvers<ContextType>;
  CustomWebhookConfig?: CustomWebhookConfigResolvers<ContextType>;
  Dashboard?: DashboardResolvers<ContextType>;
  DashboardIcon?: DashboardIconResolvers<ContextType>;
  DashboardInput?: DashboardInputResolvers<ContextType>;
  DashboardMetadata?: DashboardMetadataResolvers<ContextType>;
  DashboardsOutput?: DashboardsOutputResolvers<ContextType>;
  DataLakeDatabase?: DataLakeDatabaseResolvers<ContextType>;
  DataLakeDatabaseTable?: DataLakeDatabaseTableResolvers<ContextType>;
  DataLakeDatabaseTableColumn?: DataLakeDatabaseTableColumnResolvers<ContextType>;
  DataLakeDatabaseTablesEdges?: DataLakeDatabaseTablesEdgesResolvers<ContextType>;
  DataLakeDatabaseTablesOutput?: DataLakeDatabaseTablesOutputResolvers<ContextType>;
  DataLakeDatabaseTablesOutputPageInfo?: DataLakeDatabaseTablesOutputPageInfoResolvers<ContextType>;
  DataLakeListDefinition?: DataLakeListDefinitionResolvers<ContextType>;
  DataLakePropertyDefinition?: DataLakePropertyDefinitionResolvers<ContextType>;
  DataLakePropertyDefinitionsOutput?: DataLakePropertyDefinitionsOutputResolvers<ContextType>;
  DataLakePropertyDefinitionsOutputEdge?: DataLakePropertyDefinitionsOutputEdgeResolvers<ContextType>;
  DataLakePropertySummary?: DataLakePropertySummaryResolvers<ContextType>;
  DataLakePropertySummaryEntry?: DataLakePropertySummaryEntryResolvers<ContextType>;
  DataLakeQueriesOutput?: DataLakeQueriesOutputResolvers<ContextType>;
  DataLakeQueriesOutputPageInfo?: DataLakeQueriesOutputPageInfoResolvers<ContextType>;
  DataLakeQuery?: DataLakeQueryResolvers<ContextType>;
  DataLakeQueryEdge?: DataLakeQueryEdgeResolvers<ContextType>;
  DataLakeQueryResultEdge?: DataLakeQueryResultEdgeResolvers<ContextType>;
  DataLakeQueryResultRecordsPageInfo?: DataLakeQueryResultRecordsPageInfoResolvers<ContextType>;
  DataLakeQueryResults?: DataLakeQueryResultsResolvers<ContextType>;
  DataLakeQueryResultsColumnInfo?: DataLakeQueryResultsColumnInfoResolvers<ContextType>;
  DataLakeQueryStats?: DataLakeQueryStatsResolvers<ContextType>;
  DataLakeQueryVisualization?: DataLakeQueryVisualizationResolvers<ContextType>;
  DataLakeQueryVisualizationResults?: DataLakeQueryVisualizationResultsResolvers<ContextType>;
  DataLakeQueryVisualizationResultsColumn?: DataLakeQueryVisualizationResultsColumnResolvers<ContextType>;
  DataLakeQueryVisualizationResultsRow?: DataLakeQueryVisualizationResultsRowResolvers<ContextType>;
  DataModel?: DataModelResolvers<ContextType>;
  DataModelMapping?: DataModelMappingResolvers<ContextType>;
  DataWindow?: DataWindowResolvers<ContextType>;
  DatabaseAndTable?: DatabaseAndTableResolvers<ContextType>;
  DatalakeFieldValuesOutput?: DatalakeFieldValuesOutputResolvers<ContextType>;
  DatalakeSchemaColumnEntity?: DatalakeSchemaColumnEntityResolvers<ContextType>;
  DatalakeSchemaDatalakeEntity?: DatalakeSchemaDatalakeEntityResolvers<ContextType>;
  DatalakeSchemaEntity?: DatalakeSchemaEntityResolvers<ContextType>;
  DatalakeSchemaProperty?: DatalakeSchemaPropertyResolvers<ContextType>;
  DatalakeSchemaPropertyEntity?: DatalakeSchemaPropertyEntityResolvers<ContextType>;
  DatalakeSchemaTableEntity?: DatalakeSchemaTableEntityResolvers<ContextType>;
  DateRange?: DateRangeResolvers<ContextType>;
  DateTime?: GraphQLScalarType;
  DeleteAISkillOutput?: DeleteAISkillOutputResolvers<ContextType>;
  DeleteAPITokenOutput?: DeleteAPITokenOutputResolvers<ContextType>;
  DeleteCloudAccountOutput?: DeleteCloudAccountOutputResolvers<ContextType>;
  DeleteDetectionsOutput?: DeleteDetectionsOutputResolvers<ContextType>;
  DeleteRoleOutput?: DeleteRoleOutputResolvers<ContextType>;
  DeleteSavedQueriesByNameOutput?: DeleteSavedQueriesByNameOutputResolvers<ContextType>;
  DeleteSourceOutput?: DeleteSourceOutputResolvers<ContextType>;
  DeleteUserOutput?: DeleteUserOutputResolvers<ContextType>;
  DeletedDetection?: DeletedDetectionResolvers<ContextType>;
  Destination?: DestinationResolvers<ContextType>;
  DestinationConfig?: DestinationConfigResolvers<ContextType>;
  Detection?: DetectionResolvers<ContextType>;
  DetectionAlertMetricsOutput?: DetectionAlertMetricsOutputResolvers<ContextType>;
  DetectionEntitiesUploadStatusOutput?: DetectionEntitiesUploadStatusOutputResolvers<ContextType>;
  DetectionFilter?: DetectionFilterResolvers<ContextType>;
  DetectionFilterCondition?: DetectionFilterConditionResolvers<ContextType>;
  DetectionFilterStatement?: DetectionFilterStatementResolvers<ContextType>;
  DetectionReportEntry?: DetectionReportEntryResolvers<ContextType>;
  DetectionReportMapping?: DetectionReportMappingResolvers<ContextType>;
  DetectionStatsDetectionTypeCount?: DetectionStatsDetectionTypeCountResolvers<ContextType>;
  DetectionStatsEnabledStateCount?: DetectionStatsEnabledStateCountResolvers<ContextType>;
  DetectionStatsResponse?: DetectionStatsResponseResolvers<ContextType>;
  DetectionStatsSeverityCount?: DetectionStatsSeverityCountResolvers<ContextType>;
  DetectionTestDefinition?: DetectionTestDefinitionResolvers<ContextType>;
  DetectionTestDefinitionProtected?: DetectionTestDefinitionProtectedResolvers<ContextType>;
  DetectionTestMockDefinition?: DetectionTestMockDefinitionResolvers<ContextType>;
  DetectionTestMockDefinitionProtected?: DetectionTestMockDefinitionProtectedResolvers<ContextType>;
  DetectionUpdateError?: DetectionUpdateErrorResolvers<ContextType>;
  DiscordConfig?: DiscordConfigResolvers<ContextType>;
  DiscoverTaxiiCollectionsOutput?: DiscoverTaxiiCollectionsOutputResolvers<ContextType>;
  DiscoveredTaxiiCollection?: DiscoveredTaxiiCollectionResolvers<ContextType>;
  DraftSchema?: DraftSchemaResolvers<ContextType>;
  DuoConfig?: DuoConfigResolvers<ContextType>;
  Email?: GraphQLScalarType;
  EmailConfig?: EmailConfigResolvers<ContextType>;
  EnrichmentIntegration?: EnrichmentIntegrationResolvers<ContextType>;
  EnrichmentIntegrationConfig?: EnrichmentIntegrationConfigResolvers<ContextType>;
  EnrichmentIntegrationHealth?: EnrichmentIntegrationHealthResolvers<ContextType>;
  Error?: ErrorResolvers<ContextType>;
  EventBridgeConfig?: EventBridgeConfigResolvers<ContextType>;
  EventBridgeIntegration?: EventBridgeIntegrationResolvers<ContextType>;
  EventBridgeIntegrationHealth?: EventBridgeIntegrationHealthResolvers<ContextType>;
  EventFilter?: EventFilterResolvers<ContextType>;
  EventThresholdAlarm?: EventThresholdAlarmResolvers<ContextType>;
  EventbridgeOptions?: EventbridgeOptionsResolvers<ContextType>;
  ExecuteDataLakeQueryOutput?: ExecuteDataLakeQueryOutputResolvers<ContextType>;
  ExecuteIndicatorSearchQueryOutput?: ExecuteIndicatorSearchQueryOutputResolvers<ContextType>;
  ExecuteSimpleSearchQueryOutput?: ExecuteSimpleSearchQueryOutputResolvers<ContextType>;
  ExecuteUberSearchOutput?: ExecuteUberSearchOutputResolvers<ContextType>;
  ExecuteUberSearchPropertySummaryOutput?: ExecuteUberSearchPropertySummaryOutputResolvers<ContextType>;
  ExpelWebhookConfig?: ExpelWebhookConfigResolvers<ContextType>;
  FeatureFlagTreatment?: FeatureFlagTreatmentResolvers<ContextType>;
  FilterField?: FilterFieldResolvers<ContextType>;
  FilterFieldsOutput?: FilterFieldsOutputResolvers<ContextType>;
  FlatFilterFieldsOutput?: FlatFilterFieldsOutputResolvers<ContextType>;
  GcpPubSubConfig?: GcpPubSubConfigResolvers<ContextType>;
  GcpPubSubDestinationConfig?: GcpPubSubDestinationConfigResolvers<ContextType>;
  GcpPubSubLogIntegrationHealth?: GcpPubSubLogIntegrationHealthResolvers<ContextType>;
  GcpPubSubLogSourceIntegration?: GcpPubSubLogSourceIntegrationResolvers<ContextType>;
  GcsConfig?: GcsConfigResolvers<ContextType>;
  GcsLogIntegrationHealth?: GcsLogIntegrationHealthResolvers<ContextType>;
  GcsLogSourceIntegration?: GcsLogSourceIntegrationResolvers<ContextType>;
  GeneralSettingsConfig?: GeneralSettingsConfigResolvers<ContextType>;
  GenerateEnrichedEventResponse?: GenerateEnrichedEventResponseResolvers<ContextType>;
  GenerateS3SampleUploadResponse?: GenerateS3SampleUploadResponseResolvers<ContextType>;
  GenerateSchemaFromSqlJob?: GenerateSchemaFromSqlJobResolvers<ContextType>;
  GenerateSimpleSearchQueryOutput?: GenerateSimpleSearchQueryOutputResolvers<ContextType>;
  GenerateSqlQuerySnippetOutput?: GenerateSqlQuerySnippetOutputResolvers<ContextType>;
  GenerateUberSearchQueryOutput?: GenerateUberSearchQueryOutputResolvers<ContextType>;
  GenericGitConfig?: GenericGitConfigResolvers<ContextType>;
  GenericPullerAuthentication?: GenericPullerAuthenticationResolvers<ContextType>;
  GenericPullerConfig?: GenericPullerConfigResolvers<ContextType>;
  GenericPullerExpectedParam?: GenericPullerExpectedParamResolvers<ContextType>;
  GenericPullerGeneralSettings?: GenericPullerGeneralSettingsResolvers<ContextType>;
  GenericPullerPagination?: GenericPullerPaginationResolvers<ContextType>;
  GenericPullerPaginationSettings?: GenericPullerPaginationSettingsResolvers<ContextType>;
  GenericPullerResponseParsing?: GenericPullerResponseParsingResolvers<ContextType>;
  GenericPullerStrategyConfig?: GenericPullerStrategyConfigResolvers<ContextType>;
  GenericPullerTimeUnit?: GenericPullerTimeUnitResolvers<ContextType>;
  GetAPITokenOutput?: GetAPITokenOutputResolvers<ContextType>;
  GetAsyncQueryDownloadUrlOutput?: GetAsyncQueryDownloadUrlOutputResolvers<ContextType>;
  GetAvailableLogProviderResponse?: GetAvailableLogProviderResponseResolvers<ContextType>;
  GetDetectionResponse?: GetDetectionResponseResolvers<ContextType>;
  GetFeatureFlagsResponse?: GetFeatureFlagsResponseResolvers<ContextType>;
  GetSampleDataResponse?: GetSampleDataResponseResolvers<ContextType>;
  GetSchemaOutput?: GetSchemaOutputResolvers<ContextType>;
  GitHubAppConfig?: GitHubAppConfigResolvers<ContextType>;
  GithubConfig?: GithubConfigResolvers<ContextType>;
  GithubLogSourceConfig?: GithubLogSourceConfigResolvers<ContextType>;
  GithubLogSourceCredentialsConfig?: GithubLogSourceCredentialsConfigResolvers<ContextType>;
  GithubLogSourceOAuth2Config?: GithubLogSourceOAuth2ConfigResolvers<ContextType>;
  GithubLogSourcePatConfig?: GithubLogSourcePatConfigResolvers<ContextType>;
  GlobalHelper?: GlobalHelperResolvers<ContextType>;
  GreyNoiseConfig?: GreyNoiseConfigResolvers<ContextType>;
  GreyNoiseProfilePullerConfig?: GreyNoiseProfilePullerConfigResolvers<ContextType>;
  GroupedFilterField?: GroupedFilterFieldResolvers<ContextType>;
  GsuiteConfig?: GsuiteConfigResolvers<ContextType>;
  GsuiteCredentialsConfig?: GsuiteCredentialsConfigResolvers<ContextType>;
  GsuiteOAuth2Config?: GsuiteOAuth2ConfigResolvers<ContextType>;
  GsuiteProfilePullerConfig?: GsuiteProfilePullerConfigResolvers<ContextType>;
  GsuiteServiceAccountConfig?: GsuiteServiceAccountConfigResolvers<ContextType>;
  GsuiteWorkloadIdentityFederationConfig?: GsuiteWorkloadIdentityFederationConfigResolvers<ContextType>;
  GtiIoCStreamConfig?: GtiIoCStreamConfigResolvers<ContextType>;
  GtiIoCStreamProfilePullerConfig?: GtiIoCStreamProfilePullerConfigResolvers<ContextType>;
  HoldingTankFilters?: HoldingTankFiltersResolvers<ContextType>;
  HoldingTankInferJob?: HoldingTankInferJobResolvers<ContextType>;
  HoldingTankInferJobParams?: HoldingTankInferJobParamsResolvers<ContextType>;
  HoldingTankJobStats?: HoldingTankJobStatsResolvers<ContextType>;
  HoldingTankListTasksResponse?: HoldingTankListTasksResponseResolvers<ContextType>;
  HoldingTankLogTypeTestStats?: HoldingTankLogTypeTestStatsResolvers<ContextType>;
  HoldingTankRawDataResponse?: HoldingTankRawDataResponseResolvers<ContextType>;
  HoldingTankRawEvent?: HoldingTankRawEventResolvers<ContextType>;
  HoldingTankResults?: HoldingTankResultsResolvers<ContextType>;
  HoldingTankSchemaInferenceResult?: HoldingTankSchemaInferenceResultResolvers<ContextType>;
  HoldingTankTestJob?: HoldingTankTestJobResolvers<ContextType>;
  HoldingTankTestJobParams?: HoldingTankTestJobParamsResolvers<ContextType>;
  HoldingTankTestJobPrefixStats?: HoldingTankTestJobPrefixStatsResolvers<ContextType>;
  HoldingTankTestSchemasResultsResponse?: HoldingTankTestSchemasResultsResponseResolvers<ContextType>;
  HttpConfig?: HttpConfigResolvers<ContextType>;
  HttpLogIntegrationHealth?: HttpLogIntegrationHealthResolvers<ContextType>;
  HttpLogSourceIntegration?: HttpLogSourceIntegrationResolvers<ContextType>;
  HttpOptions?: HttpOptionsResolvers<ContextType>;
  IncidentIoWebhookConfig?: IncidentIoWebhookConfigResolvers<ContextType>;
  InferSchemaResponse?: InferSchemaResponseResolvers<ContextType>;
  InfraCategoryCosts?: InfraCategoryCostsResolvers<ContextType>;
  InfraCostOutput?: InfraCostOutputResolvers<ContextType>;
  InfraDailyCost?: InfraDailyCostResolvers<ContextType>;
  InfrastructureInfo?: InfrastructureInfoResolvers<ContextType>;
  IngestionMonitoringSummary?: IngestionMonitoringSummaryResolvers<ContextType>;
  InstallCatalogDataModelOutput?: InstallCatalogDataModelOutputResolvers<ContextType>;
  InstallCatalogDetectionOutput?: InstallCatalogDetectionOutputResolvers<ContextType>;
  InstallCatalogEnrichmentOutput?: InstallCatalogEnrichmentOutputResolvers<ContextType>;
  InstallCatalogGlobalHelperOutput?: InstallCatalogGlobalHelperOutputResolvers<ContextType>;
  InstallCatalogQueryOutput?: InstallCatalogQueryOutputResolvers<ContextType>;
  InstalledCatalogItem?: InstalledCatalogItemResolvers<ContextType>;
  InstalledCatalogItemUpdateStatus?: InstalledCatalogItemUpdateStatusResolvers<ContextType>;
  IntegrationItemHealthStatus?: IntegrationItemHealthStatusResolvers<ContextType>;
  IntegrationTemplate?: IntegrationTemplateResolvers<ContextType>;
  InternalDetection?: InternalDetectionResolvers<ContextType>;
  InviteUserOutput?: InviteUserOutputResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  JiraAssignableUser?: JiraAssignableUserResolvers<ContextType>;
  JiraConfig?: JiraConfigResolvers<ContextType>;
  JiraOrgMetadata?: JiraOrgMetadataResolvers<ContextType>;
  JiraPriority?: JiraPriorityResolvers<ContextType>;
  JiraStatusMap?: JiraStatusMapResolvers<ContextType>;
  JiraTransitionStatus?: JiraTransitionStatusResolvers<ContextType>;
  Job?: JobResolvers<ContextType>;
  ListAPITokensOutput?: ListAPITokensOutputResolvers<ContextType>;
  ListAlertContextTagsOutput?: ListAlertContextTagsOutputResolvers<ContextType>;
  ListAlertContextTagsPageInfo?: ListAlertContextTagsPageInfoResolvers<ContextType>;
  ListAnalysisItemsForWorkbenchOutput?: ListAnalysisItemsForWorkbenchOutputResolvers<ContextType>;
  ListAnalysisPackSourcesResponse?: ListAnalysisPackSourcesResponseResolvers<ContextType>;
  ListAnalysisPacksResponse?: ListAnalysisPacksResponseResolvers<ContextType>;
  ListAvailableLogProvidersResponse?: ListAvailableLogProvidersResponseResolvers<ContextType>;
  ListAvailableLogTypesResponse?: ListAvailableLogTypesResponseResolvers<ContextType>;
  ListBucketKeysResponse?: ListBucketKeysResponseResolvers<ContextType>;
  ListCatalogDataModelsOutput?: ListCatalogDataModelsOutputResolvers<ContextType>;
  ListCatalogDetectionsOutput?: ListCatalogDetectionsOutputResolvers<ContextType>;
  ListCatalogEnrichmentsOutput?: ListCatalogEnrichmentsOutputResolvers<ContextType>;
  ListCatalogGlobalHelpersOutput?: ListCatalogGlobalHelpersOutputResolvers<ContextType>;
  ListCatalogQueriesOutput?: ListCatalogQueriesOutputResolvers<ContextType>;
  ListComplianceItemsResponse?: ListComplianceItemsResponseResolvers<ContextType>;
  ListDataModelsResponse?: ListDataModelsResponseResolvers<ContextType>;
  ListDetectionsResponse?: ListDetectionsResponseResolvers<ContextType>;
  ListGitConfigsResponse?: ListGitConfigsResponseResolvers<ContextType>;
  ListGlobalHelpersResponse?: ListGlobalHelpersResponseResolvers<ContextType>;
  ListInstalledCatalogItemUpdateStatusesOutput?: ListInstalledCatalogItemUpdateStatusesOutputResolvers<ContextType>;
  ListInstalledCatalogItemsOutput?: ListInstalledCatalogItemsOutputResolvers<ContextType>;
  ListLookupResponse?: ListLookupResponseResolvers<ContextType>;
  ListResourcesResponse?: ListResourcesResponseResolvers<ContextType>;
  ListSavedQueriesResponse?: ListSavedQueriesResponseResolvers<ContextType>;
  ListScheduledPromptsResponse?: ListScheduledPromptsResponseResolvers<ContextType>;
  ListScheduledPromptsResponseEdge?: ListScheduledPromptsResponseEdgeResolvers<ContextType>;
  LoadAnalysisItemForWorkbenchOutput?: LoadAnalysisItemForWorkbenchOutputResolvers<ContextType>;
  LogForwarderConfigYaml?: LogForwarderConfigYamlResolvers<ContextType>;
  LogForwarderGeneratorInput?: LogForwarderGeneratorInputResolvers<ContextType>;
  LogForwarderLogIntegrationHealth?: LogForwarderLogIntegrationHealthResolvers<ContextType>;
  LogForwarderLogSourceIntegration?: LogForwarderLogSourceIntegrationResolvers<ContextType>;
  LogIntegration?: LogIntegrationResolvers<ContextType>;
  LogIntegrationAlarms?: LogIntegrationAlarmsResolvers<ContextType>;
  LogPullingIntegration?: LogPullingIntegrationResolvers<ContextType>;
  LogPullingIntegrationHealth?: LogPullingIntegrationHealthResolvers<ContextType>;
  LogPullingOptions?: LogPullingOptionsResolvers<ContextType>;
  LogSourceBreakdown?: LogSourceBreakdownResolvers<ContextType>;
  LogStreamTypeOptions?: LogStreamTypeOptionsResolvers<ContextType>;
  LogTypeAlertsBySeverity?: LogTypeAlertsBySeverityResolvers<ContextType>;
  Long?: GraphQLScalarType;
  Lookup?: LookupResolvers<ContextType>;
  LookupEnrichHit?: LookupEnrichHitResolvers<ContextType>;
  LookupEnrichOutput?: LookupEnrichOutputResolvers<ContextType>;
  LookupImportDataJob?: LookupImportDataJobResolvers<ContextType>;
  LookupImportDataJobStats?: LookupImportDataJobStatsResolvers<ContextType>;
  LookupIntegration?: LookupIntegrationResolvers<ContextType>;
  LookupRefreshConfig?: LookupRefreshConfigResolvers<ContextType>;
  LookupS3ImportConfig?: LookupS3ImportConfigResolvers<ContextType>;
  LookupScheduledQueryConfig?: LookupScheduledQueryConfigResolvers<ContextType>;
  LookupStats?: LookupStatsResolvers<ContextType>;
  LookupSyncJob?: LookupSyncJobResolvers<ContextType>;
  LookupSyncJobStats?: LookupSyncJobStatsResolvers<ContextType>;
  LookupVersion?: LookupVersionResolvers<ContextType>;
  M365Config?: M365ConfigResolvers<ContextType>;
  MarkAllNotificationsAsReadOutput?: MarkAllNotificationsAsReadOutputResolvers<ContextType>;
  MatchedLog?: MatchedLogResolvers<ContextType>;
  McpAuthorizationResponse?: McpAuthorizationResponseResolvers<ContextType>;
  McpConnectionTestResult?: McpConnectionTestResultResolvers<ContextType>;
  McpServer?: McpServerResolvers<ContextType>;
  McpServerDiscovery?: McpServerDiscoveryResolvers<ContextType>;
  McpServersOutput?: McpServersOutputResolvers<ContextType>;
  McpServersOutputEdge?: McpServersOutputEdgeResolvers<ContextType>;
  McpTool?: McpToolResolvers<ContextType>;
  McpUserConnection?: McpUserConnectionResolvers<ContextType>;
  MetricsOutput?: MetricsOutputResolvers<ContextType>;
  MicrosoftGraphConfig?: MicrosoftGraphConfigResolvers<ContextType>;
  MindflowWebhookConfig?: MindflowWebhookConfigResolvers<ContextType>;
  MitreCombo?: MitreComboResolvers<ContextType>;
  MitreMatrix?: MitreMatrixResolvers<ContextType>;
  MitreMatrixContent?: MitreMatrixContentResolvers<ContextType>;
  MitreMatrixTacticMapping?: MitreMatrixTacticMappingResolvers<ContextType>;
  MitreMatrixTree?: MitreMatrixTreeResolvers<ContextType>;
  MitreMatrixTreeNode?: MitreMatrixTreeNodeResolvers<ContextType>;
  MitreReportEntry?: MitreReportEntryResolvers<ContextType>;
  MitreTactic?: MitreTacticResolvers<ContextType>;
  MitreTechnique?: MitreTechniqueResolvers<ContextType>;
  MongoDBConfig?: MongoDBConfigResolvers<ContextType>;
  MsTeamsConfig?: MsTeamsConfigResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NamedMitreAttack?: NamedMitreAttackResolvers<ContextType>;
  NetskopeConfig?: NetskopeConfigResolvers<ContextType>;
  NetworkingInfo?: NetworkingInfoResolvers<ContextType>;
  Notification?: NotificationResolvers<ContextType>;
  NotificationChannel?: NotificationChannelResolvers<ContextType>;
  NotificationMetadata?: NotificationMetadataResolvers<ContextType>;
  NotificationPreference?: NotificationPreferenceResolvers<ContextType>;
  NotificationPreferencesOutput?: NotificationPreferencesOutputResolvers<ContextType>;
  NotificationsOutput?: NotificationsOutputResolvers<ContextType>;
  NotificationsOutputEdge?: NotificationsOutputEdgeResolvers<ContextType>;
  NotificationsPageInfo?: NotificationsPageInfoResolvers<ContextType>;
  OAuth2Info?: OAuth2InfoResolvers<ContextType>;
  OAuthConfig?: OAuthConfigResolvers<ContextType>;
  OTLPConfig?: OTLPConfigResolvers<ContextType>;
  OTLPLogIntegrationHealth?: OTLPLogIntegrationHealthResolvers<ContextType>;
  OTLPLogSourceIntegration?: OTLPLogSourceIntegrationResolvers<ContextType>;
  OTLPOptions?: OTLPOptionsResolvers<ContextType>;
  OTXConfig?: OTXConfigResolvers<ContextType>;
  OTXProfilePullerConfig?: OTXProfilePullerConfigResolvers<ContextType>;
  OktaConfig?: OktaConfigResolvers<ContextType>;
  OktaProfilePullerConfig?: OktaProfilePullerConfigResolvers<ContextType>;
  OnePasswordConfig?: OnePasswordConfigResolvers<ContextType>;
  OpenAIConfig?: OpenAIConfigResolvers<ContextType>;
  OpsgenieConfig?: OpsgenieConfigResolvers<ContextType>;
  OrganizationReportBySeverity?: OrganizationReportBySeverityResolvers<ContextType>;
  OrganizationStatsResponse?: OrganizationStatsResponseResolvers<ContextType>;
  PackMigrationFailure?: PackMigrationFailureResolvers<ContextType>;
  PackMigrationResult?: PackMigrationResultResolvers<ContextType>;
  PackMigrationStatus?: PackMigrationStatusResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  PagerDutyConfig?: PagerDutyConfigResolvers<ContextType>;
  PagingData?: PagingDataResolvers<ContextType>;
  PantherAIAutoResolveConfig?: PantherAIAutoResolveConfigResolvers<ContextType>;
  PantherAIAutoRunOnAlertConfig?: PantherAIAutoRunOnAlertConfigResolvers<ContextType>;
  PantherAIKendraConfig?: PantherAIKendraConfigResolvers<ContextType>;
  PantherAIRemoteMCPConfig?: PantherAIRemoteMCPConfigResolvers<ContextType>;
  PantherAIWebToolConfig?: PantherAIWebToolConfigResolvers<ContextType>;
  PantherFlowQueryWithParametersOutput?: PantherFlowQueryWithParametersOutputResolvers<ContextType>;
  ParseRunbookOutput?: ParseRunbookOutputResolvers<ContextType>;
  PatchAlertsByIdOutput?: PatchAlertsByIdOutputResolvers<ContextType>;
  Policy?: PolicyResolvers<ContextType>;
  ProfilePullerConfig?: ProfilePullerConfigResolvers<ContextType>;
  PullerConfig?: PullerConfigResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  QueryChartPropertyConfig?: QueryChartPropertyConfigResolvers<ContextType>;
  QueryTablePropertyConfig?: QueryTablePropertyConfigResolvers<ContextType>;
  QueryUserConfig?: QueryUserConfigResolvers<ContextType>;
  RSAKey?: RSAKeyResolvers<ContextType>;
  Rapid7Config?: Rapid7ConfigResolvers<ContextType>;
  Rapid7InsightConnectConfig?: Rapid7InsightConnectConfigResolvers<ContextType>;
  RawFilter?: RawFilterResolvers<ContextType>;
  ReclassifySourceAlarmJob?: ReclassifySourceAlarmJobResolvers<ContextType>;
  RelatedAlertsOutput?: RelatedAlertsOutputResolvers<ContextType>;
  RelatedAlertsOutputEdge?: RelatedAlertsOutputEdgeResolvers<ContextType>;
  RelatedAlertsOutputPageInfo?: RelatedAlertsOutputPageInfoResolvers<ContextType>;
  RelativeTimeDuration?: GraphQLScalarType;
  Replay?: ReplayResolvers<ContextType>;
  ReplayPreview?: ReplayPreviewResolvers<ContextType>;
  ReplayScope?: ReplayScopeResolvers<ContextType>;
  ReplaySummary?: ReplaySummaryResolvers<ContextType>;
  ReplayedAlertsOutput?: ReplayedAlertsOutputResolvers<ContextType>;
  ReportSetting?: ReportSettingResolvers<ContextType>;
  ReportSettingAssociation?: ReportSettingAssociationResolvers<ContextType>;
  ReportSettingAssociationMitre?: ReportSettingAssociationMitreResolvers<ContextType>;
  RequestSourceOutput?: RequestSourceOutputResolvers<ContextType>;
  ResetUserPasswordOutput?: ResetUserPasswordOutputResolvers<ContextType>;
  ResourceDetails?: ResourceDetailsResolvers<ContextType>;
  ResourceSummary?: ResourceSummaryResolvers<ContextType>;
  RiskIndicator?: RiskIndicatorResolvers<ContextType>;
  RiskScoreEvidence?: RiskScoreEvidenceResolvers<ContextType>;
  Role?: RoleResolvers<ContextType>;
  RotateAPITokenOutput?: RotateAPITokenOutputResolvers<ContextType>;
  Rule?: RuleResolvers<ContextType>;
  RulePythonBodyOutput?: RulePythonBodyOutputResolvers<ContextType>;
  RunScheduledPromptNowOutput?: RunScheduledPromptNowOutputResolvers<ContextType>;
  Runbook?: RunbookResolvers<ContextType>;
  RunbookExecutionPhase?: RunbookExecutionPhaseResolvers<ContextType>;
  RunbookExecutionState?: RunbookExecutionStateResolvers<ContextType>;
  RunbookExecutionStep?: RunbookExecutionStepResolvers<ContextType>;
  RunbookPhase?: RunbookPhaseResolvers<ContextType>;
  RunbookStep?: RunbookStepResolvers<ContextType>;
  S3LogIntegration?: S3LogIntegrationResolvers<ContextType>;
  S3LogIntegrationHealth?: S3LogIntegrationHealthResolvers<ContextType>;
  S3Object?: S3ObjectResolvers<ContextType>;
  S3PrefixLogTypes?: S3PrefixLogTypesResolvers<ContextType>;
  SalesforceConfig?: SalesforceConfigResolvers<ContextType>;
  SalesforceConfigDomainConfig?: SalesforceConfigDomainConfigResolvers<ContextType>;
  SamlConfig?: SamlConfigResolvers<ContextType>;
  SaveLookupJob?: SaveLookupJobResolvers<ContextType>;
  SaveResolvedWorkbenchAnalysisItemsOutput?: SaveResolvedWorkbenchAnalysisItemsOutputResolvers<ContextType>;
  SavedQuery?: SavedQueryResolvers<ContextType>;
  ScannedResourceStats?: ScannedResourceStatsResolvers<ContextType>;
  ScannedResources?: ScannedResourcesResolvers<ContextType>;
  Schedule?: ScheduleResolvers<ContextType>;
  ScheduledPrompt?: ScheduledPromptResolvers<ContextType>;
  Schema?: SchemaResolvers<ContextType>;
  SchemaField?: SchemaFieldResolvers<ContextType>;
  SchemaFieldValueValidation?: SchemaFieldValueValidationResolvers<ContextType>;
  SchemasOutput?: SchemasOutputResolvers<ContextType>;
  SchemasOutputEdge?: SchemasOutputEdgeResolvers<ContextType>;
  SchemasOutputPageInfo?: SchemasOutputPageInfoResolvers<ContextType>;
  SendJiraEventOutput?: SendJiraEventOutputResolvers<ContextType>;
  SendUserFeedbackOutput?: SendUserFeedbackOutputResolvers<ContextType>;
  SentinelOneApiConfig?: SentinelOneApiConfigResolvers<ContextType>;
  SentinelOneCloudFunnelConfig?: SentinelOneCloudFunnelConfigResolvers<ContextType>;
  SerializeRunbookOutput?: SerializeRunbookOutputResolvers<ContextType>;
  Series?: SeriesResolvers<ContextType>;
  SeriesData?: SeriesDataResolvers<ContextType>;
  SeriesMetric?: SeriesMetricResolvers<ContextType>;
  SeriesWithBreakdown?: SeriesWithBreakdownResolvers<ContextType>;
  SeriesWithEntityID?: SeriesWithEntityIDResolvers<ContextType>;
  SeverityBasedJiraConfig?: SeverityBasedJiraConfigResolvers<ContextType>;
  SignOutSessionsOutput?: SignOutSessionsOutputResolvers<ContextType>;
  SizeWindow?: SizeWindowResolvers<ContextType>;
  SlackBotConfig?: SlackBotConfigResolvers<ContextType>;
  SlackConfig?: SlackConfigResolvers<ContextType>;
  SlackbotBoomerangHistory?: SlackbotBoomerangHistoryResolvers<ContextType>;
  SnippetHighlight?: SnippetHighlightResolvers<ContextType>;
  SnippetWithHighlights?: SnippetWithHighlightsResolvers<ContextType>;
  SnowflakeAuditConfig?: SnowflakeAuditConfigResolvers<ContextType>;
  SnowflakeProfilePullerConfig?: SnowflakeProfilePullerConfigResolvers<ContextType>;
  SnsConfig?: SnsConfigResolvers<ContextType>;
  SnykLogSourceConfig?: SnykLogSourceConfigResolvers<ContextType>;
  SourceFilters?: SourceFiltersResolvers<ContextType>;
  SourceMetric?: SourceMetricResolvers<ContextType>;
  SourceMetricsResponse?: SourceMetricsResponseResolvers<ContextType>;
  SourceStatisticsResponse?: SourceStatisticsResponseResolvers<ContextType>;
  SourceStats?: SourceStatsResolvers<ContextType>;
  SourcesOutput?: SourcesOutputResolvers<ContextType>;
  SourcesOutputEdge?: SourcesOutputEdgeResolvers<ContextType>;
  SplunkWebhookConfig?: SplunkWebhookConfigResolvers<ContextType>;
  SqsConfig?: SqsConfigResolvers<ContextType>;
  SqsDestinationConfig?: SqsDestinationConfigResolvers<ContextType>;
  SqsLogIntegrationHealth?: SqsLogIntegrationHealthResolvers<ContextType>;
  SqsLogSourceIntegration?: SqsLogSourceIntegrationResolvers<ContextType>;
  StandardReportEntry?: StandardReportEntryResolvers<ContextType>;
  StartAsyncDownloadOfAllQueryResultsOutput?: StartAsyncDownloadOfAllQueryResultsOutputResolvers<ContextType>;
  StopReplayOutput?: StopReplayOutputResolvers<ContextType>;
  StorageInfo?: StorageInfoResolvers<ContextType>;
  SummarizeDataLakeQueryJob?: SummarizeDataLakeQueryJobResolvers<ContextType>;
  SysdigConfig?: SysdigConfigResolvers<ContextType>;
  SystemError?: SystemErrorResolvers<ContextType>;
  SystemErrorRelatedEntity?: SystemErrorRelatedEntityResolvers<ContextType>;
  TaxiiCollection?: TaxiiCollectionResolvers<ContextType>;
  TaxiiConfig?: TaxiiConfigResolvers<ContextType>;
  TaxiiProfilePullerConfig?: TaxiiProfilePullerConfigResolvers<ContextType>;
  TenableConfig?: TenableConfigResolvers<ContextType>;
  TerraformTemplateResponse?: TerraformTemplateResponseResolvers<ContextType>;
  TestCorrelationRuleResponse?: TestCorrelationRuleResponseResolvers<ContextType>;
  TestCorrelationRuleYAMLOutput?: TestCorrelationRuleYAMLOutputResolvers<ContextType>;
  TestCorrelationRuleYAMLTestResult?: TestCorrelationRuleYAMLTestResultResolvers<ContextType>;
  TestDetectionRecord?: TestDetectionRecordResolvers<ContextType>;
  TestDetectionRecordFunctions?: TestDetectionRecordFunctionsResolvers<ContextType>;
  TestDetectionSubRecord?: TestDetectionSubRecordResolvers<ContextType>;
  TestFailure?: TestFailureResolvers<ContextType>;
  TestFilterEventMatch?: TestFilterEventMatchResolvers<ContextType>;
  TestFilterEventOutput?: TestFilterEventOutputResolvers<ContextType>;
  TestPolicyRecord?: TestPolicyRecordResolvers<ContextType>;
  TestPolicyRecordFunctions?: TestPolicyRecordFunctionsResolvers<ContextType>;
  TestPolicyResponse?: TestPolicyResponseResolvers<ContextType>;
  TestPollGitResponse?: TestPollGitResponseResolvers<ContextType>;
  TestRecord?: TestRecordResolvers<ContextType>;
  TestResult?: TestResultResolvers<ContextType>;
  TestRuleResponse?: TestRuleResponseResolvers<ContextType>;
  TestSchemaData?: TestSchemaDataResolvers<ContextType>;
  TestSchemaResponse?: TestSchemaResponseResolvers<ContextType>;
  TestSchemaResult?: TestSchemaResultResolvers<ContextType>;
  TestSchemaStats?: TestSchemaStatsResolvers<ContextType>;
  TimeWindow?: TimeWindowResolvers<ContextType>;
  Timestamp?: GraphQLScalarType;
  TinesConfig?: TinesConfigResolvers<ContextType>;
  TinesWebhookConfig?: TinesWebhookConfigResolvers<ContextType>;
  TorqWebhookConfig?: TorqWebhookConfigResolvers<ContextType>;
  TranspileFiltersOutput?: TranspileFiltersOutputResolvers<ContextType>;
  TranspileSimpleDetectionsToPythonOutput?: TranspileSimpleDetectionsToPythonOutputResolvers<ContextType>;
  TransportOptions?: TransportOptionsResolvers<ContextType>;
  UberSearchTablesOutput?: UberSearchTablesOutputResolvers<ContextType>;
  UberSearchTablesOutputPageInfo?: UberSearchTablesOutputPageInfoResolvers<ContextType>;
  UniversalGitConfig?: UniversalGitConfigResolvers<ContextType>;
  UniversalSettingsConfig?: UniversalSettingsConfigResolvers<ContextType>;
  UnmatchedLog?: UnmatchedLogResolvers<ContextType>;
  UpdateAISkillOutput?: UpdateAISkillOutputResolvers<ContextType>;
  UpdateAPITokenOutput?: UpdateAPITokenOutputResolvers<ContextType>;
  UpdateAlertStatusByFilterJob?: UpdateAlertStatusByFilterJobResolvers<ContextType>;
  UpdateAlertStatusByIdOutput?: UpdateAlertStatusByIdOutputResolvers<ContextType>;
  UpdateAlertsAssigneeByEmailOutput?: UpdateAlertsAssigneeByEmailOutputResolvers<ContextType>;
  UpdateAlertsAssigneeByIdOutput?: UpdateAlertsAssigneeByIdOutputResolvers<ContextType>;
  UpdateAllCatalogItemsFailure?: UpdateAllCatalogItemsFailureResolvers<ContextType>;
  UpdateAllCatalogItemsJob?: UpdateAllCatalogItemsJobResolvers<ContextType>;
  UpdateAllCatalogItemsJobStats?: UpdateAllCatalogItemsJobStatsResolvers<ContextType>;
  UpdateAzureBlobSourceOutput?: UpdateAzureBlobSourceOutputResolvers<ContextType>;
  UpdateCatalogItemOutput?: UpdateCatalogItemOutputResolvers<ContextType>;
  UpdateCloudAccountOutput?: UpdateCloudAccountOutputResolvers<ContextType>;
  UpdateGitHubAppConfigResponse?: UpdateGitHubAppConfigResponseResolvers<ContextType>;
  UpdateMitreReportMappingOutput?: UpdateMitreReportMappingOutputResolvers<ContextType>;
  UpdateRoleOutput?: UpdateRoleOutputResolvers<ContextType>;
  UpdateRuleV2Output?: UpdateRuleV2OutputResolvers<ContextType>;
  UpdateS3SourceOutput?: UpdateS3SourceOutputResolvers<ContextType>;
  UpdateUserNotificationsOutput?: UpdateUserNotificationsOutputResolvers<ContextType>;
  UpdateUserOutput?: UpdateUserOutputResolvers<ContextType>;
  UploadDetectionEntitiesAsyncOutput?: UploadDetectionEntitiesAsyncOutputResolvers<ContextType>;
  UploadDetectionEntitiesOutput?: UploadDetectionEntitiesOutputResolvers<ContextType>;
  UploadStatistics?: UploadStatisticsResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserPreferencesOutput?: UserPreferencesOutputResolvers<ContextType>;
  ValidateAndTestAllAnalysisItemsOutput?: ValidateAndTestAllAnalysisItemsOutputResolvers<ContextType>;
  ValidateBulkUploadOutput?: ValidateBulkUploadOutputResolvers<ContextType>;
  ValidateUploadStatusOutput?: ValidateUploadStatusOutputResolvers<ContextType>;
  ViewParsedEvent?: ViewParsedEventResolvers<ContextType>;
  ViewParsedEventsResponse?: ViewParsedEventsResponseResolvers<ContextType>;
  VirusTotalIoCStreamConfig?: VirusTotalIoCStreamConfigResolvers<ContextType>;
  VirusTotalIoCStreamProfilePullerConfig?: VirusTotalIoCStreamProfilePullerConfigResolvers<ContextType>;
  Widget?: WidgetResolvers<ContextType>;
  WidgetLayout?: WidgetLayoutResolvers<ContextType>;
  WizConfig?: WizConfigResolvers<ContextType>;
  WorkbenchFile?: WorkbenchFileResolvers<ContextType>;
  WorkbenchPickerItem?: WorkbenchPickerItemResolvers<ContextType>;
  WorkdayConfig?: WorkdayConfigResolvers<ContextType>;
  ZendeskLogSourceApiConfig?: ZendeskLogSourceApiConfigResolvers<ContextType>;
  ZendeskLogSourceBasicConfig?: ZendeskLogSourceBasicConfigResolvers<ContextType>;
  ZendeskLogSourceConfig?: ZendeskLogSourceConfigResolvers<ContextType>;
  ZendeskLogSourceCredentialsConfig?: ZendeskLogSourceCredentialsConfigResolvers<ContextType>;
  ZendeskLogSourceOAuth2Config?: ZendeskLogSourceOAuth2ConfigResolvers<ContextType>;
  ZoomConfig?: ZoomConfigResolvers<ContextType>;
};

export type DirectiveResolvers<ContextType = any> = {
  audit?: AuditDirectiveResolver<any, any, ContextType>;
  auth?: AuthDirectiveResolver<any, any, ContextType>;
  sensitive?: SensitiveDirectiveResolver<any, any, ContextType>;
};
